export default {
  'pages.layouts.userLayout.title': 'TaoExpress Admin System',
  'pages.layouts.adminPanel.title': 'Admin Panel',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.login.adminCenter': 'Admin Center',
  'pages.login.adminSystem': 'Admin System',
  'pages.login.signInTitle': 'Admin Sign In',
  'pages.login.signInDescription': 'Sign in to the TodayMall admin panel',
  'pages.login.identifier.label': 'Email or ID',
  'pages.login.password.label': 'Password',
  'pages.login.email.placeholder': 'Email address',
  'pages.login.email.required': 'Please enter email',
  'pages.login.email.invalid': 'Invalid email format',
  'pages.login.identifier.placeholder': 'Email or User ID',
  'pages.login.identifier.required': 'Please enter email or user ID',
  'pages.login.keepLoggedIn': 'Keep me logged in',
  'pages.login.secureAccessNotice': 'Access is restricted to authorized administrators only.',
  'pages.login.forgotPasswordQuestion': 'Forgot password?',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.searchTable.selectItemsToDelete': 'Please select items to delete',
  
  // Home Dashboard
  'pages.home.todayOrders': "Today's Orders",
  'pages.home.todaySales': "Today's Sales",
  'pages.home.processingRate': 'Processing Rate',
  'pages.home.newMembers': 'New Members',
  'pages.home.orderStatus': 'Current Order Status',
  'pages.home.pendingPayment': 'Payment Confirmation',
  'pages.home.pendingAddress': 'Pending Address',
  'pages.home.inChinaWarehouse': 'In China Warehouse',
  'pages.home.inKoreaDelivery': 'In Transit',
  'pages.home.recentOrders': 'Recent Orders',
  'pages.home.pendingTasks': 'Pending Tasks',
  'pages.home.pendingInquiries': 'Unanswered Inquiries',
  'pages.home.salesGrowth': "Today's Sales Growth",
  'pages.home.comparedYesterday': 'Compared to Yesterday',
  'pages.home.goTo': 'Go to',
  'pages.home.count': ' ',
  'pages.home.people': 'people',
  'pages.home.won': 'KRW',
  
  // Common
  'pages.common.search': 'Search',
  'pages.common.reset': 'Reset',
  'pages.common.yearN': '{n}',
  'pages.common.monthN': '{n}',
  'pages.common.add': 'Add',
  'pages.common.edit': 'Edit',
  'pages.common.delete': 'Delete',
  'pages.common.save': 'Save',
  'pages.common.cancel': 'Cancel',
  'pages.common.confirm': 'Confirm',
  'pages.common.actions': 'Actions',
  'pages.common.pagination.total': '{range0}-{range1} of {total} items',
  'pages.common.upload': 'Upload',
  'pages.common.uploadSuccess': 'Uploaded.',
  'pages.common.uploadFailed': 'Upload failed.',
  'pages.common.change': 'Change',
  'pages.common.id': 'ID',
  'pages.common.status': 'Status',
  'pages.common.createdAt': 'Created At',
  'pages.common.updatedAt': 'Updated At',
  'pages.common.clearFilter': 'Clear Filter',
  'pages.common.export': 'Export',
  /** Shared label for list / filter toolbar Excel download buttons */
  'pages.common.exportExcel': 'Download Excel',
  'pages.common.exportSuccess': 'Data exported successfully',
  'pages.common.operate': 'Operate',
  'pages.common.yes': 'Yes',
  'pages.common.no': 'No',
  'pages.common.won': '₩',
  'pages.common.count': 'ea',
  'pages.common.unit': 'items',
  'pages.common.people': 'people',
  'pages.common.detail': 'Detail',
  'pages.common.close': 'Close',
  'pages.common.visible': 'Visible',
  'pages.common.hidden': 'Hidden',
  'pages.common.preview': 'Preview',
  'pages.common.view': 'View',
  'pages.common.active': 'Active',
  'pages.common.inactive': 'Inactive',
  'pages.common.refresh': 'Refresh',
  'pages.common.required': 'This field is required',
  'pages.common.bold': 'Bold',
  'pages.common.italic': 'Italic',
  'pages.common.underline': 'Underline',
  'pages.common.alignLeft': 'Align Left',
  'pages.common.alignCenter': 'Align Center',
  'pages.common.alignRight': 'Align Right',
  'pages.common.image': 'Image',
  'pages.common.link': 'Link',
  'pages.common.chooseFile': 'Choose File',
  'pages.common.list': 'List',
  'pages.common.use': 'Use',
  'pages.common.notUse': 'Not use',
  'pages.common.correction': 'Correction',
  'pages.common.addSuccess': 'Added successfully',
  'pages.common.createSuccess': 'Created successfully',
  'pages.common.createFailed': 'Failed to create',
  'pages.common.updateSuccess': 'Updated successfully',
  'pages.common.updateFailed': 'Failed to update',
  'pages.common.deleteSuccess': 'Deleted successfully',
  'pages.common.deleteFailed': 'Failed to delete',
  'pages.common.saveSuccess': 'Saved successfully',
  'pages.common.deleteConfirm': 'Delete Confirmation',
  
  // Order Status
  'pages.home.status.paymentComplete': 'Payment Complete',
  'pages.home.status.pendingAddress': 'Pending Address',
  'pages.home.status.inChinaWarehouse': 'In China Warehouse',
  'pages.home.status.inTransit': 'In Transit',
  'pages.home.status.delivered': 'Delivered',
  
  // Time
  'pages.home.time.minutesAgo': '{minutes} min ago',
  'pages.home.time.hoursAgo': '{hours} hr ago',
  
  // Products List Page
  // Products Operation Data
  'pages.products.operationData.title': 'Operation Data',
  'pages.products.operationData.todayOrderAmount': "Today's order amount",
  'pages.products.operationData.todayOrderCount': "Today's order count",
  'pages.products.operationData.todayPayingUsers': 'Number of people paying today',
  'pages.products.operationData.yesterday': 'Yesterday',
  'pages.products.operationData.monthOnMonthChange': 'Month-on-month change',
  'pages.products.operationData.transactionOverview': 'Transaction Overview',
  'pages.products.operationData.query': 'Query',
  'pages.products.operationData.reset': 'Reset',
  'pages.products.operationData.orderSales': 'Order sales',
  'pages.products.operationData.totalGoodsPaid': 'Total amount of goods paid',
  'pages.products.operationData.orderCouponDeduction': 'Order coupon deduction amount',
  'pages.products.operationData.orderPointsDeduction': 'Order points deduction amount',
  'pages.products.operationData.orderRefundAmount': 'Order refund amount',
  'pages.products.operationData.orderBalance': 'Order balance',
  'pages.products.operationData.waybillSales': 'Waybill sales',
  'pages.products.operationData.waybillCouponDeduction': 'Waybill coupon deduction amount',
  'pages.products.operationData.waybillRefundAmount': 'Waybill Refund Amount',
  'pages.products.operationData.waybillSupplementAmount': 'Waybill supplement amount',
  'pages.products.operationData.totalRechargeAmount': 'Total recharge amount',
  'pages.products.operationData.commissionRebateAmount': 'Commission rebate amount',
  'pages.products.operationData.commissionWithdrawalAmount': 'Commission withdrawal amount',
  // New Operation Data Metrics
  'pages.products.operationData.productPayment': 'Product Payment',
  'pages.products.operationData.couponDiscount': 'Coupon Discount',
  'pages.products.operationData.logisticsAmount': 'Logistics Amount',
  'pages.products.operationData.rechargeAmount': 'Recharge Amount',
  'pages.products.operationData.refundAmount': 'Refund Amount',
  'pages.products.operationData.rebateAmount': 'Rebate Amount',
  'pages.products.operationData.couponEarned': 'Coupon Earned',
  'pages.products.operationData.paymentCount': 'Payment Count',
  'pages.products.operationData.couponUsageCount': 'Coupon Usage Count',
  'pages.products.operationData.logisticsCount': 'Logistics Count',
  'pages.products.operationData.withdrawalAmount': 'Withdrawal Amount',
  'pages.products.operationData.refundCount': 'Refund Count',
  'pages.products.operationData.rebateCount': 'Rebate Count',
  'pages.products.operationData.couponEarnedCount': 'Coupon Earned Count',
  'pages.products.operationData.visitCount': 'Visit Count',
  'pages.products.operationData.pointUsage': 'Point Usage',
  'pages.products.operationData.pointUsageCount': 'Point Usage Count',
  // Charts
  'pages.products.operationData.websiteRevenue': 'Website Revenue',
  'pages.products.operationData.websiteExpenses': 'Website Expenses',
  'pages.products.operationData.procurementAnalysis': 'Procurement Analysis',
  'pages.products.operationData.commissionTransactions': 'Commission transactions',
  'pages.products.operationData.orderStatistics': 'Order Statistics',
  'pages.products.operationData.waybillStatistics': 'Waybill Statistics',
  'pages.products.operationData.salesAmount': 'Sales Amount',
  'pages.products.operationData.paymentOrders': 'Payment Orders',
  'pages.products.operationData.payingUsers': 'Paying Users',
  'pages.products.operationData.replenishmentAmount': 'Replenishment Amount',
  'pages.products.operationData.totalRebateCommission': 'Total Rebate Commission',
  'pages.products.operationData.purchaseOrderCost': 'Purchase Order Cost',
  'pages.products.operationData.numberOfPurchasedItems': 'Number of Purchased Items',
  'pages.products.operationData.totalPaymentAmountForItems': 'Total Payment Amount for Items',
  'pages.products.operationData.numberOfPromotedUsers': 'Number of Promoted Users',
  'pages.products.operationData.numberOfPromotedUserOrders': 'Number of Promoted User Orders',
  'pages.products.list.title': 'Product List',
  'pages.products.list.storeListTitle': 'Store List',
  'pages.products.list.productsListTitle': 'Products List',
  'pages.products.list.backToStores': 'Back to Stores',
  'pages.products.list.priceUpdateSuccess': 'Price updated successfully',
  'pages.products.list.priceUpdateFailed': 'Failed to update price',
  'pages.products.list.importTaobao': 'Import from Promotion Url',
  'pages.products.list.importExcel': 'Import from Excel',
  'pages.products.list.exportExcel': 'Export to Excel',
  'pages.products.list.addProduct': 'Add Product',
  'pages.products.list.thumbnail': 'Image',
  'pages.products.list.copyOfferIdHint': 'Copied product. The top number is the original product offer ID; {offerId} in brackets is the ID of this product (shown on orders). Stock moves together with the original.',
  'pages.products.list.productName': 'Product Name',
  'pages.products.list.category': 'Category',
  'pages.products.list.price': 'Price',
  'pages.products.list.stock': 'Stock',
  'pages.products.list.amountOnSale': 'Amount on Sale',
  'pages.products.list.salesCount': 'Sales',
  'pages.products.list.productNo': 'Item No.',
  'pages.products.list.productNoHint': 'Item number shown to customers. If empty, the OfferId is shown instead.',
  'pages.products.list.sellingSellers': 'Selling sellers',
  'pages.products.list.status': 'Status',
  'pages.products.list.createdAt': 'Created',
  'pages.products.list.brand': 'Brand',
  'pages.products.list.priceCny': 'CNY Price',
  'pages.products.list.salePrice': 'Sale Price',
  'pages.products.list.salesPeriod': 'Sales Period',
  'pages.products.list.categoryType': 'Category Type',
  'pages.products.list.event': 'Event',
  'pages.products.list.actions': 'Actions',
  'pages.products.list.edit': 'Edit',
  'pages.products.list.delete': 'Delete',
  'pages.products.list.deleteConfirm': 'Are you sure you want to delete?',
  'pages.products.list.deleteSuccess': 'Deleted successfully',
  'pages.products.list.copySuccess': 'Product copied successfully',
  'pages.products.list.copyError': 'Failed to copy product',
  'pages.products.list.batchDelete': 'Batch Delete',
  'pages.products.list.batchDeleteConfirm': 'Delete {count} products?',
  'pages.products.list.batchDeleteSuccess': 'Selected products deleted',
  'pages.products.list.batchUpdatePrice': 'Batch Update Price',
  'pages.products.list.batchUpdateCategory': 'Batch Update Category',
  'pages.products.list.batchUpdatePriceTitle': 'Batch Update Sale Price',
  'pages.products.list.batchUpdateCategoryTitle': 'Batch Update Category',
  'pages.products.list.batchUpdatePriceSuccess': 'Sale prices updated successfully',
  'pages.products.list.batchUpdateCategorySuccess': 'Categories updated successfully',
  // Put the selected products on several seller pages in one go
  'pages.products.list.addToSellerPages': 'Add to Seller Pages',
  'pages.products.list.addToSellerPages.title': 'Add Products to Seller Pages',
  'pages.products.list.addToSellerPages.confirm': 'Add',
  'pages.products.list.addToSellerPages.description': 'The {count} selected product(s) will be added to every seller page picked below.',
  'pages.products.list.addToSellerPages.selectProduct': 'Please select at least one product.',
  'pages.products.list.addToSellerPages.selectSeller': 'Please select at least one seller.',
  'pages.products.list.addToSellerPages.result':
    'Added {count} entries across {sellers} seller page(s).{skipped, plural, =0 {} other { Skipped # already on those pages.}}',
  'pages.products.list.addToSellerPages.partialResult':
    '{count} added{skipped, plural, =0 {} other {, # skipped}}, {failed} failed ({reasons})',
  'pages.products.list.addToSellerPages.failed': 'Registration failed.',
  'pages.products.list.addToSellerPages.failReason.item': '{label}: {count}',
  'pages.products.list.addToSellerPages.failReason.ownedByOtherSeller': 'owned by another seller',
  'pages.products.list.addToSellerPages.failReason.notFound': 'product not found',
  'pages.products.list.addToSellerPages.failReason.createFailed': 'registration error',
  // Link one product to several sellers from the 판매중 셀러 column
  'pages.products.list.linkSellers': 'Link sellers',
  'pages.products.list.linkSellers.title': 'Pick the sellers carrying this product',
  'pages.products.list.linkSellers.confirm': 'Link',
  'pages.products.list.linkSellers.description':
    '{title} — {count} seller(s) carry it now. Pick the sellers to add; unlinking is done on the seller page.',
  'pages.products.list.linkSellers.alreadyLinked': 'already linked',
  'pages.products.list.linkSellers.noNewSeller': 'Only already-linked sellers were picked. Choose a seller to add.',
  'pages.products.list.batchUpdatePriceNote': 'Note: Price calculations are based on the current sale price of each product.',
  'pages.products.list.priceOperation': 'Price Operation',
  'pages.products.list.multiply': 'Multiply',
  'pages.products.list.add': 'Add',
  'pages.products.list.amount': 'Amount',
  'pages.products.list.amountHint': 'For multiply: 2 = ×2, 3 = ×3. For add: 1000 = +1000',
  'pages.products.list.selectedProducts': 'Selected {count} products',
  'pages.products.list.selectCategory': 'Select Category',
  'pages.products.list.selectCategoryPlaceholder': 'Please select a category',
  'pages.products.list.totalProducts': 'Total {total} products',
  'pages.products.list.preview': 'Preview',
  'pages.products.list.lowStock': 'Low Stock ({stock})',
  'pages.products.list.status.selling': 'Selling',
  'pages.products.list.status.stopped': 'Stopped',
  'pages.products.list.status.outOfStock': 'Out of Stock',
  'pages.products.list.status.reviewing': 'Reviewing',
  'pages.products.list.status.active': 'Active',
  'pages.products.list.status.onSale': 'On Sale',
  'pages.products.list.status.offSale': 'Off Sale',
  'pages.products.list.status.draft': 'Draft',
  'pages.products.list.displayStatus': 'Display Status',
  'pages.products.list.store.title': 'Store List',
  'pages.products.list.store.name': 'Store Name',
  'pages.products.list.store.count': 'Counts',
  'pages.products.list.store.image': 'Image',
  'pages.products.list.store.status': 'Status',
  'pages.products.list.store.active': 'Active',
  'pages.products.list.store.inactive': 'Inactive',
  'pages.products.list.store.sortOrder': 'Order',
  'pages.products.list.store.viewProducts': 'View Products',
  'pages.products.list.store.backToStores': 'Back to Stores',
  'pages.products.list.store.totalStores': 'Total {total} stores',
  'pages.products.list.store.selectStoreToViewProducts': 'Select a store to view products',
  'pages.products.list.displayStatus.visible': 'Visible',
  'pages.products.list.displayStatus.hidden': 'Hidden',
  'pages.products.list.searchProductName': 'Search product name',
  'pages.products.list.category.fashion': 'Fashion',
  'pages.products.list.category.beauty': 'Beauty',
  'pages.products.list.category.living': 'Living',
  'pages.products.list.category.digital': 'Digital',
  'pages.products.list.category.food': 'Food',
  'pages.products.list.category.sports': 'Sports',
  'pages.products.list.category.toy': 'Toy',
  'pages.products.list.category.appliance': 'Appliance',
  
  // Product Form Modal
  'pages.products.form.title': 'Product Registration',
  'pages.products.form.category': 'Category',
  'pages.products.form.brand': 'Brand',
  'pages.products.form.productName': 'Product Name',
  'pages.products.form.originalPrice': 'Original Price',
  'pages.products.form.salePrice': 'Sale Price',
  'pages.products.form.productType': 'Product Type',
  'pages.products.form.productType.own': 'Ownmall',
  'pages.products.form.productType.live': 'Live',
  'pages.products.form.salesPeriod': 'Sales Period',
  'pages.products.form.startDate': 'Start Date',
  'pages.products.form.endDate': 'End Date',
  'pages.products.form.thumbnailImage': 'Thumbnail Image',
  'pages.products.form.productImages': 'Product Images',
  'pages.products.form.color': 'Color',
  'pages.products.form.size': 'Size',
  'pages.products.form.siteUrl': 'Site URL',
  'pages.products.form.originalPlace': 'Original Place',
  'pages.products.form.recommendedCategory': 'Recommended Category',
  'pages.products.form.recommendedType': 'Recommended Type',
  'pages.products.form.event': 'Event',
  'pages.products.form.shortDescription': 'Short Description',
  'pages.products.form.siteAddress': 'Site Address',
  'pages.products.form.useStatus': 'Use Status',
  'pages.products.form.detailDescription': 'Detail Description',
  'pages.products.form.save': 'Save',
  'pages.products.form.close': 'Close',
  'pages.products.form.use': 'Use',
  'pages.products.form.notUse': 'Not Use',
  'pages.products.form.colorSizeHint': '* To enter multiple colors and sizes, separate them with | ex) Black|White|Blue|Green',
  
  // Products Add Page
  'pages.products.add.title': 'Add Product',
  'pages.products.add.addAttribute': 'Add Attribute',
  'pages.products.add.preview': 'Preview',
  'pages.products.add.submit': 'Add Product',
  'pages.products.add.uploadSuccess': 'Upload successful',
  'pages.products.add.uploadFailed': 'Upload failed',
  'pages.products.add.descImageUploadHint':
    'You can upload multiple images at once, or add one image URL below (optional).',
  'pages.products.add.descImageUpload': 'Upload images',
  'pages.products.add.descImageUploadBtn': 'Upload',
  'pages.products.add.descImageUrlLabel': 'Or enter one image URL (optional)',
  'pages.products.add.descImagePreview': 'Preview',
  'pages.products.add.descImageWaitUpload': 'Please wait until all images finish uploading.',
  'pages.products.add.descImageNeedOne': 'Please upload at least one image or enter an image URL.',
  'pages.products.add.descImageInserted': '{count} image(s) inserted successfully.',
  'pages.products.add.saveProduct': 'Save Product',
  'pages.products.add.cancel': 'Cancel',
  'pages.products.add.scrollToTop': 'Back to top',
  'pages.products.add.success': 'Product added successfully',
  'pages.products.add.error': 'Please fill in required fields',
  'pages.products.add.basicInfo': 'Basic Information',
  'pages.products.add.productName': 'Product Name',
  'pages.products.add.productNamePlaceholder': 'Enter product name',
  'pages.products.add.productNameRequired': 'Please enter product name',
  'pages.products.add.category': 'Category',
  'pages.products.add.categoryPlaceholder': 'Select category',
  'pages.products.add.categoryRequired': 'Please select category',
  'pages.products.add.brand': 'Brand',
  'pages.products.add.brandPlaceholder': 'Brand name',
  'pages.products.add.description': 'Description',
  'pages.products.add.descriptionPlaceholder': 'Enter detailed product description',
  'pages.products.add.descriptionRequired': 'Please enter description',
  'pages.products.add.price': 'Price',
  'pages.products.add.pricePlaceholder': '0',
  'pages.products.add.priceRequired': 'Please enter price',
  'pages.products.add.originalPrice': 'Original Price',
  'pages.products.add.stock': 'Stock',
  'pages.products.add.sku': 'SKU Code',
  'pages.products.add.skuPlaceholder': 'SKU-001',
  'pages.products.add.barcode': 'Barcode',
  'pages.products.add.barcodePlaceholder': 'Barcode number',
  'pages.products.add.options': 'Product Options',
  'pages.products.add.addOption': 'Add Option',
  'pages.products.add.optionName': 'Option Name',
  'pages.products.add.optionNamePlaceholder': 'e.g. Black/M',
  'pages.products.add.optionImage': 'Option Image',
  'pages.products.add.optionImageUrlPlaceholder': 'Enter image URL',
  'pages.products.add.bulkUploadImage': 'Upload to all',
  'pages.products.add.bulkClearImage': 'Clear all',
  'pages.products.add.imageBulkUpdated': 'Images updated successfully',
  'pages.products.add.imageBulkCleared': 'Images cleared successfully',
  'pages.products.add.deleteSelected': 'Delete',
  'pages.products.add.confirmDeleteSelected': 'Delete selected rows?',
  'pages.products.add.noRowsSelected': 'Please select rows to delete',
  'pages.products.add.rowsDeleted': 'Selected rows deleted',
  'pages.products.add.tempSave': 'Temp Save',
  'pages.products.add.tempSaveSuccess': 'Draft saved successfully',
  'pages.products.add.tempSaveError': 'Failed to save draft',
  'pages.products.add.optionPrice': 'Additional Price',
  'pages.products.add.optionStock': 'Stock',
  'pages.products.add.optionSku': 'SKU',
  'pages.products.add.inputSellingPrice': 'Input selling price',
  'pages.products.add.tagPrice': 'Tag Price',
  'pages.products.add.inputTagPrice': 'Input tag price',
  'pages.products.add.save': 'Save',
  'pages.products.add.salePriceTooLow': 'Sale price must be at least the original price (₩{min})',
  'pages.products.add.tagPriceTooLow': 'Tag price must be at least the sale price (₩{min})',
  'pages.products.add.shippingInfo': 'Shipping Information',
  'pages.products.add.weight': 'Weight (kg)',
  'pages.products.add.width': 'Width (cm)',
  'pages.products.add.height': 'Height (cm)',
  'pages.products.add.depth': 'Depth (cm)',
  'pages.products.add.shippingMethod': 'Shipping Method',
  'pages.products.add.shippingMethodPlaceholder': 'Select shipping method',
  'pages.products.add.additionalInfo': 'Additional Information',
  'pages.products.add.tags': 'Tags',
  'pages.products.add.tagsPlaceholder': 'Enter tags (press Enter to add)',
  'pages.products.add.keywords': 'Search Keywords',
  'pages.products.add.keywordsPlaceholder': 'Search keywords (comma separated)',
  'pages.products.add.keywordsTooltip': 'Enter keywords and press Enter or comma to add',
  'pages.products.add.memo': 'Admin Memo',
  'pages.products.add.memoPlaceholder': 'Memo for admin',
  'pages.products.add.images': 'Product Images',
  'pages.products.add.uploadImage': 'Upload Image',
  'pages.products.add.imageRequired': 'Please upload at least 1 image',
  'pages.products.add.imageNote1': 'Maximum 10 images',
  'pages.products.add.imageNote2': 'Recommended size: 800x800px',
  'pages.products.add.imageNote3': 'First image will be the main image',
  'pages.products.add.salesSettings': 'Sales Settings',
  'pages.products.add.salesStatus': 'Sales Status',
  'pages.products.add.displayStatus': 'Display Status',
  'pages.products.add.featured': 'Featured',
  'pages.products.add.newArrival': 'New Arrival',
  'pages.products.add.bestSeller': 'Best Seller',
  'pages.products.add.originInfo': 'Origin Information',
  'pages.products.add.origin': 'Country of Origin',
  'pages.products.add.originPlaceholder': 'Select country',
  'pages.products.add.manufacturer': 'Manufacturer',
  'pages.products.add.manufacturerPlaceholder': 'Manufacturer name',
  'pages.products.add.importDate': 'Import Date',
  'pages.products.add.storeInfo': 'Store Information',
  'pages.products.add.storeName': 'Store Name',
  'pages.products.add.storeNamePlaceholder': 'Enter store name',
  'pages.products.add.storeSelect': 'Select Store',
  'pages.products.add.storeSelectPlaceholder': 'Please select a store',
  'pages.products.add.storeRequired': 'Please select a store',
  'pages.products.add.review': 'Review',
  'pages.products.add.reviewPlaceholder': 'Review rating (0-5)',
  'pages.products.add.soldout': 'Sold Out',
  'pages.products.add.soldoutPlaceholder': 'Number of items sold',
  'pages.products.add.previewModal': 'Product Preview',
  'pages.products.add.previewDev': 'Preview feature is under development.',
  'pages.products.add.yes': 'Yes',
  'pages.products.add.no': 'No',
  'pages.products.add.show': 'Show',
  'pages.products.add.hide': 'Hide',
  'pages.products.add.category.clothing': 'Clothing',
  'pages.products.add.category.shoes': 'Shoes',
  'pages.products.add.category.bags': 'Bags',
  'pages.products.add.category.accessories': 'Accessories',
  'pages.products.add.category.electronics': 'Electronics',
  'pages.products.add.category.home': 'Home/Living',
  'pages.products.add.status.active': 'Active',
  'pages.products.add.status.inactive': 'Inactive',
  'pages.products.add.status.soldout': 'Sold Out',
  'pages.products.add.status.preparing': 'Preparing',
  'pages.products.add.addSpecification': 'Add Specification',
  'pages.products.add.attributeNameCn': 'Attribute Name (CN)',
  'pages.products.add.attributeNameKo': 'Attribute Name (KO)',
  'pages.products.add.attributeNameEn': 'Attribute Name (EN)',
  'pages.products.add.attributePlaceholderCn': 'e.g: 颜色',
  'pages.products.add.attributePlaceholderKo': 'e.g: 색상',
  'pages.products.add.attributePlaceholderEn': 'e.g: Color',
  'pages.products.add.attributeValueCn': 'Attribute Values (CN)',
  'pages.products.add.attributeValueKo': 'Attribute Values (KO)',
  'pages.products.add.attributeValueEn': 'Attribute Values (EN)',
  'pages.products.add.attributeValuePlaceholderCn': 'e.g: 红色,蓝色,绿色',
  'pages.products.add.attributeValuePlaceholderKo': 'e.g: 빨강,파랑,초록',
  'pages.products.add.attributeValuePlaceholderEn': 'e.g: Red,Blue,Green',
  'pages.products.add.fillAllAttributes': 'Please fill in at least one language for attribute name and values',
  'pages.products.add.attributeSync.result':
    'Attribute list synchronized — {added} added, {removed} removed, {total} in total',
  'pages.products.add.atLeastOneLanguageRequired': 'At least one language is required for attribute name and values',
  'pages.products.add.optionRequired': 'Please add at least one option',
  'pages.products.add.optionCategoryRequired': 'Please set the option category name first',
  'pages.products.add.optionCategoryName': 'Option Category Name',
  'pages.products.add.specificationRequired': 'Please add at least one specification',
  'pages.products.add.shipping.air': 'Air',
  'pages.products.add.shipping.airExpress': 'Air Express',
  'pages.products.add.shipping.sea': 'Sea',
  'pages.products.add.shipping.seaExpress': 'Sea Express',
  'pages.products.add.country.CN': 'China',
  'pages.products.add.country.KR': 'Korea',
  'pages.products.add.country.US': 'USA',
  'pages.products.add.country.JP': 'Japan',
  'pages.products.add.country.EU': 'Europe',
  'pages.products.add.tag.new': 'New',
  'pages.products.add.tag.popular': 'Popular',
  'pages.products.add.tag.sale': 'Sale',
  'pages.products.add.tag.recommended': 'Recommended',
  'pages.products.add.promotionLink': 'Promotion Link',
  'pages.products.add.promotionLinkPlaceholder': 'Enter promotion link (e.g., Taobao/1688 product URL)',
  'pages.products.add.offerId': 'Product Number (Offer ID)',
  'pages.products.add.offerIdPlaceholder': 'Enter product number (Offer ID)',
  'pages.products.add.offerIdTooltip': 'Auto-filled from the promotion link, or enter it manually',
  'pages.products.add.titleKoRequired': 'Korean product name is required',
  'pages.products.add.specifications': 'Product Specifications',
  'pages.products.add.productDetail': 'Product Detail',
  'pages.products.add.sellerInfo': 'Seller Information',
  'pages.products.add.displayMetrics': 'Display Values',
  'pages.products.add.displayMetricsNotice':
    'Display-only figures shown to customers. They are not linked to real order or review data.',
  'pages.products.add.reviewCount': 'Review Count',
  'pages.products.add.reviewCountPlaceholder': 'Enter review count',
  'pages.products.add.reviewScore': 'Rating',
  'pages.products.add.reviewScorePlaceholder': 'Enter rating (0-5)',
  'pages.products.add.repurchaseRate': 'Repurchase Rate (%)',
  'pages.products.add.repurchaseRatePlaceholder': 'Enter repurchase rate (0-100)',
  'pages.products.add.copy': 'Copy',
  'pages.products.add.paste': 'Paste',
  'pages.products.add.companyNamePlaceholder': 'Company name',
  'pages.products.add.sellerAddressPlaceholder': 'Seller address',
  'pages.products.add.sellerPhonePlaceholder': 'Seller phone number',
  'pages.products.add.sellerOpenIdPlaceholder': 'Seller Open ID / Shop ID',
  'pages.products.add.editor.bold': 'Bold',
  'pages.products.add.editor.italic': 'Italic',
  'pages.products.add.editor.underline': 'Underline',
  'pages.products.add.editor.alignLeft': 'Align Left',
  'pages.products.add.editor.alignCenter': 'Align Center',
  'pages.products.add.editor.alignRight': 'Align Right',
  'pages.products.add.editor.orderedList': 'Ordered List',
  'pages.products.add.editor.unorderedList': 'Unordered List',
  'pages.products.add.editor.insertImage': 'Insert Image',
  'pages.products.add.editor.insertLink': 'Insert Link',
  'pages.products.add.editor.insertUrl': 'Enter URL:',
  'pages.products.add.editor.normal': 'Normal',
  'pages.products.add.editor.heading1': 'Heading 1',
  'pages.products.add.editor.heading2': 'Heading 2',
  'pages.products.add.editor.heading3': 'Heading 3',
  'pages.products.add.editor.heading4': 'Heading 4',

  // Products Edit Page
  'pages.products.edit.title': 'Edit Product',
  'pages.products.edit.submit': 'Update Product',
  'pages.products.edit.saveProduct': 'Update Product',
  'pages.products.edit.updateSuccess': 'Product updated successfully',
  'pages.products.edit.success': 'Product updated successfully',
  'pages.products.edit.error': 'Please fill in required fields',
  'pages.products.edit.productIdRequired': 'Product ID is required',
  'pages.products.edit.productNotFound': 'Product not found',
  'pages.products.edit.loadSuccess': 'Product loaded successfully',
  'pages.products.edit.loadError': 'Failed to load product data',
  'pages.products.edit.loading': 'Loading product...',
  'pages.products.edit.back': 'Back',
  'pages.products.edit.reset': 'Reset to Original',
  'pages.products.edit.resetSuccess': 'Product data has been reset to original values',
  'pages.products.edit.noOriginalData': 'No original data available to reset',
  
  // Products Preview
  'pages.products.preview.close': 'Close',
  'pages.products.preview.images': 'Product Images',
  'pages.products.preview.basicInfo': 'Basic Information',
  'pages.products.preview.productName': 'Product Name',
  'pages.products.preview.category': 'Category',
  'pages.products.preview.brand': 'Brand',
  'pages.products.preview.description': 'Description',
  'pages.products.preview.priceStock': 'Price & Stock',
  'pages.products.preview.price': 'Price',
  'pages.products.preview.originalPrice': 'Original Price',
  'pages.products.preview.stock': 'Stock',
  'pages.products.preview.sku': 'SKU Code',
  'pages.products.preview.barcode': 'Barcode',
  'pages.products.preview.options': 'Product Options',
  'pages.products.preview.optionName': 'Option Name',
  'pages.products.preview.optionPrice': 'Additional Price',
  'pages.products.preview.optionStock': 'Stock',
  'pages.products.preview.optionSku': 'SKU',
  'pages.products.preview.shippingInfo': 'Shipping Information',
  'pages.products.preview.weight': 'Weight',
  'pages.products.preview.dimensions': 'Dimensions',
  'pages.products.preview.shippingMethod': 'Shipping Method',
  'pages.products.preview.salesSettings': 'Sales Settings',
  'pages.products.preview.status': 'Sales Status',
  'pages.products.preview.displayStatus': 'Display Status',
  'pages.products.preview.featured': 'Featured',
  'pages.products.preview.newArrival': 'New Arrival',
  'pages.products.preview.bestSeller': 'Best Seller',
  'pages.products.preview.additionalInfo': 'Additional Information',
  'pages.products.preview.tags': 'Tags',
  'pages.products.preview.keywords': 'Search Keywords',
  'pages.products.preview.memo': 'Admin Memo',
  'pages.products.preview.originInfo': 'Origin Information',
  'pages.products.preview.origin': 'Country of Origin',
  'pages.products.preview.manufacturer': 'Manufacturer',
  'pages.products.preview.importDate': 'Import Date',
  
  // Products Category Management
  'pages.products.category.title': 'Category Management',
  'pages.products.store.add': 'Add Store',
  'pages.products.store.addTitle': 'Add Store',
  'pages.products.store.name': 'Store Name',
  'pages.products.companymallCategory.title': 'Companymall Category Management',
  'pages.products.category.storeName': 'Store Name',
  'pages.products.category.selectStore': 'Select Store',
  'pages.products.category.selectCategory': 'Select Category',
  'pages.products.category.storeRequired': 'Store is required',
  'pages.products.category.categoryRequired': 'Category is required',
  'pages.products.category.id': 'ID',
  'pages.products.category.name': 'Category Name',
  'pages.products.category.level1Placeholder': 'Level 1 (required)',
  'pages.products.category.level2Placeholder': 'Level 2 (required)',
  'pages.products.category.level2Required': 'Level 2 category is required',
  'pages.products.category.level3Placeholder': 'Level 3 (optional)',
  'pages.products.category.nameEn': 'English Name',
  'pages.products.category.nameCn': 'Chinese Name',
  'pages.products.category.parent': 'Parent Category',
  'pages.products.category.level': 'Level',
  'pages.products.category.order': 'Display Order',
  'pages.products.category.productCount': 'Products',
  'pages.products.category.status': 'Status',
  'pages.products.category.createdAt': 'Created',
  'pages.products.category.actions': 'Actions',
  'pages.products.category.add': 'Add Category',
  'pages.products.category.edit': 'Edit',
  'pages.products.category.delete': 'Delete',
  'pages.products.category.treeView': 'Tree View',
  'pages.products.category.tableView': 'Table View',
  'pages.products.category.addTitle': 'Add Category',
  'pages.products.category.editTitle': 'Edit Category',
  'pages.products.category.deleteConfirm': 'Delete Category',
  'pages.products.category.deleteContent': 'Delete "{name}" category? {count}',
  'pages.products.category.deleteSuccess': 'Category deleted',
  'pages.products.category.updateSuccess': 'Category updated',
  'pages.products.category.createSuccess': 'Category created',
  'pages.products.category.loadedFromLocalStorage': 'Categories loaded from local storage (API unavailable)',
  'pages.products.category.platform': 'Platform',
  'pages.products.category.platformTaobao': 'Taobao',
  'pages.products.category.platformVip': 'VVIC',
  'pages.products.category.platformMyCompany': 'Company Mall',
  'pages.products.category.includeInactive': 'Include Inactive',
  'pages.products.category.editImage': 'Edit Image',
  'pages.products.category.editName': 'Edit Name',
  'pages.products.category.editStatus': 'Edit Status',
  'pages.products.category.editRecommend': 'Edit Recommend',
  'pages.products.category.clickToEditImage': 'Click image to edit',
  'pages.products.category.clickToEditName': 'Click name to edit',
  'pages.products.category.clickToEditStatus': 'Click status to edit',
  'pages.products.category.clickToEditRecommend': 'Click recommend to edit',
  'pages.products.category.totalCategories': 'Total Categories',
  'pages.products.category.upload': 'Upload',
  'pages.products.category.uploadImageOnly': 'Only image files can be uploaded',
  'pages.products.category.imageSizeLimit': 'Image size must be less than 10MB',
  'pages.products.category.uploadSuccess': 'Image uploaded successfully',
  'pages.products.category.uploadFailed': 'Image upload failed',
  'pages.products.category.image': 'Image',
  'pages.products.category.externalId': 'External ID',
  
  // Todayggigu Category Management
  'pages.products.todayggigu.category.title': 'Category Management',
  'pages.products.todayggigu.category.addLevel1': 'Register Level 1 Category',
  'pages.products.todayggigu.category.sortLevel1': 'Sort Level 1 Categories',
  'pages.products.todayggigu.category.level1Title': 'Level 1 Category Register/Edit',
  'pages.products.todayggigu.category.level2Title': 'Level 2 Category Register/Edit',
  'pages.products.todayggigu.category.orderTitle': 'Change Category Order',
  'pages.products.todayggigu.category.parentCategory': 'Parent Category',
  'pages.products.todayggigu.category.categoryName': 'Category Name',
  'pages.products.todayggigu.category.categoryNamePlaceholder': 'Enter category name',
  'pages.products.todayggigu.category.categoryNameRequired': 'Please enter category name',
  'pages.products.todayggigu.category.usage': 'Usage Status',
  'pages.products.todayggigu.category.use': 'Use',
  'pages.products.todayggigu.category.notUse': 'Not Use',
  'pages.products.todayggigu.category.no': 'No',
  'pages.products.todayggigu.category.name': 'Category Name',
  'pages.products.todayggigu.category.usageStatus': 'Usage Status',
  'pages.products.todayggigu.category.registeredAt': 'Registered At',
  'pages.products.todayggigu.category.actions': 'Actions',
  'pages.products.todayggigu.category.register': 'Register',
  'pages.products.todayggigu.category.edit': 'Edit',
  'pages.products.todayggigu.category.order': 'Order',
  'pages.products.todayggigu.category.delete': 'Delete',
  'pages.products.todayggigu.category.save': 'Save',
  'pages.products.todayggigu.category.close': 'Close',
  'pages.products.todayggigu.category.deleteConfirm': 'Delete Category',
  'pages.products.todayggigu.category.deleteContent': 'Are you sure you want to delete "{name}" category?',
  'pages.products.todayggigu.category.deleteSuccess': 'Category deleted successfully',
  'pages.products.todayggigu.category.deleteFailed': 'Failed to delete category',
  'pages.products.todayggigu.category.createSuccess': 'Category created successfully',
  'pages.products.todayggigu.category.updateSuccess': 'Category updated successfully',
  'pages.products.todayggigu.category.saveFailed': 'Failed to save category',
  'pages.products.todayggigu.category.loadFailed': 'Failed to load categories',
  'pages.products.todayggigu.category.orderSuccess': 'Order changed successfully',
  'pages.products.todayggigu.category.orderFailed': 'Failed to change order',
  'pages.products.todayggigu.category.noSubcategories': 'No subcategories',
  'pages.products.todayggigu.category.dragToReorder': 'Drag to reorder',

  'pages.products.category.nameKo': 'Category Name (Korean)',
  'pages.products.category.nameKoPlaceholder': 'e.g. Clothing',
  'pages.products.category.nameKoRequired': 'Please enter category name',
  'pages.products.category.nameEnLabel': 'Category Name (English)',
  'pages.products.category.nameEnPlaceholder': 'e.g. Clothing',
  'pages.products.category.nameCnLabel': 'Category Name (Chinese)',
  'pages.products.category.nameCnPlaceholder': 'e.g. 服装',
  'pages.products.category.parentLabel': 'Parent Category',
  'pages.products.category.parentPlaceholder': 'Leave empty for top level',
  'pages.products.category.icon': 'Icon',
  'pages.products.category.iconPlaceholder': 'e.g. 👔 (emoji or icon class)',
  'pages.products.category.orderLabel': 'Display Order',
  'pages.products.category.orderPlaceholder': 'Lower numbers appear first',
  'pages.products.category.description': 'Description',
  'pages.products.category.descriptionPlaceholder': 'Category description',
  'pages.products.category.statusLabel': 'Status',
  'pages.products.category.statusAll': 'All',
  'pages.products.category.active': 'Active',
  'pages.products.category.inactive': 'Inactive',
  'pages.products.category.levelRequired': 'Please select level',
  'pages.products.category.levelPlaceholder': 'Please select level',
  'pages.products.category.parentRequired': 'Please select parent category',
  'pages.products.category.topLevel': 'Top Level',
  'pages.products.category.level1': 'Level 1',
  'pages.products.category.store': 'Store',
  'pages.products.category.level2': 'Level 2',
  'pages.products.category.level3': 'Level 3',
  'pages.products.category.level4': 'Level 4',
  'pages.products.category.orderUp': 'up',
  'pages.products.category.orderDown': 'down',
  'pages.products.category.orderMoved': '"{name}" category moved {direction}',
  'pages.products.category.reorderSaved': 'Category order saved',
  'pages.products.category.reorderSameParentOnly': 'Categories can only be reordered within the same parent (same level)',
  'pages.products.category.dragToReorder': 'Drag to reorder',
  'pages.products.category.countUnit': ' ',
  'pages.products.category.imageUrl': 'Image URL',
  'pages.products.category.imageUrlPlaceholder': 'e.g. https://example.com/image.jpg',
  'pages.products.category.imageUrlDesktop': 'Desktop Image URL',
  'pages.products.category.imageUrlMobile': 'Mobile Image URL',
  'pages.products.category.imageUrlDesktopPlaceholder': 'e.g. https://example.com/desktop-image.jpg',
  'pages.products.category.imageUrlMobilePlaceholder': 'e.g. https://example.com/mobile-image.jpg',
  'pages.products.category.updateFailed': 'Failed to update category',
  'pages.products.category.selectCategoryFirst': 'Please select a category first',
  'pages.products.category.categoryNotFound': 'Category not found',
  'pages.products.category.searchNamePlaceholder': 'Search by category name',
  'pages.products.category.statusRecommend': 'Status/Recommend',
  'pages.products.category.recommended': 'Recommended',
  'pages.products.category.notRecommended': 'Not Recommended',
  'pages.products.category.clickToEdit': 'Click to edit',
  'pages.products.category.validationError': 'Validation error',
  'pages.products.category.unauthorized': 'Authentication required',
  
  // Products Import Taobao
  'pages.products.import.title': 'Import from Promotion Url/1688/AliExpress/Temu',
  'pages.products.import.subtitle': 'Enter product URL to automatically fetch information',
  'pages.products.import.noSpecifications': 'No Specifications',
  'pages.products.import.platforms': 'Supported Platforms',
  'pages.products.import.urlPlaceholder': 'Enter product URL (e.g. https://item.taobao.com/item.htm?id=123456789)',
  'pages.products.import.fetch': 'Fetch Product',
  'pages.products.import.fetching': 'Fetching product information...',
  'pages.products.import.fetchSuccess': 'Product information fetched',
  'pages.products.import.urlRequired': 'Please enter URL',
  'pages.products.import.invalidUrl': 'Supported platforms: Taobao (Tmall), 1688, VVIC',
  'pages.products.import.productIdNotFound': 'Could not extract product ID from URL. Please check the URL format.',
  'pages.products.import.fetchError': 'Failed to fetch product information. Please try again.',
  'pages.products.import.productInfo': 'Product Information',
  'pages.products.import.translate': 'Auto Translate',
  'pages.products.import.translateSuccess': 'Translation completed',
  'pages.products.import.translateError': 'Translation failed',
  'pages.products.import.save': 'Add Product',
  'pages.products.import.saveSuccess': 'Product added successfully',
  'pages.products.import.saveError': 'Please fill in required fields',
  'pages.products.import.basicInfo': 'Basic Information',
  'pages.products.import.optionsInfo': 'Options',
  'pages.products.import.specsInfo': 'Specifications',
  'pages.products.import.titleCn': 'Product Name (Chinese)',
  'pages.products.import.titleCnPlaceholder': 'Enter Chinese product name',
  'pages.products.import.titleKo': 'Product Name (Korean)',
  'pages.products.import.titleKoPlaceholder': 'Enter Korean product name',
  'pages.products.import.titleEn': 'Product Name (English)',
  'pages.products.import.titleEnPlaceholder': 'Enter English product name',
  'pages.products.import.originalPrice': 'Original Price (₩)',
  'pages.products.import.sellingPrice': 'Selling Price (₩)',
  'pages.products.import.realPrice': 'Real Price',
  'pages.products.import.otherPrice': 'Other Price',
  'pages.products.import.tagPrice': 'Tag Price',
  'pages.products.import.margin': 'Margin',
  'pages.products.import.productType': 'Product Type',
  'pages.products.import.productTypeSelf': 'Self',
  'pages.products.import.productTypeLabang': 'Labang',
  'pages.products.import.labangEndDate': 'Labang End Date',
  'pages.products.import.labangEndDateRequired': 'Labang end date is required',
  'pages.products.import.labangPeriod': 'Labang Period',
  'pages.products.import.labangPeriodRequired': 'Labang period is required',
  'pages.products.import.days': 'days',
  'pages.products.list.productType': 'Product Type',
  'pages.products.import.description': 'Description (HTML)',
  'pages.products.import.descriptionHint': 'HTML content is supported. You can edit the description directly.',
  'pages.products.import.category': 'Category',
  'pages.products.import.categoryPlaceholder': 'Select category',
  'pages.products.import.optionNameCn': 'Option Name (Chinese)',
  'pages.products.import.optionNameKo': 'Option Name (Korean)',
  'pages.products.import.optionNameEn': 'Option Name (English)',
  'pages.products.import.optionImage': 'Option Image',
  'pages.products.import.optionImageUrlPlaceholder': 'Enter image URL',
  'pages.products.import.selectStore': 'Select Store',
  'pages.products.import.inputAttributes': 'Input Attributes',
  'pages.products.import.attributeName': 'Attribute Name',
  'pages.products.import.attributeValue': 'Attribute Value',
  'pages.products.import.synchronizeToPropertyList': 'Synchronize To Property List',
  'pages.products.import.attributeList': 'Attribute List',
  'pages.products.import.multipleAttributes': 'Multiple Attributes',
  'pages.products.import.rmbCostPrice': 'RMB Cost Price',
  'pages.products.import.koreanWonCostPrice': 'Korean Won Cost Price',
  'pages.products.import.originalPriceRMB': 'Original Price (RMB)',
  'pages.products.import.originalPriceKoreanWon': 'Original Price (Korean Won)',
  'pages.products.import.rmbPrice': 'RMB Price',
  'pages.products.import.salesPrice': 'Sales Price',
  'pages.products.import.inStock': 'In Stock',
  'pages.products.import.rebatePercentage': 'Rebate Percentage',
  'pages.products.import.attributeImages': 'Attribute Images',
  'pages.products.import.attributesInfo': 'Attributes Information',
  'pages.products.import.optionPrice': 'Offer Price',
  'pages.products.import.optionPriceCny': 'Price (CNY)',
  'pages.products.import.optionPriceKrw': 'Price (KRW)',
  'pages.products.import.optionStock': 'Stock',
  'pages.products.import.optionSkuId': 'SKU ID',
  'pages.products.import.optionSpecId': 'Spec ID',
  'pages.products.import.specId': 'Spec ID',
  'pages.products.import.descriptionTab': 'Description',
  'pages.products.import.specKeyCn': 'Attribute Name (Chinese)',
  'pages.products.import.specKeyKo': 'Attribute Name (Korean)',
  'pages.products.import.specKeyEn': 'Attribute Name (English)',
  'pages.products.import.specValueCn': 'Value (Chinese)',
  'pages.products.import.specValueKo': 'Value (Korean)',
  'pages.products.import.specValueEn': 'Value (English)',
  'pages.products.import.noImagesSelected': 'No images selected',
  'pages.products.import.downloading': 'Downloading {count} image(s)...',
  'pages.products.import.downloadSuccess': 'Successfully downloaded {count} image(s)',
  'pages.products.import.downloadPartial': 'Downloaded {success} of {total} image(s). Some images may have opened in a new tab due to CORS restrictions.',
  'pages.products.import.downloadError': 'Failed to download images',
  'pages.products.import.availableProducts': 'Available Products',
  'pages.products.import.unit': 'units',
  'pages.products.import.category.clothing': 'Clothing',
  'pages.products.import.category.shoes': 'Shoes',
  'pages.products.import.category.bags': 'Bags',
  'pages.products.import.category.accessories': 'Accessories',
  'pages.products.import.category.electronics': 'Electronics',
  'pages.products.import.category.home': 'Home & Living',
  'pages.products.import.currency.cny': 'CNY',
  'pages.products.import.currency.krw': 'KRW',
  'pages.products.import.platform.taobao': 'Taobao',
  'pages.products.import.platform.1688': '1688',
  'pages.products.import.platform.tmall': 'Tmall',
  'pages.products.import.platform.aliexpress': 'AliExpress',
  'pages.products.import.platform.temu': 'Temu',
  'pages.products.import.platform.vvic': 'VVIC',
  'pages.products.import.ratingMax': '5.0',
  'pages.products.import.sellerInfo': 'Seller Information',
  'pages.products.import.seller': 'Seller',
  'pages.products.import.rating': 'Rating',
  'pages.products.import.sales': 'Sales',
  'pages.products.import.sellerAddress': 'Seller Address',
  'pages.products.import.sellerPhone': 'Seller Phone',
  'pages.products.import.sellerMailbox': 'Seller Mailbox',
  'pages.products.import.sellerOpenId': 'Seller Open ID',
  'pages.products.import.productRating': 'Product Rating',
  'pages.products.import.soldAmount': 'Sold Amount',
  'pages.products.import.salesUnit': ' ',
  'pages.products.import.images': 'Product Images',
  'pages.products.import.imagesCount': 'Product Images ({count})',
  'pages.products.import.download': 'Download',
  'pages.products.import.downloadStart': 'Starting download of {count} images',
  'pages.products.import.imageSelectInfo': 'Drag images to reorder. The first image is automatically set as the main image.',
  'pages.products.import.mainImage': 'Main',
  'pages.products.imageTranslate.button': 'Translate all images',
  'pages.products.imageTranslate.descriptionButton': 'Translate text in description images',
  'pages.products.imageTranslate.title': 'Review image translations',
  'pages.products.imageTranslate.useTranslated': 'Use translated',
  'pages.products.imageTranslate.noText': 'No translatable text',
  'pages.products.imageTranslate.original': 'Original',
  'pages.products.imageTranslate.translated': 'Translated',
  'pages.products.imageTranslate.erased': 'Erased',
  'pages.products.imageTranslate.editHint': 'For each caption choose translate, keep or erase, and edit the translation yourself.',
  'pages.products.imageTranslate.rerender': 'Re-render',
  'pages.products.imageTranslate.actTranslate': 'Translate',
  'pages.products.imageTranslate.actKeep': 'Keep',
  'pages.products.imageTranslate.actErase': 'Erase',
  'pages.products.imageTranslate.autoPlaceholder': 'Leave empty to auto-translate',
  'pages.products.imageTranslate.keptPlaceholder': 'Left as printed',
  'pages.products.imageTranslate.tilted': 'Tilted',
  'pages.products.imageTranslate.tiltedHint': 'Tilted text (written on a prop) is left as printed by default.',
  'pages.products.imageTranslate.truncated': 'Cut off',
  'pages.products.imageTranslate.truncatedHint': 'The text did not fit and was cut with "…". Try a shorter wording.',
  'pages.products.imageTranslate.staleHint': 'Some images have edits that are not rendered yet. Press "Re-render" first.',
  'pages.products.imageTranslate.reopened': 'Reopened translation',
  'pages.products.imageTranslate.reopenedHint': 'This image already carries an applied translation. Its source and your earlier choices were restored, so you can keep editing. Untick "Use translated" and apply to go back to the original.',
  'pages.products.imageTranslate.selectAll': 'Select all translated',
  'pages.products.imageTranslate.selected': 'Selected',
  'pages.products.imageTranslate.shortcutHint': '← → move · Space select',
  'pages.products.imageTranslate.failedHint': '{count} image(s) failed. Check the list and retry.',
  'pages.products.imageTranslate.viewLarge': 'Large',
  'pages.products.imageTranslate.viewCompact': 'Small',
  'pages.products.imageTranslate.failed': 'Failed',
  'pages.products.imageTranslate.retry': 'Retry',
  'pages.products.imageTranslate.apply': 'Apply ({count})',
  'pages.products.imageTranslate.cancel': 'Cancel',
  'pages.products.imageTranslate.applied': 'Replaced {count} image(s)',
  'pages.products.imageTranslate.noImages': 'No images to translate',
  'pages.products.import.mainImageSet': 'Main image set successfully',
  'pages.products.import.imagePreview': 'Image Preview',
  'pages.products.import.close': 'Close',

  // Orders Common
  'pages.orders.common.orderNumber': 'Order Number',
  'pages.orders.shippingMethod.sea': 'Ship',
  'pages.orders.shippingMethod.air': 'Air',
  'pages.orders.shippingMethod.standard': 'Standard',
  'pages.orders.common.manual': 'Manual Payment',
  'pages.orders.common.auto': 'Automatic Payment',
  'pages.orders.common.unpaid': 'UnPaid',
  'pages.orders.common.productType': '[Product Type]',
  'pages.orders.common.platformType': 'Platform Type',
  'pages.orders.common.shippingMethod': 'Shipping Method',
  'pages.orders.common.shippingMethodNormal': 'Normal',
  'pages.orders.common.shippingMethodFast': 'Fast',
  'pages.orders.common.shippingMethodExpress': 'Express',
  'pages.orders.common.shippingStatus': 'Shipping Status',
  'pages.orders.common.warehouseAndTransferMethod': 'Warehouse/Shipping',
  'pages.orders.common.paymentMethodShort': 'Payment',
  'pages.orders.common.memberNameWithMailbox': 'Member/(Mailbox)',
  'pages.orders.common.receiverName': 'Receiver',
  'pages.orders.common.sellerName': 'Seller',
  'pages.orders.common.sellerMailbox': 'Seller mailbox',
  'pages.orders.common.sellerNameWithMailbox': 'Seller/(Mailbox)',
  'pages.orders.common.paymentMethod': 'Payment Method',
  'pages.orders.common.shipped': 'Shipped',
  'pages.orders.common.notShipped': 'Not Shipped',
  'pages.orders.common.membershipCode': 'Member Name',
  'pages.orders.common.userId': 'User ID',
  'pages.orders.common.userUniqueId': 'Member No.',
  'pages.orders.common.receiver': 'Receiver',
  'pages.orders.common.trackingCount': 'Tracking Count',
  'pages.orders.common.warehousedCount': 'Warehoused',
  'pages.orders.common.quantity': 'Quantity',
  'pages.orders.common.totalAmount': 'Total Price',
  'pages.orders.common.chineseTransportationCost': '[Chinese Transportation Cost]',
  'pages.orders.common.RealCost': '[Real Cost]',
  'pages.orders.common.internationalShippingCost': '1st Cost',
  'pages.orders.common.firstCost': '1st Cost',
  'pages.orders.common.secondCost': '2nd Cost',
  'pages.orders.common.firstInternationalShippingCost': '1st International Shipping Cost',
  'pages.orders.common.appliedWeight': 'Applied Weight',
  'pages.orders.common.realWeight': 'Real Weight',
  'pages.orders.common.extraInternationalShippingCost': '2nd Cost',
  'pages.orders.common.paymentPending': 'Payment Pending',
  'pages.orders.common.paymentComplete': 'Payment Complete',
  'pages.orders.common.total': 'Total {count}',
  'pages.orders.common.paidAmount': 'Paid Amount',
  'pages.orders.common.weight': 'Weight',
  'pages.orders.common.trackingNumber': 'Tracking Number',
  'pages.orders.common.waybillNumber': 'Waybill Number',
  'pages.orders.common.shipDate': 'Ship Date',
  'pages.orders.common.rackNumber': 'Rack Number',
  'pages.orders.common.warehouseStatus': 'Warehouse Status',
  'pages.orders.common.progressStatus': 'Progress Status',
  'pages.orders.common.createdAt': 'Created At',
  'pages.orders.common.updatedAt': 'Updated At',
  'pages.orders.common.inquiryResponder': 'Inquiry Responder',
  'pages.orders.common.buyer': 'Buyer',
  'pages.orders.common.warehouseHandler': 'Warehouse Handler',
  'pages.orders.common.actions': 'Actions',
  'pages.orders.common.paymentStatus': 'Payment Status',
  'pages.orders.common.transferMethod': 'Transfer Method',
  'pages.orders.common.none': 'None',
  'pages.orders.common.notRegistered': 'Not Registered',
  'pages.orders.common.kdexpCarrier': 'Kyungdong Express',
  'pages.orders.common.kdexpShort': 'KD',
  'pages.orders.common.kdexpSentDate': 'Sent',
  'pages.orders.common.kdexpMore': '+{count} more',
  'pages.orders.common.items': ' ',
  'pages.orders.common.won': 'KRW',
  'pages.orders.common.cny': 'CNY',
  'pages.orders.common.count': ' ',
  'pages.orders.filter.sellerId': 'Seller ID',
  'pages.orders.filter.sellerIdPlaceholder': 'Live seller ID (sellerId)',
  'pages.orders.filter.memberMailbox': 'Member mailbox',
  'pages.orders.filter.sellerMailbox': 'Seller mailbox',
  
  // Order Status Groups
  'pages.orders.status.purchaseAgency': 'Purchase Agency',
  'pages.orders.status.vvicHighpass': 'VVIC Highpass',
  'pages.orders.status.rocket': 'Rocket',
  'pages.orders.status.shippingAgency': 'Shipping Agency',
  'pages.orders.status.warehouse': 'Warehouse',
  'pages.orders.status.error': 'Error',
  'pages.orders.status.return': 'Return Management',
  'pages.orders.status.inventory': 'Inventory Management',
  'pages.orders.status.warehoused': 'Warehoused',
  'pages.orders.status.done': 'Done',
  
  // Order Status Items
  'pages.orders.status.tempSave': 'Temp Save',
  'pages.orders.status.purchaseQuote': 'Purchase Quote',
  'pages.orders.status.paymentPending': 'Payment Pending',
  'pages.orders.status.paymentComplete': 'Payment Complete',
  'pages.orders.status.purchasing': 'Purchasing',
  'pages.orders.status.automaticProcurement': 'Automatic Procurement',
  'pages.orders.status.manualProcurement': 'Manual Procurement',
  'pages.orders.status.financialSettlement': 'Financial Settlement',
  'pages.orders.status.problemProduct': 'Problem Product',
  'pages.orders.status.purchaseFinalComplete': 'Purchase Complete',
  'pages.orders.status.centerArrivalExpected': 'Arrival Expected',
  'pages.orders.status.warehouseInProgress': 'Warehousing',
  'pages.orders.status.warehouseInComplete': 'Warehoused',
  'pages.orders.status.processing': 'Processing',
  'pages.orders.status.notWarehoused': 'Not Warehoused',
  'pages.orders.status.additionalFeePending': 'Additional Fee Pending',
  'pages.orders.status.additionalFeeComplete': 'Additional Fee Complete',
  'pages.orders.status.shipmentPending': 'Shipment Pending',
  'pages.orders.status.shipmentComplete': 'Shipped',
  'pages.orders.status.waitingSettlement': 'Waiting for Settlement',
  'pages.orders.status.settlementComplete': 'Settlement Complete',
  'pages.orders.status.deliveryException': 'Delivery Exception',
  'pages.orders.status.expectedWarehouseIn': 'Expected Warehouse In',
  'pages.orders.status.domesticWarehousePacking': 'Warehouse Packing',
  'pages.orders.status.errorWarehouse': 'Error Warehouse',
  'pages.orders.status.noOrderInfo': 'No Data',
  'pages.orders.status.userRefundRequest': 'User Refund Request',
  'pages.orders.status.userRefundProgress': 'User Refund Progress',
  'pages.orders.status.userRefundComplete': 'User Refund Complete',
  'pages.orders.status.platformRefundRequest': 'Platform Refund Request',
  'pages.orders.status.platformRefundComplete': 'Platform Refund Complete',
  'pages.orders.status.localRefundRequest': 'Platform Refund Request',
  'pages.orders.status.localRefundProgress': 'Platform Refunding',
  'pages.orders.status.localRefundComplete': 'Platform Refund Complete',
  'pages.orders.status.orderCancelled': 'Order Cancelled',
  'pages.orders.status.errorIgnore': 'Error Ignore',
  'pages.orders.status.returnMove': 'Return Move',
  'pages.orders.status.refundProcessing': 'Refund Processing',
  'pages.orders.status.refundRequest': 'Refund Request',
  'pages.orders.status.cancelRequest': 'Cancel Request',
  'pages.orders.status.refunded': 'Refunded',
  'pages.orders.status.shipmentHold': 'Shipment Hold',
  'pages.orders.status.internationalShipping': 'International Shipping',
  'pages.orders.status.internationalInOut': 'International Inbound/Outbound',
  'pages.orders.status.internationalShippingInProgress': 'International Shipping in Progress',
  'pages.orders.status.internationalShippingComplete': 'International Shipping Completed',
  'pages.orders.status.orderReceived': 'Order Received',
  'pages.orders.status.finalRefundRequest': 'Final Refund Request',
  'pages.orders.status.finalRefundProgress': 'Final Refund Progress',
  'pages.orders.status.finalRefundComplete': 'Final Refund Completed',

  // Refund Modal Translations
  'pages.orders.userRefund.title': 'User Refund Request',
  'pages.orders.userRefund.orderInfo': 'Order Information',
  'pages.orders.userRefund.priceBreakdown': 'Price Breakdown',
  'pages.orders.userRefund.productPrice': 'Product Price',
  'pages.orders.userRefund.chinaShipping': 'Chinese Transportation',
  'pages.orders.userRefund.serviceFee': 'Service Fee',
  'pages.orders.userRefund.addOnServices': 'Add-on Services',
  'pages.orders.userRefund.selectRefundItems': 'Select items to refund:',
  'pages.orders.userRefund.refundItems': 'Refund Items:',
  'pages.orders.userRefund.alwaysRefunded': '(Always Refunded)',
  'pages.orders.userRefund.refundSummary': 'Refund Summary',
  'pages.orders.userRefund.productPriceRefund': 'Product Price Refund',
  'pages.orders.userRefund.chinaShippingRefund': 'Chinese Transportation Refund',
  'pages.orders.userRefund.serviceFeeRefund': 'Service Fee Refund',
  'pages.orders.userRefund.totalRefund': 'Total Refund',

  'pages.orders.platformRefund.title': 'Platform Refund Request',
  'pages.orders.platformRefund.orderInfo': 'Order Information',
  'pages.orders.platformRefund.priceBreakdown': 'Price Breakdown',
  'pages.orders.platformRefund.productPrice': 'Product Price',
  'pages.orders.platformRefund.chinaShipping': 'Chinese Transportation',
  'pages.orders.platformRefund.serviceFee': 'Service Fee',
  'pages.orders.platformRefund.addOnServices': 'Add-on Services',
  'pages.orders.platformRefund.selectRefundItems': 'Select items to refund:',
  'pages.orders.platformRefund.refundItems': 'Refund Items:',
  'pages.orders.platformRefund.alwaysRefunded': '(Always Refunded)',
  'pages.orders.platformRefund.refundSummary': 'Refund Summary',
  'pages.orders.platformRefund.productPriceRefund': 'Product Price Refund',
  'pages.orders.platformRefund.serviceFeeRefund': 'Service Fee Refund',
  'pages.orders.platformRefund.chinaShippingRefund': 'Chinese Transportation Refund',
  'pages.orders.platformRefund.totalRefund': 'Total Refund',
  'pages.orders.alreadyRefundedExternally.checkbox': 'Already refunded outside the system (no payment cancel, no deposit credit)',
  'pages.orders.alreadyRefundedExternally.alertTitle': 'No payment cancel and no deposit credit',
  'pages.orders.alreadyRefundedExternally.alertDescription': 'Use only when the customer has already been refunded by bank transfer or in the PG admin console. The card payment is not cancelled, and bank-transfer or deposit-paid orders get no deposit credit either (only the deposit share of a card/bank-transfer checkout is returned to deposit). Only the refund record, rebate clawback, stock restore and status change are applied. To refund a bank-transfer order to deposit as usual, leave this unchecked.',

  'pages.orders.finalRefund.title': 'Final Refund Request',
  'pages.orders.finalRefund.orderInfo': 'Order Information',
  'pages.orders.finalRefund.priceBreakdown': 'Price Breakdown',
  'pages.orders.finalRefund.paymentType': 'Payment Type',
  'pages.orders.finalRefund.paidPrice': 'Paid Price',
  'pages.orders.finalRefund.refundPrice': 'Refund Price',
  'pages.orders.finalRefund.ratio': 'Ratio (%)',
  'pages.orders.finalRefund.productPrice': 'Price',
  'pages.orders.finalRefund.chinaShipping': 'Chinese Transportation Price',
  'pages.orders.finalRefund.additionalInternational': 'Additional International Shipping',
  'pages.orders.finalRefund.secondTierAddOnServices': 'Second Tier Add-on Services',
  'pages.orders.finalRefund.serviceFee': 'Service Fee',
  'pages.orders.finalRefund.addOnServices': 'Add-on Services',
  'pages.orders.finalRefund.totalRefund': 'Total Refund',
  'pages.orders.finalRefund.refundExceedsPaid': 'Refund price cannot exceed paid price',
  'pages.orders.finalRefund.firstTierPayment': '1st payment',
  'pages.orders.finalRefund.secondTierPayment': '2nd payment',
  'pages.orders.finalRefund.bundleOrder': 'Bundle order (H01)',
  'pages.orders.finalRefund.bundleOrderHint': 'Set 1st-tier product and service fee refund per original parent order.',
  'pages.orders.finalRefund.noAmountSelected': 'Enter at least one refund amount.',
  'pages.orders.finalRefund.noRefundableItems': 'No refundable items available for this order.',
  'pages.orders.finalRefund.grandTotal': 'Grand total',
  'pages.orders.finalRefund.executeSuccess': 'Final refund executed successfully.',
  'pages.orders.refundPayout.failedTitle': 'The refund did not reach the customer',
  'pages.orders.refundPayout.failedBody': 'The gateway refused the cancellation, so the refund is still pending payout. Do not mark the order completed; resolve the reason and run the refund again. If you cancelled it in the gateway console, record it with [Already refunded externally].',
  'pages.orders.refundPayout.gatewayReason': 'Gateway response',
  'pages.orders.common.exchangeRate': 'Exchange Rate',

  'pages.orders.status.returnRequest': 'Return Request',
  'pages.orders.status.returnComplete': 'Return Complete',
  'pages.orders.status.inventoryRequest': 'Inventory Request',
  'pages.orders.status.inventoryAvailable': 'Available',
  'pages.orders.status.inventoryOut': 'Out of Stock',
  'pages.orders.status.applicationReceived': 'Application Received',
  'pages.orders.status.receiptApplication': 'Receipt Application',
  'pages.orders.status.deliveryApply': 'Delivery Application',
  
  // In China Warehouse Page
  'pages.orders.inChinaWarehouse.title': 'In China Warehouse',
  'pages.orders.inChinaWarehouse.regularMember': 'Regular Members',
  'pages.orders.inChinaWarehouse.businessMember': 'Business Members',
  'pages.orders.inChinaWarehouse.waiting': 'Waiting',
  'pages.orders.inChinaWarehouse.arrived': 'Arrived',
  'pages.orders.inChinaWarehouse.inspecting': 'Inspecting',
  'pages.orders.inChinaWarehouse.count': ' ',
  'pages.orders.inChinaWarehouse.warehouseDate': 'Warehouse Date',
  'pages.orders.inChinaWarehouse.warehouseStatus': 'Warehouse Status',
  'pages.orders.inChinaWarehouse.inspectionStatus': 'Inspection Status',
  'pages.orders.inChinaWarehouse.weight': 'Weight',
  'pages.orders.inChinaWarehouse.volume': 'Volume',
  'pages.orders.inChinaWarehouse.packageCount': 'Package Count',
  'pages.orders.inChinaWarehouse.inspectionComplete': 'Inspection Complete',
  'pages.orders.inChinaWarehouse.shipmentRequest': 'Shipment Request',
  'pages.orders.inChinaWarehouse.memoNormal': 'Normal Receipt',
  'pages.orders.inChinaWarehouse.memoFragile': 'Handle with Care',
  'pages.orders.inChinaWarehouse.memoReinspect': 'Reinspection Required',
  
  // Pending Address Page
  'pages.orders.pendingAddress.title': 'Pending Address',
  'pages.orders.pendingAddress.regularMember': 'Regular Members',
  'pages.orders.pendingAddress.businessMember': 'Business Members',
  'pages.orders.pendingAddress.noAddress': 'No Address',
  'pages.orders.pendingAddress.addressCompleted': 'Address Completed',
  'pages.orders.pendingAddress.filterApplied': '{group} > {label} filter applied',
  'pages.orders.pendingAddress.filterCleared': 'Filter cleared',
  'pages.orders.pendingAddress.addressStatus': 'Address Status',
  'pages.orders.pendingAddress.receiverName': 'Receiver Name',
  'pages.orders.pendingAddress.phone': 'Phone',
  'pages.orders.pendingAddress.address': 'Address',
  'pages.orders.pendingAddress.zipCode': 'Zip Code',
  'pages.orders.pendingAddress.memo': 'Delivery Memo',
  'pages.orders.pendingAddress.editAddress': 'Edit Address',
  'pages.orders.pendingAddress.saveAddress': 'Save',
  'pages.orders.pendingAddress.addressSaved': 'Address information saved',
  'pages.orders.pendingAddress.count': ' ',
  'pages.orders.pendingAddress.pending': 'Pending',
  'pages.orders.pendingAddress.completed': 'Completed',
  
  // Pending Payment Page
  'pages.orders.pendingPayment.title': 'Payment Confirmation',
  'pages.orders.pendingPayment.regularMember': 'Regular Members',
  'pages.orders.pendingPayment.businessMember': 'Business Members',
  'pages.orders.pendingPayment.paymentPending': 'Payment Pending',
  'pages.orders.pendingPayment.paymentCompleted': 'Payment Completed',
  'pages.orders.pendingPayment.filterApplied': '{group} > {label} filter applied',
  'pages.orders.pendingPayment.filterCleared': 'Filter cleared',
  'pages.orders.pendingPayment.paymentPhaseLabel': 'Payment phase',
  'pages.orders.pendingPayment.paymentPhaseAll': 'All (1st + 2nd)',
  'pages.orders.pendingPayment.paymentPhaseFirst': '1st payment',
  'pages.orders.pendingPayment.paymentPhaseSecond': '2nd payment',
  'pages.orders.pendingPayment.clearPaymentPhase': 'Reset payment phase',
  'pages.orders.pendingPayment.unmatchedBankOnlyHint': 'Only unmatched bank transfer orders are listed.',
  'pages.orders.pendingPayment.paymentAmount': 'Payment Amount',
  'pages.orders.pendingPayment.totalAmount': 'Total Amount',
  'pages.orders.pendingPayment.payerName': 'Payer Name',
  'pages.orders.pendingPayment.paymentMethod': 'Payment Method',
  'pages.orders.pendingPayment.paymentDate': 'Payment Date',
  'pages.orders.pendingPayment.orderDetails': 'Order Details',
  'pages.orders.pendingPayment.paymentStatus': 'Payment Status',
  'pages.orders.pendingPayment.actions': 'Actions',
  'pages.orders.pendingPayment.confirmPayment': 'Confirm Payment',
  'pages.orders.pendingPayment.cancelPayment': 'Cancel Payment',
  'pages.orders.pendingPayment.viewDetails': 'View Details',
  'pages.orders.pendingPayment.paymentConfirmed': 'Payment confirmed for order {orderNo}',
  'pages.orders.pendingPayment.paymentConfirmError': 'Failed to confirm payment for order {orderNo}',
  'pages.orders.pendingPayment.orderIdNotFound': 'Order ID not found',
  'pages.orders.pendingPayment.confirmPaymentTitle': 'Confirm Payment',
  'pages.orders.pendingPayment.confirmPaymentContent': 'Are you sure you want to confirm payment for order {orderNo}?',
  'pages.orders.pendingPayment.cancelPaymentTitle': 'Cancel Payment',
  'pages.orders.pendingPayment.cancelPaymentContent': 'Are you sure you want to cancel payment for order {orderNo}?',
  'pages.orders.pendingPayment.paymentCancelled': 'Payment cancelled for order {orderNo}',
  'pages.orders.pendingPayment.paymentCancelError': 'Failed to cancel payment for order {orderNo}',
  'pages.orders.pendingPayment.invalidOrderId': 'Invalid Order ID. Cannot confirm payment.',
  'pages.orders.pendingPayment.depositDiscount': 'Deposit',
  'pages.orders.pendingPayment.deposit': 'Deposit',
  'pages.orders.pendingPayment.point': 'Point',
  'pages.orders.pendingPayment.coupon': 'Coupon',
  'pages.orders.pendingPayment.discount': 'Discount',
  'pages.orders.pendingPayment.pointCoupon': '(Deposits/Points/Coupon)',
  'pages.orders.pendingPayment.regularMemberTag': 'Regular',
  'pages.orders.pendingPayment.businessMemberTag': 'Business',
  'pages.orders.pendingPayment.count': ' ',
  'pages.orders.pendingPayment.paymentMethodCard': 'Credit Card',
  'pages.orders.pendingPayment.paymentMethodTransfer': 'Bank Transfer',
  'pages.orders.pendingPayment.paymentMethodDeposit': 'Deposit',
  'pages.orders.pendingPayment.paymentMethodBillgate': 'Billgate',
  'pages.orders.pendingPayment.memberName': 'Member Name',
  'pages.orders.pendingPayment.applicationDate': 'Application Date',
  'pages.orders.pendingPayment.paymentCost': 'Payment Cost',
  'pages.orders.pendingPayment.depositForUse': 'Deposit for Use',
  'pages.orders.pendingPayment.paymentOrderNumber': 'Payment Order No',
  
  // Order Statistics Page
  'pages.orders.statistics.title': 'Order Statistics',
  'pages.orders.statistics.dateRange': 'Date Range',
  'pages.orders.statistics.last7Days': 'Last 7 Days',
  'pages.orders.statistics.last30Days': 'Last 30 Days',
  'pages.orders.statistics.last90Days': 'Last 90 Days',
  'pages.orders.statistics.totalOrders': 'Total Orders',
  'pages.orders.statistics.purchaseComplete': 'Purchase Complete',
  'pages.orders.statistics.shipped': 'Shipped',
  'pages.orders.statistics.totalSales': 'Total Sales',
  'pages.orders.statistics.refundCount': 'Refund Count',
  'pages.orders.statistics.refundAmount': 'Refund Amount',
  'pages.orders.statistics.trendChart': 'Business Trend Chart',
  'pages.orders.statistics.dailyStats': 'Daily Statistics',
  'pages.orders.statistics.chart.orders': 'Orders',
  'pages.orders.statistics.chart.purchaseComplete': 'Purchase Complete',
  'pages.orders.statistics.chart.shipped': 'Shipped',
  'pages.orders.statistics.chart.revenue': 'Revenue',
  'pages.orders.statistics.chart.refunds': 'Refunds',
  'pages.orders.statistics.chart.refundAmount': 'Refund Amount',
  'pages.orders.statistics.table.date': 'Date',
  'pages.orders.statistics.table.orderCount': 'Order Count',
  'pages.orders.statistics.table.purchaseComplete': 'Purchase Complete',
  'pages.orders.statistics.table.shipped': 'Shipped',
  'pages.orders.statistics.table.revenue': 'Revenue',
  'pages.orders.statistics.table.refundCount': 'Refund Count',
  'pages.orders.statistics.table.refundAmount': 'Refund Amount',
  'pages.orders.statistics.table.total': 'Total {total} items',
  'pages.orders.statistics.sourceFilter': 'Sales source',
  'pages.orders.statistics.source.all': 'All',
  'pages.orders.statistics.source.live': 'Live',
  'pages.orders.statistics.source.ownmall': 'Own mall',
  'pages.orders.statistics.source.1688': '1688',
  'pages.orders.statistics.source.taobao': 'Taobao',
  'pages.orders.statistics.source.vvic': 'VVIC',
  'pages.orders.statistics.sourceBreakdown': 'Sales by source',
  'pages.orders.statistics.sourceOrderCount': '{count} orders',
  'pages.orders.statistics.amountChart': 'Amount trend (revenue by source / refunds)',
  'pages.orders.statistics.countChart': 'Count trend',
  'pages.orders.statistics.sellerTop': 'Top 10 live sellers by sales',
  'pages.orders.statistics.sellerTop.rank': 'Rank',
  'pages.orders.statistics.sellerTop.seller': 'Seller',
  'pages.orders.statistics.sellerTop.orderCount': 'Paid orders',
  'pages.orders.statistics.sellerTop.saleAmount': 'Sales',
  'pages.orders.statistics.sellerTop.refundAmount': 'Refund amount',
  'pages.orders.statistics.avgOrderValue': 'Avg. order value (₩)',
  'pages.orders.statistics.refundRate': 'Refund rate',
  'pages.orders.statistics.vsPrevPeriod': 'vs previous period',
  'pages.orders.statistics.backlog.title': 'Live work status',
  'pages.orders.statistics.backlog.asOf': 'as of',
  'pages.orders.statistics.backlog.stage.payWait': 'Payment pending',
  'pages.orders.statistics.backlog.stage.purchasing': 'Purchasing',
  'pages.orders.statistics.backlog.stage.inbound': 'Awaiting inbound',
  'pages.orders.statistics.backlog.stage.warehouse': 'Warehouse work',
  'pages.orders.statistics.backlog.stage.shipReady': 'Ready to ship',
  'pages.orders.statistics.backlog.stage.shipping': 'In transit',
  'pages.orders.statistics.backlog.stage.problem': 'Problems',
  'pages.orders.statistics.backlog.stage.refundInProgress': 'Refunds in progress',
  'pages.orders.statistics.backlog.stale': '{count} stalled',
  'pages.orders.statistics.backlog.staleTooltip': 'Orders unchanged for {hours}+ hours',
  'pages.orders.statistics.backlog.needsAction': 'Orders needing attention',
  'pages.orders.statistics.backlog.status.domesticPacking': 'Local packing',

  // Member Statistics
  'pages.members.statistics.title': 'Member Statistics',
  'pages.members.statistics.dateRange': 'Date Range',
  'pages.members.statistics.query': 'Query',
  'pages.members.statistics.reset': 'Reset',
  'pages.members.statistics.cumulativeRegisteredUsers': 'Accumulated Users',
  'pages.members.statistics.visitors': 'Visitors',
  'pages.members.statistics.pageViews': 'Page Views',
  'pages.members.statistics.newUsers': 'New Users',
  'pages.members.statistics.orderTransactionUsers': 'Order Transaction Users',
  'pages.members.statistics.waybillTransactionUsers': 'Waybill Transaction Users',
  'pages.members.statistics.trendChart': 'Member Statistics Trend',
  'pages.members.statistics.chart.pageViews': 'Page Views',
  'pages.members.statistics.chart.visitors': 'Visitors',
  'pages.members.statistics.chart.newUsers': 'New Users',
  'pages.members.statistics.chart.orderTransactionUsers': 'Order Transaction Users',
  'pages.members.statistics.chart.waybillTransactionUsers': 'Waybill Transaction Users',
  
  // All Orders Page
  'pages.orders.all.title': 'All Orders',
  'pages.orders.all.count': ' ',
  'pages.orders.all.filterApplied': 'Filter Applied',
  'pages.orders.all.filterCleared': 'Filter Cleared',
  'pages.orders.all.bulkProcess': ' Bulk Process',
  'pages.orders.all.selected': 'Selected',
  'pages.orders.all.group.purchase': 'Purchase Agency',
  'pages.orders.all.group.vvic': 'VVIC HiPass',
  'pages.orders.all.group.shipping': 'Shipping Agency',
  'pages.orders.all.group.warehouse': 'Warehouse In/Out',
  'pages.orders.all.group.error': 'Error',
  'pages.orders.all.group.return': 'Return Management',
  'pages.orders.all.group.stock': 'Stock Management',
  'pages.orders.all.status.tempSave': 'Temp Save',
  'pages.orders.all.status.estimate': 'Estimate',
  'pages.orders.all.status.paymentWaiting': 'Payment Waiting',
  'pages.orders.all.status.paymentComplete': 'Payment Complete',
  'pages.orders.all.status.purchasing': 'Purchasing',
  'pages.orders.all.status.purchaseComplete': 'Purchase Complete',
  'pages.orders.all.status.applicationSubmit': 'Application Submit',
  'pages.orders.all.status.centerArrival': 'Center Arrival',
  'pages.orders.all.status.warehouseProcessing': 'Warehouse Processing',
  'pages.orders.all.status.warehouseComplete': 'Warehouse Complete',
  'pages.orders.all.status.shipmentWaiting': 'Shipment Waiting',
  'pages.orders.all.status.shipmentComplete': 'Shipment Complete',
  'pages.orders.all.status.extraFeeWaiting': 'Extra Fee Waiting',
  'pages.orders.all.status.extraFeeComplete': 'Extra Fee Complete',
  'pages.orders.all.status.errorWarehouse': 'Error Warehouse',
  'pages.orders.all.status.noOrderInfo': 'No Data',
  'pages.orders.all.status.errorIgnore': 'Error Ignore',
  'pages.orders.all.status.returnMove': 'Return Move',
  'pages.orders.all.status.refundProcessing': 'Refund Processing',
  'pages.orders.all.status.refundRequest': 'Refund Request',
  'pages.orders.all.status.cancelRequest': 'Cancel Request',
  'pages.orders.all.status.refundComplete': 'Refund Complete',
  'pages.orders.all.status.shipmentHold': 'Shipment Hold',
  'pages.orders.all.status.returnRequest': 'Return Request',
  'pages.orders.all.status.returnComplete': 'Return Complete',
  'pages.orders.all.status.stockRequest': 'Stock Request',
  'pages.orders.all.status.stockAvailable': 'Available',
  'pages.orders.all.status.stockOut': 'Out of Stock',
  'pages.orders.all.pageSize': 'Page Size',
  'pages.orders.all.center': 'Center',
  'pages.orders.all.centerAll': 'All',
  'pages.orders.all.centerWeihai': '(China) Weihai',
  'pages.orders.all.centerQingdao': '(China) Qingdao',
  'pages.orders.all.centerGuangzhou': '(China) Guangzhou',
  'pages.orders.all.shippingMethod': 'Shipping Method',
  'pages.orders.all.shippingAir': 'Air',
  'pages.orders.all.shippingAirExpress': 'Air Express',
  'pages.orders.all.shippingSea': 'Sea',
  'pages.orders.all.shippingSeaExpress': 'Sea Express',
  'pages.orders.all.isShipped': 'Shipped Status',
  'pages.orders.all.autoPayment': 'Auto Payment',
  'pages.orders.all.manualPayment': 'Manual Payment',
  'pages.orders.all.registrationDate': 'Registration Date',
  'pages.orders.all.warehouseStatus': 'Warehouse Status',
  'pages.orders.all.warehouseExpected': 'Expected',
  'pages.orders.all.warehousePartial': 'Partial',
  'pages.orders.all.warehouseDone': 'Complete',
  'pages.orders.all.receiverType': 'Receiver Type',
  'pages.orders.all.receiverPersonal': 'Personal',
  'pages.orders.all.receiverBusiness': 'Business',
  'pages.orders.all.mailbox': 'Mailbox',
  'pages.orders.all.mailboxPlaceholder': 'Mailbox Number',
  'pages.orders.all.receiver': 'Receiver',
  'pages.orders.all.receiverPlaceholder': 'Receiver Name',
  'pages.orders.all.productNo': 'Product No',
  'pages.orders.all.trackingNo': 'Tracking No',
  'pages.orders.all.trackingNoPlaceholder': 'China/Domestic Tracking No',
  'pages.orders.all.orderNoPlaceholder': 'TM2025...',
  'pages.orders.all.krTrackPlaceholder': 'Domestic Tracking No',
  'pages.orders.all.orderType': 'Order Type',
  'pages.orders.all.shippingMethodCol': 'Shipping Method',
  'pages.orders.all.shippedStatus': 'Shipped Status',
  'pages.orders.all.shipped': 'Shipped',
  'pages.orders.all.notShipped': 'Not Shipped',
  'pages.orders.all.trackingCount': 'Tracking Count',
  'pages.orders.all.warehousedCount': 'Warehoused',
  'pages.orders.all.totalAmount': 'Total Amount',
  'pages.orders.all.paidAmount': 'Paid Amount',
  'pages.orders.all.weightLabel': 'Weight',
  'pages.orders.all.krTrackingNumber': 'Tracking Number',
  'pages.orders.all.shipDateRack': 'Ship Date/Rack',
  'pages.orders.all.notRegistered': 'Not Registered',
  'pages.orders.all.progressStatus': 'Progress Status',
  'pages.orders.all.createdAt': 'Created At',
  'pages.orders.all.updatedAt': 'Updated At',
  'pages.orders.all.inquiryResponder': 'Inquiry Responder',
  'pages.orders.all.purchaseManager': 'Purchase Manager',
  'pages.orders.all.none': 'None',
  'pages.orders.all.copyOrder': 'Copy Order',
  'pages.orders.all.additionalCost': 'Additional Cost',
  'pages.orders.all.orderInquiry': 'Order Inquiry',
  'pages.orders.all.registerTracking': 'Register Tracking',
  'pages.orders.all.changeBoxCount': 'Change Box Count',
  'pages.orders.all.printTracking': 'Print Tracking',
  'pages.orders.all.reissueTracking': 'Reissue Tracking',
  'pages.orders.all.coupangLabel': 'Coupang Label',
  'pages.orders.all.return': 'Return',
  'pages.orders.all.bulkRegisterTracking': 'Bulk Register Tracking',
  
  // User Orders Page
  'pages.orders.user.title': 'User Orders',
  'pages.orders.vvicHighpass.title': 'VVIC HighPass Orders',
  'pages.orders.rocket.title': 'Rocket Orders',
  'pages.orders.user.filterApplied': '{group} > {label} filter applied (User)',
  'pages.orders.user.filterCleared': 'Filter cleared',
  'pages.orders.user.newOrderNotification': 'New order received: {orderNumber}',
  'pages.orders.user.paymentCompletedNotification': 'Payment completed orders increased by {count}',
  'pages.orders.user.purchasingNotification': 'Purchasing orders increased by {count}',
  'pages.orders.user.viewAll': 'View All',
  'pages.orders.user.viewOrdersWithoutTrackingNumber': 'View orders without tracking number',
  'pages.orders.user.viewOrder': 'View Order',
  'pages.orders.user.copied': 'Copied',
  'pages.orders.user.log': 'Log',
  'pages.orders.user.buyingOrder': 'Buying Order:',
  'pages.orders.user.deliveryOrderNumber': 'Delivery Order Number:',
  'pages.orders.user.unreadInquiry': 'Unread: {count} (Order: {orderNo})',
  'pages.orders.user.regularMember': 'Regular',
  'pages.orders.user.orderCopy': 'Copy Order',
  'pages.orders.user.delete': 'Delete',
  'pages.orders.user.editQuantity': 'Edit Quantity',
  'pages.orders.user.quantityUpdated': 'Quantity updated successfully',
  'pages.orders.user.quantityUpdateFailed': 'Failed to update quantity',
  'pages.orders.user.quantityRequired': 'Please enter quantity',
  'pages.orders.user.quantityMin': 'Quantity must be at least 1',
  'pages.orders.user.quantityPlaceholder': 'Enter quantity',
  'pages.orders.user.deleteCartItem': 'Delete Cart Item',
  'pages.orders.user.deleteCartItemConfirm': 'Are you sure you want to delete this cart item?',
  'pages.orders.user.cartItemDeleted': 'Cart item deleted successfully',
  'pages.orders.user.cartItemDeleteFailed': 'Failed to delete cart item',
  'pages.orders.user.split': 'Split',
  'pages.orders.user.waybillRegistration': 'Waybill Registration',
  'pages.orders.user.waybillIssuance': 'Issue Waybill',
  'pages.orders.user.waybillReIssuance': 'Re-Issue Waybill',
  'pages.orders.user.waybillIssuanceSuccess': 'Waybill issued successfully',
  'pages.orders.user.waybillReIssuanceSuccess': 'Waybill re-issued successfully',
  'pages.orders.user.waybillIssuanceFailed': 'Failed to issue waybill',
  'pages.orders.user.orderNumberRequired': 'Order number is required',
  'pages.orders.user.additionalCost': 'Additional Cost',
  'pages.orders.user.purchaseCost': 'Purchase Cost',
  'pages.orders.user.orderInquiry': 'Order Inquiry',
  'pages.orders.user.trackingRegister': 'Waybill Registration',
  'pages.orders.user.trackingIssue': 'Issuance of Waybill',
  'pages.orders.user.trackingBoxChange': 'Change Box Count',
  'pages.orders.user.trackingPrint': 'Waybill Printing',
  'pages.orders.user.trackingReissue': 'Reissuance of Waybill',
  'pages.orders.user.noTrackingNumber': 'No Tracking Number Filled',
  'pages.orders.user.invoiceDownload': 'Download Invoice',
  'pages.orders.user.coupangLabel': 'Coupang Label',
  'pages.orders.user.inpackingUpload': 'Inpacking Upload',
  'pages.orders.user.hanjinTrackingPrint': 'Waybill Printing',
  'pages.orders.user.hjNotSent': 'HJ Not Sent',
  'pages.orders.user.hjSuccess': 'HJ Success',
  'pages.orders.user.purchaseCostReset': 'Reset Purchase Cost',
  'pages.orders.user.purchaseCostBankTransfer': 'Purchase Cost Bank Transfer',
  'pages.orders.user.fullRefund': 'Full Refund',
  'pages.orders.user.refund': 'Refund',
  'pages.orders.user.refundCancel': 'Refund Cancel',
  'pages.orders.user.refundCancelConfirm': 'Cancel this refund request?',
  'pages.orders.user.refundCancelSuccess': 'Refund request cancelled',
  'pages.orders.user.refundCancelFailed': 'Failed to cancel refund request',
  'pages.orders.user.confirmFullRefund': 'Are you sure you want to process a full refund? The order status will be changed to Platform Refund Request.',
  'pages.orders.user.bundle': 'Bundle',
  'pages.orders.user.merge': 'Merge',
  'pages.orders.user.shippingCost': 'Shipping Cost',
  'pages.orders.user.packing': 'Packing',
  'pages.orders.user.additionalCostReset': 'Reset Additional Cost',
  'pages.orders.user.additionalCostBankTransfer': 'Additional Cost Bank Transfer',
  'pages.orders.user.customsCost': 'Customs Cost',
  'pages.orders.user.additionalFee': 'Additional Fee',
  'pages.orders.user.returnCost': 'Return Cost',
  'pages.orders.user.returnCostReset': 'Reset Return Cost',
  'pages.orders.user.returnCostBankTransfer': 'Return Cost Bank Transfer',
  'pages.orders.user.refundSplit': 'Refund Split',
  'pages.orders.user.mergeSplitOrders': 'Merge Split Orders',
  'pages.orders.user.noSplitOrdersSelected': 'Please select split orders (orders with format: {ordernumber}-S{splitnumber})',
  'pages.orders.user.mergeRequiresTwoOrders': 'Please select at least 2 split orders to merge',
  'pages.orders.user.mergeSplitOrdersConfirm': 'Confirm Merge Split Orders',
  'pages.orders.user.mergeSplitOrdersMessage': 'Are you sure you want to merge {count} split order(s)?',
  'pages.orders.user.mergeSplitOrdersSuccess': 'Successfully merged {count} split order(s)',
  'pages.orders.user.mergeSplitOrdersError': 'Failed to merge split orders',
  'pages.orders.user.noValidOrderIds': 'No valid order IDs found',
  'pages.orders.user.vvicLabelPrint': 'VVIC Label Print',
  'pages.orders.user.subTrackingEdit': 'Edit Sub Tracking',
  'pages.orders.user.packingSplit': 'Packing Split',
  'pages.orders.user.subOrderRefund': 'Sub Order Refund',
  'pages.orders.user.labelPrint': 'Label Print',
  'pages.orders.user.labelUpload': 'Label Upload',
  'pages.orders.user.labelGenerate': 'Label Generate',
  'pages.orders.user.labelRegenerate': 'Label Regenerate',
  'pages.orders.user.labelBoxChange': 'Label Box Count Change',
  'pages.orders.user.internationalShippingCostReset': 'International Shipping Cost Reset',
  'pages.orders.user.internationalShippingCostBankTransfer': 'International Shipping Cost Bank Transfer',
  'pages.orders.user.confirmInternationalShippingCostReset': 'Are you sure you want to reset the international shipping cost?',
  'pages.orders.user.confirmInternationalShippingCostBankTransfer': 'Are you sure you want to process international shipping cost via bank transfer?',
  'pages.orders.user.internationalShippingCostResetSuccess': 'International shipping cost has been reset',
  'pages.orders.user.internationalShippingCostResetFailed': 'Failed to reset international shipping cost',
  'pages.orders.user.internationalShippingCostBankTransferSuccess': 'International shipping cost bank transfer completed',
  'pages.orders.user.confirmSubOrderRefund': 'Are you sure you want to refund the sub order?',
  'pages.orders.user.subOrderRefundSuccess': 'Sub order refund has been processed',
  'pages.orders.user.subOrderRefundError': 'Failed to process sub order refund, please try again',
  'pages.orders.user.orderIdRequired': 'Order ID is required',
  'pages.orders.user.confirmReturnCostReset': 'Are you sure you want to reset the return cost?',
  'pages.orders.user.returnCostResetSuccess': 'Return cost has been reset',
  'pages.orders.user.confirmReturnCostBankTransfer': 'Are you sure you want to process return cost via bank transfer?',
  'pages.orders.user.returnCostBankTransferSuccess': 'Return cost bank transfer completed',
  'pages.orders.user.viewNoTrackingNumber': 'View Orders Without Tracking Number',
  'pages.orders.user.purchaseFinalComplete': 'Purchase Final Complete',
  'pages.orders.user.trackingNumberPrint': 'Tracking Number Print',
  'pages.orders.user.purchaseForm': 'Purchase Form',
  'pages.orders.user.settlementOrders': 'Settlement Orders',
  'pages.orders.user.redfAir': 'REDF Air',
  'pages.orders.user.purchaseFinalCompleteSuccess': 'Purchase completed orders exported successfully',
  'pages.orders.user.noPurchaseCompletedOrders': 'No purchase completed orders found',
  'pages.orders.user.selectOrdersToPrint': 'Please select orders to print tracking numbers',
  'pages.orders.user.noSelectedOrders': 'No orders selected',
  'pages.orders.user.trackingNumbersPrinted': 'Tracking numbers printed',
  'pages.orders.user.printWaybill': 'Print Waybill',
  'pages.orders.user.ManiProducts': 'MANI Products',
  'pages.orders.user.printWaybillSelectOrders': 'Please select at least one order or open an order detail to print waybill',
  'pages.orders.user.printWaybillGenerating': 'Generating waybill...',
  'pages.orders.user.printWaybillSuccess': 'Waybill generated. Print dialog opened.',
  'pages.orders.user.printWaybillPopupBlocked': 'Popup blocked. Please allow popups and try again.',
  'pages.orders.user.printWaybillNoData': 'Failed to generate waybill: No PDF data received.',
  'pages.orders.user.printWaybillError': 'Failed to generate waybill. Please try again.',
  'pages.orders.user.printWaybillOrderIdNotFound': 'Order ID not found',
  'pages.orders.user.noOrdersToExport': 'No orders to export',
  'pages.orders.user.purchaseFormExported': 'Purchase form exported successfully',
  'pages.orders.user.exportError': 'Error occurred during export',
  'pages.orders.user.confirmPurchaseCostBankTransfer': 'Confirm purchase cost bank transfer?',
  'pages.orders.user.purchaseCostBankTransferSuccess': 'Purchase cost bank transfer confirmed',
  'pages.orders.user.confirmPurchaseCostReset': 'Confirm reset purchase cost?',
  'pages.orders.user.purchaseCostResetSuccess': 'Purchase cost has been reset',
  'pages.orders.user.confirmCopyOrder': 'Confirm copy this order?',
  'pages.orders.user.copyOrderSuccess': 'Order has been copied',
  'pages.orders.user.confirmDelete': 'Confirm delete this order?',
  'pages.orders.user.confirmDeleteDescription': 'This action cannot be undone.',
  'pages.orders.user.deleteSuccess': 'Order has been deleted',
  'pages.orders.user.confirm': 'Confirm',
  'pages.orders.user.cancel': 'Cancel',
  'pages.orders.user.confirmOrderCancelled': 'Confirm Order Cancelled',
  'pages.orders.user.confirmOrderCancelledMessage': 'Are you sure you want to cancel this order? This action will mark the order as cancelled.',
  'pages.orders.user.confirmBatchOrderCancelled': 'Confirm Cancel Orders',
  'pages.orders.user.confirmBatchOrderCancelledMessage': 'Are you sure you want to cancel {count} order(s)? This action will mark the orders as cancelled.',
  'pages.orders.user.confirmLabelGenerate': 'Confirm generate label?',
  'pages.orders.user.labelGenerateSuccess': 'Label has been generated',
  'pages.orders.user.confirmLabelRegenerate': 'Confirm regenerate label?',
  'pages.orders.user.labelRegenerateSuccess': 'Label has been regenerated',
  'pages.orders.user.return': 'Return',
  'pages.orders.user.additionalService': 'Additional Service',
  'pages.orders.user.logisticsRequest': 'Logistics Request',
  'pages.orders.user.adminMemo': 'Admin Memo',
  'pages.orders.user.orderMemo': 'Order Memo',
  'pages.orders.user.adminMemoPlaceholder': 'Enter admin memo...',
  'pages.orders.user.register': 'Register',
  'pages.orders.user.adminMemoRegistered': 'Admin memo registered',
  'pages.orders.user.statusChanged': 'Order {orderNo} status changed to {status}',
  'pages.orders.user.statusChangeNotAllowed': 'Cannot change status from {current} to {new}',
  'pages.orders.user.noStatusChangesAllowed': 'No status changes allowed for this filter',
  'pages.orders.user.invoiceDownloaded': 'Invoice downloaded',
  'pages.orders.user.boxInvoiceDownloaded': 'Box invoice downloaded',
  'pages.orders.user.trackingSearch': 'Searching with tracking number {value}',
  'pages.orders.user.warehouseScan': 'Warehouse Scan',
  'pages.orders.user.lsBatchPrintSs': 'Batch print SS codes',
  'pages.orders.user.lsPrintSs': 'SS codes print',
  'pages.orders.user.lsPrintVv': 'VV codes print',
  'pages.orders.user.lsFeeReport': 'LS order fee report',
  'pages.orders.user.lsShippingList': 'LS order shipping list',
  'pages.orders.user.lsSelectLsOrders': 'Select at least one order whose order number starts with LS',
  'pages.orders.user.lsBatchPrintSsLoading': 'Generating…',
  'pages.orders.user.lsBatchPrintSsSuccess': 'Opened print/export link',
  'pages.orders.user.lsBatchPrintSsFailed': 'Failed to batch-print SS codes',
  'pages.orders.user.lsPrintSsLoading': 'Generating…',
  'pages.orders.user.lsPrintSsSuccess': 'Opened print/export link',
  'pages.orders.user.lsPrintSsFailed': 'Failed to print SS codes',
  'pages.orders.user.lsPrintVvFailed': 'Failed to print VV codes',
  'pages.orders.user.lsReportLoading': 'Loading…',
  'pages.orders.user.lsReportOpened': 'Opened in a new tab',
  'pages.orders.user.lsReportFailed': 'Failed to open LS fee report',
  'pages.orders.user.lsShippingListFailed': 'Failed to open LS shipping list',
  'pages.orders.user.rackManagement': 'Rack Management',
  'pages.orders.user.noUserId': 'User ID not available',

  // Warehouse Receipt Modal
  'pages.orders.warehouseReceipt.loadWarehousesFailed': 'Failed to load warehouses',
  'pages.orders.warehouseReceipt.enterTrackingNumber': 'Please enter tracking number',
  'pages.orders.warehouseReceipt.selectWarehouse': 'Please select a warehouse',
  'pages.orders.warehouseReceipt.selectWarehousePlaceholder': 'Select Warehouse',
  'pages.orders.warehouseReceipt.scanFailed': 'Failed to scan tracking number',
  'pages.orders.warehouseReceipt.loadingComplete': 'Loading completed successfully',
  'pages.orders.warehouseReceipt.loadingFailed': 'Failed to complete loading',
  'pages.orders.warehouseReceipt.rackOccupied': 'Rack location is already occupied',
  'pages.orders.warehouseReceipt.cameraNotReady': 'Camera not ready',
  'pages.orders.warehouseReceipt.captureFailed': 'Failed to capture photo',
  'pages.orders.warehouseReceipt.captureSuccess': 'Photo captured successfully',
  'pages.orders.warehouseReceipt.onlyImagesAllowed': 'Only image files are allowed',
  'pages.orders.warehouseReceipt.imageTooLarge': 'Image must be smaller than 10MB',
  'pages.orders.warehouseReceipt.noWaybillImage': 'Please upload at least one waybill image',
  'pages.orders.warehouseReceipt.receiptRegistered': 'Receipt registered successfully',
  'pages.orders.warehouseReceipt.receiptRegisterFailed': 'Failed to register receipt',
  'pages.orders.warehouseReceipt.chooseUploadMethod': 'Choose Upload Method',
  'pages.orders.warehouseReceipt.takePhotoWithCamera': 'Take Photo with Camera',
  'pages.orders.warehouseReceipt.uploadFromFiles': 'Upload from Files',
  'pages.orders.warehouseReceipt.capture': 'Capture',
  'pages.orders.warehouseReceipt.trackingNumber': 'Tracking Number',
  'pages.orders.warehouseReceipt.trackingNumberPlaceholder': 'Enter tracking number',
  'pages.orders.warehouseReceipt.scan': 'Scan',
  'pages.orders.warehouseReceipt.noMatchedOrder': 'No Matched Order',
  'pages.orders.warehouseReceipt.orderNumber': 'Order Number:',
  'pages.orders.warehouseReceipt.products': 'Products:',
  'pages.orders.warehouseReceipt.quantity': 'Quantity',
  'pages.orders.warehouseReceipt.notes': 'Notes',
  'pages.orders.warehouseReceipt.designatedShooting': 'Designated Shooting',
  'pages.orders.warehouseReceipt.designatedShootingPhoto': 'Photo',
  'pages.orders.warehouseReceipt.registerNoData': 'Register with No Data',
  'pages.orders.warehouseReceipt.register': 'Register',
  'pages.orders.warehouseReceipt.reinspection': 'Reinspection',
  'pages.orders.warehouseReceipt.rackDesignation': 'Rack Designation',
  'pages.orders.warehouseReceipt.rackDesignationTitle': 'Rack Designation',
  'pages.orders.warehouseReceipt.rackDesignationTracking':
    'Tracking Number: {trackingNumber}',
  'pages.orders.warehouseReceipt.locationCode': 'Location Code',
  'pages.orders.warehouseReceipt.locationCodePlaceholder':
    'Enter location code (e.g., S-01-01-012)',
  'pages.orders.warehouseReceipt.waybillImagesRequired': 'Waybill Images (Required)',
  'pages.orders.warehouseReceipt.uploadWaybillImage': 'Upload Waybill Image',
  'pages.orders.warehouseReceipt.hasIssue': 'Has Issue',
  'pages.orders.warehouseReceipt.issueImages': 'Issue Images',
  'pages.orders.warehouseReceipt.productImages': 'Product Images',
  'pages.orders.warehouseReceipt.uploadIssueImage': 'Upload Issue Image',
  'pages.orders.warehouseReceipt.uploadProductImage': 'Upload Product Image',
  'pages.orders.warehouseReceipt.adminMemo': 'Admin Memo',
  'pages.orders.warehouseReceipt.adminMemoPlaceholder': 'Enter notes...',
  'pages.orders.warehouseReceipt.cashOnDeliveryOptional': 'Cash on Delivery (Optional)',
  'pages.orders.warehouseReceipt.cashOnDeliveryPlaceholder':
    'Enter cash on delivery amount',

  // Picking Modal
  'pages.orders.picking.title': 'Picking',
  'pages.orders.picking.trackingNumber': 'Tracking Number',
  'pages.orders.picking.trackingNumberPlaceholder': 'Enter tracking number',
  'pages.orders.picking.scan': 'Scan',
  'pages.orders.picking.pick': 'Pick',
  'pages.orders.picking.orderNumber': 'Order Number:',
  'pages.orders.picking.rackNumber': 'Rack Number:',
  'pages.orders.picking.itemsToPick': 'Items to Pick:',
  'pages.orders.picking.productInformation': 'Product Information',
  'pages.orders.picking.quantity': 'Quantity',
  'pages.orders.picking.noOrdersReady': 'No orders ready for picking',
  'pages.orders.picking.fetchFailed': 'Failed to fetch picking ready orders',
  'pages.orders.picking.enterTrackingNumber': 'Please enter tracking number',
  'pages.orders.picking.noMatchedProduct': 'No matched product for picking',
  'pages.orders.picking.noMatchedProductWithTracking':
    'No matched product for picking with this tracking number',
  'pages.orders.picking.orderFound': 'Order found for picking',
  'pages.orders.picking.scanFailed': 'Failed to scan tracking number',
  'pages.orders.picking.noOrderSelected': 'No order selected for picking',
  'pages.orders.picking.completed': 'Picking completed successfully',
  'pages.orders.picking.completeFailed': 'Failed to complete picking',

  // Inpacking Upload Modal
  'pages.orders.inpackingUpload.title': 'Inpacking Upload - Order: {orderNo}',
  'pages.orders.inpackingUpload.orderNo': 'Order Number',
  'pages.orders.inpackingUpload.fileLabel': 'File Registration',
  'pages.orders.inpackingUpload.chooseFile': 'Choose File',
  'pages.orders.inpackingUpload.register': 'Register',
  'pages.orders.inpackingUpload.fileRequired': 'Please select a file to upload',
  'pages.orders.inpackingUpload.registered': 'Inpacking file has been registered',

  // Product Table
  'pages.orders.productTable.noTrackingNumber': 'No tracking number entered',
  'pages.orders.productTable.designatedShooting': 'Designated Shooting',
  'pages.orders.productTable.note': 'Note',
  'pages.orders.productTable.trackingNumbersSaved': '{count} tracking numbers saved',
  'pages.orders.productTable.pleaseEnterAmount': 'Please enter amount',
  'pages.orders.productTable.shippingCostSaved': 'Shipping cost saved: ¥{value}',
  'pages.orders.productTable.statusUpdated': 'Status updated to {status}',
  'pages.orders.productTable.pleaseEnterValue': 'Please enter value',
  'pages.orders.productTable.actualPriceSaved': 'Actual paid amount saved',
  'pages.orders.productTable.actualQuantitySaved': 'Actual quantity saved',
  'pages.orders.productTable.invalidNumber': 'Invalid number',
  'pages.orders.productTable.customsClearanceList': 'Customs Clearance List',
  'pages.orders.productTable.saveFailed': 'Failed to save',
  'pages.orders.productTable.productNoteSaved': 'Product note saved',
  'pages.orders.productTable.productMemoSaved': 'Product memo saved',
  'pages.orders.productTable.userMemoSaved': 'User memo saved',
  'pages.orders.productTable.sellerAddressSaved': 'Seller address saved',
  'pages.orders.productTable.pleaseEnterTrackingNumber': 'Please enter tracking number',
  'pages.orders.productTable.selectProductsToUpdateTracking': 'Please select at least one product to update tracking number.',
  'pages.orders.productTable.trackingNumberAppliedToAll': 'Tracking number "{trackingNumber}" applied to all products',
  'pages.orders.productTable.save': 'Save',
  'pages.orders.productTable.trackingNumberSaved': 'Tracking number "{trackingNumber}" saved',
  'pages.orders.productTable.trackingNumberRemoved': 'Tracking number removed',
  'pages.orders.productTable.trackingNumber': 'Tracking Number',
  'pages.orders.productTable.viewInRealLife': 'View in real life',
  'pages.orders.productTable.actualImage': 'Inspection Data',
  'pages.orders.productTable.inspectionData': 'Inspection Data',
  'pages.orders.productTable.inspectionNumber': 'Number',
  'pages.orders.productTable.inspectionImage': 'Image',
  'pages.orders.productTable.inspectionDetail': 'Inspection Detail',
  'pages.orders.productTable.worker': 'Worker',
  'pages.orders.productTable.inspectionTime': 'Inspection Time',
  'pages.orders.productTable.actualDateConfirmationDate': 'Actual Date/Confirmation Date',
  'pages.orders.productTable.date': 'Date',
  'pages.orders.productTable.preview': 'Preview',
  'pages.orders.productTable.enterTrackingNumber': 'Enter tracking number',
  'pages.orders.productTable.batchSave': 'Batch Save',
  'pages.orders.productTable.checkbox': 'Checkbox',
  'pages.orders.productTable.number': 'Number',
  'pages.orders.productTable.productStatus': 'Product Status',
  'pages.orders.productTable.productLog': 'Product Log',
  'pages.orders.productTable.image': 'Image',
  'pages.orders.productTable.customsItem': 'Customs Item',
  'pages.orders.productTable.productImage': 'Product Image',
  'pages.orders.productTable.productName': 'Product Name',
  'pages.orders.productTable.color': 'Color',
  'pages.orders.productTable.size': 'Size',
  'pages.orders.productTable.option': 'Option',
  'pages.orders.productTable.attribute': 'Attribute',
  'pages.orders.productTable.productNumber': 'Product Number',
  'pages.orders.productTable.typeOwnmall': 'B - Own mall',
  'pages.orders.productTable.material': 'Material',
  'pages.orders.productTable.sellerInfo': 'Seller Info',
  'pages.orders.productTable.orderNo': 'Order No',
  'pages.orders.productTable.externalOrderNo': 'External Order No',
  'pages.orders.productTable.exposureOX': 'Exposure OX',
  'pages.orders.productTable.shippingCost': 'Shipping Cost',
  'pages.orders.productTable.actual': 'Actual',
  'pages.orders.productTable.seller': 'Seller',
  'pages.orders.productTable.refundCost': 'Refund Cost',
  'pages.orders.productTable.productType': 'Product Type',
  'pages.orders.productTable.member': 'Member',
  'pages.orders.productTable.internationalShippingCost': 'Interational Shipping Cost',
  'pages.orders.productTable.extraInternationalShippingCost': 'Extra Interational Shipping Cost',
  'pages.orders.productTable.unitPrice': 'Unit Price',
  'pages.orders.productTable.quantity': 'Quantity',
  'pages.orders.productTable.totalAmount': 'Total Amount',
  'pages.orders.productTable.actualPaidAmount': 'Actual Paid Amount',
  'pages.orders.productTable.actualQuantity': 'Actual Quantity',
  'pages.orders.productTable.rackNumber': 'Rack Number',
  'pages.orders.productTable.rackNumberSaved': 'Rack number saved',
  'pages.orders.productTable.rackNumberSaveError': 'Failed to save rack number',
  'pages.orders.productTable.rackNumberRequired': 'Please enter a rack number',
  'pages.orders.productTable.trackingRequiredForRack': 'Cannot save the rack number because this item has no tracking number. Register a tracking number first',
  'pages.orders.productTable.itemAmountSaved': 'Item amount saved',
  'pages.orders.productTable.itemAmountSaveError': 'Failed to save item amount',
  'pages.orders.productTable.productMemoSaveError': 'Failed to save product memo',
  'pages.orders.productTable.orderIdRequired': 'Order ID is required',
  'pages.orders.productTable.itemIdRequired': 'Item ID is required',
  'pages.orders.productTable.externalOrderIdRequired': 'External order ID is required for tracking update',
  'pages.orders.productTable.previousRackNumber': 'Previous Rack Number',
  'pages.orders.productTable.shipped': 'Shipped',
  'pages.orders.productTable.notShipped': 'Not Shipped',
  'pages.orders.productTable.log': 'Log',
  'pages.orders.productTable.reorder.button': 'Re-order with another option',
  'pages.orders.productTable.reorder.title': 'Re-order with another option',
  'pages.orders.productTable.reorder.current': 'Current line',
  'pages.orders.productTable.reorder.quantity': 'Qty {quantity}',
  'pages.orders.productTable.reorder.unitPrice': 'Unit price',
  'pages.orders.productTable.reorder.rule': 'Only an option at the same unit price can be ordered, and the quantity stays the same. The customer is not notified.',
  'pages.orders.productTable.reorder.offerIdPlaceholder': 'Product number (offerId) of another product',
  'pages.orders.productTable.reorder.loadProduct': 'Load product',
  'pages.orders.productTable.reorder.offerIdInvalid': 'Enter a numeric product number.',
  'pages.orders.productTable.reorder.colImage': 'Image',
  'pages.orders.productTable.reorder.colOption': 'Option',
  'pages.orders.productTable.reorder.colPrice': 'Unit price',
  'pages.orders.productTable.reorder.colStock': 'Stock',
  'pages.orders.productTable.reorder.samePrice': 'Same price',
  'pages.orders.productTable.reorder.otherPrice': 'Different price',
  'pages.orders.productTable.reorder.preview': 'Check first',
  'pages.orders.productTable.reorder.place': 'Place order',
  'pages.orders.productTable.reorder.cancel': 'Cancel',
  'pages.orders.productTable.reorder.previewOk': 'Can be ordered — unit price {price} (was {original}), seller shipping {shipping}',
  'pages.orders.productTable.reorder.previewFailed': 'The check failed.',
  'pages.orders.productTable.reorder.loadFailed': 'Could not load the product options.',
  'pages.orders.productTable.reorder.confirmTitle': 'This places a real order',
  'pages.orders.productTable.reorder.confirmBody': 'Orders {quantity} × {option} on {platform} at {price} each. This cannot be undone.',
  'pages.orders.productTable.reorder.confirmOk': 'Place order',
  'pages.orders.productTable.reorder.placed': 'Ordered — order number {orderNo}',
  'pages.orders.productTable.reorder.placeFailed': 'The order failed.',
  'pages.orders.productTable.reorder.unitAlert': 'The seller sells only in units of {unit} (minimum {min}), so the {customer} the customer ordered cannot be ordered.',
  'pages.orders.productTable.reorder.unitRaise': 'Order {quantity} to match the seller unit ({extra} extra, paid by the company)',
  'pages.orders.productTable.reorder.previewOkRaised': 'Can be ordered — {quantity} (customer {customer}, {extra} extra) · unit price {price} (was {original}) · extra cost {extraCost} · seller shipping {shipping}',
  'pages.orders.productTable.reorder.confirmBodyRaised': 'Orders {quantity} of {option} on {platform} at {price} each. The customer ordered {customer}; the {extra} extra (extra cost {extraCost}) are paid by the company. This cannot be undone.',
  'pages.orders.productTable.marketplaceQuantity': 'Ordered {quantity} ({extra} extra)',
  'pages.orders.productTable.furniture': 'Furniture',
  'pages.orders.productTable.cotton': 'Cotton',
  'pages.orders.productTable.sellerA': 'Seller A',
  'pages.orders.productTable.exposureO': 'Exposure O',
  'pages.orders.productTable.actualPaid': 'Actual Paid',
  'pages.orders.productTable.coupon': 'Coupon',
  'pages.orders.productTable.points': 'Points',
  'pages.orders.productTable.totalActualPaid': 'Total Actual Paid',
  
  // Product Price Modal
  'pages.orders.productPriceModal.title': '1st Payment Details',
  'pages.orders.productPriceModal.serviceFee': 'Service Fee',
  'pages.orders.productPriceModal.quantity': 'Quantity',
  'pages.orders.productPriceModal.price': 'Price',
  'pages.orders.productPriceModal.realPrice': 'Real Price',
  'pages.orders.productPriceModal.chineseTransportation': 'Chinese Transportation Price',
  'pages.orders.productPriceModal.realChineseTransportation': 'Real Chinese Transportation Price',
  'pages.orders.productPriceModal.miscellaneousExpenses': 'Miscellaneous Expenses',
  'pages.orders.productPriceModal.firstInternationalShippingCost': '1st International Shipping Cost',
  'pages.orders.productPriceModal.ruralShippingCost': 'Island Mountain Shipping Cost',
  'pages.orders.productPriceModal.coupon': 'Coupon',
  'pages.orders.productPriceModal.couponDiscount': 'Coupon discount',
  'pages.orders.productPriceModal.deliveryCoupon': 'Delivery Coupon',
  'pages.orders.productPriceModal.deliveryCouponDiscount': 'Delivery coupon discount',
  'pages.orders.productPriceModal.costSection': 'Cost breakdown',
  'pages.orders.productPriceModal.costSubtotal': 'Cost subtotal',
  'pages.orders.productPriceModal.deductionSection': 'Deductions',
  'pages.orders.productPriceModal.deposit': 'Deposit',
  'pages.orders.productPriceModal.depositUsed': 'Deposit used',
  'pages.orders.productPriceModal.notApplied': 'Not applied',
  'pages.orders.productPriceModal.paymentMethod': 'Payment method',
  'pages.orders.productPriceModal.totalDeduction': 'Total deductions',
  'pages.orders.productPriceModal.bankDepositAmount': 'Bank transfer amount',
  'pages.orders.productPriceModal.cardPaymentAmount': 'Card payment amount',
  'pages.orders.productPriceModal.depositOnlyPayment': 'Deposit payment',
  'pages.orders.productPriceModal.sellerReference': 'Seller reference',
  'pages.orders.productPriceModal.points': 'Points',
  'pages.orders.productPriceModal.pointsUsed': 'Points used',
  'pages.orders.productPriceModal.firstCostTotal': '1st Cost Total',
  
  // International Shipping Modal
  'pages.orders.internationalShippingModal.title': 'International Shipping Details',
  'pages.orders.internationalShippingModal.weight': 'Weight',
  'pages.orders.internationalShippingModal.firstCost': '1st Cost (Total)',
  'pages.orders.internationalShippingModal.productPrice': 'Product Price',
  'pages.orders.internationalShippingModal.chineseShippingCost': 'Chinese Shipping Cost',
  'pages.orders.internationalShippingModal.coupon': 'Coupon',
  'pages.orders.internationalShippingModal.points': 'Points',
  'pages.orders.internationalShippingModal.internationalShippingCost': 'International Shipping Cost',
  'pages.orders.internationalShippingModal.extraInternationalShippingCost': 'Extra International Shipping Cost',
  'pages.orders.internationalShippingModal.internationalCouponsUsed': 'International Coupons Used',
  'pages.orders.internationalShippingModal.internationalPointsUsed': 'International Points Used',
  'pages.orders.internationalShippingModal.couponsUsed': 'Coupons Used',
  'pages.orders.internationalShippingModal.pointsUsed': 'Points Used',
  
  'pages.orders.extraInternationalShippingModal.title': 'Extra International Shipping Details (2nd Cost)',
  'pages.orders.extraInternationalShippingModal.ezpassFee': 'EZ-pass Fee',
  'pages.orders.extraInternationalShippingModal.additionalCost': 'Additional Cost',
  'pages.orders.extraInternationalShippingModal.extraInternationalShippingCost': 'International Shipping Fee',
  'pages.orders.extraInternationalShippingModal.ruralShippingCost': 'Island and Mountainous Area Cost',
  'pages.orders.extraInternationalShippingModal.addOnServices': 'Add-on Services',
  'pages.orders.extraInternationalShippingModal.serviceName': 'Service Name',
  'pages.orders.extraInternationalShippingModal.quantity': 'Quantity',
  'pages.orders.extraInternationalShippingModal.unitPrice': 'Unit Price',
  'pages.orders.extraInternationalShippingModal.serviceTotal': 'Total',
  'pages.orders.extraInternationalShippingModal.subtotal': 'Subtotal',
  'pages.orders.extraInternationalShippingModal.couponDiscount': 'Delivery Coupon Discount',
  'pages.orders.extraInternationalShippingModal.couponsUsed': 'Coupons Used',
  'pages.orders.extraInternationalShippingModal.pointsUsed': 'Points Used',
  'pages.orders.extraInternationalShippingModal.total': 'Total (2nd Cost)',
  'pages.orders.extraInternationalShippingModal.cashOnDelivery': 'Cash on Delivery',
  'pages.orders.productTable.paidInputCny': 'Paid (CNY)',
  'pages.orders.productTable.previous': 'Previous',
  'pages.orders.productTable.error': 'Error',
  'pages.orders.productTable.errorReasonTitle': 'Enter Error Reason',
  'pages.orders.productTable.errorReason': 'Error Reason',
  'pages.orders.productTable.errorReasonPlaceholder': 'Please enter the error reason',
  'pages.orders.productTable.errorReasonRequired': 'Error reason is required',
  'pages.orders.productTable.errorStatusUpdated': 'Error status updated successfully',
  'pages.orders.productTable.confirmErrorStatus': 'Confirm Status Change',
  'pages.orders.productTable.confirmErrorStatusMessage': 'Are you sure you want to change the product status to Error?',
  'pages.orders.productTable.arrivalExpected': 'Arrival Expected',
  'pages.orders.productTable.warehoused': 'Warehoused',
  'pages.orders.productTable.notWarehoused': 'Not Warehoused',
  'pages.orders.productTable.processing': 'Processing',
  'pages.orders.productTable.partial': 'Partial',
  'pages.orders.productTable.done': 'Done',
  'pages.orders.productTable.warehouseStatusUpdated': 'Warehouse status updated to {status}',
  'pages.orders.productTable.productMemo': 'Product Memo',
  'pages.orders.productTable.userMemo': 'User Memo',
  'pages.orders.productTable.enterUserMemo': 'Enter user memo',
  'pages.orders.productTable.enterProductMemo': 'Enter product memo',
  'pages.orders.productTable.sellerAddress': 'Seller Address',
  'pages.orders.productTable.enterSellerAddress': 'Enter seller address',
  'pages.orders.productTable.noInspectionData': 'There is no inspection data available.',
  'pages.orders.user.packagingManagement': 'Packaging',
  'pages.orders.user.shipmentScan': 'Shipment Scan',
  'pages.orders.user.batchProcess': 'Batch process {count} selected',
  'pages.orders.user.excelDownload': 'Excel Download',
  'pages.orders.user.selectOrdersFirst': 'Please select orders first.',
  'pages.orders.user.chimingtongNote': 'Select orders then click to download',
  'pages.orders.user.lsShippingManifest': 'LS Shipping Manifest',
  'pages.orders.user.silutongSeaManifest': 'Silutong Sea Freight',
  'pages.orders.user.chimingtong': 'Chimingtong',
  'pages.orders.user.chimingtongEnCn': 'Chimingtong EN+CN',
  'pages.orders.user.chimingtongKr': 'Chimingtong KR',
  'pages.orders.user.exportingOrders': 'Exporting orders...',
  'pages.orders.user.exportSuccess': 'Successfully exported {count} orders',
  'pages.orders.user.trackingBatchRegister': 'Batch Register Tracking',
  'pages.orders.user.statusChange': 'Change Status',
  'pages.orders.user.statusChangeSelect': '= Change Status',
  'pages.orders.user.totalSelectedPrice': 'Total Selected',
  'pages.orders.user.productPrice': 'Product',
  'pages.orders.user.shippingPrice': 'Shipping',
  'pages.orders.user.smsNotSend': 'No SMS',
  'pages.orders.user.smsSend': 'Send SMS',
  'pages.orders.user.statusChangeConfirm': 'Changing status for {count} selected orders',
  'pages.orders.user.batchStatusChangeConfirm': 'Confirm Batch Status Change',
  'pages.orders.user.batchStatusChangeMessage': 'Are you sure you want to update {count} order(s) to "{status}"?',
  'pages.orders.user.batchStatusChangeSuccess': 'Successfully updated {count} order(s)',
  'pages.orders.user.batchStatusChangeError': 'Failed to update some orders',
  'pages.orders.user.noOrdersSelected': 'Please select at least one order',
  'pages.orders.user.someStatusChangesNotAllowed': '{count} order(s) cannot be updated to this status',
  'pages.orders.user.search': 'Search',
  'pages.orders.user.reset': 'Reset',
  'pages.orders.user.showMore': 'Show More ▼',
  'pages.orders.user.searchFilterSelectTemplate': '{label} — Please select',
  'pages.orders.user.searchFilterTextTemplate': '{label} — {hint}',
  'pages.orders.user.searchFilterDateStartTemplate': '{label} start',
  'pages.orders.user.searchFilterDateEndTemplate': '{label} end',
  'pages.orders.user.collapse': 'Collapse ▲',
  'pages.orders.user.total': 'Total {total}',
  'pages.orders.user.Picking': 'Picking',
  // Purchase Cost Modal
  'pages.orders.purchaseCost.title': 'Purchase Cost - Order: {orderNo}',
  'pages.orders.purchaseCost.orderInfo': 'Order Information',
  'pages.orders.purchaseCost.orderNoTracking': 'Order No / Tracking No',
  'pages.orders.purchaseCost.totalQuantityCenterReceiver': 'Total Qty / Center / Receiver',
  'pages.orders.purchaseCost.totalQuantity': 'Total Quantity',
  'pages.orders.purchaseCost.center': 'Center',
  'pages.orders.purchaseCost.receiver': 'Receiver',
  'pages.orders.purchaseCost.totalPrice': 'Total Price',
  'pages.orders.purchaseCost.productInfo': 'Product Information',
  'pages.orders.purchaseCost.productNo': 'Product No',
  'pages.orders.purchaseCost.productImage': 'Image',
  'pages.orders.purchaseCost.productName': 'Product Name',
  'pages.orders.purchaseCost.quantity': 'Quantity',
  'pages.orders.purchaseCost.unitPrice': 'Unit Price',
  'pages.orders.purchaseCost.localShippingFee': 'Local Shipping Fee',
  'pages.orders.purchaseCost.localShippingFeeTotal': 'Local Shipping Fee (Total)',
  'pages.orders.purchaseCost.adminNote': 'Administrator Note',
  'pages.orders.purchaseCost.adminNotePlaceholder': 'Enter administrator note...',
  'pages.orders.purchaseCost.estimate': 'Purchase Cost Estimate',
  'pages.orders.purchaseCost.exchangeRate': 'Applicable Exchange Rate',
  'pages.orders.purchaseCost.exchangeRateSuffix': 'KRW per ¥1',
  'pages.orders.purchaseCost.productPurchaseCost': 'Product Purchase Cost',
  'pages.orders.purchaseCost.purchaseFee': 'Purchase Fee',
  'pages.orders.purchaseCost.additionalCosts': 'Additional Costs',
  'pages.orders.purchaseCost.excessCost': 'Excess Cost of Items',
  'pages.orders.purchaseCost.totalAmount': 'Total Amount',
  'pages.orders.purchaseCost.currentDeposit': 'Current Deposit',
  'pages.orders.purchaseCost.remainingDeposit': 'Remaining Deposit',
  'pages.orders.purchaseCost.smsNotSend': 'Do not send SMS',
  'pages.orders.purchaseCost.smsSend': 'Send SMS',
  
  // Business Orders Page
  'pages.orders.business.title': 'Business Orders',
  'pages.orders.business.filterApplied': '{group} > {label} filter applied (Business)',
  'pages.orders.business.businessMember': 'Business',
  'pages.orders.business.businessNumber': 'Business Number',
  'pages.orders.business.businessNumberPlaceholder': 'Business Registration Number',
  'pages.orders.business.orderDetails': 'Order Details',
  'pages.orders.business.orderDate': 'Order Date',
  'pages.orders.business.paymentMethod': 'Payment Method',
  'pages.orders.business.deliveryMemo': 'Delivery Memo',
  'pages.orders.business.productList': 'Product List',
  'pages.orders.business.image': 'Image',
  'pages.orders.business.productName': 'Product Name',
  'pages.orders.business.option': 'Option',
  'pages.orders.business.unitPrice': 'Unit Price',
  'pages.orders.business.total': 'Total',
  
  // Search Filters
  'pages.orders.filter.center': 'Center',
  'pages.orders.filter.centerAll': 'All',
  'pages.orders.filter.centerWeihai': '(China) Weihai',
  'pages.orders.filter.centerQingdao': '(China) Qingdao',
  'pages.orders.filter.centerGuangzhou': '(China) Guangzhou',
  'pages.orders.filter.typeAll': 'All',
  'pages.orders.filter.typeShipping': 'Shipping Agency',
  'pages.orders.filter.typePurchase': 'Purchase Agency',
  'pages.orders.filter.typeVVIC': 'VVIC Highpass',
  'pages.orders.filter.typeReturn': 'Return Agency',
  'pages.orders.filter.typeMinimall': 'Minimall',
  'pages.orders.filter.platformTypeAll': 'All',
  'pages.orders.filter.platformType1688': '1688',
  'pages.orders.filter.platformTypeTaobao': 'Taobao',
  'pages.orders.filter.platformTypeVVIC': 'VVIC',
  'pages.orders.filter.platformTypeWSY': 'WSY',
  'pages.orders.filter.platformTypeVIP': 'VIP',
  'pages.orders.filter.platformTypeSelf': 'Self-Operated',
  'pages.orders.filter.platformTypeLive': 'Live',
  'pages.orders.filter.platformTypeOwnmall': 'Own mall',
  'pages.orders.filter.shippingMethodAll': 'All',
  'pages.orders.filter.shippingMethodAir': 'Air',
  'pages.orders.filter.shippingMethodAirExpress': 'Air Express',
  'pages.orders.filter.shippingMethodSea': 'Sea',
  'pages.orders.filter.shippingMethodSeaExpress': 'Sea Express',
  'pages.orders.filter.shippedAll': 'All',
  'pages.orders.filter.shippedAuto': 'Auto Payment',
  'pages.orders.filter.shippedAutoNote': 'Use system wallet to automatically pay',
  'pages.orders.filter.shippedManual': 'Manual Payment',
  'pages.orders.filter.shippedManualNote': 'System wallet has no money, customer needs to pay by themselves',
  'pages.orders.filter.dateRange': 'Date Range',
  'pages.orders.filter.registrationDate': 'Registration Date',
  'pages.orders.filter.startDatePlaceholder': 'Start Date',
  'pages.orders.filter.endDatePlaceholder': 'End Date',
  'pages.orders.filter.warehouseStatusAll': 'All',
  'pages.orders.filter.warehouseStatusExpected': 'Expected',
  'pages.orders.filter.warehouseStatusPartial': 'Partial',
  'pages.orders.filter.warehouseStatusDone': 'Complete',
  'pages.orders.filter.warehouseStatusNotWarehoused': 'Not Warehoused',
  'pages.orders.filter.warehouseStatusProcessing': 'Processing',
  'pages.orders.filter.warehouseStatusWarehoused': 'Warehoused',
  'pages.orders.filter.paymentStatusAll': 'All',
  'pages.orders.filter.paymentStatusPending': 'Pending',
  'pages.orders.filter.paymentStatusProcessing': 'Processing',
  'pages.orders.filter.paymentStatusPaid': 'Paid',
  'pages.orders.filter.paymentStatusFailed': 'Failed',
  'pages.orders.filter.paymentStatusRefunded': 'Refunded',
  'pages.orders.filter.transferMethodAll': 'All',
  'pages.orders.filter.transferMethodShip': 'Ship',
  'pages.orders.filter.transferMethodAir': 'Air',
  'pages.orders.filter.transferMethodShipExpress': 'Ship Express',
  'pages.orders.filter.transferMethodAirExpress': 'Air Express',
  'pages.orders.filter.userNamePlaceholder': 'Member name',
  'pages.orders.filter.mailboxPlaceholder': 'Mailbox number',
  'pages.orders.filter.receiverPlaceholder': 'Receiver name',
  'pages.orders.filter.productNo': 'Product Number',
  'pages.orders.filter.productNoPlaceholder': 'Product number/Sub-order number',
  'pages.orders.filter.memberUniqueNo': 'UID',
  'pages.orders.filter.memberUniqueNoPlaceholder': 'Member UID',
  'pages.orders.filter.customerPhone': 'Customer Phone',
  'pages.orders.filter.customerPhonePlaceholder': 'Customer phone number',
  'pages.orders.filter.trackingNo': 'Tracking Number',
  'pages.orders.filter.trackingNoPlaceholder': 'China/Korea tracking number',
  'pages.orders.filter.orderNoPlaceholder': 'TM2025...',
  'pages.orders.filter.krTrackPlaceholder': 'Korea tracking number',
  'pages.orders.filter.internationalTrackingNo': 'Intl. Waybill No',
  'pages.orders.filter.paidStart': 'Paid from',
  'pages.orders.filter.paidEnd': 'Paid until',
  'pages.orders.filter.orderType': 'Order Type',
  'pages.orders.filter.orderTypeAll': 'All',
  'pages.orders.filter.orderTypeGeneral': 'General',
  'pages.orders.filter.orderTypeBuy': 'Buy',
  'pages.orders.filter.orderTypeDel': 'Delivery',
  'pages.orders.filter.orderTypeVvic': 'VVIC',
  'pages.orders.filter.orderTypeReturn': 'Return',
  'pages.orders.filter.orderTypeMinimall': 'Minimall',
  'pages.orders.filter.shippingStatus': 'Shipping Status',
  'pages.orders.filter.selectDate': 'Select Date',
  'pages.orders.filter.shippingStatusAll': 'All',
  'pages.orders.filter.shippingStatusNotShipped': 'Not Shipped',
  'pages.orders.filter.shippingStatusShipped': 'Shipped',
  'pages.orders.filter.shippingStatusAuto': 'Auto',
  'pages.orders.filter.shippingStatusManual': 'Manual',
  'pages.orders.filter.gyeongdongCod': 'Gyeongdong COD',
  'pages.orders.filter.closedArea': 'Closed Area',
  
  // User Profile
  'pages.userProfile.editInfo': 'Edit Info',
  'pages.userProfile.logout': 'Logout',
  'pages.userProfile.modalTitle': 'Edit User Information',
  'pages.userProfile.userId': 'User ID',
  'pages.userProfile.grade': 'Grade',
  'pages.userProfile.name': 'Name',
  'pages.userProfile.namePlaceholder': 'Enter name',
  'pages.userProfile.nameRequired': 'Please enter name',
  'pages.userProfile.email': 'Email',
  'pages.userProfile.emailPlaceholder': 'Enter email',
  'pages.userProfile.emailRequired': 'Please enter email',
  'pages.userProfile.emailInvalid': 'Invalid email format',
  'pages.userProfile.phone': 'Phone',
  'pages.userProfile.phonePlaceholder': 'Enter phone number',
  'pages.userProfile.phoneRequired': 'Please enter phone number',
  'pages.userProfile.newPassword': 'New Password',
  'pages.userProfile.newPasswordPlaceholder': 'Enter new password (optional)',
  'pages.userProfile.passwordMinLength': 'Password must be at least 6 characters',
  'pages.userProfile.confirmPassword': 'Confirm Password',
  'pages.userProfile.confirmPasswordPlaceholder': 'Re-enter password',
  'pages.userProfile.passwordMismatch': 'Passwords do not match',
  'pages.userProfile.updateSuccess': 'Information updated successfully.',
  'pages.userProfile.updateFailed': 'Failed to update information.',
  
  // Members List Page
  'pages.members.list.title': 'Member Management',
  'pages.members.list.memberInfo': 'Member Info',
  'pages.members.list.level': 'Level',
  'pages.members.list.levelAll': 'All',
  'pages.members.list.userUniqueId': 'UID',
  'pages.members.list.male': 'Male',
  'pages.members.list.female': 'Female',
  'pages.members.list.other': 'Other',
  'pages.members.list.levelGeneral': 'General',
  'pages.members.list.levelVIP': 'VIP',
  'pages.members.list.levelVVIP': 'VVIP',
  'pages.members.list.levelBlack': 'Blacklisted',
  'pages.members.list.levelDormant': 'Dormant',
  'pages.members.list.levelChanged': 'Member level has been changed',
  'pages.members.list.levelChangeError': 'Failed to change member level',
  'pages.members.list.mailbox': 'Mailbox',
  'pages.members.list.totalAmount': 'Total Amount',
  'pages.members.list.unpaidAmount': 'Unpaid',
  'pages.members.list.orderCount': 'Orders',
  'pages.members.list.lastOrder': 'Last Order',
  'pages.members.list.lastLogin': 'Last Login',
  'pages.members.list.joinedAt': 'Joined',
  'pages.members.list.registrationTime': 'Registration Time',
  'pages.members.list.actions': 'Actions',
  'pages.members.list.detail': 'Detail',
  'pages.members.list.edit': 'Edit',
  'pages.members.list.delete': 'Delete',
  'pages.members.list.more': 'More',
  'pages.members.list.deleteConfirm': 'Are you sure you want to delete this member?',
  'pages.members.list.deleteConfirmDesc': 'This action cannot be undone.',
  'pages.members.list.deleteSuccess': 'Member has been deleted',
  'pages.members.list.deleteError': 'Failed to delete member',
  'pages.members.list.cancel': 'Cancel',
  'pages.members.list.adjustDeposit': 'Adjust Deposit',
  'pages.members.list.adjustDeposit.amount': 'Amount',
  'pages.members.list.adjustDeposit.amountHelp': 'Positive to add, negative to subtract.',
  'pages.members.list.adjustDeposit.amountPlaceholder': 'e.g. 5000',
  'pages.members.list.adjustDeposit.amountRequired': 'Enter an amount greater than zero.',
  'pages.members.list.adjustDeposit.direction': 'Direction',
  'pages.members.list.adjustDeposit.direction.add': 'Add',
  'pages.members.list.adjustDeposit.direction.subtract': 'Subtract',
  'pages.members.list.adjustDeposit.preview': 'New balance',
  'pages.members.list.adjustDeposit.negativeWarning': 'The resulting balance would be negative. The server will reject this.',
  'pages.members.list.batchAdjustDeposit': 'Batch Adjust Deposit',
  'pages.members.list.batchAdjustDepositTitle': 'Batch adjust deposit for {count} selected members',
  'pages.members.list.batchAdjustDeposit.targets': 'Targets',
  'pages.members.list.batchAdjustDeposit.targetsCount': '{count} members',
  'pages.members.list.batchAdjustDeposit.amountHelp': 'The same adjustment and reason will be applied to every selected member.',
  'pages.members.list.batchAdjustDeposit.noSelection': 'Select at least one member first.',
  'pages.members.list.batchAdjustDeposit.success': 'Deposit adjusted for {count} members.',
  'pages.members.list.batchAdjustDeposit.partial': '{ok} succeeded, {fail} failed.',
  'pages.members.list.batchAdjustDeposit.failuresTitle': 'Some members could not be adjusted',
  'pages.members.list.adjustDeposit.reason': 'Reason',
  'pages.members.list.adjustDeposit.reasonPlaceholder': 'e.g. event reward, correction',
  'pages.members.list.adjustDeposit.reasonRequired': 'A reason is required.',
  'pages.members.list.adjustDeposit.submit': 'Adjust',
  'pages.members.list.adjustDeposit.success': 'Deposit adjusted.',
  'pages.members.list.adjustDeposit.failed': 'Failed to adjust deposit.',
  'pages.members.list.nickname': 'Nickname',
  'pages.members.list.country': 'Country',
  'pages.members.list.accountBalance': 'Account Balance',
  'pages.members.list.status': 'Status',
  'pages.members.list.statusActive': 'Active',
  'pages.members.list.statusDormant': 'Dormant',
  'pages.members.list.statusBlacklisted': 'Blacklisted',
  'pages.members.list.notes': 'Notes',
  'pages.members.list.more.orders': 'Go to Order Page',
  'pages.members.list.more.recharge': 'Go to Balance Recharge Page',
  'pages.members.list.more.points': 'Go to Points Recharge Page',
  'pages.members.list.editMember': 'Edit Member Information',
  'pages.members.list.updateSuccess': 'Member information has been updated',
  'pages.members.list.updateError': 'Failed to update member information',
  'pages.members.list.totalConsumption': 'Total Consumption Amount',
  'pages.members.list.monthlyOrderCount': 'Monthly Order Count',
  'pages.members.list.monthlyConsumption': 'Monthly Consumption Amount',
  'pages.members.list.purchaseHistory': 'Purchase History',
  'pages.members.list.orderNo': 'Order No.',
  'pages.members.list.orderDate': 'Order Date',
  'pages.members.list.orderAmount': 'Order Amount',
  'pages.members.list.orderStatus': 'Status',
  'pages.members.list.message': 'Message',
  'pages.members.list.black': 'Blacklist',
  'pages.members.list.unblack': 'Unblock',
  'pages.members.list.blackConfirm': 'Blacklist this member?',
  'pages.members.list.unblackConfirm': 'Remove from blacklist?',
  'pages.members.list.blackSuccess': 'Blacklisted',
  'pages.members.list.unblackSuccess': 'Removed from blacklist',
  'pages.members.list.totalMembers': 'Total Members',
  'pages.members.list.vipMembers': 'VIP Members',
  'pages.members.list.newThisMonth': 'New This Month',
  'pages.members.list.blackMembers': 'Blacklisted Members',
  'pages.members.list.excelDownload': 'Excel Download',
  'pages.members.list.exportingSelected': 'Exporting {count} selected members...',
  'pages.members.list.exportingAll': 'Exporting current page members...',
  'pages.members.list.noDataToExport': 'No data to export',
  'pages.members.list.exportSuccess': 'Successfully exported {count} members',
  'pages.members.list.exportError': 'Failed to export to Excel',
  'pages.members.list.blackManagement': 'Blacklist Management',
  'pages.members.list.sendSelectedMessage': 'Send Message to Selected',
  'pages.members.list.bulkBlack': 'Bulk Blacklist',
  'pages.members.list.bulkBlackConfirm': 'Blacklist {count} members?',
  'pages.members.list.detailTitle': 'Member Details',
  'pages.members.list.close': 'Close',
  'pages.members.list.sendMessage': 'Send Message',
  'pages.members.list.tabBasic': 'Basic Info',
  'pages.members.list.tabOrder': 'Order Info',
  'pages.members.list.tabMemo': 'Admin Memo',
  'pages.members.list.memberId': 'Member ID',
  'pages.members.list.memberIdEmail': 'Member ID / Email',
  'pages.members.list.id': 'ID',
  'pages.members.list.membershipCode': 'Membership Code',
  'pages.members.list.memberName': 'Member Name',
  'pages.members.list.recipientName': 'Recipient Name',
  'pages.members.list.userId': 'ID',
  'pages.members.list.startNumber': 'Start Number',
  'pages.members.list.endNumber': 'End Number',
  'pages.members.list.applicationAcceptance': 'Application Acceptance',
  'pages.members.list.referralCode': 'Referral Code',
  'pages.members.list.referredBy': 'Referred By',
  'pages.members.list.referredByPlaceholder': 'Referrer member ID, user unique ID, or value required by API',
  'pages.members.list.batchUpdateReferredBy': 'Batch set referred by',
  'pages.members.list.batchUpdateReferredByTitle': 'Set referred by ({count} selected)',
  'pages.members.list.batchUpdateReferredByRequired': 'Enter a referred-by value',
  'pages.members.list.batchUpdateReferredByNoSelection': 'No members selected',
  'pages.members.list.batchUpdateReferredByResult': 'Updated {success} member(s); {failed} failed',
  'pages.members.list.batchUpdateReferredByAllFailed': 'All updates failed',
  'pages.members.list.recommendationPointsAccumulated': 'Accumulated Points',
  'pages.members.list.personInCharge': 'Person in Charge',
  'pages.members.list.adminDesignatedDate': 'Admin Designated Date',
  'pages.members.list.adminDateSaved': 'Admin designated date saved successfully',
  'pages.members.list.adminDateSaveError': 'Failed to save admin designated date',
  'pages.members.list.personalCustomsCode': 'Personal Customs Code',
  'pages.members.list.memo': 'Memo',
  'pages.members.list.smsNotification': 'SMS Notification',
  'pages.members.list.smsNotificationAgreement': 'SMS Notification Agreement',
  'pages.members.list.kakaotalkAgree': 'Kakaotalk Agree',
  'pages.members.list.smsAgree': 'SMS Agree',
  'pages.members.list.emailAgree': 'Email Agree',
  'pages.members.list.orderInquiryAgree': 'Order Inquiry Agree',
  'pages.members.list.receiveOrderSMS': 'Order SMS',
  'pages.members.list.receive2000SMS': '2000 SMS',
  'pages.members.list.receiveShippingSMS': 'Shipping SMS',
  'pages.members.list.receiveDeliverySMS': 'Delivery SMS',
  'pages.members.list.shippingAddress': 'Shipping Address',
  'pages.members.list.registrationDate': 'Registration Date',
  'pages.members.list.lastAccessDate': 'Last Access Date',
  'pages.members.list.completedOrders': 'Completed Orders',
  'pages.members.list.totalShippingCost': 'Total Shipping Cost',
  'pages.members.list.totalAdditionalCost': 'Total Additional Cost',
  'pages.members.list.noDataCount': 'No Data Count',
  'pages.members.list.totalPointsUsed': 'Total Points Used',
  'pages.members.list.totalProductCost': 'Total Product Cost',
  'pages.members.list.totalProductRefund': 'Total Product Refund',
  'pages.members.list.totalCouponDiscount': 'Total Coupon Discount',
  'pages.members.list.totalShippingRefund': 'Total Shipping Refund',
  'pages.members.list.smsNotificationPlaceholder': 'SMS notification settings',
  'pages.members.list.memoPlaceholder': 'Enter memo',
  'pages.members.list.changePassword': 'Change Password',
  'pages.members.list.changePasswordPlaceholder': 'Enter new password',
  'pages.members.list.accumulatedPoints': 'Accumulated Points',
  'pages.members.list.basicInfo': 'Basic Information',
  'pages.members.list.memberStatistics': 'Member Statistics',
  'pages.members.list.lastLoginDate': 'Last Login Date',
  'pages.members.list.shippedOrders': 'Shipped Orders',
  'pages.members.list.purchaseOrders': 'Purchase Orders',
  'pages.members.list.noData': 'No Data',
  'pages.members.list.totalTransportationPaid': 'Total Transportation Paid',
  'pages.members.list.totalPurchasingPaid': 'Total Purchasing Paid',
  'pages.members.list.totalAdditionalPaid': 'Total Additional Paid',
  'pages.members.list.totalCouponUsage': 'Total Coupon Usage',
  'pages.members.list.notPaidOrders': 'Not Paid Orders',
  'pages.members.list.totalNotPaidAmount': 'Total Not Paid Amount',
  'pages.members.list.name': 'Name',
  'pages.members.list.namePlaceholder': 'Enter member name',
  'pages.members.list.nameRequired': 'Please enter member name',
  'pages.members.list.email': 'Email',
  'pages.members.list.emailPlaceholder': 'Enter email address',
  'pages.members.list.emailInvalid': 'Please enter a valid email address',
  'pages.members.list.phone': 'Phone',
  'pages.members.list.phonePlaceholder': 'Enter phone number',
  'pages.members.list.levelRequired': 'Please select a membership level',
  'pages.members.list.memberLevel': 'Member Level',
  'pages.members.list.totalOrders': 'Total Orders',
  'pages.members.list.lastOrderDate': 'Last Order Date',
  'pages.members.list.totalPayment': 'Total Payment',
  'pages.members.list.unpaid': 'Unpaid',
  'pages.members.list.averageOrder': 'Average Order',
  'pages.members.list.points': 'Points',
  'pages.members.list.pointsUpdated': 'Points updated successfully',
  'pages.members.list.pointsUpdateError': 'Failed to update points',
  'pages.members.list.userUpdated': 'User information updated successfully',
  'pages.members.list.adminMemo': 'Admin Memo',
  'pages.members.list.adminMemoPlaceholder': 'Enter admin memo',
  'pages.members.list.save': 'Save',
  'pages.members.list.memoSaved': 'Memo saved',
  'pages.members.list.sendMessageTitle': 'Send Message',
  'pages.members.list.sendMethod': 'Send Method',
  'pages.members.list.sms': 'SMS',
  'pages.members.list.emailMethod': 'Email',
  'pages.members.list.both': 'SMS + Email',
  'pages.members.list.subject': 'Subject',
  'pages.members.list.subjectPlaceholder': 'Message subject',
  'pages.members.list.content': 'Content',
  'pages.members.list.contentPlaceholder': 'Enter message content',
  'pages.members.list.messageSent': 'Message sent',
  'pages.members.list.count': ' ',
  'pages.members.list.currency': '$',
  
  // General Members Page
  'pages.members.general.title': 'General Members',
  'pages.members.general.total': 'Total {total} members',
  'pages.members.general.memberType': 'Member Type',
  'pages.members.general.memberTypeTag': 'General',
  'pages.members.general.totalGeneral': 'Total General Members',
  'pages.members.general.dormantMembers': 'Dormant Members',
  'pages.members.general.memberTypeLabel': 'General Member',
  'pages.members.general.searchMemberName': 'Member Name',
  'pages.members.general.searchMemberNamePlaceholder': 'Search by member name',
  'pages.members.general.emailVerification': 'Email Verification',
  'pages.members.general.emailVerified': 'Verified',
  'pages.members.general.emailUnverified': 'Unverified',
  'pages.members.general.loadMemberDetailsError': 'Failed to load member details',
  'pages.members.general.loadMemberListError': 'Failed to load member list',
  'pages.members.general.memberName': 'Member Name',
  'pages.members.general.memberNameSearch': 'Search by member name',
  'pages.members.general.allLevels': 'All',

  // Member Document Management Page
  'pages.members.documents.title': 'Member Document Management',
  'pages.members.documents.documentName': 'Document Name',
  'pages.members.documents.fileName': 'File Name',
  'pages.members.documents.fileUrl': 'File',
  'pages.members.documents.download': 'Download',
  'pages.members.documents.createdAt': 'Created At',
  'pages.members.documents.updatedAt': 'Updated At',
  'pages.members.documents.register': 'Register Document',
  'pages.members.documents.documentTemplate': 'Document Template',
  'pages.members.documents.selectFile': 'Select File',
  'pages.members.documents.documentNamePlaceholder': 'Enter document name',
  'pages.members.documents.documentNameKo': 'Document Name (Korean)',
  'pages.members.documents.documentNameEn': 'Document Name (English)',
  'pages.members.documents.documentNameZh': 'Document Name (Chinese)',
  'pages.members.documents.atLeastOneNameRequired': 'At least one document name is required',
  'pages.members.documents.fileRequired': 'Please select a file to upload',
  'pages.members.documents.deleteConfirm': 'Are you sure you want to delete this document?',

  // Order Detail Page
  'pages.orders.detail.title': 'Order Details',
  'pages.orders.detail.totalProductPrice': 'Total Product Price',
  'pages.orders.detail.paymentAddress': 'Payment Address',
  'pages.orders.detail.depositorName': 'Depositor',
  'pages.orders.detail.paymentAmount': 'Payment Amount',
  'pages.orders.detail.paymentMethod': 'Payment Method',
  'pages.orders.detail.paymentTime': 'Payment Time',
  'pages.orders.detail.paidAmount': 'Paid Amount',
  'pages.orders.detail.realProductAmount': 'Real Product Amount',
  'pages.orders.detail.shippingCost': 'Shipping Cost',
  'pages.orders.detail.otherPrice': 'Other Price',
  'pages.orders.detail.additionalCost': 'Additional Cost',
  'pages.orders.detail.couponDiscount': 'Coupon Discount',
  'pages.orders.detail.pointsUsed': 'Points Used',
  'pages.orders.detail.close': 'Close',
  'pages.orders.detail.error': 'Failed to load order details',
  'pages.orders.detail.notFound': 'Order not found',
  'pages.orders.detail.goBack': 'Go Back',
  'pages.orders.detail.basicInfo': 'Basic Order Information',
  'pages.orders.detail.orderNumber': 'Order Number / Member Name / Mailbox',
  'pages.orders.detail.product.orderNumber': 'Order Number',
  'pages.orders.detail.orderType': 'Center',
  'pages.orders.detail.depositAutoPay': 'Deposit AutoPayment',
  'pages.orders.detail.depositManualPay': 'Deposit ManualPayment',
  'pages.orders.detail.AutoPay': 'Auto Payment',
  'pages.orders.detail.ManualPay': 'Manual Payment',
  'pages.orders.detail.switchToAutoPay': 'Switch to Auto Payment',
  'pages.orders.detail.switchToManualPay': 'Switch to Manual Payment',
  'pages.orders.detail.switchedToAutoPay': 'Successfully switched to auto payment',
  'pages.orders.detail.switchedToManualPay': 'Successfully switched to manual payment',
  'pages.orders.detail.updateFailed': 'Failed to update payment method',
  'pages.orders.detail.progressStatus': 'Progress Status(Product Warehoused Status)',
  'pages.orders.detail.shippingMethod': 'Shipping Method',
  'pages.orders.detail.orderMemo': 'Order Memo',
  'pages.orders.detail.registrationDate': 'Registration Date',
  'pages.orders.detail.modifiedDate': 'Modified Date',
  'pages.orders.detail.purchaseManager': 'Purchase Manager',
  'pages.orders.detail.rackNumber': 'Rack Number',
  'pages.orders.detail.externalOrderId': 'External Order ID',
  'pages.orders.detail.editExternalOrderId': 'Edit External Order ID',
  'pages.orders.detail.edit': 'Edit',
  'pages.orders.detail.externalOrderIdPlaceholder': 'Enter external order ID',
  'pages.orders.detail.externalOrderIdUpdated': 'External order ID updated successfully',
  'pages.orders.detail.externalOrderIdUpdateFailed': 'Failed to update external order ID',
  'pages.orders.detail.memberInfo': 'Member Information',
  'pages.orders.detail.memberName': 'Member Name',
  'pages.orders.detail.memberId': 'Member ID',
  'pages.orders.detail.receiver': 'Receiver',
  'pages.orders.detail.contact': 'Contact',
  'pages.orders.detail.deliveryAddress': 'Delivery Address',
  'pages.orders.detail.shippingInfo': 'Shipping Center & Service Type',
  'pages.orders.detail.centerAndTransferMethodChange': 'Shipping Center & Transfer Method Change',
  'pages.orders.detail.trackingCount': 'Tracking Count',
  'pages.orders.detail.warehousedCount': 'Warehoused Count',
  'pages.orders.detail.trackingNumber': 'Tracking Number',
  'pages.orders.detail.notRegistered': 'Not Registered',
  'pages.orders.detail.waybillNumberPlaceholder': 'Enter the waybill number',
  'pages.orders.detail.waybillNumberRequired': 'Please enter a waybill number',
  'pages.orders.detail.waybillNumberUpdated': 'Waybill number updated',
  'pages.orders.detail.waybillNumberUnchanged': 'The waybill number is the same as before',
  'pages.orders.detail.waybillNumberUpdateFailed': 'Failed to update the waybill number',
  'pages.orders.detail.waybillNumberDuplicateTitle': 'This waybill number is already registered',
  'pages.orders.detail.waybillNumberDuplicateConfirm': 'Save with this number anyway?',
  'pages.orders.detail.shipmentDate': 'Shipment Date',
  'pages.orders.detail.productInfo': 'Product Information',
  'pages.orders.detail.preview': 'Preview',
  'pages.orders.detail.trackingNo': 'Tracking No',
  'pages.orders.detail.orderSite': 'Order Site',
  'pages.orders.detail.productName': 'Product Name',
  'pages.orders.detail.productNumber': 'Product Number',
  'pages.orders.detail.orderNo': 'Order No',
  'pages.orders.detail.color': 'Color',
  'pages.orders.detail.brandManufacturer': 'Brand/Manufacturer',
  'pages.orders.detail.size': 'Size',
  'pages.orders.detail.warehouseDate': 'Warehouse Date',
  'pages.orders.detail.quantityPriceTotal': 'Quantity × Price = Total',
  'pages.orders.detail.product': 'Product',
  'pages.orders.detail.memberProductName': 'Member Product Name',
  'pages.orders.detail.productStorage': 'Product Storage',
  'pages.orders.detail.noStorage': 'No Storage',
  'pages.orders.detail.inspectionStorage': 'Inspection Storage',
  'pages.orders.detail.noInspection': 'No Inspection',
  'pages.orders.detail.consumerPrice': 'Consumer Price',
  'pages.orders.detail.offerId': 'Offer ID',
  'pages.orders.detail.customerRequest': 'Customer Request',
  'pages.orders.detail.addButton': 'Add',
  'pages.orders.detail.copyButton': 'Copy',
  'pages.orders.detail.copiedToClipboard': 'Copied to clipboard',
  'pages.orders.detail.editButton': 'Edit',
  'pages.orders.detail.deleteButton': 'Delete',
  'pages.orders.detail.totalQuantity': 'Total Quantity',
  'pages.orders.detail.totalAmount': 'Total Amount',
  'pages.orders.detail.items': ' items',
  'pages.orders.detail.shipped': 'Shipped',
  'pages.orders.detail.notShipped': 'Not Shipped',
  'pages.orders.detail.shipmentComplete': 'Shipment Complete',
  'pages.orders.detail.shipmentCompleteSuccess': 'Shipment completed successfully',
  'pages.orders.detail.returnProduct': 'Return Product',
  'pages.orders.detail.returnInfo': 'Go to return processing page',
  'pages.orders.detail.receiverInfo': 'Receiver Information',
  'pages.orders.detail.nameCompany': 'Name (Customs code)',
  'pages.orders.detail.addressContact': 'Contact',
  'pages.orders.detail.businessAddress': 'Address',
  'pages.orders.detail.deliveryRequest': 'Delivery Request',
  'pages.orders.detail.centerRequest': 'Center Request',
  'pages.orders.detail.paymentInfo': 'Payment Information',
  'pages.orders.detail.totalProductAmount': 'Total Product Amount',
  'pages.orders.detail.additionalInfo': 'Additional Information',
  'pages.orders.detail.additionalService': 'Additional Service',
  'pages.orders.detail.logisticsRequest': 'Logistics Request',
  'pages.orders.detail.adminMemo': 'Admin Memo',
  'pages.orders.detail.none': 'None',
  'pages.orders.detail.selectAll': 'Select All',
  'pages.orders.detail.englishProductName': 'English Product Name',
  'pages.orders.detail.hsCode': 'HS Code',
  'pages.orders.detail.noExternalOrderId': 'No external order ID to copy',
  'pages.orders.detail.warehouse': 'Warehouse',
  'pages.orders.detail.selectWarehouse': 'Select warehouse',
  'pages.orders.detail.selectShippingMethod': 'Select shipping method',
  'pages.orders.detail.centerChangeSuccess': 'Center and shipping method updated successfully',
  'pages.orders.detail.centerChangeError': 'Failed to update center and shipping method',
  'pages.orders.detail.productInfoEdit': 'Edit Product Information',
  'pages.orders.detail.statusChangeSuccess': 'Product status updated successfully',
  'pages.orders.detail.statusChangeError': 'Failed to update product status',
  'pages.orders.detail.redFieldsRequired': 'Red fields are required.',
  'pages.orders.detail.yellowFieldsOptional': 'Yellow fields cannot be modified.',
  'pages.orders.detail.imageReplace': 'Upload Image',
  'pages.orders.detail.deliveryType': 'Delivery Type',
  'pages.orders.detail.selectDeliveryType': 'Search delivery type',
  'pages.orders.detail.category.clothing': 'Clothing',
  'pages.orders.detail.category.electronics': 'Electronics',
  'pages.orders.detail.inputType': 'Warehouse Status',
  'pages.orders.detail.quantityPrice': 'Quantity / Price',
  'pages.orders.detail.productUrl': 'Product URL',
  'pages.orders.detail.colorSize': 'Color',
  'pages.orders.detail.brandSeller': 'Brand / Seller',
  'pages.orders.detail.material': 'Material',
  'pages.orders.detail.managementInfo': 'Management Info',
  'pages.orders.detail.sellerAddress': 'Seller Address',
  'pages.orders.detail.option': 'Option',
  'pages.orders.detail.customsClearance': 'Customs Clearance',
  'pages.orders.detail.customsClearancePlaceholder': 'Enter customs clearance info',
  'pages.orders.detail.coEnglishName': 'C/O English Name',
  'pages.orders.detail.coHsCode': 'C/O HS Code',
  'pages.orders.type.vvicHighpass': 'VVIC Highpass',
  'pages.orders.type.minimall': 'Minimall',
  'pages.orders.detail.trackingNumberUpdated': 'Tracking number updated successfully',
  'pages.orders.detail.trackingNumberUpdateFailed': 'Failed to update tracking number',
  'pages.orders.detail.trackingNoPlaceholder': 'Enter tracking number',
  'pages.orders.detail.additionalServiceChange': 'Additional Service Change',
  'pages.orders.detail.simplifiedCustomClearance': 'Simplified Custom Clearance',
  'pages.orders.detail.designatedShooting': 'Designated Shooting',
  'pages.orders.detail.additionalServiceUpdated': 'Additional service updated successfully',
  'pages.orders.detail.additionalServiceUpdateFailed': 'Failed to update additional service',
  'pages.orders.detail.changeRecipientAddress': 'Change Recipient Address',
  'pages.orders.detail.recipientName': 'Name',
  'pages.orders.detail.koreanName': 'Korean',
  'pages.orders.detail.englishName': 'English',
  'pages.orders.detail.personalIdNote': '* Personal ID must match the name exactly (including spaces)',
  'pages.orders.detail.recipientType': 'Recipient Type',
  'pages.orders.detail.personal': 'Personal',
  'pages.orders.detail.business': 'Business',
  'pages.orders.detail.foreigner': 'Foreigner',
  'pages.orders.detail.phoneNumber': 'Phone Number',
  'pages.orders.detail.addressAndContact': 'Address and Contact',
  'pages.orders.detail.zipCodeSearch': 'Zip Code Search',
  'pages.orders.detail.zipCodeLabel': 'Zip Code',
  'pages.orders.detail.addressLabel': 'Address',
  'pages.orders.detail.detailAddress': 'Detail Address',
  'pages.orders.detail.addressNote': '* Domestic address only. For international shipping, please use the international shipping service.',
  'pages.orders.detail.deliveryMessageLabel': 'Delivery Message',
  'pages.orders.detail.selectDeliveryMessage': 'Select delivery message',
  'pages.orders.detail.leaveAtDoor': 'Leave at door',
  'pages.orders.detail.leaveWithSecurity': 'Leave with security',
  'pages.orders.detail.callBeforeDelivery': 'Call before delivery',
  'pages.orders.detail.deliveryMessagePlaceholder': 'Enter delivery message',
  'pages.orders.detail.deliveryMessageNote': '* National delivery service may not follow all delivery requests.',
  'pages.orders.detail.recipientAddressUpdated': 'Recipient address updated successfully',
  'pages.orders.detail.recipientAddressUpdateFailed': 'Failed to update recipient address',
  'pages.orders.detail.orderInquiry': 'Order Inquiry',
  'pages.orders.detail.orderInquiryButton': 'Order Inquiry',
  'pages.orders.detail.orderInquiryRedirect': 'Redirecting to order inquiry page...',
  'pages.orders.detail.orderInquiryModalTitle': 'Order Inquiry',
  'pages.orders.detail.orderInformation': 'Order Information',
  'pages.orders.detail.inquiryTitle': 'Inquiry Title',
  'pages.orders.detail.inquiryTitlePlaceholder': 'Enter inquiry title',
  'pages.orders.detail.inquiryTitleRequired': 'Please enter inquiry title',
  'pages.orders.detail.inquiryContent': 'Inquiry Content',
  'pages.orders.detail.inquiryContentPlaceholder': 'Please describe your inquiry in detail',
  'pages.orders.detail.inquiryContentRequired': 'Please enter inquiry content',
  'pages.orders.detail.inquirySubmitted': 'Inquiry submitted successfully',
  'pages.orders.detail.inquirySubmitFailed': 'Failed to submit inquiry',
  'pages.orders.detail.inquiryNote': '* We will respond to your inquiry as soon as possible. You can check the response in the CS > Inquiries menu.',
  'pages.common.submit': 'Submit',

  // Inventory Management
  'pages.inventory.title': 'Inventory Management',
  'pages.inventory.logistics': 'Logistics',
  'pages.inventory.stockNumber': 'Stock Number',
  'pages.inventory.inquiry': 'Inquiry',
  'pages.inventory.center': 'Center',
  'pages.inventory.productImage': 'Product Image',
  'pages.inventory.mailbox': 'Mailbox',
  'pages.inventory.memberName': 'Member Name',
  'pages.inventory.customsItem': 'Customs Item',
  'pages.inventory.productName': 'Product Name',
  'pages.inventory.trackingNumber': 'Tracking Number',
  'pages.inventory.color': 'Color',
  'pages.inventory.size': 'Size',
  'pages.inventory.quantity': 'Quantity',
  'pages.inventory.unitPrice': 'Unit Price',
  'pages.inventory.totalAmount': 'Total Amount',
  'pages.inventory.rackNumber': 'Rack Number',
  'pages.inventory.previousRackNumber': 'Previous Rack Number',
  'pages.inventory.previous': 'Previous',
  'pages.inventory.registrationDate': 'Registration Date',
  'pages.inventory.modificationDate': 'Modification Date',
  'pages.inventory.stockStatus': 'Stock Status',
  'pages.inventory.productStatus': 'Product Status',
  'pages.inventory.mock.center.weihei': 'Weihei',
  'pages.inventory.mock.center.qingdao': 'Qingdao',
  'pages.inventory.mock.center.guangzhou': 'Guangzhou',
  'pages.inventory.mock.memberName1': 'Kim Chul-soo',
  'pages.inventory.mock.memberName2': 'Lee Young-hee',
  'pages.inventory.mock.memberName3': 'Park Min-soo',
  'pages.inventory.mock.customsItem.doorbell': '【Doorbell】',
  'pages.inventory.mock.customsItem.furniture': '【Furniture】',
  'pages.inventory.mock.customsItem.clothing': '【Clothing】',
  'pages.inventory.mock.color.black': 'Black',
  'pages.inventory.mock.color.white': 'White',
  'pages.inventory.mock.color.red': 'Red',
  'pages.inventory.stockStatus.available': 'Available',
  'pages.inventory.stockStatus.inUse': 'In Use',
  'pages.inventory.stockStatus.onHold': 'On Hold',
  'pages.inventory.productStatus.normal': 'Normal',
  'pages.inventory.productStatus.problem': 'Problem',

  // Business Members Page
  'pages.members.business.title': 'Business Members',
  'pages.members.business.memberType': 'Member Type',
  'pages.members.business.memberTypeTag': 'Business',
  'pages.members.business.businessNumber': 'Business Number',
  'pages.members.business.representative': 'Representative',
  'pages.members.business.businessType': 'Business Type',
  'pages.members.business.businessTypeWholesale': 'Wholesale',
  'pages.members.business.businessTypeRetail': 'Retail',
  'pages.members.business.businessTypeImport': 'Import',
  'pages.members.business.businessTypeExport': 'Export',
  'pages.members.business.totalBusiness': 'Total Business Members',
  'pages.members.business.memberTypeLabel': 'Business Member',
  'pages.members.business.companyName': 'Company Name',
  'pages.members.business.monthlyAverage': 'Monthly Average Orders',
  'pages.members.business.mock.memberType': 'Business',
  'pages.members.business.memberCode': 'Member Code',
  'pages.members.business.memberName': 'Member Name',
  'pages.members.business.userId': 'ID',
  'pages.members.business.mailboxNumber': 'Mailbox Number',
  'pages.members.business.mobilePhone': 'Mobile Phone',
  'pages.members.business.deposit': 'Deposit (₩)',
  'pages.members.business.businessRegistration': 'Business Registration',
  'pages.members.business.applicationApproval': 'Application Approval',
  'pages.members.business.referralCode': 'Referral Code',
  'pages.members.business.email': 'Email',
  'pages.members.business.referralPointsAccumulation': 'Referral Points Accumulation',
  'pages.members.business.managerName': 'Manager Name',
  'pages.members.business.applicationCount': 'Application Count',
  'pages.members.business.adminAssignmentDate': 'Admin Assignment Date',
  'pages.members.business.lastLogin': 'Last Login',
  'pages.members.business.joinDate': 'Join Date',
  'pages.members.business.actions': 'Actions',

  'pages.members.list.memberNameSearchPlaceholder': 'Search by member name',
  'pages.members.list.emailVerification': 'Email Verification',
  'pages.members.list.emailVerified': 'Verified',
  'pages.members.list.emailUnverified': 'Unverified',
  'pages.members.list.loadMemberDetailsError': 'Failed to load member details',
  'pages.members.list.loadMemberListError': 'Failed to load member list',
  'pages.members.list.birthday': 'Birthday',
  'pages.members.list.gender': 'Gender',
  'pages.members.list.genderMale': 'Male',
  'pages.members.list.genderFemale': 'Female',
  'pages.members.list.genderOther': 'Other',
  'pages.members.list.deposit': 'Deposit',
  'pages.members.list.address': 'Address',
  'pages.members.list.defaultAddress': 'Default',
  'pages.members.list.zipCode': 'Zip Code',
  'pages.members.list.contact': 'Contact',

  // Blacklist Members Page
  'pages.members.blacklist.title': 'Blacklist Member Management',
  'pages.members.blacklist.totalBlacklist': 'Total Blacklisted',
  'pages.members.blacklist.generalMembers': 'General Members',
  'pages.members.blacklist.businessMembers': 'Business Members',
  'pages.members.blacklist.addedThisMonth': 'Added This Month',
  'pages.members.blacklist.unblacklistConfirm': 'Remove from blacklist?',
  'pages.members.blacklist.unblacklistSuccess': 'Removed from blacklist',
  'pages.members.blacklist.unblacklistError': 'Failed to remove from blacklist',
  'pages.members.blacklist.unblacklist': 'Unblacklist',
  'pages.members.blacklist.bulkUnblacklistConfirm': 'Remove {count} selected members from blacklist?',
  'pages.members.blacklist.bulkUnblacklistSuccess': '{count} members removed from blacklist',
  'pages.members.blacklist.bulkUnblacklist': 'Bulk Unblacklist',
  'pages.members.blacklist.unblacklistButton': 'Remove from Blacklist',
  'pages.members.blacklist.loadError': 'Failed to load blacklist members',
  'pages.members.blacklist.memberType': 'Member Type',
  'pages.members.blacklist.general': 'General',
  'pages.members.blacklist.business': 'Business',
  'pages.members.blacklist.blacklisted': 'Blacklisted',
  'pages.members.blacklist.birthday': 'Birthday',
  'pages.members.blacklist.gender': 'Gender',
  'pages.members.blacklist.genderMale': 'Male',
  'pages.members.blacklist.genderFemale': 'Female',
  'pages.members.blacklist.genderOther': 'Other',
  'pages.members.blacklist.points': 'Points',
  'pages.members.blacklist.deposit': 'Deposit Balance',
  'pages.members.blacklist.address': 'Address',
  'pages.members.blacklist.zipCode': 'Zip Code',
  'pages.members.blacklist.contact': 'Contact',
  'pages.members.blacklist.default': 'Default',
  'pages.members.blacklist.levelChanged': 'Member level changed successfully',
  'pages.members.blacklist.levelChangeError': 'Failed to change member level',
  'pages.members.blacklist.emailVerification': 'Email Verification',
  'pages.members.blacklist.emailVerified': 'Verified',
  'pages.members.blacklist.emailUnverified': 'Unverified',
  'pages.members.blacklist.searchPlaceholder': 'Search by member name',

  // Deposit Management Pages
  'pages.members.depositApplication.description': 'Deposit Application Details Management',
  'pages.members.depositApplication.subDescription': 'View and manage member deposit application details',
  'pages.members.depositUsage.description': 'Deposit Usage Details Management',
  'pages.members.depositUsage.subDescription': 'View and manage member deposit usage details',
  'pages.members.bankbookVerification.description': 'Automatic Bankbook Verification Management',
  'pages.members.bankbookVerification.subDescription': 'Configure and manage automatic bankbook verification for members',
  'pages.members.forexDepositApplication.description': 'Foreign Exchange Deposit Application Details Management',
  'pages.members.forexDepositApplication.subDescription': 'View and manage member foreign exchange deposit application details',
  'pages.members.forexDepositUsage.description': 'Foreign Exchange Deposit Usage Details Management',
  'pages.members.forexDepositUsage.subDescription': 'View and manage member foreign exchange deposit usage details',
  'pages.members.forexDepositPayment.description': 'Foreign Exchange Deposit Payment Details Management',
  'pages.members.forexDepositPayment.subDescription': 'View and manage member foreign exchange deposit payment details',

  // Deposit Application Detailed
  'pages.members.depositApplication.memberName': 'Member Name',
  'pages.members.depositApplication.applicationType': 'Application Type',
  'pages.members.depositApplication.typeDeposit': 'Deposit',
  'pages.members.depositApplication.typeRefund': 'Refund',
  'pages.members.depositApplication.depositAmount': 'Deposit Amount',
  'pages.members.depositApplication.refundAmount': 'Refund Amount',
  'pages.members.depositApplication.amount': 'Application Amount',
  'pages.members.depositApplication.bankInfo': 'Bank Information',
  'pages.members.depositApplication.depositor': 'Depositor (Account Holder)',
  'pages.members.depositApplication.status': 'Status',
  'pages.members.depositApplication.statusPending': 'Pending',
  'pages.members.depositApplication.statusApproved': 'Approved',
  'pages.members.depositApplication.statusRejected': 'Rejected',
  'pages.members.depositApplication.applicationDate': 'Application Date',
  'pages.members.depositApplication.expectedDepositDate': 'Expected Deposit Date',
  'pages.members.depositApplication.actions': 'Actions',
  'pages.members.depositApplication.approve': 'Approve',
  'pages.members.depositApplication.complete': 'Complete',
  'pages.members.depositApplication.reject': 'Reject',
  'pages.members.depositApplication.cancellation': 'Cancellation',
  'pages.members.depositApplication.viewDetails': 'View Details',
  'pages.members.depositApplication.approveConfirm': 'Approve Deposit Application',
  'pages.members.depositApplication.approveContent': 'Do you want to approve {name}\'s deposit application of {amount}?',
  'pages.members.depositApplication.approved': 'Deposit application has been approved',
  'pages.members.depositApplication.rejectConfirm': 'Reject Deposit Application',
  'pages.members.depositApplication.rejectContent': 'Do you want to reject {name}\'s deposit application?',
  'pages.members.depositApplication.rejected': 'Deposit application has been rejected',
  'pages.members.depositApplication.totalApplications': 'Total Applications',
  'pages.members.depositApplication.pendingApplications': 'Pending',
  'pages.members.depositApplication.approvedApplications': 'Approved',
  'pages.members.depositApplication.totalAmount': 'Total Amount',
  'pages.members.depositApplication.reasonRecharge': 'Deposit Recharge',
  'pages.members.depositApplication.mock.companyName': 'Trading Company Ltd.',
  'pages.members.depositApplication.mock.personName': 'John Doe',
  'pages.members.depositApplication.mock.bank.kb': 'KB Kookmin Bank',
  'pages.members.depositApplication.mock.bank.shinhan': 'Shinhan Bank',
  'pages.members.depositApplication.mock.bank.hana': 'Hana Bank',
  'pages.members.depositApplication.mock.bank.woori': 'Woori Bank',
  'pages.members.depositApplication.mock.accountHolder': 'CEO Lee',
  'pages.members.depositApplication.mock.admin': 'Admin 1',
  'pages.members.depositApplication.mock.memo': 'VIP Customer',
  'pages.members.forexDepositPayment.mock.adminMemo': 'This is admin memo content',

  // Recharge Review
  'pages.members.rechargeReview.title': 'Recharge Review',
  'pages.members.rechargeReview.filter.group.title': 'Status Filter',
  'pages.members.rechargeReview.filter.pendingReview': 'Pending Review',
  'pages.members.rechargeReview.filter.approvalSuccessful': 'Approval Successful',
  'pages.members.rechargeReview.filter.reviewFailed': 'Review Failed',
  'pages.members.rechargeReview.column.userId': 'User ID',
  'pages.members.rechargeReview.column.user': 'User',
  'pages.members.rechargeReview.column.remittanceMethod': 'Remittance methods',
  'pages.members.rechargeReview.column.remitterName': 'Remitter\'s name',
  'pages.members.rechargeReview.column.rechargeCurrencyAndAmount': 'Recharge currency and amount',
  'pages.members.rechargeReview.column.receivedCurrencyAndAmount': 'Currency and amount received',
  'pages.members.rechargeReview.column.serviceFee': 'Service fee',
  'pages.members.rechargeReview.column.receivingBankInformation': 'Receiving bank information',
  'pages.members.rechargeReview.column.addTime': 'Add time',
  'pages.members.rechargeReview.column.operate': 'Operate',
  'pages.members.rechargeReview.memberName': 'Member Name',
  'pages.members.rechargeReview.memberId': 'Member ID',
  'pages.members.rechargeReview.amount': 'Amount',
  'pages.members.rechargeReview.paymentMethod': 'Payment Method',
  'pages.members.rechargeReview.status': 'Status',
  'pages.members.rechargeReview.status.pending': 'Pending',
  'pages.members.rechargeReview.status.approved': 'Approved',
  'pages.members.rechargeReview.status.rejected': 'Rejected',
  'pages.members.rechargeReview.applicationDate': 'Application Date',
  'pages.members.rechargeReview.approvalDate': 'Approval Date',
  'pages.members.rechargeReview.transactionId': 'Transaction ID',
  'pages.members.rechargeReview.admin': 'Admin',
  'pages.members.rechargeReview.approve': 'Approve',
  'pages.members.rechargeReview.reject': 'Reject',
  'pages.members.rechargeReview.approveConfirm': 'Approve Recharge Application',
  'pages.members.rechargeReview.approveContent': 'Are you sure you want to approve {name}\'s recharge application of {amount}원?',
  'pages.members.rechargeReview.approved': 'Recharge application has been approved',
  'pages.members.rechargeReview.rejectConfirm': 'Reject Recharge Application',
  'pages.members.rechargeReview.rejectContent': 'Are you sure you want to reject {name}\'s recharge application?',
  'pages.members.rechargeReview.rejected': 'Recharge application has been rejected',
  'pages.members.rechargeReview.statistics.total': 'Total Applications',
  'pages.members.rechargeReview.statistics.pending': 'Pending',
  'pages.members.rechargeReview.statistics.approved': 'Approved',
  'pages.members.rechargeReview.statistics.totalAmount': 'Total Amount',
  'pages.members.rechargeReview.exportSuccess': 'Data exported successfully',
  'pages.members.rechargeReview.remittanceCurrency': 'Remittance currency',
  'pages.members.rechargeReview.remittanceCurrencyAndAmount': 'Remittance currency and amount',
  'pages.members.rechargeReview.receivingBankName': 'Receiving bank name',
  'pages.members.rechargeReview.receivingAccountNumber': 'Receiving account number',
  'pages.members.rechargeReview.receivingAccountHolder': 'Receiving account holder',

  // Withdraw Review
  'pages.members.withdrawReview.title': 'Withdraw Review',
  'pages.members.withdrawReview.filter.group.title': 'Status Filter',
  'pages.members.withdrawReview.filter.pendingReview': 'Pending Review',
  'pages.members.withdrawReview.filter.approvalSuccessful': 'Approval Successful',
  'pages.members.withdrawReview.filter.reviewFailed': 'Review Failed',
  'pages.members.withdrawReview.column.id': 'ID',
  'pages.members.withdrawReview.column.userId': 'User ID',
  'pages.members.withdrawReview.column.user': 'User',
  'pages.members.withdrawReview.column.handlingFee': 'Handling fee',
  'pages.members.withdrawReview.column.withdrawalAmount': 'Withdrawal amount',
  'pages.members.withdrawReview.column.amountReceived': 'Amount received',
  'pages.members.withdrawReview.column.bankCardName': 'Bank card name',
  'pages.members.withdrawReview.column.bankCardNumber': 'Bank card number',
  'pages.members.withdrawReview.column.bankCardHolder': 'Bank card holders',
  'pages.members.withdrawReview.column.withdrawalTime': 'Withdrawal time',
  'pages.members.withdrawReview.column.operate': 'Operate',
  'pages.members.withdrawReview.memberName': 'Member Name',
  'pages.members.withdrawReview.memberId': 'Member ID',
  'pages.members.withdrawReview.amount': 'Amount',
  'pages.members.withdrawReview.status': 'Status',
  'pages.members.withdrawReview.status.pending': 'Pending',
  'pages.members.withdrawReview.status.approved': 'Approved',
  'pages.members.withdrawReview.status.rejected': 'Rejected',
  'pages.members.withdrawReview.bankName': 'Bank Name',
  'pages.members.withdrawReview.accountNumber': 'Account Number',
  'pages.members.withdrawReview.accountHolder': 'Account Holder',
  'pages.members.withdrawReview.applicationDate': 'Application Date',
  'pages.members.withdrawReview.approvalDate': 'Approval Date',
  'pages.members.withdrawReview.admin': 'Admin',
  'pages.members.withdrawReview.approve': 'Approve',
  'pages.members.withdrawReview.reject': 'Reject',
  'pages.members.withdrawReview.approveConfirm': 'Approve Withdraw Application',
  'pages.members.withdrawReview.approveContent': 'Are you sure you want to approve {name}\'s withdraw application of {amount}원?',
  'pages.members.withdrawReview.approved': 'Withdraw application has been approved',
  'pages.members.withdrawReview.rejectConfirm': 'Reject Withdraw Application',
  'pages.members.withdrawReview.rejectContent': 'Are you sure you want to reject {name}\'s withdraw application?',
  'pages.members.withdrawReview.rejected': 'Withdraw application has been rejected',
  'pages.members.withdrawReview.statistics.total': 'Total Applications',
  'pages.members.withdrawReview.statistics.pending': 'Pending',
  'pages.members.withdrawReview.statistics.approved': 'Approved',
  'pages.members.withdrawReview.statistics.totalAmount': 'Total Amount',
  'pages.members.withdrawReview.exportSuccess': 'Data exported successfully',

  // Financial Record
  'pages.members.financialRecord.title': 'Financial Record',
  'pages.members.financialRecord.filter.group.title': 'Record Filter',
  'pages.members.financialRecord.filter.financialRecords': 'Financial records',
  'pages.members.financialRecord.filter.consumptionRecords': 'Consumption records',
  'pages.members.financialRecord.filter.refundRecords': 'Refund records',
  'pages.members.financialRecord.filter.rebateRecords': 'Rebate records',
  'pages.members.financialRecord.filter.pointsRecord': 'Points record',
  'pages.members.financialRecord.filter.couponUsageHistory': 'Coupon usage history',
  'pages.members.financialRecord.filter.taxSettlement': 'Tax settlement management',
  'pages.members.financialRecord.tab.financial': 'Financial Records',
  'pages.members.financialRecord.tab.consumption': 'Consumption Records',
  'pages.members.financialRecord.tab.refundRecords': 'Refund Records',
  'pages.members.financialRecord.tab.rebate': 'Rebate Records',
  'pages.members.financialRecord.tab.points': 'Points History',
  'pages.members.financialRecord.tab.coupon': 'Coupon Usage History',
  'pages.members.financialRecord.tab.tax': 'Tax Settlement Management',
  /** Shared across Financial Record tabs — same wording as settlement filters */
  'pages.members.financialRecord.tabsFilter.startTime': 'Start time',
  'pages.members.financialRecord.tabsFilter.endTime': 'End time',
  'pages.members.financialRecord.tabsFilter.paymentDateStart': 'Payment date from',
  'pages.members.financialRecord.tabsFilter.paymentDateEnd': 'Payment date to',
  // Financial Records Columns
  'pages.members.financialRecord.financial.column.orderNumber': 'Order Number',
  'pages.members.financialRecord.financial.column.purchaseOrderNumber': 'Purchase Order Number',
  'pages.members.financialRecord.financial.column.userIdUserName': 'User ID/User Name',
  'pages.members.financialRecord.financial.column.productUnitPrice': 'Product Unit Price',
  'pages.members.financialRecord.financial.column.productTotalPrice': 'Product Total Price',
  'pages.members.financialRecord.financial.column.handlingFee': 'Handling Fee (1%)',
  'pages.members.financialRecord.financial.column.designatedShootingFee': 'Designated Shooting Fee',
  'pages.members.financialRecord.financial.column.firstInternationalShippingFee': '1st Intl Shipping Fee',
  'pages.members.financialRecord.financial.column.secondInternationalShippingFee': '2nd Intl Shipping Fee',
  'pages.members.financialRecord.financial.column.paymentMethod': 'Payment Method',
  'pages.members.financialRecord.financial.column.transactionNumber': 'Transaction Number',
  'pages.members.financialRecord.financial.column.secondPaymentMethod': '2nd Payment Method',
  'pages.members.financialRecord.financial.column.secondPaymentTransactionNumber': '2nd Payment Transaction No',
  'pages.members.financialRecord.financial.column.orderPointsUsed': 'Order Points Used',
  'pages.members.financialRecord.financial.column.deliveryPointsUsed': 'Delivery Points Used',
  'pages.members.financialRecord.financial.column.orderCouponsUsed': 'Order Coupons Used',
  'pages.members.financialRecord.financial.column.deliveryCouponsUsed': 'Delivery Coupons Used',
  'pages.members.financialRecord.financial.column.paymentType': 'Payment Type',
  'pages.members.financialRecord.financial.column.amountBeforeChange': 'Amount before change',
  'pages.members.financialRecord.financial.column.changeAmount': 'Change amount',
  'pages.members.financialRecord.financial.column.amountAfterChange': 'Amount after change',
  'pages.members.financialRecord.financial.column.paidTime': 'Paid Time',
  'pages.members.financialRecord.financial.column.financialSettlementTime': 'Financial Settlement Time',
  'pages.members.financialRecord.financial.column.operatingTime': 'Operating time',
  'pages.members.financialRecord.financial.column.remarks': 'Remarks',
  // Consumption Records Columns
  'pages.members.financialRecord.consumption.column.orderNumber': 'Order Number',
  'pages.members.financialRecord.consumption.column.purchaseOrderNumber': 'Purchase Order Number',
  'pages.members.financialRecord.consumption.column.userId': 'User ID',
  'pages.members.financialRecord.consumption.column.recipientName': 'Recipient Name',
  'pages.members.financialRecord.consumption.column.productUnitPrice': 'Product Unit Price',
  'pages.members.financialRecord.consumption.column.productTotalPrice': 'Product Total Price',
  'pages.members.financialRecord.consumption.column.handlingFee': 'Handling Fee (1%)',
  'pages.members.financialRecord.consumption.column.designatedShootingFee': 'Designated Shooting Fee',
  'pages.members.financialRecord.consumption.column.firstInternationalShippingFee': '1st Intl Shipping Fee',
  'pages.members.financialRecord.consumption.column.secondInternationalShippingFee': '2nd Intl Shipping Fee',
  'pages.members.financialRecord.consumption.column.paymentMethod': 'Payment Method',
  'pages.members.financialRecord.consumption.column.transactionNumber': 'Transaction Number',
  'pages.members.financialRecord.consumption.column.secondPaymentMethod': '2nd Payment Method',
  'pages.members.financialRecord.consumption.column.secondPaymentTransactionNumber': '2nd Payment Transaction No',
  'pages.members.financialRecord.consumption.column.orderPointsUsed': 'Order Points Used',
  'pages.members.financialRecord.consumption.column.deliveryPointsUsed': 'Delivery Points Used',
  'pages.members.financialRecord.consumption.column.orderCouponsUsed': 'Order Coupons Used',
  'pages.members.financialRecord.consumption.column.deliveryCouponsUsed': 'Delivery Coupons Used',
  'pages.members.financialRecord.consumption.column.userAction': 'User Action',
  'pages.members.financialRecord.consumption.column.paymentType': 'Payment Type',
  'pages.members.financialRecord.consumption.column.amountBeforeChange': 'Amount before change',
  'pages.members.financialRecord.consumption.column.changeAmount': 'Change amount',
  'pages.members.financialRecord.consumption.column.amountAfterChange': 'Amount after change',
  'pages.members.financialRecord.consumption.column.paidTime': 'Paid Time',
  'pages.members.financialRecord.consumption.column.financialSettlementTime': 'Financial Settlement Time',
  'pages.members.financialRecord.consumption.column.changedTime': 'Changed Time',
  'pages.members.financialRecord.consumption.column.addTime': 'Add time',
  // Rebate Records Columns
  'pages.members.financialRecord.rebate.column.userInfo': 'User Info',
  'pages.members.financialRecord.rebate.column.memberName': 'Member name',
  'pages.members.financialRecord.rebate.column.mailbox': 'Mailbox',
  'pages.members.financialRecord.rebate.column.orderNumber': 'Order Number',
  'pages.members.financialRecord.rebate.column.shippingRebate': 'Shipping Rebate',
  'pages.members.financialRecord.rebate.column.serviceFeeRebate': 'Service Fee Rebate',
  'pages.members.financialRecord.rebate.column.totalRebateAmount': 'Rebate Amount',
  'pages.members.financialRecord.rebate.column.amountBeforeChange': 'Amount before change',
  'pages.members.financialRecord.rebate.column.amountAfterChange': 'Amount after change',
  'pages.members.financialRecord.rebate.column.operatingTime': 'Operating time',
  'pages.members.financialRecord.rebate.column.sellerName': 'Seller name',
  'pages.members.financialRecord.rebate.column.sellerMailbox': 'Seller mailbox',
  'pages.members.financialRecord.rebate.column.productNo': 'Product No.',
  'pages.members.financialRecord.rebate.column.productName': 'Product name',
  'pages.members.financialRecord.rebate.column.supplierName': 'Supplier name',
  'pages.members.financialRecord.rebate.column.quantity': 'Quantity',
  'pages.members.financialRecord.rebate.column.buyerMailbox': 'Member mailbox',
  'pages.members.financialRecord.rebate.column.recipient': 'Recipient',
  'pages.members.financialRecord.rebate.column.paymentAmount': 'Payment amount',
  'pages.members.financialRecord.rebate.column.productCost': 'Product cost',
  'pages.members.financialRecord.rebate.column.intlShipping': 'Intl. shipping',
  'pages.members.financialRecord.rebate.column.rebate': 'Rebate',
  'pages.members.financialRecord.rebate.column.intlTrackingNo': 'International tracking No.',
  'pages.members.financialRecord.rebate.column.orderCreatedAt': 'Order created at',
  'pages.members.financialRecord.rebate.column.downlineSellerUserId': 'Downline seller',
  'pages.members.financialRecord.rebate.filter.sellerMailbox': 'Seller mailbox',
  'pages.members.financialRecord.rebate.filter.dateRangeFrom': 'Search period start',
  'pages.members.financialRecord.rebate.filter.dateRangeTo': 'Search period end',
  // Coupon Usage History Columns
  'pages.members.financialRecord.coupon.column.id': 'No',
  'pages.members.financialRecord.coupon.column.userNameId': 'User Name(ID)',
  'pages.members.financialRecord.coupon.column.orderNumber': 'Order Number',
  'pages.members.financialRecord.coupon.column.couponName': 'Coupon Name',
  'pages.members.financialRecord.coupon.column.couponCode': 'Coupon Code',
  'pages.members.financialRecord.coupon.column.couponAmount': 'Coupon amount',
  'pages.members.financialRecord.coupon.column.minimalUsageAmount': 'Minimal Usage Amount',
  'pages.members.financialRecord.coupon.column.receiptMethod': 'Receipt method',
  'pages.members.financialRecord.coupon.column.availablePeriod': 'Available Period',
  'pages.members.financialRecord.coupon.column.status': 'Status',
  'pages.members.financialRecord.coupon.column.receiveTime': 'Receive Time',
  'pages.members.financialRecord.coupon.status.used': 'Used',
  'pages.members.financialRecord.coupon.status.available': 'Available',
  'pages.members.financialRecord.coupon.status.expired': 'Expired',
  'pages.members.financialRecord.coupon.status.unused': 'Not Use',

  // Deposit (formerly Advanced Deposit)
  'pages.members.deposit.title': 'Deposit',
  'pages.members.deposit.column.paymentMethods': 'Payment methods',
  'pages.members.deposit.column.userId': 'User ID',
  'pages.members.deposit.column.tr': 'TR',
  'pages.members.deposit.column.orderCreationTime': 'Order creation time',
  'pages.members.deposit.column.payerName': 'Name of the person making the payment',
  'pages.members.deposit.column.paymentAmountKRW': 'Payment amount (KRW)',
  'pages.members.deposit.column.amountUsedKRW': 'Amount used (KRW)',
  'pages.members.deposit.column.remainingAmountKRW': 'Remaining deposit (KRW)',

  // Membership Level Management
  'pages.members.membershipLevel.title': 'Membership Level',
  'pages.members.membershipLevel.column.level': 'Level',
  'pages.members.membershipLevel.column.availablePointsRange': 'Available Points Range',
  'pages.members.membershipLevel.column.pointsAcquisitionRatio': 'Points Acquisition Ratio',
  'pages.members.membershipLevel.column.pointsDiscountRatio': 'Points Discount Ratio',
  'pages.members.membershipLevel.column.orderAmountDiscountRatio': 'Order Amount Discount Ratio',
  'pages.members.membershipLevel.column.freeStorageDays': 'Free Warehouse Storage Days',
  'pages.members.membershipLevel.column.status': 'Status',
  'pages.members.membershipLevel.column.ruleSettingTime': 'Rule Setting Time',
  'pages.members.membershipLevel.status.active': 'Active',
  'pages.members.membershipLevel.status.inactive': 'Inactive',
  'pages.members.membershipLevel.column.id': 'ID',
  'pages.members.membershipLevel.column.grade': 'Grade',
  'pages.members.membershipLevel.column.integral': 'Integral',
  'pages.members.membershipLevel.column.maxPointsUsable': 'Maximum of points that can be used',
  'pages.members.membershipLevel.column.minPointsAvailable': 'Minimum number of points available',
  'pages.members.membershipLevel.column.discountOnTotalOrderAmount': 'Discount on total order amount',
  'pages.members.membershipLevel.column.freeStorageValidityPeriod': 'Free storage validity period (Days)',
  'pages.members.membershipLevel.column.remark': 'Remark',
  'pages.members.membershipLevel.column.addTime': 'Add time',
  'pages.members.membershipLevel.disable': 'Disable',
  'pages.members.membershipLevel.enable': 'Enable',
  'pages.members.membershipLevel.disableConfirm': 'Are you sure you want to disable this rule?',
  'pages.members.membershipLevel.disableSuccess': 'Rule has been disabled',
  'pages.members.membershipLevel.disableError': 'Failed to disable rule',
  'pages.members.membershipLevel.enableSuccess': 'Rule has been enabled',
  'pages.members.membershipLevel.enableError': 'Failed to enable rule',
  'pages.members.membershipLevel.deleteConfirmDesc': 'This action cannot be undone.',
  'pages.members.membershipLevel.deleteTitle': 'Delete Level',
  'pages.members.membershipLevel.deleteConfirm': 'Are you sure you want to delete {name} level?',
  'pages.members.membershipLevel.deleteSuccess': 'Level deleted successfully',
  'pages.members.membershipLevel.updateSuccess': 'Level updated successfully',
  'pages.members.membershipLevel.createSuccess': 'Level created successfully',
  'pages.members.membershipLevel.modal.addTitle': 'Add Level',
  'pages.members.membershipLevel.modal.editTitle': 'Edit Level',
  'pages.members.membershipLevel.form.level': 'Level',
  'pages.members.membershipLevel.form.levelPlaceholder': 'Enter level',
  'pages.members.membershipLevel.form.grade': 'Grade',
  'pages.members.membershipLevel.form.gradePlaceholder': 'Enter grade',
  'pages.members.membershipLevel.form.integral': 'Integral',
  'pages.members.membershipLevel.form.integralPlaceholder': 'Enter integral',
  'pages.members.membershipLevel.form.orderAmountDiscountRatio': 'Order Amount Discount Ratio',
  'pages.members.membershipLevel.form.orderAmountDiscountRatioPlaceholder': 'Enter order amount discount ratio',
  'pages.members.membershipLevel.form.freeStorageDays': 'Free Warehouse Storage Days',
  'pages.members.membershipLevel.form.freeStorageDaysPlaceholder': 'Enter free warehouse storage days',
  'pages.members.membershipLevel.form.maxPointsUsable': 'Maximum of points that can be used',
  'pages.members.membershipLevel.form.maxPointsUsablePlaceholder': 'Enter maximum points that can be used',
  'pages.members.membershipLevel.form.minPointsAvailable': 'Minimum number of points available',
  'pages.members.membershipLevel.form.minPointsAvailablePlaceholder': 'Enter minimum number of points available',
  'pages.members.membershipLevel.form.pointsAcquisitionRatio': 'Points acquisition ratio',
  'pages.members.membershipLevel.form.pointsAcquisitionRatioPlaceholder': 'Enter points acquisition ratio',
  'pages.members.membershipLevel.form.pointsDiscountRatio': 'Points discount ratio',
  'pages.members.membershipLevel.form.pointsDiscountRatioPlaceholder': 'Enter points discount ratio (%)',
  'pages.members.membershipLevel.form.discountOnTotalOrderAmount': 'Discount on total order amount',
  'pages.members.membershipLevel.form.discountOnTotalOrderAmountPlaceholder': 'Enter discount on total order amount (%)',
  'pages.members.membershipLevel.form.freeStorageValidityPeriod': 'Free storage validity period',
  'pages.members.membershipLevel.form.freeStorageValidityPeriodPlaceholder': 'Enter free storage validity period',
  'pages.members.membershipLevel.form.days': 'Days',
  'pages.members.membershipLevel.form.remark': 'Remark',
  'pages.members.membershipLevel.form.remarkPlaceholder': 'Enter remark',

  // Rebate Level
  'pages.members.rebateLevel.title': 'Rebate Level',
  'pages.members.rebateLevel.column.grade': 'Grade',
  'pages.members.rebateLevel.column.rebatePercentage': ' GeneralRebate Percentage',
  'pages.members.rebateLevel.column.labangRebatePercentage': ' Labang Rebate Percentage',
  'pages.members.rebateLevel.column.addTime': 'Add Time',
  'pages.members.rebateLevel.column.levelName': 'Level Name',
  'pages.members.rebateLevel.column.levelCode': 'Level Code',
  'pages.members.rebateLevel.column.rebateRate': 'Rebate Rate',
  'pages.members.rebateLevel.column.minPurchaseAmount': 'Min Purchase Amount',
  'pages.members.rebateLevel.column.maxPurchaseAmount': 'Max Purchase Amount',
  'pages.members.rebateLevel.column.description': 'Description',
  'pages.members.rebateLevel.column.isActive': 'Active',
  'pages.members.rebateLevel.deleteTitle': 'Delete Rebate Level',
  'pages.members.rebateLevel.deleteConfirm': 'Are you sure you want to delete {name} rebate level?',
  'pages.members.rebateLevel.deleteSuccess': 'Rebate level deleted successfully',
  'pages.members.rebateLevel.updateSuccess': 'Rebate level updated successfully',
  'pages.members.rebateLevel.createSuccess': 'Rebate level created successfully',
  'pages.members.rebateLevel.modal.addTitle': 'Add Rebate Level',
  'pages.members.rebateLevel.modal.editTitle': 'Edit Rebate Level',
  'pages.members.rebateLevel.form.grade': 'Grade',
  'pages.members.rebateLevel.form.gradePlaceholder': 'Enter grade',
  'pages.members.rebateLevel.form.gradeRequired': 'Please enter grade',
  'pages.members.rebateLevel.form.rebatePercentage': 'Rebate Percentage',
  'pages.members.rebateLevel.form.rebatePercentagePlaceholder': 'Enter rebate percentage (%)',
  'pages.members.rebateLevel.form.rebatePercentageRequired': 'Please enter rebate percentage',
  'pages.members.rebateLevel.form.levelName': 'Level Name',
  'pages.members.rebateLevel.form.levelNamePlaceholder': 'Enter level name',
  'pages.members.rebateLevel.form.levelCode': 'Level Code',
  'pages.members.rebateLevel.form.levelCodePlaceholder': 'Enter level code',
  'pages.members.rebateLevel.form.rebateRate': 'Rebate Rate',
  'pages.members.rebateLevel.form.rebateRatePlaceholder': 'Enter rebate rate (%)',
  'pages.members.rebateLevel.form.minPurchaseAmount': 'Min Purchase Amount',
  'pages.members.rebateLevel.form.minPurchaseAmountPlaceholder': 'Enter minimum purchase amount',
  'pages.members.rebateLevel.form.maxPurchaseAmount': 'Max Purchase Amount',
  'pages.members.rebateLevel.form.maxPurchaseAmountPlaceholder': 'Enter maximum purchase amount (optional)',
  'pages.members.rebateLevel.form.description': 'Description',
  'pages.members.rebateLevel.form.descriptionPlaceholder': 'Enter description',
  'pages.members.rebateLevel.form.isActive': 'Active',

  // Todaymall Rebate Level
  'pages.products.rebateLevel.title': 'Rebate Levels',
  'pages.products.rebateLevel.addButton': 'Add Rebate Level',
  'pages.products.rebateLevel.column.layer': 'Layer',
  'pages.products.rebateLevel.column.type': 'Type',
  'pages.products.rebateLevel.column.rebatePercentage': 'Rebate Percentage (%)',
  'pages.products.rebateLevel.column.createdAt': 'Created At',
  'pages.products.rebateLevel.column.actions': 'Actions',
  'pages.products.rebateLevel.type.regular': 'Regular',
  'pages.products.rebateLevel.type.labang': 'Labang',
  'pages.products.rebateLevel.action.edit': 'Edit',
  'pages.products.rebateLevel.action.delete': 'Delete',
  'pages.products.rebateLevel.deleteConfirm': 'Are you sure you want to delete this rebate level?',
  'pages.products.rebateLevel.deleteConfirmYes': 'Yes',
  'pages.products.rebateLevel.deleteConfirmNo': 'No',
  'pages.products.rebateLevel.deleteSuccess': 'Rebate level deleted successfully',
  'pages.products.rebateLevel.deleteFailed': 'Failed to delete rebate level',
  'pages.products.rebateLevel.updateSuccess': 'Rebate level updated successfully',
  'pages.products.rebateLevel.createSuccess': 'Rebate level created successfully',
  'pages.products.rebateLevel.saveFailed': 'Failed to save rebate level',
  'pages.products.rebateLevel.modal.addTitle': 'Add Rebate Level',
  'pages.products.rebateLevel.modal.editTitle': 'Edit Rebate Level',
  'pages.products.rebateLevel.form.layer': 'Layer',
  'pages.products.rebateLevel.form.layerPlaceholder': 'Select layer',
  'pages.products.rebateLevel.form.layerRequired': 'Please select layer',
  'pages.products.rebateLevel.form.layer1': 'Layer 1',
  'pages.products.rebateLevel.form.layer2': 'Layer 2',
  'pages.products.rebateLevel.form.layer3': 'Layer 3',
  'pages.products.rebateLevel.form.layer4': 'Layer 4',
  'pages.products.rebateLevel.form.layer5': 'Layer 5',
  'pages.products.rebateLevel.form.lecturer': 'Lecturer',
  'pages.products.rebateLevel.form.type': 'Type',
  'pages.products.rebateLevel.form.typeRequired': 'Please select type',
  'pages.products.rebateLevel.form.rebatePercentage': 'Rebate Percentage (%)',
  'pages.products.rebateLevel.form.rebatePercentagePlaceholder': 'e.g., 70',
  'pages.products.rebateLevel.form.rebatePercentageRequired': 'Please enter percentage',
  'pages.products.rebateLevel.form.rebatePercentageRange': 'Must be between 0 and 100',
  'pages.products.rebateLevel.form.example': 'Example:',
  'pages.products.rebateLevel.form.exampleText': 'Layer {layer} {type} members will receive {percentage}% rebate.',

  // Todaymall Rebate Rules
  'pages.products.rebateRules.title': 'Rebate Rules',
  'pages.products.rebateRules.addButton': 'Add Rebate Rule',
  'pages.products.rebateRules.column.lowerLimit': 'Lower Limit (₩)',
  'pages.products.rebateRules.column.upperLimit': 'Upper Limit (₩)',
  'pages.products.rebateRules.column.percentage': 'Rebate Percentage (%)',
  'pages.products.rebateRules.column.createdAt': 'Created At',
  'pages.products.rebateRules.column.actions': 'Actions',
  'pages.products.rebateRules.action.edit': 'Edit',
  'pages.products.rebateRules.action.delete': 'Delete',
  'pages.products.rebateRules.deleteConfirm': 'Are you sure you want to delete this rebate rule?',
  'pages.products.rebateRules.deleteConfirmYes': 'Yes',
  'pages.products.rebateRules.deleteConfirmNo': 'No',
  'pages.products.rebateRules.deleteSuccess': 'Rebate rule deleted successfully',
  'pages.products.rebateRules.deleteFailed': 'Failed to delete rebate rule',
  'pages.products.rebateRules.updateSuccess': 'Rebate rule updated successfully',
  'pages.products.rebateRules.createSuccess': 'Rebate rule created successfully',
  'pages.products.rebateRules.saveFailed': 'Failed to save rebate rule',
  'pages.products.rebateRules.modal.addTitle': 'Add Rebate Rule',
  'pages.products.rebateRules.modal.editTitle': 'Edit Rebate Rule',
  'pages.products.rebateRules.form.lowerLimit': 'Lower Limit (₩)',
  'pages.products.rebateRules.form.lowerLimitPlaceholder': 'e.g., 0',
  'pages.products.rebateRules.form.lowerLimitRequired': 'Please enter lower limit',
  'pages.products.rebateRules.form.lowerLimitMin': 'Must be 0 or greater',
  'pages.products.rebateRules.form.upperLimit': 'Upper Limit (₩)',
  'pages.products.rebateRules.form.upperLimitPlaceholder': 'e.g., 100000',
  'pages.products.rebateRules.form.upperLimitRequired': 'Please enter upper limit',
  'pages.products.rebateRules.form.upperLimitMin': 'Must be greater than 0',
  'pages.products.rebateRules.form.upperLimitGreater': 'Upper limit must be greater than lower limit',
  'pages.products.rebateRules.form.percentage': 'Rebate Percentage (%)',
  'pages.products.rebateRules.form.percentagePlaceholder': 'e.g., 5',
  'pages.products.rebateRules.form.percentageRequired': 'Please enter percentage',
  'pages.products.rebateRules.form.percentageRange': 'Must be between 0 and 100',
  'pages.products.rebateRules.form.example': 'Example:',
  'pages.products.rebateRules.form.exampleText': 'For purchases between ₩{lower} and ₩{upper}, customers will receive {percentage}% rebate.',

  // Rebate Rules
  'pages.members.rebateRules.title': 'Rebate Rules',
  'pages.members.rebateRules.column.lowerLimit': 'Lower Limit of Price Difference Range',
  'pages.members.rebateRules.column.upperLimit': 'Upper Limit of Price Difference Range',
  'pages.members.rebateRules.column.rebatePercentage': 'GeneralRebate Percentage',
  'pages.members.rebateRules.column.labangRebatePercentage': 'Labang Rebate Percentage',
  'pages.members.rebateRules.column.addTime': 'Add Time',
  'pages.members.rebateRules.column.ruleName': 'Rule Name',
  'pages.members.rebateRules.column.ruleType': 'Rule Type',
  'pages.members.rebateRules.column.targetName': 'Target Name',
  'pages.members.rebateRules.column.rebateRate': 'Rebate Rate',
  'pages.members.rebateRules.column.minOrderAmount': 'Min Order Amount',
  'pages.members.rebateRules.column.maxRebateAmount': 'Max Rebate Amount',
  'pages.members.rebateRules.column.startDate': 'Start Date',
  'pages.members.rebateRules.column.endDate': 'End Date',
  'pages.members.rebateRules.column.isActive': 'Active',
  'pages.members.rebateRules.ruleType.product': 'Product',
  'pages.members.rebateRules.ruleType.category': 'Category',
  'pages.members.rebateRules.ruleType.order': 'Order',
  'pages.members.rebateRules.deleteTitle': 'Delete Rebate Rule',
  'pages.members.rebateRules.deleteConfirm': 'Are you sure you want to delete this rebate rule?',
  'pages.members.rebateRules.deleteSuccess': 'Rebate rule deleted successfully',
  'pages.members.rebateRules.updateSuccess': 'Rebate rule updated successfully',
  'pages.members.rebateRules.createSuccess': 'Rebate rule created successfully',
  'pages.members.rebateRules.modal.addTitle': 'Add Rebate Rule',
  'pages.members.rebateRules.modal.editTitle': 'Edit Rebate Rule',
  'pages.members.rebateRules.form.lowerLimit': 'Lower Limit of Price Difference Range',
  'pages.members.rebateRules.form.lowerLimitPlaceholder': 'Enter lower limit of price difference range',
  'pages.members.rebateRules.form.lowerLimitRequired': 'Please enter lower limit of price difference range',
  'pages.members.rebateRules.form.upperLimit': 'Upper Limit of Price Difference Range',
  'pages.members.rebateRules.form.upperLimitPlaceholder': 'Enter upper limit of price difference range',
  'pages.members.rebateRules.form.upperLimitRequired': 'Please enter upper limit of price difference range',
  'pages.members.rebateRules.form.rebatePercentage': 'Rebate Percentage',
  'pages.members.rebateRules.form.rebatePercentagePlaceholder': 'Enter rebate percentage (%)',
  'pages.members.rebateRules.form.rebatePercentageRequired': 'Please enter rebate percentage',
  'pages.members.rebateRules.form.ruleType': 'Rule Type',
  'pages.members.rebateRules.form.ruleTypePlaceholder': 'Select rule type',
  'pages.members.rebateRules.form.ruleTypeRequired': 'Please select rule type',
  'pages.members.rebateRules.form.ruleName': 'Rule Name',
  'pages.members.rebateRules.form.ruleNamePlaceholder': 'Enter rule name',
  'pages.members.rebateRules.form.targetName': 'Target Name',
  'pages.members.rebateRules.form.targetNamePlaceholder': 'Enter target name',
  'pages.members.rebateRules.form.rebateRate': 'Rebate Rate',
  'pages.members.rebateRules.form.rebateRatePlaceholder': 'Enter rebate rate (%)',
  'pages.members.rebateRules.form.minOrderAmount': 'Min Order Amount',
  'pages.members.rebateRules.form.minOrderAmountPlaceholder': 'Enter minimum order amount (optional)',
  'pages.members.rebateRules.form.maxRebateAmount': 'Max Rebate Amount',
  'pages.members.rebateRules.form.maxRebateAmountPlaceholder': 'Enter maximum rebate amount (optional)',
  'pages.members.rebateRules.form.startDate': 'Start Date',
  'pages.members.rebateRules.form.endDate': 'End Date',
  'pages.members.rebateRules.form.isActive': 'Active',

  // User Promotion Detail
  'pages.members.userPromotionDetail.title': 'Member Referral',
  'pages.members.userPromotionDetail.column.userInfo': 'User Info',
  'pages.members.userPromotionDetail.column.userUniqueId': 'Mailbox',
  'pages.members.userPromotionDetail.column.invitationInfo': 'Invitation Info',
  'pages.members.userPromotionDetail.expand.warehouseAddresses': 'Shipping / warehouse addresses',
  'pages.members.userPromotionDetail.expand.invitedUsers': 'Members invited by this user (sellers excluded)',
  'pages.members.userPromotionDetail.expand.noAddresses': 'No saved addresses.',
  'pages.members.userPromotionDetail.expand.noInvitedUsers': 'No invited general members.',
  'pages.members.userPromotionDetail.expand.inviteeAddresses': 'Invitee addresses',
  'pages.members.userPromotionDetail.column.inviterUid': 'Inviter UID',
  'pages.members.userPromotionDetail.column.numberOfInvitees': 'Number of Invitees',
  'pages.members.userPromotionDetail.column.totalPoints': 'Total Points',
  'pages.members.userPromotionDetail.column.totalPointsWithdrawal': 'Total Points Withdrawal',
  'pages.members.userPromotionDetail.column.remainingPoints': 'Remaining Points',
  'pages.members.userPromotionDetail.column.remainingRebateAmount': 'Remaining Amount of Rebate',
  'pages.members.userPromotionDetail.column.userId': 'User ID',
  'pages.members.userPromotionDetail.column.userName': 'User Name',
  'pages.members.userPromotionDetail.column.email': 'Email',
  'pages.members.userPromotionDetail.column.referralCode': 'Referral Code',
  'pages.members.userPromotionDetail.fetchError': 'Failed to fetch member referral info',
  'pages.members.userPromotionDetail.column.level': 'Level',
  'pages.members.userPromotionDetail.column.rebatePercentage': 'Rebate Percentage',
  'pages.members.userPromotionDetail.column.settingTime': 'Rule Setting Time',
  'pages.members.userPromotionDetail.column.lowerLimit': 'Lower Limit',
  'pages.members.userPromotionDetail.column.upperLimit': 'Upper Limit',
  'pages.members.userPromotionDetail.column.ruleType': 'Rule Type',
  'pages.members.userPromotionDetail.rebateLevel': 'Rebate Level',
  'pages.members.userPromotionDetail.rebateRule': 'Rebate Rule',
  'pages.members.userPromotionDetail.editRebateLevel': 'Edit Rebate Level',
  'pages.members.userPromotionDetail.editRebateRule': 'Edit Rebate Rule',
  'pages.members.userPromotionDetail.rebateLevelManagement': 'Rebate Level Management',
  'pages.members.userPromotionDetail.rebateRuleManagement': 'Rebate Rule Management',
  'pages.members.userPromotionDetail.deleteRebateLevel': 'Delete Rebate Level',
  'pages.members.userPromotionDetail.deleteRebateLevelConfirm': 'Are you sure you want to delete this rebate level?',
  'pages.members.userPromotionDetail.deleteRebateRule': 'Delete Rebate Rule',
  'pages.members.userPromotionDetail.deleteRebateRuleConfirm': 'Are you sure you want to delete this rebate rule?',
  'pages.members.userPromotionDetail.deleteConfirm': 'Are you sure you want to delete?',
  'pages.members.userPromotionDetail.deleteSuccess': 'Deleted successfully',
  'pages.members.userPromotionDetail.updateSuccess': 'Updated successfully',
  'pages.members.userPromotionDetail.createSuccess': 'Created successfully',
  'pages.members.userPromotionDetail.form.level': 'Level',
  'pages.members.userPromotionDetail.form.rebatePercentage': 'Rebate Percentage',
  'pages.members.userPromotionDetail.form.lowerLimit': 'Lower Limit',
  'pages.members.userPromotionDetail.form.upperLimit': 'Upper Limit',
  'pages.members.userPromotionDetail.form.ruleType': 'Rule Type',
  'pages.members.userPromotionDetail.ruleType.priceDifference': 'Price Difference',
  'pages.members.userPromotionDetail.column.promotionType': 'Promotion Type',
  'pages.members.userPromotionDetail.column.promotionName': 'Promotion Name',
  'pages.members.userPromotionDetail.column.promotionCode': 'Promotion Code',
  'pages.members.userPromotionDetail.column.amount': 'Amount',
  'pages.members.userPromotionDetail.column.status': 'Status',
  'pages.members.userPromotionDetail.column.startDate': 'Start Date',
  'pages.members.userPromotionDetail.column.endDate': 'End Date',
  'pages.members.userPromotionDetail.column.usedDate': 'Used Date',
  'pages.members.userPromotionDetail.column.orderNumber': 'Order Number',
  'pages.members.userPromotionDetail.promotionType.rebate': 'Rebate',
  'pages.members.userPromotionDetail.promotionType.discount': 'Discount',
  'pages.members.userPromotionDetail.promotionType.points': 'Points',
  'pages.members.userPromotionDetail.promotionType.coupon': 'Coupon',
  'pages.members.userPromotionDetail.status.active': 'Active',
  'pages.members.userPromotionDetail.status.used': 'Used',
  'pages.members.userPromotionDetail.status.expired': 'Expired',
  'pages.members.userPromotionDetail.status.cancelled': 'Cancelled',

  // Deposit Usage Detailed
  'pages.members.depositUsage.memberName': 'Member Name',
  'pages.members.depositUsage.usageClassification': 'Usage Classification',
  'pages.members.depositUsage.classificationPaymentCost': 'Use payment Cost',
  'pages.members.depositUsage.classificationDepositTopup': 'Deposit top-up',
  'pages.members.depositUsage.classificationAdminAccrual': 'Administrator deposit accrual',
  'pages.members.depositUsage.classificationAdminDeduction': 'Administrator deposit deduction',
  'pages.members.depositUsage.classificationRefund': 'Refund of purchased items',
  'pages.members.depositUsage.content': 'Content',
  'pages.members.depositUsage.amount': 'Usage Amount',
  'pages.members.depositUsage.balance': 'Balance',
  'pages.members.depositUsage.usageDate': 'Usage Date',
  'pages.members.depositUsage.paymentOrderNumber': 'Payment OrderNumber',
  'pages.members.depositUsage.depositPaymentOrderNumber': 'Deposit Payment Order Number',
  'pages.members.depositUsage.usageType': 'Usage Type',
  'pages.members.depositUsage.typeOrder': 'Order',
  'pages.members.depositUsage.typeRefund': 'Refund',
  'pages.members.depositUsage.typeWithdrawal': 'Withdrawal',
  'pages.members.depositUsage.orderNo': 'Order No',
  'pages.members.depositUsage.actions': 'Actions',
  'pages.members.depositUsage.viewDetails': 'View Details',
  'pages.members.depositUsage.totalUsage': 'Total Usage',
  'pages.members.depositUsage.totalAmount': 'Total Amount',
  'pages.members.depositUsage.averageAmount': 'Average Amount',
  'pages.members.depositUsage.descriptionOrder': 'Order Payment',
  'pages.members.depositUsage.mock.companyName': 'Trading Co., Ltd.',
  'pages.members.depositUsage.mock.memberName': 'Hong Gildong',
  'pages.members.depositUsage.mock.paymentContent': 'Order payment related content',
  'pages.members.depositUsage.depositRegistration': 'Deposit Registration',
  'pages.members.depositUsage.memberSearch': 'Member Search',
  'pages.members.depositUsage.searchByMemberId': 'Member ID',
  'pages.members.depositUsage.searchByMemberName': 'Member Name',
  'pages.members.depositUsage.searchRequired': 'Please enter search value',
  'pages.members.depositUsage.searchPlaceholder': 'Search',
  'pages.members.depositUsage.search': 'Search',
  'pages.members.depositUsage.memberSelect': 'Member Select',
  'pages.members.depositUsage.contentRequired': 'Please enter content',
  'pages.members.depositUsage.contentPlaceholder': 'Enter content',
  'pages.members.depositUsage.amountRequired': 'Please enter amount',
  'pages.members.depositUsage.amountMin': 'Amount must be greater than 0',
  'pages.members.depositUsage.amountPlaceholder': '0',
  'pages.members.depositUsage.registrationSuccess': 'Deposit registered successfully',

  // Bankbook Verification Detailed
  'pages.members.bankbookVerification.depositDate': 'Deposit Date',
  'pages.members.bankbookVerification.accountNumber': 'Account Number',
  'pages.members.bankbookVerification.depositor': 'Depositor',
  'pages.members.bankbookVerification.amount': 'Amount',
  'pages.members.bankbookVerification.completionStatus': 'Completion Status',
  'pages.members.bankbookVerification.completed': 'Completed',
  'pages.members.bankbookVerification.notCompleted': 'Not Completed',
  'pages.members.bankbookVerification.status': 'Status',
  'pages.members.bankbookVerification.statusVerified': 'Verified',
  'pages.members.bankbookVerification.statusPending': 'Pending',
  'pages.members.bankbookVerification.statusFailed': 'Failed',
  'pages.members.bankbookVerification.processingDate': 'Processing Date',
  'pages.members.bankbookVerification.memberName': 'Member Name',
  'pages.members.bankbookVerification.bankInfo': 'Bank Information',
  'pages.members.bankbookVerification.autoVerify': 'Auto Verify',
  'pages.members.bankbookVerification.enabled': 'Enabled',
  'pages.members.bankbookVerification.disabled': 'Disabled',
  'pages.members.bankbookVerification.lastVerifiedDate': 'Last Verified Date',
  'pages.members.bankbookVerification.actions': 'Actions',
  'pages.members.bankbookVerification.verify': 'Verify',
  'pages.members.bankbookVerification.autoVerifyUpdated': 'Auto verification for {name} has been {status}',
  'pages.members.bankbookVerification.verificationStarted': 'Starting bankbook verification for {name}',
  'pages.members.bankbookVerification.totalAccounts': 'Total Accounts',
  'pages.members.bankbookVerification.autoVerified': 'Auto Verified',
  'pages.members.bankbookVerification.verified': 'Verified',
  'pages.members.bankbookVerification.failureReasonMismatch': 'Account Information Mismatch',
  'pages.members.bankbookVerification.mock.depositor1': 'Lee Representative',
  'pages.members.bankbookVerification.mock.depositor2': 'Hong Gil-dong',
  'pages.members.bankbookVerification.mock.additionalInfo': 'Additional Information',

  // Forex Deposit Application Detailed
  'pages.members.forexDepositApplication.memberName': 'Member Name',
  'pages.members.forexDepositApplication.depositorCompanyName': 'Depositor Company Name',
  'pages.members.forexDepositApplication.applicationAmountUSD': 'Application Amount ($)',
  'pages.members.forexDepositApplication.usdDepositAmount': 'USD Deposit Amount ($)',
  'pages.members.forexDepositApplication.actualDepositAmountCNY': 'Actual Deposit Amount (¥)',
  'pages.members.forexDepositApplication.feeRatePercent': 'Fee Rate (%)',
  'pages.members.forexDepositApplication.actualFeeCNY': 'Actual Fee (¥)',
  'pages.members.forexDepositApplication.actualRechargeAmountCNY': 'Actual Recharge Amount (¥)',
  'pages.members.forexDepositApplication.remittanceDate': 'Remittance Date',
  'pages.members.forexDepositApplication.completionStatus': 'Completion Status',
  'pages.members.forexDepositApplication.completed': 'Completed',
  'pages.members.forexDepositApplication.notCompleted': 'Not Completed',
  'pages.members.forexDepositApplication.applicationDate': 'Application Date',
  'pages.members.forexDepositApplication.completionDate': 'Completion Date',
  'pages.members.forexDepositApplication.adminDesignatedDate': 'Admin Designated Date',
  'pages.members.forexDepositApplication.smsNotSent': 'SMS Not Sent',
  'pages.members.forexDepositApplication.smsSent': 'SMS Sent',
  'pages.members.forexDepositApplication.memo': 'Notes',
  'pages.members.forexDepositApplication.memoPlaceholder': 'Enter notes',
  'pages.members.forexDepositApplication.memoRegistered': 'Notes have been registered',
  'pages.members.forexDepositApplication.mock.companyName': 'Trading Co., Ltd.',
  'pages.members.forexDepositApplication.mock.memberName': 'Hong Gildong',
  'pages.members.forexDepositApplication.mock.companyNameWithNumber': 'Company Name',
  'pages.members.forexDepositApplication.mock.memo': 'Note content',
  'pages.members.forexDepositApplication.amount': 'Application Amount',
  'pages.members.forexDepositApplication.bankInfo': 'Bank Information',
  'pages.members.forexDepositApplication.status': 'Status',
  'pages.members.forexDepositApplication.statusPending': 'Pending',
  'pages.members.forexDepositApplication.statusApproved': 'Approved',
  'pages.members.forexDepositApplication.statusRejected': 'Rejected',
  'pages.members.forexDepositApplication.actions': 'Actions',
  'pages.members.forexDepositApplication.approve': 'Approve',
  'pages.members.forexDepositApplication.reject': 'Reject',
  'pages.members.forexDepositApplication.viewDetails': 'View Details',
  'pages.members.forexDepositApplication.approveConfirm': 'Approve Foreign Exchange Deposit Application',
  'pages.members.forexDepositApplication.approveContent': 'Do you want to approve {name}\'s foreign exchange deposit application of {amount} {currency}?',
  'pages.members.forexDepositApplication.approved': 'Foreign exchange deposit application has been approved',
  'pages.members.forexDepositApplication.rejectConfirm': 'Reject Foreign Exchange Deposit Application',
  'pages.members.forexDepositApplication.rejectContent': 'Do you want to reject {name}\'s foreign exchange deposit application?',
  'pages.members.forexDepositApplication.rejected': 'Foreign exchange deposit application has been rejected',
  'pages.members.forexDepositApplication.totalApplications': 'Total Applications',
  'pages.members.forexDepositApplication.pendingApplications': 'Pending',
  'pages.members.forexDepositApplication.approvedApplications': 'Approved',
  'pages.members.forexDepositApplication.totalAmount': 'Total Amount',
  'pages.members.forexDepositApplication.exchangeRate': 'Exchange Rate',
  'pages.members.forexDepositApplication.reasonRecharge': 'Foreign Exchange Deposit Recharge',

  // Forex Deposit Usage Detailed
  'pages.members.forexDepositUsage.memberNameWithMailbox': 'Member Name (Mailbox)',
  'pages.members.forexDepositUsage.usageClassification': 'Usage Classification',
  'pages.members.forexDepositUsage.classificationPaymentCost': 'Use payment Cost',
  'pages.members.forexDepositUsage.classificationDepositTopup': 'Deposit top-up',
  'pages.members.forexDepositUsage.classificationAdminAccrual': 'Administrator deposit accrual',
  'pages.members.forexDepositUsage.classificationAdminDeduction': 'Administrator deposit deduction',
  'pages.members.forexDepositUsage.classificationRefund': 'Refund of purchased items',
  'pages.members.forexDepositUsage.content': 'Content',
  'pages.members.forexDepositUsage.paymentNumber': 'Payment Number',
  'pages.members.forexDepositUsage.order1688Number': '1688 Order Number',
  'pages.members.forexDepositUsage.alipayPaymentNumber': 'Alipay Payment Number',
  'pages.members.forexDepositUsage.register': 'Register',
  'pages.members.forexDepositUsage.registered': 'Registered',
  'pages.members.forexDepositUsage.pleaseEnterValue': 'Please enter a value',
  'pages.members.forexDepositUsage.enterOrder1688Number': 'Enter 1688 order number',
  'pages.members.forexDepositUsage.enterAlipayPaymentNumber': 'Enter Alipay payment number',
  'pages.members.forexDepositUsage.depositRegistration': 'Deposit Registration',
  'pages.members.forexDepositUsage.depositChangeExcel': 'Deposit Change Excel',
  'pages.members.forexDepositUsage.depositRefundExcel': 'Deposit Refund Excel',
  'pages.members.forexDepositUsage.paymentCostExcel': 'Payment Cost Usage Excel',
  'pages.members.forexDepositUsage.accumulationDeductionExcel': 'Accumulation/Deduction Excel',
  'pages.members.forexDepositUsage.memberSearch': 'Member Search',
  'pages.members.forexDepositUsage.searchByMemberId': 'Member ID',
  'pages.members.forexDepositUsage.searchByMemberName': 'Member Name',
  'pages.members.forexDepositUsage.searchRequired': 'Please enter search value',
  'pages.members.forexDepositUsage.searchPlaceholder': 'Search',
  'pages.members.forexDepositUsage.search': 'Search',
  'pages.members.forexDepositUsage.memberSelect': 'Member Select',
  'pages.members.forexDepositUsage.contentRequired': 'Please enter content',
  'pages.members.forexDepositUsage.contentPlaceholder': 'Enter content',
  'pages.members.forexDepositUsage.amountRequired': 'Please enter amount',
  'pages.members.forexDepositUsage.amountMin': 'Amount must be greater than 0',
  'pages.members.forexDepositUsage.amountPlaceholder': '0',
  'pages.members.forexDepositUsage.registrationSuccess': 'Deposit registered successfully',
  'pages.members.forexDepositUsage.exportingDepositChange': 'Exporting deposit change...',
  'pages.members.forexDepositUsage.exportingDepositRefund': 'Exporting deposit refund...',
  'pages.members.forexDepositUsage.exportingPaymentCost': 'Exporting payment cost usage...',
  'pages.members.forexDepositUsage.exportingAccumulationDeduction': 'Exporting accumulation/deduction...',
  'pages.members.forexDepositUsage.depositAmountCNY': 'Deposit Amount (¥)',
  'pages.members.forexDepositUsage.remainingDepositCNY': 'Remaining Deposit (¥)',
  'pages.members.forexDepositUsage.usageDate': 'Date',
  'pages.members.forexDepositUsage.adminDesignatedDate': 'Admin Designated Date',
  'pages.members.forexDepositUsage.usageType': 'Usage Type',
  'pages.members.forexDepositUsage.typeOrder': 'Order',
  'pages.members.forexDepositUsage.typeRefund': 'Refund',
  'pages.members.forexDepositUsage.typeWithdrawal': 'Withdrawal',
  'pages.members.forexDepositUsage.orderNo': 'Order No',
  'pages.members.forexDepositUsage.balance': 'Balance',
  'pages.members.forexDepositUsage.actions': 'Actions',
  'pages.members.forexDepositUsage.viewDetails': 'View Details',
  'pages.members.forexDepositUsage.totalUsage': 'Total Usage',
  'pages.members.forexDepositUsage.totalAmount': 'Total Amount',
  'pages.members.forexDepositUsage.averageAmount': 'Average Amount',
  'pages.members.forexDepositUsage.descriptionOrder': 'Order Payment',

  // Forex Deposit Payment Detailed
  'pages.members.forexDepositPayment.memberNameWithMailbox': 'Member Name (Mailbox)',
  'pages.members.forexDepositPayment.applicationClassification': 'Application Classification',
  'pages.members.forexDepositPayment.classificationDeposit': 'Deposit',
  'pages.members.forexDepositPayment.classificationWithdrawal': 'Withdrawal',
  'pages.members.forexDepositPayment.classificationRefund': 'Refund',
  'pages.members.forexDepositPayment.applicationInfo': 'Application Info',
  'pages.members.forexDepositPayment.siteId': 'Site ID',
  'pages.members.forexDepositPayment.request': 'Request',
  'pages.members.forexDepositPayment.enterSiteId': 'Enter Site ID',
  'pages.members.forexDepositPayment.enterRequest': 'Enter Request',
  'pages.members.forexDepositPayment.applicationAmount': 'Application Amount',
  'pages.members.forexDepositPayment.status': 'Status',
  'pages.members.forexDepositPayment.statusCompleted': 'Completed',
  'pages.members.forexDepositPayment.statusPending': 'Pending',
  'pages.members.forexDepositPayment.statusFailed': 'Failed',
  'pages.members.forexDepositPayment.applicationDate': 'Date',
  'pages.members.forexDepositPayment.adminDesignatedDate': 'Admin Designated Date',
  'pages.members.forexDepositPayment.smsNotSent': 'SMS Not Sent',
  'pages.members.forexDepositPayment.smsSent': 'SMS Sent',
  'pages.members.forexDepositPayment.all': 'All',
  'pages.members.forexDepositPayment.progressing': 'Progressing',
  'pages.members.forexDepositPayment.progressingSuccess': 'Progressing completed successfully',
  'pages.members.forexDepositPayment.adminMemo': 'Admin Memo',
  'pages.members.forexDepositPayment.adminMemoPlaceholder': 'Enter admin memo',
  'pages.members.forexDepositPayment.adminMemoRegistered': 'Admin memo has been registered',
  'pages.members.forexDepositPayment.memberName': 'Member Name',
  'pages.members.forexDepositPayment.paymentAmount': 'Payment Amount',
  'pages.members.forexDepositPayment.paymentMethod': 'Payment Method',
  'pages.members.forexDepositPayment.methodBank': 'Bank',
  'pages.members.forexDepositPayment.methodCard': 'Card',
  'pages.members.forexDepositPayment.methodTransfer': 'Transfer',
  'pages.members.forexDepositPayment.paymentStatus': 'Payment Status',
  'pages.members.forexDepositPayment.transactionId': 'Transaction ID',
  'pages.members.forexDepositPayment.paymentDate': 'Payment Date',
  'pages.members.forexDepositPayment.actions': 'Actions',
  'pages.members.forexDepositPayment.viewDetails': 'View Details',
  'pages.members.forexDepositPayment.totalPayments': 'Total Payments',
  'pages.members.forexDepositPayment.completedPayments': 'Completed',
  'pages.members.forexDepositPayment.totalAmount': 'Total Amount',
  'pages.members.forexDepositPayment.totalFee': 'Total Fee',
  'pages.members.forexDepositPayment.exchangeRate': 'Exchange Rate',
  'pages.members.forexDepositPayment.fee': 'Fee',

  // CS Pages
  'pages.cs.banners.description': 'Main banner, popup, and event page management',
  'pages.cs.lookingForOwner.description': 'Looking for Owner management page',

  // Bulletin Board Settings
  'pages.cs.bulletinBoard.title': 'Bulletin Board Setting',
  'pages.cs.bulletinBoard.saveSuccess': 'Settings saved successfully',
  'pages.cs.bulletinBoard.generalSettings': 'General Settings',
  'pages.cs.bulletinBoard.postsPerPage': 'Posts Per Page',
  'pages.cs.bulletinBoard.allowAnonymous': 'Allow Anonymous Posts',
  'pages.cs.bulletinBoard.requireApproval': 'Require Admin Approval',
  'pages.cs.bulletinBoard.attachmentSettings': 'Attachment Settings',
  'pages.cs.bulletinBoard.allowAttachments': 'Allow Attachments',
  'pages.cs.bulletinBoard.maxAttachmentSize': 'Max Attachment Size (MB)',
  'pages.cs.bulletinBoard.allowedFileTypes': 'Allowed File Types',
  'pages.cs.bulletinBoard.commentSettings': 'Comment Settings',
  'pages.cs.bulletinBoard.allowComments': 'Allow Comments',
  'pages.cs.bulletinBoard.notifyOnNewPost': 'Notify Admin on New Post',
  'pages.cs.bulletinBoard.notificationEmail': 'Notification Email',
  'pages.cs.bulletinBoard.save': 'Save Settings',
  'pages.cs.bulletinBoard.reset': 'Reset',
  'pages.cs.bulletinBoard.number': 'No',
  'pages.cs.bulletinBoard.titleColumn': 'Title',
  'pages.cs.bulletinBoard.category': 'Category',
  'pages.cs.bulletinBoard.categoryNotice': 'Notice',
  'pages.cs.bulletinBoard.categoryEvent': 'Event',
  'pages.cs.bulletinBoard.categoryFaq': 'FAQ',
  'pages.cs.bulletinBoard.categoryUpdate': 'Update',
  'pages.cs.bulletinBoard.status': 'Status',
  'pages.cs.bulletinBoard.statusActive': 'Active',
  'pages.cs.bulletinBoard.statusInactive': 'Inactive',
  'pages.cs.bulletinBoard.registrationDate': 'Registration Date',
  'pages.cs.bulletinBoard.views': 'Views',
  'pages.cs.bulletinBoard.actions': 'Actions',
  'pages.cs.bulletinBoard.edit': 'Edit',
  'pages.cs.bulletinBoard.delete': 'Delete',
  'pages.cs.bulletinBoard.add': 'Add',
  'pages.cs.bulletinBoard.addTitle': 'Add Bulletin Board',
  'pages.cs.bulletinBoard.editTitle': 'Edit Bulletin Board',
  'pages.cs.bulletinBoard.deleteConfirm': 'Delete Bulletin Board',
  'pages.cs.bulletinBoard.deleteContent': 'Are you sure you want to delete "{title}"?',
  'pages.cs.bulletinBoard.deleteSuccess': 'Deleted successfully',
  'pages.cs.bulletinBoard.updateSuccess': 'Updated successfully',
  'pages.cs.bulletinBoard.createSuccess': 'Created successfully',
  'pages.cs.bulletinBoard.titleRequired': 'Please enter title',
  'pages.cs.bulletinBoard.titlePlaceholder': 'Enter title',
  'pages.cs.bulletinBoard.categoryRequired': 'Please select category',
  'pages.cs.bulletinBoard.categoryPlaceholder': 'Select category',
  'pages.cs.bulletinBoard.content': 'Content',
  'pages.cs.bulletinBoard.contentRequired': 'Please enter content',
  'pages.cs.bulletinBoard.contentPlaceholder': 'Enter content',
  'pages.cs.bulletinBoard.cancel': 'Cancel',
  'pages.cs.bulletinBoard.type': 'Type',
  'pages.cs.bulletinBoard.typePlaceholder': 'Select type',
  'pages.cs.bulletinBoard.typeGeneral': 'General',
  'pages.cs.bulletinBoard.typeGallery': 'Gallery',
  'pages.cs.bulletinBoard.typeQA': 'Q&A',
  'pages.cs.bulletinBoard.secretPost': 'Secret Post',
  'pages.cs.bulletinBoard.headerPost': 'Header Post',
  'pages.cs.bulletinBoard.statusEnabled': 'Status Enabled',
  'pages.cs.bulletinBoard.writePermission': 'Write Permission',
  'pages.cs.bulletinBoard.viewPermission': 'View Permission',
  'pages.cs.bulletinBoard.commentPermission': 'Comment Permission',
  'pages.cs.bulletinBoard.noticeCount': 'Notice Count',
  'pages.cs.bulletinBoard.enabled': 'Enabled',

  'pages.reviews.title': 'Reviews',
  'pages.reviews.number': 'Number',
  'pages.reviews.author': 'Author',
  'pages.reviews.views': 'Views',
  'pages.reviews.registrationDate': 'Registration Date',
  'pages.reviews.actions': 'Actions',
  'pages.reviews.view': 'View',
  'pages.reviews.edit': 'Edit',
  'pages.reviews.delete': 'Delete',
  'pages.reviews.deleteConfirm': 'Are you sure you want to delete?',
  'pages.reviews.deleted': 'Deleted',
  'pages.reviews.searchSuccess': 'Search completed',
  'pages.reviews.pageSize': 'page',
  'pages.reviews.date': 'Date',
  'pages.reviews.imagesCount': ' ',
  'pages.reviews.memberName': 'Member Name',
  'pages.reviews.memberNamePlaceholder': 'Member Name',
  'pages.reviews.titlePlaceholder': 'Title',
  'pages.reviews.content': 'Content',
  'pages.reviews.contentPlaceholder': 'Content',
  'pages.reviews.postNumber': 'Post Number',
  'pages.reviews.postNumberPlaceholder': 'Post Number',
  'pages.reviews.search': 'Search',
  'pages.reviews.reset': 'Reset',
  'pages.reviews.write': 'Write Post',
  'pages.reviews.totalCount': 'total count',
  'pages.reviews.page': 'page',
  'pages.reviews.total': 'total',
  'pages.reviews.viewDetail': 'View Detail',
  'pages.reviews.titleRequired': 'Please enter title',
  'pages.reviews.contentRequired': 'Please enter content',
  'pages.reviews.isNotice': 'Is it a notice post?',
  'pages.reviews.attachments': 'Multiple attached files',
  'pages.reviews.attachments.count': 'files',
  'pages.reviews.sequenceNumber': 'Sequence Number',
  'pages.reviews.complaintType': 'Complaint Type',
  'pages.reviews.complaintType.complaint': 'Complaint',
  'pages.reviews.complaintType.suggestion': 'Suggestion',
  'pages.reviews.memberNumber': 'Member Number',
  'pages.reviews.orderNumber': 'Order Number',
  'pages.reviews.subOrderNumber': 'Sub Order Number',
  'pages.reviews.processingStatus': 'Processing Status',
  'pages.reviews.processingStatus.unconfirmed': 'Unconfirmed',
  'pages.reviews.processingStatus.processed': 'Processed',
  'pages.reviews.updatedAt': 'Last Updated Time',
  'pages.reviews.maxFiles': 'Maximum quantity : 5 files',
  'pages.reviews.maxFileSize': 'Maximum size per file : 3MB',
  'pages.reviews.chooseFiles': 'Choose files',
  'pages.reviews.cancel': 'Cancel',
  'pages.reviews.save': 'Save',
  'pages.reviews.createSuccess': 'Saved successfully',
  'pages.reviews.updateSuccess': 'Updated successfully',
  'pages.reviews.detail': 'Detail',
  'pages.reviews.postInfo': 'Post Information',
  'pages.reviews.list': 'List',
  'pages.reviews.policyWarning': 'If you post content that violates operating policies such as profanity, spamming, slander, or rumors, you may receive disadvantages such as restrictions on writing.',
  'pages.reviews.comments': 'Comments',
  'pages.reviews.commentPlaceholder': 'Hello. This is Today Jikgu.',
  'pages.reviews.writeComment': 'Write Comment',
  'pages.reviews.commentRequired': 'Please enter a comment',
  'pages.reviews.commentSubmitted': 'Comment has been submitted',
  'pages.reviews.totalComments': 'Total',
  'pages.reviews.commentsCount': 'comments',
  'pages.reviews.noComments': 'No comments yet.',
  'pages.reviews.filter': 'Search Filter',

  // Inquiries Page
  'pages.cs.inquiries.title': '1:1 Inquiries Management',
  'pages.cs.inquiries.stats.total': 'Total Inquiries',
  'pages.cs.inquiries.stats.pending': 'Pending',
  'pages.cs.inquiries.stats.answered': 'Answered',
  'pages.cs.inquiries.stats.avgResponseTime': 'Average Response Time',
  'pages.cs.inquiries.stats.hours': 'hours',
  'pages.cs.inquiries.list': 'Inquiry List',
  'pages.cs.inquiries.export': 'Export to Excel',
  'pages.cs.inquiries.exportSuccess': 'Excel export completed successfully',
  'pages.cs.inquiries.id': 'ID',
  'pages.cs.inquiries.number': 'Number',
  'pages.cs.inquiries.author': 'Author',
  'pages.cs.inquiries.views': 'Views',
  'pages.cs.inquiries.memberInfo': 'Member Info',
  'pages.cs.inquiries.category': 'Category',
  'pages.cs.inquiries.category.order': 'Order Inquiry',
  'pages.cs.inquiries.category.product': 'Product Inquiry',
  'pages.cs.inquiries.category.delivery': 'Delivery Inquiry',
  'pages.cs.inquiries.category.payment': 'Payment Inquiry',
  'pages.cs.inquiries.category.etc': 'Others',
  'pages.cs.inquiries.fieldTitle': 'Title',
  'pages.cs.inquiries.priority': 'Priority',
  'pages.cs.inquiries.priority.high': 'High',
  'pages.cs.inquiries.priority.normal': 'Normal',
  'pages.cs.inquiries.priority.low': 'Low',
  'pages.cs.inquiries.status': 'Status',
  'pages.cs.inquiries.status.pending': 'Pending',
  'pages.cs.inquiries.status.answered': 'Answered',
  'pages.cs.inquiries.status.closed': 'Closed',
  'pages.cs.inquiries.createdAt': 'Registration Date',
  'pages.cs.inquiries.answeredAt': 'Answer Date',
  'pages.cs.inquiries.actions': 'Actions',
  'pages.cs.inquiries.viewDetail': 'Detail',
  'pages.cs.inquiries.answer': 'Answer',
  'pages.cs.inquiries.detailTitle': 'Inquiry Detail',
  'pages.cs.inquiries.close': 'Close',
  'pages.cs.inquiries.answerButton': 'Answer',
  'pages.cs.inquiries.inquiryContent': 'Inquiry Content',
  'pages.cs.inquiries.inquiryId': 'Inquiry ID',
  'pages.cs.inquiries.memberName': 'Member Name',
  'pages.cs.inquiries.memberId': 'Member ID',
  'pages.cs.inquiries.answerer': 'Answerer',
  'pages.cs.inquiries.answerContent': 'Answer',
  'pages.cs.inquiries.answerTitle': 'Write Answer',
  'pages.cs.inquiries.answerContentField': 'Answer Content',
  'pages.cs.inquiries.answerContentPlaceholder': 'Please enter the answer content',
  'pages.cs.inquiries.submit': 'Submit',
  'pages.cs.inquiries.cancel': 'Cancel',
  'pages.cs.inquiries.answerSuccess': 'Answer has been registered',
  'pages.cs.inquiries.tab.all': 'All',
  'pages.cs.inquiries.tab.inProgress': 'In Progress',
  'pages.cs.inquiries.tab.answered': 'Answered',
  'pages.cs.inquiries.tab.onHold': 'On Hold',
  'pages.cs.inquiries.isHeader': 'Header Post',
  'pages.cs.inquiries.content': 'Content',
  'pages.cs.inquiries.addTitle': 'Add Inquiry',
  'pages.cs.inquiries.addSuccess': 'Inquiry added successfully',
  'pages.cs.inquiries.addError': 'Failed to add inquiry',
  'pages.cs.inquiries.secret': 'Secret',
  'pages.cs.inquiries.selectCategory': 'Select Category',
  'pages.cs.inquiries.contentPlaceholder': 'Enter content',
  'pages.cs.inquiries.attachments': 'Multiple Attachments',
  'pages.cs.inquiries.attachmentInfo': 'Maximum 5 files, 5MB each',
  'pages.cs.inquiries.loadError': 'Failed to load inquiry',
  'pages.cs.inquiries.deleteSuccess': 'Inquiry deleted successfully',
  'pages.cs.inquiries.deleteError': 'Failed to delete inquiry',
  'pages.cs.inquiries.deleteConfirm': 'Are you sure you want to delete?',
  'pages.cs.inquiries.notFound': 'Inquiry not found',
  'pages.cs.inquiries.replySection': 'Reply',
  'pages.cs.inquiries.replyRequired': 'Please enter reply content',
  'pages.cs.inquiries.replySuccess': 'Reply posted successfully',
  'pages.cs.inquiries.replyError': 'Failed to post reply',
  'pages.cs.inquiries.replyPlaceholder': 'Enter reply content',
  'pages.cs.inquiries.replyNote': 'Sensitive information such as lists, domains, passwords are prohibited',
  'pages.cs.inquiries.smsNotification': 'SMS Notification',
  'pages.cs.inquiries.noNotification': 'No Notification',
  'pages.cs.inquiries.reply': 'Reply',

  // CS - Danger Management
  'pages.cs.dangerManagement.title': 'Danger Management',
  'pages.cs.dangerManagement.addTitle': 'Add Danger Term',
  'pages.cs.dangerManagement.editTitle': 'Edit Danger Term',
  'pages.cs.dangerManagement.deleteConfirm': 'Delete Danger Term',
  'pages.cs.dangerManagement.deleteConfirmContent': 'Are you sure you want to delete danger term "{term}"?',
  'pages.cs.dangerManagement.deleteSuccess': 'Danger term deleted successfully',
  'pages.cs.dangerManagement.updateSuccess': 'Danger term updated successfully',
  'pages.cs.dangerManagement.createSuccess': 'Danger term created successfully',
  'pages.cs.dangerManagement.submitError': 'Error saving danger term',
  'pages.cs.dangerManagement.fetchError': 'Failed to load dangerous keywords',
  'pages.cs.dangerManagement.deleteError': 'Failed to delete dangerous keyword',
  'pages.cs.dangerManagement.duplicateError': 'Dangerous keyword already exists',
  'pages.cs.dangerManagement.validationError': 'Validation error',
  'pages.cs.dangerManagement.form.termLength': 'Term must be between 1 and 200 characters',
  'pages.cs.dangerManagement.column.id': 'ID',
  'pages.cs.dangerManagement.column.term': 'Term',
  'pages.cs.dangerManagement.column.category': 'Category',
  'pages.cs.dangerManagement.column.severity': 'Severity',
  'pages.cs.dangerManagement.column.action': 'Action',
  'pages.cs.dangerManagement.column.description': 'Description',
  'pages.cs.dangerManagement.column.isActive': 'Active',
  'pages.cs.dangerManagement.category.prohibited': 'Prohibited',
  'pages.cs.dangerManagement.category.restricted': 'Restricted',
  'pages.cs.dangerManagement.category.sensitive': 'Sensitive',
  'pages.cs.dangerManagement.severity.high': 'High',
  'pages.cs.dangerManagement.severity.medium': 'Medium',
  'pages.cs.dangerManagement.severity.low': 'Low',
  'pages.cs.dangerManagement.action.block': 'Block',
  'pages.cs.dangerManagement.action.warn': 'Warn',
  'pages.cs.dangerManagement.action.review': 'Review',
  'pages.cs.dangerManagement.form.term': 'Term',
  'pages.cs.dangerManagement.form.termRequired': 'Please enter term',
  'pages.cs.dangerManagement.form.atLeastOneLang': 'At least one language required (English, Chinese, or Korean)',
  'pages.cs.dangerManagement.translate': 'Translate',
  'pages.cs.dangerManagement.translateSuccess': 'Translation completed',
  'pages.cs.dangerManagement.translateError': 'Translation failed',
  'pages.cs.dangerManagement.form.category': 'Category',
  'pages.cs.dangerManagement.form.categoryRequired': 'Please select category',
  'pages.cs.dangerManagement.form.severity': 'Severity',
  'pages.cs.dangerManagement.form.severityRequired': 'Please select severity',
  'pages.cs.dangerManagement.form.action': 'Action',
  'pages.cs.dangerManagement.form.actionRequired': 'Please select action',
  'pages.cs.dangerManagement.form.description': 'Description',
  'pages.cs.dangerManagement.form.isActive': 'Active',

  // CS - Edit Search Term
  'pages.cs.editSearchTerm.title': 'Edit Search Term',
  'pages.cs.editSearchTerm.addTitle': 'Add Search Term',
  'pages.cs.editSearchTerm.editTitle': 'Edit Search Term',
  'pages.cs.editSearchTerm.deleteConfirm': 'Delete Search Term',
  'pages.cs.editSearchTerm.deleteConfirmContent': 'Are you sure you want to delete search term "{term}"?',
  'pages.cs.editSearchTerm.deleteSuccess': 'Search term deleted successfully',
  'pages.cs.editSearchTerm.updateSuccess': 'Search term updated successfully',
  'pages.cs.editSearchTerm.createSuccess': 'Search term created successfully',
  'pages.cs.editSearchTerm.submitError': 'Error saving search term',
  'pages.cs.editSearchTerm.fetchError': 'Failed to load search terms',
  'pages.cs.editSearchTerm.deleteError': 'Failed to delete search term',
  'pages.cs.editSearchTerm.createError': 'Failed to create search term',
  'pages.cs.editSearchTerm.updateError': 'Failed to update search term',
  'pages.cs.editSearchTerm.column.id': 'ID',
  'pages.cs.editSearchTerm.column.term': 'Search Term',
  'pages.cs.editSearchTerm.column.category': 'Category',
  'pages.cs.editSearchTerm.column.priority': 'Priority',
  'pages.cs.editSearchTerm.column.synonyms': 'Synonyms',
  'pages.cs.editSearchTerm.column.relatedTerms': 'Related Terms',
  'pages.cs.editSearchTerm.column.searchCount': 'Search Count',
  'pages.cs.editSearchTerm.column.isActive': 'Active',
  'pages.cs.editSearchTerm.column.correctTerm': 'Correct Term',
  'pages.cs.editSearchTerm.form.term': 'Search Term',
  'pages.cs.editSearchTerm.form.termRequired': 'Please enter search term',
  'pages.cs.editSearchTerm.form.atLeastOneLang': 'At least one language required (English, Chinese, or Korean)',
  'pages.cs.editSearchTerm.translate': 'Translate',
  'pages.cs.editSearchTerm.translateSuccess': 'Translation completed',
  'pages.cs.editSearchTerm.translateError': 'Translation failed',
  'pages.cs.editSearchTerm.form.correctTerm': 'Correct Term',
  'pages.cs.editSearchTerm.form.correctTermRequired': 'Please enter correct term',
  'pages.cs.editSearchTerm.form.isActive': 'Active',
  'pages.cs.editSearchTerm.form.category': 'Category',
  'pages.cs.editSearchTerm.form.categoryRequired': 'Please enter category',
  'pages.cs.editSearchTerm.form.priority': 'Priority',
  'pages.cs.editSearchTerm.form.priorityRequired': 'Please enter priority',
  'pages.cs.editSearchTerm.form.synonyms': 'Synonyms',
  'pages.cs.editSearchTerm.form.synonymsTooltip': 'Enter comma-separated values',
  'pages.cs.editSearchTerm.form.synonymsPlaceholder': 'e.g., mobile phone, cell phone',
  'pages.cs.editSearchTerm.form.relatedTerms': 'Related Terms',
  'pages.cs.editSearchTerm.form.relatedTermsTooltip': 'Enter comma-separated values',
  'pages.cs.editSearchTerm.form.relatedTermsPlaceholder': 'e.g., case, screen protector',

  // CS - Suggestion
  'pages.cs.suggestion.title': 'Platform Review',
  'pages.cs.suggestion.list': 'Suggestion List',
  'pages.cs.suggestion.detailTitle': 'Suggestion Detail',
  'pages.cs.suggestion.responseTitle': 'Respond to Suggestion',
  'pages.cs.suggestion.column.sequenceNumber': 'No.',
  'pages.cs.suggestion.column.category': 'Category',
  'pages.cs.suggestion.column.title': 'Title',
  'pages.cs.suggestion.column.content': 'Content',
  'pages.cs.suggestion.column.userName': 'Author',
  'pages.cs.suggestion.column.email': 'Email',
  'pages.cs.suggestion.column.status': 'Status',
  'pages.cs.suggestion.column.createdAt': 'Created Date',
  'pages.cs.suggestion.column.actions': 'Actions',
  'pages.cs.suggestion.category.feature': 'Feature Request',
  'pages.cs.suggestion.category.improvement': 'Improvement',
  'pages.cs.suggestion.category.bug': 'Bug Report',
  'pages.cs.suggestion.category.other': 'Other',
  'pages.cs.suggestion.status.pending': 'Pending',
  'pages.cs.suggestion.status.reviewing': 'Reviewing',
  'pages.cs.suggestion.status.accepted': 'Accepted',
  'pages.cs.suggestion.status.rejected': 'Rejected',
  'pages.cs.suggestion.status.completed': 'Completed',
  'pages.cs.suggestion.action.view': 'View',
  'pages.cs.suggestion.action.respond': 'Respond',
  'pages.cs.suggestion.action.delete': 'Delete',
  'pages.cs.suggestion.deleteConfirm': 'Are you sure you want to delete?',
  'pages.cs.suggestion.deleteSuccess': 'Deleted successfully',
  'pages.cs.suggestion.responseSuccess': 'Response saved successfully',
  'pages.cs.suggestion.adminResponse': 'Admin Response',
  'pages.cs.suggestion.respondedBy': 'Responded By',
  'pages.cs.suggestion.close': 'Close',
  'pages.cs.suggestion.submit': 'Save',
  'pages.cs.suggestion.cancel': 'Cancel',
  'pages.cs.suggestion.form.status': 'Status',
  'pages.cs.suggestion.form.statusRequired': 'Please select status',
  'pages.cs.suggestion.form.response': 'Response Content',
  'pages.cs.suggestion.form.responseRequired': 'Please enter response content',
  'pages.cs.suggestion.form.responsePlaceholder': 'Enter the response to send to the user',

  // Suggestion Header Options
  'pages.cs.suggestion.header.shippingAgency': 'Shipping Agency',
  'pages.cs.suggestion.header.purchaseAgency': 'Purchase Agency',
  'pages.cs.suggestion.header.payment': 'Payment',
  'pages.cs.suggestion.header.deposit': 'Deposit',
  'pages.cs.suggestion.header.etc': 'Etc',

  // CS - Email Template
  'pages.cs.emailTemplate.title': 'Email Template',
  'pages.cs.emailTemplate.addTitle': 'Add Email Template',
  'pages.cs.emailTemplate.editTitle': 'Edit Email Template',
  'pages.cs.emailTemplate.deleteConfirm': 'Delete Email Template',
  'pages.cs.emailTemplate.deleteConfirmContent': 'Are you sure you want to delete email template "{name}"?',
  'pages.cs.emailTemplate.deleteSuccess': 'Email template deleted successfully',
  'pages.cs.emailTemplate.updateSuccess': 'Email template updated successfully',
  'pages.cs.emailTemplate.createSuccess': 'Email template created successfully',
  'pages.cs.emailTemplate.submitError': 'Error saving email template',
  'pages.cs.emailTemplate.previewTitle': 'Email Template Preview',
  'pages.cs.emailTemplate.column.name': 'Template Name',
  'pages.cs.emailTemplate.column.subject': 'Subject',
  'pages.cs.emailTemplate.column.category': 'Category',
  'pages.cs.emailTemplate.column.variables': 'Variables',
  'pages.cs.emailTemplate.column.isActive': 'Active',
  'pages.cs.emailTemplate.category.notification': 'Notification',
  'pages.cs.emailTemplate.category.marketing': 'Marketing',
  'pages.cs.emailTemplate.category.transactional': 'Transactional',
  'pages.cs.emailTemplate.category.system': 'System',
  'pages.cs.emailTemplate.form.name': 'Template Name',
  'pages.cs.emailTemplate.form.nameRequired': 'Please enter template name',
  'pages.cs.emailTemplate.form.category': 'Category',
  'pages.cs.emailTemplate.form.categoryRequired': 'Please select category',
  'pages.cs.emailTemplate.form.subject': 'Subject',
  'pages.cs.emailTemplate.form.subjectRequired': 'Please enter subject',
  'pages.cs.emailTemplate.form.subjectPlaceholder': 'Enter email subject',
  'pages.cs.emailTemplate.form.content': 'Content',
  'pages.cs.emailTemplate.form.contentRequired': 'Please enter content',
  'pages.cs.emailTemplate.form.contentTooltip': 'Use variables in {variableName} format (e.g., {userName}, {orderNo})',
  'pages.cs.emailTemplate.form.contentPlaceholder': 'Enter email content. Use variables in {variableName} format',
  'pages.cs.emailTemplate.form.isActive': 'Active',

  // CS - SMS Template
  'pages.cs.smsTemplate.title': 'SMS Template',
  'pages.cs.smsTemplate.addTitle': 'Add SMS Template',
  'pages.cs.smsTemplate.editTitle': 'Edit SMS Template',
  'pages.cs.smsTemplate.deleteConfirm': 'Delete SMS Template',
  'pages.cs.smsTemplate.deleteConfirmContent': 'Are you sure you want to delete SMS template "{name}"?',
  'pages.cs.smsTemplate.deleteSuccess': 'SMS template deleted successfully',
  'pages.cs.smsTemplate.updateSuccess': 'SMS template updated successfully',
  'pages.cs.smsTemplate.createSuccess': 'SMS template created successfully',
  'pages.cs.smsTemplate.submitError': 'Error saving SMS template',
  'pages.cs.smsTemplate.previewTitle': 'SMS Template Preview',
  'pages.cs.smsTemplate.column.name': 'Template Name',
  'pages.cs.smsTemplate.column.category': 'Category',
  'pages.cs.smsTemplate.column.content': 'Content',
  'pages.cs.smsTemplate.column.variables': 'Variables',
  'pages.cs.smsTemplate.column.isActive': 'Active',
  'pages.cs.smsTemplate.category.notification': 'Notification',
  'pages.cs.smsTemplate.category.marketing': 'Marketing',
  'pages.cs.smsTemplate.category.transactional': 'Transactional',
  'pages.cs.smsTemplate.category.system': 'System',
  'pages.cs.smsTemplate.form.name': 'Template Name',
  'pages.cs.smsTemplate.form.nameRequired': 'Please enter template name',
  'pages.cs.smsTemplate.form.category': 'Category',
  'pages.cs.smsTemplate.form.categoryRequired': 'Please select category',
  'pages.cs.smsTemplate.form.content': 'Content',
  'pages.cs.smsTemplate.form.contentRequired': 'Please enter content',
  'pages.cs.smsTemplate.form.contentTooltip': 'Use variables in {variableName} format. Maximum 90 characters',
  'pages.cs.smsTemplate.form.contentPlaceholder': 'Enter SMS content. Use variables in {variableName} format',
  'pages.cs.smsTemplate.form.isActive': 'Active',

  // CS - Email Log
  'pages.cs.emailLog.title': 'Email Log',
  'pages.cs.emailLog.detailTitle': 'Email Log Detail',
  'pages.cs.emailLog.column.templateName': 'Template Name',
  'pages.cs.emailLog.column.recipient': 'Recipient',
  'pages.cs.emailLog.column.subject': 'Subject',
  'pages.cs.emailLog.column.status': 'Status',
  'pages.cs.emailLog.column.sentAt': 'Sent At',
  'pages.cs.emailLog.column.errorMessage': 'Error Message',
  'pages.cs.emailLog.status.sent': 'Sent',
  'pages.cs.emailLog.status.failed': 'Failed',
  'pages.cs.emailLog.status.pending': 'Pending',
  'pages.cs.emailLog.detail.templateName': 'Template Name',
  'pages.cs.emailLog.detail.recipient': 'Recipient',
  'pages.cs.emailLog.detail.subject': 'Subject',
  'pages.cs.emailLog.detail.status': 'Status',
  'pages.cs.emailLog.detail.sentAt': 'Sent At',
  'pages.cs.emailLog.detail.failedAt': 'Failed At',
  'pages.cs.emailLog.detail.errorMessage': 'Error Message',
  'pages.cs.emailLog.detail.createdAt': 'Created At',

  // CS - Push Message
  'pages.cs.pushMessage.title': 'Push Message',
  'pages.cs.pushMessage.addTitle': 'Add Push Message',
  'pages.cs.pushMessage.editTitle': 'Edit Push Message',
  'pages.cs.pushMessage.deleteConfirm': 'Delete Push Message',
  'pages.cs.pushMessage.deleteConfirmContent': 'Are you sure you want to delete push message "{title}"?',
  'pages.cs.pushMessage.deleteSuccess': 'Push message deleted successfully',
  'pages.cs.pushMessage.updateSuccess': 'Push message updated successfully',
  'pages.cs.pushMessage.createSuccess': 'Push message created successfully',
  'pages.cs.pushMessage.submitError': 'Error saving push message',
  'pages.cs.pushMessage.send': 'Send',
  'pages.cs.pushMessage.sendSuccess': 'Push message sent successfully',
  'pages.cs.pushMessage.column.title': 'Title',
  'pages.cs.pushMessage.column.content': 'Content',
  'pages.cs.pushMessage.column.targetType': 'Target',
  'pages.cs.pushMessage.column.sendType': 'Send Type',
  'pages.cs.pushMessage.column.status': 'Status',
  'pages.cs.pushMessage.column.sentCount': 'Sent Count',
  'pages.cs.pushMessage.column.readCount': 'Read Count',
  'pages.cs.pushMessage.column.scheduledAt': 'Scheduled At',
  'pages.cs.pushMessage.targetType.all': 'All',
  'pages.cs.pushMessage.targetType.specific': 'Specific Users',
  'pages.cs.pushMessage.targetType.segment': 'Segment',
  'pages.cs.pushMessage.sendType.immediate': 'Immediate',
  'pages.cs.pushMessage.sendType.scheduled': 'Scheduled',
  'pages.cs.pushMessage.status.draft': 'Draft',
  'pages.cs.pushMessage.status.scheduled': 'Scheduled',
  'pages.cs.pushMessage.status.sent': 'Sent',
  'pages.cs.pushMessage.status.failed': 'Failed',
  'pages.cs.pushMessage.form.title': 'Title',
  'pages.cs.pushMessage.form.titleRequired': 'Please enter title',
  'pages.cs.pushMessage.form.content': 'Content',
  'pages.cs.pushMessage.form.contentRequired': 'Please enter content',
  'pages.cs.pushMessage.form.targetType': 'Target',
  'pages.cs.pushMessage.form.targetTypeRequired': 'Please select target',
  'pages.cs.pushMessage.form.sendType': 'Send Type',
  'pages.cs.pushMessage.form.sendTypeRequired': 'Please select send type',
  'pages.cs.pushMessage.form.scheduledAt': 'Scheduled At',
  'pages.cs.pushMessage.form.scheduledAtRequired': 'Please select scheduled time',
  'pages.cs.inquiries.stats.open': 'Open',
  'pages.cs.inquiries.stats.closed': 'Closed',
  'pages.cs.inquiries.stats.resolved': 'Resolved',
  'pages.cs.inquiries.user': 'User',
  'pages.cs.inquiries.subject': 'Subject',
  'pages.cs.inquiries.subjectEmpty': '(No Subject)',
  'pages.cs.inquiries.assignedAdmin': 'Assigned Admin',
  'pages.cs.inquiries.unassigned': 'Unassigned',
  
  // Inquiry Header Options
  'pages.cs.inquiries.header.shippingAgency': 'Shipping Agency',
  'pages.cs.inquiries.header.purchaseAgency': 'Purchase Agency',
  'pages.cs.inquiries.header.payment': 'Payment',
  'pages.cs.inquiries.header.deposit': 'Deposit',
  'pages.cs.inquiries.header.etc': 'Etc',
  'pages.cs.inquiries.header.ttIdApplication': 'TT ID Application',
  'pages.cs.inquiries.status.unconfirmed': 'Unconfirmed',
  'pages.cs.inquiries.status.in_progress': 'In Progress',
  'pages.cs.inquiries.status.confirmed': 'Confirmed',
  'pages.cs.inquiries.messageCount': 'Message Count',
  'pages.cs.inquiries.createdDate': 'Created Date',
  'pages.cs.inquiries.lastMessage': 'Last Message',
  'pages.cs.inquiries.viewChat': 'View Chat',
  'pages.cs.inquiries.assign': 'Assign',
  'pages.cs.inquiries.listTitle': '1:1 Inquiries List',
  'pages.cs.inquiries.chatTitle': '1:1 Inquiry Chat',
  'pages.cs.inquiries.assignToMe': 'Assign to Me',
  'pages.cs.inquiries.admin': 'Admin',
  'pages.cs.inquiries.userLabel': 'User',
  'pages.cs.inquiries.noMessages': 'No messages.',
  'pages.cs.inquiries.messageRequired': 'Please enter a message',
  'pages.cs.inquiries.messagePlaceholder': 'Enter message...',
  'pages.cs.inquiries.send': 'Send',
  'pages.cs.inquiries.reopen': 'Reopen',
  'pages.cs.inquiries.assignSuccess': 'Inquiry has been assigned.',
  'pages.cs.inquiries.assignError': 'Failed to assign inquiry.',
  'pages.cs.inquiries.sendSuccess': 'Message has been sent.',
  'pages.cs.inquiries.sendError': 'Failed to send message.',
  'pages.cs.inquiries.userLoadError': 'Failed to load user information.',
  'pages.cs.inquiries.attachFile': 'Attach File',
  'pages.cs.inquiries.uploadError': 'Failed to upload files.',
  'pages.cs.inquiries.fileSizeLimit': 'File size must be less than 10MB.',
  'pages.cs.inquiries.closeSuccess': 'Inquiry has been closed.',
  'pages.cs.inquiries.closeError': 'Failed to close inquiry.',
  'pages.cs.inquiries.processingButton': 'Processing',
  'pages.cs.inquiries.confirmButton': 'Confirm',
  'pages.cs.inquiries.processingStarted': 'Processing started.',
  'pages.cs.inquiries.confirmedSuccess': 'Confirmed.',
  'pages.cs.inquiries.processingError': 'Failed to start processing.',
  'pages.cs.inquiries.confirmError': 'Failed to confirm.',
  'pages.cs.inquiries.attachmentPlaceholder': '[Attachment]',
  'pages.cs.inquiries.reopenSuccess': 'Inquiry has been reopened.',
  'pages.cs.inquiries.category.general': 'General',
  'pages.cs.inquiries.category.support': 'Support',
  'pages.cs.inquiries.category.complaint': 'Complaint',
  'pages.cs.inquiries.category.suggestion': 'Suggestion',
  'pages.cs.inquiries.category.technical': 'Technical',
  'pages.cs.inquiries.unreadMessages': '{count} unread messages',
  'pages.cs.inquiries.messageRead': 'Read',

  // Notices Page
  'pages.cs.notices.stats.total': 'Total Notices',
  'pages.cs.notices.stats.published': 'Published',
  'pages.cs.notices.stats.draft': 'Draft',
  'pages.cs.notices.stats.hidden': 'Hidden',
  'pages.cs.notices.list': 'Notice List',
  'pages.cs.notices.add': 'Create Notice',
  'pages.cs.notices.export': 'Export to Excel',
  'pages.cs.notices.id': 'ID',
  'pages.cs.notices.title': 'Title',
  'pages.cs.notices.category': 'Category',
  'pages.cs.notices.category.general': 'General',
  'pages.cs.notices.category.important': 'Important',
  'pages.cs.notices.category.event': 'Event',
  'pages.cs.notices.category.maintenance': 'Maintenance',
  'pages.cs.notices.status': 'Status',
  'pages.cs.notices.status.published': 'Published',
  'pages.cs.notices.status.draft': 'Draft',
  'pages.cs.notices.status.hidden': 'Hidden',
  'pages.cs.notices.priority': 'Priority',
  'pages.cs.notices.priority.high': 'High',
  'pages.cs.notices.priority.normal': 'Normal',
  'pages.cs.notices.priority.low': 'Low',
  'pages.cs.notices.views': 'Views',
  'pages.cs.notices.author': 'Author',
  'pages.cs.notices.createdAt': 'Created At',
  'pages.cs.notices.create': 'Create',
  'pages.cs.notices.actions': 'Actions',
  'pages.cs.notices.viewDetail': 'Detail',
  'pages.cs.notices.edit': 'Edit',
  'pages.cs.notices.delete': 'Delete',
  'pages.cs.notices.deleteConfirm': 'Are you sure you want to delete?',
  'pages.cs.notices.detailTitle': 'Notice Detail',
  'pages.cs.notices.content': 'Content',
  'pages.cs.notices.updatedAt': 'Updated At',
  'pages.cs.notices.publishAt': 'Published At',
  'pages.cs.notices.tags': 'Tags',
  'pages.cs.notices.editTitle': 'Edit Notice',
  'pages.cs.notices.createTitle': 'Create Notice',
  'pages.cs.notices.titlePlaceholder': 'Enter notice title',
  'pages.cs.notices.contentPlaceholder': 'Enter notice content',
  'pages.cs.notices.titleRequired': 'Please enter title',
  'pages.cs.notices.contentRequired': 'Please enter content',
  'pages.cs.notices.updateSuccess': 'Notice has been updated',
  'pages.cs.notices.createSuccess': 'Notice has been created',
  'pages.cs.notices.deleteSuccess': 'Notice has been deleted',
  'pages.cs.notices.close': 'Close',
  'pages.cs.notices.cancel': 'Cancel',
  'pages.cs.notices.broadcastCreated': 'A new notice has been created',
  'pages.cs.notices.broadcastDeleted': 'Notice has been deleted',
  'pages.cs.notices.deleteFailed': 'Failed to delete',
  'pages.cs.notices.updateFailed': 'Failed to update',
  'pages.cs.notices.createFailed': 'Failed to create',
  'pages.cs.notices.loadFailed': 'Failed to load notices',
  'pages.cs.notices.number': 'Number',
  'pages.cs.notices.fieldTitle': 'Title',
  'pages.cs.notices.isHeader': 'Header Post',
  'pages.cs.notices.tab.all': 'All',
  'pages.cs.notices.exportSuccess': 'Excel export completed successfully',
  'pages.cs.notices.addTitle': 'Add Notice',
  'pages.cs.notices.addSuccess': 'Notice added successfully',
  'pages.cs.notices.addError': 'Failed to add notice',
  'pages.cs.notices.secret': 'Secret',
  'pages.cs.notices.selectCategory': 'Select Category',
  'pages.cs.notices.attachments': 'Multiple Attachments',
  'pages.cs.notices.attachmentInfo': 'Maximum 5 files, 5MB each',
  'pages.cs.notices.loadError': 'Failed to load notice',
  'pages.cs.notices.deleteError': 'Failed to delete notice',
  'pages.cs.notices.notFound': 'Notice not found',
  'pages.cs.notices.submit': 'Submit',
  'pages.cs.notices.category.order': 'Order',
  'pages.cs.notices.category.product': 'Product',
  'pages.cs.notices.category.delivery': 'Delivery',
  'pages.cs.notices.category.payment': 'Payment',
  'pages.cs.notices.category.etc': 'Others',
  
  // Notices Header Options
  'pages.cs.notices.header.joinMembership': 'Join the membership',
  'pages.cs.notices.header.applyShippingAgency': 'Apply for shipping agency',
  'pages.cs.notices.header.combinedPackaging': 'Application for combined packaging',
  'pages.cs.notices.header.overseasReturn': 'Overseas return application',
  'pages.cs.notices.header.incomingOutgoingDelivery': 'Incoming/outgoing and delivering',
  'pages.cs.notices.header.serviceCost': 'Service Cost',
  'pages.cs.notices.header.customsClearance': 'Customs clearance and duties/VAT',
  'pages.cs.notices.header.compensation': 'Compensation',
  
  'pages.cs.notices.type': 'Type',
  'pages.cs.notices.type.announcement': 'Announcement',
  'pages.cs.notices.type.maintenance': 'Maintenance',
  'pages.cs.notices.type.update': 'Update',
  'pages.cs.notices.type.warning': 'Warning',
  'pages.cs.notices.type.info': 'Info',
  'pages.cs.notices.type.promotion': 'Promotion',
  'pages.cs.notices.status.active': 'Active',
  'pages.cs.notices.status.inactive': 'Inactive',
  'pages.cs.notices.priority.urgent': 'Urgent',
  'pages.cs.notices.targetAudience': 'Target Audience',
  'pages.cs.notices.targetAudience.all': 'All',
  'pages.cs.notices.targetAudience.users': 'Users',
  'pages.cs.notices.targetAudience.admins': 'Admins',
  'pages.cs.notices.stats.active': 'Active',
  'pages.cs.notices.stats.expired': 'Expired',
  'pages.cs.notices.stats.announcement': 'Announcement',
  'pages.cs.notices.expiresAt': 'Expires At',
  'pages.cs.notices.expiresAtOptional': 'Expires At (Optional)',
  'pages.cs.notices.expiresAtPlaceholder': 'Select expiration date',
  'pages.cs.notices.typePlaceholder': 'Select type',
  'pages.cs.notices.typeRequired': 'Please select type',
  'pages.cs.notices.contentPlaceholderFull': 'Enter notice content (max 5000 characters)',
  'pages.cs.notices.contentMaxLength': 'Content can be up to 5000 characters',
  'pages.cs.notices.priorityPlaceholder': 'Select priority',
  'pages.cs.notices.priorityRequired': 'Please select priority',
  'pages.cs.notices.targetAudiencePlaceholder': 'Select target audience',
  'pages.cs.notices.targetAudienceRequired': 'Please select target audience',

  // Looking For Owner Page
  'pages.cs.lookingForOwner.stats.total': 'Total Posts',
  'pages.cs.lookingForOwner.stats.active': 'Active',
  'pages.cs.lookingForOwner.stats.completed': 'Completed',
  'pages.cs.lookingForOwner.stats.closed': 'Closed',
  'pages.cs.lookingForOwner.list': 'Looking For Owner List',
  'pages.cs.lookingForOwner.add': 'Create Post',
  'pages.cs.lookingForOwner.export': 'Export to Excel',
  'pages.cs.lookingForOwner.id': 'ID',
  'pages.cs.lookingForOwner.memberInfo': 'Member Info',
  'pages.cs.lookingForOwner.title': 'Title',
  'pages.cs.lookingForOwner.category': 'Category',
  'pages.cs.lookingForOwner.category.lost': 'Lost',
  'pages.cs.lookingForOwner.category.found': 'Found',
  'pages.cs.lookingForOwner.category.exchange': 'Exchange',
  'pages.cs.lookingForOwner.status': 'Status',
  'pages.cs.lookingForOwner.status.active': 'Active',
  'pages.cs.lookingForOwner.status.completed': 'Completed',
  'pages.cs.lookingForOwner.status.closed': 'Closed',
  'pages.cs.lookingForOwner.location': 'Location',
  'pages.cs.lookingForOwner.views': 'Views',
  'pages.cs.lookingForOwner.replies': 'Replies',
  'pages.cs.lookingForOwner.createdAt': 'Created At',
  'pages.cs.lookingForOwner.actions': 'Actions',
  'pages.cs.lookingForOwner.viewDetail': 'Detail',
  'pages.cs.lookingForOwner.edit': 'Edit',
  'pages.cs.lookingForOwner.complete': 'Complete',
  'pages.cs.lookingForOwner.delete': 'Delete',
  'pages.cs.lookingForOwner.deleteConfirm': 'Are you sure you want to delete?',
  'pages.cs.lookingForOwner.detailTitle': 'Post Detail',
  'pages.cs.lookingForOwner.memberName': 'Member Name',
  'pages.cs.lookingForOwner.memberId': 'Member ID',
  'pages.cs.lookingForOwner.contact': 'Contact',
  'pages.cs.lookingForOwner.descriptionField': 'Content',
  'pages.cs.lookingForOwner.updatedAt': 'Updated At',
  'pages.cs.lookingForOwner.completedAt': 'Completed At',
  'pages.cs.lookingForOwner.images': 'Images',
  'pages.cs.lookingForOwner.editTitle': 'Edit Post',
  'pages.cs.lookingForOwner.createTitle': 'Create Post',
  'pages.cs.lookingForOwner.titlePlaceholder': 'Enter post title',
  'pages.cs.lookingForOwner.descriptionPlaceholder': 'Enter post content',
  'pages.cs.lookingForOwner.locationPlaceholder': 'Enter location',
  'pages.cs.lookingForOwner.contactPlaceholder': 'Enter contact information',

  // Event Page
  'pages.cs.event.number': 'Number',
  'pages.cs.event.fieldTitle': 'Title',
  'pages.cs.event.author': 'Author',
  'pages.cs.event.views': 'Views',
  'pages.cs.event.createdAt': 'Registration Date',
  'pages.cs.event.isHeader': 'Header Post',
  'pages.cs.event.content': 'Content',
  'pages.cs.event.export': 'Export to Excel',
  'pages.cs.event.exportSuccess': 'Excel export completed successfully',
  'pages.cs.event.tab.all': 'All',
  'pages.cs.event.addTitle': 'Add Event',
  'pages.cs.event.addSuccess': 'Event added successfully',
  'pages.cs.event.addError': 'Failed to add event',
  'pages.cs.event.secret': 'Secret',
  'pages.cs.event.selectCategory': 'Select Category',
  'pages.cs.event.category': 'Category',
  'pages.cs.event.category.general': 'General',
  'pages.cs.event.category.order': 'Order',
  'pages.cs.event.category.product': 'Product',
  'pages.cs.event.category.delivery': 'Delivery',
  'pages.cs.event.category.payment': 'Payment',
  'pages.cs.event.category.etc': 'Others',
  
  // Event Header Options
  'pages.cs.event.header.joinMembership': 'Join the membership',
  'pages.cs.event.header.applyShippingAgency': 'Apply for shipping agency',
  'pages.cs.event.header.combinedPackaging': 'Application for combined packaging',
  'pages.cs.event.header.overseasReturn': 'Overseas return application',
  'pages.cs.event.header.incomingOutgoingDelivery': 'Incoming/outgoing and delivering',
  'pages.cs.event.header.serviceCost': 'Service Cost',
  'pages.cs.event.header.customsClearance': 'Customs clearance and duties/VAT',
  'pages.cs.event.header.compensation': 'Compensation',
  
  'pages.cs.event.contentPlaceholder': 'Enter content',
  'pages.cs.event.attachments': 'Multiple Attachments',
  'pages.cs.event.attachmentInfo': 'Maximum 5 files, 5MB each',
  'pages.cs.event.submit': 'Submit',
  'pages.cs.event.cancel': 'Cancel',
  'pages.cs.event.detailTitle': 'Event Detail',
  'pages.cs.event.loadError': 'Failed to load event',
  'pages.cs.event.deleteSuccess': 'Event deleted successfully',
  'pages.cs.event.deleteError': 'Failed to delete event',
  'pages.cs.event.deleteConfirm': 'Are you sure you want to delete?',
  'pages.cs.event.notFound': 'Event not found',

  // Suggestion Page (Service Inquiry/Suggestion)
  'pages.cs.suggestion.number': 'Number',
  'pages.cs.suggestion.fieldTitle': 'Title',
  'pages.cs.suggestion.author': 'Author',
  'pages.cs.suggestion.views': 'Views',
  'pages.cs.suggestion.createdAt': 'Registration Date',
  'pages.cs.suggestion.status': 'Status',
  'pages.cs.suggestion.isHeader': 'Header Post',
  'pages.cs.suggestion.content': 'Content',
  'pages.cs.suggestion.export': 'Export to Excel',
  'pages.cs.suggestion.exportSuccess': 'Excel export completed successfully',
  'pages.cs.suggestion.tab.all': 'All',
  'pages.cs.suggestion.tab.inProgress': 'In Progress',
  'pages.cs.suggestion.tab.answered': 'Answered',
  'pages.cs.suggestion.tab.onHold': 'On Hold',
  'pages.cs.suggestion.addTitle': 'Add Suggestion',
  'pages.cs.suggestion.addSuccess': 'Suggestion added successfully',
  'pages.cs.suggestion.addError': 'Failed to add suggestion',
  'pages.cs.suggestion.secret': 'Secret',
  'pages.cs.suggestion.selectCategory': 'Select Category',
  'pages.cs.suggestion.category': 'Category',
  'pages.cs.suggestion.category.general': 'General',
  'pages.cs.suggestion.category.order': 'Order',
  'pages.cs.suggestion.category.product': 'Product',
  'pages.cs.suggestion.category.delivery': 'Delivery',
  'pages.cs.suggestion.category.payment': 'Payment',
  'pages.cs.suggestion.category.etc': 'Others',
  'pages.cs.suggestion.contentPlaceholder': 'Enter content',
  'pages.cs.suggestion.attachments': 'Multiple Attachments',
  'pages.cs.suggestion.attachmentInfo': 'Maximum 5 files, 5MB each',
  'pages.cs.suggestion.loadError': 'Failed to load suggestion',
  'pages.cs.suggestion.deleteError': 'Failed to delete suggestion',
  'pages.cs.suggestion.notFound': 'Suggestion not found',
  'pages.cs.suggestion.replySection': 'Reply',
  'pages.cs.suggestion.replyRequired': 'Please enter reply content',
  'pages.cs.suggestion.replySuccess': 'Reply posted successfully',
  'pages.cs.suggestion.replyError': 'Failed to post reply',
  'pages.cs.suggestion.replyPlaceholder': 'Enter reply content',
  'pages.cs.suggestion.replyNote': 'Sensitive information such as lists, domains, passwords are prohibited',
  'pages.cs.suggestion.smsNotification': 'SMS Notification',
  'pages.cs.suggestion.noNotification': 'No Notification',
  'pages.cs.suggestion.reply': 'Reply',

  // FAQ Page
  'pages.cs.faq.number': 'Number',
  'pages.cs.faq.fieldTitle': 'Title',
  'pages.cs.faq.author': 'Author',
  'pages.cs.faq.views': 'Views',
  'pages.cs.faq.createdAt': 'Registration Date',
  'pages.cs.faq.isHeader': 'Header Post',
  'pages.cs.faq.content': 'Content',
  'pages.cs.faq.export': 'Export to Excel',
  'pages.cs.faq.exportSuccess': 'Excel export completed successfully',
  'pages.cs.faq.tab.all': 'All',
  'pages.cs.faq.addTitle': 'Add FAQ',
  'pages.cs.faq.addSuccess': 'FAQ added successfully',
  'pages.cs.faq.addError': 'Failed to add FAQ',
  'pages.cs.faq.secret': 'Secret',
  'pages.cs.faq.selectCategory': 'Select Category',
  'pages.cs.faq.category': 'Category',
  'pages.cs.faq.category.general': 'General',
  'pages.cs.faq.category.order': 'Order',
  'pages.cs.faq.category.product': 'Product',
  'pages.cs.faq.category.delivery': 'Delivery',
  'pages.cs.faq.category.payment': 'Payment',
  'pages.cs.faq.category.etc': 'Others',
  'pages.cs.faq.contentPlaceholder': 'Enter content',
  'pages.cs.faq.attachments': 'Multiple Attachments',
  'pages.cs.faq.attachmentInfo': 'Maximum 5 files, 5MB each',
  'pages.cs.faq.submit': 'Submit',
  'pages.cs.faq.cancel': 'Cancel',
  
  // FAQ Header Options
  'pages.cs.faq.header.joinMembership': 'Join the membership',
  'pages.cs.faq.header.applyShippingAgency': 'Apply for shipping agency',
  'pages.cs.faq.header.combinedPackaging': 'Application for combined packaging',
  'pages.cs.faq.header.overseasReturn': 'Overseas return application',
  'pages.cs.faq.header.incomingOutgoingDelivery': 'Incoming/outgoing and delivering',
  'pages.cs.faq.header.serviceCost': 'Service Cost',
  'pages.cs.faq.header.customsClearance': 'Customs clearance and duties/VAT',
  'pages.cs.faq.header.compensation': 'Compensation',
  
  'pages.cs.faq.detailTitle': 'FAQ Detail',
  'pages.cs.faq.loadError': 'Failed to load FAQ',
  'pages.cs.faq.deleteSuccess': 'FAQ deleted successfully',
  'pages.cs.faq.deleteError': 'Failed to delete FAQ',
  'pages.cs.faq.deleteConfirm': 'Are you sure you want to delete?',
  'pages.cs.faq.notFound': 'FAQ not found',

  // Reviews Page
  'pages.cs.reviews.number': 'Number',
  'pages.cs.reviews.fieldTitle': 'Title',
  'pages.cs.reviews.author': 'Author',
  'pages.cs.reviews.views': 'Views',
  'pages.cs.reviews.createdAt': 'Registration Date',
  'pages.cs.reviews.isHeader': 'Header Post',
  'pages.cs.reviews.content': 'Content',
  'pages.cs.reviews.export': 'Export to Excel',
  'pages.cs.reviews.exportSuccess': 'Excel export completed successfully',
  'pages.cs.reviews.tab.all': 'All',
  'pages.cs.reviews.addTitle': 'Add Review',
  'pages.cs.reviews.addSuccess': 'Review added successfully',
  'pages.cs.reviews.addError': 'Failed to add review',
  'pages.cs.reviews.secret': 'Secret',
  'pages.cs.reviews.selectCategory': 'Select Category',
  'pages.cs.reviews.category': 'Category',
  'pages.cs.reviews.category.general': 'General',
  'pages.cs.reviews.category.order': 'Order',
  'pages.cs.reviews.category.product': 'Product',
  'pages.cs.reviews.category.delivery': 'Delivery',
  'pages.cs.reviews.category.payment': 'Payment',
  'pages.cs.reviews.category.etc': 'Others',
  
  // Reviews Header Options
  'pages.cs.reviews.header.joinMembership': 'Join the membership',
  'pages.cs.reviews.header.applyShippingAgency': 'Apply for shipping agency',
  'pages.cs.reviews.header.combinedPackaging': 'Application for combined packaging',
  'pages.cs.reviews.header.overseasReturn': 'Overseas return application',
  'pages.cs.reviews.header.incomingOutgoingDelivery': 'Incoming/outgoing and delivering',
  'pages.cs.reviews.header.serviceCost': 'Service Cost',
  'pages.cs.reviews.header.customsClearance': 'Customs clearance and duties/VAT',
  'pages.cs.reviews.header.compensation': 'Compensation',
  
  'pages.cs.reviews.contentPlaceholder': 'Enter content',
  'pages.cs.reviews.attachments': 'Multiple Attachments',
  'pages.cs.reviews.attachmentInfo': 'Maximum 5 files, 5MB each',
  'pages.cs.reviews.submit': 'Submit',
  'pages.cs.reviews.cancel': 'Cancel',
  'pages.cs.reviews.detailTitle': 'Review Detail',
  'pages.cs.reviews.loadError': 'Failed to load review',
  'pages.cs.reviews.deleteSuccess': 'Review deleted successfully',
  'pages.cs.reviews.deleteError': 'Failed to delete review',
  'pages.cs.reviews.deleteConfirm': 'Are you sure you want to delete?',
  'pages.cs.reviews.notFound': 'Review not found',

  // Looking for Owner Page
  'pages.cs.looking-for-owner.number': 'Number',
  'pages.cs.looking-for-owner.fieldTitle': 'Title',
  'pages.cs.looking-for-owner.author': 'Author',
  'pages.cs.looking-for-owner.views': 'Views',
  'pages.cs.looking-for-owner.createdAt': 'Registration Date',
  'pages.cs.looking-for-owner.isHeader': 'Header Post',
  'pages.cs.looking-for-owner.content': 'Content',
  'pages.cs.looking-for-owner.export': 'Export to Excel',
  'pages.cs.looking-for-owner.exportSuccess': 'Excel export completed successfully',
  'pages.cs.looking-for-owner.tab.all': 'All',
  'pages.cs.looking-for-owner.addTitle': 'Add Looking for Owner',
  'pages.cs.looking-for-owner.addSuccess': 'Looking for Owner added successfully',
  'pages.cs.looking-for-owner.addError': 'Failed to add Looking for Owner',
  'pages.cs.looking-for-owner.secret': 'Secret',
  'pages.cs.looking-for-owner.selectCategory': 'Select Category',
  'pages.cs.looking-for-owner.category': 'Category',
  'pages.cs.looking-for-owner.category.general': 'General',
  'pages.cs.looking-for-owner.category.order': 'Order',
  'pages.cs.looking-for-owner.category.product': 'Product',
  'pages.cs.looking-for-owner.category.delivery': 'Delivery',
  'pages.cs.looking-for-owner.category.payment': 'Payment',
  'pages.cs.looking-for-owner.category.etc': 'Others',
  
  // Looking for Owner Header Options
  'pages.cs.looking-for-owner.header.joinMembership': 'Join the membership',
  'pages.cs.looking-for-owner.header.applyShippingAgency': 'Apply for shipping agency',
  'pages.cs.looking-for-owner.header.combinedPackaging': 'Application for combined packaging',
  'pages.cs.looking-for-owner.header.overseasReturn': 'Overseas return application',
  'pages.cs.looking-for-owner.header.incomingOutgoingDelivery': 'Incoming/outgoing and delivering',
  'pages.cs.looking-for-owner.header.serviceCost': 'Service Cost',
  'pages.cs.looking-for-owner.header.customsClearance': 'Customs clearance and duties/VAT',
  'pages.cs.looking-for-owner.header.compensation': 'Compensation',
  
  'pages.cs.looking-for-owner.contentPlaceholder': 'Enter content',
  'pages.cs.looking-for-owner.attachments': 'Multiple Attachments',
  'pages.cs.looking-for-owner.attachmentInfo': 'Maximum 5 files, 5MB each',
  'pages.cs.looking-for-owner.submit': 'Submit',
  'pages.cs.looking-for-owner.cancel': 'Cancel',
  'pages.cs.looking-for-owner.detailTitle': 'Looking for Owner Detail',
  'pages.cs.looking-for-owner.loadError': 'Failed to load Looking for Owner',
  'pages.cs.looking-for-owner.deleteSuccess': 'Looking for Owner deleted successfully',
  'pages.cs.looking-for-owner.deleteError': 'Failed to delete Looking for Owner',
  'pages.cs.looking-for-owner.deleteConfirm': 'Are you sure you want to delete?',
  'pages.cs.looking-for-owner.notFound': 'Looking for Owner not found',
  'pages.cs.lookingForOwner.titleRequired': 'Please enter title',
  'pages.cs.lookingForOwner.descriptionRequired': 'Please enter content',
  'pages.cs.lookingForOwner.updateSuccess': 'Post has been updated',
  'pages.cs.lookingForOwner.createSuccess': 'Post has been created',
  'pages.cs.lookingForOwner.deleteSuccess': 'Post has been deleted',
  'pages.cs.lookingForOwner.statusChangeSuccess': 'Status has been changed',
  'pages.cs.lookingForOwner.close': 'Close',
  'pages.cs.lookingForOwner.cancel': 'Cancel',

  // In Transit (배송중) Pages
  'pages.orders.inKoreaDelivery.title': 'In Transit',
  'pages.orders.inKoreaDelivery.breadcrumb': 'Order Management',
  'pages.orders.inKoreaDelivery.description': 'Orders in transit within Korea',
  'pages.orders.inKoreaDelivery.subDescription': 'View and manage orders currently being delivered in Korea',
  'pages.orders.inKoreaDelivery.generalMember': 'General Member',
  'pages.orders.inKoreaDelivery.businessMember': 'Business Member',
  'pages.orders.inKoreaDelivery.shipped': 'Shipped',
  'pages.orders.inKoreaDelivery.delivering': 'In Transit',
  'pages.orders.inKoreaDelivery.delayed': 'Delayed',
  'pages.orders.inKoreaDelivery.clearFilter': 'Clear Filter',
  'pages.orders.inKoreaDelivery.courier': 'Courier',
  'pages.orders.inKoreaDelivery.allCouriers': 'All',
  'pages.orders.inKoreaDelivery.cj': 'CJ Logistics',
  'pages.orders.inKoreaDelivery.hanjin': 'Hanjin Express',
  'pages.orders.inKoreaDelivery.lotte': 'Lotte Express',
  'pages.orders.inKoreaDelivery.shipDate': 'Ship Date',
  'pages.orders.inKoreaDelivery.deliveryDate': 'Delivery Date',

  // Completed (배송완료) Pages
  'pages.orders.completed.title': 'Completed',
  'pages.orders.completed.breadcrumb': 'Order Management',
  'pages.orders.completed.description': 'Completed orders',
  'pages.orders.completed.subDescription': 'View and statistics of completed orders',
  'pages.orders.completed.completedDate': 'Completed Date',

  // No Data (노데이타) Pages
  'pages.orders.noData.title': 'No Data',
  'pages.orders.noData.breadcrumb': 'Order Management',
  'pages.orders.noData.description': 'Order Matching Management',
  'pages.orders.noData.subDescription': 'View and process unmatched orders (General/Business Members)',
  'pages.orders.noData.management': 'No Data Management',

  // Order Inquiries (주문문의) Pages
  'pages.orders.orderQuestions.title': 'Order Inquiries',
  'pages.orders.orderQuestions.breadcrumb': 'Order Management',
  'pages.orders.orderQuestions.description': 'Order inquiry management',
  'pages.orders.orderQuestions.subDescription': 'View and respond to customer inquiries about orders',
  'pages.orders.orderQuestions.orderNo': 'Order No',
  'pages.orders.orderQuestions.memberNameId': 'Recipient Name / MailBox',
  'pages.orders.orderQuestions.memberManager': 'Member Manager',
  'pages.orders.orderQuestions.content': 'Content',
  'pages.orders.orderQuestions.writer': 'Member Name',
  'pages.orders.orderQuestions.status': 'Status',
  'pages.orders.orderQuestions.processingStatus': 'Processing Status',
  'pages.orders.orderQuestions.statusUnread': 'Not Confirmed',
  'pages.orders.orderQuestions.statusRead': 'Processing',
  'pages.orders.orderQuestions.statusProcessed': 'Confirmed',
  'pages.orders.orderQuestions.statusAll': 'All',
  'pages.orders.orderQuestions.searchByUserUniqueId': 'User Unique ID',
  'pages.orders.orderQuestions.answered': 'Answered',
  'pages.orders.orderQuestions.unanswered': 'Unanswered',
  'pages.orders.orderQuestions.answeredStatus': 'Answered Status',
  'pages.orders.orderQuestions.registeredDate': 'Registered Date / Last Message At',
  'pages.orders.orderQuestions.answerer': 'Answerer',
  'pages.orders.orderQuestions.delete': 'Delete',
  'pages.orders.orderQuestions.all': 'All',
  'pages.orders.orderQuestions.searchBy': 'Search By',
  'pages.orders.orderQuestions.searchByContent': 'Content',
  'pages.orders.orderQuestions.searchByOrderNo': 'Order No',
  'pages.orders.orderQuestions.searchByMemberName': 'Member Name',
  'pages.orders.orderQuestions.searchPlaceholder': 'Enter search keyword',
  'pages.orders.orderQuestions.search': 'Search',
  'pages.orders.orderQuestions.category': 'Order Inquiry',
  'pages.orders.orderQuestions.answerSubmitted': 'Answer has been submitted',
  'pages.orders.orderQuestions.messageCount': '{count} messages',
  'pages.orders.orderQuestions.messages': 'messages',
  'pages.orders.orderQuestions.orderNoWithMessages': 'Order No: {orderNumber} ({count} messages)',
  'pages.orders.orderQuestions.unreadMessages': '{count} unread messages',
  'pages.orders.orderQuestions.totalItems': 'Total {total} items',
  'pages.orders.orderQuestions.member': 'Member',
  'pages.orders.orderQuestions.confirmDelete': 'Delete Inquiry',
  'pages.orders.orderQuestions.confirmDeleteDescription': 'Are you sure you want to delete this inquiry? This action cannot be undone.',
  'pages.orders.orderQuestions.deleteSuccess': 'Inquiry deleted successfully',
  'pages.orders.orderQuestions.deleteError': 'Failed to delete inquiry',
  'pages.orders.orderQuestions.cancel': 'Cancel',
  'pages.orders.orderQuestions.processingButton': 'Processing',
  'pages.orders.orderQuestions.confirmButton': 'Confirm',
  'pages.orders.orderQuestions.processingStarted': 'Processing started',
  'pages.orders.orderQuestions.processingError': 'Failed to start processing',
  'pages.orders.orderQuestions.confirmed': 'Inquiry confirmed',
  'pages.orders.orderQuestions.confirmError': 'Failed to confirm inquiry',
  'questionModal.edit': 'Edit',
  'questionModal.delete': 'Delete',
  'questionModal.messageDeleted': 'Message deleted',
  'questionModal.messageDeleteFailed': 'Failed to delete message',
  'questionModal.messageUpdated': 'Message updated',
  'questionModal.messageUpdateFailed': 'Failed to update message',
  'questionModal.editMessagePrompt': 'Edit message',
  'questionModal.deleteConfirmTitle': 'Delete message',
  'questionModal.deleteConfirmContent': 'Are you sure you want to delete this message?',
  'questionModal.cancel': 'Cancel',
  'questionModal.editingMessage': 'Editing…',
  'questionModal.cancelEdit': 'Cancel edit',

  // Inventory Inquiries (재고문의) Pages
  'pages.orders.inventoryQuestions.title': 'Inventory Inquiries',
  'pages.orders.inventoryQuestions.breadcrumb': 'Order Management',
  'pages.orders.inventoryQuestions.description': 'Inventory inquiry management',
  'pages.orders.inventoryQuestions.subDescription': 'Check inventory and respond to inquiries',
  'pages.orders.inventoryQuestions.orderNo': 'Order No',
  'pages.orders.inventoryQuestions.memberNameId': 'Member Name/ID',
  'pages.orders.inventoryQuestions.memberManager': 'Member Manager',
  'pages.orders.inventoryQuestions.content': 'Content',
  'pages.orders.inventoryQuestions.writer': 'Writer',
  'pages.orders.inventoryQuestions.status': 'Status',
  'pages.orders.inventoryQuestions.answered': 'Answered',
  'pages.orders.inventoryQuestions.unanswered': 'Unanswered',
  'pages.orders.inventoryQuestions.registeredDate': 'Registered Date',
  'pages.orders.inventoryQuestions.answerer': 'Answerer',
  'pages.orders.inventoryQuestions.delete': 'Delete',
  'pages.orders.inventoryQuestions.all': 'All',
  'pages.orders.inventoryQuestions.searchBy': 'Search By',
  'pages.orders.inventoryQuestions.searchByContent': 'Content',
  'pages.orders.inventoryQuestions.searchByOrderNo': 'Order No',
  'pages.orders.inventoryQuestions.searchByMemberName': 'Member Name',
  'pages.orders.inventoryQuestions.searchPlaceholder': 'Enter search keyword',
  'pages.orders.inventoryQuestions.search': 'Search',
  'pages.orders.inventoryQuestions.category': 'Inventory Inquiry',
  'pages.orders.inventoryQuestions.mock.name1': 'John Smith',
  'pages.orders.inventoryQuestions.mock.name2': 'Jane Doe',
  'pages.orders.inventoryQuestions.mock.name3': 'Bob Johnson',
  'pages.orders.inventoryQuestions.mock.question1': 'When will the ordered product inventory (board) arrive? W823,077',
  'pages.orders.inventoryQuestions.mock.answer1': 'According to inventory check, it is scheduled to arrive on November 25th.',
  'pages.orders.inventoryQuestions.mock.question2': 'Please check the inventory.',
  'pages.orders.inventoryQuestions.mock.question3': 'When is the product expected to arrive? Please reply quickly.',
  'pages.orders.inventoryQuestions.mock.answer3': 'The product is scheduled to arrive on November 30th.',

  // Additional keys for Completed and NoData pages
  'pages.orders.completed.reviewWritten': 'Review Written',
  'pages.orders.completed.noReview': 'No Review',
  'pages.orders.completed.orderNo': 'Order No',
  'pages.orders.completed.memberName': 'Member Name',
  'pages.orders.completed.memberType': 'Type',
  'pages.orders.completed.receiver': 'Receiver',
  'pages.orders.completed.contact': 'Contact',
  'pages.orders.completed.address': 'Address',
  'pages.orders.completed.trackingNo': 'Tracking No',
  'pages.orders.completed.orderAmount': 'Order Amount',
  'pages.orders.completed.shippingFee': 'Shipping Fee',
  'pages.orders.completed.deliveryDays': 'Delivery Days',
  'pages.orders.completed.review': 'Review',
  'pages.orders.completed.rating': 'Rating',
  'pages.orders.completed.reviewCompleted': 'Completed',
  'pages.orders.completed.actions': 'Actions',
  'pages.orders.completed.viewDetails': 'View Details',
  'pages.orders.completed.requestReview': 'Request Review',
  'pages.orders.completed.batchRequestReview': 'Request Review for {count} Selected',
  'pages.orders.completed.excelDownload': 'Excel Download',
  'pages.orders.completed.more': 'More ▼',
  'pages.orders.completed.collapse': 'Collapse ▲',
  'pages.orders.completed.reset': 'Reset',
  'pages.orders.completed.search': 'Search',
  'pages.orders.completed.total': 'Total {total} items',
  'pages.orders.completed.reviewStatus': 'Review Status',
  'pages.orders.completed.all': 'All',
  'pages.orders.completed.reviewed': 'Reviewed',
  'pages.orders.completed.noReviewStatus': 'No Review',
  'pages.orders.completed.viewAll': 'View All',
  'pages.orders.completed.general': 'General',
  'pages.orders.completed.business': 'Business',
  'pages.orders.noData.unmatched': 'Unmatched',
  'pages.orders.noData.matched': 'Matched',
  'pages.orders.noData.unlinked': 'Unlinked',
  'pages.orders.noData.applicationType': 'Application Type',
  'pages.orders.noData.all': 'All',
  'pages.orders.noData.delivery': 'Delivery',
  'pages.orders.noData.purchase': 'Purchase',
  'pages.orders.noData.registrationDate': 'Registration Date',
  'pages.orders.noData.matchStatus': 'Match Status',
  'pages.orders.noData.product': 'Product',
  'pages.orders.noData.image': 'Image',
  'pages.orders.noData.center': 'Center',
  'pages.orders.noData.mailbox': 'Mailbox',
  'pages.orders.noData.mailboxNo': 'Mailbox No',
  'pages.orders.noData.productName': 'Product Name',
  'pages.orders.noData.quantity': 'Quantity',
  'pages.orders.noData.codFee': 'Cash on Delivery Fee',
  'pages.orders.noData.weight': 'Weight',
  'pages.orders.noData.wearer': 'Wearer',
  'pages.orders.noData.orderNo': 'Order No',
  'pages.orders.noData.orderNumber': 'Order Number',
  'pages.orders.noData.registrationDateCol': 'Registration Date',
  'pages.orders.noData.rackNo': 'Rack No',
  'pages.orders.noData.rackNumber': 'Rack Number',
  'pages.orders.noData.issue': 'Issue',
  'pages.orders.noData.issueNoOrderInfo': 'No Order Info',
  'pages.orders.noData.result': 'Result',
  'pages.orders.noData.actions': 'Actions',
  'pages.orders.noData.match': 'Match',
  'pages.orders.noData.unlink': 'Unlink',
  'pages.orders.noData.batchMatch': 'Batch Match {count} Selected',
  'pages.orders.noData.enterTrackingNumber': 'Enter tracking number',
  'pages.orders.noData.trackingNumberRequired': 'Please enter a tracking number',
  'pages.orders.noData.trackingNumberSaved': 'Tracking number saved successfully',
  'pages.orders.noData.saveError': 'Failed to save tracking number',
  'pages.orders.noData.save': 'Save',
  'pages.orders.noData.return': 'Return',
  'pages.orders.noData.returnFunctionality': 'Return functionality to be implemented',
  'pages.orders.noData.recordIdRequired': 'Record ID is required',
  'pages.orders.noData.returnedSuccess': 'Status updated to returned successfully',
  'pages.orders.noData.returnError': 'Failed to update status to returned',
  'pages.orders.noData.excelDownload': 'Excel Download',
  'pages.orders.noData.more': 'More ▼',
  'pages.orders.noData.collapse': 'Collapse ▲',
  'pages.orders.noData.reset': 'Reset',
  'pages.orders.noData.search': 'Search',
  'pages.orders.noData.total': 'Total {total} items',
  'pages.orders.noData.refresh': 'Refresh',
  'pages.orders.noData.viewAll': 'View All',
  'pages.orders.noData.previewImage': 'Preview',
  'pages.orders.noData.general': 'General',
  'pages.orders.noData.business': 'Business',
  'pages.orders.noData.memberName': 'Member Name',
  'pages.orders.noData.trackingNo': 'Tracking No',
  // 'pages.orders.inKoreaDelivery.shipped': 'Shipped',
  'pages.orders.inKoreaDelivery.viewAll': 'View All',
  'pages.orders.inKoreaDelivery.trackDelivery': 'Track Delivery',
  'pages.orders.inKoreaDelivery.viewDetails': 'View Details',
  'pages.orders.inKoreaDelivery.deliveryStatus': 'Delivery Status',
  'pages.orders.inKoreaDelivery.shippedDate': 'Shipped Date',
  'pages.orders.inKoreaDelivery.estimatedArrival': 'Estimated Arrival',
  'pages.orders.inKoreaDelivery.receiver': 'Receiver',
  'pages.orders.inKoreaDelivery.address': 'Address',
  'pages.orders.inKoreaDelivery.courierTracking': 'Courier/Tracking No',
  'pages.orders.inKoreaDelivery.orderNo': 'Order No',
  'pages.orders.inKoreaDelivery.memberName': 'Member Name',
  'pages.orders.inKoreaDelivery.memberType': 'Type',
  'pages.orders.inKoreaDelivery.contact': 'Contact',
  'pages.orders.inKoreaDelivery.trackingNo': 'Tracking No',
  'pages.orders.inKoreaDelivery.actions': 'Actions',
  'pages.orders.inKoreaDelivery.batchTrack': 'Batch Track {count} Selected',
  'pages.orders.inKoreaDelivery.excelDownload': 'Excel Download',
  'pages.orders.inKoreaDelivery.more': 'More ▼',
  'pages.orders.inKoreaDelivery.collapse': 'Collapse ▲',
  'pages.orders.inKoreaDelivery.reset': 'Reset',
  'pages.orders.inKoreaDelivery.search': 'Search',
  'pages.orders.inKoreaDelivery.total': 'Total {total} items',
  'pages.orders.inKoreaDelivery.general': 'General',
  'pages.orders.inKoreaDelivery.business': 'Business',

  // Coupons Page
  'pages.members.coupons.title': 'Coupon Management',
  'pages.members.coupons.couponList': 'Coupon List',
  'pages.members.coupons.usageHistory': 'Issue/Usage History',
  'pages.members.coupons.totalCoupons': 'Total Coupons',
  'pages.members.coupons.activeCoupons': 'Active Coupons',
  'pages.members.coupons.issuedCoupons': 'Issued Coupons',
  'pages.members.coupons.usedCoupons': 'Used Coupons',
  'pages.members.coupons.id': 'ID',
  'pages.members.coupons.couponName': 'Coupon Name',
  'pages.members.coupons.couponCode': 'Coupon Code',
  'pages.members.coupons.discountType': 'Discount Type',
  'pages.members.coupons.discountTypeFixed': 'Fixed Amount',
  'pages.members.coupons.discountTypePercent': 'Percentage',
  'pages.members.coupons.discountAmount': 'Discount Amount',
  'pages.members.coupons.minOrderAmount': 'Min Order Amount',
  'pages.members.coupons.usageStatus': 'Usage Status',
  'pages.members.coupons.usagePercent': '% Used',
  'pages.members.coupons.validPeriod': 'Valid Period',
  'pages.members.coupons.status': 'Status',
  'pages.members.coupons.statusActive': 'Active',
  'pages.members.coupons.statusInactive': 'Inactive',
  'pages.members.coupons.statusExpired': 'Expired',
  'pages.members.coupons.createdAt': 'Created Date',
  'pages.members.coupons.actions': 'Actions',
  'pages.members.coupons.issue': 'Issue',
  'pages.members.coupons.edit': 'Edit',
  'pages.members.coupons.delete': 'Delete',
  'pages.members.coupons.memberInfo': 'Member Info',
  'pages.members.coupons.orderNo': 'Order No',
  'pages.members.coupons.usedAt': 'Used At',
  'pages.members.coupons.statusUsed': 'Used',
  'pages.members.coupons.statusUnused': 'Unused',
  'pages.members.coupons.excelDownload': 'Excel Download',
  'pages.members.coupons.createCoupon': 'Create Coupon',
  'pages.members.coupons.deleteConfirm': 'Delete Coupon',
  'pages.members.coupons.deleteContent': 'Are you sure you want to delete coupon "{name}"?',
  'pages.members.coupons.deleted': 'Coupon deleted',
  'pages.members.coupons.updated': 'Coupon updated',
  'pages.members.coupons.created': 'Coupon created',
  'pages.members.coupons.issued': 'Coupon issued',
  'pages.members.coupons.issuedSuccess': 'Coupon issued successfully. Issued: {issued}, Skipped: {skipped}',
  'pages.members.coupons.issueFailed': 'Failed to issue coupon',
  'pages.members.coupons.modalEdit': 'Edit Coupon',
  'pages.members.coupons.modalCreate': 'Create Coupon',
  'pages.members.coupons.nameLabel': 'Coupon Name',
  'pages.members.coupons.nameRequired': 'Please enter coupon name',
  'pages.members.coupons.namePlaceholder': 'e.g., Welcome New Member Coupon',
  'pages.members.coupons.codeLabel': 'Coupon Code',
  'pages.members.coupons.codeRequired': 'Please enter coupon code',
  'pages.members.coupons.codePlaceholder': 'e.g., WELCOME2025',
  'pages.members.coupons.typeLabel': 'Discount Type',
  'pages.members.coupons.typeFixed': 'Fixed Amount Discount',
  'pages.members.coupons.typePercent': 'Percentage Discount (%)',
  'pages.members.coupons.discountValueLabel': 'Discount Amount/Rate',
  'pages.members.coupons.minOrderAmountLabel': 'Min Order Amount',
  'pages.members.coupons.maxDiscountAmountLabel': 'Max Discount Amount (Optional)',
  'pages.members.coupons.validPeriodLabel': 'Valid Period',
  'pages.members.coupons.validPeriodRequired': 'Please select valid period',
  'pages.members.coupons.totalCountLabel': 'Issue Quantity',
  'pages.members.coupons.descriptionLabel': 'Coupon Description',
  'pages.members.coupons.descriptionPlaceholder': 'Enter coupon description',
  'pages.members.coupons.statusLabel': 'Status',
  'pages.members.coupons.statusActiveText': 'Active',
  'pages.members.coupons.statusInactiveText': 'Inactive',
  'pages.members.coupons.issueModalTitle': 'Issue Coupon - {name}',
  'pages.members.coupons.targetTypeLabel': 'Target',
  'pages.members.coupons.targetTypeAll': 'All Members',
  'pages.members.coupons.targetTypeLevel': 'By Level',
  'pages.members.coupons.memberLevelLabel': 'Member Level',
  'pages.members.coupons.targetTypeSpecific': 'Specific Members',
  'pages.members.coupons.memberIdsLabel': 'Select Members',
  'pages.members.coupons.memberIdsRequired': 'Please select at least one member',
  'pages.members.coupons.memberIdsPlaceholder': 'Search and select members by email or phone',
  'pages.members.coupons.messageLabel': 'Message (Optional)',
  'pages.members.coupons.messagePlaceholder': 'Message to send when issuing coupon',
  'pages.members.coupons.currency': 'KRW',
  'pages.members.coupons.unit': 'pcs',
  'pages.members.coupons.couponIdLabel': 'Coupon ID',
  'pages.members.coupons.couponIdTooltip': 'A unique ID is generated for each coupon set',
  'pages.members.coupons.couponIdPlaceholder': 'Auto-generated (e.g., COUPON_SET_000001)',
  'pages.members.coupons.validityDaysLabel': 'Validity Period (Days)',
  'pages.members.coupons.validityDaysTooltip': 'Coupon validity period in days',
  'pages.members.coupons.validityDaysPlaceholder': 'Enter number of days',
  'pages.members.coupons.days': 'days',
  'pages.members.coupons.remainingQuantity': 'Remaining',
  'pages.members.coupons.usedCountLabel': 'Used Quantity',
  'pages.members.coupons.issuanceMethod': 'Issuance Method',
  'pages.members.coupons.issuanceMethodLabel': 'Issuance Method',
  'pages.members.coupons.issuanceMethodTooltip': 'Select how the coupon is distributed: User Issuance, System Issuance, or Signup Bonus',
  'pages.members.coupons.issuanceMethodUser': 'User claim',
  'pages.members.coupons.issuanceMethodSystem': 'System distribution',
  'pages.members.coupons.issuanceMethodSignup': 'Register and receive coupons',
  'pages.members.coupons.signupCouponIdLabel': 'Signup Coupon ID',
  'pages.members.coupons.signupCouponIdTooltip': 'Select which coupon to issue after signup. You can enter the coupon ID.',
  'pages.members.coupons.signupCouponIdPlaceholder': 'Enter coupon ID to issue after signup',
  'pages.members.coupons.distributionEnabledLabel': 'Distribution System Coupon',
  'pages.members.coupons.distributionEnabledTooltip': 'Choose to distribute specific types of coupons evenly within the system',
  'pages.members.coupons.enabled': 'Enabled',
  'pages.members.coupons.disabled': 'Disabled',
  'pages.members.coupons.issueButtonTooltipUser': 'Manually issue this coupon to selected users',
  'pages.members.coupons.issueButtonTooltipSystem': 'Issue this coupon to selected users',
  'pages.members.coupons.issueModalSystemHelp': 'System coupon: You can issue this coupon to all users or specific users.',
  'pages.members.coupons.issueModalUserHelp': 'User coupon: This coupon must be manually issued. Select target users below.',
  'pages.members.coupons.issueToAll': 'Issue to All',
  'pages.members.coupons.issueToAllTooltip': 'Issue this coupon to all users automatically',
  'pages.members.coupons.issueToAllConfirm': 'Issue to All Users',
  'pages.members.coupons.issueToAllContent': 'Are you sure you want to issue "{name}" to all users?',
  'pages.members.coupons.issuedToAll': 'Coupon "{name}" has been issued to all users',

  // Points Page
  'pages.members.points.title': 'Points History',
  'pages.members.points.totalEarned': 'Total Earned Points',
  'pages.members.points.totalUsed': 'Total Used Points',
  'pages.members.points.currentBalance': 'Current Balance',
  'pages.members.points.expiringThisMonth': 'Expiring This Month',
  'pages.members.points.memberInfo': 'Member Info',
  'pages.members.points.memberId': 'Member ID',
  'pages.members.points.type': 'Type',
  'pages.members.points.typeEarn': 'Earn',
  'pages.members.points.typeUse': 'Use',
  'pages.members.points.typeExpire': 'Expire',
  'pages.members.points.typeAdmin': 'Admin',
  'pages.members.points.points': 'Points',
  'pages.members.points.balance': 'Balance',
  'pages.members.points.reason': 'Reason',
  'pages.members.points.content': 'Content',
  'pages.members.points.orderNo': 'Order No',
  'pages.members.points.processedAt': 'Processed At',
  'pages.members.points.dateRange': 'Process Period',
  'pages.members.points.expiryDate': 'Expiry Date',
  'pages.members.points.processor': 'Processor',
  'pages.members.points.excelDownload': 'Excel Download',
  'pages.members.points.addPoints': 'Add Points',
  'pages.members.points.paid': 'Points have been issued',
  'pages.members.points.modalTitle': 'Add Points',
  'pages.members.points.memberIdLabel': 'Member ID',
  'pages.members.points.memberIdRequired': 'Please enter member ID',
  'pages.members.points.memberIdPlaceholder': 'Member ID or Email',
  'pages.members.points.typeLabel': 'Type',
  // 'pages.members.points.typeAdmin': 'Admin Issue',
  // 'pages.members.points.typeEarn': 'Earn',
  'pages.members.points.typeDeduct': 'Deduct',
  'pages.members.points.amountLabel': 'Points',
  'pages.members.points.amountRequired': 'Please enter points',
  'pages.members.points.amountPlaceholder': '0',
  'pages.members.points.reasonLabel': 'Reason',
  'pages.members.points.reasonRequired': 'Please enter reason',
  'pages.members.points.reasonPlaceholder': 'Enter reason for adding/deducting points',
  'pages.members.points.expiryDateLabel': 'Expiry Date (Optional)',
  'pages.members.points.unit': 'P',
  // Points Record Table Columns
  'pages.members.points.column.id': 'ID',
  'pages.members.points.column.memberName': 'Member Name',
  'pages.members.points.column.mailbox': 'Mailbox',
  'pages.members.points.column.orderNumber': 'Order Number',
  'pages.members.points.column.paymentDetails': 'Payment Details',
  'pages.members.points.column.pointsBeforeChange': 'Points before change',
  'pages.members.points.column.pointsUsed': 'Points used',
  'pages.members.points.column.pointsReceived': 'Points received',
  'pages.members.points.column.pointsAfterChange': 'Points after change',
  'pages.members.points.column.pointsCurrencyExchangeRate': 'Points and currency exchange rate',
  'pages.members.points.column.pointsCurrencyExchangeAmount': 'Points and currency exchange amount',
  'pages.members.points.column.time': 'Time',

  'pages.helpCenter.title': 'Help Center',
  'pages.helpCenter.subTitle': 'Website help and content management',
  'pages.helpCenter.tabs.guides': 'Guides',
  'pages.helpCenter.tabs.faqs': 'FAQ',
  'pages.helpCenter.tabs.payWith': 'Payment Methods',
  'pages.helpCenter.tabs.socialLinks': 'Social Links',
  'pages.helpCenter.tabs.viewHelp': 'View Help',
  'pages.helpCenter.tabs.footer': 'Footer Info',
  'pages.helpCenter.columns.order': 'Order',
  'pages.helpCenter.columns.chapter': 'Chapter',
  'pages.helpCenter.columns.subChapterCount': 'SubChapters',
  'pages.helpCenter.columns.actions': 'Actions',
  'pages.helpCenter.columns.question': 'Question',
  'pages.helpCenter.columns.category': 'Category',
  'pages.helpCenter.columns.image': 'Image',
  'pages.helpCenter.columns.title': 'Title',
  'pages.helpCenter.columns.description': 'Description',
  'pages.helpCenter.columns.platform': 'Platform',
  'pages.helpCenter.columns.url': 'URL',
  'pages.helpCenter.columns.content': 'Content',
  'pages.helpCenter.columns.name': 'Name',
  'pages.helpCenter.columns.value': 'Value',
  'pages.helpCenter.columns.visible': 'Visible',
  'pages.helpCenter.buttons.addGuide': 'Add Guide',
  'pages.helpCenter.buttons.manageCategory': 'Manage Categories',
  'pages.helpCenter.buttons.addFAQ': 'Add FAQ',
  'pages.helpCenter.buttons.addPayWith': 'Add Payment Method',
  'pages.helpCenter.buttons.addSocialLink': 'Add Social Link',
  'pages.helpCenter.buttons.addViewHelpContent': 'Add Help Content',
  'pages.helpCenter.buttons.editFooter': 'Edit Footer Info',
  'pages.helpCenter.buttons.edit': 'Edit',
  'pages.helpCenter.buttons.delete': 'Delete',
  'pages.helpCenter.buttons.addCategory': 'Add Category',
  'pages.helpCenter.buttons.addSubChapter': 'Add SubChapter',
  'pages.helpCenter.buttons.save': 'Save',
  'pages.helpCenter.buttons.cancel': 'Cancel',
  'pages.helpCenter.modals.guide.add': 'Add Guide',
  'pages.helpCenter.modals.guide.edit': 'Edit Guide',
  'pages.helpCenter.modals.category.manage': 'Manage Categories',
  'pages.helpCenter.modals.category.add': 'Add Category',
  'pages.helpCenter.modals.category.edit': 'Edit Category',
  'pages.helpCenter.modals.viewHelpContent.add': 'Add Help Content',
  'pages.helpCenter.modals.viewHelpContent.edit': 'Edit Help Content',
  'pages.helpCenter.modals.faq.add': 'Add FAQ',
  'pages.helpCenter.modals.faq.edit': 'Edit FAQ',
  'pages.helpCenter.modals.payWith.add': 'Add Payment Method',
  'pages.helpCenter.modals.payWith.edit': 'Edit Payment Method',
  'pages.helpCenter.modals.socialLink.add': 'Add Social Link',
  'pages.helpCenter.modals.socialLink.edit': 'Edit Social Link',
  'pages.helpCenter.modals.footer.edit': 'Edit Footer Info',
  'pages.helpCenter.forms.chapter': 'Chapter',
  'pages.helpCenter.forms.chapterRequired': 'Please enter chapter',
  'pages.helpCenter.forms.chapterPlaceholder': 'Chapter title',
  'pages.helpCenter.forms.order': 'Order',
  'pages.helpCenter.forms.orderRequired': 'Please enter order',
  'pages.helpCenter.forms.orderPlaceholder': 'Order',
  'pages.helpCenter.forms.chapterContent': 'Chapter Content',
  'pages.helpCenter.forms.chapterContentTooltip': 'You can enter content directly in the chapter if there are no subchapters',
  'pages.helpCenter.forms.chapterContentPlaceholder': 'Enter chapter content',
  'pages.helpCenter.forms.subChapters': 'SubChapters (Optional)',
  'pages.helpCenter.forms.subChaptersHint': 'Adding subchapters will hide the chapter content field',
  'pages.helpCenter.forms.subChapterTitle': 'SubChapter Title',
  'pages.helpCenter.forms.subChapterTitleRequired': 'Please enter subchapter title',
  'pages.helpCenter.forms.subChapterTitlePlaceholder': 'SubChapter title',
  'pages.helpCenter.forms.subChapterContent': 'SubChapter Content',
  'pages.helpCenter.forms.subChapterContentRequired': 'Please enter subchapter content',
  'pages.helpCenter.forms.subChapterContentPlaceholder': 'SubChapter content',
  'pages.helpCenter.forms.categoryName': 'Category Name',
  'pages.helpCenter.forms.categoryNameRequired': 'Please enter category name',
  'pages.helpCenter.forms.categoryNamePlaceholder': 'e.g., Order/Purchase',
  'pages.helpCenter.forms.categoryValue': 'Category Value (English)',
  'pages.helpCenter.forms.categoryValueRequired': 'Please enter category value',
  'pages.helpCenter.forms.categoryValuePlaceholder': 'e.g., order',
  'pages.helpCenter.forms.question': 'Question',
  'pages.helpCenter.forms.questionRequired': 'Please enter question',
  'pages.helpCenter.forms.questionPlaceholder': 'Question',
  'pages.helpCenter.forms.answer': 'Answer',
  'pages.helpCenter.forms.answerRequired': 'Please enter answer',
  'pages.helpCenter.forms.answerPlaceholder': 'Answer',
  'pages.helpCenter.forms.category': 'Category',
  'pages.helpCenter.forms.categoryRequired': 'Please select category',
  'pages.helpCenter.forms.categoryPlaceholder': 'Select category',
  'pages.helpCenter.forms.title': 'Title',
  'pages.helpCenter.forms.titleRequired': 'Please enter title',
  'pages.helpCenter.forms.titlePlaceholder': 'Payment method title',
  'pages.helpCenter.forms.description': 'Description',
  'pages.helpCenter.forms.descriptionRequired': 'Please enter description',
  'pages.helpCenter.forms.descriptionPlaceholder': 'Description',
  'pages.helpCenter.forms.iconUrl': 'Icon URL',
  'pages.helpCenter.forms.iconUrlPlaceholder': 'Icon URL (Optional)',
  'pages.helpCenter.forms.platform': 'Platform',
  'pages.helpCenter.forms.platformRequired': 'Please enter platform',
  'pages.helpCenter.forms.platformPlaceholder': 'Platform name (e.g., Facebook, Twitter)',
  'pages.helpCenter.forms.url': 'URL',
  'pages.helpCenter.forms.urlRequired': 'Please enter URL',
  'pages.helpCenter.forms.urlPlaceholder': 'https://...',
  'pages.helpCenter.forms.viewHelpTitlePlaceholder': 'Help title',
  'pages.helpCenter.forms.content': 'Content',
  'pages.helpCenter.forms.contentRequired': 'Please enter content',
  'pages.helpCenter.forms.visible': 'Visible',
  'pages.helpCenter.messages.deleteConfirm': 'Are you sure you want to delete?',
  'pages.helpCenter.messages.noImage': 'None',
  'pages.helpCenter.messages.currentFooterInfo': 'Current Footer Info',
  'pages.helpCenter.messages.categoryList': 'FAQ Category List',
  'pages.helpCenter.footer.companyName': 'Company Name',
  'pages.helpCenter.footer.representative': 'Representative',
  'pages.helpCenter.footer.address': 'Address',
  'pages.helpCenter.footer.businessNumber': 'Business Number',
  'pages.helpCenter.footer.communicationNumber': 'Communication Number',
  'pages.helpCenter.footer.phone': 'Phone',
  'pages.helpCenter.footer.email': 'Email',
  'pages.helpCenter.footer.complaintContact': 'Complaint Contact',
  'pages.helpCenter.footer.serviceDescription': 'Service Description',
  'pages.helpCenter.footer.paymentDescription': 'Payment Description',
  'pages.helpCenter.footer.companyNamePlaceholder': 'TaoExpress Co., Ltd.',
  'pages.helpCenter.footer.representativePlaceholder': 'Representative Name',
  'pages.helpCenter.footer.addressPlaceholder': 'Address',
  'pages.helpCenter.footer.businessNumberPlaceholder': 'Business Number',
  'pages.helpCenter.footer.communicationNumberPlaceholder': 'Communication Number',
  'pages.helpCenter.footer.phonePlaceholder': 'Phone Number',
  'pages.helpCenter.footer.emailPlaceholder': 'Email Address',
  'pages.helpCenter.footer.complaintContactPlaceholder': 'Complaint Contact',
  'pages.helpCenter.footer.serviceDescriptionPlaceholder': 'Service description',
  'pages.helpCenter.footer.paymentDescriptionPlaceholder': 'We support various bank credit cards and debit cards for charging and payment. View Help',
  'pages.helpCenter.footer.showHideOptions': 'Show/Hide Options',
  'pages.helpCenter.footer.showCompanyName': 'Show Company Name',
  'pages.helpCenter.footer.showRepresentative': 'Show Representative',
  'pages.helpCenter.footer.showAddress': 'Show Address',
  'pages.helpCenter.footer.showBusinessNumber': 'Show Business Number',
  'pages.helpCenter.footer.showCommunicationNumber': 'Show Communication Number',
  'pages.helpCenter.footer.showPhone': 'Show Phone',
  'pages.helpCenter.footer.showEmail': 'Show Email',
  'pages.helpCenter.footer.showComplaintContact': 'Show Complaint Contact',
  'pages.helpCenter.footer.showServiceDescription': 'Show Service Description',
  'pages.helpCenter.footer.showPaymentDescription': 'Show Payment Description',
  'pages.helpCenter.footer.showViewHelp': 'Show View Help',
  'pages.helpCenter.footer.whatIsTodayMall': 'What is TodayMall',
  'pages.helpCenter.footer.whatIsTodayMallPlaceholder': 'Enter description about TodayMall',
  'pages.helpCenter.footer.whatIsTodayMallRequired': 'Please enter TodayMall description',
  'pages.helpCenter.footer.showWhatIsTodayMall': 'Show What is TodayMall',
  'pages.helpCenter.footer.companyTagline': 'Company Tagline',
  'pages.helpCenter.footer.companyTaglinePlaceholder': 'Enter company tagline (e.g., Your Best Choice for Online Shopping)',
  'pages.helpCenter.footer.companyTaglineRequired': 'Please enter company tagline',
  'pages.helpCenter.footer.showCompanyTagline': 'Show Company Tagline',
  'pages.helpCenter.footer.companyIntroduction': 'Company Introduction',
  'pages.helpCenter.footer.companyIntroductionPlaceholder': 'Enter company introduction',
  'pages.helpCenter.footer.companyIntroductionRequired': 'Please enter company introduction',
  'pages.helpCenter.footer.showCompanyIntroduction': 'Show Company Introduction',
  'pages.helpCenter.footer.sections.companyInfo': 'Company Information',
  'pages.helpCenter.footer.sections.contactInfo': 'Contact Information',
  'pages.helpCenter.footer.sections.descriptions': 'Descriptions',
  'pages.helpCenter.footer.sections.viewHelp': 'View Help',
  'pages.helpCenter.footer.companyNameRequired': 'Please enter company name',
  'pages.helpCenter.footer.representativeRequired': 'Please enter representative',
  'pages.helpCenter.footer.addressRequired': 'Please enter address',
  'pages.helpCenter.footer.businessNumberRequired': 'Please enter business number',
  'pages.helpCenter.footer.communicationNumberRequired': 'Please enter communication number',
  'pages.helpCenter.footer.phoneRequired': 'Please enter phone number',
  'pages.helpCenter.footer.emailRequired': 'Please enter email',
  'pages.helpCenter.footer.complaintContactRequired': 'Please enter complaint contact',
  'pages.helpCenter.footer.serviceDescriptionRequired': 'Please enter service description',
  'pages.helpCenter.footer.paymentDescriptionRequired': 'Please enter payment description',
  'pages.helpCenter.languages.korean': '한국어',
  'pages.helpCenter.languages.english': 'English',
  'pages.helpCenter.languages.chinese': '中文',
  'pages.helpCenter.placeholders.koreanInput': 'Enter in Korean',
  'pages.helpCenter.placeholders.englishInput': 'Enter in English',
  'pages.helpCenter.placeholders.chineseInput': '请输入中文',
  'pages.helpCenter.placeholders.koreanHTML': 'Enter HTML content in Korean...',
  'pages.helpCenter.placeholders.englishHTML': 'Enter HTML content in English...',
  'pages.helpCenter.placeholders.chineseHTML': '请输入中文HTML内容...',
  'pages.helpCenter.tooltips.bold': 'Bold',
  'pages.helpCenter.tooltips.italic': 'Italic',
  'pages.helpCenter.tooltips.underline': 'Underline',
  'pages.helpCenter.tooltips.alignLeft': 'Align Left',
  'pages.helpCenter.tooltips.alignCenter': 'Align Center',
  'pages.helpCenter.tooltips.alignRight': 'Align Right',
  'pages.helpCenter.tooltips.orderedList': 'Ordered List',
  'pages.helpCenter.tooltips.unorderedList': 'Unordered List',
  'pages.helpCenter.messages.footerLoadFailed': 'Failed to load footer information',
  'pages.helpCenter.messages.viewHelpSaved': 'View help content has been saved',
  'pages.helpCenter.messages.viewHelpSaveFailed': 'Failed to save view help content',
  'pages.helpCenter.messages.viewHelpLoadFailed': 'Failed to load view help content',
  'pages.helpCenter.messages.guideDeleted': 'Guide has been deleted',
  'pages.helpCenter.messages.guideDeleteFailed': 'Failed to delete guide',
  'pages.helpCenter.messages.guideUpdated': 'Guide has been updated',
  'pages.helpCenter.messages.guideAdded': 'Guide has been added',
  'pages.helpCenter.messages.guideSaveFailed': 'Failed to save guide',
  'pages.helpCenter.messages.categoryDeleteFailed': 'Failed to delete category',
  'pages.helpCenter.messages.categorySaveFailed': 'Failed to save category',
  'pages.helpCenter.messages.categoryLoadFailed': 'Failed to load categories',
  'pages.helpCenter.messages.faqDeleted': 'FAQ has been deleted',
  'pages.helpCenter.messages.faqDeleteFailed': 'Failed to delete FAQ',
  'pages.helpCenter.messages.faqUpdated': 'FAQ has been updated',
  'pages.helpCenter.messages.faqAdded': 'FAQ has been added',
  'pages.helpCenter.messages.faqSaveFailed': 'Failed to save FAQ',
  'pages.helpCenter.messages.faqLoadFailed': 'Failed to load FAQs',
  'pages.helpCenter.messages.paymentMethodDeleted': 'Payment method has been deleted',
  'pages.helpCenter.messages.paymentMethodDeleteFailed': 'Failed to delete payment method',
  'pages.helpCenter.messages.paymentMethodUpdated': 'Payment method has been updated',
  'pages.helpCenter.messages.paymentMethodAdded': 'Payment method has been added',
  'pages.helpCenter.messages.paymentMethodSaveFailed': 'Failed to save payment method',
  'pages.helpCenter.messages.paymentMethodLoadFailed': 'Failed to load payment methods',
  'pages.helpCenter.messages.paymentMethodStatusUpdated': 'Payment method status has been updated',
  'pages.helpCenter.messages.socialLinkDeleted': 'Social link has been deleted',
  'pages.helpCenter.messages.socialLinkDeleteFailed': 'Failed to delete social link',
  'pages.helpCenter.messages.socialLinkUpdated': 'Social link has been updated',
  'pages.helpCenter.messages.socialLinkAdded': 'Social link has been added',
  'pages.helpCenter.messages.socialLinkSaveFailed': 'Failed to save social link',
  'pages.helpCenter.messages.socialLinkLoadFailed': 'Failed to load social links',
  'pages.helpCenter.messages.socialLinkStatusUpdated': 'Social link status has been updated',
  'pages.helpCenter.messages.footerSaved': 'Footer information has been saved',
  'pages.helpCenter.messages.footerSaveFailed': 'Failed to save footer information',
  'pages.helpCenter.messages.guideStatusUpdated': 'Guide status has been updated',
  'pages.helpCenter.messages.faqStatusUpdated': 'FAQ status has been updated',
  'pages.helpCenter.messages.statusUpdateFailed': 'Failed to update status',
  'pages.helpCenter.messages.guideLoadFailed': 'Failed to load guide',
  'pages.helpCenter.forms.viewHelpContent': 'View Help Content',
  'pages.helpCenter.forms.viewHelpContentRequired': 'Please enter view help content',
  'pages.helpCenter.forms.viewHelpContentPlaceholder': 'Enter view help content (HTML supported)',
  'pages.helpCenter.forms.preview': 'Preview',
  'pages.helpCenter.forms.enterContent': 'Enter content',
  'pages.helpCenter.forms.titleMinOneLanguage': 'Please enter title in at least one language',
  'pages.helpCenter.forms.descriptionMinOneLanguage': 'Please enter description in at least one language',

  // Administrators page
  'pages.administrators.title': 'Administrator Management',
  'pages.administrators.id': 'ID',
  'pages.administrators.adminInfo': 'Administrator Info',
  'pages.administrators.name': 'Name',
  'pages.administrators.email': 'Email',
  'pages.administrators.role': 'Role',
  'pages.administrators.role.superadmin': 'Super Admin',
  'pages.administrators.role.admin': 'Admin',
  'pages.administrators.role.manager': 'Manager',
  'pages.administrators.role.staff': 'Staff',
  'pages.administrators.status': 'Status',
  'pages.administrators.status.active': 'Active',
  'pages.administrators.status.inactive': 'Inactive',
  'pages.administrators.status.locked': 'Locked',
  'pages.administrators.lastLogin': 'Last Login',
  'pages.administrators.createdAt': 'Created At',
  'pages.administrators.actions': 'Actions',
  'pages.administrators.detail': 'Detail',
  'pages.administrators.edit': 'Edit',
  'pages.administrators.password': 'Password',
  'pages.administrators.deactivate': 'Deactivate',
  'pages.administrators.activate': 'Activate',
  'pages.administrators.delete': 'Delete',
  'pages.administrators.totalAdmins': 'Total Administrators',
  'pages.administrators.activeAccounts': 'Active Accounts',
  'pages.administrators.inactiveAccounts': 'Inactive Accounts',
  'pages.administrators.superAdmins': 'Super Admins',
  'pages.administrators.list': 'Administrator List',
  'pages.administrators.add': 'Add Administrator',
  'pages.administrators.adminIdNotFound': 'Administrator ID not found',
  'pages.administrators.deleteConfirm': 'Delete Administrator',
  'pages.administrators.deleteConfirmMessage': 'Are you sure you want to delete administrator {name}?',
  'pages.administrators.deleteKeepsLogs': 'The account is removed from the list and can no longer sign in. Its work logs and processing records are kept.',
  'pages.administrators.permissions': 'Permissions',
  'pages.administrators.selectAll': 'Select All',
  'pages.administrators.deselectAll': 'Deselect All',
  'pages.administrators.selected': 'selected',
  'pages.administrators.permissionsSection.todaymallCore': 'Todaymall Core',
  'pages.administrators.permissionsSection.storehouse': 'Warehouse & Logistics',
  'pages.administrators.permissionsSection.settlement': 'Settlement',
  'pages.administrators.permissionsSection.customerService': 'Customer Service',
  'pages.administrators.permissionsSection.system': 'System',
  'pages.administrators.permissions.orders': 'Order Management',
  'pages.administrators.permissions.users': 'User Management',
  'pages.administrators.permissions.products': 'Product Management',
  'pages.administrators.permissions.categories': 'Category Management',
  'pages.administrators.permissions.warehouses': 'Warehouse Management',
  'pages.administrators.permissions.racks': 'Rack Management',
  'pages.administrators.permissions.packages': 'Package Management',
  'pages.administrators.permissions.warehouse-transactions': 'Warehouse Transactions',
  'pages.administrators.permissions.activity-logs': 'Activity Logs',
  'pages.administrators.permissions.settlement': 'Settlement Management',
  'pages.administrators.permissions.help-center': 'Help Center Management',
  'pages.administrators.permissions.banners': 'Banner Management',
  'pages.administrators.permissions.content': 'Content Management',
  'pages.administrators.permissions.general-inquiry': 'General Inquiry Management',
  'pages.administrators.permissions.system': 'System Management',
  'pages.administrators.noPermissions': 'No permissions assigned',
  'pages.administrators.close': 'Close',
  'pages.administrators.passwordReset': 'Password Reset',
  'pages.administrators.currentPassword': 'Current Password',
  'pages.administrators.newPassword': 'New Password',
  'pages.administrators.confirmPassword': 'Confirm Password',
  'pages.administrators.passwordMismatch': 'Passwords do not match',
  'pages.administrators.incorrectCurrentPassword': 'Current password is incorrect',
  'pages.administrators.permissionsMismatch': 'Warning: Sent {sent} permissions but received {returned}. Backend may have modified them.',
  'pages.administrators.form.passwordRequired': 'Please enter password',
  'pages.administrators.form.passwordPlaceholder': 'Password',
  'pages.administrators.form.nameRequired': 'Please enter name',
  'pages.administrators.form.namePlaceholder': 'Name',
  'pages.administrators.form.emailRequired': 'Please enter email',
  'pages.administrators.form.emailInvalid': 'Please enter a valid email',
  'pages.administrators.form.emailPlaceholder': 'Email',
  'pages.administrators.form.newPasswordRequired': 'Please enter new password',
  'pages.administrators.form.newPasswordPlaceholder': 'New password',
  'pages.administrators.form.confirmPasswordRequired': 'Please confirm password',
  'pages.administrators.form.confirmPasswordPlaceholder': 'Confirm password',
  'pages.administrators.form.passwordMinLength': 'Password must be at least 8 characters',
  'pages.administrators.form.currentPasswordRequired': 'Please enter current password',
  'pages.administrators.form.currentPasswordPlaceholder': 'Current password',
  'pages.administrators.form.rolePlaceholder': 'Select role',
  'pages.administrators.addMember': 'Add Member Account',
  'pages.administrators.memberCode': 'Member Code',
  'pages.administrators.memberLevel': 'Member Level',
  'pages.administrators.memberName': 'Member Name',
  'pages.administrators.userId': 'ID',
  'pages.administrators.centerInCharge': 'Center in Charge',
  'pages.administrators.registrationDate': 'Registration Date',
  'pages.administrators.accessRights': 'Access Rights',
  'pages.administrators.deleteConfirmContent': 'Are you sure you want to delete this administrator?',
  'pages.administrators.modal.title': 'Edit member information',
  'pages.administrators.modal.userId': 'id',
  'pages.administrators.modal.memberName': 'name',
  'pages.administrators.modal.memberLevel': 'Administrator level',
  'pages.administrators.modal.password': 'password',
  'pages.administrators.modal.centerInCharge': 'Center in charge',
  'pages.administrators.accessRightsModal.title': 'Modify access permissions',
  'pages.administrators.accessRightsModal.selectAll': 'Select All',
  'pages.administrators.accessRightsModal.accessRights': 'Access rights',
  'pages.administrators.accessRightsModal.menu.agency': 'Agency Comprehensive Management (101)',
  'pages.administrators.accessRightsModal.menu.rocket': 'Rocket Order Management (116)',
  'pages.administrators.accessRightsModal.menu.trade': 'Trade Services (113)',
  'pages.administrators.accessRightsModal.menu.payment': 'Payment agency service (115)',
  
  // New granular permission structure
  'pages.administrators.selectAllSection': 'Select All This Section',
  'pages.administrators.clearAllSection': 'Clear All This Section',
  'pages.administrators.pageName': 'Page Name',
  'pages.administrators.viewPermission': 'View',
  'pages.administrators.editPermission': 'Edit',
  
  // Sections
  'pages.administrators.sections.operation': 'Operation Management',
  'pages.administrators.sections.orders': 'Order Management',
  'pages.administrators.sections.storehouse': 'Storehouse Management',
  'pages.administrators.sections.logistics': 'Logistics Management',
  'pages.administrators.sections.members': 'Member Management',
  'pages.administrators.sections.settlement': 'Settlement Management',
  'pages.administrators.sections.customerService': 'Customer Service',
  'pages.administrators.sections.system': 'System Management',
  
  // Pages
  'pages.administrators.pages.operationData': 'Operation Data',
  'pages.administrators.pages.categories': 'Category Management',
  'pages.administrators.pages.companyMall': 'Company Mall',
  'pages.administrators.pages.liveSellers': 'Live Sellers',
  'pages.administrators.pages.couponPointSettings': 'Coupon/Point Settings',
  'pages.administrators.pages.rebateSettings': 'Rebate Settings',
  'pages.administrators.pages.searchManagement': 'Search Management',
  'pages.administrators.pages.orderStatistics': 'Order Statistics',
  'pages.administrators.pages.userOrders': 'User Orders',
  'pages.administrators.pages.pendingPayment': 'Pending Payment',
  'pages.administrators.pages.orderQuestions': 'Order Questions',
  'pages.administrators.pages.inspectionList': 'Inspection List',
  'pages.administrators.pages.rackManagement': 'Rack Management',
  'pages.administrators.pages.warehouseAddress': 'Warehouse Address',
  'pages.administrators.pages.waybillInformations': 'Waybill Informations',
  'pages.administrators.pages.waybillBandwidth': 'Waybill Bandwidth',
  'pages.administrators.pages.transportationMethods': 'Transportation Methods',
  'pages.administrators.pages.regionalManagement': 'Regional Management',
  'pages.administrators.pages.internationalTracking': 'International Tracking Number',
  'pages.administrators.pages.hsProductCode': 'HS Product Code',
  'pages.administrators.pages.memberStatistics': 'Member Statistics',
  'pages.administrators.pages.generalMembers': 'General Members',
  'pages.administrators.pages.promotionDetail': 'Promotion Detail',
  'pages.administrators.pages.settlementManagement': 'Settlement Management',
  'pages.administrators.pages.memberRechargeReview': 'Deposit Application History',
  'pages.administrators.pages.memberWithdrawalReview': 'Member Withdrawal Review',
  'pages.administrators.pages.financialRecords': 'Financial Records',
  'pages.administrators.pages.deposit': 'Deposit',
  'pages.administrators.pages.coupons': 'Coupons',
  'pages.administrators.pages.oneToOneInquiry': '1:1 Inquiry',
  'pages.administrators.pages.notices': 'Notices',
  'pages.administrators.pages.suggestion': 'Suggestion',
  'pages.administrators.pages.review': 'Review',
  'pages.administrators.pages.helpCenter': 'Help Center',
  'pages.administrators.pages.bannerEvent': 'Banner/Event',
  'pages.administrators.pages.administrators': 'Administrators',
  'pages.administrators.pages.exchangeTariffSetting': 'Exchange/Tariff Setting',
  'pages.administrators.pages.purchaseConditionSetting': 'Purchase Condition Setting',
  'pages.administrators.pages.workerLog': 'Worker Log',
  'pages.administrators.pages.productPriceIncrease': 'Product Price Increase',
  
  // Friendly date formats
  'pages.administrators.justNow': 'Just now',
  'pages.administrators.minutesAgo': '{count} minutes ago',
  'pages.administrators.hoursAgo': '{count} hours ago',
  'pages.administrators.daysAgo': '{count} days ago',
  'pages.administrators.monthsAgo': '{count} months ago',
  'pages.administrators.yearsAgo': '{count} years ago',
  
  // Individual permission labels
  'pages.roles.ordersread': 'Order View',
  'pages.roles.orderswrite': 'Order Edit',
  'pages.roles.ordersdelete': 'Order Delete',
  'pages.roles.ordersfulfill': 'Order Process',
  'pages.roles.ordersinquiry': 'Order Inquiry',
  'pages.roles.usersread': 'Member View',
  'pages.roles.userswrite': 'Member Edit',
  'pages.roles.usersdelete': 'Member Delete',
  'pages.roles.productsread': 'Product View',
  'pages.roles.productswrite': 'Product Create',
  'pages.roles.productswriteedit': 'Product Edit',
  'pages.roles.productsdelete': 'Product Delete',
  'pages.roles.productssync': 'Product Sync',
  'pages.roles.categoriesread': 'Category View',
  'pages.roles.categorieswrite': 'Category Edit',
  'pages.roles.categoriesdelete': 'Category Delete',
  'pages.roles.warehousesread': 'Warehouse View',
  'pages.roles.warehouseswrite': 'Warehouse Edit',
  'pages.roles.racksread': 'Rack View',
  'pages.roles.rackswrite': 'Rack Edit',
  'pages.roles.packagesread': 'Package View',
  'pages.roles.packageswrite': 'Package Edit',
  'pages.roles.warehousetransactionsread': 'Warehouse Transactions View',
  'pages.roles.activitylogsread': 'Activity Logs View',
  'pages.roles.settlementread': 'Settlement View',
  'pages.roles.settlementwrite': 'Settlement Process',
  'pages.roles.helpcenterread': 'Help Center View',
  'pages.roles.helpcenterwrite': 'Help Center Edit',
  'pages.roles.helpcenterdelete': 'Help Center Delete',
  'pages.roles.bannersread': 'Banner View',
  'pages.roles.bannerswrite': 'Banner Edit',
  'pages.roles.bannersdelete': 'Banner Delete',
  'pages.roles.contentwrite': 'Content Edit',
  'pages.roles.contentdelete': 'Content Delete',
  'pages.roles.generalinquiry': 'General Inquiry',
  'pages.roles.adminsread': 'Admin View',
  'pages.roles.adminswrite': 'Admin Edit',
  'pages.roles.adminsdelete': 'Admin Delete',
  'pages.roles.permissionsmanage': 'Permission Manage',
  'pages.roles.settingsread': 'Settings View',
  'pages.roles.settingswrite': 'Settings Edit',
  'pages.administrators.createSuccess': 'Administrator has been added',
  'pages.administrators.createFailed': 'Failed to add administrator',
  'pages.administrators.updateSuccess': 'Administrator information has been updated',
  'pages.administrators.updateFailed': 'Failed to update administrator',
  'pages.administrators.deleteSuccess': 'Administrator has been deleted',
  'pages.administrators.deleteFailed': 'Failed to delete administrator',
  'pages.administrators.phone': 'Phone',
  'pages.administrators.username': 'Username',
  'pages.administrators.usernamePlaceholder': 'admin001',
  'pages.administrators.usernameRequired': 'Please enter username',
  'pages.administrators.department': 'Department',
  'pages.administrators.department.management': 'Management',
  'pages.administrators.department.sales': 'Sales',
  'pages.administrators.department.cs': 'Customer Support',
  'pages.administrators.department.logistics': 'Logistics',
  'pages.administrators.department.it': 'IT',
  'pages.administrators.departmentPlaceholder': 'Select department',
  'pages.administrators.newThisMonth': 'New This Month',
  'pages.administrators.detailTitle': 'Administrator Details',
  'pages.administrators.basicInfo': 'Basic Information',
  'pages.administrators.passwordChange': 'Password (Enter only if changing)',
  'pages.administrators.passwordChangePlaceholder': 'Enter password if you want to change it',
  'pages.administrators.rolePlaceholder': 'Select role',
  'pages.administrators.statusActive': 'Active',
  'pages.administrators.statusInactive': 'Inactive',
  'pages.administrators.mock.name': 'John Doe',
  'pages.admins.adminIdNotFound': 'Administrator ID not found',
  'pages.admins.deleteAdmin': 'Delete Administrator',
  'pages.admins.deleteAdminContent': 'Are you sure you want to delete administrator "{name}"?',
  'pages.admins.resetPassword': 'Reset Password',
  'pages.admins.resetPasswordContent': 'Are you sure you want to reset password for administrator "{name}"?',
  'pages.admins.resetPasswordSuccess': 'Password has been reset',
  'pages.admins.adminInfo': 'Administrator Info',
  'pages.admins.email': 'Email',
  'pages.admins.role': 'Role',
  'pages.admins.role.superadmin': 'Super Administrator',
  'pages.admins.role.admin': 'Administrator',
  'pages.admins.role.manager': 'Manager',
  'pages.admins.role.staff': 'Staff',
  'pages.admins.department': 'Department',
  'pages.admins.department.management': 'Management',
  'pages.admins.department.sales': 'Sales',
  'pages.admins.department.cs': 'Customer Support',
  'pages.admins.department.logistics': 'Logistics',
  'pages.admins.department.it': 'IT',
  'pages.admins.status': 'Status',
  'pages.admins.status.active': 'Active',
  'pages.admins.status.inactive': 'Inactive',
  'pages.admins.lastLogin': 'Last Login',
  'pages.admins.createdAt': 'Created At',
  'pages.admins.actions': 'Actions',
  'pages.admins.detail': 'Detail',
  'pages.admins.edit': 'Edit',
  'pages.admins.delete': 'Delete',

  // Rates page
  'pages.rates.title': 'Exchange Rate/Tariff Settings',
  'pages.rates.currentExchangeRate': 'Current Exchange Rate (Overseas Direct CNY)',
  'pages.rates.basicTariffRate': 'Basic Tariff Rate',
  'pages.rates.vatRate': 'VAT Rate',
  'pages.rates.exchangeRateInfo': 'Exchange Rate and Tariff Information',
  'pages.rates.exchangeRateInfoDesc': 'Exchange rates are automatically updated daily and can be manually adjusted. Tariff rates may vary by product category.',
  'pages.rates.exchangeRateSettings': 'Exchange Rate Settings',
  'pages.rates.tariffSettings': 'Tariff Settings',
  'pages.rates.exchangeRateHistory': 'Exchange Rate History',
  'pages.rates.date': 'Date',
  'pages.rates.rate': 'Exchange Rate',
  'pages.rates.change': 'Change',
  'pages.rates.cny': 'Overseas Direct — Chinese Yuan (CNY)',
  'pages.rates.cnyLive': 'Live — Chinese Yuan (CNY)',
  'pages.rates.cnyOwnmall': 'Own Mall — Chinese Yuan (CNY)',
  'pages.rates.cnySegmentHint': 'Live and own-mall rates apply to newly registered products, products whose cost is edited, and new orders. Costs of existing products do not change.',
  'pages.rates.cnyLiveShort': 'Live',
  'pages.rates.cnyOwnmallShort': 'Own Mall',
  'pages.rates.usd': 'US Dollar (USD)',
  'pages.rates.jpy': 'Japanese Yen (JPY)',
  'pages.rates.eur': 'Euro (EUR)',
  'pages.rates.basicTariff': 'Basic Tariff Rate',
  'pages.rates.vat': 'VAT Rate',
  'pages.rates.specialTariff': 'Special Tariff Rate (Electronics)',
  'pages.rates.luxuryTariff': 'Luxury Goods Tariff Rate',
  'pages.rates.reset': 'Reset',
  'pages.rates.save': 'Save',
  'pages.rates.saveSuccess': 'Exchange rate and tariff settings have been saved',
  'pages.rates.saveError': 'Failed to save exchange rates',
  'pages.rates.loadError': 'Failed to load exchange rates',
  'pages.rates.noRatesToUpdate': 'No rates to update',
  'pages.rates.rateRequired': 'Please enter exchange rate',
  'pages.rates.saveExchangeRates': 'Save Exchange Rates',
  'pages.rates.saveTariff': 'Save Tariff Settings',
  'pages.rates.resetTariff': 'Reset Tariff',
  'pages.rates.noTariffToUpdate': 'No valid tariff rates to update',
  'pages.rates.tariffSaveSuccess': 'Tariff settings saved successfully',
  'pages.rates.tariffSaveError': 'Failed to save tariff settings',

  // Additional Cost Settings page
  'pages.settings.additionalCost.title': 'Additional Cost Settings',
  'pages.settings.additionalCost.description': 'Configure additional costs that will be applied to orders',
  'pages.settings.additionalCost.simplifiedCustomsClearance': 'Simplified Customs Clearance (₩)',
  'pages.settings.additionalCost.simplifiedCustomsClearanceRequired': 'Please enter the cost',
  'pages.settings.additionalCost.designatedShooting': 'Designated Shooting (₩)',
  'pages.settings.additionalCost.designatedShootingRequired': 'Please enter the cost',
  'pages.settings.additionalCost.saveSuccess': 'Settings saved successfully',
  'pages.settings.additionalCost.saveFailed': 'Failed to save settings',

  // Purchase Condition Settings page
  'pages.purchaseConditionSettings.title': 'Purchase Condition Settings',
  'pages.purchaseConditionSettings.limitPrice.title': 'Price Limit',
  'pages.purchaseConditionSettings.limitPrice.label': 'Automatic Purchase Price Limit (KRW)',
  'pages.purchaseConditionSettings.limitPrice.required': 'Please enter price limit',
  'pages.purchaseConditionSettings.limitPrice.min': 'Price limit must be 0 or greater',
  'pages.purchaseConditionSettings.limitPrice.tooltip': 'Orders above this amount will be processed as manual purchase',
  'pages.purchaseConditionSettings.limitPrice.description': 'Orders with amount equal to or above this value will be processed as manual purchase instead of automatic purchase.',
  'pages.purchaseConditionSettings.userMemo.title': 'User Memo Status',
  'pages.purchaseConditionSettings.userMemo.enabled': 'Enable User Memo Based Condition',
  'pages.purchaseConditionSettings.userMemo.keywords': 'Keywords (comma-separated)',
  'pages.purchaseConditionSettings.userMemo.keywordsTooltip': 'Orders with user memo containing these keywords will be processed as manual purchase',
  'pages.purchaseConditionSettings.userMemo.keywordsPlaceholder': 'e.g., urgent, important, check',
  'pages.purchaseConditionSettings.userMemo.description': 'Orders with user memo containing the specified keywords will be processed as manual purchase.',
  'pages.purchaseConditionSettings.sensitiveProducts.title': 'Sensitive Products List',
  'pages.purchaseConditionSettings.sensitiveProducts.add': 'Add Sensitive Product',
  'pages.purchaseConditionSettings.sensitiveProducts.empty': 'No sensitive products',
  'pages.purchaseConditionSettings.sensitiveProducts.description': 'Products registered in this list will be processed as manual purchase instead of automatic purchase.',
  'pages.purchaseConditionSettings.table.productName': 'Product Name',
  'pages.purchaseConditionSettings.table.productId': 'Product ID',
  'pages.purchaseConditionSettings.table.url': 'URL',
  'pages.purchaseConditionSettings.table.reason': 'Reason',
  'pages.purchaseConditionSettings.modal.addTitle': 'Add Sensitive Product',
  'pages.purchaseConditionSettings.modal.editTitle': 'Edit Sensitive Product',
  'pages.purchaseConditionSettings.modal.productName': 'Product Name',
  'pages.purchaseConditionSettings.modal.productNameRequired': 'Please enter product name',
  'pages.purchaseConditionSettings.modal.productId': 'Product ID',
  'pages.purchaseConditionSettings.modal.url': 'Product URL',
  'pages.purchaseConditionSettings.modal.reason': 'Reason',
  'pages.purchaseConditionSettings.saveSuccess': 'Purchase condition settings have been saved',
  'pages.purchaseConditionSettings.saveError': 'Failed to save purchase condition settings',
  'pages.purchaseConditionSettings.productAdded': 'Sensitive product has been added',
  'pages.purchaseConditionSettings.productUpdated': 'Sensitive product has been updated',
  'pages.purchaseConditionSettings.productDeleted': 'Sensitive product has been deleted',
  'pages.purchaseConditionSettings.deleteConfirm': 'Are you sure you want to delete this sensitive product?',
  'pages.purchaseConditionSettings.amountThreshold.title': 'Amount Threshold',
  'pages.purchaseConditionSettings.amountThreshold.label': 'Automatic Purchase Amount Threshold (KRW)',
  'pages.purchaseConditionSettings.amountThreshold.currentValue': 'Current Value',
  'pages.purchaseConditionSettings.amountThreshold.required': 'Please enter amount threshold',
  'pages.purchaseConditionSettings.amountThreshold.min': 'Amount threshold must be 0 or greater',
  'pages.purchaseConditionSettings.amountThreshold.tooltip': 'Orders above this amount will be processed as manual purchase',
  'pages.purchaseConditionSettings.amountThreshold.description': 'Orders with amount equal to or above this value will be processed as manual purchase instead of automatic purchase.',
  'pages.purchaseConditionSettings.memoKeywords.title': 'Memo Keywords',
  'pages.purchaseConditionSettings.memoKeywords.label': 'Memo Keywords',
  'pages.purchaseConditionSettings.memoKeywords.tooltip': 'Orders with memo containing these keywords will be processed as manual purchase',
  'pages.purchaseConditionSettings.memoKeywords.placeholder': 'Enter keyword and press Enter or click Add button',
  'pages.purchaseConditionSettings.memoKeywords.empty': 'No keywords',
  'pages.purchaseConditionSettings.memoKeywords.description': 'Orders with memo containing the specified keywords will be processed as manual purchase.',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.title': 'Sensitive Product Offer IDs',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.label': 'Sensitive Product Offer IDs',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.tooltip': 'Orders containing these offer IDs will be processed as manual purchase',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.placeholder': 'Enter offer ID and press Enter or click Add button',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.empty': 'No offer IDs',
  'pages.purchaseConditionSettings.sensitiveProductOfferIds.description': 'Orders containing offer IDs registered in this list will be processed as manual purchase instead of automatic purchase.',
  'pages.purchaseConditionSettings.info.title': 'Settings Information',
  'pages.purchaseConditionSettings.info.lastUpdatedBy': 'Last Updated By',
  'pages.purchaseConditionSettings.info.updatedAt': 'Last Updated At',
  'pages.purchaseConditionSettings.loadError': 'Failed to load settings',

  // Shipping Rate page
  'pages.shippingRate.title': 'Shipping Rate',
  'pages.shippingRate.registrationButton': 'Shipping rate registration',
  'pages.shippingRate.deleteCenterPlaceholder': '= Delete rate by center',
  'pages.shippingRate.deleteButton': 'delete',
  'pages.shippingRate.deleteConfirm': 'Are you sure you want to delete all rates for this center?',
  'pages.shippingRate.deleteSuccess': 'Rates deleted successfully',
  'pages.shippingRate.deleteError': 'Failed to delete rates',
  'pages.shippingRate.selectCenterToDelete': 'Please select a center to delete',
  'pages.shippingRate.weight': 'weight',
  'pages.shippingRate.basicMember': 'Basic Member',
  'pages.shippingRate.shippingAgencyVIP': 'Shipping Agency VIP',
  'pages.shippingRate.shippingAgencySVIP': 'Shipping agency SVIP',
  'pages.shippingRate.purchasingAgent': 'purchasing agent',
  'pages.shippingRate.vipPurchasingAgent': 'VIP purchasing agent',
  'pages.shippingRate.ttBusinessOperator': 'TT business operator',
  'pages.shippingRate.ttVIP': 'TT VIP',
  'pages.shippingRate.ttIndividual': 'TT Individual',
  'pages.shippingRate.registrationModalTitle': '배송비요율 등록',
  'pages.shippingRate.centerShippingMethod': 'Center/Shipping Method',
  'pages.shippingRate.centerRequired': 'Please select center/shipping method',
  'pages.shippingRate.selectCenter': '= Select',
  'pages.shippingRate.membershipLevel': 'Membership Level',
  'pages.shippingRate.membershipLevelRequired': 'Please select membership level',
  'pages.shippingRate.selectMembershipLevel': '= Select',
  'pages.shippingRate.startEndWeight': 'Start ~ End Weight',
  'pages.shippingRate.startWeight': 'Start Weight',
  'pages.shippingRate.endWeight': 'End Weight',
  'pages.shippingRate.startWeightRequired': 'Please enter start weight',
  'pages.shippingRate.endWeightRequired': 'Please enter end weight',
  'pages.shippingRate.weightInterval': 'Weight Interval',
  'pages.shippingRate.weightIntervalRequired': 'Please select weight interval',
  'pages.shippingRate.selectWeightInterval': 'Select weight interval',
  'pages.shippingRate.startingAmount': 'Starting Amount',
  'pages.shippingRate.startingAmountRequired': 'Please enter starting amount',
  'pages.shippingRate.amountInterval': 'Amount Interval',
  'pages.shippingRate.amountIntervalRequired': 'Please enter amount interval',
  'pages.shippingRate.registrationSuccess': 'Shipping rate registered successfully',
  'pages.shippingRate.registrationError': 'Failed to register shipping rate',
  'pages.shippingRate.updateSuccess': 'Shipping rate updated successfully',
  'pages.shippingRate.updateError': 'Failed to update shipping rate',
  'pages.shippingRate.deleteRuleConfirm': 'Are you sure you want to delete this shipping rate rule?',
  'pages.shippingRate.editModalTitle': 'Edit Shipping Rate Rule',
  'pages.shippingRate.noData': 'No rates registered yet',
  'pages.shippingRate.selectRoute': 'Select route to edit/delete',
  'pages.shippingRate.route.weihaiShip': 'China/Weihai/Ship',
  'pages.shippingRate.route.weihaiAir': 'China/Weihai/Air',
  'pages.shippingRate.route.qingdaoShip': 'China/Qingdao/Ship',
  'pages.shippingRate.route.qingdaoAir': 'China/Qingdao/Air',
  'pages.shippingRate.route.guangzhouShip': 'China/Guangzhou/Ship',
  'pages.shippingRate.route.guangzhouAir': 'China/Guangzhou/Air',

  // Roles page
  'pages.roles.title': 'Role Management',
  'pages.roles.list': 'Role List',
  'pages.roles.add': 'Add Role',
  'pages.roles.edit': 'Edit Role',
  'pages.roles.delete': 'Delete Role',
  'pages.roles.id': 'ID',
  'pages.roles.name': 'Role Name',
  'pages.roles.code': 'Role Code',
  'pages.roles.description': 'Description',
  'pages.roles.userCount': 'User Count',
  'pages.roles.permissionCount': 'Permission Count',
  'pages.roles.status': 'Status',
  'pages.roles.createdAt': 'Created At',
  'pages.roles.actions': 'Actions',
  'pages.roles.permissionSettings': 'Permission Settings',
  'pages.roles.ordersManagement': 'Order Management',
  'pages.roles.ordersView': 'View Orders',
  'pages.roles.ordersEdit': 'Edit Orders',
  'pages.roles.ordersDelete': 'Delete Orders',
  'pages.roles.membersManagement': 'Member Management',
  'pages.roles.membersView': 'View Members',
  'pages.roles.membersEdit': 'Edit Members',
  'pages.roles.membersDelete': 'Delete Members',
  'pages.roles.productsManagement': 'Product Management',
  'pages.roles.productsView': 'View Products',
  'pages.roles.productsCreate': 'Create Products',
  'pages.roles.productsEdit': 'Edit Products',
  'pages.roles.productsDelete': 'Delete Products',
  'pages.roles.settlementManagement': 'Settlement Management',
  'pages.roles.settlementView': 'View Settlement',
  'pages.roles.settlementProcess': 'Process Settlement',
  'pages.roles.systemManagement': 'System Management',
  'pages.roles.systemAdmins': 'Admin Management',
  'pages.roles.systemRoles': 'Role Management',
  'pages.roles.systemSettings': 'System Settings',
  'pages.roles.status.active': 'Active',
  'pages.roles.status.inactive': 'Inactive',
  'pages.roles.form.nameRequired': 'Please enter role name',
  'pages.roles.form.codeRequired': 'Please enter role code',
  'pages.roles.form.namePlaceholder': 'e.g., Administrator',
  'pages.roles.form.codePlaceholder': 'e.g., ADMIN',
  'pages.roles.form.descriptionPlaceholder': 'Enter description for the role',
  'pages.roles.deleteConfirm': 'Delete Role',
  'pages.roles.deleteConfirmMessage': 'Are you sure you want to delete role "{name}"?',
  'pages.roles.deleteSuccess': 'Role deleted successfully',
  'pages.roles.updateSuccess': 'Role updated successfully',
  'pages.roles.createSuccess': 'Role created successfully',
  'pages.roles.unit.people': ' people',
  'pages.roles.unit.items': ' items',
  'pages.roles.mock.superAdmin': 'Super Administrator',
  'pages.roles.mock.superAdminDesc': 'Super administrator with all permissions',
  'pages.roles.mock.admin': 'Administrator',
  'pages.roles.mock.adminDesc': 'Administrator with most management permissions',
  'pages.roles.mock.manager': 'Manager',
  'pages.roles.mock.managerDesc': 'Order and member management permissions',
  'pages.roles.mock.csStaff': 'CS Staff',
  'pages.roles.mock.csStaffDesc': 'Customer support related permissions',

  // Additional permission keys
  'pages.roles.dashboard': 'Dashboard',
  'pages.roles.dashboardView': 'View Dashboard',
  'pages.roles.todaymall': 'TodayMall',
  'pages.roles.todayggigu': 'TodayGgigu',
  'pages.roles.permissionView': 'View Only',
  'pages.roles.permissionEdit': 'Edit',
  'pages.roles.productsCategory': 'Manage Categories',
  'pages.roles.productsImport': 'Import Taobao Products',
  'pages.roles.ordersUser': 'User Orders',
  'pages.roles.ordersBusiness': 'Business Orders',
  'pages.roles.ordersVvic': 'VVIC Orders',
  'pages.roles.ordersRocket': 'Rocket Orders',
  'pages.roles.ordersPendingPayment': 'Pending Payment',
  'pages.roles.ordersPendingAddress': 'Pending Address',
  'pages.roles.ordersInChinaWarehouse': 'In China Warehouse',
  'pages.roles.ordersInKoreaDelivery': 'In Korea Delivery',
  'pages.roles.ordersCompleted': 'Completed Orders',
  'pages.roles.ordersNoData': 'No Data Orders',
  'pages.roles.ordersQuestions': 'Order Questions',
  'pages.roles.ordersInventoryQuestions': 'Inventory Questions',
  'pages.roles.membersGeneral': 'General Members',
  'pages.roles.membersBusiness': 'Business Members',
  'pages.roles.membersBlacklist': 'Blacklist Members',
  'pages.roles.membersCoupons': 'Coupon Management',
  'pages.roles.membersCouponPointSettings': 'Coupon Point Settings',
  'pages.roles.membersPoints': 'Points Management',
  'pages.roles.membersRebate': 'Rebate Management',
  'pages.roles.membersDeposit': 'Deposit Management',
  'pages.roles.storehouseManagement': 'Storehouse Management',
  'pages.roles.storehouseView': 'View Storehouse',
  'pages.roles.storehouseExpressInspection': 'Express Inspection',
  'pages.roles.storehouseNonMasterCourier': 'Non-Master Courier',
  'pages.roles.storehouseInspectionList': 'Inspection List',
  'pages.roles.storehouseRack': 'Rack Management',
  'pages.roles.storehouseWarehouseAddress': 'Warehouse Address',
  'pages.roles.logisticsManagement': 'Logistics Management',
  'pages.roles.logisticsView': 'View Logistics',
  'pages.roles.logisticsBatchTracking': 'Batch Tracking',
  'pages.roles.logisticsForwarders': 'Forwarders',
  'pages.roles.logisticsShippingRate': 'Shipping Rate Rules',
  'pages.roles.logisticsInternationalTracking': 'International Tracking',
  'pages.roles.settlementSellers': 'Sellers Settlement',
  'pages.roles.settlementPlatform': 'Platform Settlement',
  'pages.roles.settlementCoupons': 'Coupons Settlement',
  'pages.roles.settlementPriceIncrease': 'Price Increase',
  'pages.roles.settlementServiceFee': 'Service Fee',
  'pages.roles.csManagement': 'Customer Service Management',
  'pages.roles.csView': 'View CS',
  'pages.roles.csInquiries': 'Inquiries',
  'pages.roles.csNotices': 'Notices',
  'pages.roles.csLookingForOwner': 'Looking For Owner',
  'pages.roles.csReviews': 'Reviews',
  'pages.roles.csHelp': 'Help Center',
  'pages.roles.csBanners': 'Banner Management',
  'pages.roles.csEmailManagement': 'Email Management',
  'pages.roles.systemRates': 'Exchange Rates',
  'pages.roles.systemPurchaseCondition': 'Purchase Condition Settings',
  'pages.roles.systemShippingRate': 'Shipping Rate Settings',

  // System Settings page
  'pages.systemSettings.title': 'System Management',
  'pages.systemSettings.breadcrumb.system': 'System',
  'pages.systemSettings.breadcrumb.settings': 'System Management',
  'pages.systemSettings.tab.admins': 'Administrator Accounts',
  'pages.systemSettings.tab.roles': 'Role Management',
  'pages.systemSettings.admins.title': 'Administrator Account Management',
  'pages.systemSettings.admins.description': 'Add, edit, delete administrators and set permissions',
  'pages.systemSettings.roles.title': 'Role and Permission Management',
  'pages.systemSettings.roles.description': 'Create roles and assign permissions',

  // Notification Icon
  'pages.notification.title': 'Notifications',
  'pages.notification.orderInquiryMessage': 'New order inquiry message has arrived.',
  'pages.notification.generalInquiryMessage': 'New 1:1 inquiry message has arrived.',
  'pages.notification.orderInquiries': 'Order Inquiries',
  'pages.notification.generalInquiries': '1:1 Inquiries',
  'pages.notification.inventoryInquiries': 'Inventory Inquiries',
  'pages.notification.depositApplication': 'Deposit Application',
  'pages.notification.bankTransferPayment': 'Bank Transfer Payment',
  'pages.notification.unit.items': ' items',
  'pages.notification.clickToView': 'Click to view',

  // Additional Cost Modal
  'pages.additionalCost.title': '■ Register Additional Proxy Cost',
  'pages.additionalCost.save': 'Save',
  'pages.additionalCost.close': 'Close',
  'pages.additionalCost.saveSuccess': 'Additional cost has been saved',
  'pages.additionalCost.orderInfo': 'Order Information',
  'pages.additionalCost.orderNumberMemberName': 'Order Number / Member Name',
  'pages.additionalCost.center': 'Center',
  'pages.additionalCost.additionalCost': 'Additional Cost',
  'pages.additionalCost.vvicCost': 'VVIC Additional Cost',
  'pages.additionalCost.purchaseCost': 'Purchase Proxy Additional Cost',
  'pages.additionalCost.shippingCost': 'Shipping Proxy Additional Cost',
  'pages.additionalCost.saved': 'Additional cost has been saved',
  'pages.additionalCost.productInformation': 'Product Information',
  'pages.additionalCost.productNo': 'Product Number',
  'pages.additionalCost.productName': 'Product Name',
  'pages.additionalCost.image': 'Image',
  'pages.additionalCost.quantity': 'Quantity',
  'pages.additionalCost.trackingNumber': 'Tracking Number',
  'pages.additionalCost.status': 'Status',
  'pages.additionalCost.customsClearance': 'Customs Clearance List',
  'pages.additionalCost.actualInspection': 'Actual Inspection',
  'pages.additionalCost.viewActualInspection': 'View Actual Inspection',
  'pages.additionalCost.adminMemo': 'Administrator Memo',
  'pages.additionalCost.additionalServices': 'Additional Services',
  'pages.additionalCost.boxCount': 'Box Count',
  'pages.additionalCost.box': 'Box',
  'pages.additionalCost.appliedExchangeRate': 'Applied Exchange Rate',
  'pages.additionalCost.totalAmount': 'Total Amount',
  'pages.additionalCost.totalQuantityAmount': 'Total Quantity / Total Amount',
  'pages.additionalCost.items': 'items',
  'pages.additionalCost.recipientAddress': 'Recipient Address',
  'pages.additionalCost.destination': 'South Korea - Incheon',
  'pages.additionalCost.smsNotSend': 'Do not send SMS',
  'pages.additionalCost.smsSend': 'Send SMS',

  // Barcode Scan Modal
  'pages.barcodeScan.title.receiving': 'Receiving Scan',
  'pages.barcodeScan.title.rackAssignment': 'Rack Assignment',
  'pages.barcodeScan.warehouse.guangzhou': 'Guangzhou',
  'pages.barcodeScan.warehouse.weihai': 'Weihai',
  'pages.barcodeScan.warehouse.qingdao': 'Qingdao',
  'pages.barcodeScan.warehouse.yiwu': 'Yiwu',
  'pages.barcodeScan.rackSize.small': 'Small',
  'pages.barcodeScan.rackSize.medium': 'Medium',
  'pages.barcodeScan.rackSize.large': 'Large',
  'pages.barcodeScan.trackingNumber': 'Tracking Number',
  'pages.barcodeScan.trackingNumberPlaceholder': 'Tracking Number',
  'pages.barcodeScan.depositAmount': 'COD Amount (Yuan)',
  'pages.barcodeScan.orderNumber': 'Order Number',
  'pages.barcodeScan.orderNumberLabel': 'Order Number:',
  'pages.barcodeScan.rackNumber': 'Rack Number',
  'pages.barcodeScan.changeRack': 'Change Rack',
  'pages.barcodeScan.receivedTime': 'Received Time',
  'pages.barcodeScan.operator': 'Operator',
  'pages.barcodeScan.scanComplete': 'Barcode scan complete: {value}',
  'pages.barcodeScan.scanError': 'An error occurred during barcode scanning',
  'pages.barcodeScan.trackingNumberRequired': 'Please enter tracking number',
  'pages.barcodeScan.ordersFound': 'Found {count} orders',
  'pages.barcodeScan.registered': 'Registered: {value}',
  'pages.barcodeScan.scannerDeviceInstruction': 'Please scan barcode with scanner device',
  'pages.barcodeScan.deleted': 'Deleted',
  'pages.barcodeScan.checkLabel': '{orderNo} Check Label',
  'pages.barcodeScan.recheck': 'Recheck',
  'pages.barcodeScan.rackSaveComplete': '{orderNo} Rack saved',
  'pages.barcodeScan.reset': 'Reset',
  'pages.barcodeScan.selectWarehouse': 'Select Warehouse',
  'pages.barcodeScan.warehouseLoadError': 'Failed to load warehouses',
  'pages.barcodeScan.invoiceImages': 'Invoice Images',
  'pages.barcodeScan.upload': 'Upload',
  'pages.barcodeScan.onlyImagesAllowed': 'Only image files are allowed',
  'pages.barcodeScan.imageSizeLimit': 'Image must be smaller than 10MB',
  'pages.barcodeScan.maxImagesReached': 'Maximum 10 images allowed',
  'pages.barcodeScan.takePhoto': 'Take Photo',
  'pages.barcodeScan.capture': 'Capture',
  'pages.barcodeScan.cameraNotReady': 'Camera not ready',
  'pages.barcodeScan.captureFailed': 'Failed to capture photo',
  'pages.barcodeScan.photoCaptured': 'Photo captured successfully',
  'pages.barcodeScan.warehouseRequired': 'Please select a warehouse',
  'pages.barcodeScan.registerError': 'Failed to register receipt',
  'pages.barcodeScan.recheckButton': 'Recheck',
  'pages.barcodeScan.save': 'Save',
  'pages.barcodeScan.cancel': 'Cancel',
  'pages.barcodeScan.register': 'Register',
  'pages.barcodeScan.receivingScan': 'Receiving Scan',
  'pages.barcodeScan.selectScanMethod': 'Select scan method',
  'pages.barcodeScan.cameraScan': '📷 Camera Scan',
  'pages.barcodeScan.scannerDevice': '🔫 Scanner Device',
  'pages.barcodeScan.scannerWaiting': 'Waiting for scanner device...',
  'pages.barcodeScan.scannerInstruction': 'Please scan barcode with barcode scanner',
  'pages.barcodeScan.frameInstruction': 'Please align barcode within the frame',
  'pages.barcodeScan.close': 'Close',
  'pages.barcodeScan.search': 'Search Q',
  'pages.barcodeScan.rackAssignment': 'Rack Assignment',
  'pages.barcodeScan.receiptLabel': 'Receipt Label',
  'pages.barcodeScan.trackingNumberColon': 'Tracking Number:',

  // Label Management Modal
  'pages.labelManagement.title': 'Packaging Management',
  'pages.labelManagement.orderNumberRequired': 'Please enter order number',
  'pages.labelManagement.ordersFound': 'Found {count} orders',
  'pages.labelManagement.orderDetail': '{trackingNumber} Details',
  'pages.labelManagement.orderNumber': 'Order Number',
  'pages.labelManagement.orderNumberPlaceholder': 'Order Number',
  'pages.labelManagement.orderNumberColon': 'Order Number:',
  'pages.labelManagement.search': 'Search Q',
  'pages.labelManagement.detail': 'Detail',
  'pages.labelManagement.customer': 'Customer',
  'pages.labelManagement.recipient': 'Recipient',
  'pages.labelManagement.trackingNumber': 'Tracking Number',
  'pages.labelManagement.searchInstruction': 'Search by order number to view packaging information',
  'pages.labelManagement.menu.logout': 'Logout',
  'pages.labelManagement.menu.warehouseScan': 'Warehouse Scan/Inventory',
  'pages.labelManagement.menu.rackManagement': 'Rack Transport Management',
  'pages.labelManagement.menu.labelManagement': 'Packaging Management',
  'pages.labelManagement.menu.shippingScan': 'Shipping Scan',
  'pages.labelManagement.menu.title': 'Menu',
  'pages.labelManagement.message.logout': 'Logout',
  'pages.labelManagement.message.warehouseScan': 'Navigate to Warehouse Scan/Inventory page',
  'pages.labelManagement.message.rackManagement': 'Navigate to Rack Transport Management page',
  'pages.labelManagement.message.labelManagement': 'Navigate to Packaging Management page',
  'pages.labelManagement.message.shippingScan': 'Navigate to Shipping Scan page',
  'pages.labelManagement.warehouse.guangzhou': 'Guangzhou',
  'pages.labelManagement.warehouse.weihei': 'Weihei',
  'pages.labelManagement.warehouse.qingdao': 'Qingdao',
  'pages.labelManagement.warehouse.yiwu': 'Yiwu',
  'pages.labelManagement.labelPrinting': 'Preparing to print label for {trackingNumber}...',
  'pages.labelManagement.mock.recipient1': 'Kim Deok-hwa',
  'pages.labelManagement.mock.recipient2': 'Kim Hye-rim',
  'pages.labelManagement.mock.recipient3': 'Oh Hye-mi',
  'pages.labelManagement.mock.recipient4': 'Bang Jung-young',

  // Order Log Modal
  'pages.orderLog.title': '■ Order Log - Order Number: {orderNo}',
  'pages.orderLog.close': 'Close',
  'pages.orderLog.columns.no': 'No',
  'pages.orderLog.columns.time': 'Time',
  'pages.orderLog.columns.status': 'Status',
  'pages.orderLog.columns.content': 'Content',
  'pages.orderLog.columns.detail': 'Detail',
  'pages.orderLog.columns.processor': 'Processor',
  'pages.orderLog.noLogs': 'No log records',
  'pages.orderLog.memo': 'Memo:',
  'pages.orderLog.system': 'System',
  'pages.orderLog.orderNotFound': 'Order not found',
  'pages.orderLog.orderIdNotFound': 'Order ID not found',
  'pages.orderLog.fetchError': 'Failed to fetch order status history',

  // Output Scan Modal
  'pages.outputScan.title': 'Output Scan',
  'pages.outputScan.searchPlaceholder': 'Search',
  'pages.outputScan.searchRequired': 'Please enter search term',
  'pages.outputScan.ordersFound': 'Found {count} orders',
  'pages.outputScan.paymentComplete': 'Payment Complete',
  'pages.outputScan.waitingForOutput': 'Waiting for Output',
  'pages.outputScan.tab.pyeongtaek': 'Pyeongtaek',
  'pages.outputScan.tab.incheon': 'Incheon',
  'pages.outputScan.tab.air': 'Air',
  'pages.outputScan.paymentCompleteSelected': 'Payment Complete - {tab} selected',
  'pages.outputScan.waitingForOutputSelected': 'Waiting for Output - {tab} selected',
  'pages.outputScan.totalQuantity': 'Total Quantity',
  'pages.outputScan.totalWeight': 'Total Weight',
  'pages.outputScan.trackingNumberPlaceholder': 'Tracking Number',
  'pages.outputScan.trackingNumberRequired': 'Please enter tracking number',
  'pages.outputScan.moved': 'Moved',
  'pages.outputScan.move': 'Move',
  'pages.outputScan.orderNumberColon': 'Order Number:',
  'pages.outputScan.recipient': 'Recipient',
  'pages.outputScan.boxCountWeight': 'Box Count / Weight',
  'pages.outputScan.trackingNumber': 'Tracking Number',
  'pages.outputScan.internationalTrackingNumber': 'International Tracking Number',
  'pages.outputScan.locationCode': 'Location Code',
  'pages.outputScan.locationCodePlaceholder': 'Enter location code (e.g., A-01-03-001)',
  'pages.outputScan.locationCodeRequired': 'Please enter location code',
  'pages.outputScan.cancel': 'Cancel',
  'pages.outputScan.submit': 'Submit',

  // Product Log Modal
  'pages.productLog.title': '■ Product Log - Product Number: {productNo}',
  'pages.productLog.close': 'Close',
  'pages.productLog.columns.no': 'No',
  'pages.productLog.columns.operator': 'Operator',
  'pages.productLog.columns.content': 'Content',
  'pages.productLog.columns.registrationDate': 'Registration Date',
  'pages.productLog.noLogs': 'No log records',

  // Product Table Modal
  'pages.productTable.title': 'Order Product List - {orderNo}',
  'pages.productTable.trackingNumberInput': 'Tracking Number Input:',
  'pages.productTable.trackingNumberPlaceholder': 'Tracking Number',
  'pages.productTable.register': 'Register',
  'pages.productTable.columns.no': 'No.',
  'pages.productTable.columns.checkbox': 'Checkbox',
  'pages.productTable.columns.productStatus': 'Product Status',
  'pages.productTable.columns.productLog': 'Product Log',
  'pages.productTable.columns.image': 'Image',
  'pages.productTable.columns.customsClearance': '[Customs Item]',
  'pages.productTable.columns.productName': 'Product Name',
  'pages.productTable.columns.color': '[Color]',
  'pages.productTable.columns.size': 'Size',
  'pages.productTable.columns.productCode': 'Product Code / Material',
  'pages.productTable.columns.sellerInfo': 'Seller Info',
  'pages.productTable.columns.trackingNo': '[Tracking No]',
  'pages.productTable.columns.orderNo': 'Order No',
  'pages.productTable.columns.exposure': '(Exposure O/X)',
  'pages.productTable.columns.shippingCost': '[Shipping Cost] Actual(O) / Seller(X)',
  'pages.productTable.columns.refundCost': '[Refund Cost] Seller(X) / Member(O)',
  'pages.productTable.columns.unitPriceQuantity': 'Unit Price * Quantity',
  'pages.productTable.columns.totalActualPayment': 'Total / Actual Payment',
  'pages.productTable.columns.actualQuantity': '* Actual Quantity',
  'pages.productTable.columns.total': 'Total',
  'pages.productTable.columns.rackNo': '[Rack No]',
  'pages.productTable.columns.previousRackNo': 'Previous Rack No',
  'pages.productTable.status.shipped': 'Shipped',
  'pages.productTable.status.log': 'Log',
  'pages.productTable.status.arrivalExpected': 'Arrival Expected',
  'pages.productTable.exposure.yes': '(Exposure O)',
  'pages.productTable.shipping': 'Shipping:',
  'pages.productTable.refund': 'Refund:',
  'pages.productTable.actualPayment': 'Actual Payment:',
  'pages.productTable.previous': 'Previous:',
  'pages.productTable.productNote': 'Product Note:',
  'pages.productTable.productNotePlaceholder': 'Enter product note',
  'pages.productTable.sellerAddress': 'Seller Address:',
  'pages.productTable.sellerAddressPlaceholder': 'Enter seller address',
  'pages.productTable.mock.furniture': '[Furniture]',
  'pages.productTable.mock.cotton': 'Cotton',
  'pages.productTable.mock.sellerA': 'Seller A',

  // Tracking Number Modal
  'pages.trackingNumber.title': '■ Tracking Number Registration',
  'pages.trackingNumber.save': 'Save',
  'pages.trackingNumber.close': 'Close',
  'pages.trackingNumber.trackingNumber': 'Tracking Number',
  'pages.trackingNumber.trackingNumberPlaceholder': 'Tracking Number',
  'pages.trackingNumber.shippingDate': 'Shipping Date',
  'pages.trackingNumber.shippingDatePlaceholder': 'Shipping Date',
  'pages.trackingNumber.trackingNumberRequired': 'Please enter tracking number',
  'pages.trackingNumber.shippingDateRequired': 'Please enter shipping date',
  'pages.trackingNumber.registered': 'Tracking number has been registered',

  // Sub Waybill Modal
  'pages.subWaybill.title': 'Sub Waybill Number Registration',
  'pages.subWaybill.save': 'Save',
  'pages.subWaybill.close': 'Close',
  'pages.subWaybill.orderNumber': 'Order Number',
  'pages.subWaybill.mainWaybillNumber': 'Main Waybill Number',
  'pages.subWaybill.subWaybillNumber': 'Waybill Number',
  'pages.subWaybill.subWaybillNumberPlaceholder': 'Enter waybill number',
  'pages.subWaybill.registered': 'waybill number has been registered',
  'pages.subWaybill.registerFailed': 'Failed to register waybill number',
  'pages.subWaybill.waybillNumberRequired': 'Waybill number is required',
  'pages.subWaybill.orderNumberRequired': 'Order number is required',
  'pages.subWaybill.warningMessage': 'If you enter an empty waybill number, the corresponding sub waybill number will be deleted.',

  // Bundle Orders Modal
  'pages.bundleOrders.title': 'Bundle Orders',
  'pages.bundleOrders.bundle': 'Bundle',
  'pages.bundleOrders.close': 'Close',
  'pages.bundleOrders.orderNo': 'Order No.',
  'pages.bundleOrders.memberId': 'Member ID',
  'pages.bundleOrders.memberName': 'Member Name',
  'pages.bundleOrders.deliveryAddress': 'Delivery Address',
  'pages.bundleOrders.shippingMethod': 'Shipping Method',
  'pages.bundleOrders.productCount': 'Product Count',
  'pages.bundleOrders.totalAmount': 'Total Amount',
  'pages.bundleOrders.description': 'Orders with the same member ID, delivery address, and shipping method are merged to generate a new order number.',
  'pages.bundleOrders.selectedCount': '{count} orders selected',
  'pages.bundleOrders.selectAtLeastTwo': 'Please select at least 2 orders to bundle',
  'pages.bundleOrders.bundled': 'Orders have been bundled and a new order number has been generated',
  'pages.bundleOrders.noOrderInfo': 'No Data',
  'pages.bundleOrders.noOrdersFound': 'No orders found',
  'pages.bundleOrders.select': 'Select',
  'pages.bundleOrders.orderNumber': 'Order Number',
  'pages.bundleOrders.itemCount': 'Item Count',
  'pages.bundleOrders.progressStatus': 'Status',
  'pages.bundleOrders.createdAt': 'Created At',
  'pages.bundleOrders.selectAtLeastOne': 'Please select at least one order to merge',
  'pages.bundleOrders.orderIdRequired': 'Order ID is required',
  'pages.bundleOrders.fetchError': 'Failed to fetch mergeable orders',
  'pages.bundleOrders.bundleError': 'Failed to bundle orders, please try again',
  'pages.bundleOrders.currentOrder': 'Current Order',
  // Split Order Modal
  'pages.splitOrder.title': 'Split Order',
  'pages.splitOrder.split': 'Split',
  'pages.splitOrder.close': 'Close',
  'pages.splitOrder.orderNo': 'Order No.',
  'pages.splitOrder.productNo': 'Product No.',
  'pages.splitOrder.image': 'Image',
  'pages.splitOrder.productName': 'Product Name',
  'pages.splitOrder.variation': 'Variation',
  'pages.splitOrder.quantity': 'Quantity',
  'pages.splitOrder.originalQuantity': 'Original Qty',
  'pages.splitOrder.splitQuantity': 'Split Qty',
  'pages.splitOrder.originalTotal': 'Original Total',
  'pages.splitOrder.splitTotal': 'Split Total',
  'pages.splitOrder.quantityMustBeGreaterThanZero': 'Split quantity must be greater than 0',
  'pages.splitOrder.quantityExceedsAvailable': 'Split quantity cannot exceed available quantity',
  'pages.splitOrder.unitPrice': 'Unit Price',
  'pages.splitOrder.totalPrice': 'Total Price',
  'pages.splitOrder.description': 'Select products to split. Selected products will create a new order.',
  'pages.splitOrder.selectAtLeastOne': 'Please select at least one product to split',
  'pages.splitOrder.cannotSelectAll': 'Cannot select all products. At least one product must remain in the original order',
  'pages.splitOrder.selectedTotal': 'Selected Products Total',
  'pages.splitOrder.splitSuccess': 'Order split successfully, new order created',
  'pages.splitOrder.splitError': 'Failed to split order, please try again',

  // Merge Order Modal
  'pages.mergeOrder.title': 'Merge Orders',
  'pages.mergeOrder.description': 'Select orders to merge. The merged order will contain all items from selected orders.',
  'pages.mergeOrder.currentOrder': 'Current Order',
  'pages.mergeOrder.select': 'Select',
  'pages.mergeOrder.orderNumber': 'Order Number',
  'pages.mergeOrder.memberName': 'Member Name',
  'pages.mergeOrder.itemCount': 'Item Count',
  'pages.mergeOrder.totalAmount': 'Total Amount',
  'pages.mergeOrder.progressStatus': 'Status',
  'pages.mergeOrder.createdAt': 'Created At',
  'pages.mergeOrder.selectAtLeastOne': 'Please select at least one order',
  'pages.mergeOrder.selectOnlyOne': 'Please select only one split order',
  'pages.mergeOrder.orderIdRequired': 'Order ID is required',
  'pages.mergeOrder.fetchError': 'Failed to fetch mergeable orders',
  'pages.mergeOrder.splitRefundSuccess': 'Refund order split successfully',
  'pages.mergeOrder.splitRefundError': 'Failed to split refund order, please try again',
  'pages.mergeOrder.merge': 'Merge',
  'pages.mergeOrder.mergeSuccess': 'Orders merged successfully, new order created',
  'pages.mergeOrder.mergeError': 'Failed to merge orders, please try again',
  'pages.mergeOrder.close': 'Close',
  'pages.mergeOrder.orderNo': 'Order No.',
  'pages.mergeOrder.memberId': 'Member ID',
  'pages.mergeOrder.deliveryAddress': 'Delivery Address',
  'pages.mergeOrder.shippingMethod': 'Shipping Method',
  'pages.mergeOrder.productCount': 'Product Count',
  'pages.mergeOrder.selectAtLeastTwo': 'Please select at least 2 orders to merge',
  'pages.mergeOrder.merged': 'Orders have been merged and a new order number has been generated',
  'pages.mergeOrder.selectedCount': '{count} orders selected',
  'pages.mergeOrder.noOrdersFound': 'No orders found',
  'pages.mergeOrder.splitFrom': 'Split From',
  'pages.mergeOrder.hasSplitOrders': 'Has Split Orders',

  // User Info Modal
  'pages.userInfo.title': 'User Information',
  'pages.userInfo.memberDetails': 'Member Details',
  'pages.userInfo.memberType.general': 'General',
  'pages.userInfo.memberType.business': 'Business',
  'pages.userInfo.memberTypeTag.general': 'General Member',
  'pages.userInfo.memberTypeTag.business': 'Business Member',
  'pages.userInfo.mailbox': 'Mailbox Number',
  'pages.userInfo.businessNo': 'Business Registration Number',
  'pages.userInfo.registrationDate': 'Registration Date',
  'pages.userInfo.totalOrders': 'Total Orders',
  'pages.userInfo.totalAmount': 'Total Amount',
  'pages.userInfo.contact': 'Contact',
  'pages.userInfo.email': 'Email',
  'pages.userInfo.address': 'Address',
  'pages.userInfo.memo': 'Memo',
  'pages.userInfo.unit.orders': 'orders',
  'pages.userInfo.unit.currency': 'KRW',
  'pages.userInfo.actions.memberInfo': 'Member Info',
  'pages.userInfo.actions.userUniqueId': 'MailBox',
  'pages.userInfo.actions.inquiry': 'Inquiry',
  'pages.userInfo.actions.notificationMessage': 'Notification Message',
  'pages.userInfo.actions.orders': 'Orders',
  'pages.userInfo.actions.paymentConfirmation': 'Payment Confirmation',
  'pages.userInfo.actions.deposit': 'Deposit',
  'pages.userInfo.actions.coupon': 'Coupon',
  'pages.userInfo.actions.point': 'Point',

  // Auth
  'pages.auth.loginSuccess': 'Login successful!',
  'pages.auth.loginFailed': 'Login failed',
  'pages.auth.loginFailedWithConsole': 'Login failed. Please check the console for details.',
  
  // Settlement - Dashboard
  'pages.settlement.dashboard.title': 'Financial Dashboard',
  'pages.settlement.dashboard.refresh': 'Refresh',
  'pages.settlement.dashboard.overview.totalUsers': 'Total Users',
  'pages.settlement.dashboard.overview.totalOrders': 'Total Orders',
  'pages.settlement.dashboard.overview.totalRevenue': 'Total Revenue',
  'pages.settlement.dashboard.overview.totalProducts': 'Total Products',
  'pages.settlement.dashboard.overview.activeProducts': 'Active Products',
  'pages.settlement.dashboard.overview.pendingOrders': 'Pending Orders',
  'pages.settlement.dashboard.revenue.title': 'Revenue',
  'pages.settlement.dashboard.revenue.today': 'Today',
  'pages.settlement.dashboard.revenue.thisWeek': 'This Week',
  'pages.settlement.dashboard.revenue.thisMonth': 'This Month',
  'pages.settlement.dashboard.revenue.thisYear': 'This Year',
  'pages.settlement.dashboard.revenue.growth': 'Growth',
  'pages.settlement.dashboard.orders.title': 'Orders',
  'pages.settlement.dashboard.orders.today': 'Today',
  'pages.settlement.dashboard.orders.thisWeek': 'This Week',
  'pages.settlement.dashboard.orders.thisMonth': 'This Month',
  'pages.settlement.dashboard.orders.byStatus': 'By Status',
  'pages.settlement.dashboard.topProducts.title': 'Top Products',
  'pages.settlement.dashboard.topProducts.productId': 'Product ID',
  'pages.settlement.dashboard.topProducts.name': 'Title',
  'pages.settlement.dashboard.topProducts.sales': 'Sales',
  'pages.settlement.dashboard.topProducts.revenue': 'Revenue',
  'pages.settlement.dashboard.recentActivity.title': 'Recent Activity',
  'pages.settlement.dashboard.recentActivity.empty': 'No activity data',

  // Settlement - Sellers
  'pages.settlement.sellers.title': 'Seller Settlement',
  'pages.settlement.sellers.tableTitle': 'Seller Settlement History',
  'pages.settlement.sellers.processSettlement': 'Process Settlement',
  'pages.settlement.sellers.processSettlementConfirm': 'Do you want to process settlement for {sellerName}? ({amount} KRW)',
  'pages.settlement.sellers.processSettlementSuccess': 'Settlement processed successfully',
  'pages.settlement.sellers.process': 'Process',
  'pages.settlement.sellers.statement': 'Statement',
  'pages.settlement.sellers.exportExcel': 'Export Excel',
  'pages.settlement.sellers.exportExcelSuccess': 'Excel file download started',
  'pages.settlement.sellers.downloadStatement': 'Download Statement',
  'pages.settlement.sellers.settlementRate': 'Settlement Rate {percent}%',
  'pages.settlement.sellers.stat.totalSettlementThisMonth': 'Total Settlement This Month',
  'pages.settlement.sellers.stat.pending': 'Pending',
  'pages.settlement.sellers.stat.completed': 'Completed',
  'pages.settlement.sellers.stat.avgSettlement': 'Average Settlement',
  'pages.settlement.sellers.alert.title': 'Settlement Notice',
  'pages.settlement.sellers.alert.description': 'Sales from the 1st to the last day of each month are settled on the 10th of the following month. The settlement amount is the total sales minus commissions, shipping fees, and other costs.',
  'pages.settlement.sellers.column.id': 'ID',
  'pages.settlement.sellers.column.sellerInfo': 'Seller Info',
  'pages.settlement.sellers.column.period': 'Settlement Period',
  'pages.settlement.sellers.column.totalSales': 'Total Sales',
  'pages.settlement.sellers.column.commission': 'Commission',
  'pages.settlement.sellers.column.shippingFee': 'Shipping Fee',
  'pages.settlement.sellers.column.settlementAmount': 'Settlement Amount',
  'pages.settlement.sellers.column.orderProduct': 'Orders/Products',
  'pages.settlement.sellers.column.status': 'Status',
  'pages.settlement.sellers.column.requestDate': 'Request Date',
  'pages.settlement.sellers.column.completedDate': 'Completed Date',
  'pages.settlement.sellers.column.action': 'Actions',
  'pages.settlement.sellers.status.pending': 'Pending',
  'pages.settlement.sellers.status.processing': 'Processing',
  'pages.settlement.sellers.status.completed': 'Completed',
  'pages.settlement.sellers.status.failed': 'Failed',
  'pages.settlement.sellers.detailModal.title': 'Settlement Detail - {sellerName}',
  'pages.settlement.sellers.tab.summary': 'Settlement Summary',
  'pages.settlement.sellers.tab.account': 'Deposit Info',
  'pages.settlement.sellers.detail.sellerId': 'Seller ID',
  'pages.settlement.sellers.detail.sellerName': 'Seller Name',
  'pages.settlement.sellers.detail.period': 'Settlement Period',
  'pages.settlement.sellers.detail.orderCount': 'Order Count',
  'pages.settlement.sellers.detail.productCount': 'Product Count',
  'pages.settlement.sellers.detail.settlementAmountDetail': 'Settlement Amount Detail',
  'pages.settlement.sellers.detail.totalSales': 'Total Sales',
  'pages.settlement.sellers.detail.platformCommission': 'Platform Commission (10%)',
  'pages.settlement.sellers.detail.shippingFee': 'Shipping Fee',
  'pages.settlement.sellers.detail.otherDeduction': 'Other Deduction',
  'pages.settlement.sellers.detail.finalSettlementAmount': 'Final Settlement Amount',
  'pages.settlement.sellers.detail.bankName': 'Bank Name',
  'pages.settlement.sellers.detail.accountNumber': 'Account Number',
  'pages.settlement.sellers.detail.accountHolder': 'Account Holder',
  'pages.settlement.sellers.detail.requestDate': 'Request Date',
  'pages.settlement.sellers.detail.completedDate': 'Completed Date',
  'pages.settlement.sellers.detail.status': 'Status',
  'pages.settlement.sellers.mock.sellerName': 'Seller',
  'pages.settlement.sellers.mock.bank.kb': 'KB Bank',
  'pages.settlement.sellers.mock.bank.shinhan': 'Shinhan Bank',
  'pages.settlement.sellers.mock.bank.woori': 'Woori Bank',
  'pages.settlement.sellers.mock.bank.hana': 'Hana Bank',
  
  // Settlement - Member Recharge Review
  'pages.settlement.memberRechargeReview.title': 'Deposit Application History',
  'pages.settlement.memberRechargeReview.memberName': 'Member Name',
  'pages.settlement.memberRechargeReview.applicationType': 'Application Type',
  'pages.settlement.memberRechargeReview.typeDeposit': 'Deposit',
  'pages.settlement.memberRechargeReview.typeWithdraw': 'Withdrawal',
  'pages.settlement.memberRechargeReview.typeRefund': 'Refund',
  'pages.settlement.memberRechargeReview.rejectReasonPlaceholder': 'Please enter the reason for rejection',
  'pages.settlement.memberRechargeReview.depositAmount': 'Deposit Amount',
  'pages.settlement.memberRechargeReview.refundAmount': 'Refund Amount',
  'pages.settlement.memberRechargeReview.depositor': 'Depositor (Account Holder)',
  'pages.settlement.memberRechargeReview.bankInfo': 'Account Number',
  'pages.settlement.memberRechargeReview.status': 'Completion Status',
  'pages.settlement.memberRechargeReview.statusPending': 'Pending',
  'pages.settlement.memberRechargeReview.statusApproved': 'Completed',
  'pages.settlement.memberRechargeReview.statusRejected': 'Cancelled',
  'pages.settlement.memberRechargeReview.applicationDate': 'Application Date',
  'pages.settlement.memberRechargeReview.expectedDepositDate': 'Expected Deposit Date',
  'pages.settlement.memberRechargeReview.actions': 'Actions',
  'pages.settlement.memberRechargeReview.complete': 'Complete',
  'pages.settlement.memberRechargeReview.cancellation': 'Cancel',
  'pages.settlement.memberRechargeReview.totalApplications': 'Total Applications',
  'pages.settlement.memberRechargeReview.pendingApplications': 'Pending Applications',
  'pages.settlement.memberRechargeReview.approvedApplications': 'Completed',
  'pages.settlement.memberRechargeReview.totalAmount': 'Total Amount',
  'pages.settlement.memberRechargeReview.approveConfirm': 'Confirm Approval?',
  'pages.settlement.memberRechargeReview.approveContent': 'Do you want to approve {name}\'s deposit of {amount} KRW?',
  'pages.settlement.memberRechargeReview.approved': 'Approved successfully',
  'pages.settlement.memberRechargeReview.approveError': 'Failed to approve',
  'pages.settlement.memberRechargeReview.rejectConfirm': 'Reject application?',
  'pages.settlement.memberRechargeReview.rejectContent': 'Do you want to reject {name}\'s deposit application?',
  'pages.settlement.memberRechargeReview.rejected': 'Rejected successfully',
  'pages.settlement.memberRechargeReview.rejectError': 'Failed to reject',
  'pages.settlement.memberRechargeReview.registrationSuccess': 'Registered successfully',
  
  // Settlement - Member Withdrawal Review
  'pages.settlement.memberWithdrawalReview.title': 'Deposit Usage History',
  'pages.settlement.memberWithdrawalReview.memberName': 'Member Name',
  'pages.settlement.memberWithdrawalReview.usageClassification': 'Usage Type',
  'pages.settlement.memberWithdrawalReview.classificationDepositTopup': 'Deposit Top-up',
  'pages.settlement.memberWithdrawalReview.classificationRefund': 'Deposit Refund',
  'pages.settlement.memberWithdrawalReview.classificationPaymentCost': 'Payment Cost',
  'pages.settlement.memberWithdrawalReview.classificationPaymentCancel': 'Payment Cancellation',
  'pages.settlement.memberWithdrawalReview.classificationAdminAccrual': 'Admin Deposit Credit',
  'pages.settlement.memberWithdrawalReview.classificationAdminDeduction': 'Admin Deposit Deduction',
  'pages.settlement.memberWithdrawalReview.classificationProductRefund': 'Product Refund',
  'pages.settlement.memberWithdrawalReview.content': 'Content',
  'pages.settlement.memberWithdrawalReview.transactionCode': 'Transaction Code',
  'pages.settlement.memberWithdrawalReview.amount': 'Amount',
  'pages.settlement.memberWithdrawalReview.balance': 'Balance',
  'pages.settlement.memberWithdrawalReview.usageDate': 'Usage Date',
  'pages.settlement.memberWithdrawalReview.paymentOrderNumber': 'Payment Order Number',
  'pages.settlement.memberWithdrawalReview.depositPaymentOrderNumber': 'Deposit Payment Order Number',
  'pages.settlement.memberWithdrawalReview.totalUsage': 'Total Usage',
  'pages.settlement.memberWithdrawalReview.totalAmount': 'Total Amount',
  'pages.settlement.memberWithdrawalReview.averageAmount': 'Average Amount',
  'pages.settlement.memberWithdrawalReview.totalDeposit': 'Total Deposit',
  'pages.settlement.memberWithdrawalReview.depositRegistration': 'Deposit Registration',
  'pages.settlement.memberWithdrawalReview.memberSearch': 'Member Search',
  'pages.settlement.memberWithdrawalReview.searchByMemberId': 'Member ID',
  'pages.settlement.memberWithdrawalReview.searchByMemberName': 'Member Name',
  'pages.settlement.memberWithdrawalReview.searchByMailbox': 'Mailbox Number',
  'pages.settlement.memberWithdrawalReview.searchRequired': 'Please enter search term',
  'pages.settlement.memberWithdrawalReview.searchPlaceholder': 'Enter search term',
  'pages.settlement.memberWithdrawalReview.search': 'Search',
  'pages.settlement.memberWithdrawalReview.memberSelect': 'Select Member',
  'pages.settlement.memberWithdrawalReview.contentRequired': 'Please enter content',
  'pages.settlement.memberWithdrawalReview.contentPlaceholder': 'Enter reason for deposit credit or deduction',
  'pages.settlement.memberWithdrawalReview.amountRequired': 'Please enter amount',
  'pages.settlement.memberWithdrawalReview.amountMin': 'Amount must be at least 1 KRW',
  'pages.settlement.memberWithdrawalReview.amountPlaceholder': 'Enter amount',
  'pages.settlement.memberWithdrawalReview.registrationSuccess': 'Registered successfully',
  'pages.settlement.memberWithdrawalReview.registrationFailed': 'Registration failed',
  'pages.settlement.memberWithdrawalReview.direction': 'Accrue/Deduct',
  'pages.settlement.memberWithdrawalReview.direction.add': 'Accrue',
  'pages.settlement.memberWithdrawalReview.direction.subtract': 'Deduct',
  'pages.settlement.memberWithdrawalReview.currentBalance': 'Current deposit balance',
  'pages.settlement.memberWithdrawalReview.negativeWarning': 'The resulting balance would be negative. The server will reject this.',
  'pages.settlement.memberWithdrawalReview.submit': 'Register',
  'pages.settlement.memberWithdrawalReview.memberRequired': 'Please select a member',
  'pages.settlement.memberWithdrawalReview.noMemberFound': 'No members found',
  
  // Settlement - Platform
  'pages.settlement.platform.title': 'Platform Fee Settlement',
  'pages.settlement.platform.tableTitle': 'Monthly Fee History',
  'pages.settlement.platform.exportExcel': 'Export Excel',
  'pages.settlement.platform.exportExcelSuccess': 'Excel file download started',
  'pages.settlement.platform.downloadReport': 'Download Report',
  'pages.settlement.platform.month': 'Month {month}',
  'pages.settlement.platform.year': 'Year {year}',
  'pages.settlement.platform.stat.totalRevenueThisMonth': 'Total Revenue This Month',
  'pages.settlement.platform.stat.commissionRevenue': 'Commission Revenue',
  'pages.settlement.platform.stat.shippingFeeRevenue': 'Shipping Fee Revenue',
  'pages.settlement.platform.stat.monthOverMonth': 'Month Over Month',
  'pages.settlement.platform.chart.title': 'Monthly Revenue Trend',
  'pages.settlement.platform.column.id': 'ID',
  'pages.settlement.platform.column.period': 'Settlement Period',
  'pages.settlement.platform.column.year': 'Year',
  'pages.settlement.platform.column.month': 'Month',
  'pages.settlement.platform.column.totalSales': 'Total Sales',
  'pages.settlement.platform.column.commissionRate': 'Commission Rate',
  'pages.settlement.platform.column.commissionAmount': 'Commission Revenue',
  'pages.settlement.platform.column.shippingFee': 'Shipping Fee Revenue',
  'pages.settlement.platform.column.additionalFee': 'Additional Revenue',
  'pages.settlement.platform.column.totalFee': 'Total Revenue',
  'pages.settlement.platform.column.orderSeller': 'Orders/Sellers',
  'pages.settlement.platform.column.avgOrderValue': 'Average Order Value',
  'pages.settlement.platform.column.growthRate': 'Growth Rate',
  'pages.settlement.platform.column.action': 'Actions',
  'pages.settlement.platform.detailModal.title': 'Fee Detail - {period}',
  'pages.settlement.platform.detail.revenueSummary': 'Revenue Summary',
  'pages.settlement.platform.detail.revenueDetail': 'Revenue Detail',
  'pages.settlement.platform.detail.growthMetrics': 'Growth Metrics',
  'pages.settlement.platform.detail.revenueComposition': 'Revenue Composition',
  'pages.settlement.platform.detail.period': 'Settlement Period',
  'pages.settlement.platform.detail.totalSales': 'Total Sales',
  'pages.settlement.platform.detail.orderCount': 'Order Count',
  'pages.settlement.platform.detail.sellerCount': 'Seller Count',
  'pages.settlement.platform.detail.avgOrderValue': 'Average Order Value',
  'pages.settlement.platform.detail.platformCommission': 'Platform Commission ({rate}%)',
  'pages.settlement.platform.detail.shippingFeeRevenue': 'Shipping Fee Revenue',
  'pages.settlement.platform.detail.additionalRevenue': 'Additional Revenue',
  'pages.settlement.platform.detail.totalRevenue': 'Total Revenue',
  'pages.settlement.platform.detail.monthOverMonthGrowth': 'Month Over Month Growth',
  'pages.settlement.platform.detail.profitRate': 'Profit Rate',
  'pages.settlement.platform.detail.platformCommissionLabel': 'Platform Commission',
  'pages.settlement.platform.detail.shippingFeeRevenueLabel': 'Shipping Fee Revenue',
  'pages.settlement.platform.detail.additionalRevenueLabel': 'Additional Revenue',

  // Settlement - Coupons (moved from members)
  'pages.settlement.coupons.title': 'Point/Coupon Settings',

  // Members - Statistics (duplicate section removed - see line 733)

  // Settlement - Product Price Increase
  'pages.settlement.productPriceIncrease.title': 'Product Price Increase',
  'pages.settlement.productPriceIncrease.addTitle': 'Add Product Price Increase',
  'pages.settlement.productPriceIncrease.editTitle': 'Edit Product Price Increase',
  'pages.settlement.productPriceIncrease.deleteConfirm': 'Delete Product Price Increase',
  'pages.settlement.productPriceIncrease.deleteConfirmContent': 'Are you sure you want to delete price increase information for price range ID "{id}"?',
  'pages.settlement.productPriceIncrease.deleteSuccess': 'Product price increase information deleted successfully',
  'pages.settlement.productPriceIncrease.deleteError': 'Failed to delete price increase setting',
  'pages.settlement.productPriceIncrease.fetchError': 'Failed to fetch price increase settings',
  'pages.settlement.productPriceIncrease.updateSuccess': 'Product price increase information updated successfully',
  'pages.settlement.productPriceIncrease.createSuccess': 'Product price increase information created successfully',
  'pages.settlement.productPriceIncrease.submitError': 'Error saving product price increase information',
  'pages.settlement.productPriceIncrease.approve': 'Approve',
  'pages.settlement.productPriceIncrease.reject': 'Reject',
  'pages.settlement.productPriceIncrease.approveSuccess': 'Price increase approved successfully',
  'pages.settlement.productPriceIncrease.rejectSuccess': 'Price increase rejected successfully',
  'pages.settlement.productPriceIncrease.statistics.total': 'Total',
  'pages.settlement.productPriceIncrease.statistics.pending': 'Pending',
  'pages.settlement.productPriceIncrease.statistics.approved': 'Approved',
  'pages.settlement.productPriceIncrease.statistics.totalIncrease': 'Total Increase',
  'pages.settlement.productPriceIncrease.serviceFee.title': 'Service Fee',
  'pages.settlement.productPriceIncrease.serviceFee.feeAmount': 'Fee Amount',
  'pages.settlement.productPriceIncrease.serviceFee.enterFee': 'Enter service fee',
  'pages.settlement.productPriceIncrease.serviceFee.register': 'Register',
  'pages.settlement.productPriceIncrease.serviceFee.required': 'Please enter service fee',
  'pages.settlement.productPriceIncrease.serviceFee.updateSuccess': 'Service fee updated successfully',
  'pages.settlement.productPriceIncrease.serviceFee.updateError': 'Failed to update service fee',
  'pages.settlement.productPriceIncrease.column.id': 'ID',
  'pages.settlement.productPriceIncrease.column.startingPrice': 'Starting Price',
  'pages.settlement.productPriceIncrease.column.endPrice': 'End Price',
  'pages.settlement.productPriceIncrease.column.increaseType': 'Price increase type',
  'pages.settlement.productPriceIncrease.column.addValue': 'Add value',
  'pages.settlement.productPriceIncrease.column.operate': 'Operate',
  'pages.settlement.productPriceIncrease.column.productCode': 'Product Code',
  'pages.settlement.productPriceIncrease.column.productName': 'Product Name',
  'pages.settlement.productPriceIncrease.column.category': 'Category',
  'pages.settlement.productPriceIncrease.column.currentPrice': 'Current Price',
  'pages.settlement.productPriceIncrease.column.increaseValue': 'Increase Value',
  'pages.settlement.productPriceIncrease.column.newPrice': 'New Price',
  'pages.settlement.productPriceIncrease.column.effectiveDate': 'Effective Date',
  'pages.settlement.productPriceIncrease.column.reason': 'Reason',
  'pages.settlement.productPriceIncrease.column.status': 'Status',
  'pages.settlement.productPriceIncrease.increaseType.percent': 'Percent',
  'pages.settlement.productPriceIncrease.increaseType.fixed': 'Fixed',
  'pages.settlement.productPriceIncrease.status.pending': 'Pending',
  'pages.settlement.productPriceIncrease.status.approved': 'Approved',
  'pages.settlement.productPriceIncrease.status.rejected': 'Rejected',
  'pages.settlement.productPriceIncrease.status.active': 'Active',
  'pages.settlement.productPriceIncrease.form.startingPrice': 'Starting Price',
  'pages.settlement.productPriceIncrease.form.startingPriceRequired': 'Please enter starting price',
  'pages.settlement.productPriceIncrease.form.endPrice': 'End Price',
  'pages.settlement.productPriceIncrease.form.endPriceRequired': 'Please enter end price',
  'pages.settlement.productPriceIncrease.form.endPricePlaceholder': 'Enter 999999999 for unlimited',
  'pages.settlement.productPriceIncrease.form.increaseType': 'Price increase type',
  'pages.settlement.productPriceIncrease.form.increaseTypeRequired': 'Please select price increase type',
  'pages.settlement.productPriceIncrease.form.addValue': 'Add value',
  'pages.settlement.productPriceIncrease.form.addValueRequired': 'Please enter add value',
  'pages.settlement.productPriceIncrease.form.productCode': 'Product Code',
  'pages.settlement.productPriceIncrease.form.productCodeRequired': 'Please enter product code',
  'pages.settlement.productPriceIncrease.form.productName': 'Product Name',
  'pages.settlement.productPriceIncrease.form.productNameRequired': 'Please enter product name',
  'pages.settlement.productPriceIncrease.form.currentPrice': 'Current Price',
  'pages.settlement.productPriceIncrease.form.currentPriceRequired': 'Please enter current price',
  'pages.settlement.productPriceIncrease.form.increaseValue': 'Increase Value',
  'pages.settlement.productPriceIncrease.form.increaseValueRequired': 'Please enter increase value',
  'pages.settlement.productPriceIncrease.form.effectiveDate': 'Effective Date',
  'pages.settlement.productPriceIncrease.form.effectiveDateRequired': 'Please select effective date',
  'pages.settlement.productPriceIncrease.form.reason': 'Reason',
  'pages.settlement.productPriceIncrease.form.reasonRequired': 'Please enter reason',

  // Settlement - Service Fee
  'pages.settlement.serviceFee.title': 'Service Fee',
  'pages.settlement.serviceFee.addTitle': 'Add Service Fee',
  'pages.settlement.serviceFee.editTitle': 'Edit Service Fee',
  'pages.settlement.serviceFee.deleteConfirm': 'Delete Service Fee',
  'pages.settlement.serviceFee.deleteConfirmContent': 'Are you sure you want to delete service fee "{serviceName}"?',
  'pages.settlement.serviceFee.deleteSuccess': 'Service fee deleted successfully',
  'pages.settlement.serviceFee.updateSuccess': 'Service fee updated successfully',
  'pages.settlement.serviceFee.createSuccess': 'Service fee created successfully',
  'pages.settlement.serviceFee.submitError': 'Error saving service fee',
  'pages.settlement.serviceFee.statistics.total': 'Total',
  'pages.settlement.serviceFee.statistics.active': 'Active',
  'pages.settlement.serviceFee.statistics.inactive': 'Inactive',
  'pages.settlement.serviceFee.column.serviceType': 'Service Type',
  'pages.settlement.serviceFee.column.serviceName': 'Service Name',
  'pages.settlement.serviceFee.column.usageType': 'Usage Type',
  'pages.settlement.serviceFee.column.operate': 'Operate',
  'pages.settlement.serviceFee.column.feeType': 'Fee Type',
  'pages.settlement.serviceFee.column.feeValue': 'Fee Value',
  'pages.settlement.serviceFee.column.minAmount': 'Min Amount',
  'pages.settlement.serviceFee.column.maxAmount': 'Max Amount',
  'pages.settlement.serviceFee.column.applicableTo': 'Applicable To',
  'pages.settlement.serviceFee.column.isActive': 'Active',
  'pages.settlement.serviceFee.column.effectiveDate': 'Effective Date',
  'pages.settlement.serviceFee.serviceType.payment': 'Payment',
  'pages.settlement.serviceFee.serviceType.shipping': 'Shipping',
  'pages.settlement.serviceFee.serviceType.platform': 'Platform',
  'pages.settlement.serviceFee.serviceType.storage': 'Storage',
  'pages.settlement.serviceFee.feeType.fixed': 'Fixed',
  'pages.settlement.serviceFee.feeType.percent': 'Percent',
  'pages.settlement.serviceFee.feeType.tiered': 'Tiered',
  'pages.settlement.serviceFee.form.serviceType': 'Service Type',
  'pages.settlement.serviceFee.form.serviceTypeRequired': 'Please select service type',
  'pages.settlement.serviceFee.form.serviceName': 'Service Name',
  'pages.settlement.serviceFee.form.serviceNameRequired': 'Please enter service name',
  'pages.settlement.serviceFee.form.feeType': 'Fee Type',
  'pages.settlement.serviceFee.form.feeTypeRequired': 'Please select fee type',
  'pages.settlement.serviceFee.form.feeValue': 'Fee Value',
  'pages.settlement.serviceFee.form.feeValueRequired': 'Please enter fee value',
  'pages.settlement.serviceFee.form.minAmount': 'Min Amount',
  'pages.settlement.serviceFee.form.maxAmount': 'Max Amount',
  'pages.settlement.serviceFee.form.effectiveDate': 'Effective Date',
  'pages.settlement.serviceFee.form.effectiveDateRequired': 'Please select effective date',
  'pages.settlement.serviceFee.form.description': 'Description',
  'pages.settlement.serviceFee.form.isActive': 'Active',
  
  // Settlement - Member Recharge Review
  'pages.settlement.memberRechargeReview.filter.group.title': 'Status',
  'pages.settlement.memberRechargeReview.filter.pendingReview': 'Review Pending',
  'pages.settlement.memberRechargeReview.filter.approvalSuccessful': 'Review Success',
  'pages.settlement.memberRechargeReview.filter.reviewFailed': 'Review Failed',
  'pages.settlement.memberRechargeReview.column.userId': 'User ID',
  'pages.settlement.memberRechargeReview.column.user': 'User',
  'pages.settlement.memberRechargeReview.column.remittanceMethod': 'Transfer Method',
  'pages.settlement.memberRechargeReview.column.remitterName': 'Remitter Name',
  'pages.settlement.memberRechargeReview.column.rechargeCurrencyAndAmount': 'Recharge Currency Amount',
  'pages.settlement.memberRechargeReview.column.receivedCurrencyAndAmount': 'Deposit Currency Amount',
  'pages.settlement.memberRechargeReview.column.serviceFee': 'Service Fee',
  'pages.settlement.memberRechargeReview.column.receivingBankInformation': 'Receiving Bank Information',
  'pages.settlement.memberRechargeReview.column.addTime': 'Added Time',
  'pages.settlement.memberRechargeReview.approve': 'Review Success',
  'pages.settlement.memberRechargeReview.reject': 'Review Failed',
  'pages.settlement.memberRechargeReview.rejectTitle': 'Enter Rejection Reason',
  'pages.settlement.memberRechargeReview.rejectionReason': 'Rejection Reason',
  'pages.settlement.memberRechargeReview.rejectionReasonRequired': 'Please enter rejection reason',
  'pages.settlement.memberRechargeReview.rejectionReasonPlaceholder': 'Please enter rejection reason',
  'pages.settlement.memberRechargeReview.viewReason': 'View Reason',
  'pages.settlement.memberRechargeReview.viewReasonTitle': 'Rejection Reason',
  'pages.settlement.memberRechargeReview.receivingAccount': 'Receiving Account',
  'pages.settlement.memberRechargeReview.receivingAccountManagement': 'Receiving Account Management',
  'pages.settlement.memberRechargeReview.bankName': 'Bank Name',
  'pages.settlement.memberRechargeReview.bankNameRequired': 'Please enter bank name',
  'pages.settlement.memberRechargeReview.accountNumber': 'Account Number',
  'pages.settlement.memberRechargeReview.accountNumberRequired': 'Please enter account number',
  'pages.settlement.memberRechargeReview.accountHolder': 'Account Holder',
  'pages.settlement.memberRechargeReview.accountHolderRequired': 'Please enter account holder',
  'pages.settlement.memberRechargeReview.currency': 'Currency',
  'pages.settlement.memberRechargeReview.currencyRequired': 'Please select currency',
  'pages.settlement.memberRechargeReview.isActive': 'Active Status',
  'pages.settlement.memberRechargeReview.accountList': 'Account List',
  'pages.settlement.memberRechargeReview.accountAdded': 'Account added successfully',
  'pages.settlement.memberRechargeReview.accountUpdated': 'Account updated successfully',
  'pages.settlement.memberRechargeReview.accountStatusUpdated': 'Status updated successfully',
  'pages.settlement.memberRechargeReview.accountError': 'An error occurred',
  'pages.settlement.memberRechargeReview.selectOrDateRequired': 'Please select date or items',
  'pages.settlement.memberRechargeReview.exportSuccess': 'Exported {count} items',
  'pages.settlement.memberRechargeReview.receivingBankInfo': 'Receiving Bank Information',

  // Settlement - Member Withdrawal Review
  'pages.settlement.memberWithdrawalReview.filter.group.title': 'Status',
  'pages.settlement.memberWithdrawalReview.filter.pendingReview': 'Review Pending',
  'pages.settlement.memberWithdrawalReview.filter.approvalSuccessful': 'Review Success',
  'pages.settlement.memberWithdrawalReview.filter.reviewFailed': 'Review Failed',
  'pages.settlement.memberWithdrawalReview.column.userId': 'User ID',
  'pages.settlement.memberWithdrawalReview.column.user': 'User',
  'pages.settlement.memberWithdrawalReview.column.handlingFee': 'Fee',
  'pages.settlement.memberWithdrawalReview.column.withdrawalAmount': 'Withdrawal Amount',
  'pages.settlement.memberWithdrawalReview.column.amountReceived': 'Deposit Amount',
  'pages.settlement.memberWithdrawalReview.column.bankCardName': 'Bank Card Name',
  'pages.settlement.memberWithdrawalReview.column.bankCardNumber': 'Bank Card Account Number',
  'pages.settlement.memberWithdrawalReview.column.bankCardHolder': 'Bank Card Owner',
  'pages.settlement.memberWithdrawalReview.column.withdrawalTime': 'Withdrawal Time',
  'pages.settlement.memberWithdrawalReview.approve': 'Review Success',
  'pages.settlement.memberWithdrawalReview.reject': 'Review Failed',
  'pages.settlement.memberWithdrawalReview.approveConfirm': 'Are you sure you want to approve?',
  'pages.settlement.memberWithdrawalReview.approveContent': 'Are you sure you want to approve {name}\'s withdrawal of {amount}?',
  'pages.settlement.memberWithdrawalReview.approved': 'Approved successfully',
  'pages.settlement.memberWithdrawalReview.rejectTitle': 'Enter Rejection Reason',
  'pages.settlement.memberWithdrawalReview.rejectionReason': 'Rejection Reason',
  'pages.settlement.memberWithdrawalReview.rejectionReasonRequired': 'Please enter rejection reason',
  'pages.settlement.memberWithdrawalReview.rejectionReasonPlaceholder': 'Please enter rejection reason',
  'pages.settlement.memberWithdrawalReview.rejected': 'Rejected successfully',
  'pages.settlement.memberWithdrawalReview.rejectError': 'An error occurred',
  'pages.settlement.memberWithdrawalReview.viewReason': 'View Reason',
  'pages.settlement.memberWithdrawalReview.viewReasonTitle': 'Rejection Reason',
  'pages.settlement.memberWithdrawalReview.withdrawalFeeSettings': 'Withdrawal Fee Settings',
  'pages.settlement.memberWithdrawalReview.feeSettingName': 'Name',
  'pages.settlement.memberWithdrawalReview.feeSettingNameRequired': 'Please enter name',
  'pages.settlement.memberWithdrawalReview.feeType': 'Fee Type',
  'pages.settlement.memberWithdrawalReview.feeTypeRequired': 'Please select fee type',
  'pages.settlement.memberWithdrawalReview.feeTypeNone': '① Fee=0',
  'pages.settlement.memberWithdrawalReview.feeTypePercentage': '② Fee=Withdrawal Amount×Fee Rate',
  'pages.settlement.memberWithdrawalReview.feeTypeFixed': '③ Fee=Fixed Withdrawal Fee',
  'pages.settlement.memberWithdrawalReview.feeRate': 'Fee Rate',
  'pages.settlement.memberWithdrawalReview.feeRateRequired': 'Please enter fee rate',
  'pages.settlement.memberWithdrawalReview.fixedFee': 'Fixed Withdrawal Fee',
  'pages.settlement.memberWithdrawalReview.fixedFeeRequired': 'Please enter fixed withdrawal fee',
  'pages.settlement.memberWithdrawalReview.minWithdrawalAmount': 'Min Withdrawal Amount',
  'pages.settlement.memberWithdrawalReview.minWithdrawalAmountRequired': 'Please enter min withdrawal amount',
  'pages.settlement.memberWithdrawalReview.maxWithdrawalAmount': 'Max Withdrawal Amount',
  'pages.settlement.memberWithdrawalReview.maxWithdrawalAmountRequired': 'Please enter max withdrawal amount',
  'pages.settlement.memberWithdrawalReview.feeSettingsList': 'Fee Settings List',
  'pages.settlement.memberWithdrawalReview.feeSettingAdded': 'Fee setting added successfully',
  'pages.settlement.memberWithdrawalReview.feeSettingError': 'An error occurred',
  'pages.settlement.memberWithdrawalReview.minMaxAmount': 'Min/Max Withdrawal Amount',
  'pages.settlement.memberWithdrawalReview.financialTaxReport': 'Financial Tax Report',
  'pages.settlement.memberWithdrawalReview.taxReportDownloaded': 'Financial tax report downloaded successfully',

  // ── Member Recharge Review (new design) ──────────────────────
  'pages.settlement.memberRechargeReview.header.title': 'Deposit Application History',
  'pages.settlement.memberRechargeReview.list.title': 'Deposit Application History List',
  'pages.settlement.memberRechargeReview.period.today': 'Today',
  'pages.settlement.memberRechargeReview.period.month': 'This Month',
  'pages.settlement.memberRechargeReview.period.quarter': 'This Quarter',
  'pages.settlement.memberRechargeReview.period.year': 'This Year',
  'pages.settlement.memberRechargeReview.period.todayRecharge': "Today's Recharge",
  'pages.settlement.memberRechargeReview.period.todayWithdraw': "Today's Withdrawal",
  'pages.settlement.memberRechargeReview.stat.amount': 'Amount',
  'pages.settlement.memberRechargeReview.stat.count': 'Count',
  'pages.settlement.memberRechargeReview.chart.rechargeAmount': 'Recharge Amount',
  'pages.settlement.memberRechargeReview.chart.withdrawAmount': 'Withdrawal Amount',
  'pages.settlement.memberRechargeReview.chart.rechargeCount': 'Recharge Count',
  'pages.settlement.memberRechargeReview.chart.withdrawCount': 'Withdrawal Count',
  'pages.settlement.memberRechargeReview.info.description': 'This section is the deposit recharge and withdrawal history.',
  'pages.settlement.memberRechargeReview.info.relation': 'Related to bank deposits and withdrawals.',
  'pages.settlement.memberRechargeReview.viewMode.detail': 'Detail View',
  'pages.settlement.memberRechargeReview.viewMode.summary': 'Summary View',
  'pages.settlement.memberRechargeReview.filter.startTime': 'Start Time',
  'pages.settlement.memberRechargeReview.filter.endTime': 'End Time',
  'pages.settlement.memberRechargeReview.filter.applicationType': 'Application Type',
  'pages.settlement.memberRechargeReview.filter.completionStatus': 'Processing Status',
  'pages.settlement.memberRechargeReview.filter.search': 'Search',
  'pages.settlement.memberRechargeReview.filter.mailbox': 'Mailbox',
  'pages.settlement.memberRechargeReview.filter.orderNumber': 'Order No.',
  'pages.settlement.memberRechargeReview.filter.memberName': 'Member Name',
  'pages.settlement.memberRechargeReview.filter.financeManager': 'Finance Manager',
  'pages.settlement.memberRechargeReview.applicationType.recharge': 'Recharge',
  'pages.settlement.memberRechargeReview.applicationType.withdraw': 'Withdrawal',
  'pages.settlement.memberRechargeReview.completionStatus.pending': 'Pending Approval',
  'pages.settlement.memberRechargeReview.completionStatus.completed': 'Approved',
  'pages.settlement.memberRechargeReview.completionStatus.cancelled': 'Rejected',
  'pages.settlement.memberRechargeReview.completionStatus.rejected': 'Rejected',
  'pages.settlement.memberRechargeReview.column.no': 'No.',
  'pages.settlement.memberRechargeReview.column.mailboxMember': 'Mailbox / Member',
  'pages.settlement.memberRechargeReview.column.applicationTypeAndDate': 'Application Type / Application Date',
  'pages.settlement.memberRechargeReview.column.depositBalance': 'Deposit Balance',
  'pages.settlement.memberRechargeReview.column.rechargeAmountSerial': '[Application] Recharge Amount / Serial No.',
  'pages.settlement.memberRechargeReview.column.depositorName': 'Recharge Depositor',
  'pages.settlement.memberRechargeReview.column.matchedDepositorAdmin': 'Matched Depositor / Admin',
  'pages.settlement.memberRechargeReview.column.withdrawalAmountSerial': '[Application] Withdrawal Amount / Serial No.',
  'pages.settlement.memberRechargeReview.column.withdrawalRecipient': 'Withdrawal Recipient / Bank / Account No.',
  'pages.settlement.memberRechargeReview.column.balanceAfter': 'Balance After',
  'pages.settlement.memberRechargeReview.column.completionStatusAndDate': 'Processing Status / Date',
  'pages.settlement.memberRechargeReview.column.financeAdminCheckedAt': 'Finance Admin Checked At',
  'pages.settlement.memberRechargeReview.action.edit': 'Edit',
  'pages.settlement.memberRechargeReview.action.confirm': 'Approve',
  'pages.settlement.memberRechargeReview.action.cancel': 'Cancel',
  'pages.settlement.memberRechargeReview.action.approve': 'Approve',
  'pages.settlement.memberRechargeReview.action.reject': 'Reject',
  'pages.settlement.memberRechargeReview.confirmInfoRequired': 'Info and amount confirmation is required.',
  'pages.settlement.memberRechargeReview.fetchError': 'Failed to fetch deposit application data',
  'pages.settlement.memberRechargeReview.updateRemitterError': 'Failed to update remitter name',
  'pages.settlement.memberRechargeReview.confirmModal.title': 'Approve Deposit Application',
  'pages.settlement.memberRechargeReview.confirmModal.mailbox': 'Mailbox',
  'pages.settlement.memberRechargeReview.confirmModal.memberName': 'Member',
  'pages.settlement.memberRechargeReview.confirmModal.type': 'Type',
  'pages.settlement.memberRechargeReview.confirmModal.amount': 'Amount',
  'pages.settlement.memberRechargeReview.confirmModal.amountRequired': 'Please enter amount.',
  'pages.settlement.memberRechargeReview.confirmModal.confirmInfo': 'I confirmed the application information and amount',
  'pages.settlement.memberRechargeReview.confirmModal.confirmInfoRequired': 'Info and amount confirmation is required.',
  'pages.settlement.memberRechargeReview.confirmModal.ok': 'Approve',
  'pages.settlement.memberRechargeReview.confirmModal.cancel': 'Cancel',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.open': 'Register Payout',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.title': 'Register Payout on Behalf',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.hint':
    'Use this to pay a guest order refund out to a bank account. The amount is reserved from the deposit balance as a withdrawal request; approve it after the transfer is made.',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.orderNumber': 'Order Number',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.orderNumberPlaceholder': 'Refunded order number',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.orderNumberRequired': 'Enter an order number',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.amount': 'Amount',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.amountRequired': 'Enter an amount',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.bankName': 'Bank',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.accountNumber': 'Account Number',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.accountHolder': 'Account Holder',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.description': 'Memo',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.descriptionPlaceholder':
    'How the account was verified (optional)',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.ok': 'Register',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.success': 'Payout request registered',
  'pages.settlement.memberRechargeReview.proxyWithdrawModal.error': 'Failed to register the payout request',
  'pages.settlement.memberRechargeReview.editDepositorModal.title': 'Manual Depositor Matching',
  'pages.settlement.memberRechargeReview.editDepositorModal.original': 'Original Depositor',
  'pages.settlement.memberRechargeReview.editDepositorModal.matched': 'Matched Depositor',
  'pages.settlement.memberRechargeReview.editDepositorModal.matchedPlaceholder': 'Enter matched depositor name',
  'pages.settlement.memberRechargeReview.editDepositorModal.admin': 'Handler Admin',
  'pages.settlement.memberRechargeReview.editDepositorModal.adminPlaceholder': 'Admin name',
  'pages.settlement.memberRechargeReview.editDepositorModal.success': 'Manual matching information saved.',
  'pages.settlement.memberRechargeReview.editDepositorModal.save': 'Save',

  // ── Member Withdrawal Review (new design) ────────────────────
  'pages.settlement.memberWithdrawalReview.header.title': 'Deposit Usage History',
  'pages.settlement.memberWithdrawalReview.list.title': '[Tax Settlement] Deposit Usage History List',
  'pages.settlement.memberWithdrawalReview.stat.todayBalance': "Today's Balance",
  'pages.settlement.memberWithdrawalReview.stat.lastMonthEndBalance': 'Last Month End Balance',
  'pages.settlement.memberWithdrawalReview.stat.monthlyBalance': 'Monthly Balance',
  'pages.settlement.memberWithdrawalReview.stat.todayRecharge': "Today's Recharge",
  'pages.settlement.memberWithdrawalReview.stat.thisMonthRecharge': "This Month's Recharge",
  'pages.settlement.memberWithdrawalReview.stat.monthlyRecharge': 'Monthly Recharge',
  'pages.settlement.memberWithdrawalReview.stat.todayWithdraw': "Today's Withdrawal",
  'pages.settlement.memberWithdrawalReview.stat.thisMonthWithdraw': "This Month's Withdrawal",
  'pages.settlement.memberWithdrawalReview.stat.monthlyWithdraw': 'Monthly Withdrawal',
  'pages.settlement.memberWithdrawalReview.stat.todayUse': "Today's Use",
  'pages.settlement.memberWithdrawalReview.stat.thisMonthUse': "This Month's Use",
  'pages.settlement.memberWithdrawalReview.stat.monthlyUse': 'Monthly Use',
  'pages.settlement.memberWithdrawalReview.stat.todayDeduct': "Today's Deduction",
  'pages.settlement.memberWithdrawalReview.stat.thisMonthDeduct': "This Month's Deduction",
  'pages.settlement.memberWithdrawalReview.stat.monthlyDeduct': 'Monthly Deduction',
  'pages.settlement.memberWithdrawalReview.stat.todayEarn': "Today's Earning",
  'pages.settlement.memberWithdrawalReview.stat.thisMonthEarn': "This Month's Earning",
  'pages.settlement.memberWithdrawalReview.stat.monthlyEarn': 'Monthly Earning',
  'pages.settlement.memberWithdrawalReview.category.order': 'Order',
  'pages.settlement.memberWithdrawalReview.category.bankRefund': 'Bank Refund',
  'pages.settlement.memberWithdrawalReview.category.rebate': 'Rebate',
  'pages.settlement.memberWithdrawalReview.category.share': 'Share',
  'pages.settlement.memberWithdrawalReview.viewMode.detail': 'Detail View',
  'pages.settlement.memberWithdrawalReview.viewMode.summary': 'Summary View',
  'pages.settlement.memberWithdrawalReview.filter.startTime': 'Start Time',
  'pages.settlement.memberWithdrawalReview.filter.endTime': 'End Time',
  'pages.settlement.memberWithdrawalReview.filter.earningCategory': 'Earning Category',
  'pages.settlement.memberWithdrawalReview.filter.earningOption.bankRefund': 'Bank Refund',
  'pages.settlement.memberWithdrawalReview.filter.earningOption.rebate': 'Rebate Earning',
  'pages.settlement.memberWithdrawalReview.filter.earningOption.share': 'Share Earning',
  'pages.settlement.memberWithdrawalReview.filter.deductionCategory': 'Deduction Category',
  'pages.settlement.memberWithdrawalReview.filter.deductionOption.order': 'Order',
  'pages.settlement.memberWithdrawalReview.filter.deductionOption.rebate': 'Rebate Deduction',
  'pages.settlement.memberWithdrawalReview.filter.deductionOption.share': 'Share Deduction',
  'pages.settlement.memberWithdrawalReview.filter.bankCategory': 'Bank Recharge / Withdrawal',
  'pages.settlement.memberWithdrawalReview.filter.bankOption.recharge': 'Recharge',
  'pages.settlement.memberWithdrawalReview.filter.bankOption.withdraw': 'Withdrawal',
  'pages.settlement.memberWithdrawalReview.filter.serialSearch': 'Serial No. Search',
  'pages.settlement.memberWithdrawalReview.filter.serialPlaceholder': 'Select filter then enter serial number...',
  'pages.settlement.memberWithdrawalReview.filter.mailbox': 'Mailbox',
  'pages.settlement.memberWithdrawalReview.filter.orderNumber': 'Order No.',
  'pages.settlement.memberWithdrawalReview.filter.memberName': 'Member Name',
  'pages.settlement.memberWithdrawalReview.filter.memo': 'Memo',
  'pages.settlement.memberWithdrawalReview.filter.search': 'Search',
  'pages.settlement.memberWithdrawalReview.column.no': 'No.',
  'pages.settlement.memberWithdrawalReview.column.mailboxMember': 'Mailbox / Member',
  'pages.settlement.memberWithdrawalReview.column.memo': 'Memo',
  'pages.settlement.memberWithdrawalReview.column.carryover': 'Carryover Balance',
  'pages.settlement.memberWithdrawalReview.column.bankRefund': 'Bank Refund No. / Amount / Date',
  'pages.settlement.memberWithdrawalReview.column.rebateEarn': 'Rebate Earning No. / Amount / Date',
  'pages.settlement.memberWithdrawalReview.column.shareEarn': 'Share Earning No. / Amount / Date',
  'pages.settlement.memberWithdrawalReview.column.bankRecharge': 'Bank Recharge No. / Amount / Date',
  'pages.settlement.memberWithdrawalReview.column.order': 'Order No. / Use Amount / Date',
  'pages.settlement.memberWithdrawalReview.column.rebateDeduct': 'Rebate Deduction No. / Amount / Date',
  'pages.settlement.memberWithdrawalReview.column.shareDeduct': 'Share Deduction No. / Amount / Date',
  'pages.settlement.memberWithdrawalReview.column.bankWithdraw': 'Bank Withdrawal No. / Amount / Date',
  'pages.settlement.memberWithdrawalReview.column.balanceAfter': 'Balance After',
  'pages.settlement.memberWithdrawalReview.column.adminChangedAt': 'Admin Changed At',
  'pages.settlement.memberWithdrawalReview.legend.earning': '● Earning (Plus) Amount',
  'pages.settlement.memberWithdrawalReview.legend.deduction': '● Deduction (Minus) Amount',

  // Settlement - Financial Tax Report
  'pages.settlement.financialTaxReport.title': 'Financial Tax Report',
  'pages.settlement.financialTaxReport.column.date': 'Date',
  'pages.settlement.financialTaxReport.column.transactionType': 'Transaction Type',
  'pages.settlement.financialTaxReport.column.amount': 'Amount',
  'pages.settlement.financialTaxReport.column.description': 'Description',
  'pages.settlement.financialTaxReport.column.taxAmount': 'Tax Amount',
  'pages.settlement.financialTaxReport.download': 'Download',
  'pages.settlement.financialTaxReport.downloadSuccess': 'Financial tax report downloaded successfully',
  
  // Settlement - Management
  'pages.settlement.management.title': 'Financial Management',
  'pages.settlement.management.breadcrumb': 'Financial Management',
  'pages.settlement.management.tab.platformCommission': 'Platform Commission',
  'pages.settlement.management.tab.sellers': 'Seller Settlement',
  'pages.settlement.management.platform.content': 'Platform Commission Settlement Details',
  'pages.settlement.management.platform.description': 'Monthly commission revenue and statistics',
  'pages.settlement.management.sellers.content': 'Seller Settlement Processing',
  'pages.settlement.management.sellers.description': 'Settlement details and processing by seller',
  
  // Logistics - Batch Tracking
  'pages.logistics.batchTracking.title': 'Batch Tracking Registration',
  'pages.logistics.batchTracking.subTitle': 'Register tracking numbers for multiple orders at once using an Excel file',
  'pages.logistics.batchTracking.selectFile': 'Please select a file',
  'pages.logistics.batchTracking.uploadSuccess': 'File upload completed',
  'pages.logistics.batchTracking.processSuccess': 'Tracking number registration completed',
  'pages.logistics.batchTracking.downloadTemplateSuccess': 'Template file download started',
  'pages.logistics.batchTracking.downloadTemplate': 'Download Template',
  'pages.logistics.batchTracking.uploadFile': 'Upload File',
  'pages.logistics.batchTracking.manualInput': 'Manual Input',
  'pages.logistics.batchTracking.selectExcelFile': 'Select Excel File',
  'pages.logistics.batchTracking.noErrors': 'No errors',
  'pages.logistics.batchTracking.downloadErrorsSuccess': 'Downloading {count} error records',
  'pages.logistics.batchTracking.downloadErrors': 'Download Errors',
  'pages.logistics.batchTracking.customer': 'Customer {num}',
  'pages.logistics.batchTracking.error.emptyTrackingNumber': 'Tracking number is empty',
  'pages.logistics.batchTracking.notEntered': 'Not Entered',
  'pages.logistics.batchTracking.step.upload.title': 'File Upload',
  'pages.logistics.batchTracking.step.upload.description': 'Select Excel file',
  'pages.logistics.batchTracking.step.review.title': 'Data Review',
  'pages.logistics.batchTracking.step.review.description': 'Validate uploaded data',
  'pages.logistics.batchTracking.step.complete.title': 'Registration Complete',
  'pages.logistics.batchTracking.step.complete.description': 'Tracking registration completed',
  'pages.logistics.batchTracking.uploadGuide.title': 'Excel File Upload Guide',
  'pages.logistics.batchTracking.uploadGuide.format': '• Supported formats: .xlsx, .xls',
  'pages.logistics.batchTracking.uploadGuide.columns': '• Required columns: Order Number, Tracking Number, Carrier, Shipping Date',
  'pages.logistics.batchTracking.uploadGuide.maxCount': '• Maximum 1,000 records can be registered at once',
  'pages.logistics.batchTracking.uploadGuide.template': '• Please download the template file and fill it out according to the format',
  'pages.logistics.batchTracking.column.status': 'Status',
  'pages.logistics.batchTracking.column.orderNo': 'Order Number',
  'pages.logistics.batchTracking.column.customerName': 'Customer Name',
  'pages.logistics.batchTracking.column.productCount': 'Product Count',
  'pages.logistics.batchTracking.column.trackingNumber': 'Tracking Number',
  'pages.logistics.batchTracking.column.carrier': 'Carrier',
  'pages.logistics.batchTracking.column.shippingDate': 'Shipping Date',
  'pages.logistics.batchTracking.column.errorMessage': 'Error Message',
  'pages.logistics.batchTracking.status.success': 'Success',
  'pages.logistics.batchTracking.status.error': 'Error',
  'pages.logistics.batchTracking.status.pending': 'Pending',
  'pages.logistics.batchTracking.stat.total': 'Total',
  'pages.logistics.batchTracking.stat.success': 'Success',
  'pages.logistics.batchTracking.stat.error': 'Error',
  'pages.logistics.batchTracking.stat.pending': 'Pending',
  'pages.logistics.batchTracking.errorsFound': '{count} errors found',
  'pages.logistics.batchTracking.errorsDescription': 'Items with errors will not be registered. Please download error data, fix it, and upload again.',
  'pages.logistics.batchTracking.uploadedData': 'Uploaded Data ({count} records)',
  'pages.logistics.batchTracking.reupload': 'Re-upload',
  'pages.logistics.batchTracking.registerTracking': 'Register Tracking ({count} records)',
  'pages.logistics.batchTracking.completeTitle': 'Tracking number registration completed',
  'pages.logistics.batchTracking.completeDescription': 'A total of {count} tracking numbers were successfully registered',
  'pages.logistics.batchTracking.errorsExist': '{count} errors exist',
  'pages.logistics.batchTracking.errorsNotRegistered': 'Items with errors were not registered',
  'pages.logistics.batchTracking.registerAgain': 'Register Again',
  'pages.logistics.batchTracking.goToOrders': 'Go to Order Management',
  'pages.logistics.batchTracking.resultDetail': 'Registration Result Detail',
  'pages.logistics.batchTracking.manualInputModal.title': 'Manual Tracking Input',
  'pages.logistics.batchTracking.manualInputModal.orderNo': 'Order Number',
  'pages.logistics.batchTracking.manualInputModal.trackingNumber': 'Tracking Number',
  'pages.logistics.batchTracking.manualInputModal.selectCarrier': 'Select Carrier',
  'pages.logistics.batchTracking.manualInputModal.shippingDate': 'Shipping Date',
  'pages.logistics.batchTracking.manualInputModal.memo': 'Memo (Optional)',
  'pages.logistics.batchTracking.manualInputSuccess': 'Tracking number registered',
  'pages.logistics.batchTracking.carrier.cj': 'CJ Logistics',
  'pages.logistics.batchTracking.carrier.post': 'Korea Post',
  'pages.logistics.batchTracking.carrier.hanjin': 'Hanjin Express',
  'pages.logistics.batchTracking.carrier.logen': 'Logen Logistics',
  'pages.logistics.batchTracking.carrier.kdexp': 'KD Express',
  
  // Logistics - Forwarders
  'pages.logistics.forwarders.title': 'Forwarder Management',
  'pages.logistics.forwarders.addForwarder': 'Add Forwarder',
  'pages.logistics.forwarders.deleteTitle': 'Delete Forwarder',
  'pages.logistics.forwarders.deleteConfirm': 'Do you want to delete forwarder "{name}"?',
  'pages.logistics.forwarders.deleteSuccess': 'Forwarder deleted',
  'pages.logistics.forwarders.updateSuccess': 'Forwarder information updated',
  'pages.logistics.forwarders.createSuccess': 'Forwarder registered',
  'pages.logistics.forwarders.apiTestLoading': 'Testing API connection...',
  'pages.logistics.forwarders.apiTestSuccess': 'API connection successful!',
  'pages.logistics.forwarders.apiSaveSuccess': 'API settings saved',
  'pages.logistics.forwarders.syncLoading': 'Synchronizing...',
  'pages.logistics.forwarders.syncSuccess': '{name} data synchronization completed',
  'pages.logistics.forwarders.column.id': 'ID',
  'pages.logistics.forwarders.column.name': 'Forwarder Name',
  'pages.logistics.forwarders.column.code': 'Forwarder Code',
  'pages.logistics.forwarders.column.apiStatus': 'API Status',
  'pages.logistics.forwarders.column.shippingMethods': 'Shipping Methods',
  'pages.logistics.forwarders.column.pricePerKg': 'Price (per kg)',
  'pages.logistics.forwarders.column.contactPerson': 'Contact Person',
  'pages.logistics.forwarders.column.phone': 'Phone',
  'pages.logistics.forwarders.column.totalOrders': 'Total Orders',
  'pages.logistics.forwarders.column.lastSync': 'Last Sync',
  'pages.logistics.forwarders.column.status': 'Status',
  'pages.logistics.forwarders.column.action': 'Actions',
  'pages.logistics.forwarders.type.domestic': 'Domestic',
  'pages.logistics.forwarders.type.international': 'International',
  'pages.logistics.forwarders.apiStatus.connected': 'Connected',
  'pages.logistics.forwarders.apiStatus.disconnected': 'Disconnected',
  'pages.logistics.forwarders.apiStatus.error': 'Error',
  'pages.logistics.forwarders.status.active': 'Active',
  'pages.logistics.forwarders.status.inactive': 'Inactive',
  'pages.logistics.forwarders.action.apiConfig': 'API Config',
  'pages.logistics.forwarders.action.sync': 'Sync',
  'pages.logistics.forwarders.stat.totalForwarders': 'Total Forwarders',
  'pages.logistics.forwarders.stat.apiConnected': 'API Connected',
  'pages.logistics.forwarders.stat.ordersThisMonth': 'Orders This Month',
  'pages.logistics.forwarders.stat.avgPrice': 'Average Price',
  'pages.logistics.forwarders.stat.avgPriceSuffix': 'KRW/kg',
  'pages.logistics.forwarders.modal.addTitle': 'Add Forwarder',
  'pages.logistics.forwarders.modal.editTitle': 'Edit Forwarder',
  'pages.logistics.forwarders.tab.basic': 'Basic Information',
  'pages.logistics.forwarders.tab.contact': 'Contact Information',
  'pages.logistics.forwarders.tab.memo': 'Memo',
  'pages.logistics.forwarders.form.name': 'Forwarder Name',
  'pages.logistics.forwarders.form.nameRequired': 'Please enter forwarder name',
  'pages.logistics.forwarders.form.namePlaceholder': 'e.g., CJ Logistics',
  'pages.logistics.forwarders.form.code': 'Forwarder Code',
  'pages.logistics.forwarders.form.codeRequired': 'Please enter code',
  'pages.logistics.forwarders.form.codePlaceholder': 'e.g., CJ',
  'pages.logistics.forwarders.form.type': 'Type',
  'pages.logistics.forwarders.form.typePlaceholder': 'Select Type',
  'pages.logistics.forwarders.form.pricePerKg': 'Price (per kg)',
  'pages.logistics.forwarders.form.shippingMethods': 'Shipping Methods',
  'pages.logistics.forwarders.form.shippingMethodsPlaceholder': 'Select Shipping Methods',
  'pages.logistics.forwarders.form.address': 'Address',
  'pages.logistics.forwarders.form.addressPlaceholder': 'Forwarder Address',
  'pages.logistics.forwarders.form.status': 'Status',
  'pages.logistics.forwarders.form.contactPerson': 'Contact Person',
  'pages.logistics.forwarders.form.contactPersonPlaceholder': 'Contact Person Name',
  'pages.logistics.forwarders.form.phone': 'Phone',
  'pages.logistics.forwarders.form.phonePlaceholder': '02-1234-5678',
  'pages.logistics.forwarders.form.email': 'Email',
  'pages.logistics.forwarders.form.emailPlaceholder': 'email@example.com',
  'pages.logistics.forwarders.form.memo': 'Admin Memo',
  'pages.logistics.forwarders.form.memoPlaceholder': 'Enter memo',
  'pages.logistics.forwarders.shippingMethod.air': 'Air',
  'pages.logistics.forwarders.shippingMethod.airExpress': 'Air Express',
  'pages.logistics.forwarders.shippingMethod.ship': 'Ship',
  'pages.logistics.forwarders.shippingMethod.shipExpress': 'Ship Express',
  'pages.logistics.forwarders.apiModal.title': 'API Settings - {name}',
  'pages.logistics.forwarders.apiModal.alertTitle': 'API Integration Guide',
  'pages.logistics.forwarders.apiModal.alertDescription': 'By integrating forwarder APIs, you can automatically track shipments and update delivery status in real-time.',
  'pages.logistics.forwarders.apiModal.apiKey': 'API Key',
  'pages.logistics.forwarders.apiModal.apiKeyRequired': 'Please enter API Key',
  'pages.logistics.forwarders.apiModal.apiKeyPlaceholder': 'Enter API Key',
  'pages.logistics.forwarders.apiModal.trackingUrl': 'Tracking URL',
  'pages.logistics.forwarders.apiModal.trackingUrlInvalid': 'Please enter a valid URL',
  'pages.logistics.forwarders.apiModal.trackingUrlPlaceholder': 'https://api.example.com/tracking',
  'pages.logistics.forwarders.apiModal.webhookUrl': 'Webhook URL (Optional)',
  'pages.logistics.forwarders.apiModal.webhookUrlPlaceholder': 'https://your-domain.com/webhook',
  'pages.logistics.forwarders.apiModal.timeout': 'Timeout (seconds)',
  'pages.logistics.forwarders.apiModal.testButton': 'Test API Connection',
  'pages.logistics.forwarders.simple.title': 'Forwarder Management',
  'pages.logistics.forwarders.simple.breadcrumb.logistics': 'Logistics Management',
  'pages.logistics.forwarders.simple.breadcrumb.forwarders': 'Forwarder Management',
  'pages.logistics.forwarders.simple.description': 'Forwarder Information Management',
  'pages.logistics.forwarders.simple.subDescription': 'Add, edit, delete forwarders and manage information',
  'pages.logistics.forwarders.mock.cjName': 'CJ Logistics',
  'pages.logistics.forwarders.mock.cjContact': 'Manager Kim',
  'pages.logistics.forwarders.mock.cjAddress': '39 Sejong-daero, Jung-gu, Seoul',
  'pages.logistics.forwarders.mock.cjMemo': 'CJ Logistics Main Account',
  'pages.logistics.forwarders.mock.postName': 'Korea Post',
  'pages.logistics.forwarders.mock.postContact': 'Manager Lee',
  'pages.logistics.forwarders.mock.postAddress': '26 Ujeongguk-ro, Jongno-gu, Seoul',
  'pages.logistics.forwarders.mock.postMemo': 'Korea Post Account',
  'pages.logistics.forwarders.mock.hanjinName': 'Hanjin Express',
  'pages.logistics.forwarders.mock.hanjinContact': 'Manager Park',
  'pages.logistics.forwarders.mock.hanjinAddress': '152 Teheran-ro, Gangnam-gu, Seoul',
  'pages.logistics.forwarders.mock.hanjinMemo': 'Hanjin Express Account',
  'pages.logistics.forwarders.mock.logenName': 'Logen Logistics',
  'pages.logistics.forwarders.mock.logenContact': 'Manager Choi',
  'pages.logistics.forwarders.mock.logenAddress': '289 Olympic-ro, Songpa-gu, Seoul',
  'pages.logistics.forwarders.mock.logenMemo': 'API Integration Pending',
  'pages.logistics.forwarders.mock.dhlAddress': '517 Yeongdong-daero, Gangnam-gu, Seoul',
  'pages.logistics.forwarders.mock.dhlMemo': 'DHL International Express',
  'pages.logistics.forwarders.mock.fedexAddress': '136 Sejong-daero, Jung-gu, Seoul',
  'pages.logistics.forwarders.mock.fedexMemo': 'API Error - Check Required',
  
  // Logistics - Rack Management
  'pages.logistics.rack.title': 'Rack Management',
  'pages.logistics.rack.addRack': 'Add Rack',
  'pages.logistics.rack.addRackSingle': 'Add Single Rack',
  'pages.logistics.rack.batchCreate': 'Batch Add (Column)',
  'pages.logistics.rack.batchUnavailable': 'Batch Unavailable',
  'pages.logistics.rack.batch.modalTitle': 'Batch Add Racks (Column)',
  'pages.logistics.rack.batch.columnFrom': 'Column From',
  'pages.logistics.rack.batch.columnTo': 'Column To',
  'pages.logistics.rack.batch.create': 'Create',
  'pages.logistics.rack.batch.columnRangeError': 'Column From must be less than or equal to Column To',
  'pages.logistics.rack.batch.maxColumnsWarning': 'Creating more than 100 racks at once may take a while.',
  'pages.logistics.rack.batch.createSuccess': '{count} rack(s) created successfully',
  'pages.logistics.rack.batch.createPartialError': '{count} rack(s) failed to create',
  'pages.logistics.rack.exportStatus': 'Export Rack Status',
  'pages.logistics.rack.deleteTitle': 'Delete Rack',
  'pages.logistics.rack.deleteConfirm': 'Do you want to delete rack "{code}"?',
  'pages.logistics.rack.deleteSuccess': 'Rack deleted',
  'pages.logistics.rack.deleteError': 'Failed to delete rack',
  'pages.logistics.rack.batchDelete': 'Batch Delete',
  'pages.logistics.rack.batchDeleteTitle': 'Batch Delete Racks',
  'pages.logistics.rack.batchDeleteConfirm': 'Are you sure you want to delete {count} rack(s)?',
  'pages.logistics.rack.batchDeleteSuccess': '{count} rack(s) deleted successfully',
  'pages.logistics.rack.batchDeletePartialSuccess': '{deleted} rack(s) deleted, {failed} failed',
  'pages.logistics.rack.batchDeleteError': 'Failed to delete racks',
  'pages.logistics.rack.selectRacksToDelete': 'Please select racks to delete',
  'pages.logistics.rack.cannotDeleteRacksWithProducts': 'Cannot delete {count} rack(s) that contain products',
  'pages.logistics.rack.cannotDeleteInactiveRacks': 'Cannot delete {count} inactive rack(s)',
  'pages.logistics.rack.noValidRacksToDelete': 'No valid racks to delete',
  'pages.logistics.rack.updateSuccess': 'Rack information updated',
  'pages.logistics.rack.createSuccess': 'Rack registered',
  'pages.logistics.rack.printQRSuccess': 'Preparing QR code print for {code}...',
  'pages.logistics.rack.column.id': 'ID',
  'pages.logistics.rack.column.rackCode': 'Rack Code',
  'pages.logistics.rack.column.warehouse': 'Warehouse',
  'pages.logistics.rack.column.zone': 'Zone',
  'pages.logistics.rack.column.location': 'Location',
  'pages.logistics.rack.column.trackingNumbers': 'Tracking Numbers',
  'pages.logistics.rack.column.row': 'Row',
  'pages.logistics.rack.column.column': 'Column',
  'pages.logistics.rack.column.level': 'Level',
  'pages.logistics.rack.column.capacity': 'Capacity',
  'pages.logistics.rack.column.productCount': 'Product Count',
  'pages.logistics.rack.column.status': 'Status',
  'pages.logistics.rack.column.environment': 'Environment',
  'pages.logistics.rack.column.lastUpdated': 'Last Updated',
  'pages.logistics.rack.column.action': 'Actions',
  'pages.logistics.rack.warehouse.weihai': 'Weihai',
  'pages.logistics.rack.warehouse.qingdao': 'Qingdao',
  'pages.logistics.rack.warehouse.guangzhou': 'Guangzhou',
  'pages.logistics.rack.warehouse.yiwu': 'Yiwu',
  'pages.logistics.rack.zone.A': 'Zone A',
  'pages.logistics.rack.zone.B': 'Zone B',
  'pages.logistics.rack.zone.C': 'Zone C',
  'pages.logistics.rack.zone.D': 'Zone D',
  'pages.logistics.rack.zone.E': 'Zone E',
  'pages.logistics.rack.location.row': 'Row',
  'pages.logistics.rack.location.column': 'Column',
  'pages.logistics.rack.location.level': 'Level',
  'pages.logistics.rack.capacity.inUse': 'In Use',
  'pages.logistics.rack.status.available': 'Available',
  'pages.logistics.rack.status.full': 'Full',
  'pages.logistics.rack.status.maintenance': 'In Use',
  'pages.logistics.rack.status.reserved': 'Reserved',
  'pages.logistics.rack.environment.temperature': 'Temperature',
  'pages.logistics.rack.environment.humidity': 'Humidity',
  'pages.logistics.rack.action.viewInventory': 'View Inventory',
  'pages.logistics.rack.inventory.empty': 'No inventory items found for this rack.',
  'pages.logistics.rack.stat.totalRacks': 'Total Racks',
  'pages.logistics.rack.stat.available': 'Available',
  'pages.logistics.rack.stat.full': 'Full',
  'pages.logistics.rack.stat.maintenance': 'In Use',
  'pages.logistics.rack.modal.addTitle': 'Add Rack',
  'pages.logistics.rack.modal.editTitle': 'Edit Rack',
  'pages.logistics.rack.form.warehouse': 'Warehouse',
  'pages.logistics.rack.form.warehousePlaceholder': 'Select Warehouse',
  'pages.logistics.rack.form.zone': 'Zone',
  'pages.logistics.rack.form.zonePlaceholder': 'Select Zone',
  'pages.logistics.rack.form.row': 'Row',
  'pages.logistics.rack.form.rowPlaceholder': 'e.g., 01',
  'pages.logistics.rack.form.column': 'Column',
  'pages.logistics.rack.form.columnPlaceholder': 'e.g., 05',
  'pages.logistics.rack.form.level': 'Level',
  'pages.logistics.rack.form.levelPlaceholder': 'e.g., 3',
  'pages.logistics.rack.form.capacity': 'Max Capacity',
  'pages.logistics.rack.form.capacityPlaceholder': 'Count',
  'pages.logistics.rack.form.status': 'Status',
  'pages.logistics.rack.form.statusPlaceholder': 'Select Status',
  'pages.logistics.rack.form.sizeType': 'Size Type',
  'pages.logistics.rack.form.sizeTypePlaceholder': 'Select Size Type',
  'pages.logistics.rack.form.sizeTypeRequired': 'Please select size type',
  'pages.logistics.rack.form.warehouseRequired': 'Please select warehouse',
  'pages.logistics.rack.form.notes': 'Notes',
  'pages.logistics.rack.form.notesPlaceholder': 'Enter notes (optional)',
  'pages.logistics.rack.location.zone': 'Zone',
  'pages.logistics.rack.fetchError': 'Failed to fetch racks',
  'pages.logistics.rack.createError': 'Failed to create rack',
  'pages.logistics.rack.updateError': 'Failed to update rack',
  'pages.logistics.rack.batchCreateTitle': 'Batch Create Racks',
  'pages.logistics.rack.batchCreateSuccess': 'Racks created successfully',
  'pages.logistics.rack.batchCreateError': 'Failed to batch create racks',
  'pages.logistics.rack.batchCreateConfirmTitle': 'Confirm Batch Create',
  'pages.logistics.rack.batchCreateConfirm': 'Do you want to create {count} racks?',
  'pages.logistics.rack.batchCreateNoRacks': 'No racks to create',
  'pages.logistics.rack.batchCreate.zoneStart': 'Zone Start Number',
  'pages.logistics.rack.batchCreate.zoneStartPlaceholder': 'Enter zone start number',
  'pages.logistics.rack.batchCreate.zoneEnd': 'Zone End Number',
  'pages.logistics.rack.batchCreate.zoneEndPlaceholder': 'Enter zone end number',
  'pages.logistics.rack.batchCreate.rackStart': 'Rack Start Number',
  'pages.logistics.rack.batchCreate.rackStartPlaceholder': 'Enter rack start number',
  'pages.logistics.rack.batchCreate.rackEnd': 'Rack End Number',
  'pages.logistics.rack.batchCreate.rackEndPlaceholder': 'Enter rack end number',
  'pages.logistics.rack.batchCreate.positionStart': 'Position Start Number',
  'pages.logistics.rack.batchCreate.positionStartPlaceholder': 'Enter position start number',
  'pages.logistics.rack.batchCreate.positionEnd': 'Position End Number',
  'pages.logistics.rack.batchCreate.positionEndPlaceholder': 'Enter position end number',
  'pages.logistics.rack.batchUnavailableTitle': 'Batch Set Unavailable',
  'pages.logistics.rack.batchUnavailableConfirm': 'Do you want to set {count} selected racks as unavailable?',
  'pages.logistics.rack.batchUnavailableSuccess': 'Racks set as unavailable successfully',
  'pages.logistics.rack.batchUnavailableError': 'Failed to set racks as unavailable',
  'pages.logistics.rack.noSelection': 'No items selected',
  'pages.logistics.rack.barcodeError': 'Barcode value not found',
  'pages.logistics.rack.printWindowError': 'Unable to open print window. Please allow popups for this site.',
  'pages.logistics.rack.barcodeGenerationError': 'Failed to generate barcode',
  'pages.logistics.rack.printBarcode': 'Print Barcode (Code-128)',
  'pages.logistics.rack.bulkBarcode': 'Print Selected Barcodes',
  'pages.logistics.rack.noRacksSelected': 'Please select at least one rack to print barcodes',
  'pages.logistics.rack.bulkBarcodeSuccess': 'Generated barcodes for {count} racks',

  // Logistics - Waybill Informations
  'pages.logistics.waybillInformations.title': 'Waybill Informations',
  'pages.logistics.waybillInformations.addTitle': 'Add Waybill Information',
  'pages.logistics.waybillInformations.editTitle': 'Edit Waybill Information',
  'pages.logistics.waybillInformations.deleteConfirm': 'Delete Waybill Information',
  'pages.logistics.waybillInformations.deleteConfirmContent': 'Are you sure you want to delete waybill information "{zyid}"?',
  'pages.logistics.waybillInformations.deleteSuccess': 'Waybill information deleted successfully',
  'pages.logistics.waybillInformations.updateSuccess': 'Waybill information updated successfully',
  'pages.logistics.waybillInformations.createSuccess': 'Waybill information created successfully',
  'pages.logistics.waybillInformations.submitError': 'Error saving waybill information',
  'pages.logistics.waybillInformations.exportSuccess': 'Exported {count} rows',
  'pages.logistics.waybillInformations.exportError': 'Export failed',
  'pages.logistics.waybillInformations.exporting': 'Exporting...',
  'pages.logistics.waybillInformations.column.shippedAt': 'Outbound Completed At',
  'pages.logistics.waybillInformations.column.secondPaidAt': '2nd Payment Date',
  'pages.logistics.waybillInformations.column.mailbox': 'Mailbox',
  'pages.logistics.waybillInformations.column.recipient': 'Recipient',
  'pages.logistics.waybillInformations.column.secondPaymentStatus': '2nd Payment Status',
  'pages.logistics.waybillInformations.column.secondPaymentMethod': '2nd Payment Method',
  'pages.logistics.waybillInformations.column.progressStatus': 'Progress Status',
  'pages.logistics.waybillInformations.column.warehouse': 'Warehouse',
  'pages.logistics.waybillInformations.column.transferMethod': 'Transfer Method',
  'pages.logistics.waybillInformations.column.weight': 'Weight',
  'pages.logistics.waybillInformations.column.internationalShipping': 'Intl. Shipping Cost',
  'pages.logistics.waybillInformations.column.ruralShipping': 'Remote Area Cost',
  'pages.logistics.waybillInformations.column.simplifiedClearance': 'Customs Clearance Cost',
  'pages.logistics.waybillInformations.column.service': 'Service Cost',
  'pages.logistics.waybillInformations.column.deposit': 'Deposit',
  'pages.logistics.waybillInformations.column.coupon': 'Coupon',
  'pages.logistics.waybillInformations.column.secondPaymentTotal': '2nd Payment Total',
  'pages.logistics.waybillInformations.filter.shippedStart': 'Outbound from',
  'pages.logistics.waybillInformations.filter.shippedEnd': 'Outbound to',
  'pages.logistics.waybillInformations.filter.secondPaidStart': '2nd payment from',
  'pages.logistics.waybillInformations.filter.secondPaidEnd': '2nd payment to',
  'pages.logistics.waybillInformations.paymentStatus.all': 'All 2nd payment statuses',
  'pages.logistics.waybillInformations.paymentStatus.unpaid': 'Unpaid',
  'pages.logistics.waybillInformations.paymentStatus.pending': 'Pending',
  'pages.logistics.waybillInformations.paymentStatus.processing': 'Processing',
  'pages.logistics.waybillInformations.paymentStatus.paid': 'Paid',
  'pages.logistics.waybillInformations.paymentStatus.failed': 'Failed',
  'pages.logistics.waybillInformations.paymentStatus.refunded': 'Refunded',
  'pages.logistics.waybillInformations.paymentMethod.all': 'All 2nd payment methods',
  'pages.logistics.waybillInformations.paymentMethod.card': 'Card',
  'pages.logistics.waybillInformations.paymentMethod.bank': 'Bank Transfer',
  'pages.logistics.waybillInformations.paymentMethod.deposit': 'Deposit',
  'pages.logistics.waybillInformations.paymentMethod.points': 'Points',
  'pages.logistics.waybillInformations.progressStatus.all': 'All progress statuses',
  'pages.logistics.waybillInformations.progressStatus.WH_PAY_WAIT': 'Outbound Payment Pending',
  'pages.logistics.waybillInformations.progressStatus.WH_PAY_DONE': 'Outbound Payment Complete',
  'pages.logistics.waybillInformations.progressStatus.WH_SHIPPED': 'Outbound Complete',
  'pages.logistics.waybillInformations.progressStatus.INTERNATIONAL_SHIPPING': 'International Shipping',
  'pages.logistics.waybillInformations.progressStatus.INTERNATIONAL_SHIPPED': 'International Shipping Complete',
  'pages.logistics.waybillInformations.transferMethod.all': 'All transfer methods',
  'pages.logistics.waybillInformations.transferMethod.ship': 'Sea',
  'pages.logistics.waybillInformations.transferMethod.air': 'Air',
  'pages.logistics.waybillInformations.transferMethod.shipExpress': 'Sea Express',
  'pages.logistics.waybillInformations.transferMethod.airExpress': 'Air Express',
  'pages.logistics.waybillInformations.warehouse.all': 'All warehouses',
  'pages.logistics.waybillInformations.column.id': 'ID',
  'pages.logistics.waybillInformations.column.orderNumber': 'Order Number',
  'pages.logistics.waybillInformations.column.totalProductPriceW': 'Total product price (W)',
  'pages.logistics.waybillInformations.column.shippingFeeWithinChinaW': 'Shipping fee within China (W)',
  'pages.logistics.waybillInformations.column.purchaseFeeW': 'Purchase fee (W)',
  'pages.logistics.waybillInformations.column.secondaryPaymentW': 'Secondary payment (W)',
  'pages.logistics.waybillInformations.column.totalProductPriceYuan': 'Total product price (¥)',
  'pages.logistics.waybillInformations.column.shippingFeeWithinChinaYuan': 'Shipping fee within China (¥)',
  'pages.logistics.waybillInformations.column.purchaseFeeYuan': 'Purchase fee (¥)',
  'pages.logistics.waybillInformations.column.secondaryPaymentYuan': 'Secondary payment (¥)',
  'pages.logistics.waybillInformations.column.waybillNumber': 'Waybill number',
  'pages.logistics.waybillInformations.column.paymentMethod': 'Payment method',
  'pages.logistics.waybillInformations.column.paymentType': 'Payment Type',
  'pages.logistics.waybillInformations.column.createdAt': 'Created At',
  'pages.logistics.waybillInformations.status.pending': 'Pending',
  'pages.logistics.waybillInformations.status.inTransit': 'In Transit',
  'pages.logistics.waybillInformations.status.delivered': 'Delivered',
  'pages.logistics.waybillInformations.status.exception': 'Exception',
  'pages.logistics.waybillInformations.form.id': 'ID',
  'pages.logistics.waybillInformations.form.idRequired': 'Please enter ID',
  'pages.logistics.waybillInformations.form.totalProductPriceW': 'Total product price (W)',
  'pages.logistics.waybillInformations.form.totalProductPriceWRequired': 'Please enter total product price (W)',
  'pages.logistics.waybillInformations.form.shippingFeeWithinChinaW': 'Shipping fee within China (W)',
  'pages.logistics.waybillInformations.form.shippingFeeWithinChinaWRequired': 'Please enter shipping fee within China (W)',
  'pages.logistics.waybillInformations.form.purchaseFeeW': 'Purchase fee (W)',
  'pages.logistics.waybillInformations.form.purchaseFeeWRequired': 'Please enter purchase fee (W)',
  'pages.logistics.waybillInformations.form.secondaryPaymentW': 'Secondary payment (W)',
  'pages.logistics.waybillInformations.form.secondaryPaymentWRequired': 'Please enter secondary payment (W)',
  'pages.logistics.waybillInformations.form.totalProductPriceYuan': 'Total product price (¥)',
  'pages.logistics.waybillInformations.form.totalProductPriceYuanRequired': 'Please enter total product price (¥)',
  'pages.logistics.waybillInformations.form.shippingFeeWithinChinaYuan': 'Shipping fee within China (¥)',
  'pages.logistics.waybillInformations.form.shippingFeeWithinChinaYuanRequired': 'Please enter shipping fee within China (¥)',
  'pages.logistics.waybillInformations.form.purchaseFeeYuan': 'Purchase fee (¥)',
  'pages.logistics.waybillInformations.form.purchaseFeeYuanRequired': 'Please enter purchase fee (¥)',
  'pages.logistics.waybillInformations.form.secondaryPaymentYuan': 'Secondary payment (¥)',
  'pages.logistics.waybillInformations.form.secondaryPaymentYuanRequired': 'Please enter secondary payment (¥)',
  'pages.logistics.waybillInformations.form.waybillNumber': 'Waybill number',
  'pages.logistics.waybillInformations.form.waybillNumberRequired': 'Please enter waybill number',
  'pages.logistics.waybillInformations.form.paymentMethod': 'Payment method',
  'pages.logistics.waybillInformations.form.paymentMethodRequired': 'Please select payment method',
  'pages.logistics.waybillInformations.form.paymentType': 'Payment Type',
  'pages.logistics.waybillInformations.form.paymentTypeRequired': 'Please select payment type',

  // Logistics - Waybill Bandwidth Management
  'pages.logistics.waybillBandwidthManagement.title': 'Waybill Bandwidth Management',
  'pages.logistics.waybillBandwidthManagement.column.no': 'No.',
  'pages.logistics.waybillBandwidthManagement.column.centerTransportationMethod': 'Center/Transportation Method',
  'pages.logistics.waybillBandwidthManagement.column.courier': 'Courier',
  'pages.logistics.waybillBandwidthManagement.column.title': 'Title',
  'pages.logistics.waybillBandwidthManagement.column.waybillBandwidth': 'Waybill bandwidth',
  'pages.logistics.waybillBandwidthManagement.column.totalBandwidth': 'Total bandwidth',
  'pages.logistics.waybillBandwidthManagement.column.waybillsUsed': 'Number of waybills used',
  'pages.logistics.waybillBandwidthManagement.column.waybillsAvailable': 'Number of available waybills',
  'pages.logistics.waybillBandwidthManagement.column.waybillNumberStart': 'Waybill Number Start',
  'pages.logistics.waybillBandwidthManagement.column.waybillNumberEnd': 'Waybill Number End',
  'pages.logistics.waybillBandwidthManagement.column.isInUse': 'Whether to use',
  'pages.logistics.waybillBandwidthManagement.column.registrationDate': 'Registration date',
  'pages.logistics.waybillBandwidthManagement.inUse': 'Used',
  'pages.logistics.waybillBandwidthManagement.notInUse': 'Not in use',
  'pages.logistics.waybillBandwidthManagement.deleteConfirm': 'Delete Waybill Bandwidth',
  'pages.logistics.waybillBandwidthManagement.deleteConfirmContent': 'Are you sure you want to delete "{title}"?',
  'pages.logistics.waybillBandwidthManagement.deleteSuccess': 'Deleted successfully',
  'pages.logistics.waybillBandwidthManagement.setInUseSuccess': 'Set to in use',
  'pages.logistics.waybillBandwidthManagement.setNotInUseSuccess': 'Set to not in use',
  'pages.logistics.waybillBandwidthManagement.addComingSoon': 'Add feature coming soon',
  'pages.logistics.waybillBandwidthManagement.addTitle': 'Add Waybill Bandwidth',
  'pages.logistics.waybillBandwidthManagement.editTitle': 'Edit Waybill Bandwidth',
  'pages.logistics.waybillBandwidthManagement.createSuccess': 'Waybill bandwidth created successfully',
  'pages.logistics.waybillBandwidthManagement.editSuccess': 'Waybill bandwidth updated successfully',
  'pages.logistics.waybillBandwidthManagement.submitError': 'Operation failed. Please try again.',
  'pages.logistics.waybillBandwidthManagement.column.includeInactive': 'Show',
  'pages.logistics.waybillBandwidthManagement.showAll': 'All',
  'pages.logistics.waybillBandwidthManagement.showActiveOnly': 'Active only',
  'pages.logistics.waybillBandwidthManagement.includeInactivePlaceholder': 'Filter by status',
  'pages.logistics.waybillBandwidthManagement.column.warehouse': 'Warehouse',
  'pages.logistics.waybillBandwidthManagement.column.transportationMethod': 'Transportation Method',
  'pages.logistics.waybillBandwidthManagement.form.warehouse': 'Warehouse',
  'pages.logistics.waybillBandwidthManagement.form.warehouseRequired': 'Please select warehouse',
  'pages.logistics.waybillBandwidthManagement.form.warehousePlaceholder': 'Please select warehouse',
  'pages.logistics.waybillBandwidthManagement.form.transportationMethod': 'Transportation Method',
  'pages.logistics.waybillBandwidthManagement.form.transportationMethodRequired': 'Please select transportation method',
  'pages.logistics.waybillBandwidthManagement.form.transportationMethodPlaceholder': 'Select transportation method',
  'pages.logistics.waybillBandwidthManagement.transportationMethod.ship': 'Ship',
  'pages.logistics.waybillBandwidthManagement.transportationMethod.air': 'Air',
  'pages.logistics.waybillBandwidthManagement.form.courier': 'Courier',
  'pages.logistics.waybillBandwidthManagement.form.courierRequired': 'Please enter courier',
  'pages.logistics.waybillBandwidthManagement.form.courierPlaceholder': 'e.g. CJ Logistics',
  'pages.logistics.waybillBandwidthManagement.form.title': 'Title',
  'pages.logistics.waybillBandwidthManagement.form.titleRequired': 'Please enter title',
  'pages.logistics.waybillBandwidthManagement.form.titlePlaceholder': 'e.g. Weihai RED - CJ - Air',
  'pages.logistics.waybillBandwidthManagement.form.file': 'File',
  'pages.logistics.waybillBandwidthManagement.form.fileRequired': 'Please upload Excel file',
  'pages.logistics.waybillBandwidthManagement.form.uploadFile': 'Upload File',
  'pages.logistics.waybillBandwidthManagement.form.fileTypeError': 'Only Excel files are allowed (.xlsx, .xls)',
  'pages.logistics.waybillBandwidthManagement.form.isActive': 'Active',
  'pages.logistics.waybillBandwidthManagement.waybillNumbers.title': 'Waybill Numbers',
  'pages.logistics.waybillBandwidthManagement.waybillNumbers.number': 'Waybill Number',
  'pages.logistics.waybillBandwidthManagement.waybillNumbers.used': 'Status',
  'pages.logistics.waybillBandwidthManagement.waybillNumbers.usedYes': 'Used',
  'pages.logistics.waybillBandwidthManagement.waybillNumbers.usedNo': 'Available',
  'pages.logistics.waybillBandwidthManagement.uploadMore.title': 'Add tracking numbers — {title}',
  'pages.logistics.waybillBandwidthManagement.uploadMore.titleFallback': 'Add tracking numbers from file',
  'pages.logistics.waybillBandwidthManagement.uploadMore.hint':
    'Numbers are read from the first column (Excel or CSV) or one per line (TXT). Duplicates and numbers already used elsewhere are skipped. Prefer .xlsx format.',
  'pages.logistics.waybillBandwidthManagement.uploadMore.pickFile': 'Select file',
  'pages.logistics.waybillBandwidthManagement.uploadMore.submit': 'Upload',
  'pages.logistics.waybillBandwidthManagement.uploadMore.action': 'Upload numbers',
  'pages.logistics.waybillBandwidthManagement.uploadMore.success': 'Added {added} tracking numbers. Total in pool: {totalInPool}.',
  'pages.logistics.waybillBandwidthManagement.uploadMore.successWithSkipped':
    'Added {added} new numbers; {skipped} skipped (duplicates). Total in pool: {totalInPool}.',
  'pages.logistics.waybillBandwidthManagement.uploadMore.noNew':
    'No new numbers were added ({skipped} rows were duplicates or already in this pool).',
  'pages.logistics.waybillBandwidthManagement.uploadMore.fileTypeError': 'Use .xlsx, .csv, or .txt only.',

  // Logistics - Collect Orders
  'pages.logistics.collectOrders.title': 'Collect Orders',
  'pages.logistics.collectOrders.statistics.total': 'Total',
  'pages.logistics.collectOrders.statistics.pending': 'Pending',
  'pages.logistics.collectOrders.statistics.processing': 'Processing',
  'pages.logistics.collectOrders.statistics.completed': 'Completed',
  'pages.logistics.collectOrders.column.waybillNumber': 'Waybill number',
  'pages.logistics.collectOrders.column.uid': 'User Information (UID)',
  'pages.logistics.collectOrders.column.productNumber': 'Product Number',
  'pages.logistics.collectOrders.column.shippingMethod': 'Shipping method',
  'pages.logistics.collectOrders.column.overseasWarehouse': 'Overseas warehouse',
  'pages.logistics.collectOrders.column.paymentStatus': 'Payment status',
  'pages.logistics.collectOrders.column.creationTime': 'Creation time',
  'pages.logistics.collectOrders.column.updateTime': 'Update time',
  'pages.logistics.collectOrders.column.state': 'state',
  'pages.logistics.collectOrders.column.storageFees': 'Storage fees',
  'pages.logistics.collectOrders.column.work': 'work',
  'pages.logistics.collectOrders.paymentStatus.paid': 'Paid',
  'pages.logistics.collectOrders.paymentStatus.unpaid': 'Unpaid',
  'pages.logistics.collectOrders.paymentStatus.partial': 'Partial',
  'pages.logistics.collectOrders.paymentStatus.refunded': 'Refunded',
  'pages.logistics.collectOrders.state.pending': 'Pending',
  'pages.logistics.collectOrders.state.processing': 'Processing',
  'pages.logistics.collectOrders.state.completed': 'Completed',
  'pages.logistics.collectOrders.state.cancelled': 'Cancelled',
  'pages.logistics.collectOrders.deleteConfirm': 'Delete Collect Order',
  'pages.logistics.collectOrders.deleteConfirmContent': 'Are you sure you want to delete collect order "{waybillNumber}"?',
  'pages.logistics.collectOrders.deleteSuccess': 'Collect order deleted successfully',
  'pages.logistics.collectOrders.edit': 'Edit',

  // Logistics - Transportation Methods
  'pages.logistics.transportationMethods.title': 'Transportation Methods',
  'pages.logistics.transportationMethods.addTitle': 'Add Transportation Method',
  'pages.logistics.transportationMethods.editTitle': 'Edit Transportation Method',
  'pages.logistics.transportationMethods.deleteConfirm': 'Delete Transportation Method',
  'pages.logistics.transportationMethods.deleteConfirmContent': 'Are you sure you want to delete transportation method "{regionId}"?',
  'pages.logistics.transportationMethods.deleteSuccess': 'Transportation method deleted successfully',
  'pages.logistics.transportationMethods.updateSuccess': 'Transportation method updated successfully',
  'pages.logistics.transportationMethods.createSuccess': 'Transportation method created successfully',
  'pages.logistics.transportationMethods.submitError': 'Error saving transportation method',
  'pages.logistics.transportationMethods.column.regionId': 'Region ID',
  'pages.logistics.transportationMethods.column.isActive': 'Active',
  'pages.logistics.transportationMethods.column.isInactive': 'Inactive',
  'pages.logistics.transportationMethods.column.icon': 'icon',
  'pages.logistics.transportationMethods.column.userLevel': 'User Level',
  'pages.logistics.transportationMethods.userLevelAll': 'All',
  'pages.logistics.transportationMethods.column.areaName': 'Area Name',
  'pages.logistics.transportationMethods.column.deliveryName': 'Delivery Name',
  'pages.logistics.transportationMethods.column.customsClearanceFees': 'Customs clearance fees',
  'pages.logistics.transportationMethods.column.serviceFee': 'Service fee',
  'pages.logistics.transportationMethods.column.visible': 'Visible',
  'pages.logistics.transportationMethods.column.work': 'work',
  'pages.logistics.transportationMethods.form.regionId': 'Region ID',
  'pages.logistics.transportationMethods.form.regionIdRequired': 'Please enter Region ID',
  'pages.logistics.transportationMethods.form.icon': 'icon',
  'pages.logistics.transportationMethods.form.iconPlaceholder': 'Enter image URL',
  'pages.logistics.transportationMethods.form.userLevel': 'User Level',
  'pages.logistics.transportationMethods.form.userLevelPlaceholder': 'e.g. All, Premium, Basic',
  'pages.logistics.transportationMethods.form.areaName': 'Area Name',
  'pages.logistics.transportationMethods.form.areaNameRequired': 'Please enter Area Name',
  'pages.logistics.transportationMethods.form.deliveryName': 'Delivery Name',
  'pages.logistics.transportationMethods.form.deliveryNameRequired': 'Please enter Delivery Name',
  'pages.logistics.transportationMethods.form.customsClearanceFees': 'Customs clearance fees',
  'pages.logistics.transportationMethods.form.customsClearanceFeesRequired': 'Please enter Customs clearance fees',
  'pages.logistics.transportationMethods.form.serviceFee': 'Service fee',
  'pages.logistics.transportationMethods.form.serviceFeeRequired': 'Please enter Service fee',
  'pages.logistics.transportationMethods.form.visible': 'Visible',
  'pages.logistics.transportationMethods.add': 'Add Transportation Method',
  'pages.logistics.transportationMethods.stepWeight': 'Step Weight (阶梯重量)',
  'pages.logistics.transportationMethods.additionalWeight': 'Additional Weight (续重重量)',
  'pages.logistics.transportationMethods.stepWeightPlaceholder': 'Step weight settings — to be implemented.',
  'pages.logistics.transportationMethods.additionalWeightPlaceholder': 'Additional weight settings — to be implemented.',
  'pages.logistics.transportationMethods.transportationFeeTitle': 'Transportation fee (Step weight & Additional weight)',
  'pages.logistics.transportationMethods.stairWeight': 'Stair Weight',
  'pages.logistics.transportationMethods.tieredPricing': 'Tiered Pricing',
  'pages.logistics.transportationMethods.additionalWeightPrice': 'Additional Weight Price',
  'pages.logistics.transportationMethods.registrationFee': 'Registration Fee',
  'pages.logistics.transportationMethods.form.serviceCostRatioOnly': 'Ratio (%)',
  'pages.logistics.transportationMethods.disable': 'Disable',
  'pages.logistics.transportationMethods.disableConfirm': 'Are you sure you want to disable this?',
  'pages.logistics.transportationMethods.disableSuccess': 'Disabled successfully',
  'pages.logistics.transportationMethods.column.id': 'ID',
  'pages.logistics.transportationMethods.column.serviceAreaName': 'Service Area Name',
  'pages.logistics.transportationMethods.column.customsCost': 'Customs Cost',
  'pages.logistics.transportationMethods.column.serviceCost': 'Service Cost',
  'pages.logistics.transportationMethods.column.isDisplayed': 'Display Status',
  'pages.logistics.transportationMethods.tab.basicInfo': 'Basic Information',
  'pages.logistics.transportationMethods.tab.weightSettings': 'Weight Settings',
  'pages.logistics.transportationMethods.tab.weightLimits': 'Weight Limits',
  'pages.logistics.transportationMethods.tab.deviation': 'Weight/Volume Deviation',
  'pages.logistics.transportationMethods.tab.actualWeight': 'Actual Weight',
  'pages.logistics.transportationMethods.tab.tieredWeight': 'Tiered Weight Settings',
  'pages.logistics.transportationMethods.tab.volumeWeight': 'Volume Weight Calculation',
  'pages.logistics.transportationMethods.tab.billingCriteria': 'Other Billing Criteria',
  'pages.logistics.transportationMethods.tab.routeInfo': 'Route Information',
  'pages.logistics.transportationMethods.tab.displayStatus': 'Display Status',
  'pages.logistics.transportationMethods.form.serviceArea': 'Service Area',
  'pages.logistics.transportationMethods.form.shippingWarehouse': 'Shipping Warehouse',
  'pages.logistics.transportationMethods.form.shippingWarehousePlaceholder': 'Select shipping warehouse',
  'pages.logistics.transportationMethods.form.customsCost': 'Customs Cost',
  'pages.logistics.transportationMethods.form.serviceCostCalculationType': 'Service Cost Calculation Type',
  'pages.logistics.transportationMethods.form.serviceCostFixed': 'Fixed Service Fee',
  'pages.logistics.transportationMethods.form.serviceCostRatio': 'Ratio (%)',
  'pages.logistics.transportationMethods.form.minWeight': 'Minimum Weight',
  'pages.logistics.transportationMethods.form.maxWeight': 'Maximum Weight',
  'pages.logistics.transportationMethods.form.minCalculationWeight': 'Minimum Calculation Weight',
  'pages.logistics.transportationMethods.form.sizeLimit': 'Size Limit',
  'pages.logistics.transportationMethods.form.weightDeviation': 'Weight Deviation (0~1)',
  'pages.logistics.transportationMethods.form.lengthDeviation': 'Length Deviation',
  'pages.logistics.transportationMethods.form.widthDeviation': 'Width Deviation',
  'pages.logistics.transportationMethods.form.heightDeviation': 'Height Deviation',
  'pages.logistics.transportationMethods.form.volumeDeviation': 'Volume Deviation',
  'pages.logistics.transportationMethods.form.actualWeightForCustoms': 'Weight for Customs Declaration (kg)',
  'pages.logistics.transportationMethods.form.actualWeightForBilling': 'Weight for Financial Comparison (kg)',
  'pages.logistics.transportationMethods.form.weightUnit': 'Weight Unit (kg)',
  'pages.logistics.transportationMethods.form.actualWeightRules': 'Rules for Customer Explanation',
  'pages.logistics.transportationMethods.form.baseWeight': 'Base Courier Weight (kg)',
  'pages.logistics.transportationMethods.form.basePrice': 'Base Price',
  'pages.logistics.transportationMethods.form.additionalWeight': 'Additional Weight (kg)',
  'pages.logistics.transportationMethods.form.additionalWeightPrice': 'Additional Weight Price',
  'pages.logistics.transportationMethods.form.tieredWeights': 'Tiered Weight and Price',
  'pages.logistics.transportationMethods.form.volumeCoefficient': 'Volume Coefficient',
  'pages.logistics.transportationMethods.form.volumeExpansionMode': 'Volume Expansion Mode',
  'pages.logistics.transportationMethods.form.logisticsProcessingFee': 'Logistics Processing Fee',
  'pages.logistics.transportationMethods.form.fuelCost': 'Fuel Cost',
  'pages.logistics.transportationMethods.form.operatingCost': 'Operating Cost',
  'pages.logistics.transportationMethods.form.taxPaymentMethod': 'Tax Payment Method',
  'pages.logistics.transportationMethods.form.taxDeclarationMethod': 'Declaration Method',
  'pages.logistics.transportationMethods.form.shippingTime': 'Shipping Time Required',
  'pages.logistics.transportationMethods.form.routeRiskNotice': 'Transportation Route Risk Notice',
  'pages.logistics.transportationMethods.form.routeFeeStandard': 'Route Fee Standard',
  'pages.logistics.transportationMethods.form.lineCharacteristics': 'Line Characteristics',
  'pages.logistics.transportationMethods.form.volumeBillingRules': 'Volume Billing Rules',
  'pages.logistics.transportationMethods.form.volumeBillingRulesPlaceholder': 'Enter numbers only',
  'pages.logistics.transportationMethods.form.deliveryNamePlaceholder': 'Enter delivery name',
  'pages.logistics.transportationMethods.form.serviceAreaPlaceholder': 'Enter service area',
  'pages.logistics.transportationMethods.form.shippingTimePlaceholder': 'e.g. 2-3 days',
  'pages.logistics.transportationMethods.form.routeRiskNoticePlaceholder': 'Enter transportation route risk notice',
  'pages.logistics.transportationMethods.form.lineCharacteristicsPlaceholder': 'Enter line characteristics',
  'pages.logistics.transportationMethods.form.upload': 'Upload',
  'pages.logistics.transportationMethods.displayed': 'Displayed',
  'pages.logistics.transportationMethods.hidden': 'Hidden',
  'pages.logistics.transportationMethods.active': 'Active',
  'pages.logistics.transportationMethods.inactive': 'Inactive',
  'pages.logistics.transportationMethods.form.isDisplayed': 'Frontend User Display Status',
  'pages.logistics.transportationMethods.form.isActive': 'Active Status',

  // Logistics - Logistics Trajectory
  'pages.logistics.logisticsTrajectory.title': 'Logistics Trajectory',
  'pages.logistics.logisticsTrajectory.viewAll': 'View All',
  'pages.logistics.logisticsTrajectory.column.waybillNumber': 'Waybill number',
  'pages.logistics.logisticsTrajectory.column.uid': 'User Information (UID)',
  'pages.logistics.logisticsTrajectory.column.productNumber': 'Product Number',
  'pages.logistics.logisticsTrajectory.column.shippingMethod': 'Shipping method',
  'pages.logistics.logisticsTrajectory.column.overseasWarehouse': 'Overseas warehouse',
  'pages.logistics.logisticsTrajectory.column.paymentStatus': 'Payment status',
  'pages.logistics.logisticsTrajectory.column.creationTime': 'Creation time',
  'pages.logistics.logisticsTrajectory.column.updateTime': 'Update time',
  'pages.logistics.logisticsTrajectory.column.state': 'state',
  'pages.logistics.logisticsTrajectory.column.storageFees': 'Storage fees',
  'pages.logistics.logisticsTrajectory.column.work': 'work',
  'pages.logistics.logisticsTrajectory.paymentStatus.paid': 'Paid',
  'pages.logistics.logisticsTrajectory.paymentStatus.unpaid': 'Unpaid',
  'pages.logistics.logisticsTrajectory.paymentStatus.partial': 'Partial',
  'pages.logistics.logisticsTrajectory.paymentStatus.refunded': 'Refunded',
  'pages.logistics.logisticsTrajectory.viewTrajectory': 'View Trajectory',
  'pages.logistics.logisticsTrajectory.filter.group.entire': 'Entire',
  'pages.logistics.logisticsTrajectory.filter.group.chinaWarehouse': 'China Warehouse',
  'pages.logistics.logisticsTrajectory.filter.group.chinaCustoms': 'China Customs',
  'pages.logistics.logisticsTrajectory.filter.group.international': 'International Transport',
  'pages.logistics.logisticsTrajectory.filter.group.destinationCustoms': 'Destination Customs',
  'pages.logistics.logisticsTrajectory.filter.group.destinationWarehouse': 'Destination Warehouse',
  'pages.logistics.logisticsTrajectory.filter.group.transitCenter': 'Transit Center',
  'pages.logistics.logisticsTrajectory.filter.group.delivery': 'Delivery',
  'pages.logistics.logisticsTrajectory.filter.group.completed': 'Completed',
  'pages.logistics.logisticsTrajectory.filter.entire': 'Entire',
  'pages.logistics.logisticsTrajectory.filter.warehouseAwaiting': 'China warehouse awaiting shipment',
  'pages.logistics.logisticsTrajectory.filter.shipmentCompleted': 'Shipment from Chinese Warehouse Completed',
  'pages.logistics.logisticsTrajectory.filter.arrivalChineseCustoms': 'Arrival at chinese customs',
  'pages.logistics.logisticsTrajectory.filter.customsReleased': 'During Customs has released it',
  'pages.logistics.logisticsTrajectory.filter.internationalTransport': 'International transport',
  'pages.logistics.logisticsTrajectory.filter.arrivalDestinationCustoms': 'arrival at customs at the destination',
  'pages.logistics.logisticsTrajectory.filter.customsInspection': 'customs inspection in the destination country',
  'pages.logistics.logisticsTrajectory.filter.arrivalKoreanWarehouse': 'arrival at korean warehouse',
  'pages.logistics.logisticsTrajectory.filter.pickingTransitCenter': 'picking at the destination transfer center',
  'pages.logistics.logisticsTrajectory.filter.deliveryBeginsTransit': 'delivery begins at the destination transit center',
  'pages.logistics.logisticsTrajectory.filter.localDelivery': 'local delivery',
  'pages.logistics.logisticsTrajectory.filter.localDeliveryDestination': 'local delivery in the destination country',
  'pages.logistics.logisticsTrajectory.filter.packageDelivered': 'package has been delivered',
  'pages.logistics.logisticsTrajectory.filter.customerSigned': 'customer has signed for the package',

  // Logistics - Goods
  'pages.logistics.goods.title': 'Goods',
  'pages.logistics.goods.addTitle': 'Add Good',
  'pages.logistics.goods.editTitle': 'Edit Good',
  'pages.logistics.goods.detailTitle': 'Good Details',
  'pages.logistics.goods.deleteConfirm': 'Delete Good',
  'pages.logistics.goods.deleteConfirmContent': 'Are you sure you want to delete good "{goodName}"?',
  'pages.logistics.goods.deleteSuccess': 'Good deleted successfully',
  'pages.logistics.goods.updateSuccess': 'Good updated successfully',
  'pages.logistics.goods.createSuccess': 'Good created successfully',
  'pages.logistics.goods.submitError': 'Error saving good',
  'pages.logistics.goods.column.image': 'Image',
  'pages.logistics.goods.column.goodCode': 'Good Code',
  'pages.logistics.goods.column.goodName': 'Good Name',
  'pages.logistics.goods.column.category': 'Category',
  'pages.logistics.goods.column.weight': 'Weight',
  'pages.logistics.goods.column.dimensions': 'Dimensions',
  'pages.logistics.goods.column.volume': 'Volume',
  'pages.logistics.goods.column.unitPrice': 'Unit Price',
  'pages.logistics.goods.column.status': 'Status',
  'pages.logistics.goods.column.description': 'Description',
  'pages.logistics.goods.status.active': 'Active',
  'pages.logistics.goods.status.inactive': 'Inactive',
  'pages.logistics.goods.status.discontinued': 'Discontinued',
  'pages.logistics.goods.form.goodCode': 'Good Code',
  'pages.logistics.goods.form.goodCodeRequired': 'Please enter good code',
  'pages.logistics.goods.form.goodName': 'Good Name',
  'pages.logistics.goods.form.goodNameRequired': 'Please enter good name',
  'pages.logistics.goods.form.category': 'Category',
  'pages.logistics.goods.form.categoryRequired': 'Please select category',
  'pages.logistics.goods.form.weight': 'Weight',
  'pages.logistics.goods.form.weightRequired': 'Please enter weight',
  'pages.logistics.goods.form.length': 'Length',
  'pages.logistics.goods.form.lengthRequired': 'Please enter length',
  'pages.logistics.goods.form.width': 'Width',
  'pages.logistics.goods.form.widthRequired': 'Please enter width',
  'pages.logistics.goods.form.height': 'Height',
  'pages.logistics.goods.form.heightRequired': 'Please enter height',
  'pages.logistics.goods.form.unitPrice': 'Unit Price',
  'pages.logistics.goods.form.unitPriceRequired': 'Please enter unit price',
  'pages.logistics.goods.form.imageUrl': 'Image URL',
  'pages.logistics.goods.form.description': 'Description',
  'pages.logistics.goods.form.status': 'Status',
  'pages.logistics.goods.form.statusRequired': 'Please select status',

  // Logistics - Logistics Trajectory
  'pages.logistics.logisticsTrajectory.searchPlaceholder': 'Enter tracking number',
  'pages.logistics.logisticsTrajectory.enterTrackingNumber': 'Please enter tracking number',
  'pages.logistics.logisticsTrajectory.searchSuccess': 'Tracking information found',
  'pages.logistics.logisticsTrajectory.searchNotFound': 'Tracking information not found',
  'pages.logistics.logisticsTrajectory.refreshSuccess': 'Data refreshed successfully',
  'pages.logistics.logisticsTrajectory.trajectoryDetails': 'Trajectory Details - {trackingNumber}',
  'pages.logistics.logisticsTrajectory.operator': 'Operator',
  'pages.logistics.logisticsTrajectory.column.trackingNumber': 'Tracking Number',
  'pages.logistics.logisticsTrajectory.column.orderNumber': 'Order Number',
  'pages.logistics.logisticsTrajectory.column.carrier': 'Carrier',
  'pages.logistics.logisticsTrajectory.column.origin': 'Origin',
  'pages.logistics.logisticsTrajectory.column.destination': 'Destination',
  'pages.logistics.logisticsTrajectory.column.currentStatus': 'Current Status',
  'pages.logistics.logisticsTrajectory.column.eventCount': 'Event Count',
  'pages.logistics.logisticsTrajectory.status.pending': 'Pending',
  'pages.logistics.logisticsTrajectory.status.inTransit': 'In Transit',
  'pages.logistics.logisticsTrajectory.status.outForDelivery': 'Out for Delivery',
  'pages.logistics.logisticsTrajectory.status.delivered': 'Delivered',
  'pages.logistics.logisticsTrajectory.status.exception': 'Exception',

  // Logistics - Regional Management
  'pages.logistics.regionalManagement.title': 'Regional Country Management',
  'pages.logistics.regionalManagement.addTitle': 'Add New Information',
  'pages.logistics.regionalManagement.editTitle': 'Edit Region Information',
  'pages.logistics.regionalManagement.add': 'Add New Information',
  'pages.logistics.regionalManagement.deleteConfirm': 'Are you sure you want to delete?',
  'pages.logistics.regionalManagement.deleteConfirmContent': 'Are you sure you want to delete this region information?',
  'pages.logistics.regionalManagement.deleteSuccess': 'Deleted successfully',
  'pages.logistics.regionalManagement.updateSuccess': 'Updated successfully',
  'pages.logistics.regionalManagement.createSuccess': 'Created successfully',
  'pages.logistics.regionalManagement.submitError': 'An error occurred',
  'pages.logistics.regionalManagement.batchDelete': 'Batch Delete Information',
  'pages.logistics.regionalManagement.batchDeleteConfirm': 'Batch Delete',
  'pages.logistics.regionalManagement.batchDeleteConfirmContent': 'Are you sure you want to delete {count} selected items?',
  'pages.logistics.regionalManagement.batchDeleteSuccess': 'Deleted successfully',
  'pages.logistics.regionalManagement.selectItemsFirst': 'Please select items to delete',
  'pages.logistics.regionalManagement.column.id': 'ID',
  'pages.logistics.regionalManagement.column.image': 'Image',
  'pages.logistics.regionalManagement.column.region': 'Region',
  'pages.logistics.regionalManagement.column.regionNameEn': 'Region English Name',
  'pages.logistics.regionalManagement.column.countryCode': 'Country Code',
  'pages.logistics.regionalManagement.column.destinationCountry': 'Destination Country',
  'pages.logistics.regionalManagement.column.destinationCity': 'Destination City',
  'pages.logistics.regionalManagement.column.affiliationTag': 'Affiliation Tag',
  'pages.logistics.regionalManagement.column.customRegionCode': 'Custom Region Code',
  'pages.logistics.regionalManagement.column.countryPhoneCode': 'Country Phone Code',
  'pages.logistics.regionalManagement.column.createdAt': 'Created Time',
  'pages.logistics.regionalManagement.filter.startDate': 'Start date',
  'pages.logistics.regionalManagement.filter.endDate': 'End date',
  'pages.logistics.regionalManagement.filter.selectDate': 'Select date',
  'pages.logistics.regionalManagement.column.regionCode': 'Region Code',
  'pages.logistics.regionalManagement.column.regionName': 'Region Name',
  'pages.logistics.regionalManagement.column.country': 'Country',
  'pages.logistics.regionalManagement.column.province': 'Province',
  'pages.logistics.regionalManagement.column.city': 'City',
  'pages.logistics.regionalManagement.column.postalCode': 'Postal Code',
  'pages.logistics.regionalManagement.column.timeZone': 'Time Zone',
  'pages.logistics.regionalManagement.column.currency': 'Currency',
  'pages.logistics.regionalManagement.column.isActive': 'Active',
  'pages.logistics.regionalManagement.column.updatedAt': 'Updated At',
  'pages.logistics.regionalManagement.treeTitle': 'Region Tree',
  'pages.logistics.regionalManagement.detailsTitle': 'Region Details',
  'pages.logistics.regionalManagement.selectAreaFirst': 'Please select an area first',
  'pages.logistics.regionalManagement.selectAreaHint': 'Select a region from the tree on the left to view details',
  'pages.logistics.regionalManagement.form.region': 'Region',
  'pages.logistics.regionalManagement.form.regionRequired': 'Please enter region',
  'pages.logistics.regionalManagement.form.regionPlaceholder': 'Enter region',
  'pages.logistics.regionalManagement.form.regionNameEn': 'Region English Name',
  'pages.logistics.regionalManagement.form.regionNameEnRequired': 'Please enter region English name',
  'pages.logistics.regionalManagement.form.regionNameEnPlaceholder': 'Enter region English name',
  'pages.logistics.regionalManagement.form.countryCode': 'Country Code',
  'pages.logistics.regionalManagement.form.countryCodeRequired': 'Please enter country code',
  'pages.logistics.regionalManagement.form.countryCodePlaceholder': 'e.g., KR, CN, US',
  'pages.logistics.regionalManagement.form.destinationCountry': 'Destination Country',
  'pages.logistics.regionalManagement.form.destinationCountryRequired': 'Please enter destination country',
  'pages.logistics.regionalManagement.form.destinationCountryPlaceholder': 'Enter destination country',
  'pages.logistics.regionalManagement.form.destinationCity': 'Destination City',
  'pages.logistics.regionalManagement.form.destinationCityRequired': 'Please enter destination city',
  'pages.logistics.regionalManagement.form.destinationCityPlaceholder': 'Enter destination city',
  'pages.logistics.regionalManagement.form.affiliationTag': 'Affiliation Tag',
  'pages.logistics.regionalManagement.form.affiliationTagPlaceholder': 'Enter affiliation tag',
  'pages.logistics.regionalManagement.form.customRegionCode': 'Custom Region Code',
  'pages.logistics.regionalManagement.form.customRegionCodePlaceholder': 'Enter custom region code',
  'pages.logistics.regionalManagement.form.countryPhoneCode': 'Country Phone Code',
  'pages.logistics.regionalManagement.form.countryPhoneCodeRequired': 'Please enter country phone code',
  'pages.logistics.regionalManagement.form.countryPhoneCodePlaceholder': 'e.g., +82, +86',
  'pages.logistics.regionalManagement.form.image': 'Image',
  'pages.logistics.regionalManagement.form.regionCode': 'Region Code',
  'pages.logistics.regionalManagement.form.regionCodeRequired': 'Please enter region code',
  'pages.logistics.regionalManagement.form.regionName': 'Region Name',
  'pages.logistics.regionalManagement.form.regionNameRequired': 'Please enter region name',
  'pages.logistics.regionalManagement.form.country': 'Country',
  'pages.logistics.regionalManagement.form.countryRequired': 'Please enter country',
  'pages.logistics.regionalManagement.form.province': 'Province',
  'pages.logistics.regionalManagement.form.city': 'City',
  'pages.logistics.regionalManagement.form.postalCode': 'Postal Code',
  'pages.logistics.regionalManagement.form.timeZone': 'Time Zone',
  'pages.logistics.regionalManagement.form.timeZoneRequired': 'Please enter time zone',
  'pages.logistics.regionalManagement.form.currency': 'Currency',
  'pages.logistics.regionalManagement.form.currencyRequired': 'Please enter currency',
  'pages.logistics.regionalManagement.form.description': 'Description',
  'pages.logistics.regionalManagement.form.isActive': 'Active',

  // Logistics - International Tracking Number Management
  'pages.logistics.internationalTrackingNumberManagement.title': 'International Tracking Number Management',
  'pages.logistics.internationalTrackingNumberManagement.addTitle': 'Add New Tracking Number',
  'pages.logistics.internationalTrackingNumberManagement.editTitle': 'Edit Tracking Number',
  'pages.logistics.internationalTrackingNumberManagement.add': 'Add New Tracking Number',
  'pages.logistics.internationalTrackingNumberManagement.deleteConfirm': 'Are you sure you want to delete?',
  'pages.logistics.internationalTrackingNumberManagement.deleteConfirmContent': 'Are you sure you want to delete tracking number "{trackingNumber}"?',
  'pages.logistics.internationalTrackingNumberManagement.deleteSuccess': 'Deleted successfully',
  'pages.logistics.internationalTrackingNumberManagement.updateSuccess': 'Updated successfully',
  'pages.logistics.internationalTrackingNumberManagement.createSuccess': 'Created successfully',
  'pages.logistics.internationalTrackingNumberManagement.submitError': 'An error occurred',
  'pages.logistics.internationalTrackingNumberManagement.selectItemsFirst': 'Please select items to export',
  'pages.logistics.internationalTrackingNumberManagement.exportSuccess': 'Exported {count} items',
  'pages.logistics.internationalTrackingNumberManagement.importSea': 'Import Sea Shipping Excel',
  'pages.logistics.internationalTrackingNumberManagement.importAir': 'Import Air Shipping Excel',
  'pages.logistics.internationalTrackingNumberManagement.importSeaTitle': 'Import Sea Shipping Excel',
  'pages.logistics.internationalTrackingNumberManagement.importAirTitle': 'Import Air Shipping Excel',
  'pages.logistics.internationalTrackingNumberManagement.importSuccess': '{type} Excel file imported successfully',
  'pages.logistics.internationalTrackingNumberManagement.importError': 'Error occurred during import',
  'pages.logistics.internationalTrackingNumberManagement.fileRequired': 'Please select a file',
  'pages.logistics.internationalTrackingNumberManagement.uploadFile': 'Select File',
  'pages.logistics.internationalTrackingNumberManagement.column.id': 'ID',
  'pages.logistics.internationalTrackingNumberManagement.column.trackingNumber': 'Tracking Number',
  'pages.logistics.internationalTrackingNumberManagement.column.transportationType': 'Transportation Type',
  'pages.logistics.internationalTrackingNumberManagement.column.status': 'Status',
  'pages.logistics.internationalTrackingNumberManagement.column.createdAt': 'Created Time',
  'pages.logistics.internationalTrackingNumberManagement.filter.selectDate': 'Select date',
  'pages.logistics.internationalTrackingNumberManagement.column.orderNumber': 'Order Number',
  'pages.logistics.internationalTrackingNumberManagement.column.state': 'State',
  'pages.logistics.internationalTrackingNumberManagement.column.time': 'Time',
  'pages.logistics.internationalTrackingNumberManagement.column.operate': 'Operate',
  'pages.logistics.internationalTrackingNumberManagement.column.carrier': 'Carrier',
  'pages.logistics.internationalTrackingNumberManagement.transportationType.sea': 'Sea Shipping',
  'pages.logistics.internationalTrackingNumberManagement.transportationType.air': 'Air Shipping',
  'pages.logistics.internationalTrackingNumberManagement.status.unused': 'Unused',
  'pages.logistics.internationalTrackingNumberManagement.status.used': 'Used',
  'pages.logistics.internationalTrackingNumberManagement.form.trackingNumber': 'International Tracking Number',
  'pages.logistics.internationalTrackingNumberManagement.form.trackingNumberRequired': 'Please enter tracking number',
  'pages.logistics.internationalTrackingNumberManagement.form.trackingNumberPlaceholder': 'Enter tracking number',
  'pages.logistics.internationalTrackingNumberManagement.form.transportationType': 'Transportation Type',
  'pages.logistics.internationalTrackingNumberManagement.form.transportationTypeRequired': 'Please select transportation type',
  'pages.logistics.internationalTrackingNumberManagement.form.transportationTypePlaceholder': 'Select transportation type',
  'pages.logistics.internationalTrackingNumberManagement.form.excelFile': 'Excel File',
  'pages.logistics.internationalTrackingNumberManagement.form.excelFileRequired': 'Please select an Excel file',

  // Logistics - HS Product Code Management
  'pages.logistics.hsProductCodeManagement.title': 'HS Product Code Management',
  'pages.logistics.hsProductCodeManagement.addTitle': 'Add New Classification',
  'pages.logistics.hsProductCodeManagement.editTitle': 'Edit HS Product Code',
  'pages.logistics.hsProductCodeManagement.add': 'Add New Classification',
  'pages.logistics.hsProductCodeManagement.deleteConfirm': 'Are you sure you want to delete?',
  'pages.logistics.hsProductCodeManagement.deleteSuccess': 'Deleted successfully',
  'pages.logistics.hsProductCodeManagement.updateSuccess': 'Updated successfully',
  'pages.logistics.hsProductCodeManagement.createSuccess': 'Created successfully',
  'pages.logistics.hsProductCodeManagement.submitError': 'An error occurred',
  'pages.logistics.hsProductCodeManagement.importBulk': 'Bulk Import Classifications',
  'pages.logistics.hsProductCodeManagement.importSelective': 'Selective Import Classifications',
  'pages.logistics.hsProductCodeManagement.importBulkTitle': 'Bulk Import Classifications',
  'pages.logistics.hsProductCodeManagement.importSelectiveTitle': 'Selective Import Classifications',
  'pages.logistics.hsProductCodeManagement.importSuccess': '{type} import completed successfully',
  'pages.logistics.hsProductCodeManagement.importError': 'Error occurred during import',
  'pages.logistics.hsProductCodeManagement.importType.bulk': 'Bulk',
  'pages.logistics.hsProductCodeManagement.importType.selective': 'Selective',
  'pages.logistics.hsProductCodeManagement.export': 'Export Classifications',
  'pages.logistics.hsProductCodeManagement.exportSuccess': 'Export completed successfully',
  'pages.logistics.hsProductCodeManagement.fileRequired': 'Please select a file',
  'pages.logistics.hsProductCodeManagement.uploadFile': 'Select File',
  'pages.logistics.hsProductCodeManagement.column.id': 'ID',
  'pages.logistics.hsProductCodeManagement.column.classificationName': 'Classification Name',
  'pages.logistics.hsProductCodeManagement.column.classificationNameEn': 'Classification English Name',
  'pages.logistics.hsProductCodeManagement.column.productCode': 'Product Code',
  'pages.logistics.hsProductCodeManagement.column.simplifiedType': 'Simplified/Non-simplified',
  'pages.logistics.hsProductCodeManagement.column.createdAt': 'Added Time',
  'pages.logistics.hsProductCodeManagement.simplifiedType.simplified': 'Simplified',
  'pages.logistics.hsProductCodeManagement.simplifiedType.nonSimplified': 'Non-simplified',
  'pages.logistics.hsProductCodeManagement.form.classificationName': 'Classification Name',
  'pages.logistics.hsProductCodeManagement.form.classificationNameRequired': 'Please enter classification name',
  'pages.logistics.hsProductCodeManagement.form.classificationNamePlaceholder': 'Enter classification name',
  'pages.logistics.hsProductCodeManagement.form.classificationNameEn': 'Classification English Name',
  'pages.logistics.hsProductCodeManagement.form.classificationNameEnRequired': 'Please enter classification English name',
  'pages.logistics.hsProductCodeManagement.form.classificationNameEnPlaceholder': 'Enter classification English name',
  'pages.logistics.hsProductCodeManagement.form.productCode': 'Product Code',
  'pages.logistics.hsProductCodeManagement.form.productCodeRequired': 'Please enter product code',
  'pages.logistics.hsProductCodeManagement.form.productCodePlaceholder': 'e.g., HS6203.42.90',
  'pages.logistics.hsProductCodeManagement.form.simplifiedType': 'Simplified/Non-simplified',
  'pages.logistics.hsProductCodeManagement.form.simplifiedTypeRequired': 'Please select simplified type',
  'pages.logistics.hsProductCodeManagement.form.referenceImage': 'Reference Image',
  'pages.logistics.hsProductCodeManagement.form.excelFile': 'Excel File',
  'pages.logistics.hsProductCodeManagement.form.excelFileRequired': 'Please select an Excel file',

  // Article Management page
  'pages.articleManagement.title': 'Article Management',
  'pages.articleManagement.add': 'Create Article',
  'pages.articleManagement.edit': 'Edit Article',
  'pages.articleManagement.delete': 'Delete Article',
  'pages.articleManagement.deleteConfirm': 'Delete Article',
  'pages.articleManagement.deleteConfirmMessage': 'Are you sure you want to delete article "{title}"?',

  // Website Content Management
  'pages.system.websiteContentManagement.title': 'Website Content Management',
  'pages.system.websiteContentManagement.tab.seoSettings': 'Website SEO Settings',
  'pages.system.websiteContentManagement.tab.emailConfiguration': 'Email Configuration',
  'pages.system.websiteContentManagement.tab.imageSettings': 'Image Settings',
  'pages.system.websiteContentManagement.tab.basicConfiguration': 'Website Basic Configuration',
  'pages.system.websiteContentManagement.tab.appSettings': 'App Settings',

  // Website SEO Settings
  'pages.system.websiteSEOSettings.title': 'Website SEO Settings',
  'pages.system.websiteSEOSettings.websiteTitle': 'Website Title:',
  'pages.system.websiteSEOSettings.websiteTitlePlaceholder': 'Website Title',
  'pages.system.websiteSEOSettings.websiteKeywords': 'Website keywords:',
  'pages.system.websiteSEOSettings.websiteKeywordsPlaceholder': 'Website keywords',
  'pages.system.websiteSEOSettings.websiteDescription': 'Website Description:',
  'pages.system.websiteSEOSettings.websiteDescriptionPlaceholder': 'Website Detailed Description',
  'pages.system.websiteSEOSettings.googleAnalytics': 'Google Analytics:',
  'pages.system.websiteSEOSettings.googleAnalyticsDescription': 'Enter the token key for Google Analytics code',
  'pages.system.websiteSEOSettings.baiduStatistics': 'Baidu Statistics:',
  'pages.system.websiteSEOSettings.baiduStatisticsDescription': 'Enter the token key for Baidu Analytics code',
  'pages.system.websiteSEOSettings.facebookStatistics': 'Facebook statistics:',
  'pages.system.websiteSEOSettings.facebookStatisticsDescription': 'Setting up Facebook tracking codes, specifically Facebook pixel tracking codes, is to facilitate promotion on Facebook.',
  'pages.system.websiteSEOSettings.javascriptCode': 'JavaScript code:',
  'pages.system.websiteSEOSettings.javascriptCodeDescription': 'Other JavaScript code that needs to be executed',
  'pages.system.websiteSEOSettings.javascriptCodePlaceholder': 'Enter JavaScript code',
  'pages.system.websiteSEOSettings.mapDomainSettings': 'Map domain settings:',
  'pages.system.websiteSEOSettings.mapDomainSettingsDescription': 'The default domain name is the website domain name. After binding the official domain name, the domain name in the site map will be changed to the official domain name in batches.',
  'pages.system.websiteSEOSettings.mapDomainSettingsPlaceholder': 'Enter domain name',
  'pages.system.websiteSEOSettings.pleaseEnter': 'Please enter',
  'pages.system.websiteSEOSettings.saveSuccess': 'Settings saved successfully',
  'pages.system.websiteSEOSettings.saveError': 'Failed to save settings',

  // Email Configuration
  'pages.system.emailConfiguration.title': 'Email Configuration',
  'pages.system.emailConfiguration.emailSMTP': 'Email SMTP:',
  'pages.system.emailConfiguration.emailSMTPDescription': 'The server that sends emails, such as smtp.qq.com.',
  'pages.system.emailConfiguration.emailSMTPPlaceholder': 'Enter SMTP server',
  'pages.system.emailConfiguration.emailPort': 'Email port:',
  'pages.system.emailConfiguration.emailPortDescription': 'The port number corresponding to the email address, such as: 465',
  'pages.system.emailConfiguration.emailPortPlaceholder': 'Enter port number',
  'pages.system.emailConfiguration.senderName': 'Sender Name:',
  'pages.system.emailConfiguration.senderNameDescription': "Sender's Name",
  'pages.system.emailConfiguration.senderNamePlaceholder': 'Enter sender name',
  'pages.system.emailConfiguration.outboxPassword': 'Outbox password:',
  'pages.system.emailConfiguration.outboxPasswordDescription': "sender's email password",
  'pages.system.emailConfiguration.outboxPasswordPlaceholder': 'Enter password',
  'pages.system.emailConfiguration.outbox': 'Outbox:',
  'pages.system.emailConfiguration.outboxDescription': "The sender's email address",
  'pages.system.emailConfiguration.outboxPlaceholder': 'Enter email address',
  'pages.system.emailConfiguration.backendInbox': 'Back-end inbox:',
  'pages.system.emailConfiguration.backendInboxDescription': 'The email address to receive emails sent to the backend (e.g., "Customer has placed an order").',
  'pages.system.emailConfiguration.backendInboxPlaceholder': 'Enter email address',
  'pages.system.emailConfiguration.recipientName': 'Recipient Name:',
  'pages.system.emailConfiguration.recipientNameDescription': 'Sender name when receiving backend emails',
  'pages.system.emailConfiguration.recipientNamePlaceholder': 'Enter recipient name',
  'pages.system.emailConfiguration.platformAccount': 'Platform account:',
  'pages.system.emailConfiguration.platformAccountDescription': 'Enter the login account of the relevant SMS/translation platform.',
  'pages.system.emailConfiguration.platformAccountPlaceholder': 'Enter platform account',
  'pages.system.emailConfiguration.platformPassword': 'Platform password:',
  'pages.system.emailConfiguration.platformPasswordDescription': 'Enter the login password for the relevant SMS/translation platform.',
  'pages.system.emailConfiguration.platformPasswordPlaceholder': 'Enter platform password',
  'pages.system.emailConfiguration.emailSSL': 'Email SSL:',
  'pages.system.emailConfiguration.emailSSLDescription': 'ssl',
  'pages.system.emailConfiguration.emailSSLPlaceholder': 'Select SSL option',
  'pages.system.emailConfiguration.saveSuccess': 'Settings saved successfully',
  'pages.system.emailConfiguration.saveError': 'Failed to save settings',

  // Image Settings
  'pages.system.imageSettings.title': 'Image Settings',
  'pages.system.imageSettings.websiteLogo': 'Website Logo',
  'pages.system.imageSettings.websiteLogoDescription': 'Upload the website logo image',
  'pages.system.imageSettings.homepageQRCode': 'Homepage QR Code',
  'pages.system.imageSettings.homepageQRCodeDescription': 'Upload the homepage QR code image',
  'pages.system.imageSettings.mobileLogo': 'Mobile Logo',
  'pages.system.imageSettings.mobileLogoDescription': 'Upload the mobile logo image',
  'pages.system.imageSettings.pcWebsiteIcon': 'PC Website Icon',
  'pages.system.imageSettings.pcWebsiteIconDescription': 'Upload the PC website icon (favicon)',
  'pages.system.imageSettings.pcPromotionalImage': 'PC Promotional Image',
  'pages.system.imageSettings.pcPromotionalImageDescription': 'Upload the PC promotional image',
  'pages.system.imageSettings.appSharingImage': 'App Sharing Image',
  'pages.system.imageSettings.appSharingImageDescription': 'Upload the app sharing image',
  'pages.system.imageSettings.pcRegistrationBackgroundImage': 'PC Registration Background Image',
  'pages.system.imageSettings.pcRegistrationBackgroundImageDescription': 'Upload the PC registration background image',
  'pages.system.imageSettings.pcLoginBackgroundImage': 'PC Login Background Image',
  'pages.system.imageSettings.pcLoginBackgroundImageDescription': 'Upload the PC login background image',
  'pages.system.imageSettings.defaultDetailImage': 'Default Image for Details Images',
  'pages.system.imageSettings.defaultDetailImageDescription': 'Upload the default image for product details',
  'pages.system.imageSettings.imageUrlPlaceholder': 'Image URL',
  'pages.system.imageSettings.upload': 'Upload',
  'pages.system.imageSettings.uploadSuccess': 'Image uploaded successfully',
  'pages.system.imageSettings.uploadFailed': 'Image upload failed',
  'pages.system.imageSettings.uploadImageOnly': 'Only image files are allowed',
  'pages.system.imageSettings.imageSizeLimit': 'Image size must be less than 10MB',
  'pages.system.imageSettings.saveSuccess': 'Settings saved successfully',
  'pages.system.imageSettings.saveError': 'Failed to save settings',

  // Website Basic Configuration
  'pages.system.websiteBasicConfiguration.title': 'Website Basic Configuration',
  'pages.system.websiteBasicConfiguration.websiteName': 'Website Name:',
  'pages.system.websiteBasicConfiguration.websiteNamePlaceholder': 'Enter website name',
  'pages.system.websiteBasicConfiguration.websiteHomepageName': 'Website homepage name (Welcome to xxxx)',
  'pages.system.websiteBasicConfiguration.websiteHomepageNameDescription': 'Welcome to xxxx',
  'pages.system.websiteBasicConfiguration.websiteHomepageNamePlaceholder': 'Enter homepage name',
  'pages.system.websiteBasicConfiguration.storageFees': 'Storage fees:',
  'pages.system.websiteBasicConfiguration.storageFeesDescription': 'Storage fees (unit price/day)',
  'pages.system.websiteBasicConfiguration.storageFeesPlaceholder': 'Enter storage fees',
  'pages.system.websiteBasicConfiguration.storageDays': 'Storage days:',
  'pages.system.websiteBasicConfiguration.storageDaysDescription': 'Free storage days in warehouse (unit: days)',
  'pages.system.websiteBasicConfiguration.storageDaysPlaceholder': 'Enter storage days',
  'pages.system.websiteBasicConfiguration.expirationTime': 'Expiration time:',
  'pages.system.websiteBasicConfiguration.expirationTimeDescription': 'Expiration time of items in shopping cart (in days)',
  'pages.system.websiteBasicConfiguration.expirationTimePlaceholder': 'Enter expiration time',
  'pages.system.websiteBasicConfiguration.deleteShoppingCart': 'Delete shopping cart:',
  'pages.system.websiteBasicConfiguration.deleteShoppingCartDescription': 'How long will it take before items in the shopping cart are removed (in days)?',
  'pages.system.websiteBasicConfiguration.deleteShoppingCartPlaceholder': 'Enter days',
  'pages.system.websiteBasicConfiguration.registrationAgreement': 'Registration Agreement:',
  'pages.system.websiteBasicConfiguration.registrationAgreementDescription': 'Registration page privacy agreement article configuration (you need to fill in the article ID added in article management)',
  'pages.system.websiteBasicConfiguration.registrationAgreementPlaceholder': 'Enter article ID',
  'pages.system.websiteBasicConfiguration.exportList': 'Export list:',
  'pages.system.websiteBasicConfiguration.exportListDescription': 'The ratio of the US dollar exchange rate to the main currency',
  'pages.system.websiteBasicConfiguration.exportListPlaceholder': 'Enter exchange rate',
  'pages.system.websiteBasicConfiguration.customerServiceCode': 'Customer service code:',
  'pages.system.websiteBasicConfiguration.customerServiceCodeDescription': 'Set up customer service JavaScript code',
  'pages.system.websiteBasicConfiguration.customerServiceCodePlaceholder': 'Please enter',
  'pages.system.websiteBasicConfiguration.customerServiceHotline': 'Customer service hotline:',
  'pages.system.websiteBasicConfiguration.customerServiceHotlineDescription': 'Website contact information settings',
  'pages.system.websiteBasicConfiguration.customerServiceHotlinePlaceholder': 'Enter hotline',
  'pages.system.websiteBasicConfiguration.customerServiceEmail': 'Customer service email:',
  'pages.system.websiteBasicConfiguration.customerServiceEmailDescription': 'Website contact information settings',
  'pages.system.websiteBasicConfiguration.customerServiceEmailPlaceholder': 'Enter email',
  'pages.system.websiteBasicConfiguration.filingInformation': 'Filing information:',
  'pages.system.websiteBasicConfiguration.filingInformationDescription': 'Website footer copyright information and filing settings',
  'pages.system.websiteBasicConfiguration.filingInformationPlaceholder': 'Enter filing information',
  'pages.system.websiteBasicConfiguration.customerServiceWeChat': 'Customer service WeChat:',
  'pages.system.websiteBasicConfiguration.customerServiceWeChatDescription': 'Website contact information settings',
  'pages.system.websiteBasicConfiguration.customerServiceWeChatPlaceholder': 'Enter WeChat',
  'pages.system.websiteBasicConfiguration.themeColorSettings': 'Theme color settings:',
  'pages.system.websiteBasicConfiguration.themeColorSettingsDescription': 'Website theme colors, excluding icons',
  'pages.system.websiteBasicConfiguration.shippingUnit': 'Shipping unit:',
  'pages.system.websiteBasicConfiguration.shippingUnitDescription': 'Set the shipping unit: Enter kg/g. (The main display page shows: shipping cost estimation and order placement.)',
  'pages.system.websiteBasicConfiguration.shippingUnitPlaceholder': 'Enter kg/g',
  'pages.system.websiteBasicConfiguration.frontEndHomepage': 'Front-end homepage:',
  'pages.system.websiteBasicConfiguration.frontEndHomepageDescription': 'Default homepage',
  'pages.system.websiteBasicConfiguration.frontEndHomepagePlaceholder': 'Enter homepage path',
  'pages.system.websiteBasicConfiguration.regionalAdministrativeCode': 'Regional administrative code:',
  'pages.system.websiteBasicConfiguration.regionalAdministrativeCodeDescription': 'Enter the first 6 digits of the administrative code of the procurement warehouse address (look up the regional code at: https://xingzhengquhua.bmcx.com/)',
  'pages.system.websiteBasicConfiguration.regionalAdministrativeCodePlaceholder': 'Enter 6-digit code',
  'pages.system.websiteBasicConfiguration.cancelOrder': 'Cancel order:',
  'pages.system.websiteBasicConfiguration.cancelOrderDescription': 'Set the time after which a purchase order will be automatically cancelled.',
  'pages.system.websiteBasicConfiguration.cancelOrderPlaceholder': 'Enter time',
  'pages.system.websiteBasicConfiguration.automaticConfirmationTimeout': 'Automatic confirmation of receipt after timeout (hours):',
  'pages.system.websiteBasicConfiguration.automaticConfirmationTimeoutDescription': 'Automatic delivery after xxx hours',
  'pages.system.websiteBasicConfiguration.automaticConfirmationTimeoutPlaceholder': 'Enter hours',
  'pages.system.websiteBasicConfiguration.homepageWaterfallLayoutKeywords': 'Homepage waterfall layout keywords:',
  'pages.system.websiteBasicConfiguration.homepageWaterfallLayoutKeywordsDescription': 'Only Chinese keywords are allowed; multiple keywords can be entered.',
  'pages.system.websiteBasicConfiguration.homepageWaterfallLayoutKeywordsPlaceholder': 'Enter keywords separated by commas',
  'pages.system.websiteBasicConfiguration.saveSuccess': 'Settings saved successfully',
  'pages.system.websiteBasicConfiguration.saveError': 'Failed to save settings',

  // App Settings
  'pages.system.appSettings.title': 'App Settings',
  'pages.system.appSettings.androidVersionNumber': 'Android Version Number:',
  'pages.system.appSettings.androidVersionNumberDescription': 'Enter the Android app version number',
  'pages.system.appSettings.androidVersionNumberPlaceholder': 'e.g., 1.0.0',
  'pages.system.appSettings.iosVersionNumber': 'iOS Version Number:',
  'pages.system.appSettings.iosVersionNumberDescription': 'Enter the iOS app version number',
  'pages.system.appSettings.iosVersionNumberPlaceholder': 'e.g., 1.0.0',
  'pages.system.appSettings.androidDownloadLink': 'Android Download Link:',
  'pages.system.appSettings.androidDownloadLinkDescription': 'Enter the Android app download link',
  'pages.system.appSettings.androidDownloadLinkPlaceholder': 'https://...',
  'pages.system.appSettings.iosDownloadLink': 'iOS Download Link:',
  'pages.system.appSettings.iosDownloadLinkDescription': 'Enter the iOS app download link',
  'pages.system.appSettings.iosDownloadLinkPlaceholder': 'https://...',
  'pages.system.appSettings.saveSuccess': 'Settings saved successfully',
  'pages.system.appSettings.saveError': 'Failed to save settings',
  'pages.articleManagement.deleteSuccess': 'Article has been deleted',
  'pages.articleManagement.updateSuccess': 'Article has been updated',
  'pages.articleManagement.createSuccess': 'Article has been created',
  'pages.articleManagement.id': 'ID',
  'pages.articleManagement.titleColumn': 'Title',
  'pages.articleManagement.category': 'Category',
  'pages.articleManagement.category.notice': 'Notice',
  'pages.articleManagement.category.news': 'News',
  'pages.articleManagement.category.guide': 'Guide',
  'pages.articleManagement.category.event': 'Event',
  'pages.articleManagement.category.faq': 'FAQ',
  'pages.articleManagement.author': 'Author',
  'pages.articleManagement.status': 'Status',
  'pages.articleManagement.status.published': 'Published',
  'pages.articleManagement.status.draft': 'Draft',
  'pages.articleManagement.status.hidden': 'Hidden',
  'pages.articleManagement.tags': 'Tags',
  'pages.articleManagement.views': 'Views',
  'pages.articleManagement.likes': 'Likes',
  'pages.articleManagement.comments': 'Comments',
  'pages.articleManagement.createdAt': 'Created At',
  'pages.articleManagement.updatedAt': 'Updated At',
  'pages.articleManagement.actions': 'Actions',
  'pages.articleManagement.view': 'View',
  'pages.articleManagement.editButton': 'Edit',
  'pages.articleManagement.deleteButton': 'Delete',
  'pages.articleManagement.form.title': 'Title',
  'pages.articleManagement.form.titleRequired': 'Please enter title',
  'pages.articleManagement.form.titlePlaceholder': 'Article title',
  'pages.articleManagement.form.category': 'Category',
  'pages.articleManagement.form.categoryPlaceholder': 'Select category',
  'pages.articleManagement.form.content': 'Content',
  'pages.articleManagement.form.contentRequired': 'Please enter content',
  'pages.articleManagement.form.contentPlaceholder': 'Enter article content',
  'pages.articleManagement.form.tags': 'Tags',
  'pages.articleManagement.form.tagsPlaceholder': 'Enter tags (Press Enter to add)',
  'pages.articleManagement.form.status': 'Status',
  'pages.articleManagement.form.statusPlaceholder': 'Select status',
  'pages.articleManagement.mock.title1': 'New Service Launch Notice',
  'pages.articleManagement.mock.title2': 'Delivery Delay Notice',
  'pages.articleManagement.mock.title3': 'Taobao Purchase Guide',
  'pages.articleManagement.mock.title4': 'Discount Event',
  'pages.articleManagement.mock.title5': 'FAQ Update',
  'pages.articleManagement.mock.author1': 'Administrator',
  'pages.articleManagement.mock.author2': 'Operations Team',
  'pages.articleManagement.mock.author3': 'Customer Service',
  'pages.articleManagement.mock.content': 'Article content...',
  'pages.articleManagement.mock.tag1': 'Important',
  'pages.articleManagement.mock.tag2': 'Must Read',
  'pages.articleManagement.mock.tag3': 'Event',
  'pages.articleManagement.mock.tag4': 'Urgent',

  // Advertise Management
  'pages.advertise.title': 'Advertisement Management',
  'pages.advertise.list': 'Advertisement List',
  'pages.advertise.add': 'Add Advertisement',
  'pages.advertise.edit': 'Edit Advertisement',
  'pages.advertise.delete': 'Delete Advertisement',
  'pages.advertise.deleteConfirm': 'Are you sure you want to delete advertisement "{title}"?',
  'pages.advertise.deleteSuccess': 'Advertisement deleted successfully',
  'pages.advertise.updateSuccess': 'Advertisement updated successfully',
  'pages.advertise.createSuccess': 'Advertisement created successfully',
  'pages.advertise.column.id': 'ID',
  'pages.advertise.column.title': 'Title',
  'pages.advertise.column.image': 'Image',
  'pages.advertise.column.type': 'Type',
  'pages.advertise.column.position': 'Position',
  'pages.advertise.column.linkUrl': 'Link URL',
  'pages.advertise.column.dateRange': 'Period',
  'pages.advertise.column.startDate': 'Start Date',
  'pages.advertise.column.endDate': 'End Date',
  'pages.advertise.column.status': 'Status',
  'pages.advertise.column.order': 'Display Order',
  'pages.advertise.column.views': 'Views',
  'pages.advertise.column.clicks': 'Clicks',
  'pages.advertise.column.action': 'Actions',
  'pages.advertise.type.banner': 'Banner',
  'pages.advertise.type.popup': 'Popup',
  'pages.advertise.type.sidebar': 'Sidebar',
  'pages.advertise.position.mainTop': 'Main Top',
  'pages.advertise.position.mainMiddle': 'Main Middle',
  'pages.advertise.position.mainBottom': 'Main Bottom',
  'pages.advertise.position.productList': 'Product List',
  'pages.advertise.position.productDetail': 'Product Detail',
  'pages.advertise.position.orderPage': 'Order Page',
  'pages.advertise.status.active': 'Active',
  'pages.advertise.status.inactive': 'Inactive',
  'pages.advertise.action.preview': 'Preview',
  'pages.advertise.action.edit': 'Edit',
  'pages.advertise.action.delete': 'Delete',
  'pages.advertise.form.title': 'Title',
  'pages.advertise.form.titlePlaceholder': 'Advertisement title',
  'pages.advertise.form.titleRequired': 'Please enter advertisement title',
  'pages.advertise.form.type': 'Type',
  'pages.advertise.form.typePlaceholder': 'Select advertisement type',
  'pages.advertise.form.position': 'Position',
  'pages.advertise.form.positionPlaceholder': 'Select display position',
  'pages.advertise.form.image': 'Image',
  'pages.advertise.form.imageUpload': 'Upload Image',
  'pages.advertise.form.dateRange': 'Period',
  'pages.advertise.form.dateRangeRequired': 'Please select period',
  'pages.advertise.form.linkUrl': 'Link URL',
  'pages.advertise.form.linkUrlPlaceholder': 'https://example.com',
  'pages.advertise.form.linkUrlInvalid': 'Please enter a valid URL',
  'pages.advertise.form.order': 'Display Order',
  'pages.advertise.form.orderPlaceholder': 'Lower numbers appear first',
  'pages.advertise.form.status': 'Status',
  'pages.advertise.form.statusPlaceholder': 'Select status',
  'pages.advertise.mock.newMemberDiscount': 'New Member Discount',
  'pages.advertise.mock.freeShippingEvent': 'Free Shipping Event',
  'pages.advertise.mock.timeSale': 'Time Sale',
  'pages.advertise.mock.seasonSpecial': 'Season Special',
  'pages.advertise.mock.adSuffix': 'Advertisement',

  // Banners Management
  'pages.banners.title': 'Banner/Event Management',
  'pages.banners.list': 'Banner List',
  'pages.banners.add': 'Add Banner',
  'pages.banners.edit': 'Edit Banner',
  'pages.banners.delete': 'Delete Banner',
  'pages.banners.deleteConfirm': 'Are you sure you want to delete banner "{title}"?',
  'pages.banners.deleteSuccess': 'Banner deleted successfully',
  'pages.banners.updateSuccess': 'Banner updated successfully',
  'pages.banners.createSuccess': 'Banner created successfully',
  'pages.banners.column.id': 'ID',
  'pages.banners.column.image': 'Banner Image',
  'pages.banners.column.title': 'Title',
  'pages.banners.column.position': 'Position',
  'pages.banners.column.order': 'Display Order',
  'pages.banners.column.dateRange': 'Period',
  'pages.banners.column.views': 'Views',
  'pages.banners.column.clicks': 'Clicks',
  'pages.banners.column.status': 'Status',
  'pages.banners.column.action': 'Actions',
  'pages.banners.position.mainTop': 'Main Top',
  'pages.banners.position.mainMiddle': 'Main Middle',
  'pages.banners.position.mainBottom': 'Main Bottom',
  'pages.banners.position.sidebar': 'Sidebar',
  'pages.banners.status.active': 'Active',
  'pages.banners.status.inactive': 'Inactive',
  'pages.banners.status.expired': 'Expired',
  'pages.banners.action.preview': 'Preview',
  'pages.banners.action.edit': 'Edit',
  'pages.banners.action.delete': 'Delete',
  'pages.banners.form.title': 'Title',
  'pages.banners.form.titlePlaceholder': 'Banner title',
  'pages.banners.form.titleRequired': 'Please enter banner title',
  'pages.banners.form.position': 'Position',
  'pages.banners.form.positionPlaceholder': 'Select display position',
  'pages.banners.form.image': 'Banner Image',
  'pages.banners.form.imageUpload': 'Upload Image',
  'pages.banners.form.linkUrl': 'Link URL',
  'pages.banners.form.linkUrlPlaceholder': 'https://example.com',
  'pages.banners.form.linkUrlInvalid': 'Please enter a valid URL',
  'pages.banners.form.dateRange': 'Period',
  'pages.banners.form.dateRangeRequired': 'Please select period',
  'pages.banners.form.order': 'Display Order',
  'pages.banners.form.orderPlaceholder': 'Lower numbers appear first',
  'pages.banners.form.status': 'Status',
  'pages.banners.form.statusActive': 'Active',
  'pages.banners.form.statusInactive': 'Inactive',
  'pages.banners.mock.newMemberDiscount': 'New Member Discount',
  'pages.banners.mock.freeShipping': 'Free Shipping',
  'pages.banners.mock.timeSale': 'Time Sale',
  'pages.banners.mock.seasonSpecial': 'Season Special',
  'pages.banners.mock.eventSuffix': 'Event',

  // Banner Advertisement Management
  'pages.bannerAdvertisement.title': 'Banner Management',
  'pages.bannerAdvertisement.list': 'Banner List',
  'pages.bannerAdvertisement.add': 'Add Banner',
  'pages.bannerAdvertisement.edit': 'Edit Banner',
  'pages.bannerAdvertisement.delete': 'Delete Banner',
  'pages.bannerAdvertisement.deleteConfirm': 'Are you sure you want to delete banner "{title}"?',
  'pages.bannerAdvertisement.deleteSuccess': 'Banner deleted successfully',
  'pages.bannerAdvertisement.updateSuccess': 'Banner updated successfully',
  'pages.bannerAdvertisement.createSuccess': 'Banner created successfully',
  'pages.bannerAdvertisement.loadBannerError': 'Failed to load banner information',
  'pages.bannerAdvertisement.deleteError': 'Failed to delete',
  'pages.bannerAdvertisement.operationFailed': 'Operation failed',
  'pages.bannerAdvertisement.column.id': 'ID',
  'pages.bannerAdvertisement.column.image': 'Image',
  'pages.bannerAdvertisement.column.title': 'Title',
  'pages.bannerAdvertisement.column.category': 'Category',
  'pages.bannerAdvertisement.column.exposureLocation': 'Exposure Location',
  'pages.bannerAdvertisement.column.exposureOrder': 'Display Order',
  'pages.bannerAdvertisement.column.dateRange': 'Period',
  'pages.bannerAdvertisement.column.views': 'Views',
  'pages.bannerAdvertisement.column.clicks': 'Clicks',
  'pages.bannerAdvertisement.column.status': 'Status',
  'pages.bannerAdvertisement.column.active': 'Active',
  'pages.bannerAdvertisement.column.action': 'Actions',
  'pages.bannerAdvertisement.category.promotion': 'Promotion',
  'pages.bannerAdvertisement.category.event': 'Event',
  'pages.bannerAdvertisement.category.announcement': 'Announcement',
  'pages.bannerAdvertisement.category.product': 'Product',
  'pages.bannerAdvertisement.category.other': 'Other',
  'pages.bannerAdvertisement.location.home': 'Home',
  'pages.bannerAdvertisement.location.category': 'Category',
  'pages.bannerAdvertisement.location.product': 'Product',
  'pages.bannerAdvertisement.location.cart': 'Cart',
  'pages.bannerAdvertisement.location.checkout': 'Checkout',
  'pages.bannerAdvertisement.location.profile': 'Profile',
  'pages.bannerAdvertisement.location.other': 'Other',
  'pages.bannerAdvertisement.situation.active': 'Active',
  'pages.bannerAdvertisement.situation.inactive': 'Inactive',
  'pages.bannerAdvertisement.situation.scheduled': 'Scheduled',
  'pages.bannerAdvertisement.situation.expired': 'Expired',
  'pages.bannerAdvertisement.status.active': 'Active',
  'pages.bannerAdvertisement.status.inactive': 'Inactive',
  'pages.bannerAdvertisement.action.edit': 'Edit',
  'pages.bannerAdvertisement.action.delete': 'Delete',
  'pages.bannerAdvertisement.form.title': 'Title',
  'pages.bannerAdvertisement.form.titleRequired': 'Please enter title',
  'pages.bannerAdvertisement.form.titleAtLeastOneLanguage': 'Please enter title in at least one language',
  'pages.bannerAdvertisement.form.titlePlaceholder': 'Banner title (max 200 characters)',
  'pages.bannerAdvertisement.form.imageUrl': 'Image URL',
  'pages.bannerAdvertisement.form.imageUrlRequired': 'Please enter image URL',
  'pages.bannerAdvertisement.form.imageUrlPlaceholder': 'https://example.com/banner.jpg',
  'pages.bannerAdvertisement.form.category': 'Category',
  'pages.bannerAdvertisement.form.categoryRequired': 'Please select category',
  'pages.bannerAdvertisement.form.categoryPlaceholder': 'Select category',
  'pages.bannerAdvertisement.form.exposureLocation': 'Exposure Location',
  'pages.bannerAdvertisement.form.exposureLocationRequired': 'Please select exposure location',
  'pages.bannerAdvertisement.form.exposureLocationPlaceholder': 'Select exposure location',
  'pages.bannerAdvertisement.form.exposureOrder': 'Display Order',
  'pages.bannerAdvertisement.form.exposureOrderRequired': 'Please enter display order',
  'pages.bannerAdvertisement.form.exposureOrderPlaceholder': 'Lower numbers appear first (0 or higher)',
  'pages.bannerAdvertisement.form.startDate': 'Start Date & Time',
  'pages.bannerAdvertisement.form.startDateRequired': 'Please select start date & time',
  'pages.bannerAdvertisement.form.startDatePlaceholder': 'Select start date & time',
  'pages.bannerAdvertisement.form.endDate': 'End Date & Time',
  'pages.bannerAdvertisement.form.endDateRequired': 'Please select end date & time',
  'pages.bannerAdvertisement.form.endDatePlaceholder': 'Select end date & time',
  'pages.bannerAdvertisement.form.linkUrl': 'Link URL',
  'pages.bannerAdvertisement.form.linkUrlInvalid': 'Please enter a valid URL format',
  'pages.bannerAdvertisement.form.linkUrlPlaceholder': 'https://example.com (optional)',
  'pages.bannerAdvertisement.form.isActive': 'Active Status',
  'pages.bannerAdvertisement.form.isActiveActive': 'Active',
  'pages.bannerAdvertisement.form.isActiveInactive': 'Inactive',
  'pages.bannerAdvertisement.validation.startEndDateRequired': 'Please select both start and end date & time',
  'pages.bannerAdvertisement.validation.endDateAfterStartDate': 'End date & time must be after start date & time',
  'pages.bannerAdvertisement.validation.titleAtLeastOneLanguage': 'Please enter title in at least one language',
  'pages.bannerAdvertisement.validation.imageUrlRequired': 'Please enter image URL',
  'pages.bannerAdvertisement.validation.categoryRequired': 'Please select category',
  'pages.bannerAdvertisement.validation.exposureLocationRequired': 'Please select exposure location',
  'pages.bannerAdvertisement.modal.edit': 'Edit',
  'pages.bannerAdvertisement.modal.register': 'Register',
  'pages.bannerAdvertisement.modal.cancel': 'Cancel',
  'pages.bannerAdvertisement.image.noImage': 'No Image',
  'pages.bannerAdvertisement.pagination.total': 'Total {total}',
  'pages.bannerAdvertisement.multilingual.korean': 'Korean',
  'pages.bannerAdvertisement.multilingual.koreanPlaceholder': 'Enter in Korean',
  'pages.bannerAdvertisement.multilingual.english': 'English',
  'pages.bannerAdvertisement.multilingual.englishPlaceholder': 'Enter in English',
  'pages.bannerAdvertisement.multilingual.chinese': 'Chinese',
  'pages.bannerAdvertisement.multilingual.chinesePlaceholder': 'Enter in Chinese',
  'pages.bannerAdvertisement.tabs.banners': 'Banners',
  'pages.bannerAdvertisement.tabs.carousel': 'Carousel',
  'pages.bannerAdvertisement.tabs.popup': 'Popup (live / seller / product)',
  'pages.bannerAdvertisement.popup.introTitle': 'Page popups',
  'pages.bannerAdvertisement.popup.introDesc':
    'Configure optional popups for the live page, seller detail page, and product detail page. Turn a slot on, add image/video/text/link, then save. Storefront apps should read GET /admin/marketing-popups (same shape as saved here).',
  'pages.bannerAdvertisement.popup.localOnlyTitle': 'Saved in this browser only',
  'pages.bannerAdvertisement.popup.localOnlyDesc':
    'The marketing-popups API is not available or returned an error. Settings are stored in localStorage so you can still edit them; wire the backend to persist for all users.',
  'pages.bannerAdvertisement.popup.slot.live': 'Live page',
  'pages.bannerAdvertisement.popup.slot.sellerDetail': 'Seller detail page',
  'pages.bannerAdvertisement.popup.slot.productDetail': 'Product detail page',
  'pages.bannerAdvertisement.popup.image': 'Popup image',
  'pages.bannerAdvertisement.popup.changeImage': 'Change image',
  'pages.bannerAdvertisement.popup.videoUrl': 'Video URL',
  'pages.bannerAdvertisement.popup.videoUrlPlaceholder': 'https://… (mp4 or hosted player URL)',
  'pages.bannerAdvertisement.popup.videoHint':
    'Video file upload can use the same CDN pattern as images once a dedicated upload endpoint exists; for now use a direct URL.',
  'pages.bannerAdvertisement.popup.link': 'Link (on click)',
  'pages.bannerAdvertisement.popup.title': 'Title (multilingual)',
  'pages.bannerAdvertisement.popup.body': 'Body text (multilingual)',
  'pages.bannerAdvertisement.popup.saveAll': 'Save popup settings',
  'pages.bannerAdvertisement.popup.saveSuccess': 'Popup settings saved',
  'pages.bannerAdvertisement.popup.saveLocalSuccess': 'Saved locally (API unavailable)',
  'pages.bannerAdvertisement.popup.saveFailed': 'Failed to save popup settings',
  'pages.bannerAdvertisement.carousel.manage': 'Carousel Management',
  'pages.bannerAdvertisement.carousel.title': 'Carousel Management',
  'pages.bannerAdvertisement.carousel.noItems': 'No carousel items',
  'pages.bannerAdvertisement.carousel.save': 'Save',
  'pages.bannerAdvertisement.carousel.saveSuccess': 'Carousel saved successfully',
  'pages.bannerAdvertisement.carousel.item': 'Item',
  'pages.bannerAdvertisement.carousel.remove': 'Remove',
  'pages.bannerAdvertisement.carousel.addItem': 'Add Carousel Item',
  'pages.bannerAdvertisement.carousel.imageTitle': 'Image Title',
  'pages.bannerAdvertisement.carousel.imageTitleRequired': 'Please enter image title',
  'pages.bannerAdvertisement.carousel.imageTitleAtLeastOneLanguage': 'Please enter image title in at least one language',
  'pages.bannerAdvertisement.carousel.imageTitlePlaceholder': 'Enter image title',
  'pages.bannerAdvertisement.carousel.number': 'Number (Order)',
  'pages.bannerAdvertisement.carousel.numberTooltip': 'Adjust size according to the order displayed on the user\'s device',
  'pages.bannerAdvertisement.carousel.numberRequired': 'Please enter order number',
  'pages.bannerAdvertisement.carousel.link': 'Link',
  'pages.bannerAdvertisement.carousel.linkTooltip': 'Clicking the carousel image on the user\'s device moves to the corresponding link',
  'pages.bannerAdvertisement.carousel.linkRequired': 'Please enter link URL',
  'pages.bannerAdvertisement.carousel.linkInvalid': 'Please enter a valid URL',
  'pages.bannerAdvertisement.carousel.linkPlaceholder': 'https://example.com',
  'pages.bannerAdvertisement.carousel.active': 'Active',
  'pages.bannerAdvertisement.carousel.displayLocation': 'Display Location',
  'pages.bannerAdvertisement.carousel.desktopDisplaySize': 'Desktop Display Size',
  'pages.bannerAdvertisement.carousel.mobileDisplaySize': 'Mobile Display Size',
  'pages.bannerAdvertisement.carousel.width': 'Width',
  'pages.bannerAdvertisement.carousel.height': 'Height',
  'pages.bannerAdvertisement.carousel.imageUpload': 'Image Upload',
  'pages.bannerAdvertisement.carousel.desktopImageUpload': 'Desktop Image Upload',
  'pages.bannerAdvertisement.carousel.mobileImageUpload': 'Mobile Image Upload',
  'pages.bannerAdvertisement.carousel.desktopImageRequired': 'Please upload desktop image',
  'pages.bannerAdvertisement.carousel.mobileImageRequired': 'Please upload mobile image',
  'pages.bannerAdvertisement.carousel.imageUrlPlaceholder': 'Image URL or upload image',
  'pages.bannerAdvertisement.carousel.upload': 'Upload',
  'pages.bannerAdvertisement.carousel.uploadSuccess': 'Image uploaded successfully',
  'pages.bannerAdvertisement.carousel.uploadFailed': 'Image upload failed',
  'pages.bannerAdvertisement.carousel.uploadImageOnly': 'Only image files are allowed',
  'pages.bannerAdvertisement.carousel.imageSizeLimit': 'Image size must be less than 10MB',
  'pages.bannerAdvertisement.carousel.masterImageUpload': 'Banner image (one file)',
  'pages.bannerAdvertisement.carousel.masterImageRequired': 'Please upload a banner image',
  'pages.bannerAdvertisement.carousel.masterImageHint':
    'The server generates optimized desktop and mobile images from this file.',
  'pages.bannerAdvertisement.carousel.savedPcMobileHint': 'Currently saved PC / mobile assets (replace by uploading a new image above).',

  // Storehouse Management
  'pages.storehouse.expressInspection.title': 'Express Delivery Inspection into Warehouse',
  'pages.storehouse.expressInspection.column.userInfo': 'User Info (UID)',
  'pages.storehouse.expressInspection.column.orderNo': 'Order Number',
  'pages.storehouse.expressInspection.column.trackingNumber': 'Tracking Number',
  'pages.storehouse.expressInspection.column.courier': 'Courier Company',
  'pages.storehouse.expressInspection.column.status': 'Status',
  'pages.storehouse.expressInspection.column.inboundWeight': 'Inbound Weight',
  'pages.storehouse.expressInspection.column.inboundDimensions': 'Inbound Dimensions (L×W×H)',
  'pages.storehouse.expressInspection.column.locationInfo': 'Location Information',
  'pages.storehouse.expressInspection.column.inspectionInfo': 'Inspection Information',
  'pages.storehouse.expressInspection.column.orderService': 'Order Service',
  'pages.storehouse.expressInspection.column.userRemarks': 'User Remarks',
  'pages.storehouse.expressInspection.column.warehouseRemarks': 'Warehouse Remarks',
  'pages.storehouse.expressInspection.status.pending': 'Pending',
  'pages.storehouse.expressInspection.status.inspected': 'Inspected',
  'pages.storehouse.expressInspection.status.error': 'Error',
  'pages.storehouse.expressInspection.filter.total': 'Total',
  'pages.storehouse.expressInspection.filter.notYetStored': 'Not Yet Stored',
  'pages.storehouse.expressInspection.filter.received': 'Received',
  'pages.storehouse.expressInspection.filter.inspected': 'Goods Have Been Inspected',
  'pages.storehouse.expressInspection.filter.weightedAndStored': 'Weighted And Put into storage',
  'pages.storehouse.expressInspection.filter.availableNow': 'Available Now',
  'pages.storehouse.expressInspection.filter.removedFromShelves': 'Removed from Shelves',
  'pages.storehouse.expressInspection.filter.title': 'Filter',
  'pages.storehouse.expressInspection.filterApplied': 'Filter applied: {label}',
  'pages.storehouse.expressInspection.filterCleared': 'Filter cleared',
  'pages.storehouse.expressInspection.viewAll': 'View All',
  'pages.storehouse.expressInspection.action.inspect': 'Inspect',
  'pages.storehouse.expressInspection.action.batchInspect': 'Batch Inspect',
  'pages.storehouse.expressInspection.action.expand': 'Expand',
  'pages.storehouse.expressInspection.action.collapse': 'Collapse',
  'pages.storehouse.expressInspection.expandIconTitle': 'Expand',
  'pages.storehouse.expressInspection.product.column.image': 'Product Image',
  'pages.storehouse.expressInspection.product.column.name': 'Product Name',
  'pages.storehouse.expressInspection.product.column.specifications': 'Specifications/Attributes',
  'pages.storehouse.expressInspection.product.column.quantity': 'Quantity',
  'pages.storehouse.expressInspection.product.column.cargoValue': 'Cargo Value',
  'pages.storehouse.expressInspection.product.column.inboundWeight': 'Inbound Weight',
  'pages.storehouse.expressInspection.product.column.inboundDimensions': 'Inbound Dimensions (L×W×H)',
  'pages.storehouse.expressInspection.product.column.location': 'Location',
  'pages.storehouse.expressInspection.product.column.cargoAttributes': 'Cargo Attributes',
  'pages.storehouse.expressInspection.product.column.inspectionPhotos': 'Detailed Inspection Photos',
  'pages.storehouse.expressInspection.product.unit.won': ' Won',
  'pages.storehouse.expressInspection.product.unit.cm': 'cm',

  'pages.storehouse.nonMasterCourier.title': 'Non-Master Courier Enter Warehouse',
  'pages.storehouse.nonMasterCourier.column.trackingNumber': 'Tracking Number',
  'pages.storehouse.nonMasterCourier.column.courier': 'Courier',
  'pages.storehouse.nonMasterCourier.column.enteredDate': 'Entered Date',
  'pages.storehouse.nonMasterCourier.column.orderNo': 'Order Number',
  'pages.storehouse.nonMasterCourier.column.customerName': 'Customer Name',
  'pages.storehouse.nonMasterCourier.column.productCount': 'Product Count',
  'pages.storehouse.nonMasterCourier.column.status': 'Status',
  'pages.storehouse.nonMasterCourier.status.pending': 'Pending',
  'pages.storehouse.nonMasterCourier.status.processed': 'Processed',
  'pages.storehouse.nonMasterCourier.status.error': 'Error',
  'pages.storehouse.nonMasterCourier.viewUnclaimed': 'View Unclaimed Package Inbound Records',
  'pages.storehouse.nonMasterCourier.storehouse': 'Storehouse',
  'pages.storehouse.nonMasterCourier.storehouseRequired': 'Please select storehouse',
  'pages.storehouse.nonMasterCourier.warehouseLocationType': 'Warehouse Location Type',
  'pages.storehouse.nonMasterCourier.warehouseLocationTypeRequired': 'Please select warehouse location type',
  'pages.storehouse.nonMasterCourier.locationType.largeCargo': 'Large cargo area',
  'pages.storehouse.nonMasterCourier.locationType.fileArea': 'File area',
  'pages.storehouse.nonMasterCourier.locationType.sensitiveGoods': 'Sensitive goods area',
  'pages.storehouse.nonMasterCourier.locationType.generalGoods': 'General Goods Area',
  'pages.storehouse.nonMasterCourier.locationType.ecommerceSmall': 'E-commerce small item section',
  'pages.storehouse.nonMasterCourier.locationType.mixedBatch': 'Mixed batch small package area',
  'pages.storehouse.nonMasterCourier.locationType.mediumContainer': 'Medium-sized container cargo area',
  'pages.storehouse.nonMasterCourier.locationType.smallOverweight': 'Small Items Overweight Area',
  'pages.storehouse.nonMasterCourier.locationType.largeUnusual': 'Large and unusual items area',
  'pages.storehouse.nonMasterCourier.stockLocation': 'Stock location',
  'pages.storehouse.nonMasterCourier.stockLocationRequired': 'Please select stock location',
  'pages.storehouse.nonMasterCourier.print': 'Print',
  'pages.storehouse.nonMasterCourier.userId': 'User ID',
  'pages.storehouse.nonMasterCourier.userIdRequired': 'Please enter user ID',
  'pages.storehouse.nonMasterCourier.userName': 'User Name',
  'pages.storehouse.nonMasterCourier.userNameRequired': 'Please enter user name',
  'pages.storehouse.nonMasterCourier.invoiceNumber': 'Invoice number',
  'pages.storehouse.nonMasterCourier.invoiceNumberRequired': 'Please enter invoice number',
  'pages.storehouse.nonMasterCourier.weight': 'Weight (kg)',
  'pages.storehouse.nonMasterCourier.weightRequired': 'Please enter weight',
  'pages.storehouse.nonMasterCourier.length': 'Length (cm)',
  'pages.storehouse.nonMasterCourier.lengthRequired': 'Please enter length',
  'pages.storehouse.nonMasterCourier.width': 'Width (cm)',
  'pages.storehouse.nonMasterCourier.widthRequired': 'Please enter width',
  'pages.storehouse.nonMasterCourier.height': 'Height (cm)',
  'pages.storehouse.nonMasterCourier.heightRequired': 'Please enter height',
  'pages.storehouse.nonMasterCourier.confirmWarehousing': 'Confirm Warehousing',
  'pages.storehouse.nonMasterCourier.action.process': 'Process',
  'pages.storehouse.nonMasterCourier.action.batchProcess': 'Batch Process',

  'pages.storehouse.inspectionList.title': 'Inspection List',
  'pages.storehouse.inspectionList.column.userInfo': 'User Information (UID)',
  'pages.storehouse.inspectionList.column.invoiceNumber': 'Invoice number',
  'pages.storehouse.inspectionList.column.courier': 'courier company',
  'pages.storehouse.inspectionList.column.uniqueCode': 'Inspector',
  'pages.storehouse.inspectionList.column.status': 'state',
  'pages.storehouse.inspectionList.column.inboundWeight': 'Inbound weight',
  'pages.storehouse.inspectionList.column.warehouseDimensions': 'Warehouse dimensions (length, width, height)',
  'pages.storehouse.inspectionList.column.storageLocation': 'Storage location information',
  'pages.storehouse.inspectionList.column.inspectionNo': 'Inspection Number',
  'pages.storehouse.inspectionList.column.trackingNumber': 'Tracking Number',
  'pages.storehouse.inspectionList.filter.userName': 'User name',
  'pages.storehouse.inspectionList.filter.rackNumber': 'Rack number',
  'pages.storehouse.inspectionList.column.inspectionDate': 'Inspection Date',
  'pages.storehouse.inspectionList.column.orderNo': 'Order Number',
  'pages.storehouse.inspectionList.column.customerName': 'Customer Name',
  'pages.storehouse.inspectionList.column.customerEmail': 'Customer Email',
  'pages.storehouse.inspectionList.column.customerPhone': 'Customer Phone',
  'pages.storehouse.inspectionList.column.inspector': 'Inspector',
  'pages.storehouse.inspectionList.column.notes': 'Notes',
  'pages.storehouse.inspectionList.status.passed': 'Passed',
  'pages.storehouse.inspectionList.status.failed': 'Failed',
  'pages.storehouse.inspectionList.status.pending': 'Pending',
  'pages.storehouse.inspectionList.action.export': 'Export',
  'pages.storehouse.inspectionList.exporting': 'Exporting...',
  'pages.storehouse.inspectionList.exportSuccess': 'Export completed successfully',
  'pages.storehouse.inspectionList.exportError': 'Failed to export inspections',
  'pages.storehouse.inspectionList.noDataToExport': 'No data to export',
  'pages.storehouse.inspectionList.detailTitle': 'Inspection Detail',
  'pages.storehouse.inspectionList.products': 'Products',
  'pages.storehouse.inspectionList.expandIconTitle': 'Expand',
  'pages.storehouse.inspectionList.noProducts': 'No products',
  'pages.storehouse.inspectionList.product.column.image': 'Product Image',
  'pages.storehouse.inspectionList.product.column.name': 'Product Name',
  'pages.storehouse.inspectionList.product.column.specifications': 'Specifications/Attributes',
  'pages.storehouse.inspectionList.product.column.quantity': 'Quantity',
  'pages.storehouse.inspectionList.product.column.cargoValue': 'Cargo Value',
  'pages.storehouse.inspectionList.product.column.inboundWeight': 'Inbound Weight',
  'pages.storehouse.inspectionList.product.column.inboundDimensions': 'Inbound Dimensions (L×W×H)',
  'pages.storehouse.inspectionList.product.column.location': 'Location',
  'pages.storehouse.inspectionList.product.column.cargoAttributes': 'Cargo Attributes',
  'pages.storehouse.inspectionList.product.column.inspectionPhotos': 'Detailed Inspection Photos',
  'pages.storehouse.inspectionList.product.column.categoryName': 'Category',
  'pages.storehouse.inspectionList.product.unit.won': 'KRW',
  'pages.storehouse.inspectionList.product.unit.cm': 'cm',
  'pages.storehouse.inspectionList.product.unit.cny': ' CNY',
  'pages.storehouse.inspectionList.recipient': 'Recipient Information',
  'pages.storehouse.inspectionList.recipient.name': 'Recipient Name',
  'pages.storehouse.inspectionList.recipient.phone': 'Phone',
  'pages.storehouse.inspectionList.recipient.clearanceType': 'Clearance Type',
  'pages.storehouse.inspectionList.recipient.customsCode': 'Personal Customs Code',
  'pages.storehouse.inspectionList.recipient.address': 'Address',
  'pages.storehouse.inspectionList.recipient.zipCode': 'Zip Code',
  'pages.storehouse.inspectionList.recipient.postalCode': 'Postal Code',
  'pages.storehouse.inspectionList.recipient.note': 'Delivery Note',

  'pages.storehouse.warehouseSettings.title': 'Warehouse Settings',
  'pages.storehouse.warehouseSettings.tab.address': 'Warehouse Address',
  'pages.storehouse.warehouseSettings.tab.chineseWarehousePosition': 'Chinese Warehouse Position',

  'pages.storehouse.warehouseAddress.title': 'Warehouse Address',
  'pages.storehouse.warehouseAddress.rackManagement': 'Rack Management',
  'pages.storehouse.warehouseAddress.racks': 'Racks',
  'pages.storehouse.warehouseAddress.noRacks': 'No racks found for this warehouse',
  'pages.storehouse.warehouseAddress.column.name': 'Name',
  'pages.storehouse.warehouseAddress.column.address': 'Address',
  'pages.storehouse.warehouseAddress.column.contactPerson': 'Contact Person',
  'pages.storehouse.warehouseAddress.column.contactPhone': 'Contact Phone',
  'pages.storehouse.warehouseAddress.column.isDefault': 'Default',
  'pages.storehouse.warehouseAddress.column.createdAt': 'Created At',
  'pages.storehouse.warehouseAddress.addTitle': 'Add Warehouse Address',
  'pages.storehouse.warehouseAddress.editTitle': 'Edit Warehouse Address',
  'pages.storehouse.warehouseAddress.form.name': 'Name',
  'pages.storehouse.warehouseAddress.form.nameRequired': 'Please enter name',
  'pages.storehouse.warehouseAddress.form.address': 'Address',
  'pages.storehouse.warehouseAddress.form.addressRequired': 'Please enter address',
  'pages.storehouse.warehouseAddress.form.contactPerson': 'Contact Person',
  'pages.storehouse.warehouseAddress.form.contactPersonRequired': 'Please enter contact person',
  'pages.storehouse.warehouseAddress.form.contactPhone': 'Contact Phone',
  'pages.storehouse.warehouseAddress.form.contactPhoneRequired': 'Please enter contact phone',
  'pages.storehouse.warehouseAddress.confirmDelete': 'Are you sure you want to delete this warehouse address?',
  'pages.storehouse.warehouseAddress.deleteSuccess': 'Warehouse address deleted',
  'pages.storehouse.warehouseAddress.updateSuccess': 'Warehouse address updated',
  'pages.storehouse.warehouseAddress.createSuccess': 'Warehouse address created',
  'pages.storehouse.warehouseAddress.addWarehouse': 'Add Warehouse Address',
  'pages.storehouse.warehouseAddress.customizableParameters': 'Customizable parameters:',
  'pages.storehouse.warehouseAddress.noData': 'No warehouse address information available.',
  'pages.storehouse.warehouseAddress.forwardingWarehouse': 'Forwarding Warehouse Address',
  'pages.storehouse.warehouseAddress.purchasingAgentWarehouse': 'Purchasing Agent Warehouse Address',
  'pages.storehouse.warehouseAddress.consignee': 'Consignee',
  'pages.storehouse.warehouseAddress.consigneeRequired': 'Please enter consignee',
  'pages.storehouse.warehouseAddress.contactMethod': 'Contact Method',
  'pages.storehouse.warehouseAddress.contactMethodRequired': 'Please enter contact method',
  'pages.storehouse.warehouseAddress.email': 'Email',
  'pages.storehouse.warehouseAddress.emailRequired': 'Please enter email',
  'pages.storehouse.warehouseAddress.emailInvalid': 'Please enter a valid email address',
  'pages.storehouse.warehouseAddress.warehouseName': 'Warehouse Name',
  'pages.storehouse.warehouseAddress.defaultWarehouse': 'Default',
  'pages.storehouse.warehouseAddress.warehouseNameRequired': 'Please enter warehouse name',
  'pages.storehouse.warehouseAddress.postalCode': 'Warehouse Postal Code',
  'pages.storehouse.warehouseAddress.postalCodeRequired': 'Please enter postal code',
  'pages.storehouse.warehouseAddress.administrativeDivisionCode': 'Administrative Division Code',
  'pages.storehouse.warehouseAddress.administrativeDivisionCodeRequired': 'Please enter administrative division code',
  'pages.storehouse.warehouseAddress.warehouseAddress': 'Warehouse Address',
  'pages.storehouse.warehouseAddress.warehouseAddressRequired': 'Please enter warehouse address',
  'pages.storehouse.warehouseAddress.procurementWarehouse': 'Procurement Warehouse',
  'pages.storehouse.warehouseAddress.convertSuccess': 'Successfully converted to procurement warehouse',
  'pages.storehouse.warehouseAddress.warehouseCode': 'Warehouse Code',
  'pages.storehouse.warehouseAddress.warehouseCodeRequired': 'Please enter warehouse code',
  'pages.storehouse.warehouseAddress.warehouseCodePlaceholder': 'e.g., WH-QINGDAO-1',
  'pages.storehouse.warehouseAddress.phone': 'Phone',
  'pages.storehouse.warehouseAddress.phonePlaceholder': 'e.g., 0631-5555001',
  'pages.storehouse.warehouseAddress.province': 'Province',
  'pages.storehouse.warehouseAddress.provinceRequired': 'Please enter province',
  'pages.storehouse.warehouseAddress.provincePlaceholder': 'e.g., 山东省',
  'pages.storehouse.warehouseAddress.city': 'City',
  'pages.storehouse.warehouseAddress.cityRequired': 'Please enter city',
  'pages.storehouse.warehouseAddress.cityPlaceholder': 'e.g., 威海市',
  'pages.storehouse.warehouseAddress.district': 'District',
  'pages.storehouse.warehouseAddress.districtRequired': 'Please enter district',
  'pages.storehouse.warehouseAddress.districtPlaceholder': 'e.g., 环翠区',
  'pages.storehouse.warehouseAddress.town': 'Town',
  'pages.storehouse.warehouseAddress.townPlaceholder': 'e.g., 文泉镇',
  'pages.storehouse.warehouseAddress.addressCode': 'Address Code',
  'pages.storehouse.warehouseAddress.addressCodePlaceholder': 'e.g., 371002',
  'pages.storehouse.warehouseAddress.consigneePlaceholder': 'e.g., 张伟',
  'pages.storehouse.warehouseAddress.contactMethodPlaceholder': 'e.g., 18561073633',
  'pages.storehouse.warehouseAddress.warehouseNamePlaceholder': 'e.g., 青岛仓库',
  'pages.storehouse.warehouseAddress.postalCodePlaceholder': 'e.g., 264200',
  'pages.storehouse.warehouseAddress.administrativeDivisionCodePlaceholder': 'e.g., 371002',
  'pages.storehouse.warehouseAddress.warehouseAddressPlaceholder': 'e.g., 环翠区温泉镇新苑路2号',
  'pages.storehouse.warehouseAddress.createError': 'Failed to create warehouse',
  'pages.storehouse.warehouseAddress.updateError': 'Failed to update warehouse',
  'pages.storehouse.warehouseAddress.deleteError': 'Failed to delete warehouse',
  'pages.common.modify': 'Modify',
  'pages.common.today': 'Today',
  'pages.common.last7Days': 'Last 7 Days',
  'pages.common.last30Days': 'Last 30 Days',
  'pages.common.thisMonth': 'This Month',
  'pages.common.lastMonth': 'Last Month',
  'pages.common.exportingOrders': 'Exporting...',
  'pages.common.exportError': 'Failed to export',

  'pages.storehouse.chineseWarehousePosition.title': 'Chinese Warehouse Position',
  'pages.storehouse.chineseWarehousePosition.column.positionCode': 'Position Code',
  'pages.storehouse.chineseWarehousePosition.column.positionName': 'Position Name',
  'pages.storehouse.chineseWarehousePosition.column.warehouseName': 'Warehouse Name',
  'pages.storehouse.chineseWarehousePosition.column.area': 'Area',
  'pages.storehouse.chineseWarehousePosition.column.row': 'Row',
  'pages.storehouse.chineseWarehousePosition.column.column': 'Column',
  'pages.storehouse.chineseWarehousePosition.column.shelf': 'Shelf',
  'pages.storehouse.chineseWarehousePosition.column.capacity': 'Capacity',
  'pages.storehouse.chineseWarehousePosition.column.currentStock': 'Current Stock',
  'pages.storehouse.chineseWarehousePosition.column.createdAt': 'Created At',
  'pages.storehouse.chineseWarehousePosition.column.locationCode': 'Location Code',
  'pages.storehouse.chineseWarehousePosition.column.stockLocation': 'Stock Location',
  'pages.storehouse.chineseWarehousePosition.column.warehouseLocationCode': 'Warehouse Location Code',
  'pages.storehouse.chineseWarehousePosition.column.warehouseLocationType': 'Warehouse Location Type',
  'pages.storehouse.chineseWarehousePosition.column.availableStock': 'Available Stock',
  'pages.storehouse.chineseWarehousePosition.stockLocation': 'Stock Location',
  'pages.storehouse.chineseWarehousePosition.warehouseLocationCode': 'Warehouse Location Code',
  'pages.storehouse.chineseWarehousePosition.warehouseLocationType': 'Warehouse Location Type',
  'pages.storehouse.chineseWarehousePosition.availableStock': 'Available Stock',
  'pages.storehouse.chineseWarehousePosition.currentStock': 'Current Stock',
  'pages.storehouse.chineseWarehousePosition.form.locationCode': 'Location Code',
  'pages.storehouse.chineseWarehousePosition.form.locationCodeRequired': 'Please enter location code',
  'pages.storehouse.chineseWarehousePosition.form.warehouseLocationType': 'Warehouse Location Type',
  'pages.storehouse.chineseWarehousePosition.form.warehouseLocationTypeRequired': 'Please enter warehouse location type',
  'pages.storehouse.chineseWarehousePosition.form.availableStock': 'Available Stock',
  'pages.storehouse.chineseWarehousePosition.form.availableStockRequired': 'Please enter available stock',
  'pages.storehouse.chineseWarehousePosition.form.currentStock': 'Current Stock',
  'pages.storehouse.chineseWarehousePosition.form.currentStockRequired': 'Please enter current stock',
  'pages.storehouse.chineseWarehousePosition.addTitle': 'Add Warehouse Position',
  'pages.storehouse.chineseWarehousePosition.editTitle': 'Edit Warehouse Position',
  'pages.storehouse.chineseWarehousePosition.form.positionCode': 'Position Code',
  'pages.storehouse.chineseWarehousePosition.form.positionCodeRequired': 'Please enter position code',
  'pages.storehouse.chineseWarehousePosition.form.positionName': 'Position Name',
  'pages.storehouse.chineseWarehousePosition.form.positionNameRequired': 'Please enter position name',
  'pages.storehouse.chineseWarehousePosition.form.warehouseName': 'Warehouse Name',
  'pages.storehouse.chineseWarehousePosition.form.warehouseNameRequired': 'Please enter warehouse name',
  'pages.storehouse.chineseWarehousePosition.form.area': 'Area',
  'pages.storehouse.chineseWarehousePosition.form.areaRequired': 'Please enter area',
  'pages.storehouse.chineseWarehousePosition.form.row': 'Row',
  'pages.storehouse.chineseWarehousePosition.form.rowRequired': 'Please enter row',
  'pages.storehouse.chineseWarehousePosition.form.column': 'Column',
  'pages.storehouse.chineseWarehousePosition.form.columnRequired': 'Please enter column',
  'pages.storehouse.chineseWarehousePosition.form.shelf': 'Shelf',
  'pages.storehouse.chineseWarehousePosition.form.shelfRequired': 'Please enter shelf',
  'pages.storehouse.chineseWarehousePosition.form.capacity': 'Capacity',
  'pages.storehouse.chineseWarehousePosition.form.capacityRequired': 'Please enter capacity',
  'pages.storehouse.chineseWarehousePosition.confirmDelete': 'Are you sure you want to delete this warehouse position?',
  'pages.storehouse.chineseWarehousePosition.deleteSuccess': 'Warehouse position deleted',
  'pages.storehouse.chineseWarehousePosition.createSuccess': 'Warehouse position created',
  'pages.storehouse.chineseWarehousePosition.updateSuccess': 'Warehouse position updated',

  // Coupon Point Settings
  'pages.members.couponPointSettings.title': 'Coupon Point Settings',
  'pages.members.couponPointSettings.pointsPerCurrency': 'Points Per Currency (₩)',
  'pages.members.couponPointSettings.coupon': 'Coupon',
  'pages.members.couponPointSettings.example': 'Example: If set to 100, then ₩10,000 = 100 points',
  'pages.members.couponPointSettings.freeEditingFunction': 'Free editing function for adding/deleting coupons',
  'pages.members.couponPointSettings.distributionSystemCoupon': 'Distribution System Coupon',
  'pages.members.couponPointSettings.distributionSystemCouponDescription': 'You can choose to distribute specific types of coupons evenly within the system.',
  'pages.members.couponPointSettings.pointSettings': 'Point Settings',
  'pages.members.couponPointSettings.pointSettingsDescription': 'Points are granted when a user who received your invitation registers to this site. These points can be manually edited and set.',
  'pages.members.couponPointSettings.couponDetails': 'Coupon Details',
  'pages.members.couponPointSettings.addCoupon': 'Add Coupon',
  'pages.members.couponPointSettings.editCoupon': 'Edit Coupon',
  'pages.members.couponPointSettings.deleteConfirm': 'Are you sure you want to delete this coupon?',
  'pages.members.couponPointSettings.deleteSuccess': 'Coupon deleted successfully',
  'pages.members.couponPointSettings.createSuccess': 'Coupon created successfully',
  'pages.members.couponPointSettings.updateSuccess': 'Coupon updated successfully',
  'pages.members.couponPointSettings.pointUpdateSuccess': 'Point settings updated successfully',
  'pages.members.couponPointSettings.pointUpdateError': 'Failed to update referral settings',
  'pages.members.couponPointSettings.fetchError': 'Failed to load data',
  'pages.members.couponPointSettings.fetchCouponsError': 'Failed to load coupons',
  'pages.members.couponPointSettings.deleteError': 'Failed to delete coupon',
  'pages.members.couponPointSettings.createError': 'Failed to create coupon',
  'pages.members.couponPointSettings.updateError': 'Failed to update coupon',
  'pages.members.couponPointSettings.referralPoints': 'Referral Points',
  'pages.members.couponPointSettings.referralPointsRequired': 'Please enter referral points',
  'pages.members.couponPointSettings.referralPointsPlaceholder': 'Enter points granted when referral is successful',
  'pages.members.couponPointSettings.noCoupons': 'No coupons',
  'pages.members.couponPointSettings.signupPoints': 'Signup Points',
  'pages.members.couponPointSettings.signupPointsRequired': 'Please enter signup points',
  'pages.members.couponPointSettings.signupPointsPlaceholder': 'Enter points granted upon registration',
  'pages.members.couponPointSettings.promotionSuccessPoints': 'Promotion Success Points',
  'pages.members.couponPointSettings.promotionSuccessPointsRequired': 'Please enter promotion success points',
  'pages.members.couponPointSettings.promotionSuccessPointsPlaceholder': 'Enter points granted when promotion is successful',
  'pages.members.couponPointSettings.days': 'days',
  'pages.members.couponPointSettings.column.couponName': 'Coupon Name',
  'pages.members.couponPointSettings.column.amount': 'Amount',
  'pages.members.couponPointSettings.column.code': 'Code',
  'pages.members.couponPointSettings.column.minPurchaseAmount': 'Min Purchase Amount',
  'pages.members.couponPointSettings.column.validityDays': 'Validity Period (Days)',
  'pages.members.couponPointSettings.column.remainingQuantity': 'Remaining Quantity',
  'pages.members.couponPointSettings.column.usedQuantity': 'Used Quantity',
  'pages.members.couponPointSettings.column.createdBy': 'Created By',
  'pages.members.couponPointSettings.column.issuanceMethod': 'Issuance Method',
  'pages.members.couponPointSettings.column.couponId': 'Coupon ID',
  'pages.members.couponPointSettings.column.distributionEnabled': 'Distribution Enabled',
  'pages.members.couponPointSettings.column.createdAt': 'Created At',
  'pages.members.couponPointSettings.issuanceMethodUser': 'User claim',
  'pages.members.couponPointSettings.issuanceMethodSystem': 'System distribution',
  'pages.members.couponPointSettings.issuanceMethodSignup': 'Register and receive coupons',
  'pages.members.couponPointSettings.detail.addCouponName': 'Add coupon name',
  'pages.members.couponPointSettings.detail.setCouponAmount': 'Set coupon amount',
  'pages.members.couponPointSettings.detail.enterCouponCode': 'Enter coupon usage code',
  'pages.members.couponPointSettings.detail.setMinPurchaseAmount': 'Set minimum purchase amount',
  'pages.members.couponPointSettings.detail.setValidityDays': 'Coupon validity period (days)',
  'pages.members.couponPointSettings.detail.remainingQuantity': 'Remaining coupon quantity',
  'pages.members.couponPointSettings.detail.usedQuantity': 'Quantity of coupons already used',
  'pages.members.couponPointSettings.detail.issuanceMethod': 'Issuance method (details: user issuance, system issuance, signup bonus)',
  'pages.members.couponPointSettings.detail.addCouponId': 'Add coupon ID (A unique ID is generated for each coupon set)',
  'pages.members.couponPointSettings.detail.couponSettings': 'Coupon settings (Select which coupon to issue after signup completion. You can enter the coupon ID.)',
  'pages.members.couponPointSettings.form.couponName': 'Coupon Name',
  'pages.members.couponPointSettings.form.couponNameRequired': 'Please enter coupon name',
  'pages.members.couponPointSettings.form.couponNamePlaceholder': 'Enter coupon name',
  'pages.members.couponPointSettings.form.amount': 'Coupon Amount',
  'pages.members.couponPointSettings.form.amountRequired': 'Please enter coupon amount',
  'pages.members.couponPointSettings.form.discountMode': 'Discount Type',
  'pages.members.couponPointSettings.form.discountModeRequired': 'Please select discount type',
  'pages.members.couponPointSettings.discountModeFixed': 'Fixed Amount (₩)',
  'pages.members.couponPointSettings.discountModePercentage': 'Product Price Percentage (%)',
  'pages.members.couponPointSettings.form.percentage': 'Discount Percentage (%)',
  'pages.members.couponPointSettings.form.percentageRequired': 'Please enter discount percentage',
  'pages.members.couponPointSettings.form.code': 'Coupon Usage Code',
  'pages.members.couponPointSettings.form.codeRequired': 'Please enter coupon code',
  'pages.members.couponPointSettings.form.codePattern': 'Code must contain only uppercase letters and numbers',
  'pages.members.couponPointSettings.form.codePlaceholder': 'Enter coupon code',
  'pages.members.couponPointSettings.form.minPurchaseAmount': 'Minimum Purchase Amount',
  'pages.members.couponPointSettings.form.minPurchaseAmountRequired': 'Please enter minimum purchase amount',
  'pages.members.couponPointSettings.form.validityDays': 'Validity Period (Days)',
  'pages.members.couponPointSettings.form.validityDaysRequired': 'Please enter validity days',
  'pages.members.couponPointSettings.form.remainingQuantity': 'Remaining Quantity',
  'pages.members.couponPointSettings.form.remainingQuantityRequired': 'Please enter remaining quantity',
  'pages.members.couponPointSettings.form.remainingQuantityMinForCode': 'Enter at least 1 for member coupon-code redemption (admin manual issue does not use this stock).',
  'pages.members.couponPointSettings.form.remainingQuantityTooltip': 'Stock for member coupon-code redemption. Admin manual issue does not consume this count.',
  'pages.members.couponPointSettings.form.usedQuantity': 'Used Quantity',
  'pages.members.couponPointSettings.form.issuanceMethod': 'Issuance Method',
  'pages.members.couponPointSettings.form.issuanceMethodRequired': 'Please select issuance method',
  'pages.members.couponPointSettings.form.couponId': 'Coupon ID',
  'pages.members.couponPointSettings.form.couponIdTooltip': 'A unique ID is generated for each coupon set',
  'pages.members.couponPointSettings.form.couponIdPlaceholder': 'Enter coupon ID',
  'pages.members.couponPointSettings.form.signupCouponId': 'Signup Coupon ID',
  'pages.members.couponPointSettings.form.signupCouponIdTooltip': 'Select which coupon to issue after signup completion. You can enter the coupon ID.',
  'pages.members.couponPointSettings.form.signupCouponIdPlaceholder': 'Enter coupon ID to issue after signup',
  'pages.members.couponPointSettings.form.distributionEnabled': 'Enable Distribution System',
  'pages.members.couponPointSettings.form.signupWelcome': 'Signup Welcome Coupon (unlimited quantity)',
  'pages.members.couponPointSettings.form.couponType': 'Coupon Type',
  'pages.members.couponPointSettings.form.couponTypeRequired': 'Please select coupon type',
  'pages.members.couponPointSettings.couponTypeProduct': 'Product Coupon',
  'pages.members.couponPointSettings.couponTypeTransportation': 'Transportation Coupon',
  'pages.members.couponPointSettings.couponTypeLive': 'Live Coupon',
  'pages.members.couponPointSettings.couponTypeReferral': 'Referral Signup Coupon',
  'pages.members.couponPointSettings.column.platformScope': 'Platform',
  'pages.members.couponPointSettings.platformLive': 'Live',
  'pages.members.couponPointSettings.platformEcommerce': '1688 / Taobao / VVIC',
  'pages.members.couponPointSettings.form.referralDiscountType': 'Discount Type',
  'pages.members.couponPointSettings.form.platformScope': 'Platform',
  'pages.members.couponPointSettings.form.platformScopeRequired': 'Please select a platform',
  'pages.members.couponPointSettings.referralCouponHelp': 'Automatically issued to new members who sign up with a referral code. Choose product/shipping discount and target platform.',
  'pages.members.couponPointSettings.form.referralSignupEnabled': 'Referral signup auto-issue',
  'pages.members.couponPointSettings.form.referralSignupEnabledTooltip': 'When enabled, issues this coupon to new members who sign up with a referral code.',
  'pages.members.couponPointSettings.column.couponType': 'Coupon Type',
  'pages.members.couponPointSettings.column.liveSeller': 'Live Seller',
  'pages.members.couponPointSettings.form.liveSeller': 'Live Seller (LS mailbox)',
  'pages.members.couponPointSettings.form.liveSellerRequired': 'Please select a live seller',
  'pages.members.couponPointSettings.form.liveSellerPlaceholder': 'Search live seller by mailbox (e.g. LS123)',
  'pages.members.couponPointSettings.column.applicableStores': 'Applicable shops',
  'pages.members.couponPointSettings.applicableStoresAll': 'All shops',
  'pages.members.couponPointSettings.applicableStoresCount': '{count} shops',
  'pages.members.couponPointSettings.form.applicableStores': 'Applicable shops',
  'pages.members.couponPointSettings.form.applicableStoresHelp': 'The discount applies only to products of the chosen shops (shop name), and the minimum purchase is measured on them. Leave empty to apply to every product of this seller.',
  'pages.members.couponPointSettings.form.applicableStoresPlaceholder': 'Search by shop name (empty = all shops)',
  'pages.members.couponPointSettings.form.applicableStoresNeedSeller': 'Select a live seller first',
  'pages.members.couponPointSettings.form.applicableStoresEmpty': 'No matching shops',
  'pages.members.couponPointSettings.form.applicableStoresProductCount': '{count} products',
  'pages.members.couponPointSettings.form.applicableStoresMissing': 'No product of this seller is from this shop now',

  // Point Rules Engine
  'pages.members.pointRules.tabTitle': 'Point Rules Engine',
  'pages.members.pointRules.management': 'Point Rules Management',
  'pages.members.pointRules.add': 'Add Point Rule',
  'pages.members.pointRules.edit': 'Edit Point Rule',
  'pages.members.pointRules.description': 'Configure automatic and manual point award rules based on user events. Rules support conditions, limits, and expiration settings.',
  'pages.members.pointRules.noRules': 'No point rules configured',
  'pages.members.pointRules.deleteTitle': 'Delete Point Rule',
  'pages.members.pointRules.deleteConfirm': 'Are you sure you want to delete this point rule?',
  'pages.members.pointRules.deleteSuccess': 'Point rule deleted successfully',
  'pages.members.pointRules.deleteError': 'Failed to delete point rule',
  'pages.members.pointRules.createSuccess': 'Point rule created successfully',
  'pages.members.pointRules.updateSuccess': 'Point rule updated successfully',
  'pages.members.pointRules.createError': 'Failed to create point rule',
  'pages.members.pointRules.updateError': 'Failed to update point rule',
  'pages.members.pointRules.fetchError': 'Failed to load point rules',
  'pages.members.pointRules.column.ruleName': 'Rule Name',
  'pages.members.pointRules.column.eventType': 'Event Type',
  'pages.members.pointRules.column.points': 'Points',
  'pages.members.pointRules.column.conditions': 'Conditions',
  'pages.members.pointRules.column.type': 'Type',
  'pages.members.pointRules.column.maxPerUser': 'Max Per User',
  'pages.members.pointRules.column.validity': 'Validity',
  'pages.members.pointRules.column.status': 'Status',
  'pages.members.pointRules.eventType.signup': 'Sign Up',
  'pages.members.pointRules.eventType.reviewCreated': 'Review Created',
  'pages.members.pointRules.eventType.orderCompleted': 'Product Purchase',
  'pages.members.pointRules.eventType.attendance': 'Attendance Check',
  'pages.members.pointRules.grantType.automatic': 'Automatic',
  'pages.members.pointRules.grantType.manual': 'Manual',
  'pages.members.pointRules.unlimited': 'Unlimited',
  'pages.members.pointRules.conditionMinChars': 'Min {count} chars',
  'pages.members.pointRules.conditionMinImages': 'Min {count} image(s)',
  'pages.members.pointRules.conditionMinOrder': 'Min order {amount}₩',
  'pages.members.pointRules.daysUnit': '{days} days',
  'pages.members.pointRules.form.ruleName': 'Rule Name',
  'pages.members.pointRules.form.ruleNameRequired': 'Please enter rule name',
  'pages.members.pointRules.form.ruleNamePlaceholder': 'e.g., Basic Review Points, Sign Up Bonus',
  'pages.members.pointRules.form.eventType': 'Event Type',
  'pages.members.pointRules.form.eventTypeRequired': 'Please select event type',
  'pages.members.pointRules.form.eventTypePlaceholder': 'Select event type',
  'pages.members.pointRules.form.pointsToAward': 'Points to Award',
  'pages.members.pointRules.form.pointsRequired': 'Please enter points',
  'pages.members.pointRules.form.pointsPlaceholder': 'e.g., 100',
  'pages.members.pointRules.form.reviewConditions': 'Review Conditions',
  'pages.members.pointRules.form.minCharacters': 'Minimum Review Length (characters)',
  'pages.members.pointRules.form.minCharactersPlaceholder': 'e.g., 20',
  'pages.members.pointRules.form.minImages': 'Minimum Images Required',
  'pages.members.pointRules.form.minImagesPlaceholder': 'e.g., 1',
  'pages.members.pointRules.form.orderConditions': 'Order Conditions',
  'pages.members.pointRules.form.minOrderAmount': 'Minimum Order Amount (₩)',
  'pages.members.pointRules.form.minOrderAmountPlaceholder': 'e.g., 50000',
  'pages.members.pointRules.form.paymentSettings': 'Payment Settings',
  'pages.members.pointRules.form.paymentType': 'Payment Type',
  'pages.members.pointRules.form.pointValidity': 'Point Validity (days)',
  'pages.members.pointRules.form.pointValidityRequired': 'Please enter validity days',
  'pages.members.pointRules.form.pointValidityPlaceholder': 'e.g., 365',
  'pages.members.pointRules.form.limits': 'Limits',
  'pages.members.pointRules.form.maxPerUser': 'Max Per User',
  'pages.members.pointRules.form.maxPerDay': 'Max Per Day',
  'pages.members.pointRules.form.maxPerMonth': 'Max Per Month',
  'pages.members.pointRules.form.unlimitedTooltip': 'Leave empty for unlimited',
  'pages.members.pointRules.form.unlimitedPlaceholder': 'Leave empty for unlimited',
  'pages.members.pointRules.form.ruleStatus': 'Rule Status',
  'pages.members.pointRules.form.active': 'Active',
  'pages.members.pointRules.form.inactive': 'Inactive',
  'pages.members.pointRules.form.earnRatesTitle': 'Purchase Earn Rates',
  'pages.members.pointRules.form.earnRatesDescription': 'Set an earn rate on the purchase amount for each sales channel.',
  'pages.members.pointRules.form.earnRateOwnmall': 'Own Mall',
  'pages.members.pointRules.form.earnRateLive': 'Live Products',
  'pages.members.pointRules.form.earnRateOverseas': 'Purchasing Agency / Overseas Direct',
  'pages.members.pointRules.form.earnRateLabel': 'Earn rate on purchase amount',
  'pages.members.pointRules.form.earnRatePlaceholder': 'e.g. {value}',
  'pages.members.pointRules.form.earnRateRequired': 'Enter an earn rate (0 to earn nothing)',
  'pages.members.pointRules.form.earnRatesHint': 'Points = paid amount × rate, fractions dropped. An order mixing channels is split by each product\'s share of the order; a live (LS) order earns the live rate on the whole amount.',
  'pages.members.pointRules.form.purchaseConditions': 'Purchase Conditions',
  'pages.members.pointRules.form.purchaseTimingHint': 'Points are granted when the payment completes and taken back by the refunded amount on a refund.',
  'pages.members.pointRules.form.attendanceConditions': 'Attendance Conditions',
  'pages.members.pointRules.form.attendanceOncePerDay': 'Attendance points are granted once per member per day (Korea time).',
  'pages.members.pointRules.form.streakBonusEnabled': 'Use streak bonuses',
  'pages.members.pointRules.form.streakBonusTitle': 'Streak Bonus Settings',
  'pages.members.pointRules.form.streak7Bonus': '7-day streak bonus',
  'pages.members.pointRules.form.streak7BonusPlaceholder': 'e.g. 500',
  'pages.members.pointRules.form.streak30Bonus': '30-day streak bonus',
  'pages.members.pointRules.form.streak30BonusPlaceholder': 'e.g. 3,000',
  'pages.members.pointRules.form.streakBonusHint': 'Granted on top of the daily points on every 7th and every 30th consecutive day (the 7-day bonus again on day 14, 21…, the 30-day bonus on day 60…). A missed day restarts the count at 1. Leave empty or 0 to skip that bonus.',
  'pages.members.pointRules.earnRatesSummary': 'Own mall {ownmall}% · Live {live}% · Overseas {overseas}%',
  'pages.members.pointRules.conditionStreak7': '7-day streak +{points}P',
  'pages.members.pointRules.conditionStreak30': '30-day streak +{points}P',

  // Consumption Change Details
  'pages.members.consumptionChangeDetails.title': 'Consumption Change Details',
  'pages.members.consumptionChangeDetails.tab.financial': 'Member Financial Records',
  'pages.members.consumptionChangeDetails.tab.consumption': 'Member Consumption Records',
  'pages.members.consumptionChangeDetails.tab.rebate': 'Rebate Records',
  'pages.members.consumptionChangeDetails.tab.points': 'Points Usage Records',
  'pages.members.consumptionChangeDetails.tab.coupon': 'Coupon Usage Records',
  'pages.members.consumptionChangeDetails.column.userId': 'Member ID',
  'pages.members.consumptionChangeDetails.column.userName': 'User Name',
  'pages.members.consumptionChangeDetails.column.userInfo': 'User Info',
  'pages.members.consumptionChangeDetails.column.memberLevel': 'Member Level',
  'pages.members.consumptionChangeDetails.column.currentPoints': 'Current Remaining Points',
  'pages.members.consumptionChangeDetails.column.currentDeposit': 'Current Remaining Deposit',
  'pages.members.consumptionChangeDetails.column.updateTime': 'Update Time',
  'pages.members.consumptionChangeDetails.column.orderNo': 'Order No.',
  'pages.members.consumptionChangeDetails.column.paymentMethod': 'Payment Method',
  'pages.members.consumptionChangeDetails.column.paymentType': 'Payment Type',
  'pages.members.consumptionChangeDetails.column.amountBefore': 'Amount Before',
  'pages.members.consumptionChangeDetails.column.changeAmount': 'Change Amount',
  'pages.members.consumptionChangeDetails.column.amountAfter': 'Amount After',
  'pages.members.consumptionChangeDetails.column.currentBalance': 'Current Remaining Balance',
  'pages.members.consumptionChangeDetails.column.changeTime': 'Change Time',
  'pages.members.consumptionChangeDetails.column.time': 'Time',
  'pages.members.consumptionChangeDetails.column.rebateAmount': 'Rebate Amount',
  'pages.members.consumptionChangeDetails.column.type': 'Type',
  'pages.members.consumptionChangeDetails.column.couponName': 'Coupon Name',
  'pages.members.consumptionChangeDetails.column.couponCode': 'Coupon Exchange Code',
  'pages.members.consumptionChangeDetails.column.couponValue': 'Coupon Face Value',
  'pages.members.consumptionChangeDetails.column.minOrderAmount': 'Minimum Order Amount',
  'pages.members.consumptionChangeDetails.column.receiveMethod': 'Receive Method',
  'pages.members.consumptionChangeDetails.column.validPeriod': 'Valid Period',
  'pages.members.consumptionChangeDetails.column.status': 'Usage Status',
  'pages.members.consumptionChangeDetails.column.receiveTime': 'Receive Time',
  'pages.members.consumptionChangeDetails.column.usedTime': 'Used Time',
  'pages.members.consumptionChangeDetails.status.used': 'Used',
  'pages.members.consumptionChangeDetails.status.unused': 'Unused',
  'pages.members.consumptionChangeDetails.status.expired': 'Expired',
  'pages.members.consumptionChangeDetails.exportSuccess': 'Data has been exported',

  // System - Work Log
  'pages.system.workLog.title': 'Work Log',
  'pages.system.workLog.column.employeeId': 'Employee ID',
  'pages.system.workLog.column.employeeName': 'Employee Name',
  'pages.system.workLog.deletedAccount': 'Deleted account',
  'pages.system.workLog.column.workContent': 'Work Content',
  'pages.system.workLog.column.workTime': 'Work Time',
  'pages.system.workLog.exportSuccess': 'Work log data has been exported',

  // Shipping Cost Modal
  'pages.shippingCost.title': 'Shipping Weight Measurement',
  'pages.shippingCost.orderInformation': 'Order Information',
  'pages.shippingCost.orderNoMemberName': 'Order Number/Member Name',
  'pages.shippingCost.center': 'Center',
  'pages.shippingCost.trackingCount': 'Tracking Count',
  'pages.shippingCost.items': 'items',
  'pages.shippingCost.recipient': 'Recipient',
  'pages.shippingCost.mountainislandCost': 'Island and Mountainous Area Cost',
  'pages.shippingCost.recipientAddress': 'Recipient Address',
  'pages.shippingCost.totalQuantityAmount': 'Total Quantity/Total Amount',
  'pages.shippingCost.productInformation': 'Product Information',
  'pages.shippingCost.productNo': 'Product Number',
  'pages.shippingCost.productName': 'Product Name',
  'pages.shippingCost.image': 'Image',
  'pages.shippingCost.quantity': 'Quantity',
  'pages.shippingCost.trackingNumber': 'Tracking Number',
  'pages.shippingCost.status': 'Status',
  'pages.shippingCost.rackNumber': 'Rack Number',
  'pages.shippingCost.actualInspection': 'Actual Inspection',
  'pages.shippingCost.viewActualInspection': 'View Actual Inspection',
  'pages.shippingCost.adminMemo': 'Administrator Memo',
  'pages.shippingCost.additionalServices': 'Additional Services',
  'pages.shippingCost.boxCount': 'Box Count',
  'pages.shippingCost.box': 'Box',
  'pages.shippingCost.inspectionOptions': 'Inspection Options',
  'pages.shippingCost.originMarkingOptions': 'Origin Marking Options',
  'pages.shippingCost.businessLCLCustomsOptions': 'Business LCL Customs Options',
  'pages.shippingCost.packagingOptions': 'Packaging Options',
  'pages.shippingCost.otherOptions': 'Other Options',
  'pages.shippingCost.additionalCosts': 'Additional Costs',
  'pages.shippingCost.totalServiceAmount': 'Total Value-Added Service Amount',
  'pages.shippingCost.weightInformation': 'Weight Information',
  'pages.shippingCost.actualWeight': 'Actual Weight',
  'pages.shippingCost.applicableExchangeRate': 'Applicable Exchange Rate',
  'pages.shippingCost.volumetricWeight': 'Volumetric Weight',
  'pages.shippingCost.volume': 'Volume',
  'pages.shippingCost.applicableWeight': 'Applicable Weight (Shipping Cost)',
  'pages.shippingCost.actual': 'Actual Weight',
  'pages.shippingCost.volumetric': 'Volumetric Weight',
  'pages.shippingCost.totalAmount': 'Total Amount',
  'pages.shippingCost.save': 'Save',
  'pages.shippingCost.close': 'Close',
  'pages.shippingCost.saved': 'Shipping cost has been saved',
  'pages.shippingCost.smsNotSend': 'Do not send SMS',
  'pages.shippingCost.smsSend': 'Send SMS',
  'pages.shippingCost.cbmWeight': 'CBM weight',
  'pages.shippingCost.additionalCost': 'Additional cost',
  'pages.shippingCost.weightCost': 'Weight cost',
  'pages.shippingCost.totalCost': 'Total cost',
  'pages.shippingCost.additionalPlusWeight': 'Additional + Weight',
  'pages.shippingCost.calculatedWeight': 'Calculated weight',
  'pages.shippingCost.selectWeight': 'Select weight',
  'pages.shippingCost.boxNumber': 'Box Number',
  'pages.shippingCost.dimensions': 'Dimensions (W×L×H)',
  'pages.shippingCost.shippingCost': 'Shipping Cost',
  'pages.shippingCost.width': 'Width',
  'pages.shippingCost.length': 'Length',
  'pages.shippingCost.height': 'Height',
  'pages.shippingCost.warehouseComplete': 'Warehouse Complete',

  // Packing Modal
  'pages.packing.title': 'Packing',
  'pages.packing.internationalTrackingNumber': 'International Tracking Number',
  'pages.packing.recipientAddress': 'Recipient Address',
  'pages.packing.recipient': 'Recipient',
  'pages.packing.address': 'Address',
  'pages.packing.phone': 'Phone',
  'pages.packing.weightAndDimensions': 'Weight and Dimensions',
  'pages.packing.weight': 'Weight',
  'pages.packing.shippingMethod': 'Shipping Method',
  'pages.packing.width': 'Width',
  'pages.packing.length': 'Length',
  'pages.packing.height': 'Height',
  'pages.packing.shippingFeeCalculation': 'Shipping Fee Calculation',
  'pages.packing.realWeight': 'Real Weight',
  'pages.packing.volumetricWeight': 'Volumetric Weight (CBM)',
  'pages.packing.chargeableWeight': 'Chargeable Weight (Applicable)',
  'pages.packing.internationalShippingFee': 'International Shipping Fee',
  'pages.packing.additionalCost': 'Additional Cost',
  'pages.packing.simplifiedCustomsClearance': 'Simplified Customs Clearance',
  'pages.packing.designatedShooting': 'Designated Shooting',
  'pages.packing.totalCost': 'Total Cost',
  'pages.packing.save': 'Save',
  'pages.packing.close': 'Close',
  'pages.packing.saved': 'Packing completed successfully',

  // Rack Designation Modal
  'pages.rackDesignation.title': 'Rack Designation',
  'pages.rackDesignation.internationalTrackingNumber': 'International Tracking Number',
  'pages.rackDesignation.rackNumber': 'Rack Number',
  'pages.rackDesignation.save': 'Save',
  'pages.rackDesignation.close': 'Close',

  // Return Cost Modal
  'pages.returnCost.title': 'Return Cost',
  'pages.returnCost.orderInformation': 'Order Information',
  'pages.returnCost.orderNumber': 'Order Number',
  'pages.returnCost.deliveryCenter': 'Delivery Center',
  'pages.returnCost.totalQuantityAmount': 'Total Quantity/Total Amount',
  'pages.returnCost.items': 'items',
  'pages.returnCost.additionalServices': 'Additional Services',
  'pages.returnCost.costInformation': 'Cost Information',
  'pages.returnCost.weight': 'Weight',
  'pages.returnCost.returnTrackingNumber': 'Return Tracking Number',
  'pages.returnCost.returnTrackingNumberPlaceholder': 'Enter return tracking number',
  'pages.returnCost.appliedExchangeRate': 'Applied Exchange Rate',
  'pages.returnCost.totalAmount': 'Total Amount',
  'pages.returnCost.courierPaymentAmount': 'Courier Payment Amount',
  'pages.returnCost.save': 'Save',
  'pages.returnCost.close': 'Close',
  'pages.returnCost.saved': 'Return cost has been saved',
  'pages.returnCost.smsNotSend': 'Do not send SMS',
  'pages.returnCost.smsSend': 'Send SMS',
  'pages.refundSplit.title': 'Refund Split',
  'pages.refundSplit.description': 'For orders that require return/refund due to partial errors, you can select the sub-order numbers and quantities that need to be refunded to split them. The split order will automatically be converted to "Platform Refund Request" status and linked to the original order.',
  'pages.refundSplit.orderNo': 'Order Number',
  'pages.refundSplit.select': 'Select',
  'pages.refundSplit.image': 'Image',
  'pages.refundSplit.productName': 'Product Name',
  'pages.refundSplit.variation': 'Variation',
  'pages.refundSplit.originalQuantity': 'Original Quantity',
  'pages.refundSplit.refundQuantity': 'Refund Quantity',
  'pages.refundSplit.unitPrice': 'Unit Price',
  'pages.refundSplit.refundAmount': 'Refund Amount',
  'pages.refundSplit.selectedGross': 'Selected gross product total',
  'pages.refundSplit.couponDeduction': 'Coupon/points allocation deduction',
  'pages.refundSplit.selectedTotal': 'Estimated refund amount',
  'pages.refundSplit.confirm': 'Confirm Refund Split',
  'pages.refundSplit.close': 'Cancel',
  'pages.refundSplit.selectAtLeastOne': 'Please select at least one product.',
  'pages.refundSplit.invalidQuantity': 'Please enter a valid refund quantity for all selected products.',
  'pages.refundSplit.quantityExceedsMax': 'Refund quantity cannot exceed {max} items.',
  'pages.refundSplit.cannotRefundAll': 'Cannot refund all products. At least one product must remain in the original order.',
  'pages.refundSplit.noRefundProducts': 'No products to refund.',
  'pages.refundSplit.success': 'Refund split completed successfully.',
  'pages.refundSplit.error': 'An error occurred during refund split.',
  // Tax Settlement Management
  'pages.members.taxSettlement.purchaseAmount': 'Purchase Amount',
  'pages.members.taxSettlement.purchaseFee': 'Purchase Fee',
  'pages.members.taxSettlement.warehouseArea': 'Warehouse Area',
  'pages.members.taxSettlement.transportationMethod': 'Transportation Method',
  'pages.members.taxSettlement.mailboxNumber': 'Mailbox Number',
  'pages.members.taxSettlement.waybillNumber': 'Waybill Number',
  'pages.members.taxSettlement.orderNumber': 'Order Number',
  'pages.members.taxSettlement.paymentDate': 'Payment Date',
  'pages.members.taxSettlement.paymentMethod': 'Payment Method',
  'pages.members.taxSettlement.refundRoute': 'Refund Route',
  'pages.members.taxSettlement.paymentMethod.creditCard': 'Credit Card',
  'pages.members.taxSettlement.paymentMethod.deposit': 'Deposit',
  'pages.members.taxSettlement.paymentMethod.points': 'Points',
  'pages.members.taxSettlement.paymentMethod.bankTransfer': 'Bank Transfer',
  'pages.members.taxSettlement.entryType.first_payment': '1st Payment',
  'pages.members.taxSettlement.entryType.second_payment': '2nd Payment',
  'pages.members.taxSettlement.entryType.partial_refund': 'Partial Refund',
  'pages.members.taxSettlement.entryType.full_refund': 'Full Refund',
  'pages.members.taxSettlement.col.orderDateTime': 'Order Date',
  'pages.members.taxSettlement.col.userUniqueNo': 'PO Box No.',
  'pages.members.taxSettlement.col.userName': 'Member Name',
  'pages.members.taxSettlement.col.internationalTrackingNumber': 'Tracking Number',
  'pages.members.taxSettlement.col.customsItemNamesEn': 'Product Name (EN)',
  'pages.members.taxSettlement.col.entryType': 'Type',
  'pages.members.taxSettlement.col.bankAmount': 'Bank In/Out Amount',
  'pages.members.taxSettlement.col.refundDepositCredit': 'Refund Credited to Deposit',
  'pages.members.taxSettlement.col.purchaseEstimate': 'Purchase Estimate',
  'pages.members.taxSettlement.col.firstTierPaymentCost': '1st Payment Cost',
  'pages.members.taxSettlement.col.firstTierProductAmount': 'Product Amount (1st)',
  'pages.members.taxSettlement.col.firstTierServiceFee': 'Service Fee (1st)',
  'pages.members.taxSettlement.col.firstTierDomesticShipping': 'Domestic Shipping (1st)',
  'pages.members.taxSettlement.col.couponUsed': 'Coupon Used',
  'pages.members.taxSettlement.col.pointsUsed': 'Points Used',
  'pages.members.taxSettlement.col.relatedOrderNumbers': 'Related Orders',
  'pages.members.taxSettlement.col.bankNetAfterRefund': 'Bank After Refund',
  'pages.members.taxSettlement.col.firstTierAfterRefund': '1st Tier After Refund',
  'pages.members.taxSettlement.col.depositUsed': 'Deposit Used',
  'pages.members.taxSettlement.col.secondTierPaymentCost': '2nd Payment Cost',
  'pages.members.taxSettlement.col.internationalShippingSecondTier': 'Intl Shipping (2nd)',
  'pages.members.taxSettlement.col.ruralShippingSecondTier': 'Rural Shipping (2nd)',
  'pages.members.taxSettlement.col.simplifiedClearanceSecondTier': 'Simplified Clearance (2nd)',
  'pages.members.taxSettlement.col.addOnServicesSecondTier': 'Add-on Services (2nd)',
  'pages.members.taxSettlement.col.productPurchaseCNY': 'Product Purchase (CNY)',
  'pages.members.taxSettlement.col.exchangeRate': 'Exchange Rate',
  'pages.members.taxSettlement.col.miscLoss': 'Misc Loss',
  'pages.members.taxSettlement.col.note': 'Note',
  'pages.members.taxSettlement.receiver': 'Receiver',
  'pages.members.taxSettlement.receiverAddress': 'Receiver Address',
  'pages.members.taxSettlement.personalCustomsCode': 'Personal Customs Code',
  'pages.members.taxSettlement.productNameEnglish': 'Product Name (English)',
  'pages.members.taxSettlement.ct': 'C/T',
  'pages.members.taxSettlement.weight': 'Weight',
  'pages.members.taxSettlement.shippingCosts': 'Shipping Costs',
  'pages.members.taxSettlement.additionalServices': 'Additional Services',
  'pages.members.taxSettlement.additionalCostPayment': 'Additional Cost Payment',
  'pages.members.taxSettlement.export': 'Export to Excel',
  'pages.members.taxSettlement.exportSuccess': 'Excel download started successfully.',
  'pages.members.taxSettlement.progressStatus': 'Progress status',
  'pages.members.taxSettlement.tab.order': 'Order',
  'pages.members.taxSettlement.tab.deposit': 'Deposit',
  'pages.members.taxSettlement.order.orderDate': 'Order Date',
  'pages.members.taxSettlement.order.orderNumber': 'Order Number',
  'pages.members.taxSettlement.order.memberName': 'Member Name',
  'pages.members.taxSettlement.order.waybillNumber': 'Waybill Number',
  'pages.members.taxSettlement.order.productNameEnglish': 'Product Name (English)',
  'pages.members.taxSettlement.order.paymentMethod': 'Payment Method',
  'pages.members.taxSettlement.order.refundType': 'Refund / 2nd Payment Type',
  'pages.members.taxSettlement.order.paymentAmounts': '1st / 2nd Payment Amount',
  'pages.members.taxSettlement.order.productAmount': 'Product Amount',
  'pages.members.taxSettlement.order.fee': 'Fee',
  'pages.members.taxSettlement.order.domesticShippingFee': 'Domestic Shipping Fee',
  'pages.members.taxSettlement.order.sumAmount': 'Sum (Product + Fee + Domestic Shipping)',
  'pages.members.taxSettlement.order.internationalShippingFee': 'International Shipping Fee',
  'pages.members.taxSettlement.order.secondaryPaymentAmount': '2nd Payment Amount (excl. Intl. Shipping)',
  'pages.members.taxSettlement.order.pointsUsed': 'Points Used',
  'pages.members.taxSettlement.order.couponUsed': 'Coupon Used',
  'pages.members.taxSettlement.order.depositUsed': 'Deposit Used',
  'pages.members.taxSettlement.order.productPurchaseCost': 'Product Purchase Cost (Price / Rate)',
  'pages.members.taxSettlement.order.exchangeRate': 'Exchange Rate',
  'pages.members.taxSettlement.order.netFee': 'Fee − Points − Coupon',
  'pages.members.taxSettlement.order.paymentMethod.bankTransfer': 'Bank Transfer',
  'pages.members.taxSettlement.order.paymentMethod.creditCard': 'Credit Card',
  'pages.members.taxSettlement.order.paymentMethod.deposit': 'Deposit',
  'pages.members.taxSettlement.order.paymentMethod.points': 'Points',
  'pages.members.taxSettlement.order.refundType.fullRefund': 'Full Refund',
  'pages.members.taxSettlement.order.refundType.partialRefund': 'Partial Refund',
  'pages.members.taxSettlement.order.refundType.secondPayment': '2nd Payment',
  'pages.members.taxSettlement.deposit.memberName': 'Member Name',
  'pages.members.taxSettlement.deposit.carryoverBalance': 'Carryover Balance',
  'pages.members.taxSettlement.deposit.earning': 'Earnings (Refund Substitute / Rebate)',
  'pages.members.taxSettlement.deposit.depositRecharge': 'Deposit Recharge',
  'pages.members.taxSettlement.deposit.deduction': 'Deduction (Order Use / Rebate Deduction)',
  'pages.members.taxSettlement.deposit.depositWithdrawal': 'Deposit Withdrawal',
  'pages.members.taxSettlement.deposit.balanceAfter': 'Balance After',

  // Store Management
  'pages.products.store.title': 'Store Management',
  'pages.products.store.edit': 'Edit',
  'pages.products.store.delete': 'Delete',
  'pages.products.store.products': 'Products',
  'pages.products.store.viewProducts': 'View products in this store',
  'pages.products.store.editTitle': 'Edit Store',
  'pages.products.store.nameKo': 'Korean Name',
  'pages.products.store.nameEn': 'English Name',
  'pages.products.store.nameZh': 'Chinese Name',
  'pages.products.store.totalProducts': 'Total Products',
  'pages.products.store.nameKoRequired': 'Please enter Korean name',
  'pages.products.store.nameKoPlaceholder': 'Enter Korean store name',
  'pages.products.store.translateFromThis': 'Translate other languages from this',
  'pages.products.store.nameEnPlaceholder': 'Enter English store name',
  'pages.products.store.nameZhPlaceholder': 'Enter Chinese store name',
  'pages.products.store.image': 'Store Image',
  'pages.products.store.uploadImage': 'Upload Image',
  'pages.products.store.status': 'Status',
  'pages.products.store.createdAt': 'Created At',
  'pages.products.store.actions': 'Actions',
  'pages.products.store.total': 'Total',
  'pages.products.store.showInactive': 'Show Inactive',
  'pages.products.store.hideInactive': 'Hide Inactive',
  'pages.products.store.createSuccess': 'Store created successfully',
  'pages.products.store.createFailed': 'Failed to create store',
  'pages.products.store.updateSuccess': 'Store updated successfully',
  'pages.products.store.unsavedKeep': 'Keep editing',
  'pages.products.store.unsavedDiscard': 'Close',
  'pages.products.store.unsavedBody': 'Closing now discards everything you changed. Close anyway?',
  'pages.products.store.unsavedTitle': 'You have unsaved changes',
  'pages.products.store.updateFailed': 'Failed to update store',
  'pages.products.store.deleteSuccess': 'Store deleted successfully',
  'pages.products.store.deleteFailed': 'Failed to delete store',
  'pages.products.store.deleteConfirm': 'Delete Store',
  'pages.products.store.deleteContent': 'Are you sure you want to delete store "{name}"?',
  // Store ↔ member link
  'pages.products.store.owner': 'Member',
  'pages.products.store.ownerNone': 'Not linked',
  'pages.products.store.ownerHint': 'Search by mailbox number (LS56, TM373) or nickname to link the member who owns this store. The seller share of the store rebate goes to this member.',
  'pages.products.store.ownerPlaceholder': 'Search mailbox number or nickname',
  'pages.products.store.ownerNotFound': 'No member found',
  'pages.products.store.pointShop': 'Point shop',
  'pages.products.store.pointShopHint': 'When on, products of this store can be bought with points only.',

  // Store rebate settings
  'pages.products.storeRebate.title': 'Store Rebate Settings',
  'pages.products.storeRebate.store': 'Store',
  'pages.products.storeRebate.owner': 'Member',
  'pages.products.storeRebate.ownerNone': 'No member linked',
  'pages.products.storeRebate.inactiveStore': 'Inactive',
  'pages.products.storeRebate.sellerPercent': 'Seller %',
  'pages.products.storeRebate.companyPercent': 'Company %',
  'pages.products.storeRebate.configuredAt': 'Configured At',
  'pages.products.storeRebate.actions': 'Actions',
  'pages.products.storeRebate.setting': 'Edit',
  'pages.products.storeRebate.delete': 'Delete',
  'pages.products.storeRebate.addRebate': 'Add Rebate',
  'pages.products.storeRebate.addModalTitle': 'Add Store Rebate Setting',
  'pages.products.storeRebate.editModalTitle': 'Edit Store Rebate Setting',
  'pages.products.storeRebate.storeRequired': 'Select a store',
  'pages.products.storeRebate.storeSelectPlaceholder': 'Search by store name or member',
  'pages.products.storeRebate.noStoreLeft': 'Every store already has a rebate setting',
  'pages.products.storeRebate.sellerPercentRequired': 'Enter the seller percentage',
  'pages.products.storeRebate.companyPercentRequired': 'Enter the company percentage',
  'pages.products.storeRebate.sumError': 'Seller % and company % must add up to 100',
  'pages.products.storeRebate.sumHint': 'Entering the seller % fills the company % with the remainder of 100.',
  'pages.products.storeRebate.ownerMissingHint': 'This store has no linked member. Link one in Store Management first so the seller share has a recipient.',
  'pages.products.storeRebate.addSuccess': 'Store rebate setting added',
  'pages.products.storeRebate.addFailed': 'Failed to add store rebate setting',
  'pages.products.storeRebate.updateSuccess': 'Store rebate setting updated',
  'pages.products.storeRebate.updateFailed': 'Failed to update store rebate setting',
  'pages.products.storeRebate.deleteSuccess': 'Store rebate setting deleted',
  'pages.products.storeRebate.deleteFailed': 'Failed to delete store rebate setting',
  'pages.products.storeRebate.deleteConfirm': 'Delete Store Rebate Setting',
  'pages.products.storeRebate.deleteContent': 'Delete the rebate setting of store "{name}"?',
  'pages.products.storeRebate.searchPlaceholder': 'Search by store name, mailbox number, or nickname',
  'pages.products.storeRebate.search': 'Search',
  'pages.products.storeRebate.reset': 'Reset',
  'pages.products.storeRebate.batchUpdateTitle': 'Bulk Update Percentages',
  'pages.products.storeRebate.applySetting': 'Apply',
  'pages.products.storeRebate.cancel': 'Cancel',
  'pages.products.storeRebate.batchUpdateSuccess': 'Bulk update completed',
  'pages.products.storeRebate.batchUpdateFailed': 'Bulk update failed',

  // Live Sellers
  'pages.live.sellers.title': 'Live Broadcast Seller Management',
  'pages.live.sellers.register': 'Register Seller',
  'pages.live.sellers.sellerName': 'Seller Name',
  'pages.live.sellers.id': 'ID',
  'pages.live.sellers.contact': 'Contact',
  'pages.live.sellers.liveCount': 'Live Count',
  'pages.live.sellers.totalViews': 'Total Views',
  'pages.live.sellers.totalItemsSold': 'Total Items Sold',
  'pages.live.sellers.activeProducts': 'Active Products',
  'pages.live.sellers.status': 'Status',
  'pages.live.sellers.status.active': '● Live',
  'pages.live.sellers.status.inactive': '○ Rest',
  'pages.live.sellers.top10': 'TOP10',
  'pages.live.sellers.popular': 'Popular',
  'pages.live.sellers.pointSeller': 'Point',
  'pages.live.sellers.actions': 'Actions',
  'pages.live.sellers.detail': 'Detail',
  'pages.live.sellers.edit': 'Edit',
  'pages.live.sellers.delete': 'Delete',
  'pages.live.sellers.deleteConfirm': 'Delete Seller',
  'pages.live.sellers.deleteContent': 'Are you sure you want to delete seller "{name}"?',
  'pages.live.sellers.deleteSuccess': 'Seller deleted successfully',
  'pages.live.sellers.deleteFailed': 'Failed to delete seller',
  'pages.live.sellers.updateSuccess': 'Seller updated successfully',
  'pages.live.sellers.updateFailed': 'Failed to update seller',
  'pages.live.sellers.edit.topRank': 'TOP 10 Rank',
  'pages.live.sellers.edit.topRankPlaceholder': 'Enter rank (1-10)',
  'pages.live.sellers.edit.topRankTooltip': 'Set rank between 1-10 for TOP 10 sellers, leave empty for non-TOP 10',
  'pages.live.sellers.edit.rankDelta': 'Ranking Change',
  'pages.live.sellers.edit.rankDeltaHint': '+ is up, - is down, 0 is unchanged',
  'pages.live.sellers.edit.rankDeltaPlaceholder': 'e.g. 2, -1, 0',
  'pages.live.sellers.edit.liveCount': 'Live Count',
  'pages.live.sellers.edit.liveCountPlaceholder': 'Enter live count',
  'pages.live.sellers.edit.totalViews': 'Total Views',
  'pages.live.sellers.edit.totalViewsPlaceholder': 'Enter total views',
  'pages.live.sellers.edit.totalItemsSold': 'Total Items Sold',
  'pages.live.sellers.edit.totalItemsSoldPlaceholder': 'Enter total items sold',
  'pages.live.sellers.edit.popularStatus': 'Popular Seller Status',
  'pages.live.sellers.edit.pointSellerStatus': 'Point Seller Status',
  'pages.live.sellers.loadFailed': 'Failed to load seller list',
  'pages.live.sellers.legend': '[Legend] 🔥 Popular Seller (5+ lives in last 30 days)',
  'pages.live.sellers.top10Info': 'TOP10: Automatically calculated based on live count/sales this month',
  
  // Live Seller Registration
  'pages.live.sellers.register.title': 'Register Seller',
  'pages.live.sellers.register.searchUser': 'Search User',
  'pages.live.sellers.register.searchPlaceholder': 'Search by name, email, ID',
  'pages.live.sellers.register.search': 'Search',
  'pages.live.sellers.register.searchResults': 'Search Results (Existing Users)',
  'pages.live.sellers.register.noResults': 'No search results',
  'pages.live.sellers.register.selectUser': 'Select User',
  'pages.live.sellers.register.selected': 'Selected',
  'pages.live.sellers.register.registerAsSeller': 'Register as Seller',
  'pages.live.sellers.register.selectedUser': 'Selected User',
  'pages.live.sellers.register.registrationInfo': 'Registration Information',
  'pages.live.sellers.register.nickname': 'Live Nickname',
  'pages.live.sellers.register.nicknamePlaceholder': 'Nickname to use in live broadcast',
  'pages.live.sellers.register.liveChannelLink': 'Live Channel Link',
  'pages.live.sellers.register.liveChannelLinkPlaceholder': 'Enter live channel URL',
  'pages.live.sellers.channels.section': 'SNS channels',
  'pages.live.sellers.channels.tiktok': 'TikTok link',
  'pages.live.sellers.channels.youtube': 'YouTube link',
  'pages.live.sellers.channels.tiktokPlaceholder': 'https://www.tiktok.com/@username or @username',
  'pages.live.sellers.channels.youtubePlaceholder': 'https://www.youtube.com/@handle or @handle',
  'pages.live.sellers.channels.tiktokInvalid': 'Enter a tiktok.com URL or an @username',
  'pages.live.sellers.channels.youtubeInvalid': 'Enter a youtube.com / youtu.be URL or an @handle',
  'pages.live.sellers.channels.useLiveChannelLink': 'Use the live channel link',
  'pages.live.sellers.channels.hint': 'Links show as icons on the seller page and on the seller cards of the live page. Leave a field empty to hide its icon.',
  'pages.live.sellers.register.referralCode': 'Referral Code',
  'pages.live.sellers.register.referralCodePlaceholder': 'Enter referral code',
  'pages.live.sellers.register.referralCodeTooltip': 'Enter the referrer\'s code if applicable (optional)',
  'pages.live.sellers.detailInfo.title': 'Seller Details',
  'pages.live.sellers.detailInfo.userId': 'User ID',
  'pages.live.sellers.detailInfo.sellerId': 'Seller ID',
  'pages.live.sellers.detailInfo.recommender': 'Recommender',
  'pages.live.sellers.detailInfo.rebate': 'Rebate',
  'pages.live.sellers.detailInfo.teamRebate': 'Team Rebate',
  'pages.live.sellers.detailInfo.deposit': 'Deposit',
  'pages.live.sellers.detailInfo.salesCount': 'Sales Count',
  'pages.live.sellers.detailInfo.salesAmount': 'Sales Amount',
  'pages.live.sellers.detailInfo.rebateAccrued': 'Rebate (Accrued)',
  'pages.live.sellers.detailInfo.avgOrderValue': 'Avg. Order Value',
  'pages.live.sellers.detailInfo.refundCount': 'Refund Count',
  'pages.live.sellers.detailInfo.refundAmount': 'Refund Amount',
  'pages.live.sellers.detailInfo.rebateDeducted': 'Rebate (Deducted)',
  'pages.live.sellers.detailInfo.refundRate': 'Refund Rate',
  'pages.live.sellers.detailInfo.teamMembers': 'Team Members',
  'pages.live.sellers.detailInfo.teamSalesAmount': 'Team Sales',
  'pages.live.sellers.detailInfo.teamRebateAccrued': 'Team Rebate (Accrued)',
  'pages.live.sellers.detailInfo.teamRebateDeducted': 'Team Rebate (Deducted)',
  'pages.live.sellers.detailInfo.teamRefundRate': 'Team Refund Rate',
  'pages.live.sellers.detailInfo.followers': 'Followers',
  'pages.live.sellers.detailInfo.teamFollowers': 'Team Followers',
  'pages.live.sellers.detailInfo.rank': 'Rank',
  'pages.live.sellers.detailInfo.regionDistribution': 'Region Distribution',
  'pages.live.sellers.detailInfo.noData': 'No Data',
  'pages.live.sellers.detailInfo.comparedToYesterday': 'vs Yesterday',
  'pages.live.sellers.detailInfo.comparedToLastMonth': 'vs Last Month',
  'pages.live.sellers.detailInfo.unitMan': '0k',
  'pages.live.sellers.detailInfo.name': 'Name',
  'pages.live.sellers.detailInfo.miniHomepage': 'Mini Homepage',
  'pages.live.sellers.detailInfo.liveChannel': 'Live Channel',
  'pages.live.sellers.detailInfo.personal': 'Personal',
  'pages.live.sellers.detailInfo.team': 'Team',
  'pages.live.sellers.detailInfo.refunds': 'Refunds',
  'pages.live.sellers.detailInfo.metric': 'Metric',
  'pages.live.sellers.products.batchUpdate': 'Batch Update',
  'pages.live.sellers.products.batchUpdate.apply': 'Apply',
  'pages.live.sellers.products.batchUpdate.selectFirst': 'Please select products first.',
  'pages.live.sellers.products.batchUpdate.valueRequired': 'Please enter a value.',
  'pages.live.sellers.products.batchUpdate.description': 'The same value will be applied to all SKUs of the selected products.',
  'pages.live.sellers.products.batchUpdate.descriptionProduct': 'The same value will be applied to every selected product.',
  'pages.live.sellers.products.batchUpdate.placeholder.companyName': 'Enter shop name',
  'pages.live.sellers.products.column.category': 'Category',
  'pages.live.sellers.products.category.placeholder': 'Select category',
  'pages.live.sellers.products.category.wholeGroup': 'All of {name}',
  'pages.live.sellers.products.category.sharedHint': 'Uses the Company Mall categories. For company mall products the category also changes in the Company Mall product list.',
  'pages.live.sellers.products.applyToSelected.title': 'Apply to the {count} selected products?',
  'pages.live.sellers.products.category.applyToSelected.content': 'The category of all {count} selected products will be set to “{category}”.',
  'pages.live.sellers.products.applyToSelected.all': 'Apply to all {count}',
  'pages.live.sellers.products.applyToSelected.onlyThis': 'This product only',
  'pages.live.sellers.products.category.none': 'No category',
  'pages.live.sellers.products.companyName.applyToSelected.content': 'The shop name of all {count} selected products will be set to “{companyName}”.',
  'pages.live.sellers.products.companyName.none': 'No shop name',
  'pages.live.sellers.products.flag.applyToSelected.content': '“{field}” will be set to {state} for all {count} selected products.',
  'pages.live.sellers.products.flag.on': 'on',
  'pages.live.sellers.products.flag.off': 'off',
  'pages.live.sellers.products.flag.liveOnly': 'Only for quick-registered products. Change the visibility of company mall products in Company Mall product management.',
  'pages.live.sellers.products.filter.categoryNone': 'No category',
  'pages.live.sellers.products.filter.category': 'Filter by category',
  'pages.live.sellers.products.selection.setCategory': 'Set category for selected',
  'pages.live.sellers.products.selection.clear': 'Clear selection',
  'pages.live.sellers.products.tab.simple': 'Simple products',
  'pages.live.sellers.products.tab.company': 'Company mall products',
  'pages.live.sellers.products.headerTitle.simple': 'Simple products',
  'pages.live.sellers.products.headerTitle.company': 'Company mall products',
  'pages.live.sellers.products.addCompanyProduct': 'Add company mall product',
  'pages.live.sellers.products.addCompany.selectProduct': 'Please select at least one product.',
  'pages.live.sellers.products.addCompany.registeredCount': '{count} product(s) registered for this seller.',
  'pages.live.sellers.products.addCompany.failed': 'Registration failed.',
  'pages.live.sellers.products.addCompany.partialResult': '{success} succeeded, {failed} failed ({reasons})',
  'pages.live.sellers.products.addCompany.failReason.item': '{label}: {count}',
  'pages.live.sellers.products.addCompany.failReason.ownedByOtherSeller': 'owned by another seller',
  'pages.live.sellers.products.addCompany.failReason.notFound': 'product not found',
  'pages.live.sellers.products.addCompany.failReason.createFailed': 'registration error',
  'pages.live.sellers.products.addCompany.batchHint': 'Search and select a product for each row.',
  'pages.live.sellers.products.addCompany.registerSelected': 'Register Selected ({count})',
  'pages.live.sellers.products.loadFailed': 'Failed to load product list.',
  'pages.live.sellers.products.sortBy.createdAt_desc': 'Newest first',
  'pages.live.sellers.products.sortBy.createdAt_asc': 'Oldest first',
  'pages.live.sellers.products.sortBy.updatedAt_desc': 'Recently updated',
  'pages.live.sellers.products.sortBy.updatedAt_asc': 'Least recently updated',
  'pages.live.sellers.products.filter.registeredFrom': 'Registered from',
  'pages.live.sellers.products.filter.registeredTo': 'Registered to',
  'pages.live.sellers.products.column.image': 'Image',
  'pages.live.sellers.products.column.title': 'Product name',
  'pages.live.sellers.products.column.companyName': 'Shop name',
  'pages.live.sellers.products.column.offerId': 'Offer ID',
  'pages.live.sellers.products.column.productNo': 'Product No.',
  'pages.live.sellers.products.column.userName': 'User name',
  'pages.live.sellers.products.column.userUniqueId': 'User unique ID',
  'pages.live.sellers.products.filter.userUniqueIdPlaceholder': 'Search by user unique ID',
  'pages.live.sellers.products.column.liveCode': 'Live code',
  'pages.live.sellers.products.column.registeredAt': 'Registered',
  'pages.live.sellers.products.column.salesQuantity': 'Sales qty',
  'pages.live.sellers.products.column.viewCount': 'Views',
  'pages.live.sellers.products.column.hotProduct': 'Hot product',
  'pages.live.sellers.products.column.popularProduct': 'Popular product',
  'pages.live.sellers.products.column.topFixed': 'Top Fixed',
  'pages.live.sellers.products.column.liveStatus': 'Live Status',
  'pages.live.sellers.products.column.specialPrice': 'Special price',
  'pages.live.sellers.products.column.manage': 'Actions',
  'pages.live.sellers.products.tag.hot': 'Hot',
  'pages.live.sellers.products.tag.popular': 'Popular',
  'pages.live.sellers.products.tag.special': 'Special',
  'pages.live.sellers.products.delete.title': 'Remove product',
  'pages.live.sellers.products.delete.content': 'Remove this product?',
  'pages.live.sellers.products.delete.notImplemented': 'Delete is not available yet.',
  'pages.live.sellers.products.delete.noStatus': 'No live-status entry exists for this product, it cannot be deleted from here',
  'pages.live.sellers.products.batchDelete': 'Delete selected',
  'pages.live.sellers.products.batchDelete.title': 'Delete selected products',
  'pages.live.sellers.products.batchDelete.content':
    'Remove {count} selected product(s) from this seller page. This cannot be undone.',
  'pages.live.sellers.products.batchDelete.ok': 'Delete',
  'pages.live.sellers.products.batchDelete.selectFirst': 'Select the products to delete first.',
  'pages.live.sellers.products.batchDelete.result': '{count} product(s) deleted.',
  'pages.live.sellers.products.batchDelete.resultWithFailures': '{count} deleted, {failed} failed ({reasons})',
  'pages.live.sellers.products.batchDelete.failReason.item': '{label}: {count}',
  'pages.live.sellers.products.batchDelete.failReason.notRegistered': 'not on this seller page',
  'pages.live.sellers.products.batchDelete.failReason.notFound': 'product not found',
  'pages.live.sellers.products.batchDelete.failReason.deleteFailed': 'delete error',
  'pages.live.sellers.products.copyLink.tooltip': 'Copy buy link',
  'pages.live.sellers.products.copyLink.noStatus': 'No live-status entry exists for this product, link cannot be generated',
  'pages.live.sellers.products.copyLink.success': 'Buy link copied to clipboard',
  'pages.live.sellers.products.copyLink.failed': 'Failed to create buy link',
  'pages.live.sellers.products.copyLink.empty': 'Server did not return a link',
  'pages.live.sellers.products.copyLink.manualTitle': 'Please copy the link below manually',
  'pages.live.sellers.products.batchUpdate.modalTitle': '{batch} ({count})',
  'pages.live.sellers.products.batchUpdate.field': 'Field',
  'pages.live.sellers.products.batchUpdate.value': 'Value',
  'pages.live.sellers.products.batchUpdate.field.productName': 'Product name',
  'pages.live.sellers.products.batchUpdate.productName.ko': 'Product name (Ko)',
  'pages.live.sellers.products.batchUpdate.productName.en': 'Product name (En)',
  'pages.live.sellers.products.batchUpdate.productName.zh': 'Product name (Zh)',
  'pages.live.sellers.products.batchUpdate.productName.placeholder': 'Enter product name; other languages will be auto-translated',
  'pages.live.sellers.products.batchUpdate.productName.koRequired': 'Korean product name is required',
  'pages.live.sellers.products.batchUpdate.productName.translate': 'Translate other languages from this',
  'pages.live.sellers.products.batchUpdate.field.costPrice': 'Cost (₩)',
  'pages.live.sellers.products.batchUpdate.field.costPriceCny': 'Cost (CNY)',
  'pages.live.sellers.products.batchUpdate.field.salePrice': 'Sale price (₩)',
  'pages.live.sellers.products.batchUpdate.field.tagPrice': 'Tag price (₩)',
  'pages.live.sellers.products.batchUpdate.field.stock': 'Stock',
  'pages.live.sellers.products.batchUpdate.placeholder.amount': 'Amount',
  'pages.live.sellers.products.batchUpdate.placeholder.cny': 'Amount (CNY)',
  'pages.live.sellers.products.batchUpdate.placeholder.qty': 'Quantity',
  'pages.live.sellers.products.batchUpdate.result': '{success} product(s) have been updated.',
  'pages.live.sellers.products.batchUpdate.resultWithFailures':
    '{success} product(s) updated. ({failed} failed.)',
  'pages.live.sellers.products.simpleEdit.title': 'Quick edit',
  'pages.live.sellers.products.simpleEdit.titleWithProduct': 'Quick edit — {name}',
  'pages.live.sellers.products.simpleEdit.productInfo': 'Product info',
  'pages.live.sellers.products.simpleEdit.productNo': 'Product number',
  'pages.live.sellers.products.simpleEdit.productNoPlaceholder': 'Enter product number',
  'pages.live.sellers.products.simpleEdit.companyName': 'Shop name',
  'pages.live.sellers.products.simpleEdit.okSave': 'Save changes',
  'pages.live.sellers.products.simpleEdit.attr': 'Attributes',
  'pages.live.sellers.products.simpleEdit.attrColorSize': 'Color / size',
  'pages.live.sellers.products.simpleEdit.addColor': 'Add color',
  'pages.live.sellers.products.simpleEdit.addSize': 'Add size',
  'pages.live.sellers.products.simpleEdit.colorPlaceholder': 'Black / White …',
  'pages.live.sellers.products.simpleEdit.sizePlaceholder': 'S / M / L / XL …',
  'pages.live.sellers.products.simpleEdit.attrNamePlaceholder': 'Attribute name',
  'pages.live.sellers.products.simpleEdit.addValuesPlaceholder': 'Add {name}',
  'pages.live.sellers.products.simpleEdit.addValuesDefaultName': 'values',
  'pages.live.sellers.products.simpleEdit.confirmAdd': 'Add combination',
  'pages.live.sellers.products.simpleEdit.addAttr': 'Add attribute',
  'pages.live.sellers.products.simpleEdit.table.emptyText': 'Add a color and/or size.',
  'pages.live.sellers.products.simpleEdit.column.image': 'Image',
  'pages.live.sellers.products.simpleEdit.column.attrs': 'Attributes',
  'pages.live.sellers.products.simpleEdit.column.costPrice': 'Cost (KRW)',
  'pages.live.sellers.products.simpleEdit.column.costPriceCny': 'Cost (CNY)',
  'pages.live.sellers.products.simpleEdit.column.salePrice': 'Sale price',
  'pages.live.sellers.products.simpleEdit.column.tagPrice': 'Tag price',
  'pages.live.sellers.products.simpleEdit.column.stock': 'Stock',
  'pages.live.sellers.products.simpleEdit.column.delete': 'Delete',
  'pages.live.sellers.products.simpleEdit.bulkTitleSelected': 'Bulk edit (selected: {count})',
  'pages.live.sellers.products.simpleEdit.bulkTitleAll': 'Bulk edit (all rows)',
  'pages.live.sellers.products.simpleEdit.bulkField.costPrice': 'Cost',
  'pages.live.sellers.products.simpleEdit.bulkField.costPriceCny': 'Cost (CNY)',
  'pages.live.sellers.products.simpleEdit.bulkField.salePrice': 'Sale price',
  'pages.live.sellers.products.simpleEdit.bulkField.tagPrice': 'Tag price',
  'pages.live.sellers.products.simpleEdit.bulkField.stock': 'Stock',
  'pages.live.sellers.products.simpleEdit.bulkField.imageUrl': 'Image',
  'pages.live.sellers.products.simpleEdit.bulkImagePlaceholder': 'Image URL',
  'pages.live.sellers.products.simpleEdit.bulkValuePlaceholder': 'Value',
  'pages.live.sellers.products.simpleEdit.bulkApply': 'Apply to rows',
  'pages.live.sellers.products.simpleEdit.clearSelection': 'Clear selection',
  'pages.live.sellers.products.simpleEdit.imageSwapTitle': 'Replace image',
  'pages.live.sellers.products.simpleEdit.imageSwapUrlPlaceholder': 'Enter image URL',
  'pages.live.sellers.products.simpleEdit.imageSwapNoPreview': 'No preview',
  'pages.live.sellers.products.simpleEdit.gallery.label': 'Product images ({count}/{max})',
  'pages.live.sellers.products.simpleEdit.gallery.required': 'Keep at least one product image.',
  'pages.live.sellers.products.simpleEdit.coverRemovePending': 'The cover image will be removed when you save.',
  'pages.live.sellers.products.simpleEdit.coverRemoveUndo': 'Undo',
  'pages.live.sellers.products.simpleEdit.coverRemoveFailed': 'Failed to remove the cover image. Other changes were saved.',
  'pages.productGallery.main': 'Main',
  'pages.productGallery.view': 'View full size',
  'pages.productGallery.replace': 'Replace image',
  'pages.productGallery.remove': 'Remove',
  'pages.productGallery.add': 'Add image',
  'pages.productGallery.hint': 'First image is the main image · drag to reorder',
  'pages.productGallery.limit': 'You can upload up to {max} images.',
  'pages.productGallery.notImage': 'Only image files can be uploaded.',
  'pages.productGallery.uploadFailed': 'Image upload failed.',
  'pages.productGallery.cover': 'Cover',
  'pages.productGallery.coverHint':
    'Cover (landing image): uploaded in Frontend page settings. It is shown before the main image as the first image on the product page and on product cards. Remove it to use the main image again.',
  'pages.live.sellers.products.simpleEdit.noProductInfo': 'Product data is missing. Please open again.',
  'pages.live.sellers.products.simpleEdit.noSkus': 'There are no SKUs to save.',
  'pages.live.sellers.products.simpleEdit.saveSuccess': 'Product updated.',
  'pages.live.sellers.products.simpleEdit.saveFailed': 'Failed to update product.',
  'pages.live.sellers.products.simpleEdit.loadFailed': 'Failed to load product.',
  'pages.live.sellers.products.simpleEdit.colorOrSizeRequired': 'Enter a color and/or size.',
  'pages.live.sellers.products.simpleEdit.bulkValueRequired': 'Please enter a value.',
  'pages.live.sellers.products.simpleEdit.bulkAppliedAll': 'Bulk changes applied to all rows.',
  'pages.live.sellers.products.simpleEdit.bulkAppliedSelected': 'Bulk changes applied to {count} selected row(s).',
  'pages.live.sellers.register.nicknameRequired': 'Please enter nickname',
  'pages.live.sellers.register.phone': 'Contact',
  'pages.live.sellers.register.phonePlaceholder': '010-1234-5678',
  'pages.live.sellers.register.platforms': 'Platforms',
  'pages.live.sellers.register.instagram': 'Instagram @',
  'pages.live.sellers.register.tiktok': 'TikTok @',
  'pages.live.sellers.register.youtube': 'YouTube @',
  'pages.live.sellers.register.usernamePlaceholder': 'username',
  'pages.live.sellers.register.channelPlaceholder': 'channel',
  'pages.live.sellers.register.submit': 'Register Seller',
  'pages.live.sellers.register.cancel': 'Cancel',
  'pages.live.sellers.register.success': 'Seller registered successfully',
  'pages.live.sellers.register.failed': 'Failed to register seller',
  'pages.live.sellers.register.selectUserFirst': 'Please select a user',
  'pages.live.sellers.register.userInfo': 'user: {userId} | {email}',
  'pages.live.sellers.register.joinDate': 'Joined: {date} | Orders: {count} times',
  'pages.live.sellers.register.searchFailed': 'Failed to search users',
  
  // Live Seller Detail
  'pages.live.sellers.detail.title': 'Seller Detail: {name}',
  'pages.live.sellers.detail.back': 'Back',
  'pages.live.sellers.detail.list': 'List',
  'pages.live.sellers.detail.basicInfo': 'Basic Information',
  'pages.live.sellers.detail.name': 'Name',
  'pages.live.sellers.detail.contact': 'Contact',
  'pages.live.sellers.detail.uid': 'Member ID',
  'pages.live.sellers.detail.nickname': 'Nickname',
  'pages.live.sellers.detail.userNumber': 'Number',
  'pages.live.sellers.detail.joinDate': 'Join Date',
  'pages.live.sellers.detail.orderCount': 'Order Count',
  'pages.live.sellers.detail.platforms': 'Platforms',
  'pages.live.sellers.detail.status': 'Status',
  'pages.live.sellers.detail.totalLiveCount': 'Total Live Count',
  'pages.live.sellers.detail.top10Rank': 'TOP10 Rank',
  'pages.live.sellers.detail.popularSeller': 'Popular Seller',
  'pages.live.sellers.detail.popular': '🔥 Popular',
  'pages.live.sellers.detail.popularInfo': '🔥 ({count} times in 30 days)',
  'pages.live.sellers.detail.pointSeller': 'Point Seller',
  'pages.live.sellers.detail.pointSellerLabel': '⭐ Point Seller',
  'pages.live.sellers.detail.notFound': 'Seller information not found',
  'pages.live.sellers.detail.loadFailed': 'Failed to load seller information',
  'pages.live.sellers.detail.times': '{count} times',
  'pages.live.sellers.detail.rank': 'Rank {rank}',
  'pages.live.sellers.userId': 'User ID',
  'pages.live.sellers.sellerId': 'Seller ID',
  'pages.live.sellers.name': 'SellerName',
  'pages.live.sellers.recommender': 'Recommender',
  'pages.live.sellers.team': 'Team',
  'pages.live.sellers.follower': 'Follower',
  'pages.live.sellers.salesAmount': 'Sales Amount',
  'pages.live.sellers.salesCount': 'Sales Count',
  'pages.live.sellers.rebate': 'Rebate',
  'pages.live.sellers.refundAmount': 'Refund Amount',
  'pages.live.sellers.rebateDeduction': 'Rebate Deduction',
  'pages.live.sellers.liveStatus': 'Live Status',
  'pages.live.sellers.liveStatus.live': 'Live',
  'pages.live.sellers.liveStatus.idle': 'Idle',
  'pages.live.sellers.homepage': 'Homepage',
  'pages.live.sellers.homepageLink': 'Link',
  'pages.live.sellers.sellerMailbox': 'Seller mailbox',
  'pages.live.sellers.sellerNickname': 'Seller nickname',
  'pages.live.sellers.rebateAccrued': 'Rebate accrued',
  'pages.live.sellers.rebateDeducted': 'Rebate deducted',
  'pages.live.sellers.marginAmount': 'Margin Amount (KRW)',
  'pages.live.sellers.deposit': 'Deposit',
  'pages.live.sellers.livePage': 'Live page',
  'pages.live.sellers.listSearchPlaceholder': 'Search mailbox or User ID',
  'pages.live.sellers.liveLinkCopy': 'Copy live link',
  'pages.live.sellers.liveLinkCopied': 'Live link copied.',
  'pages.live.sellers.liveLinkCopyFailed': 'Could not copy link.',

  // Live Rebate Settings
  'pages.live.rebate.title': 'Live Rebate Settings',
  'pages.live.rebate.liveTeamName': 'Live Team Name',
  'pages.live.rebate.memberId': 'Member ID',
  'pages.live.rebate.sellerId': 'Seller ID',
  'pages.live.rebate.sellerPercent': 'Seller %',
  'pages.live.rebate.companyPercent': 'Company %',
  'pages.live.rebate.teamPercent': 'Team %',
  'pages.live.rebate.teamRebatePercent': 'Team Rebate %',
  'pages.live.rebate.settingTimeAdmin': 'Setting Time / Admin',
  'pages.live.rebate.actions': 'Actions',
  'pages.live.rebate.setting': 'Setting',
  'pages.live.rebate.detail': 'Detail',
  'pages.live.rebate.delete': 'Delete',
  'pages.live.rebate.addRebate': 'Add Rebate',
  'pages.live.rebate.batchUpdate': 'Batch Update',
  'pages.live.rebate.selectFirst': 'Please select items first',
  'pages.live.rebate.addSuccess': 'Rebate added successfully',
  'pages.live.rebate.addFailed': 'Failed to add rebate',
  'pages.live.rebate.updateSuccess': 'Rebate updated successfully',
  'pages.live.rebate.updateFailed': 'Failed to update rebate',
  'pages.live.rebate.deleteSuccess': 'Rebate deleted successfully',
  'pages.live.rebate.deleteFailed': 'Failed to delete rebate',
  'pages.live.rebate.deleteConfirm': 'Delete Rebate',
  'pages.live.rebate.deleteContent': 'Are you sure you want to delete this rebate setting?',
  'pages.live.rebate.addModalTitle': 'Add Rebate Setting',
  'pages.live.rebate.editModalTitle': 'Edit Rebate Setting',
  'pages.live.rebate.liveTeamNameRequired': 'Please enter live team name',
  'pages.live.rebate.memberIdRequired': 'Please enter member ID',
  'pages.live.rebate.sellerIdRequired': 'Please enter seller ID',
  'pages.live.rebate.sellerPercentRequired': 'Please enter seller percentage',
  'pages.live.rebate.companyPercentRequired': 'Please enter company percentage',
  'pages.live.rebate.teamPercentRequired': 'Please enter team percentage',
  'pages.live.rebate.teamRebatePercentRequired': 'Please enter team rebate percentage',
  'pages.live.rebate.loadFailed': 'Failed to load rebate settings',
  'pages.live.rebate.selectAtLeastTwo': 'Please select at least 2 items',
  'pages.live.rebate.batchSetting': 'Batch Setting',
  'pages.live.rebate.batchUpdateTitle': 'Batch Update Percentages',
  'pages.live.rebate.selectedItems': 'items selected',
  'pages.live.rebate.applySetting': 'Apply Setting',
  'pages.live.rebate.cancel': 'Cancel',
  'pages.live.rebate.batchUpdateSuccess': 'Batch update completed successfully',
  'pages.live.rebate.batchUpdateFailed': 'Batch update failed',
  'pages.live.rebate.searchPlaceholder': 'Search by live team name, seller ID, or member ID',
  'pages.live.rebate.levelDetailTitle': 'Live Team List',
  'pages.live.rebate.levelDetail.column.teamName': 'Team Name',
  'pages.live.rebate.levelDetail.column.depth': 'Level',
  'pages.live.rebate.levelDetail.column.userUniqueId': 'Seller Mailbox',
  'pages.live.rebate.levelDetail.column.userId': 'User ID',
  'pages.live.rebate.levelDetail.column.userName': 'Seller NickName',
  'pages.live.rebate.levelDetail.column.subordinateSellerCount': 'Subordinate Team Members',
  'pages.live.rebate.levelDetail.column.salesAmountKrw': 'Team Sales Amount',
  'pages.live.rebate.levelDetail.column.ownSalesAmountKrw': 'Own Sales Amount',
  'pages.live.rebate.levelDetail.column.subordinateSalesAmountKrw': 'Subordinate Sales Amount',
  'pages.live.rebate.levelDetail.split.own': 'Own',
  'pages.live.rebate.levelDetail.split.team': 'Team',
  'pages.live.rebate.levelDetail.column.marginAmountKrw': 'Margin Amount (KRW)',
  'pages.live.rebate.levelDetail.column.salesQuantity': 'Sales Quantity',
  'pages.live.rebate.levelDetail.column.refundAmountKrw': 'Refund Amount (KRW)',
  'pages.live.rebate.levelDetail.column.refundQuantity': 'Refund Quantity',
  'pages.live.rebate.levelDetail.column.teamRebateAccruedKrw': 'Team Rebate Accrued (KRW)',
  'pages.live.rebate.levelDetail.column.teamRebateDeductedKrw': 'Team Rebate Deducted (KRW)',
  'pages.live.rebate.levelDetail.column.rebateAccruedKrw': 'Rebate Accrued (KRW)',
  'pages.live.rebate.levelDetail.column.rebateGrossAccruedKrw': 'Gross Accrued Before Clawback (KRW)',
  'pages.live.rebate.levelDetail.column.rebateDeductedKrw': 'Rebate Deducted (KRW)',
  'pages.live.rebate.levelDetail.column.teamRebateAfterRefundKrw': 'Team Rebate After Refund (KRW)',
  'pages.live.rebate.levelDetail.column.platformAccruedKrw': 'Company Accrued (KRW)',
  'pages.live.rebate.levelDetail.column.platformDeductedKrw': 'Company Deducted (KRW)',
  'pages.live.rebate.levelDetail.column.platformAfterRefundKrw': 'Company After Refund (KRW)',
  'pages.live.rebate.levelDetail.column.level': 'Level',
  'pages.live.rebate.levelDetail.column.mailbox': 'Mailbox',
  'pages.live.rebate.levelDetail.column.teamMemberCount': 'Team Member Count',
  'pages.live.rebate.levelDetail.column.sellingPrice': 'Sales Price',
  'pages.live.rebate.levelDetail.column.sellingQuantity': 'Sales Number',
  'pages.live.rebate.levelDetail.column.companyProfit': 'Company Profit',
  'pages.live.rebate.levelDetail.column.refundPrice': 'Refund Price',
  'pages.live.rebate.levelDetail.column.refundAmount': 'Refund Amount',
  'pages.live.rebate.levelDetail.column.remountRevenue': 'Company Revenue',
  'pages.live.rebate.levelDetail.column.action': 'Action',
  'pages.live.rebate.levelDetail.searchLabel': 'Search:',
  'pages.live.rebate.levelDetail.searchPlaceholder': 'Search by seller ID, user ID, or user name...',
  'pages.live.rebate.levelDetail.searchButton': 'Search',
  'pages.live.rebate.levelDetail.resetButton': 'Reset',
  'pages.live.rebate.levelDetail.reloadButton': 'Reload',
  'pages.live.rebate.levelDetail.detailButton': 'Detail',
  'pages.live.rebate.levelDetail.loadError': 'Failed to load live rebate detail data',
  'pages.live.rebate.levelDetail.level1': 'Level 1',
  'pages.live.rebate.levelDetail.level2': 'Level 2',
  'pages.live.rebate.levelDetail.level3': 'Level 3',
  'pages.live.rebate.levelDetail.level4': 'Level 4',
  'pages.live.rebate.searchLabel': 'Search',
  'pages.live.rebate.search': 'Search',
  'pages.live.rebate.reset': 'Reset',
  'pages.live.rebate.teamLead': 'Team Lead',
  'pages.live.rebate.teamLeadId': 'Team Lead ID',
  'pages.live.rebate.teamLeadIdRequired': 'Please enter the team lead ID',
  'pages.live.rebate.teamInternalSelfPercent': 'Team Internal Self %',
  'pages.live.rebate.teamInternalSelfPercentRequired': 'Please enter the team internal self percent',
  'pages.live.rebate.teamInternalUplinePercent': 'Team Internal Upline %',
  'pages.live.rebate.teamRebate': 'Team Rebate',
  'pages.live.rebate.memberSettings': 'Member Settings',
  'pages.live.rebate.memberSettingsTitle': 'Per-seller Rebate Settings',
  'pages.live.rebate.memberSettingsHint': 'Set individual seller rebate percents. Saved values override the team settings for that seller; sellers marked "Not set" keep using the team settings.',
  'pages.live.rebate.memberSource': 'Source',
  'pages.live.rebate.memberSourceTeamCopy': 'Copied from team',
  'pages.live.rebate.memberSourceAdmin': 'Individually set',
  'pages.live.rebate.memberSourceNone': 'Not set (team settings apply)',
  'pages.live.rebate.memberSourceTeamConfig': 'Team settings',
  'pages.live.rebate.memberSelfPercent': 'Self %',
  'pages.live.rebate.memberSave': 'Save',
  'pages.live.rebate.memberSaveSuccess': 'Seller rebate settings saved',
  'pages.live.rebate.memberSaveFailed': 'Failed to save seller rebate settings',
  'pages.live.rebate.memberLoadFailed': 'Failed to load team members',
  'pages.live.rebate.marginSumError': 'Seller + Company + Team % must sum to 100',
  'pages.live.rebate.teamLeadTag': 'Team Lead',
  'pages.live.rebate.teamInternalUplinePercentRequired': 'Please enter the team internal upline percent',
  'pages.live.rebate.configuredAt': 'Configured At',
  'pages.live.rebate.configuredAtRequired': 'Please select the configured time',

  // Live Products
  'pages.live.products.title': 'Live Product Management',
  'pages.live.products.bulkUpdateTitle': 'Bulk Update Live Products',
  'pages.live.products.bulkUpdateOnlineViews': 'Bulk Update Online Views',
  'pages.live.products.bulkUpdateReviewScore': 'Bulk Update Review Score',
  'pages.live.products.bulkUpdateReviewNumbers': 'Bulk Update Review Numbers',
  'pages.live.products.bulkUpdateLivePeriods': 'Bulk Update Live Periods',
  'pages.live.products.bulkUpdateIsHot': 'Bulk Update Hot Status',
  'pages.live.products.bulkUpdateDescription': 'This will update {count} selected item(s)',
  'pages.live.products.selectedCount': 'Selected {count} items',
  'pages.live.products.clearSelection': 'Clear Selection',
  'pages.live.products.add': 'Add New Live Product',
  'pages.live.products.addTitle': 'Add New Live Product',
  'pages.live.products.editTitle': 'Edit Live Product',
  'pages.live.products.quickEdit': 'Quick Edit',
  'pages.live.products.productNumber': 'Product Number',
  'pages.live.products.offerId': 'OfferId',
  'pages.live.products.productName': 'Product Name',
  'pages.live.products.productInformation': 'Product Information',
  'pages.live.products.image': 'Image',
  'pages.live.products.video': 'Video',
  'pages.live.products.liveDateTime': 'Live Date/Time',
  'pages.live.products.liveTitle': 'Live Title',
  'pages.live.products.onlineViews': 'Online Views',
  'pages.live.products.itemsSold': 'Items Sold',
  'pages.live.products.reviewScore': 'Review Score',
  'pages.live.products.reviewNumbers': 'Review Numbers',
  'pages.live.products.videoStatus.uploaded': '[Uploaded]',
  'pages.live.products.videoStatus.notUploaded': '[Not Uploaded]',
  'pages.live.products.status': 'Status',
  'pages.live.products.status.scheduled': '○ Scheduled',
  'pages.live.products.status.live': '● Live',
  'pages.live.products.status.completed': '○ Completed',
  'pages.live.products.status.cancelled': '○ Cancelled',
  'pages.live.products.isHot': 'Hot Product',
  'pages.live.products.setHot': 'Set as Hot',
  'pages.live.products.removeHot': 'Remove Hot',
  'pages.live.products.updatedAt': 'Updated At',
  'pages.live.products.manage': 'Manage',
  'pages.live.products.edit': 'Edit',
  'pages.live.products.delete': 'Delete',
  'pages.live.products.deleteConfirm': 'Delete Product',
  'pages.live.products.deleteContent': 'Are you sure you want to delete this live product?',
  'pages.live.products.deleteSuccess': 'Product deleted successfully',
  'pages.live.products.deleteFailed': 'Failed to delete product',
  'pages.live.products.loadFailed': 'Failed to load product list',
  'pages.live.products.createSuccess': 'Product registered successfully',
  'pages.live.products.updateSuccess': 'Product updated successfully',
  'pages.live.products.saveFailed': 'Operation failed',
  'pages.live.products.bulkUpdate.liveTitleRequired': 'Please enter live title',
  'pages.live.products.bulkUpdate.onlineViewsRequired': 'Please enter online views',
  'pages.live.products.bulkUpdate.reviewScoreRequired': 'Please enter review score',
  'pages.live.products.bulkUpdate.reviewNumbersRequired': 'Please enter review numbers',
  'pages.live.products.bulkUpdate.isHotRequired': 'Please select hot status',
  
  // Live Product Form
  'pages.live.products.form.product': 'Product',
  'pages.live.products.form.productPlaceholder': 'Search by product number or name',
  'pages.live.products.form.productRequired': 'Please select a product',
  'pages.live.products.form.searchFailed': 'Failed to search products',
  'pages.live.products.form.productNumber': 'Product Number',
  'pages.live.products.form.productNumberPlaceholder': 'P00123',
  'pages.live.products.form.productNumberRequired': 'Please enter product number',
  'pages.live.products.form.liveDate': 'Live Date',
  'pages.live.products.form.liveDatePeriod': 'Live Date Period',
  'pages.live.products.form.liveDateRequired': 'Please select date',
  'pages.live.products.form.liveLink': 'Live Link',
  'pages.live.products.form.liveLinkPlaceholder': 'Enter URL for live broadcast',
  'pages.live.products.form.startTime': 'Start Time',
  'pages.live.products.form.startTimeRequired': 'Please select start time',
  'pages.live.products.form.endTime': 'End Time',
  'pages.live.products.form.title': 'Live Title',
  'pages.live.products.form.titlePlaceholder': 'New sneakers special offer',
  'pages.live.products.form.titleRequired': 'Please enter title',
  'pages.live.products.form.onlineViews': 'Online Views',
  'pages.live.products.form.onlineViewsPlaceholder': 'Enter online views',
  'pages.live.products.form.itemsSold': 'Items Sold',
  'pages.live.products.form.itemsSoldPlaceholder': 'Enter items sold',
  'pages.live.products.form.reviewScore': 'Review Score',
  'pages.live.products.form.reviewScorePlaceholder': 'Enter review score (0-5)',
  'pages.live.products.form.reviewNumbers': 'Review Numbers',
  'pages.live.products.form.reviewNumbersPlaceholder': 'Enter review numbers',
  'pages.live.products.form.image': 'Image',
  'pages.live.products.form.uploadImage': 'Upload Image',
  'pages.live.products.form.videoUrl': 'Video',
  'pages.live.products.form.uploadVideo': 'Upload Video',
  'pages.live.products.form.uploadMedia': 'Upload Video/Image',
  'pages.live.products.form.videoUrlPlaceholder': 'https://...',
  'pages.live.products.form.imageUrl': 'Image URL',
  'pages.live.products.form.imageUrlPlaceholder': 'https://...',
  'pages.live.products.form.status': 'Status',
  'pages.live.products.form.statusRequired': 'Please select status',
  'pages.live.products.form.submit': 'Submit',
  'pages.live.products.form.cancel': 'Cancel',

  // Live Page Settings
  'pages.live.pageSettings.title': 'Live Page Settings',
  'pages.live.pageSettings.visible': 'Visible',
  'pages.live.pageSettings.hidden': 'Hidden',
  'pages.live.pageSettings.col.actions': 'Actions',
  'pages.live.pageSettings.schedules.tab': 'Live Schedules',
  'pages.live.pageSettings.schedules.add': 'Add Schedule',
  'pages.live.pageSettings.schedules.addTitle': 'Add Live Schedule',
  'pages.live.pageSettings.schedules.editTitle': 'Edit Live Schedule',
  'pages.live.pageSettings.schedules.col.title': 'Title',
  'pages.live.pageSettings.schedules.col.seller': 'Seller',
  'pages.live.pageSettings.schedules.col.time': 'Schedule Time',
  'pages.live.pageSettings.schedules.col.startTime': 'Start Time',
  'pages.live.pageSettings.schedules.col.endTime': 'End Time',
  'pages.live.pageSettings.schedules.endAfterStart': 'End time must be after start time',
  'pages.live.pageSettings.schedules.col.visible': 'Visible',
  'pages.live.pageSettings.schedules.sellerPlaceholder': 'Search seller',
  'pages.live.pageSettings.schedules.created': 'Live schedule created',
  'pages.live.pageSettings.schedules.updated': 'Live schedule updated',
  'pages.live.pageSettings.schedules.deleted': 'Live schedule deleted',
  'pages.live.pageSettings.schedules.saveFailed': 'Failed to save schedule',
  'pages.live.pageSettings.schedules.deleteFailed': 'Failed to delete schedule',
  'pages.live.pageSettings.schedules.deleteConfirm': 'Delete this live schedule?',
  'pages.live.pageSettings.reels.tab': 'Live Reels',
  'pages.live.sections.tab': 'Sections',
  'pages.live.sections.add': 'Add section',
  'pages.live.sections.addTitle': 'Add section',
  'pages.live.sections.editTitle': 'Edit section',
  'pages.live.sections.saved': 'Section saved',
  'pages.live.sections.saveFailed': 'Failed to save the section',
  'pages.live.sections.loadFailed': 'Failed to load sections',
  'pages.live.sections.reordered': 'Order updated',
  'pages.live.sections.reorderFailed': 'Failed to update the order',
  'pages.live.sections.deleted': 'Section deleted',
  'pages.live.sections.deleteFailed': 'Failed to delete the section',
  'pages.live.sections.deleteConfirm': 'Delete this section?',
  'pages.live.sections.dragHint': 'Drag the handle to reorder',
  'pages.live.sections.autoOnlyHint': 'This type pulls from data managed elsewhere. Hand-picking is available on product, seller, banner, time sale, coupon and ticker sections.',
  'pages.live.sections.column.title': 'Section',
  'pages.live.sections.column.untitled': '(untitled)',
  'pages.live.sections.column.type': 'Type',
  'pages.live.sections.column.source': 'Contents',
  'pages.live.sections.column.items': 'Items',
  'pages.live.sections.column.itemCount': '{count} picked',
  'pages.live.sections.column.limitCount': 'up to {count}',
  'pages.live.sections.column.device': 'Device',
  'pages.live.sections.column.visible': 'Visible',
  'pages.live.sections.group.basic': 'Basics',
  'pages.live.sections.group.content': 'Contents',
  'pages.live.sections.group.style': 'Presentation',
  'pages.live.sections.field.key': 'Section key',
  'pages.live.sections.field.keyHint': 'Lowercase letters, digits and hyphens only (e.g. today-live-pick)',
  'pages.live.sections.field.type': 'Type',
  'pages.live.sections.field.title': 'Title',
  'pages.live.sections.field.subtitle': 'Subtitle',
  'pages.live.sections.field.layout': 'Layout',
  'pages.live.sections.field.device': 'Device',
  'pages.live.sections.field.itemLimit': 'Item count',
  'pages.live.sections.field.isVisible': 'Visible',
  'pages.live.sections.field.moreLink': 'See-more link',
  'pages.live.sections.field.period': 'Exposure window',
  'pages.live.sections.field.periodHint': 'Leave empty to show it indefinitely',
  'pages.live.sections.field.sourceMode': 'Contents',
  'pages.live.sections.field.backgroundColor': 'Background',
  'pages.live.sections.field.fullBleed': 'Full-bleed width',
  'pages.live.sections.sourceMode.auto': 'By rule',
  'pages.live.sections.sourceMode.manual': 'Hand-picked',
  'pages.live.sections.type.heroLive': 'Featured live',
  'pages.live.sections.type.liveNow': 'Live now',
  'pages.live.sections.type.schedule': 'Live schedule',
  'pages.live.sections.type.reels': 'Live reels',
  'pages.live.sections.type.sellerRail': 'Seller rail',
  'pages.live.sections.type.productRail': 'Product rail',
  'pages.live.sections.type.productGrid': 'Product grid',
  'pages.live.sections.type.ranking': 'Ranking',
  'pages.live.sections.type.categoryTabs': 'Category tabs',
  'pages.live.sections.type.banner': 'Banner',
  'pages.live.sections.type.eventTicker': 'Event ticker',
  'pages.live.sections.type.timeSale': 'Time sale',
  'pages.live.sections.type.coupon': 'Coupon',
  'pages.live.sections.type.ticker': 'Notice ticker',
  'pages.live.sections.layout.hero': 'Hero',
  'pages.live.sections.layout.rail': 'Rail',
  'pages.live.sections.layout.grid': 'Grid',
  'pages.live.sections.layout.list': 'List',
  'pages.live.sections.layout.banner': 'Banner',
  'pages.live.sections.device.all': 'All',
  'pages.live.sections.device.pc': 'Desktop',
  'pages.live.sections.device.mobile': 'Mobile',
  'pages.live.sections.filter.productFlags': 'Product flags',
  'pages.live.sections.filter.sellerFlags': 'Seller flags',
  'pages.live.sections.filter.categories': 'Categories',
  'pages.live.sections.filter.categoryTabsHint': 'Leave empty to show every active top-level category as a tab',
  'pages.live.sections.filter.simpleAutoHint':
    'This type fills itself from what is running — only the item count and sort order apply.',
  'pages.live.sections.filter.liveState': 'Live state',
  'pages.live.sections.filter.sortBy': 'Sort',
  'pages.live.sections.filter.flagPopular': 'Popular',
  'pages.live.sections.filter.flagPoint': 'Point',
  'pages.live.sections.filter.sortRank': 'Rank',
  'pages.live.sections.filter.flag_isPopular': 'Popular',
  'pages.live.sections.filter.flag_isFeatured': 'Featured',
  'pages.live.sections.filter.flag_isBestSeller': 'Best seller',
  'pages.live.sections.filter.flag_isNewArrival': 'New arrival',
  'pages.live.sections.filter.flag_isImportant': 'Pinned',
  'pages.live.sections.filter.flag_isPoint': 'Point partner',
  'pages.live.sections.filter.liveState_all': 'All',
  'pages.live.sections.filter.liveState_live': 'On air',
  'pages.live.sections.filter.liveState_scheduled': 'Scheduled',
  'pages.live.sections.filter.liveState_recent': 'Recently ended',
  'pages.live.sections.filter.sortBy_recent': 'Newest',
  'pages.live.sections.filter.sortBy_sold': 'Best selling',
  'pages.live.sections.filter.sortBy_price_asc': 'Price: low to high',
  'pages.live.sections.filter.sortBy_price_desc': 'Price: high to low',
  'pages.live.sections.filter.sortBy_rank': 'Rank',
  'pages.live.sections.filter.sortBy_views': 'Views',
  'pages.live.sections.items.remove': 'Remove',
  'pages.live.sections.items.bannerRow': 'Banner {index}',
  'pages.live.sections.items.imagePc': 'Desktop image',
  'pages.live.sections.items.imageMobile': 'Mobile image',
  'pages.live.sections.items.linkUrl': 'Link',
  'pages.live.sections.items.caption': 'Caption',
  'pages.live.sections.items.addProduct': 'Pick products',
  'pages.live.sections.items.addSeller': 'Pick sellers',
  'pages.live.sections.items.addBanner': 'Add banner',
  'pages.live.sections.items.addTimeSale': 'Pick time sales',
  'pages.live.sections.items.addCoupon': 'Pick coupons',
  'pages.live.sections.items.addMetric': 'Add line',
  'pages.live.sections.items.metricRow': 'Line {index}',
  'pages.live.sections.items.metricCaption': 'Ticker text',
  'pages.live.sections.items.metricLink': 'Link',
  'pages.live.sections.items.timeSaleHidden': 'hidden',
  'pages.live.sections.items.metricCaptionRequired': 'Ticker line {index} needs text in at least one language',
  'pages.live.sections.items.count': '{count} / {max}',
  'pages.live.sections.items.empty': 'Nothing picked yet',
  'pages.live.sections.picker.loadFailed': 'Failed to load the list',
  'pages.live.sections.picker.productTitle': 'Pick live products',
  'pages.live.sections.picker.sellerTitle': 'Pick live sellers',
  'pages.live.sections.picker.confirm': 'Add',
  'pages.live.sections.picker.searchPlaceholder': 'Search by name or product no.',
  'pages.live.sections.picker.sellerSearchPlaceholder': 'Search by seller name',
  'pages.live.sections.picker.image': 'Image',
  'pages.live.sections.picker.product': 'Product',
  'pages.live.sections.picker.productNo': 'Product no.',
  'pages.live.sections.picker.uniqueNo': 'Unique no.',
  'pages.live.sections.picker.seller': 'Seller',
  'pages.live.sections.picker.sellerId': 'Seller ID',
  'pages.live.sections.picker.sellerFlags': 'Flags',
  // Live Time Sales
  'pages.live.timeSales.tab': 'Time Sales',
  'pages.live.timeSales.add': 'Add Time Sale',
  'pages.live.timeSales.addTitle': 'Add Time Sale',
  'pages.live.timeSales.editTitle': 'Edit Time Sale',
  'pages.live.timeSales.dragHint': 'Drag the handle to reorder',
  'pages.live.timeSales.loadFailed': 'Failed to load time sales',
  'pages.live.timeSales.saved': 'Saved',
  'pages.live.timeSales.saveFailed': 'Failed to save',
  'pages.live.timeSales.deleteConfirm': 'Delete this time sale?',
  'pages.live.timeSales.deleted': 'Deleted',
  'pages.live.timeSales.deleteFailed': 'Failed to delete',
  'pages.live.timeSales.reordered': 'Order updated',
  'pages.live.timeSales.reorderFailed': 'Failed to update the order',
  'pages.live.timeSales.column.product': 'Product',
  'pages.live.timeSales.column.title': 'Sale title',
  'pages.live.timeSales.column.period': 'Period',
  'pages.live.timeSales.column.progress': 'Sold / target',
  'pages.live.timeSales.column.salePrice': 'Sale price',
  'pages.live.timeSales.column.visible': 'Visible',
  'pages.live.timeSales.column.untitled': 'Untitled',
  'pages.live.timeSales.status.scheduled': 'Scheduled',
  'pages.live.timeSales.status.running': 'Running',
  'pages.live.timeSales.status.ended': 'Ended',
  'pages.live.timeSales.progress.text': '{sold} / {target}',
  'pages.live.timeSales.salePrice.useProductPrice': 'Uses the product price',
  'pages.live.timeSales.form.product': 'Product',
  'pages.live.timeSales.form.productRequired': 'Please choose a product',
  'pages.live.timeSales.form.pickProduct': 'Choose product',
  'pages.live.timeSales.form.changeProduct': 'Change product',
  'pages.live.timeSales.form.pickOneOnly': 'A time sale holds one product. The first pick was applied',
  'pages.live.timeSales.form.noProduct': 'No product selected',
  'pages.live.timeSales.form.title': 'Sale title',
  'pages.live.timeSales.form.titlePlaceholder': 'e.g. Today only',
  'pages.live.timeSales.form.period': 'Sale period',
  'pages.live.timeSales.form.periodRequired': 'Enter both the start and the end time',
  'pages.live.timeSales.form.periodInvalid': 'The end time must be later than the start time',
  'pages.live.timeSales.form.targetQuantity': 'Target quantity',
  'pages.live.timeSales.form.soldQuantity': 'Sold quantity',
  'pages.live.timeSales.form.salePrice': 'Sale price (KRW)',
  'pages.live.timeSales.form.salePriceHint': 'Leave empty to use the product price',
  'pages.live.timeSales.form.isVisible': 'Visible',
  'pages.live.pageSettings.reels.add': 'Add Reel',
  'pages.live.pageSettings.reels.addTitle': 'Add Live Reel',
  'pages.live.pageSettings.reels.editTitle': 'Edit Live Reel',
  'pages.live.pageSettings.reels.col.cover': 'Cover',
  'pages.live.pageSettings.reels.col.title': 'Title',
  'pages.live.pageSettings.reels.col.seller': 'Seller',
  'pages.live.pageSettings.reels.col.watchUserCount': 'Viewers',
  'pages.live.pageSettings.reels.col.scheduledDate': 'Date',
  'pages.live.pageSettings.reels.col.time': 'Time',
  'pages.live.pageSettings.reels.col.video': 'Video',
  'pages.live.pageSettings.reels.col.showOnFrontend': 'On Frontend',
  'pages.live.pageSettings.reels.timeFrom': 'From',
  'pages.live.pageSettings.reels.timeTo': 'To',
  'pages.live.pageSettings.reels.imageSection': 'Cover Image',
  'pages.live.pageSettings.reels.videoSection': 'Video',
  'pages.live.pageSettings.reels.imageUrl': 'Image URL',
  'pages.live.pageSettings.reels.videoUrl': 'Video URL',
  'pages.live.pageSettings.reels.uploadImage': 'Upload Image',
  'pages.live.pageSettings.reels.uploadVideo': 'Upload Video',
  'pages.live.pageSettings.reels.clearFile': 'Clear uploaded file',
  'pages.live.pageSettings.reels.open': 'Open',
  'pages.live.pageSettings.reels.created': 'Reel created',
  'pages.live.pageSettings.reels.updated': 'Reel updated',
  'pages.live.pageSettings.reels.deleted': 'Reel deleted',
  'pages.live.pageSettings.reels.saveFailed': 'Failed to save reel',
  'pages.live.pageSettings.reels.deleteFailed': 'Failed to delete reel',
  'pages.live.pageSettings.reels.deleteConfirm': 'Delete this reel?',

  // ── [Lane J5] M2 §5-2 / §5-3 reel & time-sale card copy and product link ──
  'pages.live.pageSettings.reels.col.cardText': 'Card copy',
  'pages.live.pageSettings.reels.col.product': 'Linked product',
  'pages.live.pageSettings.reels.cardSection': 'Card copy & linked product',
  'pages.live.pageSettings.reels.product': 'Linked product',
  'pages.live.pageSettings.reels.productHint':
    'The product this clip promotes. Leave it empty to link no product',
  'pages.live.pageSettings.reels.noProduct': 'No product selected',
  'pages.live.pageSettings.reels.pickProduct': 'Select product',
  'pages.live.pageSettings.reels.changeProduct': 'Change product',
  'pages.live.pageSettings.reels.clearProduct': 'Unlink',
  'pages.live.pageSettings.reels.pickOneOnly':
    'A reel links to one product only. The first one was used',
  'pages.live.pageSettings.reels.priceLabel': 'Price line',
  'pages.live.pageSettings.reels.priceLabelHint':
    'Free text printed on the card as-is, not a computed amount (max 60 characters)',
  'pages.live.pageSettings.reels.priceLabelPlaceholder': 'From 39,000 KRW',
  'pages.live.pageSettings.reels.caption': 'Caption',
  'pages.live.pageSettings.reels.captionHint': 'Shown under the clip',
  'pages.live.pageSettings.reels.captionPlaceholder': 'e.g. Winter arrivals live',
  'pages.live.pageSettings.reels.eventText': 'Event line',
  'pages.live.pageSettings.reels.eventTextHint': 'Shown in orange on the card',
  'pages.live.pageSettings.reels.eventTextPlaceholder': 'e.g. Free gift for the first 100',
  'pages.live.timeSales.column.cardText': 'Card copy',
  'pages.live.timeSales.form.products': 'Products (up to 2)',
  'pages.live.timeSales.form.productsHint':
    'A card carries at most two products. Selecting products replaces the current list',
  'pages.live.timeSales.form.removeProduct': 'Remove this product',
  'pages.live.timeSales.form.tooManyProducts': 'At most {max} products can be added',
  'pages.live.timeSales.form.caption': 'Caption',
  'pages.live.timeSales.form.captionHint': 'Card caption line (200 characters per language)',
  'pages.live.timeSales.form.captionPlaceholder': 'e.g. Today only at this price',
  'pages.live.timeSales.form.eventText': 'Event line',
  'pages.live.timeSales.form.eventTextHint':
    'Shown in orange on the card (200 characters per language)',
  'pages.live.timeSales.form.eventTextPlaceholder': 'e.g. Free gift with purchase',
  // ── [Lane J5] end ────────────────────────────────────────────────────────

  // ── Frontend Page Settings (M2, /operation/frontend-pages) ──────────────
  // Shell-wide labels only for now. Section editor / live schedule / store keys
  // are appended below once each lane settles on its key names.
  'pages.frontendPages.carousel.changeImage': 'Change image',
  'pages.frontendPages.carousel.clearImage': 'Clear the chosen file',
  'pages.frontendPages.carousel.heavyImage': 'This image is heavy. A smaller one is better.',
  'pages.frontendPages.carousel.imagePicked': 'Image chosen. It applies once you save.',
  'pages.frontendPages.carousel.notImage': 'Only image files can be uploaded.',
  'pages.frontendPages.carousel.recommendSize': 'Recommended',
  'pages.frontendPages.carousel.tooLarge': 'The file is too large.',
  'pages.frontendPages.carousel.variants': 'Variants',
  'pages.frontendPages.items.cropHint': 'Only the area inside the orange dashes appears on the card.',
  'pages.frontendPages.items.heavyImage': 'This image is heavy. A smaller one is better.',
  'pages.frontendPages.items.pickerAction': 'Action',
  'pages.frontendPages.items.pickerAdd': 'Add',
  'pages.frontendPages.items.pickerAddOnlyHint': 'This dialog only adds cards. Remove cards from the list itself.',
  'pages.frontendPages.items.pickerAlreadyAdded': 'Added',
  'pages.frontendPages.items.pickerClose': 'Close',
  'pages.frontendPages.items.pickerExcludedReason': 'Outside the product scope of this slot, so it cannot be added.',
  'pages.frontendPages.items.pickerFull': 'This slot is full. Remove or hide a card to add more.',
  'pages.frontendPages.items.pickerTrimmed': '{count} item(s) were left out because this slot holds at most {max}.',
  'pages.frontendPages.items.recommendSize': 'Recommended',
  'pages.frontendPages.items.removeUnlistedBody': 'What this card points at is not in the list, so its name cannot be shown. Remove it anyway?',
  'pages.frontendPages.items.removeUnlistedTitle': 'This card cannot be identified',
  'pages.frontendPages.items.replaceSeller': 'Change seller',
  'pages.frontendPages.items.unlistedCoupon': '(coupon not in the list) {id}',
  'pages.frontendPages.items.unlistedSession': '(past session, not in the list) {id}',
  'pages.frontendPages.items.unlistedSessionHint': 'This session has ended, so it is no longer listed. Its seller, time and product count cannot be shown, and the card still reaches the storefront.',
  'pages.frontendPages.items.unlistedTimeSale': '(past time sale, not in the list) {id}',
  'pages.frontendPages.items.unlistedTimeSaleHint': 'This time sale has ended, so it is no longer listed and its title cannot be shown.',
  'pages.frontendPages.items.variants': 'Variants',
  'pages.frontendPages.schedule.unsavedBody': 'Closing now discards everything you changed. Close anyway?',
  'pages.frontendPages.schedule.unsavedDiscard': 'Close',
  'pages.frontendPages.schedule.unsavedKeep': 'Keep editing',
  'pages.frontendPages.schedule.unsavedTitle': 'You have unsaved changes',
  'pages.frontendPages.slots.removeConfirmBody': '{count} card(s) in this slot are removed with it.',
  'pages.frontendPages.slots.removeConfirmOk': 'Remove',
  'pages.frontendPages.slots.removeConfirmTitle': 'Remove this slot?',
  'pages.frontendPages.title': 'Frontend Page Settings',
  'pages.frontendPages.page.site': 'Common',
  'pages.frontendPages.page.home': 'Recommended',
  'pages.frontendPages.page.overseas': 'Overseas',
  'pages.frontendPages.page.live': 'Live',
  'pages.frontendPages.page.ownmall': 'Company Mall',
  'pages.frontendPages.tab.sections': 'Sections',
  'pages.frontendPages.tab.settings': 'Page Settings',
  'pages.frontendPages.tab.schedule': 'Live Schedule',
  'pages.frontendPages.tab.reels': 'Short Clips',
  'pages.frontendPages.tab.timeSales': 'Time Sales',
  'pages.frontendPages.tab.layout': 'Page layout',
  'pages.frontendPages.canvas.introHome': 'This is the order of the recommended page. Open a block to change the images, products and copy in that spot.',
  'pages.frontendPages.canvas.introLive': 'This is the order of the live page. Edit live sessions with Open live schedule in the live seller carousel block; edit the other blocks in place.',
  'pages.frontendPages.canvas.laterPages': 'The overseas page body is out of scope for this work. You can still keep its sections.',
  'pages.frontendPages.canvas.introOwnmall': 'This is the order of the company-mall page. Open a block to change the images, products and copy in that spot.',
  'pages.frontendPages.canvas.introOverseas': 'This is the order of the overseas page. Open a block to change the images, products and copy in that spot.',
  'pages.frontendPages.canvas.block.overseasHero.title': 'Hero (banner + carousel + banner)',
  'pages.frontendPages.canvas.block.overseasHero.desc': 'One image banner on each side and the carousel in the middle. The right side uses the first card of the "right top" slot.',
  'pages.frontendPages.canvas.block.ovBest.title': 'Trending now (3 columns)',
  'pages.frontendPages.canvas.block.ovBest.desc': '1688 · Taobao · VVIC columns. Each holds two marketplace cards; the Taobao and VVIC columns render as ranking cards.',
  'pages.frontendPages.canvas.block.overseasMarket.title': 'Category products by marketplace',
  'pages.frontendPages.canvas.block.overseasMarket.desc': 'Provider tabs (1688 · Taobao · VVIC) → category chips → sub-tabs → product rail. Chips pick categories from category management; cards come from a product link or manual entry. A chip with no cards shows the platform search for the category name.',
  'pages.frontendPages.canvas.block.overseasMore.title': 'More to love',
  'pages.frontendPages.canvas.block.overseasMore.desc': 'The endless grid from the 1688 new-in feed. Title, how many to show first, and how many more each click adds.',
  'pages.frontendPages.canvas.block.ownmallHero.title': 'Hero (banner + carousel + promo cards)',
  'pages.frontendPages.canvas.block.ownmallHero.desc': 'A large image banner on the left, the carousel in the middle and two promo cards on the right (small line · bold line · small line + icon).',
  'pages.frontendPages.canvas.block.ownmallStores.title': "Today's recommended stores",
  'pages.frontendPages.canvas.block.ownmallStores.desc': 'Company-mall store cards. The "more" link becomes the "View all" on the right.',
  'pages.frontendPages.canvas.block.ownmallPopular.title': 'Popular products (tabs)',
  'pages.frontendPages.canvas.block.ownmallPopular.desc': 'One chip is one tab. Pick the product conditions per tab (picks, new, popular…) and those products fill the rail.',
  'pages.frontendPages.canvas.block.ownmallCategories.title': 'Category strip + category products',
  'pages.frontendPages.canvas.block.ownmallCategories.desc': 'The category row on the own-mall page (round category buttons) and, below it, the chosen category’s sub-tabs and product row. Add no categories and every top-level category is shown automatically.',
  'pages.frontendPages.canvas.block.ownmallMore.title': 'More to love',
  'pages.frontendPages.canvas.block.ownmallMore.desc': 'The endless grid of company-mall products. Title, how many to show first, and how many more each click adds.',
  'pages.frontendPages.canvas.visible': 'On',
  'pages.frontendPages.canvas.hidden': 'Hidden',
  'pages.frontendPages.canvas.missing': 'Not created yet',
  'pages.frontendPages.canvas.cardCount': 'Cards {cards}/{total}',
  'pages.frontendPages.canvas.edit': 'Edit this block',
  'pages.frontendPages.canvas.create': 'Create this block',
  'pages.frontendPages.canvas.showSchedule': 'Open live schedule',
  'pages.frontendPages.canvas.hideSchedule': 'Hide live schedule',
  'pages.frontendPages.canvas.extras': 'Other blocks (reels, time sales, …)',
  'pages.frontendPages.canvas.extrasHint': 'Older bands that are not in the mockup. Only switched-on bands reach the storefront.',
  'pages.frontendPages.canvas.extraName.liveHeroM': 'Top banner',
  'pages.frontendPages.canvas.extraName.liveWideBanners': 'Wide banners',
  'pages.frontendPages.canvas.deviceOnly.mobile': 'Mobile only',
  'pages.frontendPages.canvas.deviceOnly.pc': 'PC only',
  'pages.frontendPages.canvas.advanced': 'Advanced: edit as a band list',
  'pages.frontendPages.canvas.empty': 'This page has no named blocks.',
  'pages.frontendPages.canvas.editHint': 'Change the titles, products and images for this mockup slot. The band key and type stay as they are.',
  'pages.frontendPages.canvas.block.hero.title': 'Hero (LIVE CHANNEL · carousel · new arrivals)',
  'pages.frontendPages.canvas.block.hero.desc': 'Left LIVE CHANNEL card, centre banner carousel, right new arrivals and mall bestsellers. Labels, icons and products are edited here.',
  'pages.frontendPages.canvas.block.homeCats.title': 'Category groups',
  'pages.frontendPages.canvas.block.homeCats.desc': 'Picking a HOT group on the left changes the circular categories on the right. Each circle has an image, title and search link.',
  'pages.frontendPages.canvas.block.liveBest.title': 'Live popular products',
  'pages.frontendPages.canvas.block.liveBest.desc': 'Three column titles and their products. Both live products and company mall products can be added. A landing image uploaded here is used on the card and as the first image on the detail page.',
  'pages.frontendPages.canvas.block.homeStores.title': "Today's recommended stores",
  'pages.frontendPages.canvas.block.homeStores.desc': 'Company-mall store cards. Round and main images, home visibility and the featured product can also be set in store and product lists.',
  'pages.frontendPages.canvas.block.overseasBest.title': 'Popular overseas products',
  'pages.frontendPages.canvas.block.overseasBest.desc': 'Column titles plus product image, title, price, sale price and link.',
  'pages.frontendPages.canvas.block.more.title': 'See more products',
  'pages.frontendPages.canvas.block.more.desc': 'Title, how many to show first, and how many more each “View more” click adds.',
  'pages.frontendPages.canvas.block.spotlight.title': 'Live seller carousel',
  'pages.frontendPages.canvas.block.spotlight.desc': 'The centre seller’s main image, time, title, slogan and three products. Side arrows bring another seller to the centre.',
  'pages.frontendPages.canvas.block.liveCats.title': 'Live category groups',
  'pages.frontendPages.canvas.block.liveCats.desc': 'Same layout as the recommended page, configured separately. A circle opens live product search.',
  'pages.frontendPages.canvas.block.chance.title': 'Live chance',
  'pages.frontendPages.canvas.block.chance.desc': 'Filter chips, sort order, and the live card grid.',
  'pages.frontendPages.canvas.block.liveBestSellers.title': 'Popular BEST sellers',
  'pages.frontendPages.canvas.block.liveBestSellers.desc': 'Saved sellers appear in that order. An empty list fills by total views (or sales). The product under each card can be chosen per seller.',
  'pages.frontendPages.canvas.block.liveRanking.title': 'Shopping Live popular ranking',
  'pages.frontendPages.canvas.block.liveRanking.desc': 'Ranked product grid with Today / 3 days / 1 week tabs (tabs work in manual mode).',
  'pages.frontendPages.canvas.block.liveStores.title': "Today's recommended stores (live)",
  'pages.frontendPages.canvas.block.liveStores.desc': 'Company-mall store rail on the live page. It can use a different list from the recommended page.',
  'pages.frontendPages.canvas.block.liveBanners.title': 'Wide highlight banners',
  'pages.frontendPages.canvas.block.liveBanners.desc': 'Full-width images and links.',
  'pages.frontendPages.canvas.block.liveReels.title': 'Trending short clips',
  'pages.frontendPages.canvas.block.liveReels.desc': 'The same broadcast card as Live Chance, with a blue “Short clip” badge. Picked broadcasts show in that order; automatic shows ended broadcasts, most watched first.',
  'pages.frontendPages.canvas.block.liveBenefits.title': 'Live benefits',
  'pages.frontendPages.canvas.block.liveBenefits.desc': 'Pick broadcasts as for Live Chance and give each card a countdown end. After it passes the card shows “Time’s up”; leave it empty for no countdown.',
  'pages.frontendPages.canvas.block.partners.title': 'Point partner sellers',
  'pages.frontendPages.canvas.block.partners.desc': 'Two-column partner cards with a large seller photo, follow, and products.',
  'pages.frontendPages.canvas.block.liveSellerRail.title': 'Recommended Sellers',
  'pages.frontendPages.canvas.block.liveSellerRail.desc':
    'Row of seller circles right below the live seller carousel. Only the sellers added here are shown, in that order — independent of the popular/point seller settings in seller management. Remove a seller in [Edit], or turn off Visible to hide the whole row.',
  'pages.frontendPages.action.preview': 'Preview (incl. hidden)',
  'pages.frontendPages.action.invalidateCache': 'Refresh cache now',
  'pages.frontendPages.preview.unavailable':
    'The preview server (Redis) is unavailable, so a preview link cannot be issued.',
  'pages.frontendPages.readOnlyHint': 'You do not have edit permission',
  'pages.frontendPages.loadFailed': 'Failed to load frontend page settings',
  'pages.frontendPages.saved': 'Saved',
  'pages.frontendPages.saveFailed': 'Failed to save',

  // ── Frontend Page Settings (M2) — sections, editor drawer, live schedule, stores/carousels ──
  // fp:action
  'pages.frontendPages.action.openStorefront': 'View on site',
  'pages.frontendPages.action.previewHint': 'Opens the page in a new window exactly as it stands, hidden bands included.',
  // fp:(top)
  'pages.frontendPages.addSection': 'Add band',
  // fp:blocked
  'pages.frontendPages.blocked.body':
    'The band settings and the cards are saved. Fix the reasons below and save again. Cards you switched off yourself are not listed here.',
  'pages.frontendPages.blocked.cardAt': '{slot} · card {index} — {reason}',
  'pages.frontendPages.blocked.cardAtNoSlot': 'Card {index} — {reason}',
  'pages.frontendPages.blocked.goToCards': 'Go to cards',
  'pages.frontendPages.blocked.more': 'and {count} more',
  'pages.frontendPages.blocked.title': '{count} cards do not reach the site right now',
  // fp:cache
  'pages.frontendPages.cache.failed': 'Failed to clear the cache.',
  'pages.frontendPages.cache.invalidated': 'Cache cleared.',
  'pages.frontendPages.cacheHint': 'The server cache is cleared the moment you save. Reload the storefront to see it — the storefront caches this response for 30 seconds, so old values can linger that long. If it is still missing after 30 seconds, check the band visibility, its date range, and how many cards are actually shown.',
  // fp:card
  'pages.frontendPages.card.basic': 'Basics',
  'pages.frontendPages.card.heading': 'Band heading (optional)',
  'pages.frontendPages.card.headingHint':
    'Only fill this if you need a title above the three hero cells. Leave it blank to show the cells alone.',
  'pages.frontendPages.card.slots': 'Slots',
  'pages.frontendPages.card.source': 'Source',
  'pages.frontendPages.card.style': 'Style',
  // fp:heroGuide
  'pages.frontendPages.heroGuide.introTitle': 'The three cells at the top of the recommended page',
  'pages.frontendPages.heroGuide.intro':
    'Left is one LIVE CHANNEL card, the centre is the banner carousel, and the right holds new arrivals and mall bestsellers. Tap a cell on the map, then add an image or products there.',
  'pages.frontendPages.heroGuide.howTo1': 'Tap the cell you want to change on the map above.',
  'pages.frontendPages.heroGuide.howTo2': 'In the step that opens, add a banner or products.',
  'pages.frontendPages.heroGuide.howTo3': 'Check the layout on the right, then save.',
  'pages.frontendPages.heroGuide.mapHint': 'Tap a cell. The matching step below opens.',
  'pages.frontendPages.heroGuide.step1': 'Left · LIVE CHANNEL',
  'pages.frontendPages.heroGuide.step1Short': '1 banner',
  'pages.frontendPages.heroGuide.step2': 'Centre · banner carousel',
  'pages.frontendPages.heroGuide.step2Short': 'Several banners',
  'pages.frontendPages.heroGuide.step3': 'Top right · new arrivals',
  'pages.frontendPages.heroGuide.step3Short': 'Up to 3 products',
  'pages.frontendPages.heroGuide.step4': 'Bottom right · mall bestsellers',
  'pages.frontendPages.heroGuide.step4Short': 'Up to 3 products',
  'pages.frontendPages.heroGuide.hint.left':
    'The large LIVE CHANNEL card. Upload a banner image and add a title and link. Only one card is shown.',
  'pages.frontendPages.heroGuide.hint.carousel':
    'The sliding banners in the centre. Create a new banner or pick an existing carousel. This list is the same as CS › Banners/Carousels.',
  'pages.frontendPages.heroGuide.hint.rightTop':
    'New arrivals. Add up to 3 products. If you add none, the system fills this shelf after you save. You can change the column title below.',
  'pages.frontendPages.heroGuide.hint.rightBottom':
    'Mall bestsellers. Add up to 3 products. Leave it empty and the system fills it.',
  'pages.frontendPages.heroGuide.stepTitle.left': '1. Left LIVE CHANNEL card',
  'pages.frontendPages.heroGuide.stepTitle.carousel': '2. Centre banner carousel',
  'pages.frontendPages.heroGuide.stepTitle.rightTop': '3. Top right · new arrivals',
  'pages.frontendPages.heroGuide.stepTitle.rightBottom': '4. Bottom right · mall bestsellers',
  'pages.frontendPages.heroGuide.columnTitle': 'Column title (shown on the storefront)',
  'pages.frontendPages.heroGuide.when': 'When to show this block',
  'pages.frontendPages.heroGuide.places': 'Content by cell',
  'pages.frontendPages.heroGuide.optional': 'Colours and background (optional)',
  'pages.frontendPages.heroGuide.visibleHint': 'Turn this off to hide the whole hero on the recommended page.',
  'pages.frontendPages.heroGuide.deviceHint':
    "Pick “All” to show the hero on phones. “PC only” hides this block on mobile.",
  'pages.frontendPages.heroGuide.preview.title': 'Layout preview',
  'pages.frontendPages.heroGuide.preview.left': 'LIVE CHANNEL',
  'pages.frontendPages.heroGuide.preview.carousel': 'Centre banners',
  'pages.frontendPages.heroGuide.preview.rightTop': 'New arrivals',
  'pages.frontendPages.heroGuide.preview.rightBottom': 'Mall bestsellers',
  'pages.frontendPages.heroGuide.preview.leftEmpty': 'Add 1 banner',
  'pages.frontendPages.heroGuide.preview.carouselEmpty': 'Pick banners in the carousel',
  'pages.frontendPages.heroGuide.preview.productsEmpty': 'Add products, or leave empty to auto-fill',
  'pages.frontendPages.heroGuide.start.left': 'Click Add banner below to upload the LIVE CHANNEL image.',
  'pages.frontendPages.heroGuide.start.rightTop': 'Click Add product, or leave empty and save to let the system fill this shelf.',
  'pages.frontendPages.heroGuide.start.rightBottom': 'Click Add product, or leave empty and save to let the system fill this shelf.',
  // fp:blockGuide
  'pages.frontendPages.blockGuide.howTo1': 'Choose when this block should appear.',
  'pages.frontendPages.blockGuide.howTo2': 'In the steps below, set the title and add the content.',
  'pages.frontendPages.blockGuide.howTo3': 'Press Save to apply the change on the storefront.',
  'pages.frontendPages.blockGuide.howToMap1': 'Tap the cell you want to change on the map above.',
  'pages.frontendPages.blockGuide.howToMap2': 'In the step that opens, set the title and add content.',
  'pages.frontendPages.blockGuide.mapHint': 'Tap a cell. The matching step below opens.',
  'pages.frontendPages.blockGuide.productColumns.mapHint': 'Tap the column you want to edit.',
  'pages.frontendPages.blockGuide.ranking.mapHint': 'Tap Today, 3 days, or 1 week to edit that tab.',
  'pages.frontendPages.blockGuide.categoryGroups.mapHint': 'Tap the group you want to edit. Set its circle image, then add circular categories for that group.',
  'pages.frontendPages.blockGuide.liveChance.mapHint': 'Tap a filter chip to add the lives that belong to it.',
  'pages.frontendPages.blockGuide.when': 'When to show this block',
  'pages.frontendPages.blockGuide.visibleHint': 'Turn this off to hide the whole block on this page.',
  'pages.frontendPages.blockGuide.deviceHint':
    'Pick “All” to show it on phones. “PC only” hides this block on mobile.',
  'pages.frontendPages.blockGuide.showOnMobileHint': 'Turn this off to hide this category row on phones.',
  'pages.frontendPages.blockGuide.showLoadMoreHint': 'Off hides the button even when more pages remain.',
  'pages.frontendPages.blockGuide.heading': 'Block title',
  'pages.frontendPages.blockGuide.heading.sellerSpotlight': 'Text above the carousel',
  'pages.frontendPages.blockGuide.headingHint': 'Shown above this block on the storefront. Leave blank for no title row.',
  'pages.frontendPages.blockGuide.headingHint.sellerSpotlight':
    'This is the orange “Today’s special” label and the large “Don’t miss it today!” title. Use eyebrow and title.',
  'pages.frontendPages.blockGuide.headingMore': 'More title styling (optional)',
  'pages.frontendPages.blockGuide.fill': 'How to fill this block',
  'pages.frontendPages.blockGuide.fillQuestion': 'Pick items yourself, or let the system choose?',
  'pages.frontendPages.blockGuide.fillQuestion.sellerSpotlight': 'Which sellers should appear in the carousel?',
  'pages.frontendPages.blockGuide.fillQuestion.reels': 'Which broadcasts should show as clips?',
  'pages.frontendPages.blockGuide.fillHint':
    '“Add myself” shows only what you put below. “Let the system fill” picks matching items automatically.',
  'pages.frontendPages.blockGuide.fillHint.sellerSpotlight':
    'Picking yourself plays sellers in order (top is the first slide). Products you pick on each row appear under the card. Auto-fill uses live or upcoming sessions.',
  'pages.frontendPages.blockGuide.fillHint.reels': 'When you pick, the broadcasts below show in that order (ended ones too). Automatic fills with ended broadcasts, most watched first. Adding a broadcast switches to picking.',
  'pages.frontendPages.blockGuide.fillHint.storeRail':
    'Pick: your stores come first in that order, and the seats left are filled at random with other stores that have featured on in Store management. Set how many in "Stores to fill at random" below; the fill changes once a day, at midnight Korea time. Hidden stores are never used. Let the system fill (or nothing picked): featured stores in Store management order.',
  'pages.frontendPages.blockGuide.autoFilters': 'Rules for auto-fill (optional)',
  'pages.frontendPages.blockGuide.source.manual': 'Add myself',
  'pages.frontendPages.blockGuide.source.manual.sellerSpotlight': 'Pick from the list',
  'pages.frontendPages.blockGuide.source.manual.reels': 'Pick broadcasts',
  'pages.frontendPages.blockGuide.source.auto': 'Let the system fill',
  'pages.frontendPages.blockGuide.source.auto.sellerSpotlight': 'Fill with live / upcoming sessions',
  'pages.frontendPages.blockGuide.source.auto.reels': 'Ended broadcasts, most watched',
  'pages.frontendPages.blockGuide.places': 'What to put here',
  'pages.frontendPages.blockGuide.places.sellerSpotlight': 'Sellers in the carousel',
  'pages.frontendPages.blockGuide.places.timeSale': 'Broadcasts shown as benefits',
  'pages.frontendPages.blockGuide.places.reels': 'Broadcasts shown as clips',
  'pages.frontendPages.blockGuide.optional': 'Colours and background (optional)',
  'pages.frontendPages.blockGuide.columnTitle': 'Column title (shown on the storefront)',
  'pages.frontendPages.blockGuide.groupTitle': 'Group name (shown under the circle)',
  'pages.frontendPages.blockGuide.chipTitle': 'Chip name',
  'pages.frontendPages.blockGuide.tabTitle': 'Tab name',
  'pages.frontendPages.blockGuide.addGroup': 'Add group',
  'pages.frontendPages.blockGuide.addChip': 'Add filter chip',
  'pages.frontendPages.blockGuide.addSlot': 'Add place',
  'pages.frontendPages.blockGuide.emptySlots': 'No places yet. Use the button below to create one.',
  'pages.frontendPages.blockGuide.noItems': 'This block does not take products here.',
  'pages.frontendPages.blockGuide.variantHint':
    'Choose the plain, live-chance, or ranking card look. Each column can differ.',
  'pages.frontendPages.blockGuide.initialCountHint': 'How many items to show when the page first opens.',
  'pages.frontendPages.blockGuide.loadMoreCountHint': 'How many more to load each time the visitor taps more.',
  'pages.frontendPages.blockGuide.rankingAutoHint':
    'In “Let the system fill”, you do not put products on the Today / 3 days / 1 week tabs. Switch to “Add myself” to edit them again.',
  'pages.frontendPages.blockGuide.hint.productColumns':
    'Add up to 2 products in this column. Leave empty and the system fills it after you save.',
  'pages.frontendPages.blockGuide.hint.productColumns.col1':
    'Left column. Add up to 2 products, or leave empty for the system to fill.',
  'pages.frontendPages.blockGuide.hint.productColumns.col2':
    'Middle column. Add up to 2 products, or leave empty for the system to fill.',
  'pages.frontendPages.blockGuide.hint.productColumns.col3':
    'Right column. Add up to 2 products, or leave empty for the system to fill.',
  'pages.frontendPages.blockGuide.hint.ranking':
    'Products for this period tab. Up to 10. If you chose “Let the system fill”, this list is unused.',
  'pages.frontendPages.blockGuide.hint.ranking.today': 'Products for today’s ranking. Up to 10.',
  'pages.frontendPages.blockGuide.hint.ranking.3d': 'Products for the last 3 days. Up to 10.',
  'pages.frontendPages.blockGuide.hint.ranking.1w': 'Products for the last week. Up to 10.',
  'pages.frontendPages.blockGuide.hint.categoryGroups':
    'Tapping this group swaps the circular categories on the right. Add up to 12 circles.',
  'pages.frontendPages.blockGuide.hint.liveChance':
    'Name the chip. Unless it is All, pick categories and then add lives.',
  'pages.frontendPages.blockGuide.hint.liveChance.all': 'The All chip. It shows every live, with no category filter.',
  'pages.frontendPages.blockGuide.start.productColumns':
    'Click Add product, or leave empty and save to let the system fill. Up to 2 per column.',
  'pages.frontendPages.blockGuide.start.ranking':
    'Click Add product. If you chose “Let the system fill”, this list is unused.',
  'pages.frontendPages.blockGuide.start.categoryGroups':
    'Use the button below to add category circles. Image, name and link are one set.',
  'pages.frontendPages.blockGuide.start.liveChance': 'Use the button below to add live cards.',
  'pages.frontendPages.blockGuide.start.storeRail': 'Add stores to feature. Yours come first and the system fills the seats left at random (the fill changes once a day). Leave empty and the system fills them all.',
  'pages.frontendPages.blockGuide.start.moreToLove':
    'Add products below, or leave empty for the system to fill. You can set the first count above.',
  'pages.frontendPages.blockGuide.start.sellerSpotlight':
    '1) Choose “Pick from the list” above. 2) Use [Add seller] to add live sellers. 3) For each seller, pick up to 3 products for the live page card. The top card is first; drag the handle to reorder.',
  'pages.frontendPages.blockGuide.start.banner': 'Add the full-width banner images.',
  'pages.frontendPages.blockGuide.start.sellerRail': 'Add the partner sellers to show.',
  'pages.frontendPages.blockGuide.hint.productTabs': 'Name the tab and pick the product conditions for it. Up to 20 products per tab.',
  'pages.frontendPages.blockGuide.start.productTabs': 'Click Add product to fill this tab.',
  'pages.frontendPages.blockGuide.hint.categoryShowcase': 'Pick a category for the category row. Its name and image come from category management as they are. Products are added below under "Products by tab", one list per storefront tab (Best and each sub-category).',
  'pages.frontendPages.blockGuide.hint.marketShowcase': 'Name the chip and pick one of this provider’s categories. The chip image is that category’s image.',
  'pages.frontendPages.blockGuide.start.marketShowcase': 'Click Add external product, or leave it empty to show a platform search for the category name.',
  'pages.frontendPages.blockGuide.addMarketChip': 'Add category chip',
  'pages.frontendPages.platform.1688': '1688',
  'pages.frontendPages.platform.taobao': 'Taobao',
  'pages.frontendPages.platform.vvic': 'VVIC',
  'pages.frontendPages.slots.chipPlatformMissing': 'This chip has no provider, so it is not shown on the storefront. Pick a provider.',
  'pages.frontendPages.slots.chipImageFromSearch': 'No image yet, so the chip uses a search-result product photo. An upload is saved to category management too.',
  'pages.frontendPages.slots.chipCategoryImage': 'Chip image',
  'pages.frontendPages.slots.chipCategoryImageSync': 'Same image as in category management. Changing it saves at once and updates both.',
  'pages.frontendPages.slots.chipCategoryImageSaved': 'Category image saved — category management shows it too.',
  'pages.frontendPages.slots.chipCategoryImageSaveFailed': 'Could not save the category image.',
  'pages.frontendPages.slots.chipCategoryImageNoPermission': 'Changing it needs category management edit permission.',
  'pages.frontendPages.slots.chipCategoryImagePc': 'PC',
  'pages.frontendPages.slots.chipCategoryImageMobile': 'Mobile',
  'pages.frontendPages.slots.ownChipCategoryImageSync': 'Same image as in own-mall category management. Changing it saves at once and updates both. If only one is set, it is used for both.',
  'pages.frontendPages.slots.ownChipCategoryImageEmpty': 'No image yet, so the first letter of the name is shown instead. An upload is saved to own-mall category management too.',
  'pages.frontendPages.slots.ownChipCategoryImageNoPermission': 'Changing it needs own-mall edit permission.',
  'pages.frontendPages.blockGuide.addCategory': 'Add category',
  'pages.frontendPages.blockGuide.emptyCategories': 'No categories added, so every top-level category is shown automatically. Click Add category to pick them yourself.',
  'pages.frontendPages.slots.categoryNotPicked': 'No category picked',
  'pages.frontendPages.slots.categoryMissing': 'Hidden or deleted category',
  'pages.frontendPages.slots.categoryPlaceholder': 'Pick a category',
  'pages.frontendPages.slots.categoryRequired': 'Pick a category. Without one this place is not shown on the storefront.',
  'pages.frontendPages.slots.categoryMissingHint': 'The picked category is hidden or deleted, so this place is not shown on the storefront. Pick another category.',
  'pages.frontendPages.slots.ownCategoryImage': 'Category image',
  'pages.frontendPages.slots.subTabs': 'Products by tab',
  'pages.frontendPages.slots.subTabsHint': 'On the storefront, choosing this category shows the tabs below. Add the products for each tab separately.',
  'pages.frontendPages.slots.subTabsNone': 'This category has no sub-categories, so the storefront shows only the "Best" tab. Sub-categories are added in own-mall category management.',
  'pages.frontendPages.slots.subTabBest': 'Best',
  'pages.frontendPages.slots.subTabOrphan': 'Removed tab',
  'pages.frontendPages.slots.subTabOrphanHint': 'This tab’s sub-category was hidden, deleted or moved under another category, so the storefront no longer has it. Products here are not shown: add the ones you need to another tab, then remove them here.',
  'pages.frontendPages.slots.subTabOrphanDropTitle': 'Remove every product in this tab?',
  'pages.frontendPages.slots.subTabOrphanDrop': 'Remove {count} products from this tab',
  'pages.frontendPages.slots.subTabHint.bestAuto': 'The "Best" tab is what the storefront shows first when this category is chosen. Added products show in this order; left empty, the whole category’s products are filled in automatically.',
  'pages.frontendPages.slots.subTabHint.bestManual': 'The "Best" tab is what the storefront shows first when this category is chosen. Added products show in this order; left empty, every product added to the sub-tabs is shown.',
  'pages.frontendPages.slots.subTabHint.subAuto': 'The storefront "{name}" tab. Added products show in this order; left empty, products of the "{name}" category are filled in automatically.',
  'pages.frontendPages.slots.subTabHint.subManual': 'The storefront "{name}" tab. Added products show in this order; left empty, only the "Best" products in the "{name}" category are shown.',
  'pages.frontendPages.slots.subTabDropConfirmTitle': 'Change the category?',
  'pages.frontendPages.slots.subTabDropConfirmBody': 'The {count} products added to sub-tabs have no tab under the new category and will be removed. Products in "Best" stay.',
  'pages.frontendPages.slots.subTabDropConfirmOk': 'Change',
  'pages.frontendPages.slots.chipItemCount': '{count} products',
  'pages.frontendPages.blockGuide.start.categoryTabs': 'Click Add product to add products. With “Let the system fill”, they are filled automatically.',
  'pages.frontendPages.blockGuide.start.productGrid': 'Click Add product to add products. With “Let the system fill”, they are filled automatically.',
  'pages.frontendPages.blockGuide.start.productRail': 'Click Add product to add products. With “Let the system fill”, they are filled automatically.',
  'pages.frontendPages.blockGuide.start.coupon': 'Use the button below to add claimable coupons. With “Let the system fill”, they are filled automatically.',
  'pages.frontendPages.blockGuide.start.eventTicker': 'Add the event banners that scroll through the strip. With “Let the system fill”, they are filled automatically.',
  'pages.frontendPages.blockGuide.start.heroLive': 'Add the short clip for the top of the page. With “Let the system fill”, one is picked automatically.',
  'pages.frontendPages.blockGuide.start.liveNow': 'Add the sellers to show as live. With “Let the system fill”, sellers on air are shown automatically.',
  'pages.frontendPages.blockGuide.start.reels': 'Use [Add Live session] below to pick the broadcasts to show as clips (up to 12). Ended broadcasts can be picked too. A video uploaded to that broadcast under Seller detail → Live Product Management plays on the card.',
  'pages.frontendPages.blockGuide.start.schedule': 'Add the broadcasts to list. With “Let the system fill”, upcoming broadcasts are shown by time.',
  'pages.frontendPages.blockGuide.start.ticker': 'Add the short lines to scroll, one line per card.',
  'pages.frontendPages.blockGuide.start.timeSale': 'Use [Add Live session] below to pick the broadcasts whose benefits to show (up to 12), then set each card’s “Countdown ends”. Empty means no countdown; once it passes the card shows “Time’s up”. Ended broadcasts can be picked too.',
  'pages.frontendPages.blockGuide.start.sellerRanking': 'Sellers you add appear on the live page in that order. Anyone you do not add is left out. An empty list fills automatically by the sort above (views or sales). Leave a seller’s product empty to use the first product on that seller’s page (pinned first, then sales).',
  'pages.frontendPages.blockGuide.stepTitle.productColumns.col1': '1. Left column',
  'pages.frontendPages.blockGuide.stepTitle.productColumns.col2': '2. Middle column',
  'pages.frontendPages.blockGuide.stepTitle.productColumns.col3': '3. Right column',
  'pages.frontendPages.blockGuide.stepTitle.ranking.today': '1. Today',
  'pages.frontendPages.blockGuide.stepTitle.ranking.3d': '2. 3 days',
  'pages.frontendPages.blockGuide.stepTitle.ranking.1w': '3. 1 week',
  'pages.frontendPages.blockGuide.stepTitle.liveChance.all': '1. All',
  'pages.frontendPages.slotPurpose.heroTriple.left': 'Left LIVE CHANNEL card',
  'pages.frontendPages.slotPurpose.heroTriple.carousel': 'Centre banner carousel',
  'pages.frontendPages.slotPurpose.heroTriple.rightTop': 'Top-right new arrivals',
  'pages.frontendPages.slotPurpose.heroTriple.rightBottom': 'Bottom-right mall bestsellers',
  'pages.frontendPages.slotPurpose.productColumns.col1': 'Left column · up to 2 products',
  'pages.frontendPages.slotPurpose.productColumns.col2': 'Middle column · up to 2 products',
  'pages.frontendPages.slotPurpose.productColumns.col3': 'Right column · up to 2 products',
  'pages.frontendPages.slotPurpose.ranking.today': 'Today’s ranking',
  'pages.frontendPages.slotPurpose.ranking.3d': 'Last 3 days ranking',
  'pages.frontendPages.slotPurpose.ranking.1w': 'Last week ranking',
  // fp:carousel
  'pages.frontendPages.carousel.actions': 'Actions',
  'pages.frontendPages.carousel.add': 'Add carousel',
  'pages.frontendPages.carousel.addTitle': 'Add carousel',
  'pages.frontendPages.carousel.delete': 'Delete',
  'pages.frontendPages.carousel.deleteConfirm': 'Delete this carousel?',
  'pages.frontendPages.carousel.deleteFailed': 'Failed to delete.',
  'pages.frontendPages.carousel.deleted': 'Deleted.',
  'pages.frontendPages.carousel.edit': 'Edit',
  'pages.frontendPages.carousel.editTitle': 'Edit carousel',
  'pages.frontendPages.carousel.imageHint': 'When adding, upload only the desktop image and the server derives the mobile size. Upload both and each is used as is. When editing, only the image you replace changes.',
  'pages.frontendPages.carousel.imageMobile': 'Mobile image',
  'pages.frontendPages.carousel.imagePc': 'Desktop image',
  'pages.frontendPages.carousel.imageRequired': 'At least one image is required.',
  'pages.frontendPages.carousel.isActive': 'Active',
  'pages.frontendPages.carousel.link': 'Link',
  'pages.frontendPages.carousel.loadFailed': 'Failed to load carousels.',
  'pages.frontendPages.carousel.viewPermissionRequired':
    'Without banner/event view permission the carousel list cannot be loaded.',
  'pages.frontendPages.carousel.editPermissionRequired':
    'Editing carousels requires banner/event edit permission.',
  'pages.frontendPages.carousel.newTabShort': '(new tab)',
  'pages.frontendPages.carousel.no': 'No.',
  'pages.frontendPages.carousel.openInNewTab': 'New tab',
  'pages.frontendPages.carousel.period': 'Period',
  'pages.frontendPages.carousel.periodAlways': 'Always',
  'pages.frontendPages.carousel.periodHint': 'Leave empty to show it always. Times are Korean time.',
  'pages.frontendPages.carousel.permissionHint': 'Saving carousels requires the banner / event edit permission.',
  'pages.frontendPages.carousel.pickImage': 'Pick an image',
  'pages.frontendPages.carousel.sameDataHint': 'This list is the same data as CS › Banner / carousel management.',
  'pages.frontendPages.carousel.saveFailed': 'Failed to save.',
  'pages.frontendPages.carousel.saved': 'Saved.',
  'pages.frontendPages.carousel.title': 'Title',
  'pages.frontendPages.carousel.subtitle': 'Subtitle',
  'pages.frontendPages.carousel.subtitleHint':
    'Shown in orange above the title on the app own-mall page cards. Leave blank to hide it.',
  // fp:categoryLink
  'pages.frontendPages.categoryLink.category': 'Category',
  'pages.frontendPages.categoryLink.categoryOnly1688': 'Taobao and VVIC search on the keyword only. The category is ignored.',
  'pages.frontendPages.categoryLink.companymallCategoryFirst': 'Pick a category first. The keyword field opens after that.',
  'pages.frontendPages.categoryLink.companymallKeywordHint': 'The keyword must match the selected category name exactly. Anything else returns an empty list.',
  'pages.frontendPages.categoryLink.companymallKeywordLock': 'Enter keyword manually',
  'pages.frontendPages.categoryLink.companymallLiveHint': 'The company mall list searches company mall products only. For live products, use the "Live" mode.',
  'pages.frontendPages.categoryLink.customUrl': 'Custom address',
  'pages.frontendPages.categoryLink.keyword': 'Keyword',
  'pages.frontendPages.categoryLink.keywordMismatch': 'This differs from the selected category name. Saving will be rejected.',
  'pages.frontendPages.categoryLink.keywordRequired': 'This provider needs a keyword before a link can be built.',
  'pages.frontendPages.categoryLink.mode': 'Link mode',
  'pages.frontendPages.categoryLink.mode_custom': 'Custom address',
  'pages.frontendPages.categoryLink.mode_live': 'Live products',
  'pages.frontendPages.categoryLink.mode_mall': 'Company mall list',
  'pages.frontendPages.categoryLink.mode_search': 'Marketplace search',
  'pages.frontendPages.categoryLink.preview': 'Link preview',
  'pages.frontendPages.categoryLink.previewEmpty': 'Not yet a link that can be opened.',
  'pages.frontendPages.categoryLink.provider': 'Provider',
  'pages.frontendPages.categoryLink.provider_1688': '1688',
  'pages.frontendPages.categoryLink.provider_companymall': 'Company mall',
  'pages.frontendPages.categoryLink.provider_taobao': 'Taobao',
  'pages.frontendPages.categoryLink.provider_vvic': 'VVIC',
  'pages.frontendPages.categoryLink.useCategoryName': 'Use the category name',
  // fp:column
  'pages.frontendPages.column.always': 'Always',
  'pages.frontendPages.column.autoLimit': 'Auto, up to {count}',
  'pages.frontendPages.column.cards': 'Cards',
  'pages.frontendPages.column.cardsBlocked': '{count} more dropped because their source is hidden',
  'pages.frontendPages.column.cardsHint':
    'Cards that actually reach the site / total cards. Cards you switched off, and cards whose source is missing or hidden, are excluded from the first number.',
  'pages.frontendPages.column.device': 'Device',
  'pages.frontendPages.column.order': 'No.',
  'pages.frontendPages.column.period': 'Period',
  'pages.frontendPages.column.section': 'Band',
  'pages.frontendPages.column.slots': 'Slots',
  'pages.frontendPages.column.source': 'Source',
  'pages.frontendPages.column.type': 'Type',
  'pages.frontendPages.column.untitled': '(no title)',
  'pages.frontendPages.column.usedElsewhere': 'Other pages',
  'pages.frontendPages.column.visible': 'Visible',
  // fp:delete
  'pages.frontendPages.delete.confirmBody': 'The band "{key}" and every card in it will be removed. This cannot be undone.',
  'pages.frontendPages.delete.confirmTitle': 'Delete this band?',
  'pages.frontendPages.delete.done': 'Deleted.',
  'pages.frontendPages.delete.failed': 'Failed to delete.',
  // fp:device
  'pages.frontendPages.device.all': 'All',
  'pages.frontendPages.device.mobile': 'Mobile only',
  'pages.frontendPages.device.pc': 'Desktop only',
  // fp:(top)
  'pages.frontendPages.dragDisabled': 'Reordering is off while a search or filter is applied.',
  'pages.frontendPages.dragHint': 'Drag the handle to reorder.',
  // fp:duplicate
  'pages.frontendPages.duplicate.action': 'Duplicate',
  'pages.frontendPages.duplicate.body': 'Which page should the band "{key}" be copied to?',
  'pages.frontendPages.duplicate.done': 'Duplicated.',
  'pages.frontendPages.duplicate.failed': 'Failed to duplicate.',
  'pages.frontendPages.duplicate.hiddenNotice': 'The copy is created hidden. Check it, then switch it to visible.',
  'pages.frontendPages.duplicate.notAllowed': 'does not accept this type',
  'pages.frontendPages.duplicate.target': 'Target page',
  'pages.frontendPages.duplicate.title': 'Duplicate band',
  'pages.frontendPages.duplicate.tooltip': 'Duplicate to another page',
  // fp:(top)
  'pages.frontendPages.editTitle': 'Edit band',
  // fp:emptyBanner
  'pages.frontendPages.emptyBanner.action': 'Import to the list',
  'pages.frontendPages.emptyBanner.body': 'No bands are stored for this page yet. Import the default layout to start editing it here.',
  'pages.frontendPages.emptyBanner.title': 'The page is running on the built-in default layout',
  // fp:field
  'pages.frontendPages.field.accentColor': 'Accent color',
  'pages.frontendPages.field.autoLoadPages': 'Auto-load rounds',
  'pages.frontendPages.field.backgroundColor': 'Background color',
  'pages.frontendPages.field.badge': 'Title badge',
  'pages.frontendPages.field.device': 'Device',
  'pages.frontendPages.field.eyebrow': 'Kicker',
  'pages.frontendPages.field.fullBleed': 'Full bleed',
  'pages.frontendPages.field.initialCount': 'Initial count',
  'pages.frontendPages.field.isVisible': 'Visible',
  'pages.frontendPages.field.itemLimit': 'Item count',
  'pages.frontendPages.field.autoFillCount': 'Stores to fill at random',
  'pages.frontendPages.field.autoFillCountPlaceholder': 'All seats left',
  'pages.frontendPages.field.autoFillCountHint':
    'How many stores the system adds at random after yours. Leave empty to fill every seat left; 0 shows only your stores. If fewer stores have featured on, only those appear.',
  'pages.frontendPages.field.key': 'Key',
  'pages.frontendPages.field.keyHint': 'Lowercase letters, digits, - and _ only. Must be unique within the page.',
  'pages.frontendPages.field.layout': 'Layout',
  'pages.frontendPages.field.loadMoreCount': 'Load-more count',
  'pages.frontendPages.field.metaText': 'Supporting text',
  'pages.frontendPages.field.moreLink': 'More link',
  'pages.frontendPages.field.moreLinkHint': 'Leave blank to hide the see-more button.',
  'pages.frontendPages.field.period': 'Display period',
  'pages.frontendPages.field.periodHint': 'Leave empty to show it always. Times are Korean time.',
  'pages.frontendPages.field.productScope': 'Product scope',
  'pages.frontendPages.field.productScopeHint': 'Used for automatic filling, the product picker, and whether a card shows.',
  'pages.frontendPages.field.salesMetric': 'Sales figure',
  'pages.frontendPages.field.showOnMobile': 'Show on mobile',
  'pages.frontendPages.field.showLoadMore': 'Show load-more button',
  'pages.frontendPages.field.singleSourceModeHint': 'This type has a single fixed source.',
  'pages.frontendPages.field.sortOptions': 'Sort options',
  'pages.frontendPages.field.sortOptionsHint': 'Leave empty to hide the sort dropdown.',
  'pages.frontendPages.field.sourceMode': 'Source',
  'pages.frontendPages.field.subtitle': 'Subtitle',
  'pages.frontendPages.field.textColor': 'Text color',
  'pages.frontendPages.field.title': 'Title',
  'pages.frontendPages.field.titleIconHint': 'A single emoji or an image address.',
  'pages.frontendPages.field.titleIconUrl': 'Title icon',
  'pages.frontendPages.field.type': 'Type',
  // fp:filter
  'pages.frontendPages.filter.categories': 'Categories',
  'pages.frontendPages.filter.liveState': 'Broadcast state',
  'pages.frontendPages.filter.productFlags': 'Product flags',
  'pages.frontendPages.filter.searchPlaceholder': 'Search by key or title',
  'pages.frontendPages.filter.sellerFlags': 'Seller flags',
  'pages.frontendPages.filter.sortBy': 'Sort by',
  'pages.frontendPages.filter.type': 'All types',
  'pages.frontendPages.filter.visibleAll': 'All',
  'pages.frontendPages.filter.visibleOff': 'Hidden only',
  'pages.frontendPages.filter.visibleOn': 'Visible only',
  // fp:flag
  'pages.frontendPages.flag.isBestSeller': 'Best seller',
  'pages.frontendPages.flag.isFeatured': 'Featured',
  'pages.frontendPages.flag.isImportant': 'Important',
  'pages.frontendPages.flag.isNewArrival': 'New arrival',
  'pages.frontendPages.flag.isPoint': 'Point seller',
  'pages.frontendPages.flag.isPopular': 'Popular',
  // fp:gallery
  'pages.frontendPages.gallery.createFailed': 'Failed to add the band.',
  'pages.frontendPages.gallery.created': 'Band added.',
  'pages.frontendPages.gallery.empty': 'This page accepts no bands.',
  'pages.frontendPages.gallery.intro': 'Only bands this page accepts are listed. Pick one, then fill it in from the editor.',
  'pages.frontendPages.gallery.perSlot': '{max} per slot · {mobile} on mobile',
  'pages.frontendPages.gallery.slotsFixed': '{count} fixed slots · {keys}',
  'pages.frontendPages.gallery.slotsNone': 'No slots',
  'pages.frontendPages.gallery.slotsRange': '{min}–{max} slots',
  'pages.frontendPages.gallery.title': 'Bands for the {page} page',
  // fp:hiddenReason
  'pages.frontendPages.hiddenReason.coupon_inactive': 'The coupon cannot be claimed',
  'pages.frontendPages.hiddenReason.item_hidden': 'This card is set to hidden',
  'pages.frontendPages.hiddenReason.live_status_ended': 'The session has already ended',
  'pages.frontendPages.hiddenReason.live_status_hidden': 'The session is hidden',
  'pages.frontendPages.hiddenReason.live_status_no_product': 'The session has no products',
  'pages.frontendPages.hiddenReason.live_status_products_hidden': '{count} products hidden',
  'pages.frontendPages.hiddenReason.product_hidden': 'The product is hidden',
  'pages.frontendPages.hiddenReason.product_not_on_sale': 'The product is not on sale',
  'pages.frontendPages.hiddenReason.product_out_of_scope': "Outside this slot's product scope",
  'pages.frontendPages.hiddenReason.sub_category_missing': 'Its sub-category tab is gone (hidden, deleted or moved to another category)',
  'pages.frontendPages.hiddenReason.reel_hidden': 'The short clip is hidden',
  'pages.frontendPages.hiddenReason.ref_missing': 'The linked source is gone',
  'pages.frontendPages.hiddenReason.schedule_hidden': 'The schedule entry is hidden',
  'pages.frontendPages.hiddenReason.store_inactive': 'The store is inactive',
  'pages.frontendPages.hiddenReason.store_product_hidden': "The store's featured product is hidden",
  'pages.frontendPages.hiddenReason.time_sale_ended': 'The time sale has already ended',
  'pages.frontendPages.hiddenReason.time_sale_hidden': 'The time sale is hidden',
  // fp:importDefaults
  'pages.frontendPages.importDefaults.action': 'Import default layout',
  'pages.frontendPages.importDefaults.confirmBody': 'Adds the default bands to the list. Keys that already exist are skipped, so your current setup is not overwritten. Imported bands come in visible right away — unlike bands added from the gallery or duplicated, which come in hidden.',
  'pages.frontendPages.importDefaults.confirmTitle': 'Import the default layout?',
  'pages.frontendPages.importDefaults.failed': 'Failed to import the default layout.',
  'pages.frontendPages.importDefaults.nothingNew': 'Nothing new to import. {skipped} bands are already on the list.',
  'pages.frontendPages.importDefaults.result': 'Imported {created}. Skipped {skipped} that already existed.',
  // fp:items
  'pages.frontendPages.items.add': 'Add {refType}',
  'pages.frontendPages.items.addLiveSession': 'Add live',
  'pages.frontendPages.items.addSpotlightSeller': 'Add seller',
  'pages.frontendPages.items.addPartnerSeller': 'Add seller',
  'pages.frontendPages.items.autoSellersTitle': 'Sellers currently on the storefront',
  'pages.frontendPages.items.autoSellersHint':
    'This band currently fills from matching sellers (for example point partners). The list below is what the live page shows now. Add, remove, or reorder, then save to lock this list — it will no longer update automatically.',
  'pages.frontendPages.items.partnerEmpty':
    'No sellers yet. Use Add seller, or matching flagged sellers will fill this band automatically.',
  'pages.frontendPages.items.pickSeller': 'Pick a seller',
  'pages.frontendPages.items.spotlightProductsHint':
    'Products under the live page card. Search this seller’s quick-register and company-mall products by name or live code, up to 3. Leave empty to use the session’s products.',
  'pages.frontendPages.items.spotlightTitleHint':
    'Once products are chosen, the large title is the seller name. Leave products empty to show the live-schedule broadcast title.',
  'pages.frontendPages.items.rankingProductHint':
    'The product under this card. Pick one quick-register or company-mall product. Leave empty to use the first product on the seller page (a pinned product wins, then sales).',
  'pages.frontendPages.items.partnerProductsHint':
    'Featured products shown with this seller on the point-partner card. Search this seller’s quick-register and company-mall products by name or live code, up to 3. Leave empty to show the seller’s live products automatically.',
  'pages.frontendPages.items.productTypeOwn': 'Company mall',
  'pages.frontendPages.items.productTypeLive': 'Live',
  'pages.frontendPages.items.spotlightLandingHint':
    'For each picked product you can change the main (landing) image. It also updates the product detail and other page cards.',
  'pages.frontendPages.items.spotlightProductsPlaceholder': 'Pick products to show',
  'pages.frontendPages.items.spotlightProductsCount': '{count}/{max} selected',
  'pages.frontendPages.items.spotlightProductsLoadFailed': 'Could not load seller products.',
  'pages.frontendPages.items.spotlightBanner': 'Banner image',
  'pages.frontendPages.items.spotlightBannerHint':
    'The large photo on this seller card of the live page (left of the card on PC; the big card and the thumbnail column on mobile). It is separate from the seller profile photo, which shows when this is empty. Portrait 3:4 is recommended. Fill only one box to use the same photo on PC and mobile.',
  'pages.frontendPages.items.cardImage': 'Card photo',
  'pages.frontendPages.items.partnerCardImageHint':
    'The large photo on the left of this point partner card. It is separate from the seller profile photo, which shows when this is empty (a default avatar shows if that photo cannot load). A square photo is recommended.',
  'pages.frontendPages.items.cardImageHint':
    'The large photo on this card of the live page. It is separate from the seller profile photo, which shows when this is empty. The card has the same shape on PC and mobile, so one photo is enough; a portrait photo (about 3:4) is recommended.',
  'pages.frontendPages.items.clipCardImageHint':
    'The large photo on this short-clip card. When the broadcast has a video, the web card plays the video and this photo shows before it loads and in the app. Leave it empty to show the seller profile photo. A portrait photo (about 3:4) is recommended.',
  'pages.frontendPages.items.benefitCardImageHint':
    'The large photo on this live-benefit card. When a countdown end is set, the countdown bar covers the bottom of the photo, so keep important text away from the bottom. Leave it empty to show the seller profile photo (or the lead product photo). A portrait photo (about 3:4) is recommended.',
  'pages.frontendPages.items.unlistedSpotlightProduct': '(product not in list) {id}',
  'pages.frontendPages.items.addThisSession': 'Add',
  'pages.frontendPages.items.alreadyAdded': 'Already added',
  'pages.frontendPages.items.advisoryHint': 'The card goes out, but part of it is left off.',
  'pages.frontendPages.items.badgeText': 'Badge text',
  'pages.frontendPages.items.blockingHint': 'This card is not going out to the site right now.',
  'pages.frontendPages.items.changeImage': 'Change image',
  'pages.frontendPages.items.changeLanding': 'Change landing image',
  'pages.frontendPages.items.clearImage': 'Clear',
  'pages.frontendPages.items.clearLanding': 'Clear landing image',
  'pages.frontendPages.items.count': '{count}/{max}',
  'pages.frontendPages.items.discountLabel': 'Discount label',
  'pages.frontendPages.items.empty': 'No cards yet.',
  'pages.frontendPages.items.spotlightEmpty': 'No sellers yet. Press [Add seller] above.',
  'pages.frontendPages.items.spotlightLegacySession':
    'This card still uses the old session pick. Remove it, add the seller again, then pick products for the live page.',
  'pages.frontendPages.items.spotlightOrderHint':
    'Drag the handle on the left to change order. The top card is the first slide. On each row, pick products for the live page.',
  'pages.frontendPages.items.sessionPickerTitle': 'Pick a broadcast',
  'pages.frontendPages.items.countdownEndAt': 'Countdown ends',
  'pages.frontendPages.items.countdownEndAtHint': 'Until this time the card counts down under the photo; after it, the card shows “Time’s up”. Leave it empty for no countdown. Korea time.',
  'pages.frontendPages.items.countdownRunning': 'Counting down',
  'pages.frontendPages.items.countdownOver': 'Passed — shows “Time’s up”',
  'pages.frontendPages.items.countdownNone': 'No countdown',
  'pages.frontendPages.items.countdownPreset1h': 'In 1 hour',
  'pages.frontendPages.items.countdownPreset6h': 'In 6 hours',
  'pages.frontendPages.items.countdownPreset24h': 'In 24 hours',
  'pages.frontendPages.items.countdownPreset3d': 'In 3 days',
  'pages.frontendPages.items.benefitExtra': 'Blue event line (empty uses the broadcast’s slogan)',
  'pages.frontendPages.items.reelsSwitchedToManual': 'Switched to “Pick broadcasts” because you added one. Save to show the picked broadcasts.',
  'pages.frontendPages.items.sessionPickerHint': 'Pick a live to add. Sessions already in the list cannot be added again.',
  'pages.frontendPages.items.sessionPickerReplaceHint': 'Pick a different live for this slot.',
  'pages.frontendPages.items.sessionPickerEmpty': 'No upcoming or live sessions to pick. Create one in Live schedule first.',
  'pages.frontendPages.items.sessionPickerAllSellers': 'All sellers',
  'pages.frontendPages.items.sessionPickerSearch': 'Search product no., title, or seller',
  'pages.frontendPages.items.sessionPickerNoMatch': 'No sessions match.',
  'pages.frontendPages.items.changeSession': 'Change live',
  'pages.frontendPages.items.useThisSession': 'Use this live',
  'pages.frontendPages.items.extraOptional': 'Discount / event text (usually unused)',
  'pages.frontendPages.items.entityReadOnly': 'These values are edited only on their own screen.',
  'pages.frontendPages.items.eventLinkUrl': 'Event link',
  'pages.frontendPages.items.eventText': 'Event text',
  'pages.frontendPages.items.externalId': 'External product ID',
  'pages.frontendPages.items.externalLinkRequired': 'Give either platform + external product ID, or a link.',
  'pages.frontendPages.items.imageMobile': 'Mobile image',
  'pages.frontendPages.items.imagePc': 'Desktop image',
  'pages.frontendPages.items.circleImage': 'Circle image',
  'pages.frontendPages.items.circleImageHint':
    'Shown in the category circle on the storefront. A square photo is cropped to a circle. Leave empty for a grey circle.',
  'pages.frontendPages.items.circleTitle': 'Name under the circle',
  'pages.frontendPages.items.circleBadgeHint': 'Leave empty for no badge. Keep it short, e.g. HOT.',
  'pages.frontendPages.items.landingChanged': 'Landing image changed.',
  'pages.frontendPages.items.landingClearBody': "Once cleared, the card falls back to the product's first image.",
  'pages.frontendPages.items.landingClearTitle': 'Clearing the landing image',
  'pages.frontendPages.items.landingCleared': 'Landing image cleared.',
  'pages.frontendPages.items.landingFailed': 'Failed to change the landing image.',
  'pages.frontendPages.items.landingHint': "The card image is the product's landing image. To use a different picture in this band only, add it as an external card.",
  'pages.frontendPages.items.landingWarnBody': 'The picture is saved on the product. It also becomes the first image on the product detail page and appears on every other page where this product sits.',
  'pages.frontendPages.items.landingWarnOk': 'Change it',
  'pages.frontendPages.items.landingWarnTitle': 'Changing the landing image',
  'pages.frontendPages.items.linkPreview': 'Link preview',
  'pages.frontendPages.items.linkUrl': 'Link',
  'pages.frontendPages.items.liveScheduleEditLink': 'Edit in Live schedule →',
  'pages.frontendPages.items.metricCaption': 'Caption',
  'pages.frontendPages.items.mobileLimit': 'Mobile shows only the first {count}.',
  'pages.frontendPages.items.notImage': 'Only image files can be uploaded.',
  'pages.frontendPages.items.openInNewTab': 'Open in a new tab',
  'pages.frontendPages.items.overLimit': 'Over the slot limit ({count}/{max}). Remove or hide cards to save.',
  'pages.frontendPages.items.pickCoupon': 'Pick a coupon',
  'pages.frontendPages.items.pickLiveSession': 'Pick a live session',
  'pages.frontendPages.items.pickSeller': 'Pick a seller',
  'pages.frontendPages.items.pickStore': 'Pick a store',
  'pages.frontendPages.items.pickTimeSale': 'Pick a time sale',
  'pages.frontendPages.items.pickerExcluded': 'Excluded from cards',
  'pages.frontendPages.items.pickerExcludedHint':
    '{count} products on this page do not meet the public conditions for this scope (visibility, product type) and cannot be added.',
  'pages.frontendPages.items.pickerImage': 'Image',
  'pages.frontendPages.items.pickerLoadFailed': 'Failed to load the product list.',
  'pages.frontendPages.items.productViewRequired':
    'Product management permission is required. The product list cannot be loaded.',
  'pages.frontendPages.items.productEditRequired':
    'This action requires product edit permission.',
  'pages.frontendPages.items.productEditDenied':
    'This action requires product edit permission — the image was not changed.',
  'pages.frontendPages.items.productNamesUnavailable':
    'Without product view permission the cards show ids instead of names. The cards themselves still go out normally.',
  'pages.frontendPages.items.sellerViewRequired':
    'Live seller view permission is required. The seller list cannot be loaded.',
  'pages.frontendPages.items.pickerProduct': 'Product',
  'pages.frontendPages.items.pickerProductNo': 'Product no.',
  'pages.frontendPages.items.pickerScopeHint': 'Shows on-sale products in the {scope} scope only.',
  'pages.frontendPages.items.pickerSearch': 'Search by name or product no.',
  'pages.frontendPages.items.pickerTitle': 'Pick products',
  'pages.frontendPages.items.platform': 'Platform',
  'pages.frontendPages.items.price': 'Price',
  'pages.frontendPages.items.rankDelta': 'Rank change',
  'pages.frontendPages.items.rankDeltaPlaceholder': 'NEW / +2',
  'pages.frontendPages.items.rawRefHint': 'No dedicated picker yet. Copy the ID from the matching admin screen.',
  'pages.frontendPages.items.reelId': 'Short clip ID',
  'pages.frontendPages.items.remove': 'Remove',
  'pages.frontendPages.items.salePrice': 'Sale price',
  'pages.frontendPages.items.scheduleId': 'Schedule ID',
  'pages.frontendPages.items.sessionHidden': 'Hidden',
  'pages.frontendPages.items.sessionProducts': '{count} products',
  'pages.frontendPages.items.storeCopyHint':
    'Photos, name, promo line and featured product are edited in Store management. Under the card photo, the blue line is the event text (it opens the event link) and the black line below it is the badge text. Both apply only to this band.',
  'pages.frontendPages.items.storeEventLinkHint':
    'The event line opens this address. If the line is empty, the card shows an "Event" link.',
  'pages.frontendPages.items.storeBadgeHint':
    'Shown in black under the card photo, on the line after the event text. Leave it empty to show the promo line set in Store management.',
  'pages.frontendPages.items.storeEditLink': 'Edit in Store management →',
  'pages.frontendPages.items.storeEventText': 'Event text (this band only)',
  'pages.frontendPages.items.storeFeatured': 'Featured',
  'pages.frontendPages.items.storeInactive': 'Inactive',
  'pages.frontendPages.items.subtitle': 'Card subtitle',
  'pages.frontendPages.items.timeSaleHidden': 'Hidden',
  'pages.frontendPages.items.title': 'Card title',
  'pages.frontendPages.items.tooLarge': 'The file is too large.',
  'pages.frontendPages.items.upload': 'Upload image',
  'pages.frontendPages.items.uploadFailed': 'Failed to upload the image.',
  'pages.frontendPages.items.uploadSuccess': 'Image uploaded.',
  'pages.frontendPages.items.usedElsewhere': '{count} other pages',
  // fp:layout
  'pages.frontendPages.layout.banner': 'Banner',
  'pages.frontendPages.layout.grid': 'Grid',
  'pages.frontendPages.layout.hero': 'Hero',
  'pages.frontendPages.layout.list': 'List',
  'pages.frontendPages.layout.rail': 'Rail',
  // fp:liveState
  'pages.frontendPages.liveState.all': 'All',
  'pages.frontendPages.liveState.live': 'On air',
  'pages.frontendPages.liveState.recent': 'Recently on air',
  'pages.frontendPages.liveState.scheduled': 'Scheduled',
  // fp:(top)
  'pages.frontendPages.metaMissing': 'The band rules could not be loaded, so saving is off. Please reopen in a moment.',
  'pages.frontendPages.loadErrorNotice': 'The form is locked because the current values could not be read. Saving now would overwrite the SEO text with blanks. Reload first, then edit.',
  'pages.frontendPages.loadErrorNoticeSite': 'The form is locked because the current values could not be read. Saving now would blank all three taglines and reset the Kakao inquiry link to its default. A site save clears every page cache, so those blanks would reach the header right away. Reload first, then edit.',
  // fp:preview
  'pages.frontendPages.preview.autoHint': 'Filled automatically. The real cards are resolved by rule after you save.',
  'pages.frontendPages.preview.blocked': 'This page refuses to load inside a frame. Open it in a new window instead.',
  'pages.frontendPages.preview.deviceHidden': 'Not shown on this device',
  'pages.frontendPages.preview.deviceMobile': 'Mobile {width}',
  'pages.frontendPages.preview.devicePc': 'Desktop {width}',
  'pages.frontendPages.preview.emptySlot': 'No cards',
  'pages.frontendPages.preview.failed': 'Failed to create the preview link.',
  'pages.frontendPages.preview.frameTitle': 'Page preview',
  'pages.frontendPages.preview.includeHidden': 'Include hidden',
  'pages.frontendPages.preview.includeHiddenHint': 'Renders hidden bands and cards too. Visitors still do not see them.',
  'pages.frontendPages.preview.mobile': 'Mobile',
  'pages.frontendPages.preview.mobileCut': 'Cut on mobile',
  'pages.frontendPages.preview.more': 'More',
  'pages.frontendPages.preview.noTitle': '(no title)',
  'pages.frontendPages.preview.openNewWindow': 'Open in a new window',
  'pages.frontendPages.preview.originConfirmed': 'Now showing: {origin} — confirmed by the backend preview response.',
  'pages.frontendPages.preview.originSeed': 'Now showing: {origin} — the value baked into this admin build. Turn on "Include hidden" once to align it with the address the backend actually uses.',
  'pages.frontendPages.preview.pc': 'Desktop',
  'pages.frontendPages.preview.sectionHidden': 'Hidden',
  'pages.frontendPages.preview.title': 'Card preview',
  // fp:(top)
  'pages.frontendPages.previewFailed': 'Failed to create the preview link.',
  'pages.frontendPages.previewUnavailable': 'The preview server (Redis) is unavailable, so no link can be issued.',
  // fp:productScope
  'pages.frontendPages.productScope.all': 'All products',
  'pages.frontendPages.productScope.live': 'Live products',
  'pages.frontendPages.productScope.own': 'Company mall products',
  // fp:(top)
  'pages.frontendPages.readOnlyNotice': 'Read-only. You can see the values but not save them.',
  // fp:refType
  'pages.frontendPages.refType.banner': 'Banner',
  'pages.frontendPages.refType.categoryLink': 'Category link',
  'pages.frontendPages.refType.coupon': 'Coupon',
  'pages.frontendPages.refType.external': 'External product',
  'pages.frontendPages.refType.liveStatus': 'Live session',
  'pages.frontendPages.refType.metric': 'Caption line',
  'pages.frontendPages.refType.product': 'Product',
  'pages.frontendPages.refType.reel': 'Short clip',
  'pages.frontendPages.refType.schedule': 'Schedule',
  'pages.frontendPages.refType.seller': 'Seller',
  'pages.frontendPages.refType.store': 'Store',
  'pages.frontendPages.refType.timeSale': 'Time sale',
  // fp:(top)
  'pages.frontendPages.reorderFailed': 'Failed to update the order.',
  'pages.frontendPages.reload': 'Reload',
  'pages.frontendPages.reordered': 'Order updated.',
  // fp:salesMetric
  'pages.frontendPages.salesMetric.hidden': 'Do not show',
  'pages.frontendPages.salesMetric.liveSoldAmountSum': 'Live sales amount',
  'pages.frontendPages.salesMetric.totalItemsSold': 'Total items sold',
  // fp:(top)
  'pages.frontendPages.saveAndPreview': 'Save and preview page',
  'pages.frontendPages.saveBlockedByLoad': 'The current values could not be read. Reload before saving.',
  'pages.frontendPages.savedWithAdvisory': 'Some products are missing from {count} cards.',
  // fp:schedule
  'pages.frontendPages.schedule.addSession': 'Add session',
  'pages.frontendPages.schedule.assignTime': 'Set time',
  'pages.frontendPages.schedule.assignTimeTitle': 'Set start time',
  'pages.frontendPages.schedule.cancel': 'Cancel',
  'pages.frontendPages.schedule.column.actions': 'Actions',
  'pages.frontendPages.schedule.column.date': 'Date',
  'pages.frontendPages.schedule.column.productCount': 'Products',
  'pages.frontendPages.schedule.column.seller': 'Seller',
  'pages.frontendPages.schedule.column.source': 'Source',
  'pages.frontendPages.schedule.column.time': 'Time',
  'pages.frontendPages.schedule.column.title': 'Title',
  'pages.frontendPages.schedule.column.visible': 'Visible',
  'pages.frontendPages.schedule.convert': 'Convert to session',
  'pages.frontendPages.schedule.convertHideFailed': 'The session was created, but the legacy schedule could not be hidden.',
  'pages.frontendPages.schedule.convertHint': 'Create a new session from this legacy schedule.',
  'pages.frontendPages.schedule.convertNotice': 'Saving creates a new session and hides the original legacy schedule.',
  'pages.frontendPages.schedule.convertSuccess': 'Converted to a session.',
  'pages.frontendPages.schedule.delete': 'Delete',
  'pages.frontendPages.schedule.deleteConfirm': 'Delete this schedule?',
  'pages.frontendPages.schedule.deleteContentLegacy': 'Deleting a legacy schedule cannot be undone.',
  'pages.frontendPages.schedule.deleteContentSession': 'The session will also disappear from the spotlight on the storefront.',
  'pages.frontendPages.schedule.deleteFailed': 'Failed to delete.',
  'pages.frontendPages.schedule.deleteSuccess': 'Deleted.',
  'pages.frontendPages.schedule.edit': 'Edit',
  'pages.frontendPages.schedule.editLegacy': 'Edit legacy schedule',
  'pages.frontendPages.schedule.editSession': 'Edit session',
  'pages.frontendPages.schedule.emptyDay': 'None',
  'pages.frontendPages.schedule.field.endAt': 'End time',
  'pages.frontendPages.schedule.field.endAtPlaceholder': 'Select end time',
  'pages.frontendPages.schedule.field.mainImage': 'Spotlight main image',
  'pages.frontendPages.schedule.field.mainImageHint': 'The large portrait image shown in the spotlight. A 3:4 ratio is recommended.',
  'pages.frontendPages.schedule.field.periodHint': 'Times are in Korean time. A session created without a start time is saved as time TBD. But once a start time is set it cannot be cleared here — emptying the field and saving leaves the stored time untouched. To call off a broadcast, turn its visibility off or delete it.',
  'pages.frontendPages.schedule.field.products': 'Live products',
  'pages.frontendPages.schedule.field.productsHint': 'Pick up to 3 products for the spotlight. They appear in the order you pick them.',
  'pages.frontendPages.schedule.field.seller': 'Seller',
  'pages.frontendPages.schedule.field.sellerPlaceholder': 'Search by seller name or code',
  'pages.frontendPages.schedule.field.slogan': 'Slogan',
  'pages.frontendPages.schedule.field.sloganHint': 'A short line shown over the spotlight image.',
  'pages.frontendPages.schedule.field.sloganPlaceholder': 'e.g. Today only at this price',
  'pages.frontendPages.schedule.field.spotlightLabel': 'Spotlight label',
  'pages.frontendPages.schedule.field.spotlightLabelHint': 'A short tag shown above the spotlight.',
  'pages.frontendPages.schedule.field.spotlightLabelPlaceholder': 'e.g. Live today',
  'pages.frontendPages.schedule.field.startAt': 'Start time',
  'pages.frontendPages.schedule.field.startAtPlaceholder': 'Select start time',
  'pages.frontendPages.schedule.field.thumbnail': 'Live chance card image',
  'pages.frontendPages.schedule.field.thumbnailHint': 'The square image used on the live chance card. A 1:1 ratio is recommended.',
  'pages.frontendPages.schedule.field.title': 'Live title',
  'pages.frontendPages.schedule.field.titlePlaceholder': 'Enter the live title',
  'pages.frontendPages.schedule.field.visible': 'Visible',
  'pages.frontendPages.schedule.filteredByDate': 'Only {date}',
  'pages.frontendPages.schedule.intro': 'These are the live sessions shown on the storefront live page.',
  'pages.frontendPages.schedule.introDetail': 'The date cells show ten days, from 3 days before today to 6 days after. Sessions and legacy schedules are listed together, and all times are in Korean time.',
  'pages.frontendPages.schedule.legacyHint': 'This is a legacy schedule entered by the seller. Only the title, times and visibility can be changed.',
  'pages.frontendPages.schedule.legacyUnavailable': 'The legacy schedule list could not be loaded, so only sessions are shown.',
  'pages.frontendPages.schedule.loadFailed': 'Failed to load the schedule.',
  'pages.frontendPages.schedule.missingAlert': 'Sessions with no start time: {count}.',
  'pages.frontendPages.schedule.missingChipHint': 'Click to filter',
  'pages.frontendPages.schedule.missingHint': 'A session with no start time does not sit in any date cell. Set a start time and it moves into that date cell. Times are in Korean time.',
  'pages.frontendPages.schedule.missingOnly': 'Time TBD only',
  'pages.frontendPages.schedule.nextWeek': 'Next week',
  'pages.frontendPages.schedule.prevWeek': 'Previous week',
  'pages.frontendPages.schedule.productPicker.empty': 'No products picked yet.',
  'pages.frontendPages.schedule.productPicker.excluded': 'Excluded from card',
  'pages.frontendPages.schedule.productPicker.excludedHint': 'Hidden or not on sale, so it does not appear on the storefront card.',
  'pages.frontendPages.schedule.productPicker.limit': 'You can add up to {max} products.',
  'pages.frontendPages.schedule.productPicker.moveDown': 'Move down',
  'pages.frontendPages.schedule.productPicker.moveUp': 'Move up',
  'pages.frontendPages.schedule.productPicker.remove': 'Remove',
  'pages.frontendPages.schedule.productPicker.search': 'Search by name or product no.',
  'pages.frontendPages.schedule.readOnly':
    'This is view-only. Editing requires front page edit or live seller edit permission.',
  'pages.frontendPages.schedule.uploadNoPermission':
    'Uploading images requires product edit permission.',
  'pages.frontendPages.schedule.productPicker.noPermission':
    'Without product management permission products cannot be picked.',
  'pages.frontendPages.schedule.refresh': 'Refresh',
  'pages.frontendPages.schedule.save': 'Save',
  'pages.frontendPages.schedule.saveFailed': 'Failed to save.',
  'pages.frontendPages.schedule.saveSuccess': 'Saved.',
  'pages.frontendPages.schedule.sellerFilterAll': 'All sellers',
  'pages.frontendPages.schedule.source.legacy': 'Legacy',
  'pages.frontendPages.schedule.source.missing': 'Time TBD',
  'pages.frontendPages.schedule.source.session': 'Session',
  'pages.frontendPages.schedule.stripHint': 'Click a cell to see only that date. Times are in Korean time.',
  'pages.frontendPages.schedule.stripTitle': 'Lives by date',
  'pages.frontendPages.schedule.tableEmpty': 'No schedules.',
  'pages.frontendPages.schedule.today': 'Today',
  'pages.frontendPages.schedule.todayBadge': 'Today',
  'pages.frontendPages.schedule.upload': 'Upload image',
  'pages.frontendPages.schedule.uploadChange': 'Change image',
  'pages.frontendPages.schedule.uploadClear': 'Clear',
  'pages.frontendPages.schedule.uploadFailed': 'Failed to upload the image.',
  'pages.frontendPages.schedule.uploadNotImage': 'Only image files can be uploaded.',
  'pages.frontendPages.schedule.uploadSuccess': 'Image uploaded.',
  'pages.frontendPages.schedule.uploadTooLarge': 'The image must be 10MB or smaller.',
  'pages.frontendPages.schedule.validate.periodOrder': 'The end time must be later than the start time.',
  'pages.frontendPages.schedule.validate.productRequired': 'Pick at least one product.',
  'pages.frontendPages.schedule.validate.sellerRequired': 'Select a seller.',
  'pages.frontendPages.schedule.validate.startRequired': 'Select a start time.',
  'pages.frontendPages.schedule.validate.titleRequired': 'Enter a title.',
  'pages.frontendPages.schedule.visibleUpdateFailed': 'Failed to change the visibility.',
  // fp:sectionType
  'pages.frontendPages.sectionType.banner.desc': 'A single-image strip banner.',
  'pages.frontendPages.sectionType.banner.name': 'Banner',
  'pages.frontendPages.sectionType.categoryGroups.desc': 'Category link cards split into groups (slots). 1–10 slots.',
  'pages.frontendPages.sectionType.categoryGroups.name': 'Category groups',
  'pages.frontendPages.sectionType.categoryTabs.desc': 'Category tabs that swap the product list underneath.',
  'pages.frontendPages.sectionType.categoryTabs.name': 'Category tabs',
  'pages.frontendPages.sectionType.coupon.desc': 'A row of claimable coupon cards.',
  'pages.frontendPages.sectionType.coupon.name': 'Coupon',
  'pages.frontendPages.sectionType.eventTicker.desc': 'Event banners scrolling through a narrow strip.',
  'pages.frontendPages.sectionType.eventTicker.name': 'Event ticker',
  'pages.frontendPages.sectionType.heroLive.desc': 'The big short clip at the top of the live page.',
  'pages.frontendPages.sectionType.heroLive.name': 'Live hero',
  'pages.frontendPages.sectionType.heroTriple.desc': 'A first screen split into a left feature, a carousel, and two right cells. Manual only.',
  'pages.frontendPages.sectionType.heroTriple.name': 'Triple hero',
  'pages.frontendPages.sectionType.liveChance.desc': 'Live session cards split by chips. The first chip is fixed to "All"; up to 6 chips.',
  'pages.frontendPages.sectionType.liveChance.name': 'Live chance',
  'pages.frontendPages.sectionType.liveNow.desc': 'A row of sellers who are on air.',
  'pages.frontendPages.sectionType.liveNow.name': 'On air now',
  'pages.frontendPages.sectionType.moreToLove.desc': 'A product grid at the foot of the page that keeps loading more. Up to 60.',
  'pages.frontendPages.sectionType.moreToLove.name': 'More to love',
  'pages.frontendPages.sectionType.productColumns.desc': 'Three columns with two products each. Manual only.',
  'pages.frontendPages.sectionType.productColumns.name': 'Product columns',
  'pages.frontendPages.sectionType.productGrid.desc': 'Product cards laid out in a grid.',
  'pages.frontendPages.sectionType.productGrid.name': 'Product grid',
  'pages.frontendPages.sectionType.productRail.desc': 'Product cards in a single horizontally scrolling row.',
  'pages.frontendPages.sectionType.productRail.name': 'Product rail',
  'pages.frontendPages.sectionType.ranking.desc': 'A ranking split into today / 3 days / 1 week tabs. 10 per slot, 4 on mobile.',
  'pages.frontendPages.sectionType.ranking.name': 'Ranking',
  'pages.frontendPages.sectionType.reels.desc': 'Broadcast cards like Live Chance, with a blue short-clip badge, swiped sideways. Up to 12.',
  'pages.frontendPages.sectionType.reels.name': 'Short clips',
  'pages.frontendPages.sectionType.schedule.desc': 'Upcoming broadcasts laid out by time.',
  'pages.frontendPages.sectionType.schedule.name': 'Broadcast schedule',
  'pages.frontendPages.sectionType.sellerRail.desc': 'Seller profile cards in a row. You choose which sales figure to show.',
  'pages.frontendPages.sectionType.sellerRail.name': 'Seller rail',
  'pages.frontendPages.sectionType.sellerRanking.desc': 'Seller broadcast cards with rank badges. A saved seller list keeps that order; an empty list ranks by total views or sales. Up to 20 sellers.',
  'pages.frontendPages.sectionType.sellerRanking.name': 'Popular BEST sellers',
  'pages.frontendPages.sectionType.sellerSpotlight.desc':
    'Live sellers as large portrait cards. Pick products per seller. Up to 10.',
  'pages.frontendPages.sectionType.sellerSpotlight.name': 'Live seller carousel',
  'pages.frontendPages.sectionType.storeRail.desc': 'Store cards in a row. Up to 12.',
  'pages.frontendPages.sectionType.storeRail.name': 'Featured stores',
  'pages.frontendPages.sectionType.productTabs.desc': 'A product rail whose chips (tabs) each carry their own product conditions. 1–8 tabs, up to 20 per tab.',
  'pages.frontendPages.sectionType.productTabs.name': 'Product tabs',
  'pages.frontendPages.sectionType.categoryShowcase.desc': 'A category row plus the chosen category’s sub-tabs and product row. Up to 12 categories; leave it empty and every top-level category is shown. Products are added per sub-tab.',
  'pages.frontendPages.sectionType.categoryShowcase.name': 'Category showcase',
  'pages.frontendPages.sectionType.marketShowcase.desc': 'Provider tabs (1688 · Taobao · VVIC) with marketplace category chips, sub-tabs and a product rail. Up to 20 chips per provider; a chip with no cards searches the platform for the category name.',
  'pages.frontendPages.sectionType.marketShowcase.name': 'Marketplace category products',
  'pages.frontendPages.sectionType.ticker.desc': 'A strip of short lines scrolling past. Manual only.',
  'pages.frontendPages.sectionType.ticker.name': 'Text ticker',
  'pages.frontendPages.sectionType.timeSale.desc': 'Benefit cards: a broadcast card with a countdown strip under the photo, each with its own end time. Up to 12.',
  'pages.frontendPages.sectionType.timeSale.name': 'Live benefits',
  // fp:settings
  'pages.frontendPages.settings.notSavedYet': 'No settings are stored for this page yet. What you see are the defaults.',
  'pages.frontendPages.settings.previewCard': 'Preview',
  'pages.frontendPages.settings.seoCard': 'Search listing',
  'pages.frontendPages.settings.seoDescription': 'Page description',
  'pages.frontendPages.settings.seoDescriptionHint': 'Shows under the title in search results. About two lines works best.',
  'pages.frontendPages.settings.seoTitle': 'Page title',
  'pages.frontendPages.settings.seoTitleHint': 'Used for the browser tab and the search result title.',
  // fp:site
  'pages.frontendPages.site.advanced': 'Advanced',
  'pages.frontendPages.site.categoryLimit.en': 'English',
  'pages.frontendPages.site.categoryLimit.ko': 'Korean',
  'pages.frontendPages.site.categoryLimit.zh': 'Chinese',
  'pages.frontendPages.site.categoryLimitHint': 'How many categories the header shows. Names differ in length per language, so each is set separately.',
  'pages.frontendPages.site.categorySourceHint': 'The categories themselves are edited in Products › Categories.',
  'pages.frontendPages.site.headerTagline': 'Header tagline',
  'pages.frontendPages.site.headerTaglineHint': 'Sits on the top line of the header and hides as the visitor scrolls.',
  'pages.frontendPages.site.headerTaglineMobile': 'Mobile tagline (optional)',
  'pages.frontendPages.site.headerTaglineMobileHint': 'Leave empty to reuse the tagline above. Keep it short — mobile is narrow.',
  'pages.frontendPages.site.headerTaglinePlaceholder': 'e.g. Live shopping at the day’s best price',
  'pages.frontendPages.site.kakaoInquiryUrl': 'KakaoTalk inquiry link',
  'pages.frontendPages.site.kakaoInquiryUrlHint': 'The inquiry buttons in the header and footer open this address.',
  'pages.frontendPages.site.notSavedYet': 'No common settings are stored yet. What you see are the defaults.',
  'pages.frontendPages.site.scopeNotice': 'Changes here apply to every page.',
  'pages.frontendPages.site.urlWarning': 'This does not look like an http:// or https:// address.',
  // fp:slotKey
  'pages.frontendPages.slotKey.1w': '1 week',
  'pages.frontendPages.slotKey.3d': '3 days',
  'pages.frontendPages.slotKey.all': 'All',
  'pages.frontendPages.slotKey.carousel': 'Carousel',
  'pages.frontendPages.slotKey.col1': 'Column 1',
  'pages.frontendPages.slotKey.col2': 'Column 2',
  'pages.frontendPages.slotKey.col3': 'Column 3',
  'pages.frontendPages.slotKey.left': 'Left feature',
  'pages.frontendPages.slotKey.rightBottom': 'Bottom right',
  'pages.frontendPages.slotKey.rightTop': 'Top right',
  'pages.frontendPages.slotKey.today': 'Today',
  // fp:slotVariant
  'pages.frontendPages.slotVariant.chance': 'Live chance',
  'pages.frontendPages.slotVariant.plain': 'Plain',
  'pages.frontendPages.slotVariant.ranking': 'Ranking',
  'pages.frontendPages.slotVariant.store': 'Store',
  // fp:autoFill
  'pages.frontendPages.autoFill.title': 'Empty slots are filled automatically',
  'pages.frontendPages.autoFill.body':
    'No cards here yet. After you save, the server fills matching items automatically. To curate manually, add cards with the buttons below.',
  'pages.frontendPages.autoFill.tab': 'Auto',
  // fp:slots
  'pages.frontendPages.slots.allChipHint': 'The first chip is "All". It shows every session with no category filter.',
  'pages.frontendPages.slots.allChipLocked': 'The "All" chip cannot be removed.',
  'pages.frontendPages.slots.badgeText': 'Badge',
  'pages.frontendPages.slots.chipCategories': 'Categories for this chip',
  'pages.frontendPages.slots.chipCategoryHint': 'Auto mode filters by the categories of the session products. Quick-registered products may have none, so manual assignment is safer.',
  'pages.frontendPages.slots.tabFlags': 'Product conditions for this tab',
  'pages.frontendPages.slots.tabFlagsHint': 'In auto mode, products matching every chosen condition fill this tab. Leave it empty to apply only the section filter.',
  'pages.frontendPages.slots.chipRootCategory': 'Category',
  'pages.frontendPages.slots.chipRootCategoryHint': 'Only top-level categories can be picked. The storefront sub-tabs are built from its child categories; add each tab’s products below.',
  'pages.frontendPages.slots.chipPlatform': 'Marketplace for this chip',
  'pages.frontendPages.slots.chipMarketCategory': 'Category',
  'pages.frontendPages.slots.chipMarketCategorySearch': 'Search by category name',
  'pages.frontendPages.slots.chipMarketCategoryHint': 'Lists the category-management categories that have children (search by name). Sub-tabs are built from its children, and a chip with no cards shows a platform search for the category name. Leave it empty to search by the chip name.',
  'pages.frontendPages.items.importLink': 'Product link',
  'pages.frontendPages.items.importLinkAction': 'Fetch',
  'pages.frontendPages.items.importLinkHint': 'Paste a 1688 / Taobao / VVIC product URL and press Fetch to fill the platform, product id, title, image and price. You can still edit the fields below.',
  'pages.frontendPages.items.importLinkInvalid': 'Not a 1688 / Taobao / VVIC product URL.',
  'pages.frontendPages.items.importLinkDone': 'Product details fetched.',
  'pages.frontendPages.items.importLinkFailed': 'Could not fetch the product details.',
  'pages.frontendPages.slots.chipCategoryRequired': 'Auto mode needs at least one category. Left empty, this chip shows the same list as "All".',
  'pages.frontendPages.slots.duplicateKey': 'That slot key is already in use.',
  'pages.frontendPages.slots.iconUrl': 'Icon',
  'pages.frontendPages.slots.iconUrlHint': 'The storefront renders this as an image. Use an image URL, not an emoji.',
  'pages.frontendPages.slots.groupImage': 'Group circle image',
  'pages.frontendPages.slots.groupImageHint':
    'Shown in the group circle on the storefront. A square photo is cropped to a circle. Leave empty to show the name inside the circle.',
  'pages.frontendPages.slots.key': 'Slot key',
  'pages.frontendPages.slots.legacyNoSlots': 'This band has no slots yet. Once you save slots, the existing cards move into the first one, and saving is rejected if that exceeds the per-slot limit.',
  'pages.frontendPages.slots.minSlots': 'At least {min} slots are required.',
  'pages.frontendPages.slots.moveLeft': '← Move left',
  'pages.frontendPages.slots.moveRight': 'Move right →',
  'pages.frontendPages.slots.noItemsSection': 'This band holds no cards. It pulls data from another screen by rule.',
  'pages.frontendPages.slots.noItemsSlot': 'This slot holds no cards.',
  'pages.frontendPages.slots.pickTypeFirst': 'Pick a type first.',
  'pages.frontendPages.slots.productScope': 'Product scope',
  'pages.frontendPages.slots.rankingAutoHint': 'In auto mode the period tabs (today / 3 days / 1 week) hold no cards. The values below are read-only; switch to manual mode to edit them.',
  'pages.frontendPages.slots.scopeInherit': 'Inherit from band',
  'pages.frontendPages.slots.title': 'Label',
  'pages.frontendPages.slots.subtitle': 'Subtitle',
  'pages.frontendPages.slots.titleMobile': 'Mobile label',
  'pages.frontendPages.slots.variant': 'Card style',
  // fp:sortBy
  'pages.frontendPages.sortBy.price_asc': 'Price: low to high',
  'pages.frontendPages.sortBy.price_desc': 'Price: high to low',
  'pages.frontendPages.sortBy.rank': 'Recommended',
  'pages.frontendPages.sortBy.recent': 'Newest',
  'pages.frontendPages.sortBy.sold': 'Best selling',
  'pages.frontendPages.sortBy.views': 'Most watched',
  // fp:sourceMode
  'pages.frontendPages.sourceMode.auto': 'Automatic',
  'pages.frontendPages.sourceMode.manual': 'Manual',
  // fp:(top)
  'pages.frontendPages.typeChangeConfirmBody': '{count} card(s) the new type does not accept, and the current slot layout, are dropped. This cannot be undone.',
  'pages.frontendPages.typeChangeConfirmOk': 'Change it',
  'pages.frontendPages.typeChangeConfirmTitle': 'Change the band type',
  'pages.frontendPages.typeChangeDroppedItems': 'Cards the new type does not accept were removed from the list.',
  // fp:usedElsewhere
  'pages.frontendPages.unsaved.blockedNote': '{count} card(s) that do not reach the storefront are still in place.',
  'pages.frontendPages.unsaved.body': 'Closing now discards everything you changed. Close anyway?',
  'pages.frontendPages.unsaved.discard': 'Close',
  'pages.frontendPages.unsaved.keepEditing': 'Keep editing',
  'pages.frontendPages.unsaved.title': 'You have unsaved changes',
  'pages.frontendPages.usedElsewhere.badge': '{count} other pages',
  'pages.frontendPages.usedElsewhere.failed': 'Could not read the other pages.',
  'pages.frontendPages.usedElsewhere.hint': 'The same products or stores sit on several pages. Removing one here leaves the others in place.',
  'pages.frontendPages.usedElsewhere.pagesOnly': 'Pages only for now. The exact bands will appear in a moment.',
  'pages.frontendPages.usedElsewhere.retry': 'Try again',
  'pages.frontendPages.usedElsewhere.title': 'Where these cards also appear',
  // fp:validation
  'pages.frontendPages.validation.captionRequired': 'Fill in the caption on {card}.',
  'pages.frontendPages.validation.cardAt': '{slot} · card {index}',
  'pages.frontendPages.validation.cardAtNoSlot': 'card {index}',
  'pages.frontendPages.validation.chipCategoryRequired': 'Chip "{slot}" needs at least one category.',
  'pages.frontendPages.validation.externalHalf': '{card} needs both a platform and an external product ID.',
  'pages.frontendPages.validation.externalLink': '{card} has no link that can be opened.',
  'pages.frontendPages.validation.imageRequired': 'Add an image to {card}.',
  'pages.frontendPages.validation.linkRequired': 'Set where {card} links to.',
  'pages.frontendPages.validation.overLimit': 'This band is over its card limit ({count}/{max}).',
  'pages.frontendPages.validation.refRequired': 'Pick what {card} should point to.',
  'pages.frontendPages.validation.slotOverLimit': 'Slot "{slot}" is over its card limit ({count}/{max}).',
  'pages.frontendPages.validation.sectionOverLimit': 'This block holds up to {max} cards (now {count}).',
  'pages.frontendPages.validation.titleRequired': 'Add a title to {card}.',
  'pages.frontendPages.validation.unknownType': 'No rules found for this type.',
  // fp:(top)
  'pages.frontendPages.viewOnlyTooltip': 'Opens read-only. You can see the values but not save them.',
  // bannerAdvertisement:carousel
  'pages.bannerAdvertisement.carousel.openInNewTab': 'New tab',
  'pages.bannerAdvertisement.carousel.pageKey': 'Page',
  'pages.bannerAdvertisement.carousel.pageKeyAll': 'All pages',
  'pages.bannerAdvertisement.carousel.pageKeyHome': 'Recommended',
  'pages.bannerAdvertisement.carousel.pageKeyLive': 'Live',
  'pages.bannerAdvertisement.carousel.pageKeyOverseas': 'Overseas',
  'pages.bannerAdvertisement.carousel.pageKeyOwnmall': 'Company mall',
  'pages.bannerAdvertisement.carousel.pageKeyTooltip': 'The public page this banner is attached to.',
  'pages.bannerAdvertisement.carousel.period': 'Display period',
  'pages.bannerAdvertisement.carousel.periodAlways': 'Always',
  'pages.bannerAdvertisement.carousel.periodTooltip': 'Leave empty to show it always. Times are Korean time.',
  // products:add
  'pages.products.add.landingImage': 'Landing image (optional)',
  'pages.products.add.landingImageAfterCreate': 'It is applied once the product itself is saved.',
  'pages.products.add.landingImageChange': 'Change image',
  'pages.products.add.landingImageClear': 'Clear',
  'pages.products.add.landingImageHeavy': 'The image is heavy. A smaller upload is better.',
  'pages.products.add.landingImageHint': "Used for recommendation and live cards and as the first image on the detail page. Left empty, the product's first image is used.",
  'pages.products.add.landingImageNotImage': 'Only image files can be uploaded',
  'pages.products.add.landingImageRecommend': 'Recommended',
  'pages.products.add.landingImageSaveFailed': 'Failed to save the landing image. The product itself was saved.',
  'pages.products.add.landingImageTooLarge': 'The image is too large (10MB max)',
  'pages.products.add.landingImageVariants': 'Variants',
  'pages.products.add.requiredFieldsError': 'Please fill in required fields',
  'pages.products.add.uploadError': 'Failed to upload image',
  // products:category
  'pages.products.category.addCategory': 'Add category',
  'pages.products.category.deleteError': 'Failed to delete category',
  'pages.products.category.level1Required': 'Please select a top-level category',
  // products:list
  'pages.products.list.landingBadge': 'Landing',
  'pages.products.list.setStoreRepresentative': 'Store feature',
  'pages.products.list.setStoreRepresentativeConfirm': 'Show this product as the store card’s featured item?',
  'pages.products.list.setStoreRepresentativeFailed': 'Could not set the featured product.',
  'pages.products.list.setStoreRepresentativeSuccess': 'Set as the store’s featured product.',
  'pages.products.list.storeRepresentativeBadge': 'Store feature',
  // products:store
  'pages.products.store.avatarImage': 'Round image',
  'pages.products.store.avatarImageHint': 'Used in the round slot on the store card and in the seller list.',
  'pages.products.store.basicSection': 'Basics',
  'pages.products.store.cardPreview': 'Card preview',
  'pages.products.store.cardSection': 'Featured card',
  'pages.products.store.changeImage': 'Change image',
  'pages.products.store.clearImage': 'Clear',
  'pages.products.store.cropHint': 'Only the area inside the orange dashed line (316:185) shows on the card. Drag the photo to choose it.',
  'pages.products.store.eventLinkInvalid': 'That is not a valid address',
  'pages.products.store.eventLinkUrl': 'Event link',
  'pages.products.store.eventText': 'Event text',
  'pages.products.store.eventTextPlaceholder': 'Gift with purchase',
  'pages.products.store.featuredHint': 'This applies when the featured store band is in automatic mode.',
  'pages.products.store.featuredOff': 'Hidden',
  'pages.products.store.featuredOn': 'Shown',
  'pages.products.store.featuredOnHome': 'Show on the recommended page',
  'pages.products.store.heavyImage': 'The image is heavy. A smaller upload is better.',
  'pages.products.store.homeSortOrder': 'Sort order',
  'pages.products.store.homeSortOrderHint': 'Lower numbers come first.',
  'pages.products.store.orderButton': 'Arrange order',
  'pages.products.store.orderTitle': 'Arrange store order',
  'pages.products.store.orderHint': 'Drag to reorder, then save. The all-stores page (featured stores View more) and a featured-store rail with no stores picked follow this order. Stores with featured off come after featured ones, and inactive stores are not listed.',
  'pages.products.store.orderFeatured': 'Featured',
  'pages.products.store.orderNotFeatured': 'Not featured',
  'pages.products.store.orderDragHandle': 'Drag to reorder',
  'pages.products.store.orderSaved': 'Store order saved.',
  'pages.products.store.orderSaveFailed': 'Could not save the store order.',
  'pages.products.store.orderEmpty': 'There are no active stores to arrange.',
  'pages.products.store.imageSection': 'Images',
  'pages.products.store.imageTooLarge': 'The image is too large (10MB max)',
  'pages.products.store.mainImage': 'Main wide image',
  'pages.products.store.mainImageHint': 'The large landscape photo on the featured store card.',
  'pages.products.store.promoText': 'Promo text',
  'pages.products.store.promoTextPlaceholder': '10% off during the autumn new-arrival live',
  'pages.products.store.recommendSize': 'Recommended',
  'pages.products.store.representativeEmpty': 'This store has no products.',
  'pages.products.store.representativeHint': 'Pick one product to show alongside the store card. The product list only shows a "Store feature" badge.',
  'pages.products.store.representativeNone': 'None',
  'pages.products.store.representativeProduct': 'Featured product',
  'pages.products.store.representativeSaveFirst': 'Save the store first, then you can pick a featured product.',
  'pages.products.store.uploadImageOnly': 'Only image files can be uploaded',
  'pages.products.store.variants': 'Variants',

  // Main Rolling Banner
  'pages.homepage.mainRollingBanner.title': 'Main Rolling Banner',
  'pages.homepage.mainRollingBanner.list': 'Banner List',
  'pages.homepage.banner.add': 'Add Banner',
  'pages.homepage.banner.order': 'Change Order',
  'pages.homepage.banner.image': 'Image',
  'pages.homepage.banner.title': 'Title',
  'pages.homepage.banner.url': 'URL',
  'pages.homepage.banner.displayType': 'Display Type',
  'pages.homepage.banner.registrationType': 'Registration Type',
  'pages.homepage.banner.targetType': 'Target',
  'pages.homepage.banner.actions': 'Actions',
  'pages.homepage.banner.edit': 'Edit',
  'pages.homepage.banner.delete': 'Delete',
  'pages.homepage.banner.addModal': 'Add/Edit Banner',
  'pages.homepage.banner.editModal': 'Edit Banner',
  'pages.homepage.banner.orderModal': 'Reorder Banners',
  'pages.homepage.banner.form.displayType': 'Display Type',
  'pages.homepage.banner.form.displayTypePlaceholder': 'Main>Rolling Banner',
  'pages.homepage.banner.form.displayTypeRequired': 'Please select display type',
  'pages.homepage.banner.form.registrationType': 'Registration Type',
  'pages.homepage.banner.form.registrationTypePlaceholder': 'Select registration type',
  'pages.homepage.banner.form.registrationTypeRequired': 'Please select registration type',
  'pages.homepage.banner.form.title': 'Title',
  'pages.homepage.banner.form.titlePlaceholder': 'Enter title',
  'pages.homepage.banner.form.titleRequired': 'Please enter title',
  'pages.homepage.banner.form.image': 'Image',
  'pages.homepage.banner.form.imageUpload': 'Choose file',
  'pages.homepage.banner.form.url': 'URL',
  'pages.homepage.banner.form.urlPlaceholder': 'Enter URL',
  'pages.homepage.banner.form.usageStatus': 'Usage Status',
  'pages.homepage.banner.form.usageStatusPlaceholder': 'Use',
  'pages.homepage.banner.form.usageStatusRequired': 'Please select usage status',
  'pages.homepage.banner.form.usageStatus.use': 'Use',
  'pages.homepage.banner.form.usageStatus.notUse': 'Not Use',
  'pages.homepage.banner.form.target': 'Target',
  'pages.homepage.banner.form.targetPlaceholder': 'Select',
  'pages.homepage.banner.form.targetRequired': 'Please select target',
  'pages.homepage.banner.form.target.oneself': 'Oneself',
  'pages.homepage.banner.form.target.newWindow': 'New Window',
  'pages.homepage.banner.form.period': 'Period',
  'pages.homepage.banner.orderModal.instruction': 'Drag and drop to reorder banners',
  'pages.homepage.banner.orderModal.header.management': 'Banner Management',
  'pages.homepage.banner.orderModal.header.type': 'Main>Rolling Banner',
  'pages.homepage.banner.message.added': 'Banner added successfully',
  'pages.homepage.banner.message.updated': 'Banner updated successfully',
  'pages.homepage.banner.message.deleted': 'Banner deleted successfully',
  'pages.homepage.banner.message.orderChanged': 'Order changed',
  'pages.homepage.banner.message.orderSaved': 'Order saved successfully',
  'pages.homepage.banner.message.editInfo': 'Edit feature',
  'pages.homepage.banner.confirm.deleteTitle': 'Confirm Delete',
  'pages.homepage.banner.confirm.deleteContent': 'Are you sure you want to delete this banner?',

  // Homepage - Recommended Products
  'pages.homepage.recommendedProducts.title': 'Recommended Products Management',
  'pages.homepage.product.order': 'Order',
  'pages.homepage.product.image': 'Image',
  'pages.homepage.product.recommendationType': 'Recommendation Type',
  'pages.homepage.product.name': 'Product Name',
  'pages.homepage.product.country': 'Country',
  'pages.homepage.product.price': 'Price',
  'pages.homepage.product.category': 'Category',
  'pages.homepage.product.actions': 'Actions',
  'pages.homepage.product.add': 'Add/Edit Recommended Product',
  'pages.homepage.product.edit': 'Edit',
  'pages.homepage.product.delete': 'Delete',
  'pages.homepage.product.addModal': 'Add/Edit Recommended Product',
  'pages.homepage.product.editModal': 'Add/Edit Recommended Product',
  'pages.homepage.product.form.recommendationType': 'Recommendation Type',
  'pages.homepage.product.form.recommendationTypePlaceholder': 'Select',
  'pages.homepage.product.form.recommendationTypeRequired': 'Please select recommendation type',
  'pages.homepage.product.form.productName': 'Product Name',
  'pages.homepage.product.form.productNamePlaceholder': 'Enter product name',
  'pages.homepage.product.form.productNameRequired': 'Please enter product name',
  'pages.homepage.product.form.productUrl': 'Product URL',
  'pages.homepage.product.form.productUrlPlaceholder': 'Enter product URL',
  'pages.homepage.product.form.country': 'Country',
  'pages.homepage.product.form.countryPlaceholder': 'Select',
  'pages.homepage.product.form.countryRequired': 'Please select country',
  'pages.homepage.product.form.price': 'Price',
  'pages.homepage.product.form.pricePlaceholder': '0',
  'pages.homepage.product.form.priceRequired': 'Please enter price',
  'pages.homepage.product.form.category': 'Category',
  'pages.homepage.product.form.categoryPlaceholder': 'Enter category',
  'pages.homepage.product.form.image': 'Product Image',
  'pages.homepage.product.form.imageUpload': 'Choose file',
  'pages.homepage.product.type.hotDeal': 'Hot Deal',
  'pages.homepage.product.type.newArrival': 'New Arrival',
  'pages.homepage.product.type.bestSeller': 'Best Seller',
  'pages.homepage.product.type.featured': 'Featured',
  'pages.homepage.product.country.china': 'China',
  'pages.homepage.product.country.korea': 'Korea',
  'pages.homepage.product.country.usa': 'USA',
  'pages.homepage.product.country.japan': 'Japan',
  'pages.homepage.product.message.added': 'Product added successfully',
  'pages.homepage.product.message.updated': 'Product updated successfully',
  'pages.homepage.product.message.deleted': 'Product deleted successfully',
  'pages.homepage.product.confirm.deleteTitle': 'Delete Product',
  'pages.homepage.product.confirm.deleteContent': 'Are you sure you want to delete this product?',

  // Homepage - Departure Schedule
  'pages.homepage.departureSchedule.title': 'Departure Schedule Management',
  'pages.homepage.schedule.center': 'Center',
  'pages.homepage.schedule.transportMethod': 'Transport Method',
  'pages.homepage.schedule.departureDate': 'Departure Date',
  'pages.homepage.schedule.departureTime': 'Departure Time',
  'pages.homepage.schedule.notes': 'Notes',
  'pages.homepage.schedule.actions': 'Actions',
  'pages.homepage.schedule.add': 'Add Departure Schedule',
  'pages.homepage.schedule.edit': 'Edit',
  'pages.homepage.schedule.delete': 'Delete',
  'pages.homepage.schedule.addModal': 'Add Departure Schedule',
  'pages.homepage.schedule.editModal': 'Edit Departure Schedule',
  'pages.homepage.schedule.form.center': 'Center',
  'pages.homepage.schedule.form.centerRequired': 'Please select center',
  'pages.homepage.schedule.form.transportMethod': 'Transport Method',
  'pages.homepage.schedule.form.transportMethodRequired': 'Please select transport method',
  'pages.homepage.schedule.form.departureDate': 'Departure Date',
  'pages.homepage.schedule.form.departureDateRequired': 'Please select departure date',
  'pages.homepage.schedule.form.departureTime': 'Departure Time',
  'pages.homepage.schedule.form.departureTimeRequired': 'Please select departure time',
  'pages.homepage.schedule.form.notes': 'Notes',
  'pages.homepage.schedule.form.notesPlaceholder': 'Enter notes',
  'pages.homepage.schedule.center.weihai': 'Weihai',
  'pages.homepage.schedule.center.guangzhou': 'Guangzhou',
  'pages.homepage.schedule.transport.seaIncheonCJ': 'Sea Incheon (CJ)',
  'pages.homepage.schedule.transport.seaPyeongtaekHanjin': 'Sea Pyeongtaek (Hanjin)',
  'pages.homepage.schedule.transport.lclMWF': 'LCL (Mon/Wed/Fri Cargo)',
  'pages.homepage.schedule.transport.lclTThSun': 'LCL (Tue/Thu/Sun Welly)',
  'pages.homepage.schedule.transport.air': 'Air',
  'pages.homepage.schedule.transport.airExpress': 'Air Express',
  'pages.homepage.schedule.transport.topitLCL': 'Topit LCL (Tue/Thu)',
  'pages.homepage.schedule.transport.topitLCLGeneral': 'Topit LCL',
  'pages.homepage.schedule.message.added': 'Schedule added successfully',
  'pages.homepage.schedule.message.updated': 'Schedule updated successfully',
  'pages.homepage.schedule.message.deleted': 'Schedule deleted successfully',
  'pages.homepage.schedule.confirm.deleteTitle': 'Delete Schedule',
  'pages.homepage.schedule.confirm.deleteContent': 'Are you sure you want to delete this schedule?',

  // Homepage - Shopping Information
  'pages.homepage.shoppingInformation.title': 'Shopping Information Management',
  'pages.homepage.shopping.tab.category': 'Category Management',
  'pages.homepage.shopping.tab.site': 'Site Management',
  'pages.homepage.shopping.addCategory': 'Add Category',
  'pages.homepage.shopping.addSite': 'Add Site',
  'pages.homepage.shopping.addCategoryModal': 'Add Category',
  'pages.homepage.shopping.editCategoryModal': 'Edit Category',
  'pages.homepage.shopping.addSiteModal': 'Add Site',
  'pages.homepage.shopping.editSiteModal': 'Edit Site',
  'pages.homepage.shopping.category.name': 'Category Name',
  'pages.homepage.shopping.category.order': 'Order',
  'pages.homepage.shopping.site.country': 'Country',
  'pages.homepage.shopping.site.category': 'Category',
  'pages.homepage.shopping.site.name': 'Site Name',
  'pages.homepage.shopping.site.url': 'Site URL',
  'pages.homepage.shopping.actions': 'Actions',
  'pages.homepage.shopping.edit': 'Edit',
  'pages.homepage.shopping.delete': 'Delete',
  'pages.homepage.shopping.form.categoryName': 'Category Name',
  'pages.homepage.shopping.form.categoryNameRequired': 'Please enter category name',
  'pages.homepage.shopping.form.categoryNamePlaceholder': 'Enter category name',
  'pages.homepage.shopping.form.country': 'Country',
  'pages.homepage.shopping.form.countryRequired': 'Please select country',
  'pages.homepage.shopping.form.countryPlaceholder': 'Select country',
  'pages.homepage.shopping.form.category': 'Category',
  'pages.homepage.shopping.form.categoryRequired': 'Please select category',
  'pages.homepage.shopping.form.categoryPlaceholder': 'Select category',
  'pages.homepage.shopping.form.siteName': 'Site Name',
  'pages.homepage.shopping.form.siteNameRequired': 'Please enter site name',
  'pages.homepage.shopping.form.siteNamePlaceholder': 'Enter site name',
  'pages.homepage.shopping.form.siteUrl': 'Site URL',
  'pages.homepage.shopping.form.siteUrlPlaceholder': 'Enter site URL',
  'pages.homepage.shopping.form.image': 'Image',
  'pages.homepage.shopping.form.imageUpload': 'Upload',
  'pages.homepage.shopping.country.china': 'China',
  'pages.homepage.shopping.country.korea': 'Korea',
  'pages.homepage.shopping.country.usa': 'USA',
  'pages.homepage.shopping.country.japan': 'Japan',
  'pages.homepage.shopping.message.categoryAdded': 'Category added successfully',
  'pages.homepage.shopping.message.categoryUpdated': 'Category updated successfully',
  'pages.homepage.shopping.message.categoryDeleted': 'Category deleted successfully',
  'pages.homepage.shopping.message.siteAdded': 'Site added successfully',
  'pages.homepage.shopping.message.siteUpdated': 'Site updated successfully',
  'pages.homepage.shopping.message.siteDeleted': 'Site deleted successfully',
  'pages.homepage.shopping.confirm.deleteCategoryTitle': 'Delete Category',
  'pages.homepage.shopping.confirm.deleteCategoryContent': 'Are you sure you want to delete this category?',
  'pages.homepage.shopping.confirm.deleteSiteTitle': 'Delete Site',
  'pages.homepage.shopping.confirm.deleteSiteContent': 'Are you sure you want to delete this site?',

  // Homepage - Event Management
  'pages.homepage.eventManagement.title': 'Event Management',
  'pages.homepage.event.title': 'Title',
  'pages.homepage.event.thumbnail': 'Thumbnail',
  'pages.homepage.event.period': 'Period',
  'pages.homepage.event.displayType': 'Display Type',
  'pages.homepage.event.actions': 'Actions',
  'pages.homepage.event.add': 'Add Event',
  'pages.homepage.event.edit': 'Edit',
  'pages.homepage.event.delete': 'Delete',
  'pages.homepage.event.addModal': 'Add/Edit Event',
  'pages.homepage.event.editModal': 'Add/Edit Event',
  'pages.homepage.event.form.title': 'Title',
  'pages.homepage.event.form.titleRequired': 'Please enter title',
  'pages.homepage.event.form.titlePlaceholder': 'Enter title',
  'pages.homepage.event.form.briefDescription': 'Brief Description',
  'pages.homepage.event.form.briefDescriptionRequired': 'Please enter brief description',
  'pages.homepage.event.form.briefDescriptionPlaceholder': 'Enter brief description',
  'pages.homepage.event.form.thumbnail': 'Thumbnail',
  'pages.homepage.event.form.thumbnailUpload': 'Upload',
  'pages.homepage.event.form.externalLink': 'External Link',
  'pages.homepage.event.form.externalLinkPlaceholder': 'Enter external link',
  'pages.homepage.event.form.period': 'Period',
  'pages.homepage.event.form.periodRequired': 'Please select period',
  'pages.homepage.event.form.exposurePeriod': 'Exposure Period',
  'pages.homepage.event.form.exposurePeriodRequired': 'Please select exposure period',
  'pages.homepage.event.form.displayType': 'Display Type',
  'pages.homepage.event.form.displayTypeRequired': 'Please select display type',
  'pages.homepage.event.form.displayTypePlaceholder': 'Select display type',
  'pages.homepage.event.form.content': 'Content',
  'pages.homepage.event.form.contentHint': 'Enter content in HTML format',
  'pages.homepage.event.displayType.active': 'Active',
  'pages.homepage.event.displayType.inactive': 'Inactive',
  'pages.homepage.event.message.added': 'Event added successfully',
  'pages.homepage.event.message.updated': 'Event updated successfully',
  'pages.homepage.event.message.deleted': 'Event deleted successfully',
  'pages.homepage.event.confirm.deleteTitle': 'Delete Event',
  'pages.homepage.event.confirm.deleteContent': 'Are you sure you want to delete this event?',

  // Homepage - Popup Management
  'pages.homepage.popupManagement.title': 'Popup Management',
  'pages.homepage.popup.title': 'Title',
  'pages.homepage.popup.coordinates': 'Coordinates',
  'pages.homepage.popup.isCentered': 'Centered',
  'pages.homepage.popup.size': 'Size',
  'pages.homepage.popup.isOpen': 'Open Status',
  'pages.homepage.popup.period': 'Period',
  'pages.homepage.popup.displayType': 'Display Type',
  'pages.homepage.popup.actions': 'Actions',
  'pages.homepage.popup.add': 'Add Popup',
  'pages.homepage.popup.edit': 'Edit',
  'pages.homepage.popup.delete': 'Delete',
  'pages.homepage.popup.addModal': 'Add/Edit Popup',
  'pages.homepage.popup.editModal': 'Add/Edit Popup',
  'pages.homepage.popup.form.title': 'Title',
  'pages.homepage.popup.form.titleRequired': 'Please enter title',
  'pages.homepage.popup.form.titlePlaceholder': 'Enter title',
  'pages.homepage.popup.form.coordinates': 'Coordinates',
  'pages.homepage.popup.form.isCentered': 'Centered',
  'pages.homepage.popup.form.isCenteredLabel': 'Center position',
  'pages.homepage.popup.form.size': 'Size',
  'pages.homepage.popup.form.isOpen': 'Open Status',
  'pages.homepage.popup.form.isOpenLabel': 'Popup open',
  'pages.homepage.popup.form.period': 'Period',
  'pages.homepage.popup.form.periodRequired': 'Please select period',
  'pages.homepage.popup.form.displayType': 'Display Type',
  'pages.homepage.popup.form.displayTypeRequired': 'Please select display type',
  'pages.homepage.popup.form.displayTypePlaceholder': 'Select display type',
  'pages.homepage.popup.form.content': 'Content',
  'pages.homepage.popup.form.contentPlaceholder': 'Enter content',
  'pages.homepage.popup.form.contentHint': 'Enter content in HTML format',
  'pages.homepage.popup.displayType.active': 'Active',
  'pages.homepage.popup.displayType.inactive': 'Inactive',
  'pages.homepage.popup.message.added': 'Popup added successfully',
  'pages.homepage.popup.message.updated': 'Popup updated successfully',
  'pages.homepage.popup.message.deleted': 'Popup deleted successfully',
  'pages.homepage.popup.confirm.deleteTitle': 'Delete Popup',
  'pages.homepage.popup.confirm.deleteContent': 'Are you sure you want to delete this popup?',

  // Homepage - Page Management
  'pages.homepage.pageManagement.title': 'Page Management',
  'pages.homepage.page.pageTitle': 'Page Title',
  'pages.homepage.page.displayType': 'Display Type',
  'pages.homepage.page.actions': 'Actions',
  'pages.homepage.page.add': 'Add Page',
  'pages.homepage.page.edit': 'Edit',
  'pages.homepage.page.delete': 'Delete',
  'pages.homepage.page.addModal': 'Add/Edit HTML Page',
  'pages.homepage.page.editModal': 'Add/Edit HTML Page',
  'pages.homepage.page.form.pageTitle': 'Page Title',
  'pages.homepage.page.form.pageTitleRequired': 'Please enter page title',
  'pages.homepage.page.form.pageTitlePlaceholder': 'Enter page title',
  'pages.homepage.page.form.displayType': 'Display Type',
  'pages.homepage.page.form.displayTypeRequired': 'Please select display type',
  'pages.homepage.page.form.displayTypePlaceholder': 'Select display type',
  'pages.homepage.page.form.content': 'Content',
  'pages.homepage.page.form.contentPlaceholder': 'Enter content',
  'pages.homepage.page.form.contentHint': 'Enter content in HTML format',
  'pages.homepage.page.displayType.active': 'Active',
  'pages.homepage.page.displayType.inactive': 'Inactive',
  'pages.homepage.page.message.added': 'Page added successfully',
  'pages.homepage.page.message.updated': 'Page updated successfully',
  'pages.homepage.page.message.deleted': 'Page deleted successfully',
  'pages.homepage.page.confirm.deleteTitle': 'Delete Page',
  'pages.homepage.page.confirm.deleteContent': 'Are you sure you want to delete this page?',

  // Homepage - Mail Form Management
  'pages.homepage.mailFormManagement.title': 'Mail Form Management',
  'pages.homepage.mailForm.title': 'Title',
  'pages.homepage.mailForm.displayType': 'Display Type',
  'pages.homepage.mailForm.actions': 'Actions',
  'pages.homepage.mailForm.add': 'Add Mail Form',
  'pages.homepage.mailForm.edit': 'Edit',
  'pages.homepage.mailForm.delete': 'Delete',
  'pages.homepage.mailForm.addModal': 'Add/Edit Mail Form',
  'pages.homepage.mailForm.editModal': 'Add/Edit Mail Form',
  'pages.homepage.mailForm.form.title': 'Title',
  'pages.homepage.mailForm.form.titleRequired': 'Please enter title',
  'pages.homepage.mailForm.form.titlePlaceholder': 'Enter title',
  'pages.homepage.mailForm.form.displayType': 'Display Type',
  'pages.homepage.mailForm.form.displayTypeRequired': 'Please select display type',
  'pages.homepage.mailForm.form.displayTypePlaceholder': 'Select display type',
  'pages.homepage.mailForm.form.content': 'Content',
  'pages.homepage.mailForm.form.contentPlaceholder': 'Enter content',
  'pages.homepage.mailForm.form.contentHint': 'Enter content in HTML format',
  'pages.homepage.mailForm.form.variablesHint': 'Site Name: [$SITE_NAME], Name: [$MEMBER_NAME], ID: [$MEMBER_ID], Mobile: [$MOBILE_NO], Password: [$PASSWORD]',
  'pages.homepage.mailForm.displayType.active': 'Active',
  'pages.homepage.mailForm.displayType.inactive': 'Inactive',
  'pages.homepage.mailForm.message.added': 'Mail form added successfully',
  'pages.homepage.mailForm.message.updated': 'Mail form updated successfully',
  'pages.homepage.mailForm.message.deleted': 'Mail form deleted successfully',
  'pages.homepage.mailForm.confirm.deleteTitle': 'Delete Mail Form',
  'pages.homepage.mailForm.confirm.deleteContent': 'Are you sure you want to delete this mail form?',

  // Coupon Issuance
  'pages.coupon.issuance.modalTitle': 'Issue Coupon',
  'pages.coupon.issuance.memberButton': 'Issue Coupon by Member',
  'pages.coupon.issuance.levelButton': 'Issue Coupon by Level',
  'pages.coupon.issuance.memberInfo': 'Member Info (Coupon Period: Unlimited)',
  'pages.coupon.issuance.type': 'Type',
  'pages.coupon.issuance.code': 'Coupon Code',
  'pages.coupon.issuance.amount': 'Amount',
  'pages.coupon.issuance.method': 'Issuance Method (Member ID)',
  'pages.coupon.issuance.usageStatus': 'Usage Status',
  'pages.coupon.issuance.date': 'Issuance Date',
  'pages.coupon.issuance.memberSearch': 'Member Search',
  'pages.coupon.issuance.memberId': 'Member ID',
  'pages.coupon.issuance.memberName': 'Member Name',
  'pages.coupon.issuance.phone': 'Phone',
  'pages.coupon.issuance.searchPlaceholder': 'Enter search term',
  'pages.coupon.issuance.selectMember': 'Member Name',
  'pages.coupon.issuance.selectMemberPlaceholder': '= Select Member =',
  'pages.coupon.issuance.couponType': 'Coupon Type',
  'pages.coupon.issuance.shippingFee': 'Shipping Fee',
  'pages.coupon.issuance.discount': 'Discount',
  'pages.coupon.issuance.count': 'Count',
  'pages.coupon.issuance.category': 'Issuance Category',
  'pages.coupon.issuance.validDays': 'Valid Days',
  'pages.coupon.issuance.fromIssuanceDate': 'From issuance date',
  'pages.coupon.issuance.days': 'days',
  'pages.coupon.issuance.smsOption': 'SMS Option',
  'pages.coupon.issuance.noSms': 'Do not send SMS',
  'pages.coupon.issuance.sendSms': 'Send SMS',
  'pages.coupon.issuance.memberLevel': 'Member Level',
  'pages.coupon.issuance.level.all': 'All Member Levels',
  'pages.coupon.issuance.level.basic': 'Basic Member',
  'pages.coupon.issuance.level.shippingVip': 'Shipping VIP',
  'pages.coupon.issuance.level.shippingSvip': 'Shipping SVIP',
  'pages.coupon.issuance.level.purchaseBusiness': 'Purchase Business',
  'pages.coupon.issuance.level.purchase': 'Purchase',
  'pages.coupon.issuance.level.agencyVip': 'Agency VIP',
  'pages.coupon.issuance.level.ttBusiness': 'TT Business',
  'pages.coupon.issuance.level.ttVip': 'TT VIP',
  'pages.coupon.issuance.level.ttPersonal': 'TT Personal',
  'pages.coupon.issuance.successMessage': 'Coupon issued successfully',
  'pages.coupon.issuance.table.couponType': 'Coupon Type',
  'pages.coupon.issuance.table.issuanceType': 'Issuance Type',
  'pages.coupon.issuance.table.amount': 'Amount',
  'pages.coupon.issuance.table.effectiveDate': 'Effective Date',
  'pages.coupon.issuance.table.ownerMember': 'Owner Member',
  'pages.coupon.issuance.table.isUsed': 'Usage Status',
  'pages.coupon.issuance.table.issuanceDate': 'Issuance Date',
  'pages.coupon.issuance.filter.period': 'Period',
  'pages.coupon.issuance.filter.membershipEvent': 'Membership Registration Event',
  'pages.coupon.issuance.filter.adminIssued': 'Administrator Issued',
  'pages.coupon.issuance.filter.upgradeEvent': 'Membership Upgrade Coupon',
  'pages.coupon.issuance.filter.used': 'Used',
  'pages.coupon.issuance.filter.unused': 'Unused',
  'pages.coupon.issuance.filter.memberId': 'Member ID',
  'pages.coupon.issuance.filter.memberIdPlaceholder': 'Enter Member ID',
  'pages.coupon.issuance.filter.memberNamePlaceholder': 'Enter Member Name',
  'pages.coupon.issuance.filter.orderNumber': 'Order Number',
  'pages.coupon.issuance.filter.orderNumberPlaceholder': 'Enter Order Number',
  'pages.coupon.issuance.deleteButton': 'Delete',
  'pages.coupon.issuance.selectToDelete': 'Please select items to delete',
  'pages.coupon.issuance.deleteConfirmTitle': 'Delete Coupons',
  'pages.coupon.issuance.deleteConfirmContent': 'Are you sure you want to delete {count} coupon(s)?',
  'pages.coupon.issuance.deleteSuccess': 'Coupons deleted successfully',
  'pages.coupon.issuance.selectedCount': '{count} selected',
  'pages.coupon.issuance.table.couponTypeAndIssuance': 'Coupon Type (Issuance Type)',
  'pages.coupon.issuance.combined.shippingMembership': 'Shipping Fee - Membership Event',
  'pages.coupon.issuance.combined.shippingAdmin': 'Shipping Fee - Admin Issued',
  'pages.coupon.issuance.combined.shippingUpgrade': 'Shipping Fee - Membership Upgrade',
  'pages.coupon.issuance.searchResults': 'Search Results',
  'pages.coupon.issuance.selectedMember': 'Selected Member',
  'pages.coupon.issuance.price': 'Price',
  'pages.coupon.issuance.pieces': 'pcs',
  'pages.coupon.issuance.issuanceType': 'Issuance Type',
  'pages.coupon.issuance.filter.startDate': 'Start Date',
  'pages.coupon.issuance.filter.endDate': 'End Date',

  // Event Coupon
  'pages.coupon.event.couponType': 'Coupon Type',
  'pages.coupon.event.issuanceType': 'Issuance Type',
  'pages.coupon.event.amount': 'Amount',
  'pages.coupon.event.validDays': 'Valid Days',
  'pages.coupon.event.eventPeriod': 'Event Period',
  'pages.coupon.event.createdAt': 'Created At',
  'pages.coupon.event.priceRequired': 'Please enter price',
  'pages.coupon.event.countRequired': 'Please enter count',
  'pages.coupon.event.validDaysRequired': 'Please enter valid days',
  'pages.coupon.event.eventPeriodRequired': 'Please select event period',
  'pages.coupon.event.saveSuccess': 'Event coupon created successfully',
  'pages.coupon.event.deleteConfirmTitle': 'Delete Coupon',
  'pages.coupon.event.deleteConfirmContent': 'Are you sure you want to delete this coupon?',
  'pages.coupon.event.deleteSuccess': 'Coupon deleted successfully',

  // SMS
  'pages.sms.title': 'Send SMS',
  'pages.sms.tabs.storage': 'Message Storage',
  'pages.sms.tabs.members': 'Member List',
  'pages.sms.storage.title': 'Message Storage',
  'pages.sms.form.recipient': 'Recipient',
  'pages.sms.form.individual': 'Individual',
  'pages.sms.form.group': 'Group',
  'pages.sms.form.phonePlaceholder': 'Enter phone number',
  'pages.sms.form.selectGroup': 'Select group',
  'pages.sms.form.allMembers': 'All',
  'pages.sms.form.sender': 'Sender',
  'pages.sms.form.message': 'Message',
  'pages.sms.form.messagePlaceholder': 'Enter message',
  'pages.sms.form.currentLength': 'Current length',
  'pages.sms.form.bytes': 'bytes',
  'pages.sms.form.smsInfo': 'SMS is 30 Bytes and sent as sender name | MS.',
  'pages.sms.form.lmsInfo': 'SMS message costs 15P.',
  'pages.sms.form.mmsInfo': 'LMS message costs 35P. MMS message costs 100P (with image attachment).',
  'pages.sms.form.send': 'Send',
  'pages.sms.member.memberId': 'Member (ID)',
  'pages.sms.member.name': 'Grade',
  'pages.sms.member.phone': 'Phone',
  'pages.sms.member.createdAt': 'Created At',
  'pages.sms.member.emptyText': 'Please search for members.',
  'pages.sms.history.title': 'SMS Sending History',
  'pages.sms.history.sendInfo': 'Send Information',
  'pages.sms.history.date': 'Date',
  'pages.sms.history.datePlaceholder': 'Select date',
  'pages.sms.history.phone': 'Phone',
  'pages.sms.history.phonePlaceholder': 'Enter phone number',
  'pages.sms.history.message': 'Message',
  'pages.sms.history.type': 'Type',
  'pages.sms.history.status': 'Status',
  'pages.sms.history.pageSize': 'Items per page',

  // Kakao SMS Management
  'pages.kakao.title': 'Kakao SMS Management',
  'pages.kakao.table.name': 'Name',
  'pages.kakao.table.kakaoContent': '[KakaoTalk]',
  'pages.kakao.table.replacementText': 'Text Message [Replacement text if KakaoTalk message is not sent]',
  'pages.kakao.table.bytes': 'Bytes',
  'pages.kakao.table.useStatus': 'Use or Not',
  'pages.kakao.status.active': 'Active',
  'pages.kakao.status.inactive': 'Inactive',
  'pages.kakao.placeholder.replacementText': 'Enter replacement text',

  // SMS Point Details
  'pages.smsPoint.title': 'Point Details',
  'pages.smsPoint.filter.year': 'Year',
  'pages.smsPoint.filter.month': 'Month',
  'pages.smsPoint.table.chargingPoint': 'Charging Point',
  'pages.smsPoint.table.location': 'Location',
  'pages.smsPoint.table.date': 'Date',

  // Member Grades
  'pages.member.grade.basic': 'Basic Member',
  'pages.member.grade.shippingAgency': 'Shipping Agency',
  'pages.member.grade.shippingVip': 'Shipping Agency VIP',
  'pages.member.grade.shippingSvip': 'Shipping Agency SVIP',
  'pages.member.grade.purchaseBusiness': 'Purchase Business',
  'pages.member.grade.purchaseVip': 'Purchase Agency VIP',
  'pages.member.grade.ttBusiness': 'TT Business',
  'pages.member.grade.ttVip': 'TT VIP',
  'pages.member.grade.ttSvip': 'TT SVIP',

  // Rack Usage Management
  'pages.rack.usage.title': 'Rack Usage Management',
  'pages.rack.usage.rackCode': 'Rack Code',
  'pages.rack.usage.rackNumber': 'Rack Number',
  'pages.rack.usage.size': 'Size',
  'pages.rack.usage.registrant': 'Tracking Number',
  'pages.rack.usage.stockNumber': 'Stock Number',
  'pages.rack.usage.locationNumber': 'Location Number',
  'pages.rack.usage.registrationDate': 'Registration Date',
  'pages.rack.usage.detail': 'Detail',

  // Rack Management
  'pages.rack.management.title': 'Rack Management',
  'pages.rack.management.register': 'Rack Registration',
  'pages.rack.management.rackDefinition': 'Rack Definition',
  'pages.rack.management.rackCode': 'Rack Code',
  'pages.rack.management.size': 'Size',
  'pages.rack.management.range': 'Start ~ End Number',
  'pages.rack.management.totalRacks': 'Total Number of Racks',
  'pages.rack.management.usedRacks': 'Number of Racks Used',
  'pages.rack.management.isActive': 'Whether to Use',
  'pages.rack.management.rackDetails': 'Rack Number Details',
  'pages.rack.management.addRack': 'Add Rack Number',
  'pages.rack.management.correction': 'Correction',
  'pages.rack.management.registerModal': 'Rack Registration',
  'pages.rack.management.detailsModal': 'Rack Number Details',
  'pages.rack.management.addRackModal': 'Add Rack Number',
  'pages.rack.management.correctionModal': 'Rack Information Correction',
  'pages.rack.management.rackCode1': 'Rack Code_1',
  'pages.rack.management.rackCode2': 'Rack Code_2',
  'pages.rack.management.startNumber': 'Start Number',
  'pages.rack.management.endNumber': 'End Number',
  'pages.rack.management.useCategory': 'Use Category',
  'pages.rack.management.combination': 'Combination',
  'pages.rack.management.availableRacks': 'Available Racks',
  'pages.rack.management.rackNumber': 'Rack Number',
  'pages.rack.management.status': 'Status',
  'pages.rack.management.inquiry': 'Inquiry',
  'pages.rack.management.addRackCount': 'Add Rack Count',
  'pages.rack.management.maxAddable': 'Maximum addable racks',
  'pages.rack.management.sizeSmall': 'Small',
  'pages.rack.management.sizeMedium': 'Medium',
  'pages.rack.management.sizeLarge': 'Large',
  'pages.rack.management.sizeLCL': 'LCL',
  'pages.rack.management.use': 'Use',
  'pages.rack.management.notUse': 'Not Use',
  'pages.rack.management.notInUse': 'Not In Use',
  'pages.rack.management.reset': 'Reset',
  'pages.rack.management.detail': 'Detail',
  'pages.rack.management.registrationDate': 'Registration Date',
  'pages.rack.management.enterAddCount': 'Enter number of racks to add',
  'pages.rack.management.registerSuccess': 'Rack registered successfully',
  'pages.rack.management.addSuccess': 'Rack added successfully',
  'pages.rack.management.editSuccess': 'Rack updated successfully',

  // Rack Information Log
  'pages.rack.log.title': 'Rack Information Log',
  'pages.rack.log.logNumber': 'Log Number',
  'pages.rack.log.rackNumber': 'Rack Number',
  'pages.rack.log.trackingNumber': 'Tracking Number',
  'pages.rack.log.stockNumber': 'Stock Number',
  'pages.rack.log.noDataNumber': 'No Data Number',
  'pages.rack.log.registrationCode': 'Registration Code',
  'pages.rack.log.memberName': 'Member Name',
  'pages.rack.log.registrationDate': 'Registration Date',
  'pages.rack.log.filter.first': 'First',
  'pages.rack.log.filter.date': 'Date',
  'pages.rack.log.filter.rackNumber': 'Rack Number',
  'pages.rack.log.filter.trackingNumber': 'Tracking Number',
  'pages.rack.log.filter.stockNumber': 'Stock Number',
  'pages.rack.log.filter.noDataNumber': 'No Data Number',
  'pages.rack.log.filter.memberName': 'Member Name',

  // Membership Level Management
  'pages.membership.level.title': 'Membership Level Management',
  'pages.membership.level.register': 'Register Level',
  'pages.membership.level.gradeNumber': 'Grade Number',
  'pages.membership.level.gradeName': 'Grade Name',
  'pages.membership.level.numberOfDeliveries': 'Number of Deliveries',
  'pages.membership.level.purchaseFee': 'Purchase Fee(%)',
  'pages.membership.level.serviceFee': 'Service Fee(%)',
  'pages.membership.level.levelUpCoupon': 'Level-up Coupon',
  'pages.membership.level.pointAccumulation': 'Point Accumulation(%)',
  'pages.membership.level.exchangeRates': 'Exchange Rates by Grade',
  'pages.membership.level.usageStatus': 'Usage Status',
  'pages.membership.level.deleteConfirmContent': 'Are you sure you want to delete this level?',
  'pages.membership.level.modal.title': 'Membership Level Management',
  'pages.membership.level.modal.gradeName': 'Grade Name',
  'pages.membership.level.modal.purchaseFee': 'Purchase Fee(%)',
  'pages.membership.level.modal.serviceFee': 'Service Fee(%)',
  'pages.membership.level.modal.numberOfDeliveries': 'Number of Deliveries',
  'pages.membership.level.modal.levelUpCoupon': 'Level-up Coupon',
  'pages.membership.level.modal.pointAccumulation': 'Point Accumulation(%)',
  'pages.membership.level.modal.exchangeRates': 'Exchange Rates by Grade',
  'pages.membership.level.modal.usageStatus': 'Usage Status',
  'pages.membership.level.modal.active': 'Active',
  'pages.membership.level.modal.inactive': 'Inactive',

  // Center Management
  'pages.center.title': 'Center Management',
  'pages.center.centerRegistration': 'Center registration',
  'pages.center.centerAlignment': 'Center alignment',
  'pages.center.nation': 'nation',
  'pages.center.center': 'center',
  'pages.center.centerCode': 'center code',
  'pages.center.unitOfMeasurement': 'Unit of measurement (weight)',
  'pages.center.transportationMethod': 'Transportation method',
  'pages.center.address': 'address',
  'pages.center.phoneNumber': 'phone number',
  'pages.center.shippingCenter': 'Shipping Center',
  'pages.center.whetherToUse': 'Whether to use',
  'pages.center.deleteConfirmContent': 'Are you sure you want to delete this center?',
  'pages.center.modal.title': 'Center registration/modification',
  'pages.center.modal.nation': 'nation',
  'pages.center.modal.centerName': 'Center name',
  'pages.center.modal.centerCode': 'Center code',
  'pages.center.modal.postalCode': 'Postal code',
  'pages.center.modal.city': 'CITY',
  'pages.center.modal.state': 'STATE',
  'pages.center.modal.address1': 'Address 1',
  'pages.center.modal.address2': 'Address 2',
  'pages.center.modal.phoneNumber': 'phone number',
  'pages.center.modal.weightUnit': 'Weight',
  'pages.center.modal.transportationMethod': 'Transportation method',
  'pages.center.modal.image': 'Image (417 x 235)',
  'pages.center.modal.chooseFile': 'Choose file',
  'pages.center.modal.whetherToUse': 'Whether to use',
  'pages.center.modal.briefSummary': 'Brief summary',
  'pages.center.alignmentModal.title': 'Center alignment',
  'pages.center.alignmentModal.centerManagement': 'Center Management',
  'pages.center.alignmentModal.order': 'order',
  'pages.center.alignmentModal.dragToReorder': 'Drag to reorder',
  'pages.center.alignmentModal.center1': 'Republic of Korea (Incheon)',
  'pages.center.alignmentModal.center2': 'China (for)',
  'pages.center.alignmentModal.center3': 'China (Qingdao)',
  'pages.center.alignmentModal.center4': 'China (Guangzhou)',
  'pages.center.alignmentModal.center5': 'China (Yiwu)',
  'pages.center.alignmentModal.center6': 'China (Hangzhou)',

  // Deposit Account Management
  'pages.depositAccount.title': 'Deposit Account Management',
  'pages.depositAccount.register': 'Register Deposit Account',
  'pages.depositAccount.id': 'ID',
  'pages.depositAccount.bankName': 'Bank name',
  'pages.depositAccount.accountNumber': 'Account number',
  'pages.depositAccount.depositor': 'Depositor',
  'pages.depositAccount.whetherToUse': 'Whether to use',
  'pages.depositAccount.deleteConfirmContent': 'Are you sure you want to delete this account?',
  'pages.depositAccount.modal.title': 'Register/edit deposit account',
  'pages.depositAccount.modal.bankName': 'Bank name',
  'pages.depositAccount.modal.accountNumber': 'Account number',
  'pages.depositAccount.modal.depositor': 'Depositor',
  'pages.depositAccount.modal.whetherToUse': 'Whether to use',

  // Exchange Rate (Customs & Applicable)
  'pages.customsExchangeRate.title': 'Customs Service Exchange Rate',
  'pages.applicableExchangeRate.title': 'Applicable Exchange Rate',
  'pages.exchangeRate.register': 'Exchange rate registration',
  'pages.exchangeRate.id': 'ID',
  'pages.exchangeRate.nation': 'nation',
  'pages.exchangeRate.period': 'Period (Title)',
  'pages.exchangeRate.exchangeRate': 'Exchange rate',
  'pages.exchangeRate.deleteConfirmContent': 'Are you sure you want to delete this exchange rate?',
  'pages.exchangeRate.modal.title': 'Exchange rate registration',
  'pages.exchangeRate.modal.nation': 'nation',
  'pages.exchangeRate.modal.period': 'Period (Title)',
  'pages.exchangeRate.modal.periodPlaceholder': 'e.g. October 1, 2022 - October 31, 2022',
  'pages.exchangeRate.modal.exchangeRate': 'Exchange rate',

  // Additional Service Management
  'pages.additionalService.title': 'Additional Service Management',
  'pages.additionalService.note1': 'Additional service costs are automatically added when ordering.',
  'pages.additionalService.note2': '¥ = CNY / ₩ = KRW / $ = USD',
  'pages.additionalService.saveChanges': 'Save changes',
  'pages.additionalService.additionalServices': 'Additional services',
  'pages.additionalService.amount': 'amount',
  'pages.additionalService.explanation': 'explanation',
  'pages.additionalService.localShippingFee': 'Local shipping fee',
  'pages.additionalService.additionalCosts': 'Additional costs',
  'pages.additionalService.excessCostOfItems': 'Excess cost of items',
  'pages.additionalService.uninspectedShipment': 'Uninspected shipment',
  'pages.additionalService.uninspectedShipmentExplanation': 'Service that ships without checking product quantity/size/color/options. However, external damage is inspected.',
  'pages.additionalService.finishworkCostVVIC': 'Finishwork cost (VVIC required)',
  'pages.additionalService.finishworkCostVVICExplanation': 'Wholesale product finishing work cost',
  'pages.additionalService.precisionInspection': 'Precision inspection',
  'pages.additionalService.precisionInspectionExplanation': 'If you want detailed inspection of product size/color, precision inspection fee will be added when billing. Additional costs may occur after inspection. Inspection photos taken with smartphone will be provided.',
  'pages.additionalService.doNotOpenTheProduct': 'Do not open the product box',
  'pages.additionalService.businessInspection': 'Business inspection',
  'pages.additionalService.businessInspectionExplanation': 'Business inspection service.',
  'pages.additionalService.noNeedToCheckQuantity': 'No need to check quantity',
  'pages.additionalService.noNeedToCheckQuantityExplanation': 'Service that does not require quantity check.',
  'pages.additionalService.customerRequestReview': 'Customer request review',
  'pages.additionalService.customerRequestReviewExplanation': 'Review items requested by customer.',
  'pages.additionalService.noInspectionRequired': 'No inspection required',
  'pages.additionalService.noInspectionRequiredExplanation': 'Service that does not require inspection.',
  'pages.additionalService.bubbleWrapPackaging': 'Bubble wrap packaging',
  'pages.additionalService.bubbleWrapPackagingExplanation': 'Package products with bubble wrap.',
  'pages.additionalService.indivBox': 'indivBox',
  'pages.additionalService.serviceNameKo': 'Service Name (Korean)',
  'pages.additionalService.serviceNameZh': 'Service Name (Chinese)',
  'pages.additionalService.serviceNameEn': 'Service Name (English)',
  'pages.additionalService.indivBoxExplanation': 'Package products in individual boxes.',
  'pages.additionalService.usdExchangeRate': 'USD exchange rate (yuan amount divided by exchange rate)',
  'pages.additionalService.example': 'Example)',
  'pages.additionalService.serviceName': 'Service Name',
  'pages.additionalService.serviceNamePlaceholder': 'Enter service name',
  'pages.additionalService.unit': 'Unit',
  'pages.additionalService.unitPrice': 'Unit Price',
  'pages.additionalService.requiresQuantity': 'Need Quantity',
  'pages.additionalService.sortOrder': 'Sort Order',
  'pages.additionalService.status': 'Status',
  'pages.additionalService.unitPlaceholder': 'e.g., dog, bux',
  'pages.additionalService.unitPricePlaceholder': 'Enter unit price',
  'pages.additionalService.sortOrderPlaceholder': 'Enter sort order',
  'pages.additionalService.code': 'Code',
  'pages.additionalService.codePlaceholder': 'Enter service code (optional)',
  'pages.additionalService.addService': 'Add Service',
  'pages.additionalService.editService': 'Edit Service',

  // Island and Mountain Cost Management
  'pages.islandMountainCost.import': 'Upload File',
  'pages.islandMountainCost.import.title': 'Upload Island/Remote Cost File',
  'pages.islandMountainCost.import.selectFile': 'Select Excel file',
  'pages.islandMountainCost.import.fileHint': 'Island/remote Excel (.xlsx). The first row of each sheet needs a postal-code header (우편번호 or 국가기초코드) and a ferry-fee header (도선료 or 도선료금).',
  'pages.excelFormat.title': 'What the file should look like',
  'pages.excelFormat.download': 'Download sample',
  'pages.excelFormat.downloadFailed': 'Could not build the sample file',
  'pages.excelFormat.headerRequired': 'The first row must be the header.',
  'pages.excelFormat.noHeaderRow': 'Start on row 1 with no header. A header row is skipped if present.',
  'pages.excelFormat.aliases': 'Accepted header names:',
  'pages.islandMountainCost.import.formatNote': 'Extra columns are ignored, and several sheets are fine.',
  'pages.islandMountainCost.import.modeTitle': 'How to apply',
  'pages.islandMountainCost.import.mode.merge': 'Merge',
  'pages.islandMountainCost.import.mode.mergeHint': 'Update and add the postal codes in the file; leave every other one as it is.',
  'pages.islandMountainCost.import.mode.replace': 'Replace all',
  'pages.islandMountainCost.import.mode.replaceHint': 'Treat the file as the whole list and delete the postal codes it does not have.',
  'pages.islandMountainCost.import.fileRequired': 'Please select a file',
  'pages.islandMountainCost.import.analyzing': 'Checking the file...',
  'pages.islandMountainCost.import.applying': 'Applying...',
  'pages.islandMountainCost.import.analyze': 'Check file',
  'pages.islandMountainCost.import.apply': 'Apply',
  'pages.islandMountainCost.import.reselect': 'Choose another file',
  'pages.islandMountainCost.import.failed': 'Failed to process the file',
  'pages.islandMountainCost.import.previewTitle': 'Applying will change',
  'pages.islandMountainCost.import.sheetsTitle': 'What was read from each sheet',
  'pages.islandMountainCost.import.sheetName': 'Sheet',
  'pages.islandMountainCost.import.sheetRows': 'Rows',
  'pages.islandMountainCost.import.sheetUnique': 'Postal codes',
  'pages.islandMountainCost.import.sheetFees': 'Ferry fee',
  'pages.islandMountainCost.import.sheetKind.fee': 'Fee sheet',
  'pages.islandMountainCost.import.sheetKind.mixed': 'Mixed area (not imported)',
  'pages.islandMountainCost.import.sheetKind.empty': 'Nothing to read',
  'pages.islandMountainCost.import.toCreate': 'Add',
  'pages.islandMountainCost.import.toUpdate': 'Fee changed',
  'pages.islandMountainCost.import.unchanged': 'Unchanged',
  'pages.islandMountainCost.import.toDelete': 'Delete',
  'pages.islandMountainCost.import.toKeep': 'Keep',
  'pages.islandMountainCost.import.keepNotice.count': '{count} postal codes are not in the file and are left as they are. Nothing is deleted.',
  'pages.islandMountainCost.import.deleteWarning': '{count} postal codes not in the file will be deleted, including manually added ones.',
  'pages.islandMountainCost.import.deleteSamples': 'Rows to be deleted (sample)',
  'pages.islandMountainCost.import.mixedNotice': '{count} mixed-area rows have no ferry fee and are not imported.',
  'pages.islandMountainCost.import.conflictNotice': '{count} postal codes appear with different fees on two sheets; the higher fee is applied.',
  'pages.islandMountainCost.import.invalidNotice': '{count} rows could not be read and are skipped.',
  'pages.islandMountainCost.import.keepNotice': 'Additional fare and memo are not in the file, so existing rows keep their current values.',
  'pages.islandMountainCost.import.done': 'Applied — {created} added / {updated} changed / {deleted} deleted',
  'pages.islandMountainCost.import.doneMerge': 'Applied — {created} added / {updated} changed / {kept} kept',
  'pages.islandMountainCost.title': 'Island and Mountainous Area Cost Management',
  'pages.islandMountainCost.from': 'from',
  'pages.islandMountainCost.all': 'all',
  'pages.islandMountainCost.resetAbove': 'Reset above conditions',
  'pages.islandMountainCost.register': 'register',
  'pages.islandMountainCost.no': 'No',
  'pages.islandMountainCost.postalCode': 'Postal code',
  'pages.islandMountainCost.ferryFare': 'ferry fare',
  'pages.islandMountainCost.additionalFare': 'Additional fare',
  'pages.islandMountainCost.memo': 'memo',
  'pages.islandMountainCost.registrationDate': 'Registration date (modification date)',
  'pages.islandMountainCost.deleteConfirmContent': 'Are you sure you want to delete this item?',
  'pages.islandMountainCost.modal.title': 'Register/modify pilotage fees',
  'pages.islandMountainCost.modal.postalCode': 'Postal code',
  'pages.islandMountainCost.modal.postalCodeExample': 'Example) 5-digit road name postal code',
  'pages.islandMountainCost.modal.ferryFare': 'ferry fare',
  'pages.islandMountainCost.modal.additionalFare': 'Additional fare',
  'pages.islandMountainCost.modal.memo': 'memo',

  // Item Management
  'pages.itemManagement.title': 'Item Management',
  'pages.itemManagement.customsClearanceItems': 'Customs clearance items',
  'pages.itemManagement.customsClearanceItemCategories': 'Customs clearance item categories',
  'pages.itemManagement.registerItem': 'Register item',
  'pages.itemManagement.categoryRegistration': 'Category registration',
  'pages.itemManagement.itemNumber': 'Item number',
  'pages.itemManagement.hsCode': 'HS CODE',
  'pages.itemManagement.category': 'Category',
  'pages.itemManagement.itemName': 'Item name',
  'pages.itemManagement.itemNameEnglish': 'Item Name (English)',
  'pages.itemManagement.itemNameChinese': 'Item name (Chinese)',
  'pages.itemManagement.whetherOrNotToClearTheList': 'Whether or not to clear the list',
  'pages.itemManagement.tariffRate': 'Tariff rate',
  'pages.itemManagement.vatRate': 'VAT rate',
  'pages.itemManagement.categorySymbol': 'Category symbol',
  'pages.itemManagement.categoryNumber': 'Category number',
  'pages.itemManagement.categoryName': 'Category name',
  'pages.itemManagement.categoryNameEnglish': 'Category name (English)',
  'pages.itemManagement.whetherToUse': 'Whether to use',
  'pages.itemManagement.deleteItemConfirm': 'Are you sure you want to delete this item?',
  'pages.itemManagement.deleteCategoryConfirm': 'Are you sure you want to delete this category?',
  'pages.itemManagement.itemModal.title': 'Register/modify customs clearance items',
  'pages.itemManagement.modal.category': 'Category',
  'pages.itemManagement.modal.hsCode': 'HS CODE',
  'pages.itemManagement.modal.itemName': 'Item name',
  'pages.itemManagement.modal.itemNameEnglish': 'Item Name (English)',
  'pages.itemManagement.modal.itemNameChinese': 'Item name (Chinese)',
  'pages.itemManagement.modal.whetherOrNotToClearTheList': 'Whether or not to clear the list',
  'pages.itemManagement.modal.tariffRate': 'Tariff rate',
  'pages.itemManagement.modal.vatRate': 'VAT rate',
  'pages.itemManagement.categoryModal.title': 'Register/Edit Category',
  'pages.itemManagement.categoryModal.category': 'Category',
  'pages.itemManagement.categoryModal.categoryEnglish': 'Category (English)',
  'pages.itemManagement.categoryModal.whetherToUse': 'Whether to use',
  'pages.itemManagement.categoryId': 'Category ID',
  'pages.itemManagement.parentId': 'Parent ID',
  'pages.itemManagement.chineseName': 'Chinese Name',
  'pages.itemManagement.englishName': 'English Name',
  'pages.itemManagement.simpleNonSimple': 'Simple/Non-simple',
  'pages.itemManagement.source': 'Source',
  'pages.itemManagement.addTime': 'Add Time',
  'pages.itemManagement.title.hsCode': 'HS CODE Management',
  'pages.itemManagement.importExcel': 'Import Excel',
  'pages.itemManagement.exportExcel': 'Export Excel',
  'pages.itemManagement.importSuccess': 'Successfully imported {count} items',
  'pages.itemManagement.importFailed': 'Failed to import Excel',
  'pages.itemManagement.exportFailed': 'Failed to export Excel',

  // Waybill Bandwidth Management
  'pages.waybillBandwidth.title': 'Waybill Bandwidth Management',
  'pages.waybillBandwidth.registerWaybillBandwidth': 'Register Waybill Bandwidth',
  'pages.waybillBandwidth.no': 'No',
  'pages.waybillBandwidth.centerTransportationMethod': 'Center/Transportation Method',
  'pages.waybillBandwidth.osxId': 'OSX ID',
  'pages.waybillBandwidth.info': 'Info',
  'pages.waybillBandwidth.waybillBandwidth': 'Waybill bandwidth',
  'pages.waybillBandwidth.shipCondition': 'Ship condition',
  'pages.waybillBandwidth.numberOfAvailable': 'Number of available',
  'pages.waybillBandwidth.numberOfAvailableWaybills': 'Number of available waybills',
  'pages.waybillBandwidth.whetherToUse': 'Whether to use',
  'pages.waybillBandwidth.registrationDate': 'Registration date',
  'pages.waybillBandwidth.notInUse': 'Not in use',
  'pages.waybillBandwidth.deleteConfirmContent': 'Are you sure you want to delete this waybill bandwidth?',
  'pages.waybillBandwidth.modal.title': 'Waybill Bandwidth Registration',
  'pages.waybillBandwidth.modal.center': 'Center',
  'pages.waybillBandwidth.modal.for': 'For',
  'pages.waybillBandwidth.modal.guangzhou': 'Guangzhou',
  'pages.waybillBandwidth.modal.transportationMethod': 'Transportation method',
  'pages.waybillBandwidth.modal.domesticTransportationCompany': 'Domestic transportation company',
  'pages.waybillBandwidth.modal.bandwidth': 'Bandwidth',

  // Order Statistics
  'pages.orderStatistics.title': 'Order Statistics',
  'pages.orderStatistics.annualOrderStatistics': 'Annual order statistics',
  'pages.orderStatistics.monthlyOrderStatistics': 'Monthly order statistics',
  'pages.orderStatistics.applicationItem': 'Application Item',
  'pages.orderStatistics.costClassification': 'Cost classification',
  'pages.orderStatistics.january': 'January',
  'pages.orderStatistics.february': 'February',
  'pages.orderStatistics.march': 'March',
  'pages.orderStatistics.april': 'April',
  'pages.orderStatistics.may': 'May',
  'pages.orderStatistics.june': 'June',
  'pages.orderStatistics.july': 'July',
  'pages.orderStatistics.august': 'August',
  'pages.orderStatistics.september': 'September',
  'pages.orderStatistics.october': 'October',
  'pages.orderStatistics.november': 'November',
  'pages.orderStatistics.december': 'December',
  'pages.orderStatistics.days': 'days',
  'pages.orderStatistics.year': 'year',
  'pages.orderStatistics.month': 'month',
  'pages.orderStatistics.center': 'Center',
  'pages.orderStatistics.all': 'All',
  'pages.orderStatistics.for': 'For',
  'pages.orderStatistics.guangzhou': 'Guangzhou',
  'pages.orderStatistics.centerNote': '* To calculate to be based on the number of orders and order statistics are based on the time of completion (delivery/purchase, Guangzhou/overseas), Return (Return completed)',
  'pages.orderStatistics.annualPaymentCost': 'Annual payment cost',
  'pages.orderStatistics.monthlyPaymentFee': 'Monthly payment fee',

  // Member Statistics
  'pages.memberStatistics.title': 'Member statistics',
  'pages.memberStatistics.annualMembershipStatistics': 'Annual membership statistics',
  'pages.memberStatistics.monthlyMembershipStatistics': 'Monthly membership statistics',
  'pages.memberStatistics.memberType': 'Member type',
  'pages.memberStatistics.applicationItem': 'Application Item',
  'pages.memberStatistics.memberName': 'Member name',
  'pages.memberStatistics.leeSeomHo': 'Lee Seom-Ho',
  'pages.memberStatistics.leeSeomBark': 'Lee Seom-Bark',
  'pages.memberStatistics.memberNote': '* The calculation refers to the number of orders and amount in statistics are based on the time of completion (Delivery/Purchase, Guangzhou/overseas), Return (Return completed)',

  // Worker Statistics
  'pages.workerStatistics.title': 'Worker statistics',
  'pages.workerStatistics.workerName': "Worker's name",
  'pages.workerStatistics.numberOfActualCases': 'Number of actual cases',
  'pages.workerStatistics.actualAverage': 'Actual average',
  'pages.workerStatistics.numberOfPackages': 'Number of packages',
  'pages.workerStatistics.packagingAverage': 'Packaging average',
  'pages.workerStatistics.workerOfOrderClass': 'Worker of order class',

  // Worker Log
  'pages.workerLog.title': 'Worker Log',
  'pages.workerLog.no': 'No',
  'pages.workerLog.trackingNumber': 'Tracking number',
  'pages.workerLog.orderNumber': 'Order number',
  'pages.workerLog.operationLog': 'Operation log',
  'pages.workerLog.workerName': "Worker's name",
  'pages.workerLog.recipientName': "Recipient's name",
  'pages.workerLog.memberNamePostOffice': 'Member Name/Post Office',
  'pages.workerLog.waybillNumber': 'Waybill number',
  'pages.workerLog.packagingDate': 'Packaging date',
  'pages.workerLog.shippingDate': 'Shipping date',

  // Tax Settlement Management
  'pages.taxSettlement.title': 'Tax settlement management',
  'pages.taxSettlement.no': 'No',
  'pages.taxSettlement.agencyClassification': 'Agency classification',
  'pages.taxSettlement.purchaseAmount': 'Purchase amount',
  'pages.taxSettlement.purchaseFee': 'Purchase fee',
  'pages.taxSettlement.region': 'Region',
  'pages.taxSettlement.transportationMethod': 'Transportation method',
  'pages.taxSettlement.mailboxNumber': 'Mailbox number',
  'pages.taxSettlement.waybillNumber': 'Waybill number',
  'pages.taxSettlement.orderNumber': 'Order number',
  'pages.taxSettlement.receiver': 'Receiver',
  'pages.taxSettlement.recipientAddress': 'Recipient address',
  'pages.taxSettlement.personalCustomsCode': 'Personal customs code',
  'pages.taxSettlement.productNameEnglish': 'Product name (English)',
  'pages.taxSettlement.ct': 'C/T',
  'pages.taxSettlement.weight': 'Weight',
  'pages.taxSettlement.shippingCosts': 'Shipping costs',
  'pages.taxSettlement.additionalServices': 'Additional services',
  'pages.taxSettlement.additionalCostPayment': 'Additional cost payment',
  'pages.taxSettlement.memberName': 'Member name',
  'pages.taxSettlement.federalCode': 'Federal code',
  'pages.taxSettlement.excelDownload': 'Excel Download',

  // Purchase Cost Statistics
  'pages.purchaseCost.title': 'Purchase cost statistics',
  'pages.purchaseCost.costItems': 'Cost items',
  'pages.purchaseCost.totalWon': 'Total (₩)',
  'pages.purchaseCost.yuanAmount': 'Yuan (¥)',
  'pages.purchaseCost.no': 'No',
  'pages.purchaseCost.purchaseCompletionDate': 'Purchase completion date',
  'pages.purchaseCost.orderNumber': 'Order number',
  'pages.purchaseCost.transportationMethod': 'Transportation method',
  'pages.purchaseCost.productPurchaseCost': 'Product purchase cost',
  'pages.purchaseCost.localShippingFee': 'Local shipping fee',
  'pages.purchaseCost.purchaseFee': 'Purchase fee',
  'pages.purchaseCost.additionalCost': 'Additional cost',
  'pages.purchaseCost.excessCostOfItems': 'Excess cost of items',
  'pages.purchaseCost.productPurchaseCostPercent': 'Product purchase cost (%)',
  'pages.purchaseCost.localShippingFeePercent': 'Local shipping fee (%)',
  'pages.purchaseCost.purchaseFeePercent': 'Purchase fee (%)',
  'pages.purchaseCost.additionalCostPercent': 'Additional cost (%)',
  'pages.purchaseCost.excessCostOfItemsPercent': 'Excess cost of items (%)',
  'pages.purchaseCost.yuan': 'Yuan (¥)',

  // Trade Cost Statistics
  'pages.tradeCost.title': 'Trade cost statistics',
  'pages.tradeCost.applicationType': 'Application type',
  'pages.tradeCost.chibaYonggun1': '1 Chiba Yonggun (gun)',
  'pages.tradeCost.chibayong1': '1 chibayong (₩)',
  'pages.tradeCost.chibaYonggun2': '2-chibayong gun (gun)',
  'pages.tradeCost.chiba2': '2 Chiba (₩)',
  'pages.tradeCost.chibaYonggun3': '3-chibayong gun (gun)',
  'pages.tradeCost.pieceSet3': '3-piece set (₩)',
  'pages.tradeCost.totalAmount': 'Total amount (₩)',
  'pages.tradeCost.no': 'No',
  'pages.tradeCost.tradeNumber': 'Trade number',
  'pages.tradeCost.endDate': 'End date',
  'pages.tradeCost.memberName': 'Member name',
  'pages.tradeCost.mailboxNumber': 'Mailbox number',
  'pages.tradeCost.firstCost': '1st cost (₩)',
  'pages.tradeCost.secondaryCost': 'Secondary cost (₩)',
  'pages.tradeCost.thirdCost': '3rd cost (₩)',
  'pages.tradeCost.select': '= Select',
  'pages.tradeCost.detailList': 'Detail list',
  'pages.tradeCost.noData': 'No data',

  // Payment Agency Statistics
  'pages.paymentAgency.title': 'Payment agency statistics',
  'pages.paymentAgency.annualPaymentAgencyStatistics': 'Annual payment agency statistics',
  'pages.paymentAgency.monthlyPaymentAgencyStatistics': 'Monthly payment agency statistics',
  'pages.paymentAgency.applicationItem': 'Application Item',
  'pages.paymentAgency.note': '* The calculation refers to the number of orders and amount in statistics are all based on the time of completion (Delivery/Purchase, Guangzhou/overseas), Return (Return completed)',
  'pages.paymentAgency.monthlyNote': '* The calculation refers to the number of orders and amount in statistics are all based on the time of completion (Payment agency, Agency completed)',
  'pages.paymentAgency.annualPaymentCost': 'Annual payment cost',
  'pages.paymentAgency.monthlyPaymentFee': 'Monthly payment fee',

  // Solution Inquiry
  'pages.solutionInquiry.title': 'Today Direct Purchase Co., Ltd.',
  'pages.solutionInquiry.announcement': 'announcement',
  'pages.solutionInquiry.workRequest': 'Work request',
  'pages.solutionInquiry.administratorGuide': 'Administrator Guide',
  'pages.solutionInquiry.num': 'num',
  'pages.solutionInquiry.author': 'Author',
  'pages.solutionInquiry.dateOfWriting': 'Date of writing',
  'pages.solutionInquiry.check': 'check',
  'pages.solutionInquiry.menu': 'menu',
  'pages.solutionInquiry.submenu': 'Submenu',
  'pages.solutionInquiry.submenuFilter': '= Submenu',
  'pages.solutionInquiry.detail': 'detail',
  'pages.solutionInquiry.noContent': 'No content available',
  'pages.solutionInquiry.depositInfo': 'Deposit account information: Kookmin Bank 984784307598 Areum Solution Co., Ltd.',
  'pages.solutionInquiry.copyright': '©Copyright 2014 — 2026 Arum Solution. All rights reserved. Go to',
  'pages.solutionInquiry.requestNumber': 'Request number',
  'pages.solutionInquiry.requestType': 'Request type',
  'pages.solutionInquiry.status': 'Status',
  'pages.solutionInquiry.requestDate': 'Request date',
  'pages.solutionInquiry.completionDate': 'Completion date',
  'pages.solutionInquiry.description': 'Description',

  'pages.common.ok': 'OK',

  // Trade Services
  'pages.orders.tradeServices.serviceType': 'Service Type',
  'pages.orders.tradeServices.type': 'Type',
  'pages.orders.tradeServices.tradeNumber': 'Trade Number',
  'pages.orders.tradeServices.tradeNumberPlaceholder': 'Enter trade number',
  'pages.orders.tradeServices.applicationDate': 'Application Date',
  'pages.orders.tradeServices.typeCenter': 'Type/Center',
  'pages.orders.tradeServices.title': 'Title',
  'pages.orders.tradeServices.progress': 'Progress',
  'pages.orders.tradeServices.progressApplication': 'Application',
  'pages.orders.tradeServices.progressQuotation': 'Quotation',
  'pages.orders.tradeServices.progressPayment': 'Payment Pending',
  'pages.orders.tradeServices.progressInProgress': 'In Progress',
  'pages.orders.tradeServices.progressCompleted': 'Completed',
  'pages.orders.tradeServices.paymentInfo': 'Payment Info',
  'pages.orders.tradeServices.quotationAmount': 'Quotation',
  'pages.orders.tradeServices.paidAmount': 'Paid',
  'pages.orders.tradeServices.documents': 'Quotation/Report',
  'pages.orders.tradeServices.viewQuotation': 'View Quotation',
  'pages.orders.tradeServices.viewCompletionReport': 'View Report',
  'pages.orders.tradeServices.viewApplication': 'View Application',
  'pages.orders.tradeServices.delete': 'Delete',
  'pages.orders.tradeServices.viewingApplication': 'Viewing application {number}',
  'pages.orders.tradeServices.deleteConfirm': 'Delete {number}?',
  'pages.orders.tradeServices.sampleTitle1': 'Clothing Export Agency Application',
  'pages.orders.tradeServices.sampleTitle2': 'Electronics Import Customs Clearance',
  'pages.orders.tradeServices.sampleTitle3': 'Trade Consulting Request',
  'pages.orders.tradeServices.export': 'Export',
  'pages.orders.tradeServices.import': 'Import',
  'pages.orders.tradeServices.customs': 'Customs',
  'pages.orders.tradeServices.consulting': 'Consulting',
  'pages.orders.tradeServices.amount': 'Amount',
  'pages.orders.tradeServices.requestDate': 'Request Date',
  'pages.orders.tradeServices.completionDate': 'Completion Date',
  'pages.orders.tradeServices.totalServices': 'Total Services',
  'pages.orders.tradeServices.processingServices': 'Processing Services',
  'pages.orders.tradeServices.completedServices': 'Completed Services',
  'pages.orders.tradeServices.totalAmount': 'Total Amount',
  'pages.orders.tradeServices.pendingCount': 'Pending',
  'pages.orders.tradeServices.overdueCount': 'Overdue',
  'pages.orders.tradeServices.totalPendingAmount': 'Total Pending Amount',
  'pages.orders.tradeServices.dueDate': 'Due Date',
  'pages.orders.tradeServices.processPayment': 'Process Payment',
  'pages.orders.tradeServices.paymentProcessed': 'Payment has been processed',
  'pages.orders.tradeServices.sampleMemo': 'Sample memo',
  
  // Trade Services - Comprehensive Management Filter
  'pages.orders.tradeServices.marketResearchUnitPrice': 'Market research (unit price)',
  'pages.orders.tradeServices.marketResearchOEM': 'Market research (OEM factory)',
  'pages.orders.tradeServices.productionAgency': 'Production agency',
  'pages.orders.tradeServices.exportAgency': 'Export agency',
  'pages.orders.tradeServices.oneStopGuide': 'One-stop guide',
  'pages.orders.tradeServices.applicationReception': 'Application reception',
  'pages.orders.tradeServices.confirmationReceipt': 'Confirmation of receipt',
  'pages.orders.tradeServices.paymentWaiting1st': 'Payment waiting (1st)',
  'pages.orders.tradeServices.inProgress': 'In progress',
  'pages.orders.tradeServices.1stCompletion': '1st completion',
  'pages.orders.tradeServices.paymentWaiting2nd': 'Payment waiting (2nd)',
  'pages.orders.tradeServices.paymentCompleted2nd': 'Payment completed (2nd)',
  'pages.orders.tradeServices.paymentCompleted3rd': 'Payment completed (3rd)',
  'pages.orders.tradeServices.shipmentCompleted': 'Shipment completed',
  'pages.orders.tradeServices.cancelApplication': 'Cancel application',
  
  // Payment Agency - Comprehensive Management Filter
  'pages.orders.paymentAgency.title': 'Payment agency',
  'pages.orders.paymentAgency.waitingForPayment': 'Waiting for payment',
  'pages.orders.paymentAgency.depositCompleted': 'Deposit completed',
  'pages.orders.paymentAgency.paymentCompletedAtPurchase': 'Payment completed at the point of purchase',
  'pages.orders.paymentAgency.agencyCompleted': 'Agency completed',
  'pages.orders.paymentAgency.paymentRefundRequest': 'Payment refund request',
  'pages.orders.paymentAgency.paymentRefundCompleted': 'Payment refund completed',
  'pages.orders.paymentAgency.cancellation': 'cancellation',

  // Trade Service Application Modal
  'pages.orders.tradeServices.applicationModal.title': 'Trade Services - Market Research (Product Unit Price)',
  'pages.orders.tradeServices.applicationModal.basicInfo': 'Basic Information',
  'pages.orders.tradeServices.applicationModal.centerName': 'Center Name',
  'pages.orders.tradeServices.applicationModal.quotationReport': 'Quotation/Completion Report',
  'pages.orders.tradeServices.applicationModal.chooseFile': 'Choose File',
  'pages.orders.tradeServices.applicationModal.fileSelect': 'File Select',
  'pages.orders.tradeServices.applicationModal.fileUpload': 'File Upload',
  'pages.orders.tradeServices.applicationModal.applicationInfo': 'Application Information',
  'pages.orders.tradeServices.applicationModal.client': 'Client',
  'pages.orders.tradeServices.applicationModal.totalQuantity': 'Total Quantity',
  'pages.orders.tradeServices.applicationModal.totalAmount': 'Total Amount',
  'pages.orders.tradeServices.applicationModal.contact': 'Contact',
  'pages.orders.tradeServices.applicationModal.email': 'Email',
  'pages.orders.tradeServices.applicationModal.address': 'Address',
  'pages.orders.tradeServices.applicationModal.productInfo': 'Product Information',
  'pages.orders.tradeServices.applicationModal.productName': 'Product Name',
  'pages.orders.tradeServices.applicationModal.productUrl': 'Product URL',
  'pages.orders.tradeServices.applicationModal.material': 'Material/Material',
  'pages.orders.tradeServices.applicationModal.estimatedUnitPrice': 'Estimated Unit Price',
  'pages.orders.tradeServices.applicationModal.quantity': 'Quantity',
  'pages.orders.tradeServices.applicationModal.productImage': 'Product Image',
  'pages.orders.tradeServices.applicationModal.downloadImage': 'Download Image',
  'pages.orders.tradeServices.applicationModal.adminMemo': 'Admin Memo',

  // Payment Agency
  'pages.orders.paymentAgency.paymentType': 'Payment Type',
  'pages.orders.paymentAgency.alipay': 'Alipay',
  'pages.orders.paymentAgency.wechat': 'WeChat Pay',
  'pages.orders.paymentAgency.unionpay': 'UnionPay',
  'pages.orders.paymentAgency.bank': 'Bank Transfer',
  'pages.orders.paymentAgency.amount': 'Amount',
  'pages.orders.paymentAgency.requestDate': 'Request Date',
  'pages.orders.paymentAgency.completionDate': 'Completion Date',
  'pages.orders.paymentAgency.totalPayments': 'Total Payments',
  'pages.orders.paymentAgency.processingPayments': 'Processing Payments',
  'pages.orders.paymentAgency.completedPayments': 'Completed Payments',
  'pages.orders.paymentAgency.totalAmount': 'Total Amount',
  'pages.orders.paymentAgency.pendingCount': 'Pending',
  'pages.orders.paymentAgency.overdueCount': 'Overdue',
  'pages.orders.paymentAgency.totalPendingAmount': 'Total Pending Amount',
  'pages.orders.paymentAgency.dueDate': 'Due Date',
  'pages.orders.paymentAgency.processPayment': 'Process Payment',
  'pages.orders.paymentAgency.paymentProcessed': 'Payment has been processed',
  'pages.orders.paymentAgency.sampleMemo': 'Sample memo',

  // Order Finance
  'pages.orderFinance.headerTitle': 'Order Finance List',
  'pages.orderFinance.modal.title': 'Order Finance Detail',
  'pages.orderFinance.column.orderNumber': 'Order No.',
  'pages.orderFinance.column.user': 'User',
  'pages.orderFinance.column.progressStatus': 'Progress Status',
  'pages.orderFinance.column.firstTierStatus': '1st Payment Status',
  'pages.orderFinance.column.firstTierPaymentMethod': '1st Payment Method',
  'pages.orderFinance.column.firstTierPaidAt': '1st Paid At',
  'pages.orderFinance.column.secondTierStatus': '2nd Payment Status',
  'pages.orderFinance.column.secondTierPaymentMethod': '2nd Payment Method',
  'pages.orderFinance.column.secondTierPaidAt': '2nd Paid At',
  'pages.orderFinance.column.firstTierAmountKRW': '1st Amount (₩)',
  'pages.orderFinance.column.secondTierAmountKRW': '2nd Amount (₩)',
  'pages.orderFinance.column.totalChargeKRW': 'Total Charge (₩)',
  'pages.orderFinance.column.totalCollectedKRW': 'Total Collected (₩)',
  'pages.orderFinance.column.outstandingKRW': 'Outstanding (₩)',
  'pages.orderFinance.column.hasRefundRisk': 'Refund Risk',
  'pages.orderFinance.column.updatedAt': 'Last Updated',
  'pages.orderFinance.column.createdAt': 'Created At',
  'pages.orderFinance.refundRisk.danger': 'Risk',
  'pages.orderFinance.refundRisk.normal': 'Normal',
  'pages.orderFinance.modal.userId': 'User',
  'pages.orderFinance.modal.memberId': 'Member ID',
  'pages.orderFinance.modal.email': 'Email',
  'pages.orderFinance.modal.progressStatus': 'Progress Status',
  'pages.orderFinance.modal.firstTierStatus': '1st Payment Status',
  'pages.orderFinance.modal.firstTierPaymentMethod': '1st Payment Method',
  'pages.orderFinance.modal.firstTierAmount': '1st Amount',
  'pages.orderFinance.modal.firstTierBeforeDiscount': '1st Before Discount',
  'pages.orderFinance.modal.firstTierPaidAt': '1st Paid At',
  'pages.orderFinance.modal.secondTierStatus': '2nd Payment Status',
  'pages.orderFinance.modal.secondTierPaymentMethod': '2nd Payment Method',
  'pages.orderFinance.modal.secondTierAmount': '2nd Amount',
  'pages.orderFinance.modal.secondTierBeforeDiscount': '2nd Before Discount',
  'pages.orderFinance.modal.secondTierPaidAt': '2nd Paid At',
  'pages.orderFinance.modal.totalCharge': 'Total Charge',
  'pages.orderFinance.modal.totalCollected': 'Total Collected',
  'pages.orderFinance.modal.outstanding': 'Outstanding',
  'pages.orderFinance.modal.createdAt': 'Created At',
  'pages.orderFinance.modal.updatedAt': 'Last Updated',
  'pages.orderFinance.progressStatus.BUY_PAY_WAIT': 'Awaiting Purchase Payment',
  'pages.orderFinance.progressStatus.BUY_PAY_DONE': 'Purchase Payment Done',
  'pages.orderFinance.progressStatus.BUYING_AUTO': 'Auto Purchasing',
  'pages.orderFinance.progressStatus.BUYING_MANUAL': 'Manual Purchasing',
  'pages.orderFinance.progressStatus.BUYING_PROBLEM': 'Purchase Problem',
  'pages.orderFinance.progressStatus.BUYING_FINANCIAL_SETTLEMENT': 'Purchase Settlement',
  'pages.orderFinance.progressStatus.BUY_FINAL_DONE': 'Purchase Complete',
  'pages.orderFinance.progressStatus.WH_IN_DONE': 'Warehoused',
  'pages.orderFinance.progressStatus.WH_PAY_WAIT': 'Awaiting Shipping Payment',
  'pages.orderFinance.progressStatus.WH_PAY_DONE': 'Shipping Payment Done',
  'pages.orderFinance.paymentStatus.pending': 'Pending',
  'pages.orderFinance.paymentStatus.processing': 'Processing',
  'pages.orderFinance.paymentStatus.paid': 'Paid',
  'pages.orderFinance.paymentStatus.failed': 'Failed',
  'pages.orderFinance.paymentStatus.refunded': 'Refunded',
  'pages.orderFinance.paymentMethod.card': 'Card',
  'pages.orderFinance.paymentMethod.bank': 'Bank Transfer',
  'pages.orderFinance.paymentMethod.deposit': 'Deposit',
  'pages.orderFinance.paymentMethod.points': 'Points',

  // Refund Records
  'pages.refundRecords.headerTitle': 'Refund Records',
  'pages.refundRecords.column.status': 'Status',
  'pages.refundRecords.column.gateway': 'Gateway',
  'pages.refundRecords.column.reason': 'Reason',
  'pages.refundRecords.column.refundAmountKRW': 'Refund Amount (₩)',
  'pages.refundRecords.column.refundCount': 'Refund Count',
  'pages.refundRecords.summary.totalRefundAmountKRW': 'Total Refund Amount',
  'pages.refundRecords.summary.totalRefundCount': 'Total Refund Count',
  'pages.refundRecords.summary.paidRefundCount': 'Paid Refund Count',
  'pages.refundRecords.summary.refundSuccessRate': 'Success Rate',
  'pages.refundRecords.status.paid': 'Paid',
  'pages.refundRecords.status.pending': 'Pending',
  'pages.refundRecords.status.failed': 'Failed',
  'pages.refundRecords.gateway.deposit': 'Deposit',
  'pages.refundRecords.gateway.billgate': 'Billgate',
  'pages.refundRecords.gateway.card': 'Card',
  'pages.refundRecords.gateway.bank': 'Bank Transfer',
  'pages.refundRecords.filter.startDate': 'Start Date',
  'pages.refundRecords.filter.endDate': 'End Date',

  // Refund Records (settlement page — new design)
  'pages.refundRecords.title': 'Refund Records',
  'pages.refundRecords.listTitle': 'Refund Records List',
  'pages.refundRecords.period.todayRefundAmount': "Today's Refund Amount",
  'pages.refundRecords.period.month': 'This Month',
  'pages.refundRecords.period.quarter': 'This Quarter',
  'pages.refundRecords.period.year': 'This Year',
  'pages.refundRecords.unit.count': 'Cases',
  'pages.refundRecords.unit.qty': 'Qty',
  'pages.refundRecords.stat.total': 'Total',
  'pages.refundRecords.stat.partial': 'Partial Refund',
  'pages.refundRecords.stat.bankWithdrawal': 'Bank Withdrawal',
  'pages.refundRecords.stat.member': 'Member Refund',
  'pages.refundRecords.stat.deposit': 'Deposit',
  'pages.refundRecords.stat.card': 'Credit Card',
  'pages.refundRecords.stat.full': 'Full Refund',
  'pages.refundRecords.stat.platform': 'Platform Refund',
  'pages.refundRecords.stat.lostCoupon': 'Lost Coupon',
  'pages.refundRecords.stat.final': 'Final Refund',
  'pages.refundRecords.stat.lostPoints': 'Lost Points',
  'pages.refundRecords.viewMode.detail': 'Detail View',
  'pages.refundRecords.viewMode.summary': 'Summary View',
  'pages.refundRecords.filter.page': 'Page Size',
  'pages.refundRecords.filter.startTime': 'Start Time',
  'pages.refundRecords.filter.endTime': 'End Time',
  'pages.refundRecords.filter.domesticTrackingNo': 'Domestic Tracking No.',
  'pages.refundRecords.filter.refundReason': 'Refund Reason',
  'pages.refundRecords.filter.platform': 'Platform',
  'pages.refundRecords.filter.errorType': 'Error Type',
  'pages.refundRecords.filter.refundType': 'Refund Type',
  'pages.refundRecords.filter.refundRoute': 'Refund Route',
  'pages.refundRecords.filter.refundStatus': 'Refund Status',
  'pages.refundRecords.filter.mailbox': 'Mailbox',
  'pages.refundRecords.filter.sellerMailbox': 'Seller mailbox',
  'pages.refundRecords.filter.orderNumber': 'Order Number',
  'pages.refundRecords.filter.returnDomesticTrackingNo': 'Return Domestic Tracking',
  'pages.refundRecords.filter.refundSerialNo': 'Refund Serial No.',
  'pages.refundRecords.filter.memberName': 'Member Name',
  'pages.refundRecords.filter.asManager': 'AS Manager',
  'pages.refundRecords.filter.returnInternationalTrackingNo': 'Return International Tracking',
  'pages.refundRecords.filter.financeManager': 'Finance Manager',
  'pages.refundRecords.filter.returnManager': 'Return Manager',
  'pages.refundRecords.platform.1688': '1688',
  'pages.refundRecords.platform.taobao': 'Taobao',
  'pages.refundRecords.platform.vvic': 'vvic',
  'pages.refundRecords.platform.self': 'Self Mall',
  'pages.refundRecords.platform.ownmall': 'Self Mall',
  'pages.refundRecords.platform.live': 'Live Channel',
  'pages.refundRecords.errorType.member': 'Member Refund',
  'pages.refundRecords.errorType.platform': 'Platform Refund',
  'pages.refundRecords.errorType.final': 'Final Refund',
  'pages.refundRecords.errorType.user_refund': 'Member Refund',
  'pages.refundRecords.errorType.platform_refund': 'Platform Refund',
  'pages.refundRecords.errorType.final_refund': 'Final Refund',
  'pages.refundRecords.refundType.partial': 'Partial',
  'pages.refundRecords.refundType.full': 'Full',
  'pages.refundRecords.paymentMethod.deposit': 'Deposit',
  'pages.refundRecords.paymentMethod.points': 'Points',
  'pages.refundRecords.paymentMethod.bank': 'Bank transfer',
  'pages.refundRecords.paymentMethod.card': 'Credit card',
  'pages.refundRecords.paymentMethod.billgate': 'Billgate',
  'pages.refundRecords.refundRoute.cardCard': 'Card → Card',
  'pages.refundRecords.refundRoute.bankDeposit': 'Bank → Deposit',
  'pages.refundRecords.refundRoute.depositDeposit': 'Deposit → Deposit',
  'pages.refundRecords.refundRoute.depositBank': 'Deposit → Bank',
  'pages.refundRecords.refundRoute.pointsPoints': 'Points → Points',
  'pages.refundRecords.refundRoute.applying': 'Applying',
  'pages.refundRecords.refundRoute.user_refund': 'Member Refund',
  'pages.refundRecords.refundRoute.platform_refund': 'Platform Refund',
  'pages.refundRecords.refundRoute.final_refund': 'Final Refund',
  'pages.refundRecords.recordStatus.pending': 'Pending',
  'pages.refundRecords.recordStatus.completed': 'Completed',
  'pages.refundRecords.status.done': 'Completed',
  'pages.refundRecords.status.asInProgress': 'AS In Progress',
  'pages.refundRecords.action.search': 'Search',
  'pages.refundRecords.action.download': 'Download',
  'pages.refundRecords.action.confirm': 'Confirm',
  'pages.refundRecords.action.cancel': 'Cancel',
  'pages.refundRecords.note.asInputArea': 'AS manager input fields: Refund Reason, AS History, Bank Info, Return Tracking Numbers',
  'pages.refundRecords.note.autoAccumulate': 'Data is auto-accumulated upon refund completion',
  'pages.refundRecords.col.no': 'No.',
  'pages.refundRecords.col.mailboxMember': 'Mailbox / Member',
  'pages.refundRecords.col.refundOrderProduct': 'Refund Serial / Order No. / Product Name',
  'pages.refundRecords.col.relatedOrderNumbers': 'Related order no.',
  'pages.refundRecords.col.routeStatus': 'Refund Route / Status',
  'pages.refundRecords.col.platformRefundNo': 'Platform / Refund No.',
  'pages.refundRecords.col.priceFeeShipping': 'Product / Fee / Domestic Shipping',
  'pages.refundRecords.col.lostCouponPoints': 'Lost Coupon / Points',
  'pages.refundRecords.col.firstPayment': '1st Payment / Method / Order Date',
  'pages.refundRecords.col.secondPayment': '2nd Payment / Method / Order Date',
  'pages.refundRecords.col.refundAmountRate': 'Refund Amount / Rate',
  'pages.refundRecords.col.tracking': 'Domestic / International Tracking',
  'pages.refundRecords.col.reasonErrorType': 'Error Type / Refund Type',
  'pages.refundRecords.col.asInfo': 'AS Manager / History / Node Change Date',
  'pages.refundRecords.col.bankWithdrawal': '[Bank Withdrawal] / Recipient / Account No.',
  'pages.refundRecords.col.returnTracking': '[AS Input] / Return Domestic / International Tracking',
  'pages.refundRecords.col.returnManager': 'Return Manager / Confirmation Date',
  'pages.refundRecords.col.refundChannel': '[Deposit Refund] / [Card Refund]',
  'pages.refundRecords.col.financeManager': 'Finance Manager / Withdrawal Date',
  'pages.refundRecords.col.action': 'Action',

  // Points (settlement page — new design)
  'pages.points.title': 'Points History',
  'pages.points.listTitle': 'Points Usage History List',
  'pages.points.period.today': 'Today',
  'pages.points.period.month': 'This Month',
  'pages.points.period.quarter': 'This Quarter',
  'pages.points.period.year': 'This Year',
  'pages.points.label.earnPoints': 'Earned Points',
  'pages.points.label.deductPoints': 'Deducted Points',
  'pages.points.chart.monthlyAccrual': 'Monthly Accrual',
  'pages.points.chart.monthlyDeduction': 'Monthly Deduction',
  'pages.points.chart.accrualPoints': 'Accrual Points',
  'pages.points.chart.deductionPoints': 'Deduction Points',
  'pages.points.chart.dayAxis': 'Day',
  'pages.points.filter.accrualType': 'Accrual Type',
  'pages.points.filter.deductionType': 'Deduction Type',
  'pages.points.accrualType.join': 'Join Bonus',
  'pages.points.accrualType.review': 'Review Bonus',
  'pages.points.accrualType.orderDone': 'Order Complete Bonus',
  'pages.points.accrualType.attendance': 'Attendance Bonus',
  'pages.points.accrualType.share': 'Share Bonus',
  'pages.points.accrualType.admin': 'Admin Accrual',
  'pages.points.deductionType.orderDeduct': 'Order Deduction',
  'pages.points.deductionType.adminDeduct': 'Admin Deduction',
  'pages.points.deductionType.expired': 'Expired Removal',
  'pages.points.action.search': 'Search',
  'pages.points.action.download': 'Download',
  'pages.points.filter.page': 'Page Size',
  'pages.points.filter.startTime': 'Start Time',
  'pages.points.filter.endTime': 'End Time',
  'pages.points.filter.mailbox': 'Mailbox',
  'pages.points.filter.serialNo': 'Serial No.',
  'pages.points.filter.memberName': 'Member Name',
  'pages.points.filter.orderNumber': 'Order Number',
  'pages.points.col.no': 'No.',
  'pages.points.col.mailboxMember': 'Mailbox / Member',
  'pages.points.col.remainingPoints': 'Remaining Points',
  'pages.points.col.serialNo': 'Serial No.',
  'pages.points.col.category': 'Category',
  'pages.points.col.earnedPoints': 'Earned Points',
  'pages.points.col.orderInfo': 'Order No. / Order Date',
  'pages.points.col.deductedPoints': 'Deducted Points',
  'pages.points.col.afterChange': 'Points After / Change Date',
  'pages.points.col.adminAction': 'Admin / Action',
  'pages.points.action.addOrDeduct': 'Add / Deduct',
  'pages.points.modal.title': 'Admin Points Operation',
  'pages.points.modal.label.mailbox': 'Mailbox',
  'pages.points.modal.label.memberName': 'Member',
  'pages.points.modal.placeholder.reason': 'Enter reason...',
  'pages.points.modal.button.addPoints': 'Points +',
  'pages.points.modal.button.deductPoints': 'Points -',
  'pages.points.modal.checkbox.confirmRequired': 'Info & Points confirmation required',
  'pages.points.modal.button.confirm': 'Confirm',
  'pages.points.modal.button.cancel': 'Cancel',
  'pages.points.modal.error.reasonRequired': 'Please enter a reason',
  'pages.points.modal.error.confirmRequired': 'Confirmation is required',
  'pages.points.message.operationDone': 'Points operation completed',
  'pages.points.message.fetchError': 'Failed to load points history',
  'pages.points.message.exportSuccess': 'Excel export completed',
  'pages.points.message.exportError': 'Export failed',

  // Coupon Usage (settlement page — new design)
  'pages.couponUsage.title': 'Coupon Usage History',
  'pages.couponUsage.listTitle': 'Coupon Usage History List',
  'pages.couponUsage.period.today': 'Today',
  'pages.couponUsage.period.month': 'This Month',
  'pages.couponUsage.period.quarter': 'This Quarter',
  'pages.couponUsage.period.year': 'This Year',
  'pages.couponUsage.label.usedAmount': 'Used Amount',
  'pages.couponUsage.label.usedCount': 'Used Count',
  'pages.couponUsage.label.monthlyUsedAmount': 'Monthly Used Amount',
  'pages.couponUsage.label.monthlyUsedCount': 'Monthly Used Count',
  'pages.couponUsage.label.issueAmountQty': 'Issued Amount/Qty',
  'pages.couponUsage.label.useAmountQty': 'Used Amount/Qty',
  'pages.couponUsage.label.remainAmountQty': 'Remaining Amount/Qty',
  'pages.couponUsage.chart.legend.amount': 'Amount',
  'pages.couponUsage.chart.legend.count': 'Count',
  'pages.couponUsage.chart.daily': 'Daily',
  'pages.couponUsage.chart.monthly': 'Monthly',
  'pages.couponUsage.viewMode.detail': 'Detail Search',
  'pages.couponUsage.viewMode.summary': 'Summary Search',
  'pages.couponUsage.filter.page': 'Page Size',
  'pages.couponUsage.filter.startTime': 'Start Time',
  'pages.couponUsage.filter.endTime': 'End Time',
  'pages.couponUsage.filter.couponType': 'Coupon Type',
  'pages.couponUsage.filter.issueMethod': 'Issue Method',
  'pages.couponUsage.couponType.product': 'Product Coupon',
  'pages.couponUsage.couponType.shipping': 'Shipping Coupon',
  'pages.couponUsage.couponType.system': 'System Coupon',
  'pages.couponUsage.issueMethod.voucher': 'Voucher',
  'pages.couponUsage.issueMethod.systemIssue': 'System Issue',
  'pages.couponUsage.action.search': 'Search',
  'pages.couponUsage.action.download': 'Download',
  'pages.couponUsage.filter.mailbox': 'Mailbox',
  'pages.couponUsage.filter.orderNumber': 'Order Number',
  'pages.couponUsage.filter.couponCode': 'Coupon Code',
  'pages.couponUsage.filter.memberName': 'Member Name',
  'pages.couponUsage.filter.createdAt': 'Created Date',
  'pages.couponUsage.filter.couponName': 'Coupon Name',
  'pages.couponUsage.col.no': 'No.',
  'pages.couponUsage.col.mailboxMember': 'Mailbox / Member',
  'pages.couponUsage.col.orderInfo': 'Order No. / Order Date',
  'pages.couponUsage.col.typeMethod': 'Coupon Type / Issue Method',
  'pages.couponUsage.col.nameCode': 'Coupon Name / Code',
  'pages.couponUsage.col.faceValueMin': 'Face Value / Min Order Amount',
  'pages.couponUsage.col.serialCreated': 'Serial No. / Created Date',

  // Financial Records (settlement page — new design)
  'pages.financialRecords.title': 'Financial Records',
  'pages.financialRecords.listTitle': 'Financial Records List',
  'pages.financialRecords.listNote': '1st Payment Cost = Deposit / Coupon / Points + 1st Bank Deposit · 2nd Payment Cost = Deposit / Coupon + 2nd Bank Deposit',
  'pages.financialRecords.viewMode.detail': 'Detail View',
  'pages.financialRecords.viewMode.summary': 'Summary View',
  'pages.financialRecords.period.todayPaymentAmount': "Today's Payment Amount",
  'pages.financialRecords.period.month': 'This Month',
  'pages.financialRecords.period.quarter': 'This Quarter',
  'pages.financialRecords.period.year': 'This Year',
  'pages.financialRecords.stat.total': 'Total',
  'pages.financialRecords.stat.bank': 'Bank Transfer',
  'pages.financialRecords.stat.card': 'Credit Card',
  'pages.financialRecords.stat.deposit': 'Deposit',
  'pages.financialRecords.stat.first': '1st',
  'pages.financialRecords.stat.second': '2nd',
  'pages.financialRecords.info.defaultIsTodayDone': "Default shows today's completed-payment amount",
  'pages.financialRecords.info.clickShowsCorrespondingTime': 'Click to show completed-payment amount for the corresponding period',
  'pages.financialRecords.info.totalEqFirstSecond': 'Total = 1st + 2nd',
  'pages.financialRecords.info.totalEqBankCard': 'Total = Bank Transfer + Credit Card',
  'pages.financialRecords.info.depositSeparate': 'Deposit is separate',
  'pages.financialRecords.info.systemTimeUtc9': 'System time set to UTC+9',
  'pages.financialRecords.info.shownAsCurrentResults': "Displayed with the day's current results",
  'pages.financialRecords.info.recordedAsDailyAfter24h': "Recorded as that day's data after 24 hours",
  'pages.financialRecords.filter.page': 'Page Size',
  'pages.financialRecords.filter.startTime': 'Start Time',
  'pages.financialRecords.filter.endTime': 'End Time',
  'pages.financialRecords.filter.paymentSerialNo': 'Payment Serial No.',
  'pages.financialRecords.filter.platform': 'Platform',
  'pages.financialRecords.filter.region': 'Region',
  'pages.financialRecords.filter.orderType': 'Order type',
  'pages.financialRecords.filter.shippingMethod': 'Shipping Method',
  'pages.financialRecords.filter.appliedOrder': 'Applied Order',
  'pages.financialRecords.filter.depositUsage': 'Deposit Usage',
  'pages.financialRecords.filter.specialCase': 'Special Case',
  'pages.financialRecords.filter.warehouseService': 'Warehouse Service',
  'pages.financialRecords.filter.paymentNode': 'Payment Node',
  'pages.financialRecords.filter.paymentStatus': 'Payment Status',
  'pages.financialRecords.filter.matching': 'Matching',
  'pages.financialRecords.filter.paymentMethod': 'Payment Method',
  'pages.financialRecords.filter.mailbox': 'Mailbox',
  'pages.financialRecords.filter.orderNumber': 'Order Number',
  'pages.financialRecords.filter.memberName': 'Member Name',
  'pages.financialRecords.filter.paymentAmount': 'Payment Amount',
  'pages.financialRecords.filter.domesticTrackingNo': 'Domestic Tracking No.',
  'pages.financialRecords.filter.internationalTrackingNo': 'International Tracking No.',
  'pages.financialRecords.filter.warehouseCode': 'Warehouse Code',
  'pages.financialRecords.filter.includeMergedSourceOrders': 'Include Merged Orders',
  'pages.financialRecords.filter.paymentAmountMin': 'Min',
  'pages.financialRecords.filter.paymentAmountMax': 'Max',
  'pages.financialRecords.includeMergedSourceOrders.yes': 'Include',
  'pages.financialRecords.includeMergedSourceOrders.no': 'Exclude',
  'pages.financialRecords.platform.taobao': 'Taobao',
  'pages.financialRecords.platform.self': 'Self Mall',
  'pages.financialRecords.platform.live': 'Live Channel',
  'pages.financialRecords.region.weihai': 'Weihai',
  'pages.financialRecords.region.yiwu': 'Yiwu',
  'pages.financialRecords.region.guangzhou': 'Guangzhou',
  'pages.financialRecords.shippingMethod.air': 'Air',
  'pages.financialRecords.shippingMethod.sea': 'Sea',
  'pages.financialRecords.shippingMethod.airExpress': 'Air Express',
  'pages.financialRecords.shippingMethod.shipExpress': 'Sea Express',
  'pages.financialRecords.appliedOrder.coupon': 'Coupon',
  'pages.financialRecords.appliedOrder.point': 'Points',
  'pages.financialRecords.appliedOrder.both': 'Coupon + Points',
  'pages.financialRecords.depositUsage.yes': 'Yes',
  'pages.financialRecords.depositUsage.no': 'No',
  'pages.financialRecords.specialCase.remote': 'Remote',
  'pages.financialRecords.specialCase.simple': 'Simple',
  'pages.financialRecords.specialCase.remoteSimple': 'Remote + Simple',
  'pages.financialRecords.warehouseService.photo': 'Photo Shoot',
  'pages.financialRecords.warehouseService.smallBox': 'Small Box Pack',
  'pages.financialRecords.warehouseService.bigBox': 'Big Box Pack',
  'pages.financialRecords.warehouseService.sticker': 'Sticker',
  'pages.financialRecords.warehouseService.split': 'Split Shipping',
  'pages.financialRecords.warehouseService.extra': 'Extra Charge',
  'pages.financialRecords.paymentNode.first': '1st Bank Deposit',
  'pages.financialRecords.paymentNode.second': '2nd Bank Deposit',
  'pages.financialRecords.paymentNode.integrated': 'Integrated',
  'pages.financialRecords.paymentStatusOpt.done': 'Completed',
  'pages.financialRecords.paymentStatusOpt.wait': 'Pending',
  'pages.financialRecords.paymentStatusOpt.processing': 'Processing',
  'pages.financialRecords.paymentStatusOpt.failed': 'Failed',
  'pages.financialRecords.paymentStatusOpt.refunded': 'Refunded',
  'pages.financialRecords.orderType.general': 'General',
  'pages.financialRecords.orderType.vvic': 'VVIC',
  'pages.financialRecords.orderType.rocket': 'Rocket',
  'pages.financialRecords.matching.auto': 'Auto Match',
  'pages.financialRecords.matching.manual': 'Manual Match',
  'pages.financialRecords.paymentMethodOpt.card': 'Credit Card',
  'pages.financialRecords.paymentMethodOpt.bank': 'Bank Transfer',
  'pages.financialRecords.paymentMethodOpt.deposit': 'Deposit',
  'pages.financialRecords.action.search': 'Search',
  'pages.financialRecords.action.reset': 'Reset',
  'pages.financialRecords.action.download': 'Download',
  'pages.financialRecords.col.no': 'No.',
  'pages.financialRecords.col.orderNumber': 'Order No.',
  'pages.financialRecords.col.mailboxMember': 'Mailbox / Member',
  'pages.financialRecords.col.platformProduct': 'Platform / Product Name',
  'pages.financialRecords.col.priceFeeShipping': 'Price / Fee / Domestic Shipping',
  'pages.financialRecords.col.firstTotalRate': '1st Payment Cost / Rate',
  'pages.financialRecords.col.depositCouponPoint': 'Deposit / Coupon / Points',
  'pages.financialRecords.col.firstFinal': '1st Bank Deposit / Status / Domestic Tracking',
  'pages.financialRecords.col.firstPayment': '1st Method / Depositor / Serial No.',
  'pages.financialRecords.col.firstTimes': 'Applied At / Paid At',
  'pages.financialRecords.col.routing': 'Routing',
  'pages.financialRecords.col.shippingCosts': 'Intl. Shipping / Remote Fee / Express Customs',
  'pages.financialRecords.col.serviceCost': 'Service Cost',
  'pages.financialRecords.col.secondTotalRate': '2nd Payment Cost / Rate',
  'pages.financialRecords.col.depositOnly': 'Deposit / Coupon',
  'pages.financialRecords.col.secondFinal': '2nd Bank Deposit / Status / Intl. Tracking',
  'pages.financialRecords.col.secondPayment': '2nd Method / Depositor / Serial No.',
  'pages.financialRecords.col.secondTimes': 'Applied At / Paid At',
  'pages.financialRecords.col.assignee': 'Type / Manager / Operation Time',
  'pages.financialRecords.related.mergedInto': 'Merged into',
  'pages.financialRecords.related.mergedFrom': 'Merged from',
  'pages.financialRecords.related.splitInto': 'Split into',
  'pages.financialRecords.cell.paymentDone': 'Completed',
  'pages.financialRecords.cell.firstTeamLead': '1st Team Lead',
  'pages.live.sellers.products.column.originalPriceKrw': 'Original Price',
  'pages.live.sellers.products.column.salePriceKrw': 'Sale Price',
  'pages.live.sellers.products.column.amountOnSale': 'Stock',
  'pages.live.sellers.products.inlineEdit.editTitle': 'Edit product name',
  'pages.live.sellers.products.inlineEdit.editPrice': 'Edit price',
  'pages.live.sellers.products.inlineEdit.editCompanyName': 'Edit shop name',
  'pages.live.sellers.products.inlineEdit.save': 'Save',
  'pages.live.sellers.products.inlineEdit.cancel': 'Cancel',
  'pages.live.sellers.products.inlineEdit.success': 'Updated',
  'pages.live.sellers.products.inlineEdit.failed': 'Update failed',
  'pages.orders.detail.firstPayment': '1st Payment',
  'pages.orders.detail.firstPaymentForMergedOrder': '1st Payment ({orderNumber})',
  'pages.orders.detail.secondPayment': '2nd Payment',
  'pages.orders.detail.paymentMethod.bank': 'Bank Transfer',
  'pages.orders.detail.paymentMethod.bankDeposit': 'Bank Transfer + Deposit',
  'pages.orders.detail.paymentMethod.billgate': 'Billgate',
  'pages.orders.detail.paymentMethod.cardDeposit': 'Card + Deposit',
  'pages.orders.detail.paymentMethod.deposit': 'Deposit',
  'pages.orders.detail.paymentMethod.points': 'Points',
  'pages.orders.detail.netPaymentAmount': '1st payment total',
  'pages.orders.detail.depositUsedAmount': 'Deposit',
  'pages.orders.detail.bankDepositAmount': 'Bank transfer amount',
  'pages.members.activeUsers.title': 'Active Users',
  'pages.members.activeUsers.currentActive': 'Current Active',
  'pages.members.activeUsers.loggedInUsers': 'Logged-in Users',
  'pages.members.activeUsers.anonymousVisitors': 'Anonymous Visitors',
  'pages.members.activeUsers.lastSample': 'Last Sample',
  'pages.members.activeUsers.historyTitle': 'Active Users History',
  'pages.members.activeUsers.total': 'Total',
  'pages.members.activeUsers.loggedIn': 'Logged-in',
  'pages.members.activeUsers.anonymous': 'Anonymous',
  'pages.members.activeUsers.loggedInTableTitle': 'Active Logged-in Users',
  'pages.members.activeUsers.anonymousTableTitle': 'Anonymous Visitors',
  'pages.members.activeUsers.anonymousHint': 'Showing up to 50 active anonymous visitors by visitorId.',
  'pages.members.activeUsers.memberId': 'Member ID',
  'pages.members.activeUsers.name': 'Name',
  'pages.members.activeUsers.email': 'Email',
  'pages.members.activeUsers.platform': 'Platform',
  'pages.members.activeUsers.category': 'Category',
  'pages.members.activeUsers.lastActive': 'Last Active',
  'pages.members.activeUsers.visitorId': 'Visitor ID',
  'pages.members.activeUsers.platform.web': 'Web',
  'pages.members.activeUsers.platform.android': 'Android',
  'pages.members.activeUsers.platform.ios': 'iOS',
  'pages.members.activeUsers.platform.unknown': 'Unknown',
  'pages.members.activeUsers.category.seller': 'Seller',
  'pages.members.activeUsers.category.business': 'Business',
  'pages.members.activeUsers.category.general': 'General',
  'pages.members.activeUsers.granularity.hour': 'Hourly',
  'pages.members.activeUsers.granularity.day': 'Daily',
  'pages.members.activeUsers.granularity.month': 'Monthly',
  'pages.members.activeUsers.granularity.year': 'Yearly',
  'pages.members.activeUsers.botSuspectedCard': 'Bot Suspected',
  'pages.members.activeUsers.botSuspected': 'Bot suspected',
  'pages.members.activeUsers.verdict': 'Verdict',
  'pages.members.activeUsers.verdictNormal': 'Normal',
  'pages.members.activeUsers.requestsLastHour': 'Requests (1h)',
  'pages.members.activeUsers.requestsTotal': 'Requests (7d)',
  'pages.members.activeUsers.topEndpoint': 'Top Endpoint',
  'pages.members.activeUsers.botReason.highRate': 'High rate',
  'pages.members.activeUsers.botReason.botUserAgent': 'Bot UA',
  'pages.members.activeUsers.botReason.endpointConcentration': 'Single endpoint',
  'pages.members.activeUsers.ipStatsTitle': 'Top Requesters by IP',
  'pages.members.activeUsers.ipStatsHint':
    'All-API top IPs, not 1688/Taobao detail specifically. Use the table above to block crawlers.',
  'pages.members.activeUsers.currentlyActive': 'Active Now',
  'pages.members.activeUsers.currentlyActiveYes': 'Connected',
  'pages.members.activeUsers.currentlyActiveNo': 'No socket',
  'pages.members.activeUsers.lastRequestAt': 'Last Request',
  'pages.members.activeUsers.adminTraffic': 'Admin traffic',
  'pages.members.activeUsers.purposeAlert':
    'This page is for finding and blocking IPs that crawl 1688/Taobao product-detail APIs. Socket presence counts are secondary.',
  'pages.members.activeUsers.marketplaceTitle': '1688/Taobao product-detail heavy IPs',
  'pages.members.activeUsers.marketplaceHint':
    'Counts only GET /v1/products/detail for 1688 and Taobao, plus the 1688/Taobao detail routes. Search, help-center, and admin APIs are excluded. Flagged when there are 80+ detail calls or 40+ distinct product IDs in the last hour. Blocking denies that IP access to /v1/products marketplace APIs.',
  'pages.members.activeUsers.detailLastHour': 'Detail (1h)',
  'pages.members.activeUsers.detailTotal': 'Detail (7d)',
  'pages.members.activeUsers.uniqueLastHour': 'Unique products (1h)',
  'pages.members.activeUsers.uniqueTotal': 'Unique products (7d)',
  'pages.members.activeUsers.detail1688Hour': '1688 detail (1h)',
  'pages.members.activeUsers.detailTaobaoHour': 'Taobao detail (1h)',
  'pages.members.activeUsers.abusiveCount': 'Flagged IPs',
  'pages.members.activeUsers.blockedCount': 'Blocked IPs',
  'pages.members.activeUsers.verdictAbuse': 'Detail abuse',
  'pages.members.activeUsers.abuseReason.high-detail-rate': 'High detail rate',
  'pages.members.activeUsers.abuseReason.many-unique-products': 'Many unique products',
  'pages.members.activeUsers.block7d': 'Block 7 days',
  'pages.members.activeUsers.blockPermanent': 'Block permanently',
  'pages.members.activeUsers.unblock': 'Unblock',
  'pages.members.activeUsers.blockConfirm7d': 'Block this IP from 1688/Taobao product APIs for 7 days?',
  'pages.members.activeUsers.blockConfirmPermanent': 'Permanently block this IP from 1688/Taobao product APIs?',
  'pages.members.activeUsers.unblockConfirm': 'Unblock this IP?',
  'pages.members.activeUsers.blockSuccess': 'IP blocked. Product APIs reject it immediately.',
  'pages.members.activeUsers.unblockSuccess': 'IP unblocked.',
  'pages.members.activeUsers.blockedListTitle': 'Blocked IPs',
  'pages.members.activeUsers.blockedUntil': 'Expires',
  'pages.members.activeUsers.blockedUntilPermanent': 'Permanent',
  'pages.members.activeUsers.blockedBy': 'Blocked by',
  'pages.members.activeUsers.blockedReason': 'Reason',
  'pages.members.activeUsers.action': 'Action',
  'pages.financialRecords.message.exportError': 'Failed to export to Excel',

  // Inventory management (own-mall warehouses)
  'pages.ownWarehouse.title': 'Warehouse Management',
  'pages.ownWarehouse.subtitle': 'Warehouse list and management',
  'pages.ownWarehouse.loadFailed': 'Failed to load data.',
  'pages.ownWarehouse.saveFailed': 'Failed to save.',
  'pages.ownWarehouse.deleteFailed': 'Failed to delete.',
  'pages.ownWarehouse.createSuccess': 'Warehouse created.',
  'pages.ownWarehouse.updateSuccess': 'Warehouse updated.',
  'pages.ownWarehouse.deleteSuccess': 'Warehouse deleted.',
  'pages.ownWarehouse.deleteConfirmTitle': 'Delete Warehouse',
  'pages.ownWarehouse.deleteConfirmContent': 'Delete warehouse "{name}"? It cannot be deleted while stock remains.',
  'pages.ownWarehouse.addWarehouse': 'Add Warehouse',
  'pages.ownWarehouse.editWarehouse': 'Edit Warehouse',
  'pages.ownWarehouse.save': 'Save',
  'pages.ownWarehouse.cancel': 'Cancel',
  'pages.ownWarehouse.searchPlaceholder': 'Search warehouse name',
  'pages.ownWarehouse.totalWarehouses': '{total} warehouses in total',
  'pages.ownWarehouse.status.all': 'All statuses',
  'pages.ownWarehouse.status.active': 'Active',
  'pages.ownWarehouse.status.inactive': 'Inactive',
  'pages.ownWarehouse.columns.name': 'Warehouse',
  'pages.ownWarehouse.columns.address': 'Address',
  'pages.ownWarehouse.columns.productKinds': 'Products',
  'pages.ownWarehouse.columns.totalStock': 'Total Stock',
  'pages.ownWarehouse.columns.createdAt': 'Created',
  'pages.ownWarehouse.columns.updatedAt': 'Updated',
  'pages.ownWarehouse.columns.status': 'Status',
  'pages.ownWarehouse.columns.actions': 'Actions',
  'pages.ownWarehouse.columns.image': 'Image',
  'pages.ownWarehouse.columns.productTitle': 'Product / Options',
  'pages.ownWarehouse.columns.productNo': 'Product No.',
  'pages.ownWarehouse.columns.inboundTotal': 'Total Inbound',
  'pages.ownWarehouse.columns.stock': 'On-hand Stock',
  'pages.ownWarehouse.columns.costPrice': 'Cost',
  'pages.ownWarehouse.columns.salePrice': 'Sale Price',
  'pages.ownWarehouse.columns.stockStatus': 'Stock Status',
  'pages.ownWarehouse.columns.mallLink': 'Mall Link',
  'pages.ownWarehouse.columns.skuCount': 'SKUs',
  'pages.ownWarehouse.columns.option': 'Option',
  'pages.ownWarehouse.actions.detail': 'Warehouse detail',
  'pages.ownWarehouse.actions.edit': 'Edit',
  'pages.ownWarehouse.actions.delete': 'Delete',
  'pages.ownWarehouse.form.name': 'Warehouse Name',
  'pages.ownWarehouse.form.namePlaceholder': 'Enter warehouse name',
  'pages.ownWarehouse.form.nameRequired': 'Warehouse name is required.',
  'pages.ownWarehouse.form.address': 'Address',
  'pages.ownWarehouse.form.addressPlaceholder': 'Enter warehouse address',
  'pages.ownWarehouse.form.addressRequired': 'Warehouse address is required.',
  'pages.ownWarehouse.form.manager': 'Manager',
  'pages.ownWarehouse.form.managerPlaceholder': 'Enter manager name',
  'pages.ownWarehouse.form.contact': 'Contact',
  'pages.ownWarehouse.form.contactPlaceholder': 'Enter contact',
  'pages.ownWarehouse.form.memo': 'Memo',
  'pages.ownWarehouse.form.memoPlaceholder': 'Enter memo (optional)',
  'pages.ownWarehouse.stockStatus.normal': 'Normal',
  'pages.ownWarehouse.stockStatus.lowStock': 'Low Stock',
  'pages.ownWarehouse.stockStatus.outOfStock': 'Out of Stock',
  'pages.ownWarehouse.tabs.items': 'Inventory Products',
  'pages.ownWarehouse.tabs.info': 'Warehouse Info',
  'pages.ownWarehouse.stats.productKinds': 'Products (SKU)',
  'pages.ownWarehouse.stats.totalInbound': 'Total Inbound',
  'pages.ownWarehouse.stats.totalStock': 'Total Stock',
  'pages.ownWarehouse.stats.outOfStock': 'Out-of-stock Products',
  'pages.ownWarehouse.stats.kindsUnit': 'types',
  'pages.ownWarehouse.stats.piecesUnit': 'pcs',
  'pages.ownWarehouse.addProducts': 'Add Products',
  'pages.ownWarehouse.itemSearchPlaceholder': 'Search product name or product no.',
  'pages.ownWarehouse.totalItems': '{total} products in total',
  'pages.ownWarehouse.removeConfirmTitle': 'Remove Product',
  'pages.ownWarehouse.removeConfirmContent': 'Remove "{name}" from this warehouse? Its remaining stock record ({stock}) is removed too.',
  'pages.ownWarehouse.removeSuccess': 'Product removed from the warehouse.',
  'pages.ownWarehouse.bulkRemove': 'Delete selected ({count})',
  'pages.ownWarehouse.bulkRemoveConfirmTitle': 'Remove Selected Products',
  'pages.ownWarehouse.bulkRemoveConfirmContent': 'Remove the {count} selected products from this warehouse? Their remaining stock records ({stock}) are removed too.',
  'pages.ownWarehouse.bulkRemoveSuccess': '{count} products removed from the warehouse.',
  'pages.ownWarehouse.picker.title': 'Register Company Mall Products',
  'pages.ownWarehouse.picker.loadFailed': 'Failed to load products.',
  'pages.ownWarehouse.picker.noneSelected': 'Select at least one product to add.',
  'pages.ownWarehouse.picker.addResult': '{added} products added. ({skipped} already registered, skipped)',
  'pages.ownWarehouse.picker.addFailed': 'Failed to add products.',
  'pages.ownWarehouse.picker.addSelected': 'Add Selected ({count})',
  'pages.ownWarehouse.picker.searchPlaceholder': 'Search by name / OfferId / UniqueNo',
  'pages.ownWarehouse.picker.totalProducts': '{total} in total',
  'pages.ownWarehouse.picker.columns.image': 'Image',
  'pages.ownWarehouse.picker.columns.title': 'Product',
  'pages.ownWarehouse.picker.columns.productNo': 'Product No.',
  'pages.ownWarehouse.picker.columns.salePrice': 'Sale Price',
  'pages.ownWarehouse.txn.inboundTitle': 'Inbound',
  'pages.ownWarehouse.txn.outboundTitle': 'Outbound',
  'pages.ownWarehouse.txn.confirm': 'Confirm',
  'pages.ownWarehouse.txn.reason': 'Reason',
  'pages.ownWarehouse.txn.noQuantity': 'Enter at least one quantity.',
  'pages.ownWarehouse.txn.inboundSuccess': 'Inbound processed.',
  'pages.ownWarehouse.txn.outboundSuccess': 'Outbound processed.',
  'pages.ownWarehouse.txn.failed': 'Failed to process.',
  'pages.ownWarehouse.txn.inboundQty': 'Inbound Qty',
  'pages.ownWarehouse.txn.outboundQty': 'Outbound Qty',
  'pages.ownWarehouse.reason.normalInbound': 'Normal inbound',
  'pages.ownWarehouse.reason.returnInbound': 'Return inbound',
  'pages.ownWarehouse.reason.correction': 'Mistake correction',
  'pages.ownWarehouse.reason.saleOutbound': 'Sale outbound',
  'pages.ownWarehouse.reason.disposal': 'Disposal',
  'pages.ownWarehouse.reason.inboundTypo': 'Inbound typo fix',
  'pages.ownWarehouse.reason.outboundTypo': 'Outbound typo fix',
  'pages.ownWarehouse.reason.stocktaking': 'Stocktaking',
  'pages.ownWarehouse.reason.damageLoss': 'Damage / loss',
  'pages.ownWarehouse.adjust.title': 'Correct stock',
  'pages.ownWarehouse.adjust.hint': 'Fixes a mis-keyed inbound or outbound. Change only the figures that are wrong — every correction is logged with its reason.',
  'pages.ownWarehouse.adjust.newInbound': 'Inbound total (after)',
  'pages.ownWarehouse.adjust.newStock': 'Stock (after)',
  'pages.ownWarehouse.adjust.memoPlaceholder': 'Note (e.g. logged 11 inbound, actually 10)',
  'pages.ownWarehouse.adjust.noChanges': 'Nothing was changed.',
  'pages.ownWarehouse.adjust.reasonRequired': 'Select a reason for the correction.',
  'pages.ownWarehouse.adjust.stockOverInbound': '{option}: stock cannot exceed the inbound total.',
  'pages.ownWarehouse.adjust.success': 'Stock corrected.',
  'pages.ownWarehouse.log.title': '■ In/Out Log - Warehouse : {name}',
  'pages.ownWarehouse.log.productTitle': '■ In/Out Log - Product : {name}',
  'pages.ownWarehouse.log.button': 'In/Out Log',
  'pages.ownWarehouse.log.warehouseButton': 'In/Out History',
  'pages.ownWarehouse.log.loadFailed': 'Failed to load logs.',
  'pages.ownWarehouse.log.noLogs': 'No logs.',
  'pages.ownWarehouse.log.system': 'System',
  'pages.ownWarehouse.log.orderNo': 'Order No.',
  'pages.ownWarehouse.log.columns.processor': 'Processor',
  'pages.ownWarehouse.log.columns.content': 'Content',
  'pages.ownWarehouse.log.columns.detail': 'Detail',
  'pages.ownWarehouse.log.columns.time': 'Time',
  'pages.ownWarehouse.log.type.productAdd': 'Product added',
  'pages.ownWarehouse.log.type.productRemove': 'Product removed',
  'pages.ownWarehouse.log.type.inbound': 'Inbound',
  'pages.ownWarehouse.log.type.outbound': 'Outbound',
  'pages.ownWarehouse.log.type.orderOutbound': 'Order outbound',
  'pages.ownWarehouse.log.type.adjust': 'Stock correction',
  'pages.ownWarehouse.orderOutbound.button': 'Stock Outbound',
  'pages.ownWarehouse.orderOutbound.title': 'Stock Outbound - Select Warehouse',
  'pages.ownWarehouse.orderOutbound.loadFailed': 'Failed to load warehouse info.',
  'pages.ownWarehouse.orderOutbound.noWarehouse': 'No warehouse holds this product.',
  'pages.ownWarehouse.orderOutbound.noMatch': 'Option not matched',
  'pages.ownWarehouse.orderOutbound.stockLabel': 'On-hand',
  'pages.ownWarehouse.orderOutbound.confirmTitle': 'Confirm Stock Outbound',
  'pages.ownWarehouse.orderOutbound.confirmContent': 'Outbound {qty} of {option} from warehouse "{warehouse}"?',
  'pages.ownWarehouse.orderOutbound.success': 'Outbound from "{warehouse}" completed. (Remaining stock: {stockAfter})',
  'pages.ownWarehouse.orderOutbound.insufficient': 'Stock in "{warehouse}" ({stock}) is less than the order quantity ({qty}).',
  'pages.ownWarehouse.orderOutbound.loading': 'Loading warehouses...',
  'pages.ownWarehouse.orderOutbound.showOtherOptions': 'Show other options ({count})',
  'pages.ownWarehouse.orderOutbound.done': 'Taken from stock',
  'pages.ownWarehouse.orderOutbound.doneTooltip': '{qty} taken from "{warehouse}" · {time}',
  'pages.ownWarehouse.orderOutbound.movedToPacking': 'Every product in this order came from stock, so the order moved to Packing.',

  // 상품 등록 다국어 입력 언어 탭
  'pages.products.add.langTab.ko': 'Korean',
  'pages.products.add.langTab.cn': 'Chinese',
  'pages.products.add.langTab.en': 'English',
  'pages.products.add.langTab.all': 'All languages',
  'pages.products.add.langTab.hint': 'Applies to title, option, and spec inputs. Korean/English are auto-translated from Chinese input.',
  'pages.products.add.bulkBar.scopeAll':
    'Column bulk buttons apply to all rows',
  'pages.products.add.bulkBar.scopeSelected':
    'Column bulk buttons apply to the {count} selected rows',
  'pages.products.add.bulkBar.apply': 'Apply',
  'pages.products.add.marketplaceCategoryMissing': 'not available',
  'pages.products.add.categoryNotDetermined':
    'Could not read the source category — please pick a category yourself.',
  'pages.products.add.categoryAutoCreated':
    'Created and selected the category "{path}" — rename it in Category Management if needed.',
  'pages.products.add.categoryAutoCreateFailed':
    'Could not create the category automatically — please pick one yourself.',
  'pages.products.add.marketplaceCategoryPath': 'Source category: {path}',
  'pages.products.add.newCategory.marketplacePath': 'Source category: {path}',
  'pages.products.add.newCategory.open': 'No matching category? Create one',
  'pages.products.add.newCategory.title': 'Create a category',
  'pages.products.add.newCategory.ok': 'Create and select',
  'pages.products.add.newCategory.levelHint': 'Creates a level {level} category — {path}',
  'pages.products.add.newCategory.rootLevel': 'top level',
  'pages.products.add.newCategory.rootPlaceholder': 'Leave empty to create a top-level category',
  'pages.products.add.newCategory.level2Placeholder': 'Leave empty to create a level 2 category',
  'pages.products.add.newCategory.nameKo': 'Category name (Korean)',
  'pages.products.add.newCategory.nameKoRequired': 'Enter the Korean name.',
  'pages.products.add.newCategory.nameZh': 'Chinese name',
  'pages.products.add.newCategory.nameZhHint':
    'Use the word the source site uses (连衣裙, 运动鞋…) so future imports match this category automatically.',
  'pages.products.add.newCategory.nameEn': 'English name',
  'pages.products.add.newCategory.duplicate': 'A category with this name already exists in the same place.',
  'pages.products.add.newCategory.created': 'Created the category "{path}".',
  'pages.products.add.newCategory.failed': 'Could not create the category.',
  'pages.products.add.categoryAutoPicked':
    'Category set to "{path}" — change it if it does not fit.',
  'pages.products.add.bulkBar.valueRequired': 'Enter a value to apply.',
  'pages.products.add.bulkBar.setPlaceholder': 'Set',
  'pages.products.add.bulkBar.salePriceUpdated': 'Sale prices updated successfully',
  'pages.products.add.bulkBar.originalKrwUpdated': 'Original prices updated successfully',
  'pages.products.add.bulkBar.originalCnyUpdated': 'Original CNY prices updated successfully',
  'pages.products.add.bulkBar.tagPriceUpdated': 'Tag prices updated successfully',
  'pages.products.add.bulkBar.stockUpdated': 'Stock updated successfully',
  'pages.products.add.skuTable.originalCny': 'Original CNY Price',
  'pages.products.add.skuTable.originalKrw': 'Original Price (₩)',
  'pages.products.add.skuTable.salePrice': 'Sale Price (₩)',
  'pages.products.add.skuTable.tagPrice': 'Tag Price (₩)',
  'pages.products.add.skuTable.image': 'Image',
  'pages.ownWarehouse.picker.allStores': 'All stores',
  'pages.products.add.editor.translateDescription': 'Translate ZH→KO',
  'pages.products.add.descTranslateDone': 'Translated {count} description text blocks.',
  'pages.products.add.descTranslateNone': 'No Chinese text to translate.',
  'pages.products.add.descTranslateFailed': 'Translation failed. Please try again later.',
  'pages.products.add.refineTitle.button': 'AI title summary',
  'pages.products.add.refineTitle.restore': 'Restore original title',
  'pages.products.add.refineTitle.tooltip': 'Strips filler words from a long title and keeps the product name. All three languages change together.',
  'pages.products.add.refineTitle.empty': 'Enter a title to summarize first.',
  'pages.products.add.refineTitle.unchanged': 'The title could not be shortened further. The original title is kept.',
  'pages.products.add.refineTitle.done': 'Title summarized. You can restore the original title.',
  'pages.products.add.refineTitle.failed': 'Title summary failed. Please try again later.',
  // 공유 리베이트 (share rebate) — 설정 · 모니터링 · 주문 상세 공유 귀속 카드
  'pages.shareRebate.status.pending': 'Pending',
  'pages.shareRebate.status.held': 'On hold',
  'pages.shareRebate.status.confirmed': 'Confirmed',
  'pages.shareRebate.status.paid': 'Paid',
  'pages.shareRebate.status.cancelled': 'Cancelled',
  'pages.shareRebate.status.reversed': 'Clawed back',
  'pages.shareRebate.source.live': 'Live',
  'pages.shareRebate.source.ownmall': 'Own mall',
  'pages.shareRebate.source.1688': '1688',
  'pages.shareRebate.source.taobao': 'Taobao',
  'pages.shareRebate.source.vvic': 'VVIC',
  'pages.shareRebate.tier.label': 'Tier {tier}',
  'pages.shareRebate.tier.role.1': 'Sharer',
  'pages.shareRebate.tier.role.2': "Sharer's sponsor",
  'pages.shareRebate.tier.role.3': "Sponsor's sponsor",
  'pages.shareRebate.attributionStatus.awaiting_payment': 'Awaiting payment',
  'pages.shareRebate.attributionStatus.active': 'Active',
  'pages.shareRebate.attributionStatus.settled': 'Settled',
  'pages.shareRebate.attributionStatus.void': 'Void',
  'pages.shareRebate.attributionStatus.needs_review': 'Needs review',
  'pages.shareRebate.risk.missing_user_price': 'Missing sale price',
  'pages.shareRebate.risk.failed_external_orders': 'External order failed',
  'pages.shareRebate.risk.same_phone': 'Sharer and buyer share a phone',
  'pages.shareRebate.risk.recipient_is_sharer': 'Recipient is the sharer',
  'pages.shareRebate.risk.family_too_large': 'Order family over 200',
  'pages.shareRebate.risk.marker_gap': 'Attribution marker gap',
  'pages.shareRebate.risk.refund_reason_unparsed': 'Refund reason not parsed',
  'pages.shareRebate.risk.markers_missing': 'Attribution markers missing',
  'pages.shareRebate.reason.risk': 'Risk flags',
  'pages.shareRebate.reason.admin': 'Admin',
  'pages.shareRebate.reason.released': 'Released',
  'pages.shareRebate.reason.sharer_suspended': 'Sharer suspended',
  'pages.shareRebate.reason.monthly_cap': 'Monthly cap reached',
  'pages.shareRebate.reason.order_cancelled_or_refunded': 'Order cancelled or refunded',
  'pages.shareRebate.reason.zero_amount': 'Zero amount',
  'pages.shareRebate.reason.below_minimum': 'Below minimum payout',
  'pages.shareRebate.skip.buyer_in_chain': 'Buyer is in the chain',
  'pages.shareRebate.skip.guest_account': 'Guest account',
  'pages.shareRebate.skip.suspended': 'Suspended sharer',
  'pages.shareRebate.skip.user_missing': 'Member not found',
  'pages.shareRebate.skip.user_deleted': 'Deleted member',
  'pages.shareRebate.skip.user_blacklisted': 'Blacklisted member',
  'pages.shareRebate.relationSource.signup': 'Signed up during a shared visit',
  'pages.shareRebate.relationSource.first_purchase': 'First attributed payment',
  'pages.shareRebate.relationSource.admin': 'Set by admin',
  'pages.shareRebate.relationAction.sponsor_assigned': 'Sponsor assigned',
  'pages.shareRebate.relationAction.sponsor_changed': 'Sponsor changed',
  'pages.shareRebate.relationAction.suspended': 'Suspended',
  'pages.shareRebate.relationAction.unsuspended': 'Unsuspended',
  'pages.shareRebate.taskType.reconcile_order': 'Order recheck',
  'pages.shareRebate.taskType.reconcile_attribution': 'Attribution recheck',
  'pages.shareRebate.taskType.checkout_incident': 'Checkout incident',
  'pages.shareRebate.scope.all_items': 'All items of an attributed order',
  'pages.shareRebate.scope.shared_product_only': 'Shared product only',
  'pages.shareRebate.payoutMode.auto': 'Automatic',
  'pages.shareRebate.payoutMode.manual_approval': 'After admin approval',
  'pages.shareRebate.lang.ko': 'Korean',
  'pages.shareRebate.lang.en': 'English',
  'pages.shareRebate.lang.zh': 'Chinese',
  'pages.shareRebate.reasonModal.label': 'Reason',
  'pages.shareRebate.reasonModal.placeholder': 'Enter a reason. It is kept in the activity log and history.',
  'pages.shareRebate.reasonModal.required': 'Please enter a reason.',
  'pages.shareRebate.reasonModal.ok': 'Confirm',
  'pages.shareRebate.settings.featureOff': 'The server feature switch (FEATURE_SHARE_REBATE) is off, so saved settings will not take effect',
  'pages.shareRebate.settings.readOnly': 'Read only. Editing needs the Share Rebate Settings edit permission.',
  'pages.shareRebate.settings.loadFailed': 'Could not load the share rebate settings.',
  'pages.shareRebate.settings.section.program': 'Program',
  'pages.shareRebate.settings.section.rates': 'Member rates — tier × source (%)',
  'pages.shareRebate.settings.section.periods': 'Periods and limits',
  'pages.shareRebate.settings.section.sponsor': 'Sponsor assignment',
  'pages.shareRebate.settings.section.disclosure': 'Disclosure text (economic interest)',
  'pages.shareRebate.settings.state.live': 'Running',
  'pages.shareRebate.settings.state.off': 'Off',
  'pages.shareRebate.settings.lastUpdated': 'v{version} · last saved {time} · {admin}',
  'pages.shareRebate.settings.enabled': 'Enable share rebates',
  'pages.shareRebate.settings.enabledHelp': 'When on, visits through share links and the resulting payments earn rebates. The server feature switch must be on as well.',
  'pages.shareRebate.settings.payoutMode': 'Payout mode',
  'pages.shareRebate.settings.payoutModeHelp': 'Automatic: credited to deposit once confirmed. Approval: credited only after an admin approves the payout in Records.',
  'pages.shareRebate.settings.scope': 'Attribution scope',
  'pages.shareRebate.settings.scopeHelp': 'Which items of the orders placed within the window by a buyer who came through a share link earn rebates.',
  'pages.shareRebate.settings.grid.tier': 'Tier',
  'pages.shareRebate.settings.grid.rowTotal': 'Row total',
  'pages.shareRebate.settings.grid.columnTotal': 'Source total',
  'pages.shareRebate.settings.grid.columnTotalHint': 'Tiers 1-3 of one source (max {max}%)',
  'pages.shareRebate.settings.grid.hint': 'Paid product amount (after coupons, excluding shipping and fees) × %. Each cell is 0-{max}% with up to two decimals; tiers 1-3 of one source may not exceed {total}% in total. 0% turns that tier/source off.',
  'pages.shareRebate.settings.grid.legalNote': 'Paying tier 2 and above may count as multi-level marketing under the Door-to-Door Sales Act; get a legal review before going live in production',
  'pages.shareRebate.settings.field.rate': '{tier} · {source}',
  'pages.shareRebate.settings.field.disclosureText': 'Disclosure text ({lang})',
  'pages.shareRebate.settings.windowDays': 'Attribution window',
  'pages.shareRebate.settings.windowDaysHelp': 'Payments within this many days after a share-link visit are attributed (1-30 days, last click wins).',
  'pages.shareRebate.settings.creditOnShipmentNote': 'Rebates are confirmed and credited as soon as the order is shipped out (no delivery wait or hold period). Until then members see them as "Not credited".',
  'pages.shareRebate.settings.holdDays': 'Hold period',
  'pages.shareRebate.settings.holdDaysHelp': 'Rows are confirmed and paid this many days after delivery (0-60 days).',
  'pages.shareRebate.settings.deliveredFallbackDays': 'Deemed delivered after',
  'pages.shareRebate.settings.deliveredFallbackDaysHelp': 'Without a delivery record, an order counts as delivered this many days after it shipped (1-120 days).',
  'pages.shareRebate.settings.perOrderCapKRW': 'Cap per order',
  'pages.shareRebate.settings.perOrderCapKRWHelp': 'Most one recipient can earn from one order. 0 = no cap.',
  'pages.shareRebate.settings.monthlyCapKRW': 'Monthly cap',
  'pages.shareRebate.settings.monthlyCapKRWHelp': 'Most one recipient can be paid in a month (KST); the excess is forfeited. 0 = no cap.',
  'pages.shareRebate.settings.minPayoutKRW': 'Minimum payout',
  'pages.shareRebate.settings.minPayoutKRWHelp': 'Confirmed amounts below this are not paid. 0 = pay anything from 1 won.',
  'pages.shareRebate.settings.unit.days': 'days',
  'pages.shareRebate.settings.unit.krw': 'KRW',
  'pages.shareRebate.settings.sponsorOnSignup': 'Assign a sponsor on sign-up during a shared visit',
  'pages.shareRebate.settings.sponsorOnSignupHelp': 'A member who signs up after arriving through a share link gets that sharer as sponsor.',
  'pages.shareRebate.settings.sponsorOnFirstPurchase': 'Assign a sponsor on the first attributed payment',
  'pages.shareRebate.settings.sponsorOnFirstPurchaseHelp': 'A member without a sponsor gets the tier-1 sharer of their first attributed payment. Whichever happens first wins; it never changes automatically. Off by default — existing members join a team only by pressing [Join team] on an instructor link.',
  'pages.shareRebate.settings.friendCoupon.title': 'Friend first-purchase coupon',
  'pages.shareRebate.settings.friendCoupon.label': 'Coupon for friends',
  'pages.shareRebate.settings.friendCoupon.help': 'Given automatically, once per person, to members who arrive through a share link and have never paid. Only active, unlimited-quantity product discount coupons can be chosen. The chosen coupon is hidden from the public coupon list and cannot be claimed by code.',
  'pages.shareRebate.settings.friendCoupon.none': 'Not used',
  'pages.shareRebate.settings.friendCoupon.benefitFixed': '{amount} KRW off',
  'pages.shareRebate.settings.friendCoupon.benefitPercent': '{percent}% off',
  'pages.shareRebate.settings.friendCoupon.minPurchase': 'Min. {amount} KRW',
  'pages.shareRebate.settings.friendCoupon.validity': '{n} days',
  'pages.shareRebate.settings.friendCoupon.unavailable': 'This coupon cannot be used now',
  'pages.shareRebate.settings.friendCoupon.unavailableHelp': 'The saved coupon was turned off or no longer meets the conditions (unlimited quantity, product discount), so friends are not getting it. Choose another coupon or switch to [Not used] and save.',
  'pages.shareRebate.settings.friendCoupon.unavailableOption': 'Unavailable coupon ({id})',
  'pages.shareRebate.settings.friendCoupon.noCandidates': 'No coupons to choose from. First create an active, unlimited-quantity product discount coupon (not a signup or referral auto coupon) in coupon management.',
  'pages.shareRebate.settings.friendCoupon.loadFailed': 'Could not load the coupon list.',
  'pages.shareRebate.settings.banner.title': 'Product page share banner',
  'pages.shareRebate.settings.banner.help': 'Shown on product pages in place of the share button; clicking it opens the share window. It appears only on products whose sharing earns (program on and a tier-1 rate above 0 for the product source); other products keep the share button. It can take up to 5 minutes to show on the store after saving.',
  'pages.shareRebate.settings.banner.enabled': 'Show banner',
  'pages.shareRebate.settings.banner.state.on': 'On',
  'pages.shareRebate.settings.banner.state.off': 'Off',
  'pages.shareRebate.settings.banner.pcImage': 'PC image (required)',
  'pages.shareRebate.settings.banner.mobileImage': 'Mobile image (optional)',
  'pages.shareRebate.settings.banner.pcHint': 'Shown under the PC buy buttons, scaled to their width (about 350-366px). Never cropped; height follows the image ratio. On upload, transparent margins are trimmed and the image is saved as WebP up to 1200px wide. Recommended: a wide image around {size}.',
  'pages.shareRebate.settings.banner.mobileHint': 'On phones it is shown under the quantity, scaled to the screen width (up to 480px). Leave empty to use the PC image.',
  'pages.shareRebate.settings.banner.mobileFallback': 'Uses the PC image',
  'pages.shareRebate.settings.banner.uploadInfo': 'Saved: {size} · {kb}KB WebP',
  'pages.shareRebate.settings.banner.uploadInfoTrimmed': 'Saved: {size} · {kb}KB WebP (transparent margins trimmed)',
  'pages.shareRebate.settings.banner.upload': 'Upload image',
  'pages.shareRebate.settings.banner.change': 'Change image',
  'pages.shareRebate.settings.banner.clear': 'Remove',
  'pages.shareRebate.settings.banner.uploaded': 'Image uploaded. Click [Save banner] to apply it.',
  'pages.shareRebate.settings.banner.uploadFailed': 'Could not upload the image.',
  'pages.shareRebate.settings.banner.notImage': 'Only JPG, PNG, GIF and WEBP images can be uploaded.',
  'pages.shareRebate.settings.banner.tooLarge': 'Images must be {max}MB or smaller.',
  'pages.shareRebate.settings.banner.save': 'Save banner',
  'pages.shareRebate.settings.banner.reset': 'Revert',
  'pages.shareRebate.settings.banner.saved': 'Banner saved.',
  'pages.shareRebate.settings.banner.saveFailed': 'Could not save the banner.',
  'pages.shareRebate.settings.banner.needPcImage': 'Upload a PC image to turn the banner on.',
  'pages.shareRebate.settings.banner.programOff': 'The share rebate program is off, so the banner is not shown on the store now. Once the program is on, it shows on products whose sharing earns.',
  'pages.shareRebate.settings.banner.unsaved': 'You have unsaved banner changes.',
  'pages.shareRebate.settings.banner.separateSave': 'The banner is saved separately from the rate settings above, without change history or a reason.',
  'pages.shareRebate.settings.banner.lastUpdated': 'Last saved {time} · {admin}',
  'pages.shareRebate.settings.disclosureHelp': 'Economic-interest disclosure put on the first line of share messages (endorsement guidelines). Conditional wording such as "may receive" is not accepted. Up to 300 characters.',
  'pages.shareRebate.settings.error.intRange': 'Enter a whole number from {min} to {max}.',
  'pages.shareRebate.settings.error.rateRange': '{cell}: must be between 0 and {max}%.',
  'pages.shareRebate.settings.error.ratePrecision': '{cell}: up to two decimal places.',
  'pages.shareRebate.settings.error.sourceTotal': '{source}: tiers 1-3 add up to {total}, over {max}%.',
  'pages.shareRebate.settings.error.gridInvalid': 'Please fix the rate table.',
  'pages.shareRebate.settings.error.disclosureRequired': 'Enter the disclosure text.',
  'pages.shareRebate.settings.error.disclosureTooLong': 'Up to {max} characters.',
  'pages.shareRebate.settings.error.fixFirst': 'Please fix the input errors first.',
  'pages.shareRebate.settings.noChanges': 'Nothing has changed.',
  'pages.shareRebate.settings.unsaved': '{n} unsaved change(s)',
  'pages.shareRebate.settings.noUnsaved': 'No changes',
  'pages.shareRebate.settings.reset': 'Revert',
  'pages.shareRebate.settings.save': 'Save',
  'pages.shareRebate.settings.saveSuccess': 'Share rebate settings saved.',
  'pages.shareRebate.settings.saveFailed': 'Could not save.',
  'pages.shareRebate.settings.confirm.title': 'Confirm settings change',
  'pages.shareRebate.settings.confirm.intro': 'The following {n} item(s) will change.',
  'pages.shareRebate.settings.confirm.reason': 'Reason for the change',
  'pages.shareRebate.settings.confirm.reasonPlaceholder': 'Why are you changing this? It is kept in the change history.',
  'pages.shareRebate.settings.confirm.appliesToNew': 'New rates apply to orders attributed after saving; orders already attributed keep the rates they were placed with.',
  'pages.shareRebate.settings.conflict.title': 'Someone saved first',
  'pages.shareRebate.settings.conflict.content': 'Another admin saved the settings first. Reload to get the latest values, then save again. (What you entered now will be discarded.)',
  'pages.shareRebate.settings.conflict.reload': 'Reload',
  'pages.shareRebate.settings.change.field': 'Item',
  'pages.shareRebate.settings.change.before': 'Before',
  'pages.shareRebate.settings.change.after': 'After',
  'pages.shareRebate.settings.history.title': 'Change history',
  'pages.shareRebate.settings.history.version': 'Version',
  'pages.shareRebate.settings.history.changes': 'Changed items',
  'pages.shareRebate.settings.history.more': 'and {n} more',
  'pages.shareRebate.settings.history.noChanges': 'No changed items',
  'pages.shareRebate.settings.history.admin': 'Admin',
  'pages.shareRebate.settings.history.reason': 'Reason',
  'pages.shareRebate.settings.history.time': 'Time (KST)',
  'pages.shareRebate.settings.value.on': 'On',
  'pages.shareRebate.settings.value.off': 'Off',
  'pages.shareRebate.settings.value.none': 'None',
  'pages.shareRebate.settings.value.days': '{n} days',
  'pages.shareRebate.settings.value.krw': '₩{amount}',
  'pages.shareRebate.monitor.tab.dashboard': 'Dashboard',
  'pages.shareRebate.monitor.tab.records': 'Records',
  'pages.shareRebate.monitor.tab.sharers': 'Sharers',
  'pages.shareRebate.monitor.loadFailed': 'Could not load.',
  'pages.shareRebate.monitor.dashboard.range': 'Period',
  'pages.shareRebate.monitor.dashboard.last30': 'Last 30 days',
  'pages.shareRebate.monitor.dashboard.kstNote': 'Dates are in Korea time (KST).',
  'pages.shareRebate.monitor.kpi.visits': 'Visits',
  'pages.shareRebate.monitor.kpi.uniqueVisitors': 'Unique visitors',
  'pages.shareRebate.monitor.kpi.attributedOrders': 'Attributed orders',
  'pages.shareRebate.monitor.kpi.conversionRate': 'Conversion',
  'pages.shareRebate.monitor.kpi.conversionHint': 'Attributed orders ÷ visits',
  'pages.shareRebate.monitor.kpi.attributedGmv': 'Attributed GMV',
  'pages.shareRebate.monitor.kpi.attributedGmvHint': 'Coupon-adjusted product amount (active and settled)',
  'pages.shareRebate.monitor.kpi.pending': 'Pending (incl. on hold)',
  'pages.shareRebate.monitor.kpi.confirmed': 'Confirmed',
  'pages.shareRebate.monitor.kpi.paid': 'Paid (net of clawbacks)',
  'pages.shareRebate.monitor.kpi.reversed': 'Clawed back',
  'pages.shareRebate.monitor.chart.title': 'Daily trend',
  'pages.shareRebate.monitor.chart.visits': 'Visits',
  'pages.shareRebate.monitor.chart.orders': 'Attributed orders',
  'pages.shareRebate.monitor.chart.rebate': 'Rebate (KRW)',
  'pages.shareRebate.monitor.byTier.title': 'By tier',
  'pages.shareRebate.monitor.byTier.tier': 'Tier',
  'pages.shareRebate.monitor.byTier.rows': 'Rows',
  'pages.shareRebate.monitor.byTier.open': 'Unpaid',
  'pages.shareRebate.monitor.byTier.paid': 'Paid',
  'pages.shareRebate.monitor.top.recipientsTitle': 'Top recipients',
  'pages.shareRebate.monitor.top.productsTitle': 'Top products',
  'pages.shareRebate.monitor.top.member': 'Member',
  'pages.shareRebate.monitor.top.product': 'Product',
  'pages.shareRebate.monitor.top.source': 'Source',
  'pages.shareRebate.monitor.top.orders': 'Orders',
  'pages.shareRebate.monitor.top.net': 'Attributed amount',
  'pages.shareRebate.monitor.health.title': 'Settlement health',
  'pages.shareRebate.monitor.health.failedTasks': 'Failed tasks',
  'pages.shareRebate.monitor.health.needsReview': 'Needs review',
  'pages.shareRebate.monitor.health.awaitingPayment': 'Awaiting payment',
  'pages.shareRebate.monitor.health.runNow': 'Run settlement now',
  'pages.shareRebate.monitor.health.runNowConfirm': 'Run the settlement cycle now?',
  'pages.shareRebate.monitor.health.runNowContent': 'Runs payment checks, confirmation and payouts (automatic mode) once. It also runs every 2 minutes on its own.',
  'pages.shareRebate.monitor.health.runNowDone': 'Settlement ran — tasks {tasks} · activated {activated} · rechecked {reconciled} · paid {paid} ({ms} ms)',
  'pages.shareRebate.monitor.health.runNowSkipped': 'A settlement cycle is already running. Try again shortly.',
  'pages.shareRebate.monitor.health.attributionsInRange': 'Attributions in range:',
  'pages.shareRebate.monitor.tasks.title': 'Failed tasks',
  'pages.shareRebate.monitor.tasks.type': 'Type',
  'pages.shareRebate.monitor.tasks.ref': 'Target',
  'pages.shareRebate.monitor.tasks.attempts': 'Attempts',
  'pages.shareRebate.monitor.tasks.lastError': 'Last error',
  'pages.shareRebate.monitor.tasks.updatedAt': 'Time',
  'pages.shareRebate.monitor.tasks.retry': 'Retry',
  'pages.shareRebate.monitor.tasks.retrySuccess': 'Retry queued. It runs in the next settlement cycle.',
  'pages.shareRebate.monitor.tasks.empty': 'No failed tasks.',
  'pages.shareRebate.monitor.review.title': 'Attributions needing review',
  'pages.shareRebate.monitor.review.order': 'Order',
  'pages.shareRebate.monitor.review.riskFlags': 'Risk flags',
  'pages.shareRebate.monitor.review.reconcile': 'Recheck',
  'pages.shareRebate.monitor.review.reconcileSuccess': 'Rechecked.',
  'pages.shareRebate.monitor.review.empty': 'Nothing to review.',
  'pages.shareRebate.monitor.records.filter.from': 'From (KST)',
  'pages.shareRebate.monitor.records.filter.to': 'To (KST)',
  'pages.shareRebate.monitor.records.filter.statusAll': 'All statuses',
  'pages.shareRebate.monitor.records.filter.tier': 'Tier',
  'pages.shareRebate.monitor.records.filter.source': 'Source',
  'pages.shareRebate.monitor.records.filter.recipient': 'Recipient (member no./name)',
  'pages.shareRebate.monitor.records.filter.sharer': 'Sharer (member no./name)',
  'pages.shareRebate.monitor.records.filter.buyer': 'Buyer (member no./name)',
  'pages.shareRebate.monitor.records.filter.orderNo': 'Order number',
  'pages.shareRebate.monitor.records.filter.code': 'Record code',
  'pages.shareRebate.monitor.records.filter.attribution': 'Only the tiers of attribution …{id}',
  'pages.shareRebate.monitor.records.totals': 'Totals for the filter',
  'pages.shareRebate.monitor.records.col.code': 'Code',
  'pages.shareRebate.monitor.records.col.createdAt': 'Created',
  'pages.shareRebate.monitor.records.col.status': 'Status',
  'pages.shareRebate.monitor.records.col.tier': 'Tier',
  'pages.shareRebate.monitor.records.col.recipient': 'Recipient',
  'pages.shareRebate.monitor.records.col.sharer': 'Sharer',
  'pages.shareRebate.monitor.records.col.buyer': 'Buyer',
  'pages.shareRebate.monitor.records.col.orderNo': 'Order number',
  'pages.shareRebate.monitor.records.col.sources': 'Sources %',
  'pages.shareRebate.monitor.records.col.base': 'Base',
  'pages.shareRebate.monitor.records.col.amount': 'Amount',
  'pages.shareRebate.monitor.records.col.paid': 'Paid',
  'pages.shareRebate.monitor.records.col.forfeited': 'Forfeited (cap)',
  'pages.shareRebate.monitor.records.col.reversed': 'Clawed back',
  'pages.shareRebate.monitor.records.col.eligibleAt': 'Shipped (credit basis)',
  'pages.shareRebate.monitor.records.col.paidAt': 'Paid at',
  'pages.shareRebate.monitor.records.col.actions': 'Actions',
  'pages.shareRebate.monitor.records.productMore': '{title} and {n} more',
  'pages.shareRebate.monitor.records.amountReduced': 'earned {gross} · reduced {reduction}',
  'pages.shareRebate.monitor.records.sourceTooltip': 'base ₩{base} → rebate ₩{amount}',
  'pages.shareRebate.monitor.records.deemed': 'Deemed delivered',
  'pages.shareRebate.monitor.records.deemedHint': 'No delivery record — delivery was deemed from the shipping date.',
  'pages.shareRebate.monitor.records.manualConfirm': 'Confirmed manually',
  'pages.shareRebate.monitor.records.sameAttribution': 'Show only the tiers of this attribution',
  'pages.shareRebate.monitor.records.action.hold': 'Hold',
  'pages.shareRebate.monitor.records.action.release': 'Release',
  'pages.shareRebate.monitor.records.action.cancel': 'Cancel',
  'pages.shareRebate.monitor.records.action.confirm': 'Confirm now',
  'pages.shareRebate.monitor.records.action.reverse': 'Claw back',
  'pages.shareRebate.monitor.records.action.pay': 'Approve payout',
  'pages.shareRebate.monitor.records.action.holdDesc': 'Put {code} on hold. It is not confirmed or paid while on hold.',
  'pages.shareRebate.monitor.records.action.releaseDesc': 'Release {code} back to pending. If the order has shipped it is confirmed and paid at the next check.',
  'pages.shareRebate.monitor.records.action.cancelDesc': 'Cancel {code}. The ₩{amount} it would pay is dropped; this cannot be undone.',
  'pages.shareRebate.monitor.records.action.confirmDesc': 'Confirm the whole attribution of {code} without waiting for shipment (paid right away in automatic mode). Orders with a refund in progress cannot be confirmed.',
  'pages.shareRebate.monitor.records.action.reverseDesc': 'Claw back the remaining ₩{outstanding} paid for {code} from the deposit. This cannot be undone.',
  'pages.shareRebate.monitor.records.action.payDesc': 'Pay ₩{amount} for {code} to the deposit now.',
  'pages.shareRebate.monitor.records.action.payConfirmTitle': 'Approve payout',
  'pages.shareRebate.monitor.records.action.modalTitle': '{action} — {code}',
  'pages.shareRebate.monitor.records.action.success': '{code}: {action} done',
  'pages.shareRebate.monitor.sharers.searchPlaceholder': 'Member no., ID, nickname or email',
  'pages.shareRebate.monitor.sharers.col.member': 'Member',
  'pages.shareRebate.monitor.sharers.col.sponsor': 'Sponsor',
  'pages.shareRebate.monitor.sharers.col.suspended': 'Status',
  'pages.shareRebate.monitor.sharers.col.directDownline': 'Direct team members',
  'pages.shareRebate.monitor.sharers.col.visits': 'Visits',
  'pages.shareRebate.monitor.sharers.col.rows': 'Rows',
  'pages.shareRebate.monitor.sharers.col.open': 'Unpaid',
  'pages.shareRebate.monitor.sharers.col.paid': 'Paid',
  'pages.shareRebate.monitor.sharers.col.actions': 'Actions',
  'pages.shareRebate.monitor.sharers.noSponsor': 'None',
  'pages.shareRebate.monitor.sharers.suspendedTag': 'Suspended',
  'pages.shareRebate.monitor.sharers.activeTag': 'Active',
  'pages.shareRebate.monitor.sharers.detail': 'Details',
  'pages.shareRebate.monitor.sharers.drawerTitle': 'Sharer details',
  'pages.shareRebate.monitor.sharers.member': 'Member',
  'pages.shareRebate.monitor.sharers.userId': 'User ID',
  'pages.shareRebate.monitor.sharers.email': 'Email',
  'pages.shareRebate.monitor.sharers.phone': 'Phone',
  'pages.shareRebate.monitor.sharers.joinedAt': 'Joined',
  'pages.shareRebate.monitor.sharers.shareLinks': 'Share links',
  'pages.shareRebate.monitor.sharers.visits': 'Visits',
  'pages.shareRebate.monitor.sharers.visitsValue': '{total} (last 30 days {recent})',
  'pages.shareRebate.monitor.sharers.attributedOrders': 'Attributed orders',
  'pages.shareRebate.monitor.sharers.cancelled': 'Cancelled',
  'pages.shareRebate.monitor.sharers.suspendedInfo': 'Suspended — {time} · {admin} · {reason}',
  'pages.shareRebate.monitor.sharers.sponsorTitle': 'Sponsor',
  'pages.shareRebate.monitor.sharers.sponsorCurrent': 'Current sponsor',
  'pages.shareRebate.monitor.sharers.sponsorSource': 'Assigned by',
  'pages.shareRebate.monitor.sharers.sponsorAssignedAt': 'Assigned at',
  'pages.shareRebate.monitor.sharers.sponsorPick': 'Find the new sponsor (member no./nickname)',
  'pages.shareRebate.monitor.sharers.sponsorNotFound': 'No member found',
  'pages.shareRebate.monitor.sharers.sponsorChange': 'Change sponsor',
  'pages.shareRebate.monitor.sharers.sponsorClear': 'Remove sponsor',
  'pages.shareRebate.monitor.sharers.sponsorSelf': 'A member cannot be their own sponsor.',
  'pages.shareRebate.monitor.sharers.sponsorHint': 'A new sponsor applies to orders attributed from now on; existing rows do not change. The server rejects cycles.',
  'pages.shareRebate.monitor.sharers.sponsorChangeDesc': 'Change the sponsor of {member} from {from} to {to}.',
  'pages.shareRebate.monitor.sharers.sponsorClearDesc': 'Remove the sponsor ({from}) of {member}. Later attributions will have no tier 2 or 3 above them.',
  'pages.shareRebate.monitor.sharers.suspend': 'Suspend sharer',
  'pages.shareRebate.monitor.sharers.suspendDesc': 'Suspend {member}. All pending and confirmed rows go on hold, and no share rebates are earned while suspended.',
  'pages.shareRebate.monitor.sharers.unsuspend': 'Unsuspend',
  'pages.shareRebate.monitor.sharers.unsuspendDesc': 'Lift the suspension of {member}. Rows on hold are not released automatically — release them one by one in Records.',
  'pages.shareRebate.monitor.sharers.actionSuccess': 'Done.',
  'pages.shareRebate.monitor.sharers.actionFailed': 'Could not complete the action.',
  'pages.shareRebate.monitor.sharers.downlineTab': 'Team ({tier1}/{tier2}/{tier3})',
  'pages.shareRebate.monitor.sharers.downlineCounts': 'Direct {tier1} · 2nd step {tier2} · 3rd step {tier3} (members invited directly below, up to 100)',
  'pages.shareRebate.monitor.sharers.visitsTab': 'Recent visits',
  'pages.shareRebate.monitor.sharers.visitTime': 'Time',
  'pages.shareRebate.monitor.sharers.visitLanding': 'Landing path',
  'pages.shareRebate.monitor.sharers.visitChannel': 'Channel',
  'pages.shareRebate.monitor.sharers.visitBuyer': 'Buyer',
  'pages.shareRebate.monitor.sharers.visitAttributed': 'Attributed',
  'pages.shareRebate.monitor.sharers.rowsTab': 'Recent rows',
  'pages.shareRebate.monitor.sharers.viewAllRows': 'All rows of this member',
  'pages.shareRebate.monitor.sharers.historyTab': 'Relation history',
  'pages.shareRebate.monitor.sharers.historyTime': 'Time',
  'pages.shareRebate.monitor.sharers.historyAction': 'Action',
  'pages.shareRebate.monitor.sharers.historyChange': 'Change',
  'pages.shareRebate.monitor.sharers.historySource': 'Source',
  'pages.shareRebate.monitor.sharers.historyAdmin': 'Admin',
  'pages.shareRebate.monitor.sharers.historyReason': 'Reason',
  'pages.orders.detail.shareAttribution.title': 'Share attribution',
  'pages.orders.detail.shareAttribution.sharer': 'Sharer',
  'pages.orders.detail.shareAttribution.buyer': 'Buyer',
  'pages.orders.detail.shareAttribution.attributedAt': 'Attributed at',
  'pages.orders.detail.shareAttribution.visit': 'Visit',
  'pages.orders.detail.shareAttribution.visitId': 'Visit ID {id}',
  'pages.orders.detail.shareAttribution.delivered': 'Delivered',
  'pages.orders.detail.shareAttribution.deemed': 'Deemed',
  'pages.orders.detail.shareAttribution.eligible': 'Shipped',
  'pages.orders.detail.shareAttribution.manualConfirm': 'Confirmed manually',
  'pages.orders.detail.shareAttribution.totalNet': 'Attributed amount',
  'pages.orders.detail.shareAttribution.riskFlags': 'Risk flags',
  'pages.orders.detail.shareAttribution.none': 'None',
  'pages.orders.detail.shareAttribution.skipped': 'Skipped tiers',
  'pages.orders.detail.shareAttribution.viewRecords': 'Open in share rebate records',
  'pages.orders.detail.shareAttribution.tier': 'Tier',
  'pages.orders.detail.shareAttribution.recipient': 'Recipient',
  'pages.orders.detail.shareAttribution.rate': 'Rate',
  'pages.orders.detail.shareAttribution.amount': 'Amount',
  'pages.orders.detail.shareAttribution.paid': 'Paid',
  'pages.orders.detail.shareAttribution.status': 'Status',
  'pages.orders.detail.shareAttribution.noRows': 'No tier rows yet (payment not confirmed)',
  'pages.orders.detail.shareAttribution.lines': 'Attributed items',
  'pages.orders.detail.shareAttribution.product': 'Product',
  'pages.orders.detail.shareAttribution.source': 'Source',
  'pages.orders.detail.shareAttribution.quantity': 'Qty',
  'pages.orders.detail.shareAttribution.net': 'Attributed amount',
  'pages.orders.detail.shareAttribution.netHint': 'Product ₩{gross} × coupon factor {factor}',
  // Share rebate round 2 — instructors · team · performance (funnel)
  'pages.orders.detail.shareAttribution.instructorRate': 'Instructor rate',
  'pages.orders.detail.shareAttribution.instructorRateHint': 'The recipient was an instructor at checkout, so this tier used the instructor rates.',
  'pages.shareRebate.role.member': 'Member',
  'pages.shareRebate.role.instructor': 'Instructor',
  'pages.shareRebate.relationSource.join': 'Joined an instructor team',
  'pages.shareRebate.reasonModal.labelOptional': 'Reason (optional)',
  'pages.shareRebate.reasonModal.memoLabel': 'Internal memo',
  'pages.shareRebate.reasonModal.memoHelp': 'Only admins see this memo. It is never shown to the member.',
  'pages.shareRebate.reasonModal.memoPlaceholder': 'Review notes, contact history, etc.',
  'pages.shareRebate.settings.section.instructorRates': 'Instructor rates — tier × source (%)',
  'pages.shareRebate.settings.field.memberRate': 'Member rate · {tier} · {source}',
  'pages.shareRebate.settings.field.instructorRate': 'Instructor rate · {tier} · {source}',
  'pages.shareRebate.settings.instructor.hint': 'When the recipient is an approved instructor, that tier is paid from this table. The role is fixed at checkout, so revoking an instructor does not change rebates that already exist. It starts out equal to the member rates.',
  'pages.shareRebate.settings.instructor.diffCount': '{n} cells differ from the member rates',
  'pages.shareRebate.settings.instructor.sameAsMember': 'Same as the member rates',
  'pages.shareRebate.settings.instructor.copyFromMember': 'Copy member rates',
  'pages.shareRebate.settings.instructor.copyHint': 'Makes the instructor table identical to the current member table. Takes effect when you save.',
  'pages.shareRebate.settings.instructor.cellDiff': 'Member rate {member}',
  'pages.shareRebate.settings.instructor.tableTotal': 'Instructor table total',
  'pages.shareRebate.settings.instructor.mixedTotal': 'Mixed maximum total',
  'pages.shareRebate.settings.instructor.mixedTotalHint': 'One order chain can mix members and instructors (e.g. a member on tier 1 and an instructor on tier 2). So for each source, the sum over the tiers of the larger of the member and instructor rates must also stay within {max}%.',
  'pages.shareRebate.settings.instructor.legalBoth': 'Both the member and the instructor tables are checked.',
  'pages.shareRebate.settings.error.mixedTotal': '{source}: the mixed maximum total {total} exceeds {max}%. Lower the instructor rates or press [Copy member rates].',
  'pages.shareRebate.monitor.tab.instructors': 'Instructors',
  'pages.shareRebate.monitor.tab.instructorsPending': '{n} awaiting review',
  'pages.shareRebate.monitor.instructors.title': 'Instructors',
  'pages.shareRebate.monitor.instructors.approved': 'Approved instructors',
  'pages.shareRebate.monitor.instructors.pending': 'Awaiting review',
  'pages.shareRebate.monitor.instructors.viewList': 'View list',
  'pages.shareRebate.monitor.instructors.review': 'Review',
  'pages.shareRebate.monitor.instructors.byRoleHint': 'Rebates created in the range, by recipient role (cancelled excluded)',
  'pages.shareRebate.monitor.instructors.role': 'Role',
  'pages.shareRebate.monitor.instructors.topTitle': 'Top instructors',
  'pages.shareRebate.monitor.instructors.member': 'Instructor',
  'pages.shareRebate.monitor.instructors.rowsHint': 'Rebates created with the instructor rates in the range',
  'pages.shareRebate.monitor.instructors.teamRows': 'Via team',
  'pages.shareRebate.monitor.instructors.teamRowsHint': 'Of those, orders that came in through the links of team members (tiers 2–3)',
  'pages.shareRebate.monitor.instructors.topEmpty': 'No rebates were created with the instructor rates in this range.',
  'pages.shareRebate.monitor.records.filter.recipientRole': 'Recipient role',
  'pages.shareRebate.monitor.records.col.recipientRole': 'Recipient role',
  'pages.shareRebate.monitor.records.col.recipientRoleHint': 'Role at checkout. Instructor rows were calculated with the instructor rates.',
  'pages.shareRebate.monitor.records.via': 'Via',
  'pages.shareRebate.monitor.records.viaHint': 'A team member the recipient invited directly. The order came in through this member’s link (tier 2) or the link of someone this member invited (tier 3).',
  'pages.shareRebate.monitor.sharers.col.role': 'Role',
  'pages.shareRebate.monitor.sharers.col.roleHint': 'Whether the member is an approved instructor now.',
  'pages.shareRebate.monitor.sharers.filter.role': 'Role',
  'pages.shareRebate.monitor.sharers.performanceTab': 'Performance',
  'pages.shareRebate.instructor.tag': 'Instructor',
  'pages.shareRebate.instructor.tagTooltip': 'Instructor name: {name}',
  'pages.shareRebate.instructor.status.pending': 'Awaiting review',
  'pages.shareRebate.instructor.status.approved': 'Approved',
  'pages.shareRebate.instructor.status.rejected': 'Rejected',
  'pages.shareRebate.instructor.status.revoked': 'Revoked',
  'pages.shareRebate.instructor.status.withdrawn': 'Withdrawn',
  'pages.shareRebate.instructor.status.none': 'No application',
  'pages.shareRebate.instructor.filter.all': 'All',
  'pages.shareRebate.instructor.history.applied': 'Applied',
  'pages.shareRebate.instructor.history.updated': 'Application edited',
  'pages.shareRebate.instructor.history.approved': 'Approved',
  'pages.shareRebate.instructor.history.rejected': 'Rejected',
  'pages.shareRebate.instructor.history.revoked': 'Revoked',
  'pages.shareRebate.instructor.history.withdrawn': 'Withdrawn',
  'pages.shareRebate.instructor.history.designated': 'Designated by admin',
  'pages.shareRebate.instructor.searchPlaceholder': 'Instructor name, member no., ID, nickname or email',
  'pages.shareRebate.instructor.pendingHint': 'Applications awaiting review are listed oldest first.',
  'pages.shareRebate.instructor.empty': 'No matching instructors.',
  'pages.shareRebate.instructor.emptyPending': 'No instructor applications to review.',
  'pages.shareRebate.instructor.col.member': 'Member',
  'pages.shareRebate.instructor.col.displayName': 'Instructor name',
  'pages.shareRebate.instructor.col.application': 'Application',
  'pages.shareRebate.instructor.col.status': 'Status',
  'pages.shareRebate.instructor.col.team': 'Team (direct/2nd/3rd)',
  'pages.shareRebate.instructor.col.teamHint': 'Team members of this instructor — invited directly / invited by them / one step further',
  'pages.shareRebate.instructor.col.mine30': 'Own links, 30 days',
  'pages.shareRebate.instructor.col.mine30Hint': 'People who opened this instructor’s links in the last 30 days, how many of them paid, and the instructor’s tier-1 rebates',
  'pages.shareRebate.instructor.col.team30': 'Team, 30 days',
  'pages.shareRebate.instructor.col.team30Hint': 'People who opened the links of team members (direct and 2nd step) in the last 30 days, how many of them paid, and the instructor’s tier-2/3 rebates',
  'pages.shareRebate.instructor.col.totals': 'Total rebates',
  'pages.shareRebate.instructor.col.totalsHint': 'All time — paid (net of clawbacks) and unpaid (pending, on hold, confirmed)',
  'pages.shareRebate.instructor.col.actions': 'Actions',
  'pages.shareRebate.instructor.perf.counts': 'Visitors {visitors} · Payers {payers}',
  'pages.shareRebate.instructor.perf.rebate': 'Rebates',
  'pages.shareRebate.instructor.perf.activeSharers': '{n} active team members',
  'pages.shareRebate.instructor.teamTooltip': 'Direct {tier1} · 2nd step {tier2} · 3rd step {tier3}',
  'pages.shareRebate.instructor.displayNamePreview': 'People who open the links see “Instructor {name}”.',
  'pages.shareRebate.instructor.noIntro': 'No introduction',
  'pages.shareRebate.instructor.appliedAt': 'Applied {time}',
  'pages.shareRebate.instructor.decidedAt': '{time} · {admin}',
  'pages.shareRebate.instructor.memberReason': 'Reason shown to the member: {reason}',
  'pages.shareRebate.instructor.memoTooltip': 'Internal memo: {memo}',
  'pages.shareRebate.instructor.memberVisibleNotice': 'This reason is shown on the member’s My Page.',
  'pages.shareRebate.instructor.action.approve': 'Approve',
  'pages.shareRebate.instructor.action.reject': 'Reject',
  'pages.shareRebate.instructor.action.revoke': 'Revoke',
  'pages.shareRebate.instructor.action.designate': 'Make instructor',
  'pages.shareRebate.instructor.action.designateNew': 'Designate an instructor',
  'pages.shareRebate.instructor.action.memo': 'Memo',
  'pages.shareRebate.instructor.action.failed': 'Could not complete the action.',
  'pages.shareRebate.instructor.approve.title': 'Approve instructor — {member}',
  'pages.shareRebate.instructor.approve.desc': 'Approves {member} as an instructor. New orders from now on use the instructor rates, and people who open the links see “Instructor {name}”. Existing members without an inviter who open these links are also offered to join the team.',
  'pages.shareRebate.instructor.approve.reasonPlaceholder': 'Approval note (optional). Kept in the history only; the member does not see it.',
  'pages.shareRebate.instructor.approve.success': '{member} is now an instructor.',
  'pages.shareRebate.instructor.reject.title': 'Reject instructor application — {member}',
  'pages.shareRebate.instructor.reject.desc': 'Rejects the instructor application of {member}. The member can read the reason and apply again.',
  'pages.shareRebate.instructor.reject.reasonPlaceholder': 'Write the reason for the member, e.g. We could not verify the channel address.',
  'pages.shareRebate.instructor.reject.success': 'Rejected the instructor application of {member}.',
  'pages.shareRebate.instructor.revoke.title': 'Revoke instructor — {member}',
  'pages.shareRebate.instructor.revoke.desc': 'Revokes instructor “{name}”. New orders use the member rates and the links stop offering to join the team. Rebates that already exist and the team (inviter links) stay as they are.',
  'pages.shareRebate.instructor.revoke.reasonPlaceholder': 'Write the reason for the member.',
  'pages.shareRebate.instructor.revoke.success': 'Revoked the instructor status of {member}.',
  'pages.shareRebate.instructor.memo.title': 'Internal memo — {member}',
  'pages.shareRebate.instructor.memo.help': 'Not shown to the member. Save it empty to delete the memo.',
  'pages.shareRebate.instructor.memo.success': 'Saved the internal memo.',
  'pages.shareRebate.instructor.designate.title': 'Designate an instructor',
  'pages.shareRebate.instructor.designate.ok': 'Make instructor',
  'pages.shareRebate.instructor.designate.intro': 'Approves the member right away, without an application. Any earlier application or rejection is replaced by this, and new orders from now on use the instructor rates.',
  'pages.shareRebate.instructor.designate.member': 'Member',
  'pages.shareRebate.instructor.designate.memberPlaceholder': 'Search by member no., nickname or ID',
  'pages.shareRebate.instructor.designate.memberRequired': 'Choose a member.',
  'pages.shareRebate.instructor.designate.reasonHelp': 'Kept in the history only.',
  'pages.shareRebate.instructor.designate.success': 'Designated as an instructor.',
  'pages.shareRebate.instructor.designate.footnote': 'An approved instructor cannot be designated again.',
  'pages.shareRebate.instructor.field.displayName': 'Instructor name',
  'pages.shareRebate.instructor.field.displayNameHelp': 'Public name shown as “Instructor OOO” to people who open the links. 2–20 characters; do not add “강사” or “강사님” at the end.',
  'pages.shareRebate.instructor.field.intro': 'Introduction',
  'pages.shareRebate.instructor.field.introOptional': 'Introduction (optional)',
  'pages.shareRebate.instructor.field.channel': 'Channel',
  'pages.shareRebate.instructor.field.channelOptional': 'Channel URL (optional)',
  'pages.shareRebate.instructor.field.phone': 'Contact',
  'pages.shareRebate.instructor.field.phoneOptional': 'Contact (optional)',
  'pages.shareRebate.instructor.field.phoneHelp': 'Visible to admins only.',
  'pages.shareRebate.instructor.field.appliedAt': 'Applied',
  'pages.shareRebate.instructor.field.decided': 'Decision',
  'pages.shareRebate.instructor.field.memberReason': 'Reason shown to the member',
  'pages.shareRebate.instructor.error.displayNameLength': 'Use {min}–{max} characters for the instructor name.',
  'pages.shareRebate.instructor.error.displayNameSuffix': 'Do not end the name with “강사” or “강사님” — the title is added automatically.',
  'pages.shareRebate.instructor.error.introLength': 'Use {min}–{max} characters for the introduction.',
  'pages.shareRebate.instructor.error.channel': 'Enter an address starting with http:// or https://, up to {max} characters.',
  'pages.shareRebate.instructor.error.phone': 'Use {min}–{max} digits and hyphens (-).',
  'pages.shareRebate.instructor.card.title': 'Instructor',
  'pages.shareRebate.instructor.card.none': 'This member has never applied to be an instructor.',
  'pages.shareRebate.instructor.card.history': 'History',
  'pages.shareRebate.funnel.period.today': 'Today',
  'pages.shareRebate.funnel.period.7d': '7 days',
  'pages.shareRebate.funnel.period.30d': '30 days',
  'pages.shareRebate.funnel.period.90d': '90 days',
  'pages.shareRebate.funnel.period.all': 'All time',
  'pages.shareRebate.funnel.scope.mine': 'Own links',
  'pages.shareRebate.funnel.scope.team': 'Team',
  'pages.shareRebate.funnel.scope.mineHint': 'Sign-ups, orders and payments by people who opened this member’s links in the period, and the member’s tier-1 rebates. Orders placed after the period still count for those visits.',
  'pages.shareRebate.funnel.scope.teamHint': 'Orders and payments by people who opened, in the period, the links of the direct team members and of the people they invited, and this member’s tier-2/3 rebates.',
  'pages.shareRebate.funnel.range': '{from} ~ {to} (KST)',
  'pages.shareRebate.funnel.rangeAll': 'All time ~ {to} (KST)',
  'pages.shareRebate.funnel.team.counts': 'Team: direct {tier1} · 2nd step {tier2} · 3rd step {tier3} · {active} team members had link visits in the period',
  'pages.shareRebate.funnel.step.visitors': 'Visitors',
  'pages.shareRebate.funnel.step.visitsSub': '{n} visits',
  'pages.shareRebate.funnel.step.orderers': 'Orderers',
  'pages.shareRebate.funnel.step.ordersSub': '{n} orders',
  'pages.shareRebate.funnel.step.payers': 'Payers',
  'pages.shareRebate.funnel.step.paidSub': '{n} paid orders',
  'pages.shareRebate.funnel.step.paidGmvSub': '{n} paid orders · ₩{amount}',
  'pages.shareRebate.funnel.orderRate': 'Order rate',
  'pages.shareRebate.funnel.orderRateHint': 'Orderers ÷ visitors',
  'pages.shareRebate.funnel.payRate': 'Payment rate',
  'pages.shareRebate.funnel.payRateHint': 'Payers ÷ orderers',
  'pages.shareRebate.funnel.joins': 'From these visits: {signups} new sign-ups · {joins} team joins',
  'pages.shareRebate.funnel.rebate.total': 'Total rebates',
  'pages.shareRebate.funnel.rebate.totalHint': 'Pending + confirmed + paid (net of clawbacks). Cancelled rebates are excluded.',
  'pages.shareRebate.funnel.rebate.pending': 'Pending',
  'pages.shareRebate.funnel.rebate.confirmed': 'Confirmed',
  'pages.shareRebate.funnel.rebate.paid': 'Paid',
  'pages.shareRebate.funnel.rebate.reversed': 'Clawed back ₩{amount}',
  'pages.shareRebate.funnel.chart.daily': 'Daily trend',
  'pages.shareRebate.funnel.chart.monthly': 'Monthly trend',
  'pages.shareRebate.funnel.chart.rebate': 'Rebates (KRW)',
  'pages.shareRebate.funnel.empty': 'No visits came in through the links in this period.',
  'pages.shareRebate.funnel.emptyTeam': 'No visits came in through the links of team members in this period.',
  'pages.shareRebate.funnel.cohortNote': 'Grouped by the day of the visit (later orders and rebates count for that visit). As of {time}',
  'pages.shareRebate.funnel.notSupported': 'The server does not provide performance data yet.',
  'pages.shareRebate.picks.tab': 'Recommended products',
  'pages.shareRebate.picks.notSupported': 'The server does not support recommended product pages yet.',
  'pages.shareRebate.picks.empty': 'No recommended products page has been created yet.',
  'pages.shareRebate.picks.emptyHint': 'The page is created the first time the instructor opens Recommended products on My Page.',
  'pages.shareRebate.picks.visible': 'Anyone with the link can see this page now.',
  'pages.shareRebate.picks.notVisible': 'This page cannot be seen through the link right now.',
  'pages.shareRebate.picks.visibilityRule': 'The page shows only when the instructor has published it and no admin has hidden it. Otherwise visitors from the link see a “page not available” screen.',
  'pages.shareRebate.picks.field.link': 'Page link',
  'pages.shareRebate.picks.field.published': 'Publish status',
  'pages.shareRebate.picks.published': 'Published',
  'pages.shareRebate.picks.unpublished': 'Unpublished (instructor setting)',
  'pages.shareRebate.picks.field.adminHidden': 'Hidden by admin',
  'pages.shareRebate.picks.adminHiddenOn': 'Hidden',
  'pages.shareRebate.picks.adminHiddenOff': 'Not hidden',
  'pages.shareRebate.picks.adminHiddenSwitchHint': 'Turn on to hide the public page (reason required). Turn off to show it again.',
  'pages.shareRebate.picks.adminHiddenInfo': '{time} · {admin} · Reason: {reason}',
  'pages.shareRebate.picks.field.title': 'Page title',
  'pages.shareRebate.picks.defaultTitle': 'Recommended products by instructor {name}',
  'pages.shareRebate.picks.defaultTitleTag': 'Default title',
  'pages.shareRebate.picks.field.intro': 'Intro',
  'pages.shareRebate.picks.field.items': 'Products',
  'pages.shareRebate.picks.counts': 'Pinned {pinned} · Auto {auto} · Left out {off}',
  'pages.shareRebate.picks.field.autoSyncedAt': 'Auto list computed',
  'pages.shareRebate.picks.field.autoSyncedAtHint': 'The ranking of the products the instructor shared (paid buyers, then visitors, then newest share, last 180 days) is recomputed when the page is opened more than 10 minutes after the last run.',
  'pages.shareRebate.picks.itemsTitle': 'Products',
  'pages.shareRebate.picks.itemsHint': 'Pinned products (instructor order) come first, then auto products (ranking order). Products hidden by the instructor or an admin, or no longer on sale, are left out of the public page.',
  'pages.shareRebate.picks.itemsEmpty': 'No products yet.',
  'pages.shareRebate.picks.col.image': 'Photo',
  'pages.shareRebate.picks.col.source': 'Source',
  'pages.shareRebate.picks.col.title': 'Product',
  'pages.shareRebate.picks.col.price': 'Price',
  'pages.shareRebate.picks.col.origin': 'Type',
  'pages.shareRebate.picks.col.status': 'Status',
  'pages.shareRebate.picks.col.stats': 'Visitors · Buyers',
  'pages.shareRebate.picks.col.statsHint': 'Ranking basis of auto products — people who came in through this product’s share links and people who paid, last 180 days',
  'pages.shareRebate.picks.col.adminHidden': 'Hidden by admin',
  'pages.shareRebate.picks.col.adminHiddenHint': 'Turn on to leave this product out of the public page. It stays on the instructor’s screen.',
  'pages.shareRebate.picks.openProduct': 'Open product page',
  'pages.shareRebate.picks.price.unknown': 'Unknown',
  'pages.shareRebate.picks.price.unknownHint': 'No price is known yet, so the public page shows “Check on the product page”.',
  'pages.shareRebate.picks.price.at': 'as of {time}',
  'pages.shareRebate.picks.origin.pinned': 'Pinned',
  'pages.shareRebate.picks.origin.auto': 'Auto',
  'pages.shareRebate.picks.tag.instructorHidden': 'Hidden by instructor',
  'pages.shareRebate.picks.tag.soldOut': 'Not on sale',
  'pages.shareRebate.picks.tag.adminHidden': 'Hidden by admin',
  'pages.shareRebate.picks.tag.shown': 'Shown',
  'pages.shareRebate.picks.stats': 'Visitors {visitors} · Buyers {payers}',
  'pages.shareRebate.picks.hide.title': 'Hide recommended products page',
  'pages.shareRebate.picks.hide.desc': 'Hides the recommended products page of instructor {name}. Visitors from the link see a “page not available” screen. The products and the instructor’s settings stay, so the page comes back when you unhide it.',
  'pages.shareRebate.picks.hide.notice': 'The reason stays in the admin records only. It is not shown to the instructor.',
  'pages.shareRebate.picks.hide.ok': 'Hide',
  'pages.shareRebate.picks.hide.success': 'The recommended products page is hidden.',
  'pages.shareRebate.picks.unhide.title': 'Unhide recommended products page',
  'pages.shareRebate.picks.unhide.desc': 'Unhides the recommended products page of instructor {name}. It can be seen through the link again.',
  'pages.shareRebate.picks.unhide.descUnpublished': 'Unhides the recommended products page of instructor {name}. The instructor has unpublished it, so it still cannot be seen through the link.',
  'pages.shareRebate.picks.unhide.ok': 'Unhide',
  'pages.shareRebate.picks.unhide.success': 'The recommended products page is no longer hidden.',
  'pages.shareRebate.picks.item.hideSuccess': 'The product is left out of the public page.',
  'pages.shareRebate.picks.item.unhideSuccess': 'The product shows on the public page again.',
  'pages.shareRebate.picks.actionFailed': 'The action failed.',
};

